import { jsx as s, jsxs as R, Fragment as le } from "react/jsx-runtime";
import * as d from "react";
import ae, { forwardRef as q, createElement as Ge, useState as ne, useEffect as Oe, useRef as Je, useCallback as hn, createContext as Mr, useMemo as gn, useContext as lo, useLayoutEffect as y1, Children as ao, isValidElement as fl, cloneElement as w1, Fragment as ia, useReducer as eP, useImperativeHandle as tP, useId as nP } from "react";
import { f as Bn, g as rP } from "./localisationConfig-BfnSuGmH.js";
import { c as Be, f as oP } from "./react-DikN064b.js";
import { c as F, a as iP, b as ws } from "./tailwind-BXrsiEcF.js";
import { AssessmentLights as de, FlowType as Uo, AccountType as fd } from "./types.js";
import { b as sr, c as r3, d as o3, a as yo, u as aP, g as sP, h as Tl } from "./useParsedReviews-4rnmeVis.js";
import * as Tn from "react-dom";
import Br, { flushSync as i3 } from "react-dom";
import "@tanstack/react-query";
import "./services.gen-72h9jWK3.js";
import { t as lP, i as or, e as Fg } from "./utils-CIU8rhkz.js";
import { u as $l } from "./useCreateConversationReview-CX3jha91.js";
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cP = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), a3 = (...e) => e.filter((t, n, r) => !!t && r.indexOf(t) === n).join(" ");
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var uP = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dP = q(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: o = "",
    children: i,
    iconNode: l,
    ...c
  }, f) => Ge(
    "svg",
    {
      ref: f,
      ...uP,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: a3("lucide", o),
      ...c
    },
    [
      ...l.map(([p, m]) => Ge(p, m)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const st = (e, t) => {
  const n = q(
    ({ className: r, ...o }, i) => Ge(dP, {
      ref: i,
      iconNode: t,
      className: a3(`lucide-${cP(e)}`, r),
      ...o
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wo = st("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const va = st("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fP = st("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pP = st("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mP = st("ChevronsUpDown", [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hP = st("CircleCheck", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gP = st("CircleHelp", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S1 = st("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vP = st("ExternalLink", [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CP = st("EyeOff", [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ro = st("FileText", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bg = st("Frown", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xP = st("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const So = st("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vg = st("Meh", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "8", x2: "16", y1: "15", y2: "15", key: "1xb1d9" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bP = st("MessageSquare", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yP = st("PanelLeft", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oo = st("PersonStanding", [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["path", { d: "m9 20 3-6 3 6", key: "se2kox" }],
  ["path", { d: "m6 8 6 2 6-2", key: "4o3us4" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wP = st("SlidersHorizontal", [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wg = st("Smile", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $t = st("ThumbsDown", [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lt = st("ThumbsUp", [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ]
]);
/**
 * @license lucide-react v0.447.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ll = st("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
function Ca(e, t) {
  var o, i, l, c, f, p;
  const { expert_name: n = "", output_key: r = "" } = (e == null ? void 0 : e.report_heading) || {};
  return (i = (o = t == null ? void 0 : t[n]) == null ? void 0 : o.parsed_output) != null && i[r] ? (c = (l = t == null ? void 0 : t[n]) == null ? void 0 : l.parsed_output) == null ? void 0 : c[r] : (f = t == null ? void 0 : t[n]) != null && f.raw_output ? (p = t == null ? void 0 : t[n]) == null ? void 0 : p.raw_output : "Your planning enquiry report";
}
function s3(e, t) {
  var o, i, l, c, f, p;
  const { expert_name: n = "", output_key: r = "" } = (e == null ? void 0 : e.report_abstract) || {};
  return (i = (o = t == null ? void 0 : t[n]) == null ? void 0 : o.parsed_output) != null && i[r] ? (c = (l = t == null ? void 0 : t[n]) == null ? void 0 : l.parsed_output) == null ? void 0 : c[r] : (f = t == null ? void 0 : t[n]) != null && f.raw_output ? (p = t == null ? void 0 : t[n]) == null ? void 0 : p.raw_output : "";
}
function tr(e, t) {
  var o, i, l, c, f, p, m, v, C;
  const { expert_name: n = "", output_key: r = "" } = (e == null ? void 0 : e.report_summary) || {};
  return (i = (o = t == null ? void 0 : t[n]) == null ? void 0 : o.parsed_output) != null && i[r] ? (c = (l = t == null ? void 0 : t[n]) == null ? void 0 : l.parsed_output) == null ? void 0 : c[r] : (f = t == null ? void 0 : t[n]) != null && f.raw_output ? (p = t == null ? void 0 : t[n]) == null ? void 0 : p.raw_output : (m = t == null ? void 0 : t.buildings_works_final) != null && m.raw_output ? t.buildings_works_final.raw_output : (v = t == null ? void 0 : t.report_summary_legalese) != null && v.raw_output ? t.report_summary_legalese.raw_output : (C = t == null ? void 0 : t.report_summary) != null && C.raw_output ? t.report_summary.raw_output : "";
}
function aa(e, t) {
  var o, i, l, c, f, p;
  const { expert_name: n = "", output_key: r = "" } = (e == null ? void 0 : e.application_requirements) || {};
  return (i = (o = t == null ? void 0 : t[n]) == null ? void 0 : o.parsed_output) != null && i[r] ? (c = (l = t == null ? void 0 : t[n]) == null ? void 0 : l.parsed_output) == null ? void 0 : c[r] : (f = t == null ? void 0 : t[n]) != null && f.raw_output ? (p = t == null ? void 0 : t[n]) == null ? void 0 : p.raw_output : "";
}
function Ml(e, t) {
  var o;
  const { expert_name: n = "" } = (e == null ? void 0 : e.show_mandatory_requirements) || {};
  return "<1>" in (((o = t == null ? void 0 : t[n]) == null ? void 0 : o.parsed_output) || {});
}
function Il(e, t) {
  var o, i, l, c, f, p;
  const { expert_name: n = "", output_key: r = "" } = (e == null ? void 0 : e.mandatory_requirements) || {};
  return (i = (o = t == null ? void 0 : t[n]) == null ? void 0 : o.parsed_output) != null && i[r] ? (c = (l = t == null ? void 0 : t[n]) == null ? void 0 : l.parsed_output) == null ? void 0 : c[r] : (f = t == null ? void 0 : t[n]) != null && f.raw_output ? (p = t == null ? void 0 : t[n]) == null ? void 0 : p.raw_output : "";
}
function Ol(e, t) {
  var o, i, l, c, f, p;
  const { expert_name: n = "", output_key: r = "" } = (e == null ? void 0 : e.vic_smart) || {};
  return (i = (o = t == null ? void 0 : t[n]) == null ? void 0 : o.parsed_output) != null && i[r] ? (c = (l = t == null ? void 0 : t[n]) == null ? void 0 : l.parsed_output) == null ? void 0 : c[r] : (f = t == null ? void 0 : t[n]) != null && f.raw_output ? (p = t == null ? void 0 : t[n]) == null ? void 0 : p.raw_output : "";
}
function l3(e, t) {
  var o, i, l, c, f, p;
  const { expert_name: n = "", output_key: r = "" } = (e == null ? void 0 : e.vic_smart_application_requirements) || {};
  return (i = (o = t == null ? void 0 : t[n]) == null ? void 0 : o.parsed_output) != null && i[r] ? (c = (l = t == null ? void 0 : t[n]) == null ? void 0 : l.parsed_output) == null ? void 0 : c[r] : (f = t == null ? void 0 : t[n]) != null && f.raw_output ? (p = t == null ? void 0 : t[n]) == null ? void 0 : p.raw_output : "";
}
const Ir = {
  eligible: "eligible",
  ineligible: "ineligible",
  unknown: "unknown"
};
function kl(e, t) {
  var o, i, l;
  const { expert_name: n = "" } = (e == null ? void 0 : e.vic_smart_eligibility) || {}, r = ((o = t == null ? void 0 : t[n]) == null ? void 0 : o.parsed_output) || {};
  return "<1>" in r && ((i = r["<1>"]) == null ? void 0 : i.toLowerCase()) !== "n/a" ? "eligible" : "<2>" in r && ((l = r["<2>"]) == null ? void 0 : l.toLowerCase()) !== "n/a" ? "ineligible" : "unknown";
}
function pl(e) {
  return !!(e != null && e.enable_vic_smart);
}
function Pr(e) {
  return !!(e != null && e.enable_follow_up_flow);
}
function N1({
  eligibility: e
}) {
  switch (e) {
    case Ir.eligible:
      return /* @__PURE__ */ s("span", { className: "rounded-xl py-0.5 px-2 text-bodymd text-[#005C41] bg-successBgDefault", children: "Likely eligible" });
    case Ir.ineligible:
    default:
      return /* @__PURE__ */ s("span", { className: "rounded-xl py-0.5 px-2 text-bodymd text-destructiveText bg-destructiveBgDefault", children: "Likely ineligible" });
  }
}
function lf({
  expertMap: e,
  noticeboardData: t,
  ordinanceLink: n
}) {
  const r = kl(
    e,
    t
  ), o = Ol(e, t);
  if (pl(e) && r !== "unknown")
    return /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { className: "text-headingmd text-textPrimary mb-1", children: "VicSmart eligibility" }),
      /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-2", children: "VicSmart is an approval pathway for straightforward planning applications. If you're eligible, lodging a VicSmart application will be much faster than the standard pathway." }),
      /* @__PURE__ */ s(N1, { eligibility: r }),
      r === Ir.eligible ? /* @__PURE__ */ s(qe, { className: "mt-2", children: Be(o, {
        ordinanceLink: n
      }) }) : null
    ] });
}
function cf({
  expertMap: e,
  noticeboardData: t,
  ordinanceLink: n
}) {
  const r = aa(
    e,
    t
  );
  return /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ s("h3", { className: "text-headingmd text-textPrimary mb-1", children: "Required documents and information" }),
    /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-5", children: "If your proposal isn’t eligible for VicSmart, you may need to provide the following documents when you submit a planning permit application. It is recommended that you speak to a planner to confirm if these documents are required for your proposal." }),
    /* @__PURE__ */ s(qe, { children: Be(r, {
      components: {
        h1({ children: o }) {
          return /* @__PURE__ */ s("h5", { className: "text-base font-bold", children: o });
        },
        h2({ children: o }) {
          return /* @__PURE__ */ s("h5", { className: "text-base font-bold", children: o });
        },
        h3({ children: o }) {
          return /* @__PURE__ */ s("h5", { className: "text-base font-bold", children: o });
        },
        h4({ children: o }) {
          return /* @__PURE__ */ s("h5", { className: "text-base font-bold", children: o });
        }
      },
      ordinanceLink: n
    }) })
  ] });
}
const SP = {
  [de.NoPermitRequired]: {
    text: "text-successHover",
    border: "!border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [de.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "!border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [de.RequiresPermit]: {
    text: "text-warningHover",
    border: "!border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [de.Prohibited]: {
    text: "text-destructiveHover",
    border: "!border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function LY({
  conversation: e,
  expertMap: t,
  messages: n,
  noticeboardData: r,
  onClickCheckExemptionCriteria: o,
  onClickApplicationRequirements: i,
  publicView: l = !1
}) {
  const [c, f] = ne({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), { getLocalisationEntry: p } = sr(e), m = p("councilOrdinanceLink"), v = r3({ messages: n }), C = o3({ conversation: e, messages: n });
  console.log("<AnalysisReport>", {
    isReportFinalised: v,
    isReportLocked: C,
    isFollowUpFlowEnabled: Pr(t),
    phase: e == null ? void 0 : e.phase
  });
  const x = yo(e, r);
  Oe(() => {
    x && ["1", "2", "3", "4"].includes(x.toString()) ? f(SP[x.toString()]) : f({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [x, e == null ? void 0 : e.phase]);
  const y = () => {
    var _, P, A, I, T, M;
    const { expert_name: b = "", output_key: w = "" } = (t == null ? void 0 : t.easy_read_report) || {};
    let N = "";
    return (P = (_ = r == null ? void 0 : r[b]) == null ? void 0 : _.parsed_output) != null && P[w] ? N = (I = (A = r == null ? void 0 : r[b]) == null ? void 0 : A.parsed_output) == null ? void 0 : I[w] : (T = r == null ? void 0 : r[b]) != null && T.raw_output && (N = (M = r == null ? void 0 : r[b]) == null ? void 0 : M.raw_output), /* @__PURE__ */ s("div", { children: Be(N, { ordinanceLink: m }) });
  }, h = () => {
    const b = tr(
      t,
      r
    ), w = Ml(
      t,
      r
    ), N = Il(
      t,
      r
    );
    switch (x) {
      case de.NoPermitRequired:
        return /* @__PURE__ */ R("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ R("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Why your proposal likely doesn’t require a planning permit." }),
            /* @__PURE__ */ R(nr, { defaultValue: "summary", children: [
              /* @__PURE__ */ R(Fn, { className: "pb-3", children: [
                /* @__PURE__ */ R(
                  bt,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 px-2 !bg-transparent",
                    value: "summary",
                    children: [
                      /* @__PURE__ */ s(ro, {}),
                      " Full assessment"
                    ]
                  }
                ),
                /* @__PURE__ */ R(
                  bt,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 px-2 !bg-transparent",
                    value: "easy-read",
                    children: [
                      /* @__PURE__ */ s(oo, {}),
                      " Easy read"
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ s(gt, { value: "easy-read", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: y() }) }),
              /* @__PURE__ */ s(gt, { value: "summary", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: Be(b, { ordinanceLink: m }) }) })
            ] })
          ] }),
          w && N ? /* @__PURE__ */ R("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ s(qe, { children: Be(N, {
              ordinanceLink: m
            }) })
          ] }) : null
        ] });
      case de.MoreInformationRequired:
        return /* @__PURE__ */ R("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ R("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Why a planning permit could be required" }),
            /* @__PURE__ */ R(nr, { defaultValue: "summary", children: [
              /* @__PURE__ */ R(Fn, { className: "pb-3", children: [
                /* @__PURE__ */ R(
                  bt,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 px-2 !bg-transparent",
                    value: "summary",
                    children: [
                      /* @__PURE__ */ s(ro, {}),
                      " Full assessment"
                    ]
                  }
                ),
                /* @__PURE__ */ R(
                  bt,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 px-2 !bg-transparent",
                    value: "easy-read",
                    children: [
                      /* @__PURE__ */ s(oo, {}),
                      " Easy read"
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ s(gt, { value: "easy-read", children: /* @__PURE__ */ s("div", { children: y() }) }),
              /* @__PURE__ */ s(gt, { value: "summary", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: Be(b, { ordinanceLink: m }) }) })
            ] })
          ] }),
          w && N ? /* @__PURE__ */ R("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ s(qe, { children: Be(N, {
              ordinanceLink: m
            }) })
          ] }) : null,
          Pr(t) && !C && !v && !l ? /* @__PURE__ */ s(
            ct,
            {
              className: "w-min",
              onClick: o,
              children: "Check exemption criteria"
            }
          ) : null,
          Pr(t) && v ? /* @__PURE__ */ R("div", { children: [
            /* @__PURE__ */ s(
              "div",
              {
                className: F(
                  "w-full border-b mb-6",
                  c.border
                )
              }
            ),
            /* @__PURE__ */ s(
              "h2",
              {
                className: "text-headinglg text-textPrimary mb-5",
                id: "application-requirements",
                children: "Application requirements"
              }
            ),
            /* @__PURE__ */ s(
              lf,
              {
                expertMap: t,
                noticeboardData: r,
                ordinanceLink: m
              }
            ),
            /* @__PURE__ */ s("div", { className: "h-4" }),
            /* @__PURE__ */ s(
              cf,
              {
                expertMap: t,
                noticeboardData: r,
                ordinanceLink: m
              }
            )
          ] }) : null
        ] });
      case de.RequiresPermit:
        return /* @__PURE__ */ R("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ R("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Why a permit is likely required" }),
            /* @__PURE__ */ R(nr, { defaultValue: "summary", children: [
              /* @__PURE__ */ R(Fn, { className: "pb-3", children: [
                /* @__PURE__ */ R(
                  bt,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 px-2 !bg-transparent",
                    value: "summary",
                    children: [
                      /* @__PURE__ */ s(ro, {}),
                      " Full assessment"
                    ]
                  }
                ),
                /* @__PURE__ */ R(
                  bt,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 px-2 !bg-transparent",
                    value: "easy-read",
                    children: [
                      /* @__PURE__ */ s(oo, {}),
                      " Easy read"
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ s(gt, { value: "easy-read", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: y() }) }),
              /* @__PURE__ */ s(gt, { value: "summary", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: Be(b, { ordinanceLink: m }) }) })
            ] })
          ] }),
          w && N ? /* @__PURE__ */ R("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ s(qe, { children: Be(N, {
              ordinanceLink: m
            }) })
          ] }) : null,
          Pr(t) && !C && !v && !l ? /* @__PURE__ */ R("div", { children: [
            /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Ready to apply?" }),
            /* @__PURE__ */ s("p", { className: "text-bodymd text-textPrimary mb-3", children: "Check what information you’ll need to provide to council when you apply." }),
            /* @__PURE__ */ s(
              ct,
              {
                className: "w-min",
                onClick: i,
                children: "Check application requirements"
              }
            )
          ] }) : null,
          Pr(t) && v ? /* @__PURE__ */ R("div", { children: [
            /* @__PURE__ */ s(
              "div",
              {
                className: F(
                  "w-full border-b mb-6",
                  c.border
                )
              }
            ),
            /* @__PURE__ */ s(
              "h2",
              {
                className: "text-headinglg text-textPrimary mb-5",
                id: "application-requirements",
                children: "Application requirements"
              }
            ),
            /* @__PURE__ */ s(
              lf,
              {
                expertMap: t,
                noticeboardData: r,
                ordinanceLink: m
              }
            ),
            /* @__PURE__ */ s("div", { className: "h-4" }),
            /* @__PURE__ */ s(
              cf,
              {
                expertMap: t,
                noticeboardData: r,
                ordinanceLink: m
              }
            )
          ] }) : null
        ] });
      case de.Prohibited:
        return /* @__PURE__ */ R("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Why your proposal is likely prohibited" }),
          /* @__PURE__ */ R(nr, { defaultValue: "summary", children: [
            /* @__PURE__ */ R(Fn, { className: "pb-3", children: [
              /* @__PURE__ */ R(
                bt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2 !bg-transparent",
                  value: "summary",
                  children: [
                    /* @__PURE__ */ s(ro, {}),
                    " Full assessment"
                  ]
                }
              ),
              /* @__PURE__ */ R(
                bt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2 !bg-transparent",
                  value: "easy-read",
                  children: [
                    /* @__PURE__ */ s(oo, {}),
                    " Easy read"
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ s(gt, { value: "easy-read", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: y() }) }),
            /* @__PURE__ */ s(gt, { value: "summary", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: Be(b, { ordinanceLink: m }) }) })
          ] })
        ] });
    }
  };
  return /* @__PURE__ */ R(
    "div",
    {
      className: F(
        "rounded-lg border border-l-[12px] p-5 md:p-8 flex flex-col gap-6",
        c.border,
        c.bgLight
      ),
      "data-testid": "assessment-report",
      children: [
        /* @__PURE__ */ s(
          "h2",
          {
            className: `text-[32px] font-medium leading-[38px] ${c.text}`,
            children: Ca(t, r)
          }
        ),
        h()
      ]
    }
  );
}
const NP = {
  [de.NoPermitRequired]: {
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [de.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [de.RequiresPermit]: {
    text: "text-warningHover",
    border: "border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [de.Prohibited]: {
    text: "text-destructiveHover",
    border: "border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function MY({
  conversation: e,
  expertMap: t,
  messages: n,
  noticeboardData: r,
  onClickCheckExemptionCriteria: o,
  onClickApplicationRequirements: i,
  publicView: l = !1
}) {
  const [c, f] = ne({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), { getLocalisationEntry: p } = sr(e), m = p("councilOrdinanceLink"), v = r3({ messages: n }), C = o3({ conversation: e, messages: n }), x = yo(e, r);
  Oe(() => {
    x && ["1", "2", "3", "4"].includes(x.toString()) ? f(NP[x.toString()]) : f({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [x, e == null ? void 0 : e.phase]);
  const y = () => {
    const I = s3(t, r);
    if (I)
      return /* @__PURE__ */ s("div", { className: "text-bodylg text-textPrimary mb-1", children: Be(I, { ordinanceLink: m }) });
  }, h = () => {
    const I = Ml(
      t,
      r
    ), T = Il(
      t,
      r
    );
    if (I && T)
      return /* @__PURE__ */ R(le, { children: [
        /* @__PURE__ */ s("div", { className: F("w-full border-b", c.border) }),
        /* @__PURE__ */ s(hi, { collapsible: !0, type: "single", children: /* @__PURE__ */ R(
          co,
          {
            className: "border-b-0",
            value: "mandatory-requirements",
            children: [
              /* @__PURE__ */ s(uo, { className: "!py-0", children: /* @__PURE__ */ R("div", { className: "text-left", children: [
                /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary", children: "Mandatory requirements" }),
                /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued", children: "Check your proposal complies with these requirements or it won’t be accepted." })
              ] }) }),
              /* @__PURE__ */ s(fo, { className: "!pb-0 pt-5", children: Be(T, {
                ordinanceLink: m
              }) })
            ]
          }
        ) })
      ] });
  }, b = () => {
    let T = [
      {
        expert_name: "landuse_report",
        title: "Land use"
      },
      {
        expert_name: "zone_works_report",
        title: "Buildings and works"
      },
      {
        expert_name: "provisions_assessor_report",
        title: "Particular provisions"
      },
      {
        expert_name: "bmo_overlay_report",
        title: "Bushfire Management Overlay"
      },
      {
        expert_name: "ddo_overlay_report",
        title: "Design and Development Overlay"
      },
      {
        expert_name: "emo_overlay_report",
        title: "Erosion Management Overlay"
      },
      {
        expert_name: "eso_overlay_report",
        title: "Environmental Significance Overlay"
      },
      {
        expert_name: "ho_overlay_report",
        title: "Heritage Overlay"
      },
      {
        expert_name: "lsio_overlay_report",
        title: "Land Subject to Inundation Overlay"
      },
      {
        expert_name: "sbo_overlay_report",
        title: "Special Building Overlay"
      },
      {
        expert_name: "slo_overlay_report",
        title: "Significant Landscape Overlay"
      },
      {
        expert_name: "vpo_overlay_report",
        title: "Vegetation Protection Overlay"
      },
      {
        expert_name: "tree_policy_assessor",
        title: "Local policies"
      }
    ];
    return t && Array.isArray(t.report_details) && t.report_details.length > 0 && (T = t.report_details), /* @__PURE__ */ s("div", { className: "flex flex-col gap-5", children: T.map((M, D) => {
      var X, oe, G, Q, te, ee;
      const { expert_name: W = "", output_key: U = "", title: re } = M;
      let j = "";
      return U && ((oe = (X = r == null ? void 0 : r[W]) == null ? void 0 : X.parsed_output) != null && oe[U]) ? j = (Q = (G = r == null ? void 0 : r[W]) == null ? void 0 : G.parsed_output) == null ? void 0 : Q[U] : (te = r == null ? void 0 : r[W]) != null && te.raw_output && (j = (ee = r == null ? void 0 : r[W]) == null ? void 0 : ee.raw_output), !j || j.trim().toLowerCase().startsWith("no content") || /^no (.+) at this address/.test(j.trim().toLowerCase()) ? null : /* @__PURE__ */ R("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ s("h3", { className: "text-headingsm text-textPrimary", children: re }),
        Be(j, {
          components: {
            h1({ children: Pe }) {
              return /* @__PURE__ */ s("h4", { className: "text-headingsm", children: Pe });
            },
            h2({ children: Pe }) {
              return /* @__PURE__ */ s("h4", { className: "text-headingsm", children: Pe });
            },
            h3({ children: Pe }) {
              return /* @__PURE__ */ s("h4", { className: "text-headingsm", children: Pe });
            },
            h4({ children: Pe }) {
              return /* @__PURE__ */ s("h4", { className: "text-headingsm", children: Pe });
            }
          },
          ordinanceLink: m
        })
      ] }, D);
    }) });
  }, w = () => /* @__PURE__ */ R(le, { children: [
    /* @__PURE__ */ s("div", { className: F("w-full border-b", c.border) }),
    /* @__PURE__ */ s(hi, { collapsible: !0, type: "single", children: /* @__PURE__ */ R(co, { className: "border-b-0", value: "detailed-analysis", children: [
      /* @__PURE__ */ s(uo, { className: "!py-0", children: /* @__PURE__ */ R("div", { className: "text-left", children: [
        /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary", children: "Detailed analysis" }),
        /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued", children: "Breakdown by the zone, overlays, and other controls relevant to your proposal." })
      ] }) }),
      /* @__PURE__ */ s(fo, { className: "!pb-0 pt-5", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: b() }) })
    ] }) })
  ] }), N = () => {
    if (Pr(t) && !C && !v && !l)
      return /* @__PURE__ */ R(le, { children: [
        /* @__PURE__ */ s("div", { className: F("w-full border-b", c.border) }),
        /* @__PURE__ */ s(ct, { className: "w-min", onClick: o, children: "Check exemption criteria" })
      ] });
  }, _ = () => {
    if (Pr(t) && !C && !v && !l)
      return /* @__PURE__ */ R(le, { children: [
        /* @__PURE__ */ s("div", { className: F("w-full border-b", c.border) }),
        /* @__PURE__ */ R("div", { children: [
          /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Ready to apply?" }),
          /* @__PURE__ */ s("p", { className: "text-bodymd text-textPrimary mb-3", children: "Check what information you’ll need to provide to council when you apply." }),
          /* @__PURE__ */ s(ct, { className: "w-min", onClick: i, children: "Check application requirements" })
        ] })
      ] });
  }, P = () => {
    if (Pr(t) && v)
      return /* @__PURE__ */ R(le, { children: [
        /* @__PURE__ */ s("div", { className: F("w-full border-b", c.border) }),
        /* @__PURE__ */ R("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ s(
            "h2",
            {
              className: "text-headinglg text-textPrimary",
              id: "application-requirements",
              children: "Application requirements"
            }
          ),
          /* @__PURE__ */ s(
            lf,
            {
              expertMap: t,
              noticeboardData: r,
              ordinanceLink: m
            }
          ),
          /* @__PURE__ */ s(
            cf,
            {
              expertMap: t,
              noticeboardData: r,
              ordinanceLink: m
            }
          )
        ] })
      ] });
  }, A = () => {
    var I, T, M, D;
    switch (x) {
      case de.NoPermitRequired:
        return /* @__PURE__ */ R("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ R("div", { className: "flex flex-col gap-1", children: [
            ((I = e == null ? void 0 : e.address_data) == null ? void 0 : I.lga_name) !== "Sunshine Coast" ? /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary", children: "Why your proposal likely doesn’t require a planning permit." }) : null,
            y()
          ] }),
          h(),
          w()
        ] });
      case de.MoreInformationRequired:
        return /* @__PURE__ */ R("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ R("div", { className: "flex flex-col gap-1", children: [
            ((T = e == null ? void 0 : e.address_data) == null ? void 0 : T.lga_name) !== "Sunshine Coast" ? /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary", children: "Why a planning permit could be required" }) : null,
            y()
          ] }),
          h(),
          w(),
          N(),
          P()
        ] });
      case de.RequiresPermit:
        return /* @__PURE__ */ R("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ R("div", { className: "flex flex-col gap-1", children: [
            ((M = e == null ? void 0 : e.address_data) == null ? void 0 : M.lga_name) !== "Sunshine Coast" ? /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary", children: "Why a permit is likely required" }) : null,
            y()
          ] }),
          h(),
          w(),
          P(),
          _()
        ] });
      case de.Prohibited:
        return /* @__PURE__ */ s("div", { className: "flex flex-col gap-6", children: /* @__PURE__ */ R("div", { className: "flex flex-col gap-1", children: [
          ((D = e == null ? void 0 : e.address_data) == null ? void 0 : D.lga_name) !== "Sunshine Coast" ? /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary", children: "Why your proposal is likely prohibited" }) : null,
          y()
        ] }) });
    }
  };
  return /* @__PURE__ */ R(
    "div",
    {
      className: F(
        "flex flex-col gap-6 rounded-lg border border-l-[12px] p-5 md:p-8",
        c.border,
        c.bgLight
      ),
      "data-testid": "assessment-report",
      children: [
        /* @__PURE__ */ s("h2", { className: "text-textPrimary text-[32px] font-medium leading-[38px]", children: Ca(t, r) }),
        A()
      ]
    }
  );
}
function Vr(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    function p(v) {
      const { scope: C, children: x, ...y } = v, h = (C == null ? void 0 : C[e][f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    }
    function m(v, C) {
      const x = (C == null ? void 0 : C[e][f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return p.displayName = i + "Provider", [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, _P(o, ...t)];
}
function _P(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function RP(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function c3(...e) {
  return (t) => e.forEach((n) => RP(n, t));
}
function ke(...e) {
  return d.useCallback(c3(...e), e);
}
var mi = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = d.Children.toArray(n), i = o.find(PP);
  if (i) {
    const l = i.props.children, c = o.map((f) => f === i ? d.Children.count(l) > 1 ? d.Children.only(null) : d.isValidElement(l) ? l.props.children : null : f);
    return /* @__PURE__ */ s(uf, { ...r, ref: t, children: d.isValidElement(l) ? d.cloneElement(l, void 0, c) : null });
  }
  return /* @__PURE__ */ s(uf, { ...r, ref: t, children: n });
});
mi.displayName = "Slot";
var uf = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const o = TP(n);
    return d.cloneElement(n, {
      ...AP(r, n.props),
      // @ts-ignore
      ref: t ? c3(t, o) : o
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
uf.displayName = "SlotClone";
var EP = ({ children: e }) => /* @__PURE__ */ s(le, { children: e });
function PP(e) {
  return d.isValidElement(e) && e.type === EP;
}
function AP(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function TP(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Dl(e) {
  const t = e + "CollectionProvider", [n, r] = Vr(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), l = (x) => {
    const { scope: y, children: h } = x, b = ae.useRef(null), w = ae.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ s(o, { scope: y, itemMap: w, collectionRef: b, children: h });
  };
  l.displayName = t;
  const c = e + "CollectionSlot", f = ae.forwardRef(
    (x, y) => {
      const { scope: h, children: b } = x, w = i(c, h), N = ke(y, w.collectionRef);
      return /* @__PURE__ */ s(mi, { ref: N, children: b });
    }
  );
  f.displayName = c;
  const p = e + "CollectionItemSlot", m = "data-radix-collection-item", v = ae.forwardRef(
    (x, y) => {
      const { scope: h, children: b, ...w } = x, N = ae.useRef(null), _ = ke(y, N), P = i(p, h);
      return ae.useEffect(() => (P.itemMap.set(N, { ref: N, ...w }), () => void P.itemMap.delete(N))), /* @__PURE__ */ s(mi, { [m]: "", ref: _, children: b });
    }
  );
  v.displayName = p;
  function C(x) {
    const y = i(e + "CollectionConsumer", x);
    return ae.useCallback(() => {
      const b = y.collectionRef.current;
      if (!b) return [];
      const w = Array.from(b.querySelectorAll(`[${m}]`));
      return Array.from(y.itemMap.values()).sort(
        (P, A) => w.indexOf(P.ref.current) - w.indexOf(A.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: l, Slot: f, ItemSlot: v },
    C,
    r
  ];
}
function he(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function xe(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function et({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = $P({ defaultProp: t, onChange: n }), i = e !== void 0, l = i ? e : r, c = xe(n), f = d.useCallback(
    (p) => {
      if (i) {
        const v = typeof p == "function" ? p(e) : p;
        v !== e && c(v);
      } else
        o(p);
    },
    [i, e, o, c]
  );
  return [l, f];
}
function $P({
  defaultProp: e,
  onChange: t
}) {
  const n = d.useState(e), [r] = n, o = d.useRef(r), i = xe(t);
  return d.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var LP = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ve = LP.reduce((e, t) => {
  const n = d.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, c = i ? mi : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(c, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Fl(e, t) {
  e && Tn.flushSync(() => e.dispatchEvent(t));
}
var be = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
};
function MP(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var Bl = (e) => {
  const { present: t, children: n } = e, r = IP(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), i = ke(r.ref, OP(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: i }) : null;
};
Bl.displayName = "Presence";
function IP(e) {
  const [t, n] = d.useState(), r = d.useRef({}), o = d.useRef(e), i = d.useRef("none"), l = e ? "mounted" : "unmounted", [c, f] = MP(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const p = Ss(r.current);
    i.current = c === "mounted" ? p : "none";
  }, [c]), be(() => {
    const p = r.current, m = o.current;
    if (m !== e) {
      const C = i.current, x = Ss(p);
      e ? f("MOUNT") : x === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && C !== x ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), be(() => {
    if (t) {
      const p = (v) => {
        const x = Ss(r.current).includes(v.animationName);
        v.target === t && x && Tn.flushSync(() => f("ANIMATION_END"));
      }, m = (v) => {
        v.target === t && (i.current = Ss(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", p), t.addEventListener("animationend", p), () => {
        t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", p), t.removeEventListener("animationend", p);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: d.useCallback((p) => {
      p && (r.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function Ss(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function OP(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var kP = d.useId || (() => {
}), DP = 0;
function it(e) {
  const [t, n] = d.useState(kP());
  return be(() => {
    n((r) => r ?? String(DP++));
  }, [e]), t ? `radix-${t}` : "";
}
var _1 = "Collapsible", [FP, u3] = Vr(_1), [BP, R1] = FP(_1), d3 = d.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: i,
      onOpenChange: l,
      ...c
    } = e, [f = !1, p] = et({
      prop: r,
      defaultProp: o,
      onChange: l
    });
    return /* @__PURE__ */ s(
      BP,
      {
        scope: n,
        disabled: i,
        contentId: it(),
        open: f,
        onOpenToggle: d.useCallback(() => p((m) => !m), [p]),
        children: /* @__PURE__ */ s(
          ve.div,
          {
            "data-state": P1(f),
            "data-disabled": i ? "" : void 0,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
d3.displayName = _1;
var f3 = "CollapsibleTrigger", p3 = d.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, o = R1(f3, n);
    return /* @__PURE__ */ s(
      ve.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": P1(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: t,
        onClick: he(e.onClick, o.onOpenToggle)
      }
    );
  }
);
p3.displayName = f3;
var E1 = "CollapsibleContent", m3 = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = R1(E1, e.__scopeCollapsible);
    return /* @__PURE__ */ s(Bl, { present: n || o.open, children: ({ present: i }) => /* @__PURE__ */ s(VP, { ...r, ref: t, present: i }) });
  }
);
m3.displayName = E1;
var VP = d.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...i } = e, l = R1(E1, n), [c, f] = d.useState(r), p = d.useRef(null), m = ke(t, p), v = d.useRef(0), C = v.current, x = d.useRef(0), y = x.current, h = l.open || c, b = d.useRef(h), w = d.useRef();
  return d.useEffect(() => {
    const N = requestAnimationFrame(() => b.current = !1);
    return () => cancelAnimationFrame(N);
  }, []), be(() => {
    const N = p.current;
    if (N) {
      w.current = w.current || {
        transitionDuration: N.style.transitionDuration,
        animationName: N.style.animationName
      }, N.style.transitionDuration = "0s", N.style.animationName = "none";
      const _ = N.getBoundingClientRect();
      v.current = _.height, x.current = _.width, b.current || (N.style.transitionDuration = w.current.transitionDuration, N.style.animationName = w.current.animationName), f(r);
    }
  }, [l.open, r]), /* @__PURE__ */ s(
    ve.div,
    {
      "data-state": P1(l.open),
      "data-disabled": l.disabled ? "" : void 0,
      id: l.contentId,
      hidden: !h,
      ...i,
      ref: m,
      style: {
        "--radix-collapsible-content-height": C ? `${C}px` : void 0,
        "--radix-collapsible-content-width": y ? `${y}px` : void 0,
        ...e.style
      },
      children: h && o
    }
  );
});
function P1(e) {
  return e ? "open" : "closed";
}
var WP = d3, HP = p3, UP = m3, GP = d.createContext(void 0);
function vn(e) {
  const t = d.useContext(GP);
  return e || t || "ltr";
}
var lr = "Accordion", zP = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [A1, qP, KP] = Dl(lr), [Vl, IY] = Vr(lr, [
  KP,
  u3
]), T1 = u3(), h3 = ae.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, o = r, i = r;
    return /* @__PURE__ */ s(A1.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ s(jP, { ...i, ref: t }) : /* @__PURE__ */ s(XP, { ...o, ref: t }) });
  }
);
h3.displayName = lr;
var [g3, YP] = Vl(lr), [v3, ZP] = Vl(
  lr,
  { collapsible: !1 }
), XP = ae.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: o = () => {
      },
      collapsible: i = !1,
      ...l
    } = e, [c, f] = et({
      prop: n,
      defaultProp: r,
      onChange: o
    });
    return /* @__PURE__ */ s(
      g3,
      {
        scope: e.__scopeAccordion,
        value: c ? [c] : [],
        onItemOpen: f,
        onItemClose: ae.useCallback(() => i && f(""), [i, f]),
        children: /* @__PURE__ */ s(v3, { scope: e.__scopeAccordion, collapsible: i, children: /* @__PURE__ */ s(C3, { ...l, ref: t }) })
      }
    );
  }
), jP = ae.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...i
  } = e, [l = [], c] = et({
    prop: n,
    defaultProp: r,
    onChange: o
  }), f = ae.useCallback(
    (m) => c((v = []) => [...v, m]),
    [c]
  ), p = ae.useCallback(
    (m) => c((v = []) => v.filter((C) => C !== m)),
    [c]
  );
  return /* @__PURE__ */ s(
    g3,
    {
      scope: e.__scopeAccordion,
      value: l,
      onItemOpen: f,
      onItemClose: p,
      children: /* @__PURE__ */ s(v3, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ s(C3, { ...i, ref: t }) })
    }
  );
}), [QP, Wl] = Vl(lr), C3 = ae.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: o, orientation: i = "vertical", ...l } = e, c = ae.useRef(null), f = ke(c, t), p = qP(n), v = vn(o) === "ltr", C = he(e.onKeyDown, (x) => {
      var M;
      if (!zP.includes(x.key)) return;
      const y = x.target, h = p().filter((D) => {
        var W;
        return !((W = D.ref.current) != null && W.disabled);
      }), b = h.findIndex((D) => D.ref.current === y), w = h.length;
      if (b === -1) return;
      x.preventDefault();
      let N = b;
      const _ = 0, P = w - 1, A = () => {
        N = b + 1, N > P && (N = _);
      }, I = () => {
        N = b - 1, N < _ && (N = P);
      };
      switch (x.key) {
        case "Home":
          N = _;
          break;
        case "End":
          N = P;
          break;
        case "ArrowRight":
          i === "horizontal" && (v ? A() : I());
          break;
        case "ArrowDown":
          i === "vertical" && A();
          break;
        case "ArrowLeft":
          i === "horizontal" && (v ? I() : A());
          break;
        case "ArrowUp":
          i === "vertical" && I();
          break;
      }
      const T = N % w;
      (M = h[T].ref.current) == null || M.focus();
    });
    return /* @__PURE__ */ s(
      QP,
      {
        scope: n,
        disabled: r,
        direction: o,
        orientation: i,
        children: /* @__PURE__ */ s(A1.Slot, { scope: n, children: /* @__PURE__ */ s(
          ve.div,
          {
            ...l,
            "data-orientation": i,
            ref: f,
            onKeyDown: r ? void 0 : C
          }
        ) })
      }
    );
  }
), ml = "AccordionItem", [JP, $1] = Vl(ml), x3 = ae.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...o } = e, i = Wl(ml, n), l = YP(ml, n), c = T1(n), f = it(), p = r && l.value.includes(r) || !1, m = i.disabled || e.disabled;
    return /* @__PURE__ */ s(
      JP,
      {
        scope: n,
        open: p,
        disabled: m,
        triggerId: f,
        children: /* @__PURE__ */ s(
          WP,
          {
            "data-orientation": i.orientation,
            "data-state": _3(p),
            ...c,
            ...o,
            ref: t,
            disabled: m,
            open: p,
            onOpenChange: (v) => {
              v ? l.onItemOpen(r) : l.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
x3.displayName = ml;
var b3 = "AccordionHeader", y3 = ae.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Wl(lr, n), i = $1(b3, n);
    return /* @__PURE__ */ s(
      ve.h3,
      {
        "data-orientation": o.orientation,
        "data-state": _3(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
y3.displayName = b3;
var df = "AccordionTrigger", w3 = ae.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Wl(lr, n), i = $1(df, n), l = ZP(df, n), c = T1(n);
    return /* @__PURE__ */ s(A1.ItemSlot, { scope: n, children: /* @__PURE__ */ s(
      HP,
      {
        "aria-disabled": i.open && !l.collapsible || void 0,
        "data-orientation": o.orientation,
        id: i.triggerId,
        ...c,
        ...r,
        ref: t
      }
    ) });
  }
);
w3.displayName = df;
var S3 = "AccordionContent", N3 = ae.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Wl(lr, n), i = $1(S3, n), l = T1(n);
    return /* @__PURE__ */ s(
      UP,
      {
        role: "region",
        "aria-labelledby": i.triggerId,
        "data-orientation": o.orientation,
        ...l,
        ...r,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
N3.displayName = S3;
function _3(e) {
  return e ? "open" : "closed";
}
var eA = h3, tA = x3, nA = y3, R3 = w3, E3 = N3;
const hi = eA, co = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  tA,
  {
    ref: n,
    className: F("not-last:border-b border-border", e),
    ...t
  }
));
co.displayName = "AccordionItem";
const uo = q(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ s(nA, { className: "flex", children: /* @__PURE__ */ R(
  R3,
  {
    ref: r,
    className: F(
      "flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ s(va, { className: "min-h-4 min-w-4 transition-transform duration-200" })
    ]
  }
) }));
uo.displayName = R3.displayName;
const fo = q(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ s(
  E3,
  {
    ref: r,
    className: "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm transition-all",
    ...n,
    children: /* @__PURE__ */ s("div", { className: F("pb-4 pt-0", e), children: t })
  }
));
fo.displayName = E3.displayName;
const Hg = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Ug = iP, cr = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return Ug(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = t, l = Object.keys(o).map((p) => {
    const m = n == null ? void 0 : n[p], v = i == null ? void 0 : i[p];
    if (m === null) return null;
    const C = Hg(m) || Hg(v);
    return o[p][C];
  }), c = n && Object.entries(n).reduce((p, m) => {
    let [v, C] = m;
    return C === void 0 || (p[v] = C), p;
  }, {}), f = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((p, m) => {
    let { class: v, className: C, ...x } = m;
    return Object.entries(x).every((y) => {
      let [h, b] = y;
      return Array.isArray(b) ? b.includes({
        ...i,
        ...c
      }[h]) : {
        ...i,
        ...c
      }[h] === b;
    }) ? [
      ...p,
      v,
      C
    ] : p;
  }, []);
  return Ug(e, l, f, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, rA = cr(
  "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), oA = q(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ s(
  "div",
  {
    ref: r,
    role: "alert",
    className: F(rA({ variant: t }), e),
    ...n
  }
));
oA.displayName = "Alert";
const iA = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "h5",
  {
    ref: n,
    className: F(
      "mb-1 font-medium leading-none tracking-tight",
      e
    ),
    ...t
  }
));
iA.displayName = "AlertTitle";
const aA = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "div",
  {
    ref: n,
    className: F("text-sm [&_p]:leading-relaxed", e),
    ...t
  }
));
aA.displayName = "AlertDescription";
function sA(e, t) {
  const n = d.createContext(t), r = (i) => {
    const { children: l, ...c } = i, f = d.useMemo(() => c, Object.values(c));
    return /* @__PURE__ */ s(n.Provider, { value: f, children: l });
  };
  r.displayName = e + "Provider";
  function o(i) {
    const l = d.useContext(n);
    if (l) return l;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function P3(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    const p = (v) => {
      var w;
      const { scope: C, children: x, ...y } = v, h = ((w = C == null ? void 0 : C[e]) == null ? void 0 : w[f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    };
    p.displayName = i + "Provider";
    function m(v, C) {
      var h;
      const x = ((h = C == null ? void 0 : C[e]) == null ? void 0 : h[f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, lA(o, ...t)];
}
function lA(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Gg(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function A3(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = Gg(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : Gg(e[o], null);
        }
      };
  };
}
function ur(...e) {
  return d.useCallback(A3(...e), e);
}
function rr(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
var L1 = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = d.Children.toArray(n), i = o.find(cA);
  if (i) {
    const l = i.props.children, c = o.map((f) => f === i ? d.Children.count(l) > 1 ? d.Children.only(null) : d.isValidElement(l) ? l.props.children : null : f);
    return /* @__PURE__ */ s(ff, { ...r, ref: t, children: d.isValidElement(l) ? d.cloneElement(l, void 0, c) : null });
  }
  return /* @__PURE__ */ s(ff, { ...r, ref: t, children: n });
});
L1.displayName = "Slot";
var ff = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const o = dA(n);
    return d.cloneElement(n, {
      ...uA(r, n.props),
      // @ts-ignore
      ref: t ? A3(t, o) : o
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
ff.displayName = "SlotClone";
var T3 = ({ children: e }) => /* @__PURE__ */ s(le, { children: e });
function cA(e) {
  return d.isValidElement(e) && e.type === T3;
}
function uA(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function dA(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var fA = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], dr = fA.reduce((e, t) => {
  const n = d.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, c = i ? L1 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(c, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function pA(e, t) {
  e && Tn.flushSync(() => e.dispatchEvent(t));
}
function Wr(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e);
  d.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var mA = "DismissableLayer", pf = "dismissableLayer.update", hA = "dismissableLayer.pointerDownOutside", gA = "dismissableLayer.focusOutside", zg, $3 = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), L3 = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: l,
      onDismiss: c,
      ...f
    } = e, p = d.useContext($3), [m, v] = d.useState(null), C = (m == null ? void 0 : m.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, x] = d.useState({}), y = ur(t, (T) => v(T)), h = Array.from(p.layers), [b] = [...p.layersWithOutsidePointerEventsDisabled].slice(-1), w = h.indexOf(b), N = m ? h.indexOf(m) : -1, _ = p.layersWithOutsidePointerEventsDisabled.size > 0, P = N >= w, A = xA((T) => {
      const M = T.target, D = [...p.branches].some((W) => W.contains(M));
      !P || D || (o == null || o(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C), I = bA((T) => {
      const M = T.target;
      [...p.branches].some((W) => W.contains(M)) || (i == null || i(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C);
    return Wr((T) => {
      N === p.layers.size - 1 && (r == null || r(T), !T.defaultPrevented && c && (T.preventDefault(), c()));
    }, C), d.useEffect(() => {
      if (m)
        return n && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (zg = C.body.style.pointerEvents, C.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(m)), p.layers.add(m), qg(), () => {
          n && p.layersWithOutsidePointerEventsDisabled.size === 1 && (C.body.style.pointerEvents = zg);
        };
    }, [m, C, n, p]), d.useEffect(() => () => {
      m && (p.layers.delete(m), p.layersWithOutsidePointerEventsDisabled.delete(m), qg());
    }, [m, p]), d.useEffect(() => {
      const T = () => x({});
      return document.addEventListener(pf, T), () => document.removeEventListener(pf, T);
    }, []), /* @__PURE__ */ s(
      dr.div,
      {
        ...f,
        ref: y,
        style: {
          pointerEvents: _ ? P ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: rr(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: rr(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: rr(
          e.onPointerDownCapture,
          A.onPointerDownCapture
        )
      }
    );
  }
);
L3.displayName = mA;
var vA = "DismissableLayerBranch", CA = d.forwardRef((e, t) => {
  const n = d.useContext($3), r = d.useRef(null), o = ur(t, r);
  return d.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ s(dr.div, { ...e, ref: o });
});
CA.displayName = vA;
function xA(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1), o = d.useRef(() => {
  });
  return d.useEffect(() => {
    const i = (c) => {
      if (c.target && !r.current) {
        let f = function() {
          M3(
            hA,
            n,
            p,
            { discrete: !0 }
          );
        };
        const p = { originalEvent: c };
        c.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = f, t.addEventListener("click", o.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function bA(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && M3(gA, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function qg() {
  const e = new CustomEvent(pf);
  document.dispatchEvent(e);
}
function M3(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? pA(o, i) : o.dispatchEvent(i);
}
var pd = "focusScope.autoFocusOnMount", md = "focusScope.autoFocusOnUnmount", Kg = { bubbles: !1, cancelable: !0 }, yA = "FocusScope", I3 = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...l
  } = e, [c, f] = d.useState(null), p = xe(o), m = xe(i), v = d.useRef(null), C = ur(t, (h) => f(h)), x = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (r) {
      let h = function(_) {
        if (x.paused || !c) return;
        const P = _.target;
        c.contains(P) ? v.current = P : Sr(v.current, { select: !0 });
      }, b = function(_) {
        if (x.paused || !c) return;
        const P = _.relatedTarget;
        P !== null && (c.contains(P) || Sr(v.current, { select: !0 }));
      }, w = function(_) {
        if (document.activeElement === document.body)
          for (const A of _)
            A.removedNodes.length > 0 && Sr(c);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", b);
      const N = new MutationObserver(w);
      return c && N.observe(c, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", b), N.disconnect();
      };
    }
  }, [r, c, x.paused]), d.useEffect(() => {
    if (c) {
      Zg.add(x);
      const h = document.activeElement;
      if (!c.contains(h)) {
        const w = new CustomEvent(pd, Kg);
        c.addEventListener(pd, p), c.dispatchEvent(w), w.defaultPrevented || (wA(EA(O3(c)), { select: !0 }), document.activeElement === h && Sr(c));
      }
      return () => {
        c.removeEventListener(pd, p), setTimeout(() => {
          const w = new CustomEvent(md, Kg);
          c.addEventListener(md, m), c.dispatchEvent(w), w.defaultPrevented || Sr(h ?? document.body, { select: !0 }), c.removeEventListener(md, m), Zg.remove(x);
        }, 0);
      };
    }
  }, [c, p, m, x]);
  const y = d.useCallback(
    (h) => {
      if (!n && !r || x.paused) return;
      const b = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, w = document.activeElement;
      if (b && w) {
        const N = h.currentTarget, [_, P] = SA(N);
        _ && P ? !h.shiftKey && w === P ? (h.preventDefault(), n && Sr(_, { select: !0 })) : h.shiftKey && w === _ && (h.preventDefault(), n && Sr(P, { select: !0 })) : w === N && h.preventDefault();
      }
    },
    [n, r, x.paused]
  );
  return /* @__PURE__ */ s(dr.div, { tabIndex: -1, ...l, ref: C, onKeyDown: y });
});
I3.displayName = yA;
function wA(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Sr(r, { select: t }), document.activeElement !== n) return;
}
function SA(e) {
  const t = O3(e), n = Yg(t, e), r = Yg(t.reverse(), e);
  return [n, r];
}
function O3(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Yg(e, t) {
  for (const n of e)
    if (!NA(n, { upTo: t })) return n;
}
function NA(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function _A(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Sr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && _A(e) && t && e.select();
  }
}
var Zg = RA();
function RA() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Xg(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Xg(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Xg(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function EA(e) {
  return e.filter((t) => t.tagName !== "A");
}
var PA = "Portal", k3 = d.forwardRef((e, t) => {
  var c;
  const { container: n, ...r } = e, [o, i] = d.useState(!1);
  be(() => i(!0), []);
  const l = n || o && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return l ? Br.createPortal(/* @__PURE__ */ s(dr.div, { ...r, ref: t }), l) : null;
});
k3.displayName = PA;
function AA(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var Hl = (e) => {
  const { present: t, children: n } = e, r = TA(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), i = ur(r.ref, $A(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: i }) : null;
};
Hl.displayName = "Presence";
function TA(e) {
  const [t, n] = d.useState(), r = d.useRef({}), o = d.useRef(e), i = d.useRef("none"), l = e ? "mounted" : "unmounted", [c, f] = AA(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const p = Ns(r.current);
    i.current = c === "mounted" ? p : "none";
  }, [c]), be(() => {
    const p = r.current, m = o.current;
    if (m !== e) {
      const C = i.current, x = Ns(p);
      e ? f("MOUNT") : x === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && C !== x ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), be(() => {
    if (t) {
      let p;
      const m = t.ownerDocument.defaultView ?? window, v = (x) => {
        const h = Ns(r.current).includes(x.animationName);
        if (x.target === t && h && (f("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, C = (x) => {
        x.target === t && (i.current = Ns(r.current));
      };
      return t.addEventListener("animationstart", C), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        m.clearTimeout(p), t.removeEventListener("animationstart", C), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: d.useCallback((p) => {
      p && (r.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function Ns(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function $A(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var hd = 0;
function M1() {
  d.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? jg()), document.body.insertAdjacentElement("beforeend", e[1] ?? jg()), hd++, () => {
      hd === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), hd--;
    };
  }, []);
}
function jg() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ae = function() {
  return Ae = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Ae.apply(this, arguments);
};
function Hn(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function wi(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var el = "right-scroll-bar-position", tl = "width-before-scroll-bar", LA = "with-scroll-bars-hidden", MA = "--removed-body-scroll-bar-size";
function gd(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function IA(e, t) {
  var n = ne(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var OA = typeof window < "u" ? d.useLayoutEffect : d.useEffect, Qg = /* @__PURE__ */ new WeakMap();
function kA(e, t) {
  var n = IA(null, function(r) {
    return e.forEach(function(o) {
      return gd(o, r);
    });
  });
  return OA(function() {
    var r = Qg.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), l = n.current;
      o.forEach(function(c) {
        i.has(c) || gd(c, null);
      }), i.forEach(function(c) {
        o.has(c) || gd(c, l);
      });
    }
    Qg.set(n, e);
  }, [e]), n;
}
function DA(e) {
  return e;
}
function FA(e, t) {
  t === void 0 && (t = DA);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var l = t(i, r);
      return n.push(l), function() {
        n = n.filter(function(c) {
          return c !== l;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var l = n;
        n = [], l.forEach(i);
      }
      n = {
        push: function(c) {
          return i(c);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var l = [];
      if (n.length) {
        var c = n;
        n = [], c.forEach(i), l = n;
      }
      var f = function() {
        var m = l;
        l = [], m.forEach(i);
      }, p = function() {
        return Promise.resolve().then(f);
      };
      p(), n = {
        push: function(m) {
          l.push(m), p();
        },
        filter: function(m) {
          return l = l.filter(m), n;
        }
      };
    }
  };
  return o;
}
function BA(e) {
  e === void 0 && (e = {});
  var t = FA(null);
  return t.options = Ae({ async: !0, ssr: !1 }, e), t;
}
var D3 = function(e) {
  var t = e.sideCar, n = Hn(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return d.createElement(r, Ae({}, n));
};
D3.isSideCarExport = !0;
function VA(e, t) {
  return e.useMedium(t), D3;
}
var F3 = BA(), vd = function() {
}, Ul = d.forwardRef(function(e, t) {
  var n = d.useRef(null), r = d.useState({
    onScrollCapture: vd,
    onWheelCapture: vd,
    onTouchMoveCapture: vd
  }), o = r[0], i = r[1], l = e.forwardProps, c = e.children, f = e.className, p = e.removeScrollBar, m = e.enabled, v = e.shards, C = e.sideCar, x = e.noIsolation, y = e.inert, h = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, N = e.gapMode, _ = Hn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), P = C, A = kA([n, t]), I = Ae(Ae({}, _), o);
  return d.createElement(
    d.Fragment,
    null,
    m && d.createElement(P, { sideCar: F3, removeScrollBar: p, shards: v, noIsolation: x, inert: y, setCallbacks: i, allowPinchZoom: !!h, lockRef: n, gapMode: N }),
    l ? d.cloneElement(d.Children.only(c), Ae(Ae({}, I), { ref: A })) : d.createElement(w, Ae({}, I, { className: f, ref: A }), c)
  );
});
Ul.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ul.classNames = {
  fullWidth: tl,
  zeroRight: el
};
var Gl = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function WA() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Gl();
  return t && e.setAttribute("nonce", t), e;
}
function HA(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function UA(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var GA = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = WA()) && (HA(t, n), UA(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, zA = function() {
  var e = GA();
  return function(t, n) {
    d.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, B3 = function() {
  var e = zA(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, qA = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Cd = function(e) {
  return parseInt(e || "", 10) || 0;
}, KA = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Cd(n), Cd(r), Cd(o)];
}, YA = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return qA;
  var t = KA(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, ZA = B3(), oi = "data-scroll-locked", XA = function(e, t, n, r) {
  var o = e.left, i = e.top, l = e.right, c = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(LA, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(c, "px ").concat(r, `;
  }
  body[`).concat(oi, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(l, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(c, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(el, ` {
    right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(tl, ` {
    margin-right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(el, " .").concat(el, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(tl, " .").concat(tl, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(oi, `] {
    `).concat(MA, ": ").concat(c, `px;
  }
`);
}, Jg = function() {
  var e = parseInt(document.body.getAttribute(oi) || "0", 10);
  return isFinite(e) ? e : 0;
}, jA = function() {
  d.useEffect(function() {
    return document.body.setAttribute(oi, (Jg() + 1).toString()), function() {
      var e = Jg() - 1;
      e <= 0 ? document.body.removeAttribute(oi) : document.body.setAttribute(oi, e.toString());
    };
  }, []);
}, QA = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  jA();
  var i = d.useMemo(function() {
    return YA(o);
  }, [o]);
  return d.createElement(ZA, { styles: XA(i, !t, o, n ? "" : "!important") });
}, mf = !1;
if (typeof window < "u")
  try {
    var _s = Object.defineProperty({}, "passive", {
      get: function() {
        return mf = !0, !0;
      }
    });
    window.addEventListener("test", _s, _s), window.removeEventListener("test", _s, _s);
  } catch {
    mf = !1;
  }
var Go = mf ? { passive: !1 } : !1, JA = function(e) {
  return e.tagName === "TEXTAREA";
}, V3 = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !JA(e) && n[t] === "visible")
  );
}, eT = function(e) {
  return V3(e, "overflowY");
}, tT = function(e) {
  return V3(e, "overflowX");
}, e0 = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = W3(e, r);
    if (o) {
      var i = H3(e, r), l = i[1], c = i[2];
      if (l > c)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, nT = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, rT = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, W3 = function(e, t) {
  return e === "v" ? eT(t) : tT(t);
}, H3 = function(e, t) {
  return e === "v" ? nT(t) : rT(t);
}, oT = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, iT = function(e, t, n, r, o) {
  var i = oT(e, window.getComputedStyle(t).direction), l = i * r, c = n.target, f = t.contains(c), p = !1, m = l > 0, v = 0, C = 0;
  do {
    var x = H3(e, c), y = x[0], h = x[1], b = x[2], w = h - b - i * y;
    (y || w) && W3(e, c) && (v += w, C += y), c instanceof ShadowRoot ? c = c.host : c = c.parentNode;
  } while (
    // portaled content
    !f && c !== document.body || // self content
    f && (t.contains(c) || t === c)
  );
  return (m && (Math.abs(v) < 1 || !o) || !m && (Math.abs(C) < 1 || !o)) && (p = !0), p;
}, Rs = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, t0 = function(e) {
  return [e.deltaX, e.deltaY];
}, n0 = function(e) {
  return e && "current" in e ? e.current : e;
}, aT = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, sT = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, lT = 0, zo = [];
function cT(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), o = d.useState(lT++)[0], i = d.useState(B3)[0], l = d.useRef(e);
  d.useEffect(function() {
    l.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = wi([e.lockRef.current], (e.shards || []).map(n0), !0).filter(Boolean);
      return h.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = d.useCallback(function(h, b) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !l.current.allowPinchZoom;
    var w = Rs(h), N = n.current, _ = "deltaX" in h ? h.deltaX : N[0] - w[0], P = "deltaY" in h ? h.deltaY : N[1] - w[1], A, I = h.target, T = Math.abs(_) > Math.abs(P) ? "h" : "v";
    if ("touches" in h && T === "h" && I.type === "range")
      return !1;
    var M = e0(T, I);
    if (!M)
      return !0;
    if (M ? A = T : (A = T === "v" ? "h" : "v", M = e0(T, I)), !M)
      return !1;
    if (!r.current && "changedTouches" in h && (_ || P) && (r.current = A), !A)
      return !0;
    var D = r.current || A;
    return iT(D, b, h, D === "h" ? _ : P, !0);
  }, []), f = d.useCallback(function(h) {
    var b = h;
    if (!(!zo.length || zo[zo.length - 1] !== i)) {
      var w = "deltaY" in b ? t0(b) : Rs(b), N = t.current.filter(function(A) {
        return A.name === b.type && (A.target === b.target || b.target === A.shadowParent) && aT(A.delta, w);
      })[0];
      if (N && N.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!N) {
        var _ = (l.current.shards || []).map(n0).filter(Boolean).filter(function(A) {
          return A.contains(b.target);
        }), P = _.length > 0 ? c(b, _[0]) : !l.current.noIsolation;
        P && b.cancelable && b.preventDefault();
      }
    }
  }, []), p = d.useCallback(function(h, b, w, N) {
    var _ = { name: h, delta: b, target: w, should: N, shadowParent: uT(w) };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(P) {
        return P !== _;
      });
    }, 1);
  }, []), m = d.useCallback(function(h) {
    n.current = Rs(h), r.current = void 0;
  }, []), v = d.useCallback(function(h) {
    p(h.type, t0(h), h.target, c(h, e.lockRef.current));
  }, []), C = d.useCallback(function(h) {
    p(h.type, Rs(h), h.target, c(h, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return zo.push(i), e.setCallbacks({
      onScrollCapture: v,
      onWheelCapture: v,
      onTouchMoveCapture: C
    }), document.addEventListener("wheel", f, Go), document.addEventListener("touchmove", f, Go), document.addEventListener("touchstart", m, Go), function() {
      zo = zo.filter(function(h) {
        return h !== i;
      }), document.removeEventListener("wheel", f, Go), document.removeEventListener("touchmove", f, Go), document.removeEventListener("touchstart", m, Go);
    };
  }, []);
  var x = e.removeScrollBar, y = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    y ? d.createElement(i, { styles: sT(o) }) : null,
    x ? d.createElement(QA, { gapMode: e.gapMode }) : null
  );
}
function uT(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const dT = VA(F3, cT);
var U3 = d.forwardRef(function(e, t) {
  return d.createElement(Ul, Ae({}, e, { ref: t, sideCar: dT }));
});
U3.classNames = Ul.classNames;
var fT = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, qo = /* @__PURE__ */ new WeakMap(), Es = /* @__PURE__ */ new WeakMap(), Ps = {}, xd = 0, G3 = function(e) {
  return e && (e.host || G3(e.parentNode));
}, pT = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = G3(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, mT = function(e, t, n, r) {
  var o = pT(t, Array.isArray(e) ? e : [e]);
  Ps[n] || (Ps[n] = /* @__PURE__ */ new WeakMap());
  var i = Ps[n], l = [], c = /* @__PURE__ */ new Set(), f = new Set(o), p = function(v) {
    !v || c.has(v) || (c.add(v), p(v.parentNode));
  };
  o.forEach(p);
  var m = function(v) {
    !v || f.has(v) || Array.prototype.forEach.call(v.children, function(C) {
      if (c.has(C))
        m(C);
      else
        try {
          var x = C.getAttribute(r), y = x !== null && x !== "false", h = (qo.get(C) || 0) + 1, b = (i.get(C) || 0) + 1;
          qo.set(C, h), i.set(C, b), l.push(C), h === 1 && y && Es.set(C, !0), b === 1 && C.setAttribute(n, "true"), y || C.setAttribute(r, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", C, w);
        }
    });
  };
  return m(t), c.clear(), xd++, function() {
    l.forEach(function(v) {
      var C = qo.get(v) - 1, x = i.get(v) - 1;
      qo.set(v, C), i.set(v, x), C || (Es.has(v) || v.removeAttribute(r), Es.delete(v)), x || v.removeAttribute(n);
    }), xd--, xd || (qo = /* @__PURE__ */ new WeakMap(), qo = /* @__PURE__ */ new WeakMap(), Es = /* @__PURE__ */ new WeakMap(), Ps = {});
  };
}, Si = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = fT(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), mT(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, I1 = "Dialog", [z3, q3] = P3(I1), [hT, $n] = z3(I1), K3 = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: l = !0
  } = e, c = d.useRef(null), f = d.useRef(null), [p = !1, m] = et({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ s(
    hT,
    {
      scope: t,
      triggerRef: c,
      contentRef: f,
      contentId: it(),
      titleId: it(),
      descriptionId: it(),
      open: p,
      onOpenChange: m,
      onOpenToggle: d.useCallback(() => m((v) => !v), [m]),
      modal: l,
      children: n
    }
  );
};
K3.displayName = I1;
var Y3 = "DialogTrigger", Z3 = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = $n(Y3, n), i = ur(t, o.triggerRef);
    return /* @__PURE__ */ s(
      dr.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": D1(o.open),
        ...r,
        ref: i,
        onClick: rr(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Z3.displayName = Y3;
var O1 = "DialogPortal", [gT, X3] = z3(O1, {
  forceMount: void 0
}), j3 = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = $n(O1, t);
  return /* @__PURE__ */ s(gT, { scope: t, forceMount: n, children: d.Children.map(r, (l) => /* @__PURE__ */ s(Hl, { present: n || i.open, children: /* @__PURE__ */ s(k3, { asChild: !0, container: o, children: l }) })) });
};
j3.displayName = O1;
var hl = "DialogOverlay", Q3 = d.forwardRef(
  (e, t) => {
    const n = X3(hl, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = $n(hl, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ s(Hl, { present: r || i.open, children: /* @__PURE__ */ s(vT, { ...o, ref: t }) }) : null;
  }
);
Q3.displayName = hl;
var vT = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = $n(hl, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ s(U3, { as: L1, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ s(
        dr.div,
        {
          "data-state": D1(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), po = "DialogContent", J3 = d.forwardRef(
  (e, t) => {
    const n = X3(po, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = $n(po, e.__scopeDialog);
    return /* @__PURE__ */ s(Hl, { present: r || i.open, children: i.modal ? /* @__PURE__ */ s(CT, { ...o, ref: t }) : /* @__PURE__ */ s(xT, { ...o, ref: t }) });
  }
);
J3.displayName = po;
var CT = d.forwardRef(
  (e, t) => {
    const n = $n(po, e.__scopeDialog), r = d.useRef(null), o = ur(t, n.contentRef, r);
    return d.useEffect(() => {
      const i = r.current;
      if (i) return Si(i);
    }, []), /* @__PURE__ */ s(
      ev,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: rr(e.onCloseAutoFocus, (i) => {
          var l;
          i.preventDefault(), (l = n.triggerRef.current) == null || l.focus();
        }),
        onPointerDownOutside: rr(e.onPointerDownOutside, (i) => {
          const l = i.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0;
          (l.button === 2 || c) && i.preventDefault();
        }),
        onFocusOutside: rr(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), xT = d.forwardRef(
  (e, t) => {
    const n = $n(po, e.__scopeDialog), r = d.useRef(!1), o = d.useRef(!1);
    return /* @__PURE__ */ s(
      ev,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var l, c;
          (l = e.onCloseAutoFocus) == null || l.call(e, i), i.defaultPrevented || (r.current || (c = n.triggerRef.current) == null || c.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var f, p;
          (f = e.onInteractOutside) == null || f.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const l = i.target;
          ((p = n.triggerRef.current) == null ? void 0 : p.contains(l)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), ev = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...l } = e, c = $n(po, n), f = d.useRef(null), p = ur(t, f);
    return M1(), /* @__PURE__ */ R(le, { children: [
      /* @__PURE__ */ s(
        I3,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ s(
            L3,
            {
              role: "dialog",
              id: c.contentId,
              "aria-describedby": c.descriptionId,
              "aria-labelledby": c.titleId,
              "data-state": D1(c.open),
              ...l,
              ref: p,
              onDismiss: () => c.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ R(le, { children: [
        /* @__PURE__ */ s(yT, { titleId: c.titleId }),
        /* @__PURE__ */ s(ST, { contentRef: f, descriptionId: c.descriptionId })
      ] })
    ] });
  }
), k1 = "DialogTitle", tv = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = $n(k1, n);
    return /* @__PURE__ */ s(dr.h2, { id: o.titleId, ...r, ref: t });
  }
);
tv.displayName = k1;
var nv = "DialogDescription", rv = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = $n(nv, n);
    return /* @__PURE__ */ s(dr.p, { id: o.descriptionId, ...r, ref: t });
  }
);
rv.displayName = nv;
var ov = "DialogClose", iv = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = $n(ov, n);
    return /* @__PURE__ */ s(
      dr.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: rr(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
iv.displayName = ov;
function D1(e) {
  return e ? "open" : "closed";
}
var av = "DialogTitleWarning", [bT, sv] = sA(av, {
  contentName: po,
  titleName: k1,
  docsSlug: "dialog"
}), yT = ({ titleId: e }) => {
  const t = sv(av), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return d.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, wT = "DialogDescriptionWarning", ST = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${sv(wT).contentName}}.`;
  return d.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, NT = K3, _T = Z3, RT = j3, ET = Q3, PT = J3, AT = tv, TT = rv, lv = iv, cv = "AlertDialog", [$T, OY] = P3(cv, [
  q3
]), fr = q3(), uv = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = fr(t);
  return /* @__PURE__ */ s(NT, { ...r, ...n, modal: !0 });
};
uv.displayName = cv;
var LT = "AlertDialogTrigger", dv = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = fr(n);
    return /* @__PURE__ */ s(_T, { ...o, ...r, ref: t });
  }
);
dv.displayName = LT;
var MT = "AlertDialogPortal", fv = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = fr(t);
  return /* @__PURE__ */ s(RT, { ...r, ...n });
};
fv.displayName = MT;
var IT = "AlertDialogOverlay", pv = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = fr(n);
    return /* @__PURE__ */ s(ET, { ...o, ...r, ref: t });
  }
);
pv.displayName = IT;
var ii = "AlertDialogContent", [OT, kT] = $T(ii), mv = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, children: r, ...o } = e, i = fr(n), l = d.useRef(null), c = ur(t, l), f = d.useRef(null);
    return /* @__PURE__ */ s(
      bT,
      {
        contentName: ii,
        titleName: hv,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ s(OT, { scope: n, cancelRef: f, children: /* @__PURE__ */ R(
          PT,
          {
            role: "alertdialog",
            ...i,
            ...o,
            ref: c,
            onOpenAutoFocus: rr(o.onOpenAutoFocus, (p) => {
              var m;
              p.preventDefault(), (m = f.current) == null || m.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (p) => p.preventDefault(),
            onInteractOutside: (p) => p.preventDefault(),
            children: [
              /* @__PURE__ */ s(T3, { children: r }),
              /* @__PURE__ */ s(FT, { contentRef: l })
            ]
          }
        ) })
      }
    );
  }
);
mv.displayName = ii;
var hv = "AlertDialogTitle", gv = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = fr(n);
    return /* @__PURE__ */ s(AT, { ...o, ...r, ref: t });
  }
);
gv.displayName = hv;
var vv = "AlertDialogDescription", Cv = d.forwardRef((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = fr(n);
  return /* @__PURE__ */ s(TT, { ...o, ...r, ref: t });
});
Cv.displayName = vv;
var DT = "AlertDialogAction", xv = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = fr(n);
    return /* @__PURE__ */ s(lv, { ...o, ...r, ref: t });
  }
);
xv.displayName = DT;
var bv = "AlertDialogCancel", yv = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, { cancelRef: o } = kT(bv, n), i = fr(n), l = ur(t, o);
    return /* @__PURE__ */ s(lv, { ...i, ...r, ref: l });
  }
);
yv.displayName = bv;
var FT = ({ contentRef: e }) => {
  const t = `\`${ii}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${ii}\` by passing a \`${vv}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${ii}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return d.useEffect(() => {
    var r;
    document.getElementById(
      (r = e.current) == null ? void 0 : r.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, BT = uv, VT = dv, WT = fv, wv = pv, Sv = mv, Nv = xv, _v = yv, Rv = gv, Ev = Cv;
const kY = BT, DY = VT, HT = WT, Pv = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  wv,
  {
    className: F(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0  fixed inset-0 z-50 bg-black/80",
      e
    ),
    ...t,
    ref: n
  }
));
Pv.displayName = wv.displayName;
const UT = q(({ className: e, ...t }, n) => /* @__PURE__ */ R(HT, { children: [
  /* @__PURE__ */ s(Pv, {}),
  /* @__PURE__ */ s(
    Sv,
    {
      ref: n,
      className: F(
        "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border p-6 shadow-lg duration-200 sm:rounded-lg",
        e
      ),
      ...t
    }
  )
] }));
UT.displayName = Sv.displayName;
const GT = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  "div",
  {
    className: F(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
GT.displayName = "AlertDialogHeader";
const zT = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  "div",
  {
    className: F(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
zT.displayName = "AlertDialogFooter";
const qT = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Rv,
  {
    ref: n,
    className: F("text-lg font-semibold", e),
    ...t
  }
));
qT.displayName = Rv.displayName;
const KT = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Ev,
  {
    ref: n,
    className: F("text-muted-foreground text-sm", e),
    ...t
  }
));
KT.displayName = Ev.displayName;
const YT = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Nv,
  {
    ref: n,
    className: F(zl(), e),
    ...t
  }
));
YT.displayName = Nv.displayName;
const ZT = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  _v,
  {
    ref: n,
    className: F(
      zl({ variant: "outline" }),
      "mt-2 sm:mt-0",
      e
    ),
    ...t
  }
));
ZT.displayName = _v.displayName;
function FY({
  className: e,
  onCompleteAnimation: t,
  pauseAnimation: n,
  text: r,
  textAnimationSpeed: o = 500
}) {
  const [i, l] = ne(r), [c, f] = ne(""), [p, m] = ne(0), v = Je(null);
  return Oe(() => {
    l(r), f(""), m(0), v.current && clearTimeout(v.current);
  }, [r]), Oe(() => {
    if (!n)
      return v.current = setTimeout(() => {
        f((C) => C + i[p]), m((C) => C + 1);
      }, o), () => {
        v.current && clearTimeout(v.current);
      };
  }, [p, i, n, o]), Oe(() => {
    p > i.length && (f(""), m(0), i.length > 0 && t && t());
  }, [p, t, i]), /* @__PURE__ */ s("div", { className: e, children: c || /* @__PURE__ */ s(le, { children: " " }) });
}
function r0(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function XT(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = r0(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : r0(e[o], null);
        }
      };
  };
}
var rn = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = d.Children.toArray(n), i = o.find(QT);
  if (i) {
    const l = i.props.children, c = o.map((f) => f === i ? d.Children.count(l) > 1 ? d.Children.only(null) : d.isValidElement(l) ? l.props.children : null : f);
    return /* @__PURE__ */ s(hf, { ...r, ref: t, children: d.isValidElement(l) ? d.cloneElement(l, void 0, c) : null });
  }
  return /* @__PURE__ */ s(hf, { ...r, ref: t, children: n });
});
rn.displayName = "Slot";
var hf = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const o = e$(n);
    return d.cloneElement(n, {
      ...JT(r, n.props),
      // @ts-ignore
      ref: t ? XT(t, o) : o
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
hf.displayName = "SlotClone";
var jT = ({ children: e }) => /* @__PURE__ */ s(le, { children: e });
function QT(e) {
  return d.isValidElement(e) && e.type === jT;
}
function JT(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function e$(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
const zl = cr(
  "cursor-pointer inline-flex items-center justify-center whitespace-nowrap rounded-md text-headingmd font-semibold ring-offset-background transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 gap-2 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "bg-background border border-blueDefault text-blueDefault hover:bg-blueBgLight",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-textLink underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), ct = q(
  ({ className: e, variant: t, size: n, asChild: r = !1, ...o }, i) => /* @__PURE__ */ s(
    r ? rn : "button",
    {
      className: F(zl({ variant: t, size: n }), e),
      ref: i,
      ...o
    }
  )
);
ct.displayName = "Button";
const t$ = cr(
  "inline-flex items-center rounded-full border border-border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function n$({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ s("div", { className: F(t$({ variant: t }), e), ...n });
}
const r$ = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ s(
    "div",
    {
      ref: n,
      className: F(
        "bg-card text-card-foreground border-border shadow-xs rounded-lg border",
        e
      ),
      ...t
    }
  )
);
r$.displayName = "Card";
const o$ = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ s(
    "div",
    {
      ref: n,
      className: F("flex flex-col space-y-1.5 p-6", e),
      ...t
    }
  )
);
o$.displayName = "CardHeader";
const i$ = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "h3",
  {
    ref: n,
    className: F(
      "text-2xl font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
i$.displayName = "CardTitle";
const a$ = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "p",
  {
    ref: n,
    className: F("text-muted-foreground text-sm", e),
    ...t
  }
));
a$.displayName = "CardDescription";
const s$ = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ s("div", { ref: n, className: F("p-6 pt-0", e), ...t })
);
s$.displayName = "CardContent";
const l$ = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ s(
    "div",
    {
      ref: n,
      className: F("flex items-center p-6 pt-0", e),
      ...t
    }
  )
);
l$.displayName = "CardFooter";
function o0(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Av(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = o0(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : o0(e[o], null);
        }
      };
  };
}
function Tv(...e) {
  return d.useCallback(Av(...e), e);
}
function c$(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    const p = (v) => {
      var w;
      const { scope: C, children: x, ...y } = v, h = ((w = C == null ? void 0 : C[e]) == null ? void 0 : w[f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    };
    p.displayName = i + "Provider";
    function m(v, C) {
      var h;
      const x = ((h = C == null ? void 0 : C[e]) == null ? void 0 : h[f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, u$(o, ...t)];
}
function u$(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function i0(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Ni(e) {
  const t = d.useRef({ value: e, previous: e });
  return d.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function Hr(e) {
  const [t, n] = d.useState(void 0);
  return be(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let l, c;
        if ("borderBoxSize" in i) {
          const f = i.borderBoxSize, p = Array.isArray(f) ? f[0] : f;
          l = p.inlineSize, c = p.blockSize;
        } else
          l = e.offsetWidth, c = e.offsetHeight;
        n({ width: l, height: c });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function d$(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var $v = (e) => {
  const { present: t, children: n } = e, r = f$(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), i = Tv(r.ref, p$(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: i }) : null;
};
$v.displayName = "Presence";
function f$(e) {
  const [t, n] = d.useState(), r = d.useRef({}), o = d.useRef(e), i = d.useRef("none"), l = e ? "mounted" : "unmounted", [c, f] = d$(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const p = As(r.current);
    i.current = c === "mounted" ? p : "none";
  }, [c]), be(() => {
    const p = r.current, m = o.current;
    if (m !== e) {
      const C = i.current, x = As(p);
      e ? f("MOUNT") : x === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && C !== x ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), be(() => {
    if (t) {
      let p;
      const m = t.ownerDocument.defaultView ?? window, v = (x) => {
        const h = As(r.current).includes(x.animationName);
        if (x.target === t && h && (f("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, C = (x) => {
        x.target === t && (i.current = As(r.current));
      };
      return t.addEventListener("animationstart", C), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        m.clearTimeout(p), t.removeEventListener("animationstart", C), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: d.useCallback((p) => {
      p && (r.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function As(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function p$(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Lv = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = d.Children.toArray(n), i = o.find(h$);
  if (i) {
    const l = i.props.children, c = o.map((f) => f === i ? d.Children.count(l) > 1 ? d.Children.only(null) : d.isValidElement(l) ? l.props.children : null : f);
    return /* @__PURE__ */ s(gf, { ...r, ref: t, children: d.isValidElement(l) ? d.cloneElement(l, void 0, c) : null });
  }
  return /* @__PURE__ */ s(gf, { ...r, ref: t, children: n });
});
Lv.displayName = "Slot";
var gf = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const o = v$(n);
    return d.cloneElement(n, {
      ...g$(r, n.props),
      // @ts-ignore
      ref: t ? Av(t, o) : o
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
gf.displayName = "SlotClone";
var m$ = ({ children: e }) => /* @__PURE__ */ s(le, { children: e });
function h$(e) {
  return d.isValidElement(e) && e.type === m$;
}
function g$(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function v$(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var C$ = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Mv = C$.reduce((e, t) => {
  const n = d.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, c = i ? Lv : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(c, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), F1 = "Checkbox", [x$, BY] = c$(F1), [b$, y$] = x$(F1), Iv = d.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: l,
      disabled: c,
      value: f = "on",
      onCheckedChange: p,
      form: m,
      ...v
    } = e, [C, x] = d.useState(null), y = Tv(t, (P) => x(P)), h = d.useRef(!1), b = C ? m || !!C.closest("form") : !0, [w = !1, N] = et({
      prop: o,
      defaultProp: i,
      onChange: p
    }), _ = d.useRef(w);
    return d.useEffect(() => {
      const P = C == null ? void 0 : C.form;
      if (P) {
        const A = () => N(_.current);
        return P.addEventListener("reset", A), () => P.removeEventListener("reset", A);
      }
    }, [C, N]), /* @__PURE__ */ R(b$, { scope: n, state: w, disabled: c, children: [
      /* @__PURE__ */ s(
        Mv.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": $r(w) ? "mixed" : w,
          "aria-required": l,
          "data-state": Dv(w),
          "data-disabled": c ? "" : void 0,
          disabled: c,
          value: f,
          ...v,
          ref: y,
          onKeyDown: i0(e.onKeyDown, (P) => {
            P.key === "Enter" && P.preventDefault();
          }),
          onClick: i0(e.onClick, (P) => {
            N((A) => $r(A) ? !0 : !A), b && (h.current = P.isPropagationStopped(), h.current || P.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ s(
        w$,
        {
          control: C,
          bubbles: !h.current,
          name: r,
          value: f,
          checked: w,
          required: l,
          disabled: c,
          form: m,
          style: { transform: "translateX(-100%)" },
          defaultChecked: $r(i) ? !1 : i
        }
      )
    ] });
  }
);
Iv.displayName = F1;
var Ov = "CheckboxIndicator", kv = d.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, i = y$(Ov, n);
    return /* @__PURE__ */ s($v, { present: r || $r(i.state) || i.state === !0, children: /* @__PURE__ */ s(
      Mv.span,
      {
        "data-state": Dv(i.state),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
kv.displayName = Ov;
var w$ = (e) => {
  const { control: t, checked: n, bubbles: r = !0, defaultChecked: o, ...i } = e, l = d.useRef(null), c = Ni(n), f = Hr(t);
  d.useEffect(() => {
    const m = l.current, v = window.HTMLInputElement.prototype, x = Object.getOwnPropertyDescriptor(v, "checked").set;
    if (c !== n && x) {
      const y = new Event("click", { bubbles: r });
      m.indeterminate = $r(n), x.call(m, $r(n) ? !1 : n), m.dispatchEvent(y);
    }
  }, [c, n, r]);
  const p = d.useRef($r(n) ? !1 : n);
  return /* @__PURE__ */ s(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: o ?? p.current,
      ...i,
      tabIndex: -1,
      ref: l,
      style: {
        ...e.style,
        ...f,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function $r(e) {
  return e === "indeterminate";
}
function Dv(e) {
  return $r(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var Fv = Iv, S$ = kv;
const io = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Fv,
  {
    ref: n,
    className: F(
      "ring-offset-background focus-visible:ring-ring data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground border-interactiveBorder peer h-6 w-6 shrink-0 rounded-xs border focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    children: /* @__PURE__ */ s(
      S$,
      {
        className: F("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ s(wo, { className: "h-4 w-4" })
      }
    )
  }
));
io.displayName = Fv.displayName;
function VY({
  className: e,
  options: t,
  onChange: n,
  values: r
}) {
  return /* @__PURE__ */ s("ul", { className: F("flex flex-col gap-2", e), children: t.map((o, i) => {
    const l = r.some((c) => c.value === o.value);
    return /* @__PURE__ */ s("li", { children: /* @__PURE__ */ R(nt, { className: F("flex gap-2", e), children: [
      /* @__PURE__ */ s(
        io,
        {
          checked: l,
          onCheckedChange: (c) => n(
            c ? [...r, o] : r.filter((f) => f.value !== o.value)
          )
        }
      ),
      o.label
    ] }) }, `${o.value}-${i}`);
  }) });
}
function WY({
  noOptionsFoundMessage: e = "no options found.",
  onChange: t,
  options: n,
  placeholder: r,
  value: o
}) {
  var c;
  const [i, l] = ne(!1);
  return /* @__PURE__ */ R(B7, { open: i, onOpenChange: l, children: [
    /* @__PURE__ */ s(V7, { asChild: !0, children: /* @__PURE__ */ R(
      ct,
      {
        variant: "outline",
        role: "combobox",
        "aria-expanded": i,
        className: "w-[200px] justify-between",
        children: [
          o ? (c = n.find((f) => f.value === o)) == null ? void 0 : c.label : r,
          /* @__PURE__ */ s(mP, { className: "ml-2 h-4 w-4 shrink-0 opacity-50" })
        ]
      }
    ) }),
    /* @__PURE__ */ s(Vp, { className: "w-[200px] p-0", children: /* @__PURE__ */ R(
      ya,
      {
        filter: (f, p, m) => m != null && m[0].includes(p) ? 1 : 0,
        children: [
          /* @__PURE__ */ s(s4, { placeholder: r }),
          /* @__PURE__ */ R(jl, { children: [
            /* @__PURE__ */ s(l4, { children: e }),
            /* @__PURE__ */ s(Ql, { children: n.map((f) => /* @__PURE__ */ R(
              Jl,
              {
                keywords: [f.label],
                value: f.value || "",
                onSelect: (p) => {
                  t(p === o ? "" : p), l(!1);
                },
                children: [
                  /* @__PURE__ */ s(
                    wo,
                    {
                      className: F(
                        "mr-2 h-4 w-4",
                        o === f.value ? "opacity-100" : "opacity-0"
                      )
                    }
                  ),
                  f.label
                ]
              },
              f.value
            )) })
          ] })
        ]
      }
    ) })
  ] });
}
function ql(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var N$ = ["color"], _$ = /* @__PURE__ */ q(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, o = ql(e, N$);
  return Ge("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), Ge("path", {
    d: "M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), R$ = ["color"], E$ = /* @__PURE__ */ q(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, o = ql(e, R$);
  return Ge("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), Ge("path", {
    d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), P$ = ["color"], A$ = /* @__PURE__ */ q(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, o = ql(e, P$);
  return Ge("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), Ge("path", {
    d: "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), T$ = ["color"], $$ = /* @__PURE__ */ q(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, o = ql(e, T$);
  return Ge("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), Ge("path", {
    d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), a0 = 1, L$ = 0.9, M$ = 0.8, I$ = 0.17, bd = 0.1, yd = 0.999, O$ = 0.9999, k$ = 0.99, D$ = /[\\\/_+.#"@\[\(\{&]/, F$ = /[\\\/_+.#"@\[\(\{&]/g, B$ = /[\s-]/, Bv = /[\s-]/g;
function vf(e, t, n, r, o, i, l) {
  if (i === t.length) return o === e.length ? a0 : k$;
  var c = `${o},${i}`;
  if (l[c] !== void 0) return l[c];
  for (var f = r.charAt(i), p = n.indexOf(f, o), m = 0, v, C, x, y; p >= 0; ) v = vf(e, t, n, r, p + 1, i + 1, l), v > m && (p === o ? v *= a0 : D$.test(e.charAt(p - 1)) ? (v *= M$, x = e.slice(o, p - 1).match(F$), x && o > 0 && (v *= Math.pow(yd, x.length))) : B$.test(e.charAt(p - 1)) ? (v *= L$, y = e.slice(o, p - 1).match(Bv), y && o > 0 && (v *= Math.pow(yd, y.length))) : (v *= I$, o > 0 && (v *= Math.pow(yd, p - o))), e.charAt(p) !== t.charAt(i) && (v *= O$)), (v < bd && n.charAt(p - 1) === r.charAt(i + 1) || r.charAt(i + 1) === r.charAt(i) && n.charAt(p - 1) !== r.charAt(i)) && (C = vf(e, t, n, r, p + 1, i + 2, l), C * bd > v && (v = C * bd)), v > m && (m = v), p = n.indexOf(f, p + 1);
  return l[c] = m, m;
}
function s0(e) {
  return e.toLowerCase().replace(Bv, " ");
}
function V$(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, vf(e, t, s0(e), s0(t), 0, 0, {});
}
function Bt() {
  return Bt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bt.apply(null, arguments);
}
function ai(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented) return t == null ? void 0 : t(o);
  };
}
function W$(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Vv(...e) {
  return (t) => e.forEach(
    (n) => W$(n, t)
  );
}
function xa(...e) {
  return hn(Vv(...e), e);
}
function H$(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = /* @__PURE__ */ Mr(l), f = n.length;
    n = [
      ...n,
      l
    ];
    function p(v) {
      const { scope: C, children: x, ...y } = v, h = (C == null ? void 0 : C[e][f]) || c, b = gn(
        () => y,
        Object.values(y)
      );
      return /* @__PURE__ */ Ge(h.Provider, {
        value: b
      }, x);
    }
    function m(v, C) {
      const x = (C == null ? void 0 : C[e][f]) || c, y = lo(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return p.displayName = i + "Provider", [
      p,
      m
    ];
  }
  const o = () => {
    const i = n.map((l) => /* @__PURE__ */ Mr(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return gn(
        () => ({
          [`__scope${e}`]: {
            ...c,
            [e]: f
          }
        }),
        [
          c,
          f
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    U$(o, ...t)
  ];
}
function U$(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return {
          ...c,
          ...v
        };
      }, {});
      return gn(
        () => ({
          [`__scope${t.scopeName}`]: l
        }),
        [
          l
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const Cf = globalThis != null && globalThis.document ? y1 : () => {
}, G$ = d.useId || (() => {
});
let z$ = 0;
function wd(e) {
  const [t, n] = d.useState(G$());
  return Cf(() => {
    e || n(
      (r) => r ?? String(z$++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function mo(e) {
  const t = Je(e);
  return Oe(() => {
    t.current = e;
  }), gn(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function q$({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = K$({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, l = i ? e : r, c = mo(n), f = hn((p) => {
    if (i) {
      const v = typeof p == "function" ? p(e) : p;
      v !== e && c(v);
    } else o(p);
  }, [
    i,
    e,
    o,
    c
  ]);
  return [
    l,
    f
  ];
}
function K$({ defaultProp: e, onChange: t }) {
  const n = ne(e), [r] = n, o = Je(r), i = mo(t);
  return Oe(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
const B1 = /* @__PURE__ */ q((e, t) => {
  const { children: n, ...r } = e, o = ao.toArray(n), i = o.find(Z$);
  if (i) {
    const l = i.props.children, c = o.map((f) => f === i ? ao.count(l) > 1 ? ao.only(null) : /* @__PURE__ */ fl(l) ? l.props.children : null : f);
    return /* @__PURE__ */ Ge(xf, Bt({}, r, {
      ref: t
    }), /* @__PURE__ */ fl(l) ? /* @__PURE__ */ w1(l, void 0, c) : null);
  }
  return /* @__PURE__ */ Ge(xf, Bt({}, r, {
    ref: t
  }), n);
});
B1.displayName = "Slot";
const xf = /* @__PURE__ */ q((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ fl(n) ? /* @__PURE__ */ w1(n, {
    ...X$(r, n.props),
    ref: t ? Vv(t, n.ref) : n.ref
  }) : ao.count(n) > 1 ? ao.only(null) : null;
});
xf.displayName = "SlotClone";
const Y$ = ({ children: e }) => /* @__PURE__ */ Ge(ia, null, e);
function Z$(e) {
  return /* @__PURE__ */ fl(e) && e.type === Y$;
}
function X$(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const j$ = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Cn = j$.reduce((e, t) => {
  const n = /* @__PURE__ */ q((r, o) => {
    const { asChild: i, ...l } = r, c = i ? B1 : t;
    return Oe(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ Ge(c, Bt({}, l, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function Q$(e, t) {
  e && i3(
    () => e.dispatchEvent(t)
  );
}
function J$(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = mo(e);
  Oe(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const bf = "dismissableLayer.update", eL = "dismissableLayer.pointerDownOutside", tL = "dismissableLayer.focusOutside";
let l0;
const nL = /* @__PURE__ */ Mr({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), rL = /* @__PURE__ */ q((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: l, onInteractOutside: c, onDismiss: f, ...p } = e, m = lo(nL), [v, C] = ne(null), x = (n = v == null ? void 0 : v.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, y] = ne({}), h = xa(
    t,
    (M) => C(M)
  ), b = Array.from(m.layers), [w] = [
    ...m.layersWithOutsidePointerEventsDisabled
  ].slice(-1), N = b.indexOf(w), _ = v ? b.indexOf(v) : -1, P = m.layersWithOutsidePointerEventsDisabled.size > 0, A = _ >= N, I = oL((M) => {
    const D = M.target, W = [
      ...m.branches
    ].some(
      (U) => U.contains(D)
    );
    !A || W || (i == null || i(M), c == null || c(M), M.defaultPrevented || f == null || f());
  }, x), T = iL((M) => {
    const D = M.target;
    [
      ...m.branches
    ].some(
      (U) => U.contains(D)
    ) || (l == null || l(M), c == null || c(M), M.defaultPrevented || f == null || f());
  }, x);
  return J$((M) => {
    _ === m.layers.size - 1 && (o == null || o(M), !M.defaultPrevented && f && (M.preventDefault(), f()));
  }, x), Oe(() => {
    if (v)
      return r && (m.layersWithOutsidePointerEventsDisabled.size === 0 && (l0 = x.body.style.pointerEvents, x.body.style.pointerEvents = "none"), m.layersWithOutsidePointerEventsDisabled.add(v)), m.layers.add(v), c0(), () => {
        r && m.layersWithOutsidePointerEventsDisabled.size === 1 && (x.body.style.pointerEvents = l0);
      };
  }, [
    v,
    x,
    r,
    m
  ]), Oe(() => () => {
    v && (m.layers.delete(v), m.layersWithOutsidePointerEventsDisabled.delete(v), c0());
  }, [
    v,
    m
  ]), Oe(() => {
    const M = () => y({});
    return document.addEventListener(bf, M), () => document.removeEventListener(bf, M);
  }, []), /* @__PURE__ */ Ge(Cn.div, Bt({}, p, {
    ref: h,
    style: {
      pointerEvents: P ? A ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: ai(e.onFocusCapture, T.onFocusCapture),
    onBlurCapture: ai(e.onBlurCapture, T.onBlurCapture),
    onPointerDownCapture: ai(e.onPointerDownCapture, I.onPointerDownCapture)
  }));
});
function oL(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = mo(e), r = Je(!1), o = Je(() => {
  });
  return Oe(() => {
    const i = (c) => {
      if (c.target && !r.current) {
        let p = function() {
          Wv(eL, n, f, {
            discrete: !0
          });
        };
        const f = {
          originalEvent: c
        };
        c.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = p, t.addEventListener("click", o.current, {
          once: !0
        })) : p();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function iL(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = mo(e), r = Je(!1);
  return Oe(() => {
    const o = (i) => {
      i.target && !r.current && Wv(tL, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function c0() {
  const e = new CustomEvent(bf);
  document.dispatchEvent(e);
}
function Wv(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? Q$(o, i) : o.dispatchEvent(i);
}
const Sd = "focusScope.autoFocusOnMount", Nd = "focusScope.autoFocusOnUnmount", u0 = {
  bubbles: !1,
  cancelable: !0
}, aL = /* @__PURE__ */ q((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...l } = e, [c, f] = ne(null), p = mo(o), m = mo(i), v = Je(null), C = xa(
    t,
    (h) => f(h)
  ), x = Je({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Oe(() => {
    if (r) {
      let h = function(_) {
        if (x.paused || !c) return;
        const P = _.target;
        c.contains(P) ? v.current = P : Nr(v.current, {
          select: !0
        });
      }, b = function(_) {
        if (x.paused || !c) return;
        const P = _.relatedTarget;
        P !== null && (c.contains(P) || Nr(v.current, {
          select: !0
        }));
      }, w = function(_) {
        if (document.activeElement === document.body)
          for (const A of _) A.removedNodes.length > 0 && Nr(c);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", b);
      const N = new MutationObserver(w);
      return c && N.observe(c, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", b), N.disconnect();
      };
    }
  }, [
    r,
    c,
    x.paused
  ]), Oe(() => {
    if (c) {
      f0.add(x);
      const h = document.activeElement;
      if (!c.contains(h)) {
        const w = new CustomEvent(Sd, u0);
        c.addEventListener(Sd, p), c.dispatchEvent(w), w.defaultPrevented || (sL(fL(Hv(c)), {
          select: !0
        }), document.activeElement === h && Nr(c));
      }
      return () => {
        c.removeEventListener(Sd, p), setTimeout(() => {
          const w = new CustomEvent(Nd, u0);
          c.addEventListener(Nd, m), c.dispatchEvent(w), w.defaultPrevented || Nr(h ?? document.body, {
            select: !0
          }), c.removeEventListener(Nd, m), f0.remove(x);
        }, 0);
      };
    }
  }, [
    c,
    p,
    m,
    x
  ]);
  const y = hn((h) => {
    if (!n && !r || x.paused) return;
    const b = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, w = document.activeElement;
    if (b && w) {
      const N = h.currentTarget, [_, P] = lL(N);
      _ && P ? !h.shiftKey && w === P ? (h.preventDefault(), n && Nr(_, {
        select: !0
      })) : h.shiftKey && w === _ && (h.preventDefault(), n && Nr(P, {
        select: !0
      })) : w === N && h.preventDefault();
    }
  }, [
    n,
    r,
    x.paused
  ]);
  return /* @__PURE__ */ Ge(Cn.div, Bt({
    tabIndex: -1
  }, l, {
    ref: C,
    onKeyDown: y
  }));
});
function sL(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Nr(r, {
      select: t
    }), document.activeElement !== n) return;
}
function lL(e) {
  const t = Hv(e), n = d0(t, e), r = d0(t.reverse(), e);
  return [
    n,
    r
  ];
}
function Hv(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function d0(e, t) {
  for (const n of e)
    if (!cL(n, {
      upTo: t
    })) return n;
}
function cL(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function uL(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Nr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && uL(e) && t && e.select();
  }
}
const f0 = dL();
function dL() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = p0(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = p0(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function p0(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function fL(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const pL = /* @__PURE__ */ q((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ Br.createPortal(/* @__PURE__ */ Ge(Cn.div, Bt({}, o, {
    ref: t
  })), r) : null;
});
function mL(e, t) {
  return eP((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const Kl = (e) => {
  const { present: t, children: n } = e, r = hL(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : ao.only(n), i = xa(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ w1(o, {
    ref: i
  }) : null;
};
Kl.displayName = "Presence";
function hL(e) {
  const [t, n] = ne(), r = Je({}), o = Je(e), i = Je("none"), l = e ? "mounted" : "unmounted", [c, f] = mL(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Oe(() => {
    const p = Ts(r.current);
    i.current = c === "mounted" ? p : "none";
  }, [
    c
  ]), Cf(() => {
    const p = r.current, m = o.current;
    if (m !== e) {
      const C = i.current, x = Ts(p);
      e ? f("MOUNT") : x === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && C !== x ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    f
  ]), Cf(() => {
    if (t) {
      const p = (v) => {
        const x = Ts(r.current).includes(v.animationName);
        v.target === t && x && i3(
          () => f("ANIMATION_END")
        );
      }, m = (v) => {
        v.target === t && (i.current = Ts(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", p), t.addEventListener("animationend", p), () => {
        t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", p), t.removeEventListener("animationend", p);
      };
    } else
      f("ANIMATION_END");
  }, [
    t,
    f
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(c),
    ref: hn((p) => {
      p && (r.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function Ts(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
let _d = 0;
function gL() {
  Oe(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : m0()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : m0()), _d++, () => {
      _d === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), _d--;
    };
  }, []);
}
function m0() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var si = "right-scroll-bar-position", li = "width-before-scroll-bar", vL = "with-scroll-bars-hidden", CL = "--removed-body-scroll-bar-size";
function Rd(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function xL(e, t) {
  var n = ne(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var bL = typeof window < "u" ? d.useLayoutEffect : d.useEffect, h0 = /* @__PURE__ */ new WeakMap();
function V1(e, t) {
  var n = xL(null, function(r) {
    return e.forEach(function(o) {
      return Rd(o, r);
    });
  });
  return bL(function() {
    var r = h0.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), l = n.current;
      o.forEach(function(c) {
        i.has(c) || Rd(c, null);
      }), i.forEach(function(c) {
        o.has(c) || Rd(c, l);
      });
    }
    h0.set(n, e);
  }, [e]), n;
}
function yL(e) {
  return e;
}
function wL(e, t) {
  t === void 0 && (t = yL);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var l = t(i, r);
      return n.push(l), function() {
        n = n.filter(function(c) {
          return c !== l;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var l = n;
        n = [], l.forEach(i);
      }
      n = {
        push: function(c) {
          return i(c);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var l = [];
      if (n.length) {
        var c = n;
        n = [], c.forEach(i), l = n;
      }
      var f = function() {
        var m = l;
        l = [], m.forEach(i);
      }, p = function() {
        return Promise.resolve().then(f);
      };
      p(), n = {
        push: function(m) {
          l.push(m), p();
        },
        filter: function(m) {
          return l = l.filter(m), n;
        }
      };
    }
  };
  return o;
}
function W1(e) {
  e === void 0 && (e = {});
  var t = wL(null);
  return t.options = Ae({ async: !0, ssr: !1 }, e), t;
}
var Uv = function(e) {
  var t = e.sideCar, n = Hn(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return d.createElement(r, Ae({}, n));
};
Uv.isSideCarExport = !0;
function H1(e, t) {
  return e.useMedium(t), Uv;
}
var Gv = W1(), Ed = function() {
}, Yl = d.forwardRef(function(e, t) {
  var n = d.useRef(null), r = d.useState({
    onScrollCapture: Ed,
    onWheelCapture: Ed,
    onTouchMoveCapture: Ed
  }), o = r[0], i = r[1], l = e.forwardProps, c = e.children, f = e.className, p = e.removeScrollBar, m = e.enabled, v = e.shards, C = e.sideCar, x = e.noIsolation, y = e.inert, h = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, N = Hn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), _ = C, P = V1([n, t]), A = Ae(Ae({}, N), o);
  return d.createElement(
    d.Fragment,
    null,
    m && d.createElement(_, { sideCar: Gv, removeScrollBar: p, shards: v, noIsolation: x, inert: y, setCallbacks: i, allowPinchZoom: !!h, lockRef: n }),
    l ? d.cloneElement(d.Children.only(c), Ae(Ae({}, A), { ref: P })) : d.createElement(w, Ae({}, A, { className: f, ref: P }), c)
  );
});
Yl.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Yl.classNames = {
  fullWidth: li,
  zeroRight: si
};
function SL() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Gl();
  return t && e.setAttribute("nonce", t), e;
}
function NL(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function _L(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var RL = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = SL()) && (NL(t, n), _L(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, EL = function() {
  var e = RL();
  return function(t, n) {
    d.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Zl = function() {
  var e = EL(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, PL = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Pd = function(e) {
  return parseInt(e || "", 10) || 0;
}, AL = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Pd(n), Pd(r), Pd(o)];
}, TL = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return PL;
  var t = AL(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, $L = Zl(), ci = "data-scroll-locked", LL = function(e, t, n, r) {
  var o = e.left, i = e.top, l = e.right, c = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(vL, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(c, "px ").concat(r, `;
  }
  body[`).concat(ci, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(l, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(c, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(si, ` {
    right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(li, ` {
    margin-right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(si, " .").concat(si, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(li, " .").concat(li, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(ci, `] {
    `).concat(CL, ": ").concat(c, `px;
  }
`);
}, g0 = function() {
  var e = parseInt(document.body.getAttribute(ci) || "0", 10);
  return isFinite(e) ? e : 0;
}, ML = function() {
  d.useEffect(function() {
    return document.body.setAttribute(ci, (g0() + 1).toString()), function() {
      var e = g0() - 1;
      e <= 0 ? document.body.removeAttribute(ci) : document.body.setAttribute(ci, e.toString());
    };
  }, []);
}, U1 = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  ML();
  var i = d.useMemo(function() {
    return TL(o);
  }, [o]);
  return d.createElement($L, { styles: LL(i, !t, o, n ? "" : "!important") });
}, yf = !1;
if (typeof window < "u")
  try {
    var $s = Object.defineProperty({}, "passive", {
      get: function() {
        return yf = !0, !0;
      }
    });
    window.addEventListener("test", $s, $s), window.removeEventListener("test", $s, $s);
  } catch {
    yf = !1;
  }
var Ko = yf ? { passive: !1 } : !1, IL = function(e) {
  return e.tagName === "TEXTAREA";
}, zv = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !IL(e) && n[t] === "visible")
  );
}, OL = function(e) {
  return zv(e, "overflowY");
}, kL = function(e) {
  return zv(e, "overflowX");
}, v0 = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = qv(e, n);
    if (r) {
      var o = Kv(e, n), i = o[1], l = o[2];
      if (i > l)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, DL = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, FL = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, qv = function(e, t) {
  return e === "v" ? OL(t) : kL(t);
}, Kv = function(e, t) {
  return e === "v" ? DL(t) : FL(t);
}, BL = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, VL = function(e, t, n, r, o) {
  var i = BL(e, window.getComputedStyle(t).direction), l = i * r, c = n.target, f = t.contains(c), p = !1, m = l > 0, v = 0, C = 0;
  do {
    var x = Kv(e, c), y = x[0], h = x[1], b = x[2], w = h - b - i * y;
    (y || w) && qv(e, c) && (v += w, C += y), c = c.parentNode;
  } while (
    // portaled content
    !f && c !== document.body || // self content
    f && (t.contains(c) || t === c)
  );
  return (m && (v === 0 || !o) || !m && (C === 0 || !o)) && (p = !0), p;
}, Ls = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, C0 = function(e) {
  return [e.deltaX, e.deltaY];
}, x0 = function(e) {
  return e && "current" in e ? e.current : e;
}, WL = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, HL = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, UL = 0, Yo = [];
function GL(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), o = d.useState(UL++)[0], i = d.useState(function() {
    return Zl();
  })[0], l = d.useRef(e);
  d.useEffect(function() {
    l.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = wi([e.lockRef.current], (e.shards || []).map(x0), !0).filter(Boolean);
      return h.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = d.useCallback(function(h, b) {
    if ("touches" in h && h.touches.length === 2)
      return !l.current.allowPinchZoom;
    var w = Ls(h), N = n.current, _ = "deltaX" in h ? h.deltaX : N[0] - w[0], P = "deltaY" in h ? h.deltaY : N[1] - w[1], A, I = h.target, T = Math.abs(_) > Math.abs(P) ? "h" : "v";
    if ("touches" in h && T === "h" && I.type === "range")
      return !1;
    var M = v0(T, I);
    if (!M)
      return !0;
    if (M ? A = T : (A = T === "v" ? "h" : "v", M = v0(T, I)), !M)
      return !1;
    if (!r.current && "changedTouches" in h && (_ || P) && (r.current = A), !A)
      return !0;
    var D = r.current || A;
    return VL(D, b, h, D === "h" ? _ : P, !0);
  }, []), f = d.useCallback(function(h) {
    var b = h;
    if (!(!Yo.length || Yo[Yo.length - 1] !== i)) {
      var w = "deltaY" in b ? C0(b) : Ls(b), N = t.current.filter(function(A) {
        return A.name === b.type && A.target === b.target && WL(A.delta, w);
      })[0];
      if (N && N.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!N) {
        var _ = (l.current.shards || []).map(x0).filter(Boolean).filter(function(A) {
          return A.contains(b.target);
        }), P = _.length > 0 ? c(b, _[0]) : !l.current.noIsolation;
        P && b.cancelable && b.preventDefault();
      }
    }
  }, []), p = d.useCallback(function(h, b, w, N) {
    var _ = { name: h, delta: b, target: w, should: N };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(P) {
        return P !== _;
      });
    }, 1);
  }, []), m = d.useCallback(function(h) {
    n.current = Ls(h), r.current = void 0;
  }, []), v = d.useCallback(function(h) {
    p(h.type, C0(h), h.target, c(h, e.lockRef.current));
  }, []), C = d.useCallback(function(h) {
    p(h.type, Ls(h), h.target, c(h, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return Yo.push(i), e.setCallbacks({
      onScrollCapture: v,
      onWheelCapture: v,
      onTouchMoveCapture: C
    }), document.addEventListener("wheel", f, Ko), document.addEventListener("touchmove", f, Ko), document.addEventListener("touchstart", m, Ko), function() {
      Yo = Yo.filter(function(h) {
        return h !== i;
      }), document.removeEventListener("wheel", f, Ko), document.removeEventListener("touchmove", f, Ko), document.removeEventListener("touchstart", m, Ko);
    };
  }, []);
  var x = e.removeScrollBar, y = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    y ? d.createElement(i, { styles: HL(o) }) : null,
    x ? d.createElement(U1, { gapMode: "margin" }) : null
  );
}
const zL = H1(Gv, GL);
var Yv = d.forwardRef(function(e, t) {
  return d.createElement(Yl, Ae({}, e, { ref: t, sideCar: zL }));
});
Yv.classNames = Yl.classNames;
const Zv = "Dialog", [Xv, HY] = H$(Zv), [qL, No] = Xv(Zv), KL = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: o, onOpenChange: i, modal: l = !0 } = e, c = Je(null), f = Je(null), [p = !1, m] = q$({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ Ge(qL, {
    scope: t,
    triggerRef: c,
    contentRef: f,
    contentId: wd(),
    titleId: wd(),
    descriptionId: wd(),
    open: p,
    onOpenChange: m,
    onOpenToggle: hn(
      () => m(
        (v) => !v
      ),
      [
        m
      ]
    ),
    modal: l
  }, n);
}, jv = "DialogPortal", [YL, Qv] = Xv(jv, {
  forceMount: void 0
}), ZL = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = No(jv, t);
  return /* @__PURE__ */ Ge(YL, {
    scope: t,
    forceMount: n
  }, ao.map(
    r,
    (l) => /* @__PURE__ */ Ge(Kl, {
      present: n || i.open
    }, /* @__PURE__ */ Ge(pL, {
      asChild: !0,
      container: o
    }, l))
  ));
}, wf = "DialogOverlay", XL = /* @__PURE__ */ q((e, t) => {
  const n = Qv(wf, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = No(wf, e.__scopeDialog);
  return i.modal ? /* @__PURE__ */ Ge(Kl, {
    present: r || i.open
  }, /* @__PURE__ */ Ge(jL, Bt({}, o, {
    ref: t
  }))) : null;
}), jL = /* @__PURE__ */ q((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = No(wf, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ Ge(Yv, {
      as: B1,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ Ge(Cn.div, Bt({
      "data-state": e4(o.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), sa = "DialogContent", QL = /* @__PURE__ */ q((e, t) => {
  const n = Qv(sa, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = No(sa, e.__scopeDialog);
  return /* @__PURE__ */ Ge(Kl, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ Ge(JL, Bt({}, o, {
    ref: t
  })) : /* @__PURE__ */ Ge(eM, Bt({}, o, {
    ref: t
  })));
}), JL = /* @__PURE__ */ q((e, t) => {
  const n = No(sa, e.__scopeDialog), r = Je(null), o = xa(t, n.contentRef, r);
  return Oe(() => {
    const i = r.current;
    if (i) return Si(i);
  }, []), /* @__PURE__ */ Ge(Jv, Bt({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: ai(e.onCloseAutoFocus, (i) => {
      var l;
      i.preventDefault(), (l = n.triggerRef.current) === null || l === void 0 || l.focus();
    }),
    onPointerDownOutside: ai(e.onPointerDownOutside, (i) => {
      const l = i.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0;
      (l.button === 2 || c) && i.preventDefault();
    }),
    onFocusOutside: ai(
      e.onFocusOutside,
      (i) => i.preventDefault()
    )
  }));
}), eM = /* @__PURE__ */ q((e, t) => {
  const n = No(sa, e.__scopeDialog), r = Je(!1), o = Je(!1);
  return /* @__PURE__ */ Ge(Jv, Bt({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var l;
      if ((l = e.onCloseAutoFocus) === null || l === void 0 || l.call(e, i), !i.defaultPrevented) {
        var c;
        r.current || (c = n.triggerRef.current) === null || c === void 0 || c.focus(), i.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (i) => {
      var l, c;
      (l = e.onInteractOutside) === null || l === void 0 || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const f = i.target;
      ((c = n.triggerRef.current) === null || c === void 0 ? void 0 : c.contains(f)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
    }
  }));
}), Jv = /* @__PURE__ */ q((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...l } = e, c = No(sa, n), f = Je(null), p = xa(t, f);
  return gL(), /* @__PURE__ */ Ge(ia, null, /* @__PURE__ */ Ge(aL, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ Ge(rL, Bt({
    role: "dialog",
    id: c.contentId,
    "aria-describedby": c.descriptionId,
    "aria-labelledby": c.titleId,
    "data-state": e4(c.open)
  }, l, {
    ref: p,
    onDismiss: () => c.onOpenChange(!1)
  }))), !1);
});
function e4(e) {
  return e ? "open" : "closed";
}
const tM = KL, nM = ZL, rM = XL, oM = QL;
var ji = '[cmdk-group=""]', Ad = '[cmdk-group-items=""]', iM = '[cmdk-group-heading=""]', G1 = '[cmdk-item=""]', b0 = `${G1}:not([aria-disabled="true"])`, Sf = "cmdk-item-select", no = "data-value", aM = (e, t, n) => V$(e, t, n), t4 = d.createContext(void 0), ba = () => d.useContext(t4), n4 = d.createContext(void 0), z1 = () => d.useContext(n4), r4 = d.createContext(void 0), o4 = d.forwardRef((e, t) => {
  let n = ri(() => {
    var K, pe;
    return { search: "", value: (pe = (K = e.value) != null ? K : e.defaultValue) != null ? pe : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = ri(() => /* @__PURE__ */ new Set()), o = ri(() => /* @__PURE__ */ new Map()), i = ri(() => /* @__PURE__ */ new Map()), l = ri(() => /* @__PURE__ */ new Set()), c = i4(e), { label: f, children: p, value: m, onValueChange: v, filter: C, shouldFilter: x, loop: y, disablePointerSelection: h = !1, vimBindings: b = !0, ...w } = e, N = d.useId(), _ = d.useId(), P = d.useId(), A = d.useRef(null), I = vM();
  ho(() => {
    if (m !== void 0) {
      let K = m.trim();
      n.current.value = K, T.emit();
    }
  }, [m]), ho(() => {
    I(6, j);
  }, []);
  let T = d.useMemo(() => ({ subscribe: (K) => (l.current.add(K), () => l.current.delete(K)), snapshot: () => n.current, setState: (K, pe, ge) => {
    var ue, ye, ie;
    if (!Object.is(n.current[K], pe)) {
      if (n.current[K] = pe, K === "search") re(), W(), I(1, U);
      else if (K === "value" && (ge || I(5, j), ((ue = c.current) == null ? void 0 : ue.value) !== void 0)) {
        let Ce = pe ?? "";
        (ie = (ye = c.current).onValueChange) == null || ie.call(ye, Ce);
        return;
      }
      T.emit();
    }
  }, emit: () => {
    l.current.forEach((K) => K());
  } }), []), M = d.useMemo(() => ({ value: (K, pe, ge) => {
    var ue;
    pe !== ((ue = i.current.get(K)) == null ? void 0 : ue.value) && (i.current.set(K, { value: pe, keywords: ge }), n.current.filtered.items.set(K, D(pe, ge)), I(2, () => {
      W(), T.emit();
    }));
  }, item: (K, pe) => (r.current.add(K), pe && (o.current.has(pe) ? o.current.get(pe).add(K) : o.current.set(pe, /* @__PURE__ */ new Set([K]))), I(3, () => {
    re(), W(), n.current.value || U(), T.emit();
  }), () => {
    i.current.delete(K), r.current.delete(K), n.current.filtered.items.delete(K);
    let ge = X();
    I(4, () => {
      re(), (ge == null ? void 0 : ge.getAttribute("id")) === K && U(), T.emit();
    });
  }), group: (K) => (o.current.has(K) || o.current.set(K, /* @__PURE__ */ new Set()), () => {
    i.current.delete(K), o.current.delete(K);
  }), filter: () => c.current.shouldFilter, label: f || e["aria-label"], disablePointerSelection: h, listId: N, inputId: P, labelId: _, listInnerRef: A }), []);
  function D(K, pe) {
    var ge, ue;
    let ye = (ue = (ge = c.current) == null ? void 0 : ge.filter) != null ? ue : aM;
    return K ? ye(K, n.current.search, pe) : 0;
  }
  function W() {
    if (!n.current.search || c.current.shouldFilter === !1) return;
    let K = n.current.filtered.items, pe = [];
    n.current.filtered.groups.forEach((ue) => {
      let ye = o.current.get(ue), ie = 0;
      ye.forEach((Ce) => {
        let _e = K.get(Ce);
        ie = Math.max(_e, ie);
      }), pe.push([ue, ie]);
    });
    let ge = A.current;
    oe().sort((ue, ye) => {
      var ie, Ce;
      let _e = ue.getAttribute("id"), Te = ye.getAttribute("id");
      return ((ie = K.get(Te)) != null ? ie : 0) - ((Ce = K.get(_e)) != null ? Ce : 0);
    }).forEach((ue) => {
      let ye = ue.closest(Ad);
      ye ? ye.appendChild(ue.parentElement === ye ? ue : ue.closest(`${Ad} > *`)) : ge.appendChild(ue.parentElement === ge ? ue : ue.closest(`${Ad} > *`));
    }), pe.sort((ue, ye) => ye[1] - ue[1]).forEach((ue) => {
      let ye = A.current.querySelector(`${ji}[${no}="${encodeURIComponent(ue[0])}"]`);
      ye == null || ye.parentElement.appendChild(ye);
    });
  }
  function U() {
    let K = oe().find((ge) => ge.getAttribute("aria-disabled") !== "true"), pe = K == null ? void 0 : K.getAttribute(no);
    T.setState("value", pe || void 0);
  }
  function re() {
    var K, pe, ge, ue;
    if (!n.current.search || c.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let ye = 0;
    for (let ie of r.current) {
      let Ce = (pe = (K = i.current.get(ie)) == null ? void 0 : K.value) != null ? pe : "", _e = (ue = (ge = i.current.get(ie)) == null ? void 0 : ge.keywords) != null ? ue : [], Te = D(Ce, _e);
      n.current.filtered.items.set(ie, Te), Te > 0 && ye++;
    }
    for (let [ie, Ce] of o.current) for (let _e of Ce) if (n.current.filtered.items.get(_e) > 0) {
      n.current.filtered.groups.add(ie);
      break;
    }
    n.current.filtered.count = ye;
  }
  function j() {
    var K, pe, ge;
    let ue = X();
    ue && (((K = ue.parentElement) == null ? void 0 : K.firstChild) === ue && ((ge = (pe = ue.closest(ji)) == null ? void 0 : pe.querySelector(iM)) == null || ge.scrollIntoView({ block: "nearest" })), ue.scrollIntoView({ block: "nearest" }));
  }
  function X() {
    var K;
    return (K = A.current) == null ? void 0 : K.querySelector(`${G1}[aria-selected="true"]`);
  }
  function oe() {
    var K;
    return Array.from((K = A.current) == null ? void 0 : K.querySelectorAll(b0));
  }
  function G(K) {
    let pe = oe()[K];
    pe && T.setState("value", pe.getAttribute(no));
  }
  function Q(K) {
    var pe;
    let ge = X(), ue = oe(), ye = ue.findIndex((Ce) => Ce === ge), ie = ue[ye + K];
    (pe = c.current) != null && pe.loop && (ie = ye + K < 0 ? ue[ue.length - 1] : ye + K === ue.length ? ue[0] : ue[ye + K]), ie && T.setState("value", ie.getAttribute(no));
  }
  function te(K) {
    let pe = X(), ge = pe == null ? void 0 : pe.closest(ji), ue;
    for (; ge && !ue; ) ge = K > 0 ? hM(ge, ji) : gM(ge, ji), ue = ge == null ? void 0 : ge.querySelector(b0);
    ue ? T.setState("value", ue.getAttribute(no)) : Q(K);
  }
  let ee = () => G(oe().length - 1), Pe = (K) => {
    K.preventDefault(), K.metaKey ? ee() : K.altKey ? te(1) : Q(1);
  }, ce = (K) => {
    K.preventDefault(), K.metaKey ? G(0) : K.altKey ? te(-1) : Q(-1);
  };
  return d.createElement(Cn.div, { ref: t, tabIndex: -1, ...w, "cmdk-root": "", onKeyDown: (K) => {
    var pe;
    if ((pe = w.onKeyDown) == null || pe.call(w, K), !K.defaultPrevented) switch (K.key) {
      case "n":
      case "j": {
        b && K.ctrlKey && Pe(K);
        break;
      }
      case "ArrowDown": {
        Pe(K);
        break;
      }
      case "p":
      case "k": {
        b && K.ctrlKey && ce(K);
        break;
      }
      case "ArrowUp": {
        ce(K);
        break;
      }
      case "Home": {
        K.preventDefault(), G(0);
        break;
      }
      case "End": {
        K.preventDefault(), ee();
        break;
      }
      case "Enter":
        if (!K.nativeEvent.isComposing && K.keyCode !== 229) {
          K.preventDefault();
          let ge = X();
          if (ge) {
            let ue = new Event(Sf);
            ge.dispatchEvent(ue);
          }
        }
    }
  } }, d.createElement("label", { "cmdk-label": "", htmlFor: M.inputId, id: M.labelId, style: xM }, f), Xl(e, (K) => d.createElement(n4.Provider, { value: T }, d.createElement(t4.Provider, { value: M }, K))));
}), sM = d.forwardRef((e, t) => {
  var n, r;
  let o = d.useId(), i = d.useRef(null), l = d.useContext(r4), c = ba(), f = i4(e), p = (r = (n = f.current) == null ? void 0 : n.forceMount) != null ? r : l == null ? void 0 : l.forceMount;
  ho(() => {
    if (!p) return c.item(o, l == null ? void 0 : l.id);
  }, [p]);
  let m = a4(o, i, [e.value, e.children, i], e.keywords), v = z1(), C = go((I) => I.value && I.value === m.current), x = go((I) => p || c.filter() === !1 ? !0 : I.search ? I.filtered.items.get(o) > 0 : !0);
  d.useEffect(() => {
    let I = i.current;
    if (!(!I || e.disabled)) return I.addEventListener(Sf, y), () => I.removeEventListener(Sf, y);
  }, [x, e.onSelect, e.disabled]);
  function y() {
    var I, T;
    h(), (T = (I = f.current).onSelect) == null || T.call(I, m.current);
  }
  function h() {
    v.setState("value", m.current, !0);
  }
  if (!x) return null;
  let { disabled: b, value: w, onSelect: N, forceMount: _, keywords: P, ...A } = e;
  return d.createElement(Cn.div, { ref: la([i, t]), ...A, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!b, "aria-selected": !!C, "data-disabled": !!b, "data-selected": !!C, onPointerMove: b || c.disablePointerSelection ? void 0 : h, onClick: b ? void 0 : y }, e.children);
}), lM = d.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...i } = e, l = d.useId(), c = d.useRef(null), f = d.useRef(null), p = d.useId(), m = ba(), v = go((x) => o || m.filter() === !1 ? !0 : x.search ? x.filtered.groups.has(l) : !0);
  ho(() => m.group(l), []), a4(l, c, [e.value, e.heading, f]);
  let C = d.useMemo(() => ({ id: l, forceMount: o }), [o]);
  return d.createElement(Cn.div, { ref: la([c, t]), ...i, "cmdk-group": "", role: "presentation", hidden: v ? void 0 : !0 }, n && d.createElement("div", { ref: f, "cmdk-group-heading": "", "aria-hidden": !0, id: p }, n), Xl(e, (x) => d.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? p : void 0 }, d.createElement(r4.Provider, { value: C }, x))));
}), cM = d.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = d.useRef(null), i = go((l) => !l.search);
  return !n && !i ? null : d.createElement(Cn.div, { ref: la([o, t]), ...r, "cmdk-separator": "", role: "separator" });
}), uM = d.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, i = z1(), l = go((m) => m.search), c = go((m) => m.value), f = ba(), p = d.useMemo(() => {
    var m;
    let v = (m = f.listInnerRef.current) == null ? void 0 : m.querySelector(`${G1}[${no}="${encodeURIComponent(c)}"]`);
    return v == null ? void 0 : v.getAttribute("id");
  }, []);
  return d.useEffect(() => {
    e.value != null && i.setState("search", e.value);
  }, [e.value]), d.createElement(Cn.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": f.listId, "aria-labelledby": f.labelId, "aria-activedescendant": p, id: f.inputId, type: "text", value: o ? e.value : l, onChange: (m) => {
    o || i.setState("search", m.target.value), n == null || n(m.target.value);
  } });
}), dM = d.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, i = d.useRef(null), l = d.useRef(null), c = ba();
  return d.useEffect(() => {
    if (l.current && i.current) {
      let f = l.current, p = i.current, m, v = new ResizeObserver(() => {
        m = requestAnimationFrame(() => {
          let C = f.offsetHeight;
          p.style.setProperty("--cmdk-list-height", C.toFixed(1) + "px");
        });
      });
      return v.observe(f), () => {
        cancelAnimationFrame(m), v.unobserve(f);
      };
    }
  }, []), d.createElement(Cn.div, { ref: la([i, t]), ...o, "cmdk-list": "", role: "listbox", "aria-label": r, id: c.listId }, Xl(e, (f) => d.createElement("div", { ref: la([l, c.listInnerRef]), "cmdk-list-sizer": "" }, f)));
}), fM = d.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: i, container: l, ...c } = e;
  return d.createElement(tM, { open: n, onOpenChange: r }, d.createElement(nM, { container: l }, d.createElement(rM, { "cmdk-overlay": "", className: o }), d.createElement(oM, { "aria-label": e.label, "cmdk-dialog": "", className: i }, d.createElement(o4, { ref: t, ...c }))));
}), pM = d.forwardRef((e, t) => go((n) => n.filtered.count === 0) ? d.createElement(Cn.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), mM = d.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...i } = e;
  return d.createElement(Cn.div, { ref: t, ...i, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, Xl(e, (l) => d.createElement("div", { "aria-hidden": !0 }, l)));
}), Mt = Object.assign(o4, { List: dM, Item: sM, Input: uM, Group: lM, Separator: cM, Dialog: fM, Empty: pM, Loading: mM });
function hM(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function gM(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function i4(e) {
  let t = d.useRef(e);
  return ho(() => {
    t.current = e;
  }), t;
}
var ho = typeof window > "u" ? d.useEffect : d.useLayoutEffect;
function ri(e) {
  let t = d.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function la(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
function go(e) {
  let t = z1(), n = () => e(t.snapshot());
  return d.useSyncExternalStore(t.subscribe, n, n);
}
function a4(e, t, n, r = []) {
  let o = d.useRef(), i = ba();
  return ho(() => {
    var l;
    let c = (() => {
      var p;
      for (let m of n) {
        if (typeof m == "string") return m.trim();
        if (typeof m == "object" && "current" in m) return m.current ? (p = m.current.textContent) == null ? void 0 : p.trim() : o.current;
      }
    })(), f = r.map((p) => p.trim());
    i.value(e, c, f), (l = t.current) == null || l.setAttribute(no, c), o.current = c;
  }), o;
}
var vM = () => {
  let [e, t] = d.useState(), n = ri(() => /* @__PURE__ */ new Map());
  return ho(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function CM(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function Xl({ asChild: e, children: t }, n) {
  return e && d.isValidElement(t) ? d.cloneElement(CM(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var xM = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const ya = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Mt,
  {
    ref: n,
    className: F(
      "bg-popover text-popover-foreground flex h-full w-full flex-col overflow-hidden rounded-md",
      e
    ),
    ...t
  }
));
ya.displayName = Mt.displayName;
const UY = ({ children: e, ...t }) => /* @__PURE__ */ s(s5, { ...t, children: /* @__PURE__ */ s(ip, { className: "overflow-hidden p-0", children: /* @__PURE__ */ s(ya, { className: "[&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: e }) }) }), s4 = q(({ className: e, ...t }, n) => /* @__PURE__ */ R(
  "div",
  {
    className: "flex items-center border-b px-3",
    "cmdk-input-wrapper": "",
    children: [
      /* @__PURE__ */ s($$, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
      /* @__PURE__ */ s(
        Mt.Input,
        {
          ref: n,
          className: F(
            "placeholder:text-muted-foreground flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50",
            e
          ),
          ...t
        }
      )
    ]
  }
));
s4.displayName = Mt.Input.displayName;
const jl = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Mt.List,
  {
    ref: n,
    className: F(
      "max-h-[300px] overflow-y-auto overflow-x-hidden",
      e
    ),
    ...t
  }
));
jl.displayName = Mt.List.displayName;
const l4 = q((e, t) => /* @__PURE__ */ s(
  Mt.Empty,
  {
    ref: t,
    className: "py-6 text-center text-sm",
    ...e
  }
));
l4.displayName = Mt.Empty.displayName;
const Ql = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Mt.Group,
  {
    ref: n,
    className: F(
      "text-foreground [&_[cmdk-group-heading]]:text-muted-foreground overflow-hidden p-1 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium",
      e
    ),
    ...t
  }
));
Ql.displayName = Mt.Group.displayName;
const bM = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Mt.Separator,
  {
    ref: n,
    className: F("bg-border -mx-1 h-px", e),
    ...t
  }
));
bM.displayName = Mt.Separator.displayName;
const Jl = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Mt.Item,
  {
    ref: n,
    className: F(
      "data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground relative flex cursor-default select-none items-center rounded-xs px-2 py-1.5 text-sm outline-hidden data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50",
      e
    ),
    ...t
  }
));
Jl.displayName = Mt.Item.displayName;
const yM = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  "span",
  {
    className: F(
      "text-muted-foreground ml-auto text-xs tracking-widest",
      e
    ),
    ...t
  }
);
yM.displayName = "CommandShortcut";
function ec(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    const p = (v) => {
      var w;
      const { scope: C, children: x, ...y } = v, h = ((w = C == null ? void 0 : C[e]) == null ? void 0 : w[f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    };
    p.displayName = i + "Provider";
    function m(v, C) {
      var h;
      const x = ((h = C == null ? void 0 : C[e]) == null ? void 0 : h[f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, wM(o, ...t)];
}
function wM(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function SM(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var c4 = (e) => {
  const { present: t, children: n } = e, r = NM(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), i = ke(r.ref, _M(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: i }) : null;
};
c4.displayName = "Presence";
function NM(e) {
  const [t, n] = d.useState(), r = d.useRef({}), o = d.useRef(e), i = d.useRef("none"), l = e ? "mounted" : "unmounted", [c, f] = SM(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const p = Ms(r.current);
    i.current = c === "mounted" ? p : "none";
  }, [c]), be(() => {
    const p = r.current, m = o.current;
    if (m !== e) {
      const C = i.current, x = Ms(p);
      e ? f("MOUNT") : x === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && C !== x ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), be(() => {
    if (t) {
      let p;
      const m = t.ownerDocument.defaultView ?? window, v = (x) => {
        const h = Ms(r.current).includes(x.animationName);
        if (x.target === t && h && (f("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, C = (x) => {
        x.target === t && (i.current = Ms(r.current));
      };
      return t.addEventListener("animationstart", C), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        m.clearTimeout(p), t.removeEventListener("animationstart", C), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: d.useCallback((p) => {
      p && (r.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function Ms(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function _M(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var q1 = "Collapsible", [RM, GY] = ec(q1), [EM, K1] = RM(q1), u4 = d.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: i,
      onOpenChange: l,
      ...c
    } = e, [f = !1, p] = et({
      prop: r,
      defaultProp: o,
      onChange: l
    });
    return /* @__PURE__ */ s(
      EM,
      {
        scope: n,
        disabled: i,
        contentId: it(),
        open: f,
        onOpenToggle: d.useCallback(() => p((m) => !m), [p]),
        children: /* @__PURE__ */ s(
          ve.div,
          {
            "data-state": Z1(f),
            "data-disabled": i ? "" : void 0,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
u4.displayName = q1;
var d4 = "CollapsibleTrigger", f4 = d.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, o = K1(d4, n);
    return /* @__PURE__ */ s(
      ve.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": Z1(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: t,
        onClick: he(e.onClick, o.onOpenToggle)
      }
    );
  }
);
f4.displayName = d4;
var Y1 = "CollapsibleContent", p4 = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = K1(Y1, e.__scopeCollapsible);
    return /* @__PURE__ */ s(c4, { present: n || o.open, children: ({ present: i }) => /* @__PURE__ */ s(PM, { ...r, ref: t, present: i }) });
  }
);
p4.displayName = Y1;
var PM = d.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...i } = e, l = K1(Y1, n), [c, f] = d.useState(r), p = d.useRef(null), m = ke(t, p), v = d.useRef(0), C = v.current, x = d.useRef(0), y = x.current, h = l.open || c, b = d.useRef(h), w = d.useRef();
  return d.useEffect(() => {
    const N = requestAnimationFrame(() => b.current = !1);
    return () => cancelAnimationFrame(N);
  }, []), be(() => {
    const N = p.current;
    if (N) {
      w.current = w.current || {
        transitionDuration: N.style.transitionDuration,
        animationName: N.style.animationName
      }, N.style.transitionDuration = "0s", N.style.animationName = "none";
      const _ = N.getBoundingClientRect();
      v.current = _.height, x.current = _.width, b.current || (N.style.transitionDuration = w.current.transitionDuration, N.style.animationName = w.current.animationName), f(r);
    }
  }, [l.open, r]), /* @__PURE__ */ s(
    ve.div,
    {
      "data-state": Z1(l.open),
      "data-disabled": l.disabled ? "" : void 0,
      id: l.contentId,
      hidden: !h,
      ...i,
      ref: m,
      style: {
        "--radix-collapsible-content-height": C ? `${C}px` : void 0,
        "--radix-collapsible-content-width": y ? `${y}px` : void 0,
        ...e.style
      },
      children: h && o
    }
  );
});
function Z1(e) {
  return e ? "open" : "closed";
}
var AM = u4;
const zY = AM, qY = f4, KY = p4;
function YY({
  table: e
}) {
  const t = e == null ? void 0 : e.getAllLeafColumns().reduce((r, o) => o.getIsVisible() ? r : r + 1, 0), n = () => {
    const o = ((e == null ? void 0 : e.getAllLeafColumns()) || []).filter((i) => i.getCanHide());
    return /* @__PURE__ */ s("ul", { className: "flex flex-col gap-2", children: o.map((i) => /* @__PURE__ */ s("li", { children: /* @__PURE__ */ R(nt, { className: "text-bodymd flex items-center gap-1", children: [
      /* @__PURE__ */ s(
        KC,
        {
          checked: i.getIsVisible(),
          className: "!h-3 !w-6",
          onCheckedChange: (l) => i.toggleVisibility(l),
          thumbClassName: "!h-2 !w-2 data-[state=checked]:!translate-x-3"
        }
      ),
      " ",
      /* @__PURE__ */ s(le, { children: i.columnDef.header })
    ] }) }, i.id)) });
  };
  return /* @__PURE__ */ R(B7, { children: [
    /* @__PURE__ */ s(V7, { asChild: !0, children: /* @__PURE__ */ R(
      ct,
      {
        className: F(
          "text-textPrimary !rounded",
          t === 0 ? "!border-interactiveBorder" : "!border-blueBorder bg-blueBgDefault"
        ),
        variant: "outline",
        children: [
          /* @__PURE__ */ s(CP, {}),
          t === 0 ? "Hide fields" : `${t} hidden fields`
        ]
      }
    ) }),
    /* @__PURE__ */ R(
      Vp,
      {
        align: "start",
        className: "flex flex-col gap-3",
        side: "bottom",
        children: [
          n(),
          /* @__PURE__ */ s(
            ct,
            {
              className: "!border-interactiveBorder text-textPrimary !text-bodysm h-min w-full py-1.5",
              onClick: () => e == null ? void 0 : e.toggleAllColumnsVisible(!0),
              variant: "outline",
              children: "Show all"
            }
          )
        ]
      }
    )
  ] });
}
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function ZY() {
  return {
    accessor: (e, t) => typeof e == "function" ? {
      ...t,
      accessorFn: e
    } : {
      ...t,
      accessorKey: e
    },
    display: (e) => e,
    group: (e) => e
  };
}
function Ar(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function on(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: Ar(n, r[e])
    }));
  };
}
function tc(e) {
  return e instanceof Function;
}
function TM(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function $M(e, t) {
  const n = [], r = (o) => {
    o.forEach((i) => {
      n.push(i);
      const l = t(i);
      l != null && l.length && r(l);
    });
  };
  return r(e), n;
}
function Re(e, t, n) {
  let r = [], o;
  return (i) => {
    let l;
    n.key && n.debug && (l = Date.now());
    const c = e(i);
    if (!(c.length !== r.length || c.some((m, v) => r[v] !== m)))
      return o;
    r = c;
    let p;
    if (n.key && n.debug && (p = Date.now()), o = t(...c), n == null || n.onChange == null || n.onChange(o), n.key && n.debug && n != null && n.debug()) {
      const m = Math.round((Date.now() - l) * 100) / 100, v = Math.round((Date.now() - p) * 100) / 100, C = v / 16, x = (y, h) => {
        for (y = String(y); y.length < h; )
          y = " " + y;
        return y;
      };
      console.info(`%c⏱ ${x(v, 5)} /${x(m, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * C, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return o;
  };
}
function Ee(e, t, n, r) {
  return {
    debug: () => {
      var o;
      return (o = e == null ? void 0 : e.debugAll) != null ? o : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function LM(e, t, n, r) {
  const o = () => {
    var l;
    return (l = i.getValue()) != null ? l : e.options.renderFallbackValue;
  }, i = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: o,
    getContext: Re(() => [e, n, t, i], (l, c, f, p) => ({
      table: l,
      column: c,
      row: f,
      cell: p,
      getValue: p.getValue,
      renderValue: p.renderValue
    }), Ee(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((l) => {
    l.createCell == null || l.createCell(i, n, t, e);
  }, {}), i;
}
function MM(e, t, n, r) {
  var o, i;
  const c = {
    ...e._getDefaultColumnDef(),
    ...t
  }, f = c.accessorKey;
  let p = (o = (i = c.id) != null ? i : f ? typeof String.prototype.replaceAll == "function" ? f.replaceAll(".", "_") : f.replace(/\./g, "_") : void 0) != null ? o : typeof c.header == "string" ? c.header : void 0, m;
  if (c.accessorFn ? m = c.accessorFn : f && (f.includes(".") ? m = (C) => {
    let x = C;
    for (const h of f.split(".")) {
      var y;
      x = (y = x) == null ? void 0 : y[h], process.env.NODE_ENV !== "production" && x === void 0 && console.warn(`"${h}" in deeply nested key "${f}" returned undefined.`);
    }
    return x;
  } : m = (C) => C[c.accessorKey]), !p)
    throw process.env.NODE_ENV !== "production" ? new Error(c.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let v = {
    id: `${String(p)}`,
    accessorFn: m,
    parent: r,
    depth: n,
    columnDef: c,
    columns: [],
    getFlatColumns: Re(() => [!0], () => {
      var C;
      return [v, ...(C = v.columns) == null ? void 0 : C.flatMap((x) => x.getFlatColumns())];
    }, Ee(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: Re(() => [e._getOrderColumnsFn()], (C) => {
      var x;
      if ((x = v.columns) != null && x.length) {
        let y = v.columns.flatMap((h) => h.getLeafColumns());
        return C(y);
      }
      return [v];
    }, Ee(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const C of e._features)
    C.createColumn == null || C.createColumn(v, e);
  return v;
}
const At = "debugHeaders";
function y0(e, t, n) {
  var r;
  let i = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const l = [], c = (f) => {
        f.subHeaders && f.subHeaders.length && f.subHeaders.map(c), l.push(f);
      };
      return c(i), l;
    },
    getContext: () => ({
      table: e,
      header: i,
      column: t
    })
  };
  return e._features.forEach((l) => {
    l.createHeader == null || l.createHeader(i, e);
  }), i;
}
const IM = {
  createTable: (e) => {
    e.getHeaderGroups = Re(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => {
      var i, l;
      const c = (i = r == null ? void 0 : r.map((v) => n.find((C) => C.id === v)).filter(Boolean)) != null ? i : [], f = (l = o == null ? void 0 : o.map((v) => n.find((C) => C.id === v)).filter(Boolean)) != null ? l : [], p = n.filter((v) => !(r != null && r.includes(v.id)) && !(o != null && o.includes(v.id)));
      return Is(t, [...c, ...p, ...f], e);
    }, Ee(e.options, At, "getHeaderGroups")), e.getCenterHeaderGroups = Re(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => (n = n.filter((i) => !(r != null && r.includes(i.id)) && !(o != null && o.includes(i.id))), Is(t, n, e, "center")), Ee(e.options, At, "getCenterHeaderGroups")), e.getLeftHeaderGroups = Re(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var o;
      const i = (o = r == null ? void 0 : r.map((l) => n.find((c) => c.id === l)).filter(Boolean)) != null ? o : [];
      return Is(t, i, e, "left");
    }, Ee(e.options, At, "getLeftHeaderGroups")), e.getRightHeaderGroups = Re(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var o;
      const i = (o = r == null ? void 0 : r.map((l) => n.find((c) => c.id === l)).filter(Boolean)) != null ? o : [];
      return Is(t, i, e, "right");
    }, Ee(e.options, At, "getRightHeaderGroups")), e.getFooterGroups = Re(() => [e.getHeaderGroups()], (t) => [...t].reverse(), Ee(e.options, At, "getFooterGroups")), e.getLeftFooterGroups = Re(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), Ee(e.options, At, "getLeftFooterGroups")), e.getCenterFooterGroups = Re(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), Ee(e.options, At, "getCenterFooterGroups")), e.getRightFooterGroups = Re(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), Ee(e.options, At, "getRightFooterGroups")), e.getFlatHeaders = Re(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Ee(e.options, At, "getFlatHeaders")), e.getLeftFlatHeaders = Re(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Ee(e.options, At, "getLeftFlatHeaders")), e.getCenterFlatHeaders = Re(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Ee(e.options, At, "getCenterFlatHeaders")), e.getRightFlatHeaders = Re(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Ee(e.options, At, "getRightFlatHeaders")), e.getCenterLeafHeaders = Re(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Ee(e.options, At, "getCenterLeafHeaders")), e.getLeftLeafHeaders = Re(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Ee(e.options, At, "getLeftLeafHeaders")), e.getRightLeafHeaders = Re(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Ee(e.options, At, "getRightLeafHeaders")), e.getLeafHeaders = Re(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var o, i, l, c, f, p;
      return [...(o = (i = t[0]) == null ? void 0 : i.headers) != null ? o : [], ...(l = (c = n[0]) == null ? void 0 : c.headers) != null ? l : [], ...(f = (p = r[0]) == null ? void 0 : p.headers) != null ? f : []].map((m) => m.getLeafHeaders()).flat();
    }, Ee(e.options, At, "getLeafHeaders"));
  }
};
function Is(e, t, n, r) {
  var o, i;
  let l = 0;
  const c = function(C, x) {
    x === void 0 && (x = 1), l = Math.max(l, x), C.filter((y) => y.getIsVisible()).forEach((y) => {
      var h;
      (h = y.columns) != null && h.length && c(y.columns, x + 1);
    }, 0);
  };
  c(e);
  let f = [];
  const p = (C, x) => {
    const y = {
      depth: x,
      id: [r, `${x}`].filter(Boolean).join("_"),
      headers: []
    }, h = [];
    C.forEach((b) => {
      const w = [...h].reverse()[0], N = b.column.depth === y.depth;
      let _, P = !1;
      if (N && b.column.parent ? _ = b.column.parent : (_ = b.column, P = !0), w && (w == null ? void 0 : w.column) === _)
        w.subHeaders.push(b);
      else {
        const A = y0(n, _, {
          id: [r, x, _.id, b == null ? void 0 : b.id].filter(Boolean).join("_"),
          isPlaceholder: P,
          placeholderId: P ? `${h.filter((I) => I.column === _).length}` : void 0,
          depth: x,
          index: h.length
        });
        A.subHeaders.push(b), h.push(A);
      }
      y.headers.push(b), b.headerGroup = y;
    }), f.push(y), x > 0 && p(h, x - 1);
  }, m = t.map((C, x) => y0(n, C, {
    depth: l,
    index: x
  }));
  p(m, l - 1), f.reverse();
  const v = (C) => C.filter((y) => y.column.getIsVisible()).map((y) => {
    let h = 0, b = 0, w = [0];
    y.subHeaders && y.subHeaders.length ? (w = [], v(y.subHeaders).forEach((_) => {
      let {
        colSpan: P,
        rowSpan: A
      } = _;
      h += P, w.push(A);
    })) : h = 1;
    const N = Math.min(...w);
    return b = b + N, y.colSpan = h, y.rowSpan = b, {
      colSpan: h,
      rowSpan: b
    };
  });
  return v((o = (i = f[0]) == null ? void 0 : i.headers) != null ? o : []), f;
}
const X1 = (e, t, n, r, o, i, l) => {
  let c = {
    id: t,
    index: r,
    original: n,
    depth: o,
    parentId: l,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (f) => {
      if (c._valuesCache.hasOwnProperty(f))
        return c._valuesCache[f];
      const p = e.getColumn(f);
      if (p != null && p.accessorFn)
        return c._valuesCache[f] = p.accessorFn(c.original, r), c._valuesCache[f];
    },
    getUniqueValues: (f) => {
      if (c._uniqueValuesCache.hasOwnProperty(f))
        return c._uniqueValuesCache[f];
      const p = e.getColumn(f);
      if (p != null && p.accessorFn)
        return p.columnDef.getUniqueValues ? (c._uniqueValuesCache[f] = p.columnDef.getUniqueValues(c.original, r), c._uniqueValuesCache[f]) : (c._uniqueValuesCache[f] = [c.getValue(f)], c._uniqueValuesCache[f]);
    },
    renderValue: (f) => {
      var p;
      return (p = c.getValue(f)) != null ? p : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => $M(c.subRows, (f) => f.subRows),
    getParentRow: () => c.parentId ? e.getRow(c.parentId, !0) : void 0,
    getParentRows: () => {
      let f = [], p = c;
      for (; ; ) {
        const m = p.getParentRow();
        if (!m) break;
        f.push(m), p = m;
      }
      return f.reverse();
    },
    getAllCells: Re(() => [e.getAllLeafColumns()], (f) => f.map((p) => LM(e, c, p, p.id)), Ee(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: Re(() => [c.getAllCells()], (f) => f.reduce((p, m) => (p[m.column.id] = m, p), {}), Ee(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let f = 0; f < e._features.length; f++) {
    const p = e._features[f];
    p == null || p.createRow == null || p.createRow(c, e);
  }
  return c;
}, OM = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, m4 = (e, t, n) => {
  var r, o;
  const i = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
  return !!(!((o = e.getValue(t)) == null || (o = o.toString()) == null || (o = o.toLowerCase()) == null) && o.includes(i));
};
m4.autoRemove = (e) => En(e);
const h4 = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
h4.autoRemove = (e) => En(e);
const g4 = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
g4.autoRemove = (e) => En(e);
const v4 = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
v4.autoRemove = (e) => En(e) || !(e != null && e.length);
const C4 = (e, t, n) => !n.some((r) => {
  var o;
  return !((o = e.getValue(t)) != null && o.includes(r));
});
C4.autoRemove = (e) => En(e) || !(e != null && e.length);
const x4 = (e, t, n) => n.some((r) => {
  var o;
  return (o = e.getValue(t)) == null ? void 0 : o.includes(r);
});
x4.autoRemove = (e) => En(e) || !(e != null && e.length);
const b4 = (e, t, n) => e.getValue(t) === n;
b4.autoRemove = (e) => En(e);
const y4 = (e, t, n) => e.getValue(t) == n;
y4.autoRemove = (e) => En(e);
const j1 = (e, t, n) => {
  let [r, o] = n;
  const i = e.getValue(t);
  return i >= r && i <= o;
};
j1.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, o = typeof n != "number" ? parseFloat(n) : n, i = t === null || Number.isNaN(r) ? -1 / 0 : r, l = n === null || Number.isNaN(o) ? 1 / 0 : o;
  if (i > l) {
    const c = i;
    i = l, l = c;
  }
  return [i, l];
};
j1.autoRemove = (e) => En(e) || En(e[0]) && En(e[1]);
const Jn = {
  includesString: m4,
  includesStringSensitive: h4,
  equalsString: g4,
  arrIncludes: v4,
  arrIncludesAll: C4,
  arrIncludesSome: x4,
  equals: b4,
  weakEquals: y4,
  inNumberRange: j1
};
function En(e) {
  return e == null || e === "";
}
const kM = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: on("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      return typeof r == "string" ? Jn.includesString : typeof r == "number" ? Jn.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? Jn.equals : Array.isArray(r) ? Jn.arrIncludes : Jn.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return tc(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : Jn[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, o;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const o = e.getFilterFn(), i = r == null ? void 0 : r.find((m) => m.id === e.id), l = Ar(n, i ? i.value : void 0);
        if (w0(o, l, e)) {
          var c;
          return (c = r == null ? void 0 : r.filter((m) => m.id !== e.id)) != null ? c : [];
        }
        const f = {
          id: e.id,
          value: l
        };
        if (i) {
          var p;
          return (p = r == null ? void 0 : r.map((m) => m.id === e.id ? f : m)) != null ? p : [];
        }
        return r != null && r.length ? [...r, f] : [f];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (o) => {
        var i;
        return (i = Ar(t, o)) == null ? void 0 : i.filter((l) => {
          const c = n.find((f) => f.id === l.id);
          if (c) {
            const f = c.getFilterFn();
            if (w0(f, l.value, c))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function w0(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const DM = (e, t, n) => n.reduce((r, o) => {
  const i = o.getValue(e);
  return r + (typeof i == "number" ? i : 0);
}, 0), FM = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const i = o.getValue(e);
    i != null && (r > i || r === void 0 && i >= i) && (r = i);
  }), r;
}, BM = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const i = o.getValue(e);
    i != null && (r < i || r === void 0 && i >= i) && (r = i);
  }), r;
}, VM = (e, t, n) => {
  let r, o;
  return n.forEach((i) => {
    const l = i.getValue(e);
    l != null && (r === void 0 ? l >= l && (r = o = l) : (r > l && (r = l), o < l && (o = l)));
  }), [r, o];
}, WM = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((o) => {
    let i = o.getValue(e);
    i != null && (i = +i) >= i && (++n, r += i);
  }), n) return r / n;
}, HM = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((i) => i.getValue(e));
  if (!TM(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), o = n.sort((i, l) => i - l);
  return n.length % 2 !== 0 ? o[r] : (o[r - 1] + o[r]) / 2;
}, UM = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), GM = (e, t) => new Set(t.map((n) => n.getValue(e))).size, zM = (e, t) => t.length, Td = {
  sum: DM,
  min: FM,
  max: BM,
  extent: VM,
  mean: WM,
  median: HM,
  unique: UM,
  uniqueCount: GM,
  count: zM
}, qM = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: on("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      if (typeof r == "number")
        return Td.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return Td.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return tc(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : Td[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var o;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((o = n.subRows) != null && o.length);
    };
  }
};
function KM(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((i) => !t.includes(i.id));
  return n === "remove" ? r : [...t.map((i) => e.find((l) => l.id === i)).filter(Boolean), ...r];
}
const YM = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: on("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = Re((n) => [ra(t, n)], (n) => n.findIndex((r) => r.id === e.id), Ee(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = ra(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const o = ra(t, n);
      return ((r = o[o.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = Re(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (o) => {
      let i = [];
      if (!(t != null && t.length))
        i = o;
      else {
        const l = [...t], c = [...o];
        for (; c.length && l.length; ) {
          const f = l.shift(), p = c.findIndex((m) => m.id === f);
          p > -1 && i.push(c.splice(p, 1)[0]);
        }
        i = [...i, ...c];
      }
      return KM(i, n, r);
    }, Ee(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, $d = () => ({
  left: [],
  right: []
}), ZM = {
  getInitialState: (e) => ({
    columnPinning: $d(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: on("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((o) => o.id).filter(Boolean);
      t.setColumnPinning((o) => {
        var i, l;
        if (n === "right") {
          var c, f;
          return {
            left: ((c = o == null ? void 0 : o.left) != null ? c : []).filter((v) => !(r != null && r.includes(v))),
            right: [...((f = o == null ? void 0 : o.right) != null ? f : []).filter((v) => !(r != null && r.includes(v))), ...r]
          };
        }
        if (n === "left") {
          var p, m;
          return {
            left: [...((p = o == null ? void 0 : o.left) != null ? p : []).filter((v) => !(r != null && r.includes(v))), ...r],
            right: ((m = o == null ? void 0 : o.right) != null ? m : []).filter((v) => !(r != null && r.includes(v)))
          };
        }
        return {
          left: ((i = o == null ? void 0 : o.left) != null ? i : []).filter((v) => !(r != null && r.includes(v))),
          right: ((l = o == null ? void 0 : o.right) != null ? l : []).filter((v) => !(r != null && r.includes(v)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var o, i, l;
      return ((o = r.columnDef.enablePinning) != null ? o : !0) && ((i = (l = t.options.enableColumnPinning) != null ? l : t.options.enablePinning) != null ? i : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((c) => c.id), {
        left: r,
        right: o
      } = t.getState().columnPinning, i = n.some((c) => r == null ? void 0 : r.includes(c)), l = n.some((c) => o == null ? void 0 : o.includes(c));
      return i ? "left" : l ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      return o ? (n = (r = t.getState().columnPinning) == null || (r = r[o]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = Re(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, o) => {
      const i = [...r ?? [], ...o ?? []];
      return n.filter((l) => !i.includes(l.column.id));
    }, Ee(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = Re(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((i) => n.find((l) => l.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "left"
    })), Ee(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = Re(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((i) => n.find((l) => l.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "right"
    })), Ee(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? $d() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : $d());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var o, i;
        return !!((o = r.left) != null && o.length || (i = r.right) != null && i.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = Re(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), Ee(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = Re(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), Ee(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = Re(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const o = [...n ?? [], ...r ?? []];
      return t.filter((i) => !o.includes(i.id));
    }, Ee(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, Os = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Ld = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), XM = {
  getDefaultColumnDef: () => Os,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: Ld(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: on("columnSizing", e),
    onColumnSizingInfoChange: on("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, o;
      const i = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : Os.minSize, (r = i ?? e.columnDef.size) != null ? r : Os.size), (o = e.columnDef.maxSize) != null ? o : Os.maxSize);
    }, e.getStart = Re((n) => [n, ra(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((o, i) => o + i.getSize(), 0), Ee(t.options, "debugColumns", "getStart")), e.getAfter = Re((n) => [n, ra(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((o, i) => o + i.getSize(), 0), Ee(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...o
        } = n;
        return o;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (o) => {
        if (o.subHeaders.length)
          o.subHeaders.forEach(r);
        else {
          var i;
          n += (i = o.column.getSize()) != null ? i : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), o = r == null ? void 0 : r.getCanResize();
      return (i) => {
        if (!r || !o || (i.persist == null || i.persist(), Md(i) && i.touches && i.touches.length > 1))
          return;
        const l = e.getSize(), c = e ? e.getLeafHeaders().map((w) => [w.column.id, w.column.getSize()]) : [[r.id, r.getSize()]], f = Md(i) ? Math.round(i.touches[0].clientX) : i.clientX, p = {}, m = (w, N) => {
          typeof N == "number" && (t.setColumnSizingInfo((_) => {
            var P, A;
            const I = t.options.columnResizeDirection === "rtl" ? -1 : 1, T = (N - ((P = _ == null ? void 0 : _.startOffset) != null ? P : 0)) * I, M = Math.max(T / ((A = _ == null ? void 0 : _.startSize) != null ? A : 0), -0.999999);
            return _.columnSizingStart.forEach((D) => {
              let [W, U] = D;
              p[W] = Math.round(Math.max(U + U * M, 0) * 100) / 100;
            }), {
              ..._,
              deltaOffset: T,
              deltaPercentage: M
            };
          }), (t.options.columnResizeMode === "onChange" || w === "end") && t.setColumnSizing((_) => ({
            ..._,
            ...p
          })));
        }, v = (w) => m("move", w), C = (w) => {
          m("end", w), t.setColumnSizingInfo((N) => ({
            ...N,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, x = n || typeof document < "u" ? document : null, y = {
          moveHandler: (w) => v(w.clientX),
          upHandler: (w) => {
            x == null || x.removeEventListener("mousemove", y.moveHandler), x == null || x.removeEventListener("mouseup", y.upHandler), C(w.clientX);
          }
        }, h = {
          moveHandler: (w) => (w.cancelable && (w.preventDefault(), w.stopPropagation()), v(w.touches[0].clientX), !1),
          upHandler: (w) => {
            var N;
            x == null || x.removeEventListener("touchmove", h.moveHandler), x == null || x.removeEventListener("touchend", h.upHandler), w.cancelable && (w.preventDefault(), w.stopPropagation()), C((N = w.touches[0]) == null ? void 0 : N.clientX);
          }
        }, b = jM() ? {
          passive: !1
        } : !1;
        Md(i) ? (x == null || x.addEventListener("touchmove", h.moveHandler, b), x == null || x.addEventListener("touchend", h.upHandler, b)) : (x == null || x.addEventListener("mousemove", y.moveHandler, b), x == null || x.addEventListener("mouseup", y.upHandler, b)), t.setColumnSizingInfo((w) => ({
          ...w,
          startOffset: f,
          startSize: l,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: c,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? Ld() : (n = e.initialState.columnSizingInfo) != null ? n : Ld());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    };
  }
};
let ks = null;
function jM() {
  if (typeof ks == "boolean") return ks;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return ks = e, ks;
}
function Md(e) {
  return e.type === "touchstart";
}
const QM = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: on("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const o = e.columns;
      return (n = o.length ? o.some((i) => i.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = Re(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), Ee(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = Re(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, o) => [...n, ...r, ...o], Ee(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => Re(() => [r(), r().filter((o) => o.getIsVisible()).map((o) => o.id).join("_")], (o) => o.filter((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), Ee(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((o, i) => ({
        ...o,
        [i.id]: n || !(i.getCanHide != null && i.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function ra(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const JM = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, eI = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: on("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, o, i;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && ((i = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? i : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Jn.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return tc(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : Jn[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, tI = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: on("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var o, i;
      e.setExpanded(r ? {} : (o = (i = e.initialState) == null ? void 0 : i.expanded) != null ? o : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((o) => !o.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((i) => {
        const l = i.split(".");
        r = Math.max(r, l.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var o;
        const i = r === !0 ? !0 : !!(r != null && r[e.id]);
        let l = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((c) => {
          l[c] = !0;
        }) : l = r, n = (o = n) != null ? o : !i, !i && n)
          return {
            ...l,
            [e.id]: !0
          };
        if (i && !n) {
          const {
            [e.id]: c,
            ...f
          } = l;
          return f;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var n, r, o;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((o = e.subRows) != null && o.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, Nf = 0, _f = 10, Id = () => ({
  pageIndex: Nf,
  pageSize: _f
}), nI = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...Id(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: on("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const o = (i) => Ar(r, i);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(o);
    }, e.resetPagination = (r) => {
      var o;
      e.setPagination(r ? Id() : (o = e.initialState.pagination) != null ? o : Id());
    }, e.setPageIndex = (r) => {
      e.setPagination((o) => {
        let i = Ar(r, o.pageIndex);
        const l = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return i = Math.max(0, Math.min(i, l)), {
          ...o,
          pageIndex: i
        };
      });
    }, e.resetPageIndex = (r) => {
      var o, i;
      e.setPageIndex(r ? Nf : (o = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageIndex) != null ? o : Nf);
    }, e.resetPageSize = (r) => {
      var o, i;
      e.setPageSize(r ? _f : (o = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageSize) != null ? o : _f);
    }, e.setPageSize = (r) => {
      e.setPagination((o) => {
        const i = Math.max(1, Ar(r, o.pageSize)), l = o.pageSize * o.pageIndex, c = Math.floor(l / i);
        return {
          ...o,
          pageIndex: c,
          pageSize: i
        };
      });
    }, e.setPageCount = (r) => e.setPagination((o) => {
      var i;
      let l = Ar(r, (i = e.options.pageCount) != null ? i : -1);
      return typeof l == "number" && (l = Math.max(-1, l)), {
        ...o,
        pageCount: l
      };
    }), e.getPageOptions = Re(() => [e.getPageCount()], (r) => {
      let o = [];
      return r && r > 0 && (o = [...new Array(r)].fill(null).map((i, l) => l)), o;
    }, Ee(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, o = e.getPageCount();
      return o === -1 ? !0 : o === 0 ? !1 : r < o - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, Od = () => ({
  top: [],
  bottom: []
}), rI = {
  getInitialState: (e) => ({
    rowPinning: Od(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: on("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, o) => {
      const i = r ? e.getLeafRows().map((f) => {
        let {
          id: p
        } = f;
        return p;
      }) : [], l = o ? e.getParentRows().map((f) => {
        let {
          id: p
        } = f;
        return p;
      }) : [], c = /* @__PURE__ */ new Set([...l, e.id, ...i]);
      t.setRowPinning((f) => {
        var p, m;
        if (n === "bottom") {
          var v, C;
          return {
            top: ((v = f == null ? void 0 : f.top) != null ? v : []).filter((h) => !(c != null && c.has(h))),
            bottom: [...((C = f == null ? void 0 : f.bottom) != null ? C : []).filter((h) => !(c != null && c.has(h))), ...Array.from(c)]
          };
        }
        if (n === "top") {
          var x, y;
          return {
            top: [...((x = f == null ? void 0 : f.top) != null ? x : []).filter((h) => !(c != null && c.has(h))), ...Array.from(c)],
            bottom: ((y = f == null ? void 0 : f.bottom) != null ? y : []).filter((h) => !(c != null && c.has(h)))
          };
        }
        return {
          top: ((p = f == null ? void 0 : f.top) != null ? p : []).filter((h) => !(c != null && c.has(h))),
          bottom: ((m = f == null ? void 0 : f.bottom) != null ? m : []).filter((h) => !(c != null && c.has(h)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: o
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? o) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: o
      } = t.getState().rowPinning, i = n.some((c) => r == null ? void 0 : r.includes(c)), l = n.some((c) => o == null ? void 0 : o.includes(c));
      return i ? "top" : l ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      if (!o) return -1;
      const i = (n = o === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((l) => {
        let {
          id: c
        } = l;
        return c;
      });
      return (r = i == null ? void 0 : i.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? Od() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : Od());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var o, i;
        return !!((o = r.top) != null && o.length || (i = r.bottom) != null && i.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var o;
      return ((o = e.options.keepPinnedRows) == null || o ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((l) => {
          const c = e.getRow(l, !0);
          return c.getIsAllParentsExpanded() ? c : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((l) => t.find((c) => c.id === l))
      )).filter(Boolean).map((l) => ({
        ...l,
        position: r
      }));
    }, e.getTopRows = Re(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), Ee(e.options, "debugRows", "getTopRows")), e.getBottomRows = Re(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), Ee(e.options, "debugRows", "getBottomRows")), e.getCenterRows = Re(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const o = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((i) => !o.has(i.id));
    }, Ee(e.options, "debugRows", "getCenterRows"));
  }
}, oI = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: on("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, o = e.getPreGroupedRowModel().flatRows;
        return t ? o.forEach((i) => {
          i.getCanSelect() && (r[i.id] = !0);
        }) : o.forEach((i) => {
          delete r[i.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), o = {
        ...n
      };
      return e.getRowModel().rows.forEach((i) => {
        Rf(o, i.id, r, !0, e);
      }), o;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = Re(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? kd(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Ee(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = Re(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? kd(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Ee(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = Re(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? kd(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Ee(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((o) => o.getCanSelect() && !n[o.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((o) => o.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((o) => !n[o.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const o = e.getIsSelected();
      t.setRowSelection((i) => {
        var l;
        if (n = typeof n < "u" ? n : !o, e.getCanSelect() && o === n)
          return i;
        const c = {
          ...i
        };
        return Rf(c, e.id, n, (l = r == null ? void 0 : r.selectChildren) != null ? l : !0, t), c;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Q1(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Ef(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Ef(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var o;
        n && e.toggleSelected((o = r.target) == null ? void 0 : o.checked);
      };
    };
  }
}, Rf = (e, t, n, r, o) => {
  var i;
  const l = o.getRow(t, !0);
  n ? (l.getCanMultiSelect() || Object.keys(e).forEach((c) => delete e[c]), l.getCanSelect() && (e[t] = !0)) : delete e[t], r && (i = l.subRows) != null && i.length && l.getCanSelectSubRows() && l.subRows.forEach((c) => Rf(e, c.id, n, r, o));
};
function kd(e, t) {
  const n = e.getState().rowSelection, r = [], o = {}, i = function(l, c) {
    return l.map((f) => {
      var p;
      const m = Q1(f, n);
      if (m && (r.push(f), o[f.id] = f), (p = f.subRows) != null && p.length && (f = {
        ...f,
        subRows: i(f.subRows)
      }), m)
        return f;
    }).filter(Boolean);
  };
  return {
    rows: i(t.rows),
    flatRows: r,
    rowsById: o
  };
}
function Q1(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function Ef(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length)) return !1;
  let o = !0, i = !1;
  return e.subRows.forEach((l) => {
    if (!(i && !o) && (l.getCanSelect() && (Q1(l, t) ? i = !0 : o = !1), l.subRows && l.subRows.length)) {
      const c = Ef(l, t);
      c === "all" ? i = !0 : (c === "some" && (i = !0), o = !1);
    }
  }), o ? "all" : i ? "some" : !1;
}
const Pf = /([0-9]+)/gm, iI = (e, t, n) => w4(Or(e.getValue(n)).toLowerCase(), Or(t.getValue(n)).toLowerCase()), aI = (e, t, n) => w4(Or(e.getValue(n)), Or(t.getValue(n))), sI = (e, t, n) => J1(Or(e.getValue(n)).toLowerCase(), Or(t.getValue(n)).toLowerCase()), lI = (e, t, n) => J1(Or(e.getValue(n)), Or(t.getValue(n))), cI = (e, t, n) => {
  const r = e.getValue(n), o = t.getValue(n);
  return r > o ? 1 : r < o ? -1 : 0;
}, uI = (e, t, n) => J1(e.getValue(n), t.getValue(n));
function J1(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function Or(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function w4(e, t) {
  const n = e.split(Pf).filter(Boolean), r = t.split(Pf).filter(Boolean);
  for (; n.length && r.length; ) {
    const o = n.shift(), i = r.shift(), l = parseInt(o, 10), c = parseInt(i, 10), f = [l, c].sort();
    if (isNaN(f[0])) {
      if (o > i)
        return 1;
      if (i > o)
        return -1;
      continue;
    }
    if (isNaN(f[1]))
      return isNaN(l) ? -1 : 1;
    if (l > c)
      return 1;
    if (c > l)
      return -1;
  }
  return n.length - r.length;
}
const Qi = {
  alphanumeric: iI,
  alphanumericCaseSensitive: aI,
  text: sI,
  textCaseSensitive: lI,
  datetime: cI,
  basic: uI
}, dI = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: on("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const o of n) {
        const i = o == null ? void 0 : o.getValue(e.id);
        if (Object.prototype.toString.call(i) === "[object Date]")
          return Qi.datetime;
        if (typeof i == "string" && (r = !0, i.split(Pf).length > 1))
          return Qi.alphanumeric;
      }
      return r ? Qi.text : Qi.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return tc(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : Qi[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const o = e.getNextSortingOrder(), i = typeof n < "u" && n !== null;
      t.setSorting((l) => {
        const c = l == null ? void 0 : l.find((x) => x.id === e.id), f = l == null ? void 0 : l.findIndex((x) => x.id === e.id);
        let p = [], m, v = i ? n : o === "desc";
        if (l != null && l.length && e.getCanMultiSort() && r ? c ? m = "toggle" : m = "add" : l != null && l.length && f !== l.length - 1 ? m = "replace" : c ? m = "toggle" : m = "replace", m === "toggle" && (i || o || (m = "remove")), m === "add") {
          var C;
          p = [...l, {
            id: e.id,
            desc: v
          }], p.splice(0, p.length - ((C = t.options.maxMultiSortColCount) != null ? C : Number.MAX_SAFE_INTEGER));
        } else m === "toggle" ? p = l.map((x) => x.id === e.id ? {
          ...x,
          desc: v
        } : x) : m === "remove" ? p = l.filter((x) => x.id !== e.id) : p = [{
          id: e.id,
          desc: v
        }];
        return p;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, o;
      const i = e.getFirstSortDir(), l = e.getIsSorted();
      return l ? l !== i && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (o = t.options.enableMultiRemove) != null) || o) ? !1 : l === "desc" ? "asc" : "desc" : i;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((o) => o.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, fI = [
  IM,
  QM,
  YM,
  ZM,
  OM,
  kM,
  JM,
  //depends on ColumnFaceting
  eI,
  //depends on ColumnFiltering
  dI,
  qM,
  //depends on RowSorting
  tI,
  nI,
  rI,
  oI,
  XM
];
function pI(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...fI, ...(t = e._features) != null ? t : []];
  let o = {
    _features: r
  };
  const i = o._features.reduce((C, x) => Object.assign(C, x.getDefaultOptions == null ? void 0 : x.getDefaultOptions(o)), {}), l = (C) => o.options.mergeOptions ? o.options.mergeOptions(i, C) : {
    ...i,
    ...C
  };
  let f = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  o._features.forEach((C) => {
    var x;
    f = (x = C.getInitialState == null ? void 0 : C.getInitialState(f)) != null ? x : f;
  });
  const p = [];
  let m = !1;
  const v = {
    _features: r,
    options: {
      ...i,
      ...e
    },
    initialState: f,
    _queue: (C) => {
      p.push(C), m || (m = !0, Promise.resolve().then(() => {
        for (; p.length; )
          p.shift()();
        m = !1;
      }).catch((x) => setTimeout(() => {
        throw x;
      })));
    },
    reset: () => {
      o.setState(o.initialState);
    },
    setOptions: (C) => {
      const x = Ar(C, o.options);
      o.options = l(x);
    },
    getState: () => o.options.state,
    setState: (C) => {
      o.options.onStateChange == null || o.options.onStateChange(C);
    },
    _getRowId: (C, x, y) => {
      var h;
      return (h = o.options.getRowId == null ? void 0 : o.options.getRowId(C, x, y)) != null ? h : `${y ? [y.id, x].join(".") : x}`;
    },
    getCoreRowModel: () => (o._getCoreRowModel || (o._getCoreRowModel = o.options.getCoreRowModel(o)), o._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => o.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (C, x) => {
      let y = (x ? o.getPrePaginationRowModel() : o.getRowModel()).rowsById[C];
      if (!y && (y = o.getCoreRowModel().rowsById[C], !y))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${C}`) : new Error();
      return y;
    },
    _getDefaultColumnDef: Re(() => [o.options.defaultColumn], (C) => {
      var x;
      return C = (x = C) != null ? x : {}, {
        header: (y) => {
          const h = y.header.column.columnDef;
          return h.accessorKey ? h.accessorKey : h.accessorFn ? h.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (y) => {
          var h, b;
          return (h = (b = y.renderValue()) == null || b.toString == null ? void 0 : b.toString()) != null ? h : null;
        },
        ...o._features.reduce((y, h) => Object.assign(y, h.getDefaultColumnDef == null ? void 0 : h.getDefaultColumnDef()), {}),
        ...C
      };
    }, Ee(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => o.options.columns,
    getAllColumns: Re(() => [o._getColumnDefs()], (C) => {
      const x = function(y, h, b) {
        return b === void 0 && (b = 0), y.map((w) => {
          const N = MM(o, w, b, h), _ = w;
          return N.columns = _.columns ? x(_.columns, N, b + 1) : [], N;
        });
      };
      return x(C);
    }, Ee(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: Re(() => [o.getAllColumns()], (C) => C.flatMap((x) => x.getFlatColumns()), Ee(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: Re(() => [o.getAllFlatColumns()], (C) => C.reduce((x, y) => (x[y.id] = y, x), {}), Ee(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: Re(() => [o.getAllColumns(), o._getOrderColumnsFn()], (C, x) => {
      let y = C.flatMap((h) => h.getLeafColumns());
      return x(y);
    }, Ee(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (C) => {
      const x = o._getAllFlatColumnsById()[C];
      return process.env.NODE_ENV !== "production" && !x && console.error(`[Table] Column with id '${C}' does not exist.`), x;
    }
  };
  Object.assign(o, v);
  for (let C = 0; C < o._features.length; C++) {
    const x = o._features[C];
    x == null || x.createTable == null || x.createTable(o);
  }
  return o;
}
function mI() {
  return (e) => Re(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(o, i, l) {
      i === void 0 && (i = 0);
      const c = [];
      for (let p = 0; p < o.length; p++) {
        const m = X1(e, e._getRowId(o[p], p, l), o[p], p, i, void 0, l == null ? void 0 : l.id);
        if (n.flatRows.push(m), n.rowsById[m.id] = m, c.push(m), e.options.getSubRows) {
          var f;
          m.originalSubRows = e.options.getSubRows(o[p], p), (f = m.originalSubRows) != null && f.length && (m.subRows = r(m.originalSubRows, i + 1, m));
        }
      }
      return c;
    };
    return n.rows = r(t), n;
  }, Ee(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function hI(e) {
  const t = [], n = (r) => {
    var o;
    t.push(r), (o = r.subRows) != null && o.length && r.getIsExpanded() && r.subRows.forEach(n);
  };
  return e.rows.forEach(n), {
    rows: t,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function gI(e, t, n) {
  return n.options.filterFromLeafRows ? vI(e, t, n) : CI(e, t, n);
}
function vI(e, t, n) {
  var r;
  const o = [], i = {}, l = (r = n.options.maxLeafRowFilterDepth) != null ? r : 100, c = function(f, p) {
    p === void 0 && (p = 0);
    const m = [];
    for (let C = 0; C < f.length; C++) {
      var v;
      let x = f[C];
      const y = X1(n, x.id, x.original, x.index, x.depth, void 0, x.parentId);
      if (y.columnFilters = x.columnFilters, (v = x.subRows) != null && v.length && p < l) {
        if (y.subRows = c(x.subRows, p + 1), x = y, t(x) && !y.subRows.length) {
          m.push(x), i[x.id] = x, o.push(x);
          continue;
        }
        if (t(x) || y.subRows.length) {
          m.push(x), i[x.id] = x, o.push(x);
          continue;
        }
      } else
        x = y, t(x) && (m.push(x), i[x.id] = x, o.push(x));
    }
    return m;
  };
  return {
    rows: c(e),
    flatRows: o,
    rowsById: i
  };
}
function CI(e, t, n) {
  var r;
  const o = [], i = {}, l = (r = n.options.maxLeafRowFilterDepth) != null ? r : 100, c = function(f, p) {
    p === void 0 && (p = 0);
    const m = [];
    for (let C = 0; C < f.length; C++) {
      let x = f[C];
      if (t(x)) {
        var v;
        if ((v = x.subRows) != null && v.length && p < l) {
          const h = X1(n, x.id, x.original, x.index, x.depth, void 0, x.parentId);
          h.subRows = c(x.subRows, p + 1), x = h;
        }
        m.push(x), o.push(x), i[x.id] = x;
      }
    }
    return m;
  };
  return {
    rows: c(e),
    flatRows: o,
    rowsById: i
  };
}
function xI() {
  return (e) => Re(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter], (t, n, r) => {
    if (!t.rows.length || !(n != null && n.length) && !r) {
      for (let C = 0; C < t.flatRows.length; C++)
        t.flatRows[C].columnFilters = {}, t.flatRows[C].columnFiltersMeta = {};
      return t;
    }
    const o = [], i = [];
    (n ?? []).forEach((C) => {
      var x;
      const y = e.getColumn(C.id);
      if (!y)
        return;
      const h = y.getFilterFn();
      if (!h) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${y.id}.`);
        return;
      }
      o.push({
        id: C.id,
        filterFn: h,
        resolvedValue: (x = h.resolveFilterValue == null ? void 0 : h.resolveFilterValue(C.value)) != null ? x : C.value
      });
    });
    const l = (n ?? []).map((C) => C.id), c = e.getGlobalFilterFn(), f = e.getAllLeafColumns().filter((C) => C.getCanGlobalFilter());
    r && c && f.length && (l.push("__global__"), f.forEach((C) => {
      var x;
      i.push({
        id: C.id,
        filterFn: c,
        resolvedValue: (x = c.resolveFilterValue == null ? void 0 : c.resolveFilterValue(r)) != null ? x : r
      });
    }));
    let p, m;
    for (let C = 0; C < t.flatRows.length; C++) {
      const x = t.flatRows[C];
      if (x.columnFilters = {}, o.length)
        for (let y = 0; y < o.length; y++) {
          p = o[y];
          const h = p.id;
          x.columnFilters[h] = p.filterFn(x, h, p.resolvedValue, (b) => {
            x.columnFiltersMeta[h] = b;
          });
        }
      if (i.length) {
        for (let y = 0; y < i.length; y++) {
          m = i[y];
          const h = m.id;
          if (m.filterFn(x, h, m.resolvedValue, (b) => {
            x.columnFiltersMeta[h] = b;
          })) {
            x.columnFilters.__global__ = !0;
            break;
          }
        }
        x.columnFilters.__global__ !== !0 && (x.columnFilters.__global__ = !1);
      }
    }
    const v = (C) => {
      for (let x = 0; x < l.length; x++)
        if (C.columnFilters[l[x]] === !1)
          return !1;
      return !0;
    };
    return gI(t.rows, v, e);
  }, Ee(e.options, "debugTable", "getFilteredRowModel", () => e._autoResetPageIndex()));
}
function bI(e) {
  return (t) => Re(() => [t.getState().pagination, t.getPrePaginationRowModel(), t.options.paginateExpandedRows ? void 0 : t.getState().expanded], (n, r) => {
    if (!r.rows.length)
      return r;
    const {
      pageSize: o,
      pageIndex: i
    } = n;
    let {
      rows: l,
      flatRows: c,
      rowsById: f
    } = r;
    const p = o * i, m = p + o;
    l = l.slice(p, m);
    let v;
    t.options.paginateExpandedRows ? v = {
      rows: l,
      flatRows: c,
      rowsById: f
    } : v = hI({
      rows: l,
      flatRows: c,
      rowsById: f
    }), v.flatRows = [];
    const C = (x) => {
      v.flatRows.push(x), x.subRows.length && x.subRows.forEach(C);
    };
    return v.rows.forEach(C), v;
  }, Ee(t.options, "debugTable", "getPaginationRowModel"));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function S0(e, t) {
  return e ? yI(e) ? /* @__PURE__ */ d.createElement(e, t) : e : null;
}
function yI(e) {
  return wI(e) || typeof e == "function" || SI(e);
}
function wI(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function SI(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function NI(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = d.useState(() => ({
    current: pI(t)
  })), [r, o] = d.useState(() => n.current.initialState);
  return n.current.setOptions((i) => ({
    ...i,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (l) => {
      o(l), e.onStateChange == null || e.onStateChange(l);
    }
  })), n.current;
}
const S4 = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ s("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ s(
    "table",
    {
      ref: n,
      className: F("w-full caption-bottom text-sm", e),
      ...t
    }
  ) })
);
S4.displayName = "Table";
const N4 = q(({ className: e, ...t }, n) => /* @__PURE__ */ s("thead", { ref: n, className: F("[&_tr]:border-b", e), ...t }));
N4.displayName = "TableHeader";
const _4 = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "tbody",
  {
    ref: n,
    className: F("[&_tr:last-child]:border-0", e),
    ...t
  }
));
_4.displayName = "TableBody";
const _I = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "tfoot",
  {
    ref: n,
    className: F("bg-primary text-primary-foreground font-medium", e),
    ...t
  }
));
_I.displayName = "TableFooter";
const nl = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "tr",
  {
    ref: n,
    className: F(
      "hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors",
      e
    ),
    ...t
  }
));
nl.displayName = "TableRow";
const R4 = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "th",
  {
    ref: n,
    className: F(
      "text-muted-foreground h-12 px-4 text-left align-middle font-medium [&:has([role=checkbox])]:pr-0",
      e
    ),
    ...t
  }
));
R4.displayName = "TableHead";
const Af = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "td",
  {
    ref: n,
    className: F("p-4 align-middle [&:has([role=checkbox])]:pr-0", e),
    ...t
  }
));
Af.displayName = "TableCell";
const RI = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "caption",
  {
    ref: n,
    className: F("text-muted-foreground mt-4 text-sm", e),
    ...t
  }
));
RI.displayName = "TableCaption";
function EI({
  columnFilters: e,
  columns: t,
  columnVisibility: n,
  data: r,
  enableMultiRowSelection: o = !1,
  enableRowSelection: i = !1,
  getRowId: l,
  manualPagination: c = !0,
  noResultsMessage: f = "No results",
  onColumnFiltersChange: p,
  onColumnVisibilityChange: m,
  onRowsSelected: v,
  state: C
}, x) {
  const y = C || {};
  e && (y.columnFilters = e), n && (y.columnVisibility = n);
  const h = NI({
    columns: t,
    data: r,
    enableRowSelection: i,
    enableMultiRowSelection: o,
    getCoreRowModel: mI(),
    getFilteredRowModel: xI(),
    getPaginationRowModel: bI(),
    getRowId: l,
    manualPagination: c,
    onColumnFiltersChange: p,
    onColumnVisibilityChange: m,
    state: y
  }), b = h.getRowModel().rows || [], w = h.getSelectedRowModel();
  return Oe(() => {
    v && v(w);
  }, [w]), tP(
    x,
    () => ({
      table: h
    }),
    [h]
  ), /* @__PURE__ */ R(S4, { className: "border-interactiveBorder rounded-xs border ", children: [
    /* @__PURE__ */ s(N4, { className: "px-3 py-0", children: h.getHeaderGroups().map((N) => /* @__PURE__ */ s(
      nl,
      {
        className: "border-interactiveBorder border bg-transparent p-0 hover:bg-transparent",
        children: N.headers.map((_) => /* @__PURE__ */ s(
          R4,
          {
            className: "text-textSubdued px-3 py-0 text-base font-normal leading-5",
            children: _.isPlaceholder ? null : S0(
              _.column.columnDef.header,
              _.getContext()
            )
          },
          _.id
        ))
      },
      N.id
    )) }),
    /* @__PURE__ */ R(_4, { children: [
      b.length > 0 ? b.map((N) => /* @__PURE__ */ s(
        nl,
        {
          className: "border-interfaceBorder bg-interfaceWhite cursor-pointer border-b hover:bg-[#F9F8F5]",
          id: `row-${N.id}`,
          "data-state": N.getIsSelected() && "selected",
          onClick: () => N.toggleSelected(),
          children: N.getVisibleCells().map((_) => /* @__PURE__ */ s(Af, { className: "", children: S0(_.column.columnDef.cell, _.getContext()) }, _.id))
        },
        N.id
      )) : null,
      b.length === 0 ? /* @__PURE__ */ s(nl, { className: "border-interfaceBorder bg-interfaceWhite hover:bg-interfaceWhite border-b", children: /* @__PURE__ */ s(Af, { colSpan: t.length, className: "text-center", children: f }) }) : null
    ] })
  ] });
}
const XY = oP(EI), E4 = ({ className: e, ...t }) => /* @__PURE__ */ s(
  "nav",
  {
    role: "navigation",
    "aria-label": "pagination",
    className: F("flex justify-center", e),
    ...t
  }
);
E4.displayName = "Pagination";
const P4 = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ s(
    "ul",
    {
      ref: n,
      className: F("flex flex-row items-center gap-1", e),
      ...t
    }
  )
);
P4.displayName = "PaginationContent";
const Ji = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ s("li", { ref: n, className: F("", e), ...t })
);
Ji.displayName = "PaginationItem";
const nc = ({
  className: e,
  isActive: t,
  onClick: n,
  size: r = "icon",
  ...o
}) => {
  const i = (l) => {
    n && !o.disabled && n(l);
  };
  return /* @__PURE__ */ s(
    "a",
    {
      "aria-current": t ? "page" : void 0,
      className: F(
        zl({
          variant: t ? "outline" : "ghost",
          size: r
        }),
        e
      ),
      onClick: i,
      ...o
    }
  );
};
nc.displayName = "PaginationLink";
const A4 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ R(
  nc,
  {
    "aria-label": "Go to previous page",
    size: "default",
    className: F("gap-1 pl-2.5", e),
    ...t,
    children: [
      /* @__PURE__ */ s(_$, { className: "h-4 w-4" }),
      /* @__PURE__ */ s("span", { children: "Prev" })
    ]
  }
);
A4.displayName = "PaginationPrevious";
const T4 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ R(
  nc,
  {
    "aria-label": "Next page",
    size: "default",
    className: F("gap-1 pr-2.5", e),
    ...t,
    children: [
      /* @__PURE__ */ s("span", { children: "Next" }),
      /* @__PURE__ */ s(E$, { className: "h-4 w-4" })
    ]
  }
);
T4.displayName = "PaginationNext";
const $4 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ R(
  "span",
  {
    "aria-hidden": !0,
    className: F(
      "flex h-9 w-9 items-center justify-center",
      e
    ),
    ...t,
    children: [
      /* @__PURE__ */ s(A$, { className: "h-4 w-4" }),
      /* @__PURE__ */ s("span", { className: "sr-only", children: "More pages" })
    ]
  }
);
$4.displayName = "PaginationEllipsis";
function PI({
  className: e,
  onClickNext: t,
  onClickPageNumber: n,
  onClickPrevious: r,
  pageNumber: o,
  pageSize: i,
  totalRecords: l
}) {
  const c = gn(() => l < i ? 1 : Math.ceil(l / i), [i, l]), f = (v) => /* @__PURE__ */ s(Ji, { children: /* @__PURE__ */ s(
    nc,
    {
      isActive: o === v,
      onClick: () => n == null ? void 0 : n(v),
      children: v
    }
  ) }, v), p = () => /* @__PURE__ */ s(Ji, { children: /* @__PURE__ */ s($4, {}) });
  return /* @__PURE__ */ s(E4, { className: e, children: /* @__PURE__ */ R(P4, { children: [
    /* @__PURE__ */ s(Ji, { children: /* @__PURE__ */ s(
      A4,
      {
        disabled: o === 1,
        onClick: r
      }
    ) }),
    c <= 5 ? Array.from(Array(c).keys()).map(
      (v) => f(v + 1)
    ) : c > 5 && o < 5 ? /* @__PURE__ */ R(le, { children: [
      f(1),
      f(2),
      f(3),
      f(4),
      p(),
      f(c)
    ] }) : c > 5 && o > 4 && o <= c - 4 ? /* @__PURE__ */ R(le, { children: [
      f(1),
      p(),
      Array.from({ length: 2 }, (v, C) => C).map(
        (v) => f(v + o)
      ),
      p(),
      f(c)
    ] }) : /* @__PURE__ */ R(le, { children: [
      f(1),
      p(),
      f(c - 3),
      f(c - 2),
      f(c - 1),
      f(c)
    ] }),
    /* @__PURE__ */ s(Ji, { children: /* @__PURE__ */ s(
      T4,
      {
        disabled: o === c,
        onClick: t
      }
    ) })
  ] }) });
}
function jY({
  onPageChange: e,
  pageNumber: t,
  pageSize: n,
  totalRecords: r
}) {
  const o = (f) => {
    e(f);
  }, i = () => {
    e(t - 1);
  }, l = () => {
    e(t + 1);
  };
  return {
    DataTablePagination: () => /* @__PURE__ */ s(
      PI,
      {
        onClickPageNumber: o,
        onClickPrevious: i,
        onClickNext: l,
        pageNumber: t,
        pageSize: n,
        totalRecords: r
      }
    )
  };
}
function AI(e, t) {
  const n = d.createContext(t), r = (i) => {
    const { children: l, ...c } = i, f = d.useMemo(() => c, Object.values(c));
    return /* @__PURE__ */ s(n.Provider, { value: f, children: l });
  };
  r.displayName = e + "Provider";
  function o(i) {
    const l = d.useContext(n);
    if (l) return l;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function TI(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    const p = (v) => {
      var w;
      const { scope: C, children: x, ...y } = v, h = ((w = C == null ? void 0 : C[e]) == null ? void 0 : w[f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    };
    p.displayName = i + "Provider";
    function m(v, C) {
      var h;
      const x = ((h = C == null ? void 0 : C[e]) == null ? void 0 : h[f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, $I(o, ...t)];
}
function $I(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var LI = "DismissableLayer", Tf = "dismissableLayer.update", MI = "dismissableLayer.pointerDownOutside", II = "dismissableLayer.focusOutside", N0, L4 = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), M4 = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: l,
      onDismiss: c,
      ...f
    } = e, p = d.useContext(L4), [m, v] = d.useState(null), C = (m == null ? void 0 : m.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, x] = d.useState({}), y = ke(t, (T) => v(T)), h = Array.from(p.layers), [b] = [...p.layersWithOutsidePointerEventsDisabled].slice(-1), w = h.indexOf(b), N = m ? h.indexOf(m) : -1, _ = p.layersWithOutsidePointerEventsDisabled.size > 0, P = N >= w, A = DI((T) => {
      const M = T.target, D = [...p.branches].some((W) => W.contains(M));
      !P || D || (o == null || o(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C), I = FI((T) => {
      const M = T.target;
      [...p.branches].some((W) => W.contains(M)) || (i == null || i(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C);
    return Wr((T) => {
      N === p.layers.size - 1 && (r == null || r(T), !T.defaultPrevented && c && (T.preventDefault(), c()));
    }, C), d.useEffect(() => {
      if (m)
        return n && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (N0 = C.body.style.pointerEvents, C.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(m)), p.layers.add(m), _0(), () => {
          n && p.layersWithOutsidePointerEventsDisabled.size === 1 && (C.body.style.pointerEvents = N0);
        };
    }, [m, C, n, p]), d.useEffect(() => () => {
      m && (p.layers.delete(m), p.layersWithOutsidePointerEventsDisabled.delete(m), _0());
    }, [m, p]), d.useEffect(() => {
      const T = () => x({});
      return document.addEventListener(Tf, T), () => document.removeEventListener(Tf, T);
    }, []), /* @__PURE__ */ s(
      ve.div,
      {
        ...f,
        ref: y,
        style: {
          pointerEvents: _ ? P ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: he(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: he(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: he(
          e.onPointerDownCapture,
          A.onPointerDownCapture
        )
      }
    );
  }
);
M4.displayName = LI;
var OI = "DismissableLayerBranch", kI = d.forwardRef((e, t) => {
  const n = d.useContext(L4), r = d.useRef(null), o = ke(t, r);
  return d.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ s(ve.div, { ...e, ref: o });
});
kI.displayName = OI;
function DI(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1), o = d.useRef(() => {
  });
  return d.useEffect(() => {
    const i = (c) => {
      if (c.target && !r.current) {
        let f = function() {
          I4(
            MI,
            n,
            p,
            { discrete: !0 }
          );
        };
        const p = { originalEvent: c };
        c.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = f, t.addEventListener("click", o.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function FI(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && I4(II, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function _0() {
  const e = new CustomEvent(Tf);
  document.dispatchEvent(e);
}
function I4(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Fl(o, i) : o.dispatchEvent(i);
}
var Dd = "focusScope.autoFocusOnMount", Fd = "focusScope.autoFocusOnUnmount", R0 = { bubbles: !1, cancelable: !0 }, BI = "FocusScope", ep = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...l
  } = e, [c, f] = d.useState(null), p = xe(o), m = xe(i), v = d.useRef(null), C = ke(t, (h) => f(h)), x = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (r) {
      let h = function(_) {
        if (x.paused || !c) return;
        const P = _.target;
        c.contains(P) ? v.current = P : _r(v.current, { select: !0 });
      }, b = function(_) {
        if (x.paused || !c) return;
        const P = _.relatedTarget;
        P !== null && (c.contains(P) || _r(v.current, { select: !0 }));
      }, w = function(_) {
        if (document.activeElement === document.body)
          for (const A of _)
            A.removedNodes.length > 0 && _r(c);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", b);
      const N = new MutationObserver(w);
      return c && N.observe(c, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", b), N.disconnect();
      };
    }
  }, [r, c, x.paused]), d.useEffect(() => {
    if (c) {
      P0.add(x);
      const h = document.activeElement;
      if (!c.contains(h)) {
        const w = new CustomEvent(Dd, R0);
        c.addEventListener(Dd, p), c.dispatchEvent(w), w.defaultPrevented || (VI(zI(O4(c)), { select: !0 }), document.activeElement === h && _r(c));
      }
      return () => {
        c.removeEventListener(Dd, p), setTimeout(() => {
          const w = new CustomEvent(Fd, R0);
          c.addEventListener(Fd, m), c.dispatchEvent(w), w.defaultPrevented || _r(h ?? document.body, { select: !0 }), c.removeEventListener(Fd, m), P0.remove(x);
        }, 0);
      };
    }
  }, [c, p, m, x]);
  const y = d.useCallback(
    (h) => {
      if (!n && !r || x.paused) return;
      const b = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, w = document.activeElement;
      if (b && w) {
        const N = h.currentTarget, [_, P] = WI(N);
        _ && P ? !h.shiftKey && w === P ? (h.preventDefault(), n && _r(_, { select: !0 })) : h.shiftKey && w === _ && (h.preventDefault(), n && _r(P, { select: !0 })) : w === N && h.preventDefault();
      }
    },
    [n, r, x.paused]
  );
  return /* @__PURE__ */ s(ve.div, { tabIndex: -1, ...l, ref: C, onKeyDown: y });
});
ep.displayName = BI;
function VI(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (_r(r, { select: t }), document.activeElement !== n) return;
}
function WI(e) {
  const t = O4(e), n = E0(t, e), r = E0(t.reverse(), e);
  return [n, r];
}
function O4(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function E0(e, t) {
  for (const n of e)
    if (!HI(n, { upTo: t })) return n;
}
function HI(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function UI(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function _r(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && UI(e) && t && e.select();
  }
}
var P0 = GI();
function GI() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = A0(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = A0(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function A0(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function zI(e) {
  return e.filter((t) => t.tagName !== "A");
}
var qI = "Portal", k4 = d.forwardRef((e, t) => {
  var c;
  const { container: n, ...r } = e, [o, i] = d.useState(!1);
  be(() => i(!0), []);
  const l = n || o && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return l ? Br.createPortal(/* @__PURE__ */ s(ve.div, { ...r, ref: t }), l) : null;
});
k4.displayName = qI;
function KI(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var rc = (e) => {
  const { present: t, children: n } = e, r = YI(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), i = ke(r.ref, ZI(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: i }) : null;
};
rc.displayName = "Presence";
function YI(e) {
  const [t, n] = d.useState(), r = d.useRef({}), o = d.useRef(e), i = d.useRef("none"), l = e ? "mounted" : "unmounted", [c, f] = KI(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const p = Ds(r.current);
    i.current = c === "mounted" ? p : "none";
  }, [c]), be(() => {
    const p = r.current, m = o.current;
    if (m !== e) {
      const C = i.current, x = Ds(p);
      e ? f("MOUNT") : x === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && C !== x ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), be(() => {
    if (t) {
      let p;
      const m = t.ownerDocument.defaultView ?? window, v = (x) => {
        const h = Ds(r.current).includes(x.animationName);
        if (x.target === t && h && (f("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, C = (x) => {
        x.target === t && (i.current = Ds(r.current));
      };
      return t.addEventListener("animationstart", C), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        m.clearTimeout(p), t.removeEventListener("animationstart", C), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: d.useCallback((p) => {
      p && (r.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function Ds(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function ZI(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Bd = 0;
function XI() {
  d.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? T0()), document.body.insertAdjacentElement("beforeend", e[1] ?? T0()), Bd++, () => {
      Bd === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Bd--;
    };
  }, []);
}
function T0() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var D4 = W1(), Vd = function() {
}, oc = d.forwardRef(function(e, t) {
  var n = d.useRef(null), r = d.useState({
    onScrollCapture: Vd,
    onWheelCapture: Vd,
    onTouchMoveCapture: Vd
  }), o = r[0], i = r[1], l = e.forwardProps, c = e.children, f = e.className, p = e.removeScrollBar, m = e.enabled, v = e.shards, C = e.sideCar, x = e.noIsolation, y = e.inert, h = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, N = e.gapMode, _ = Hn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), P = C, A = V1([n, t]), I = Ae(Ae({}, _), o);
  return d.createElement(
    d.Fragment,
    null,
    m && d.createElement(P, { sideCar: D4, removeScrollBar: p, shards: v, noIsolation: x, inert: y, setCallbacks: i, allowPinchZoom: !!h, lockRef: n, gapMode: N }),
    l ? d.cloneElement(d.Children.only(c), Ae(Ae({}, I), { ref: A })) : d.createElement(w, Ae({}, I, { className: f, ref: A }), c)
  );
});
oc.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
oc.classNames = {
  fullWidth: li,
  zeroRight: si
};
var $f = !1;
if (typeof window < "u")
  try {
    var Fs = Object.defineProperty({}, "passive", {
      get: function() {
        return $f = !0, !0;
      }
    });
    window.addEventListener("test", Fs, Fs), window.removeEventListener("test", Fs, Fs);
  } catch {
    $f = !1;
  }
var Zo = $f ? { passive: !1 } : !1, jI = function(e) {
  return e.tagName === "TEXTAREA";
}, F4 = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !jI(e) && n[t] === "visible")
  );
}, QI = function(e) {
  return F4(e, "overflowY");
}, JI = function(e) {
  return F4(e, "overflowX");
}, $0 = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = B4(e, r);
    if (o) {
      var i = V4(e, r), l = i[1], c = i[2];
      if (l > c)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, eO = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, tO = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, B4 = function(e, t) {
  return e === "v" ? QI(t) : JI(t);
}, V4 = function(e, t) {
  return e === "v" ? eO(t) : tO(t);
}, nO = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, rO = function(e, t, n, r, o) {
  var i = nO(e, window.getComputedStyle(t).direction), l = i * r, c = n.target, f = t.contains(c), p = !1, m = l > 0, v = 0, C = 0;
  do {
    var x = V4(e, c), y = x[0], h = x[1], b = x[2], w = h - b - i * y;
    (y || w) && B4(e, c) && (v += w, C += y), c instanceof ShadowRoot ? c = c.host : c = c.parentNode;
  } while (
    // portaled content
    !f && c !== document.body || // self content
    f && (t.contains(c) || t === c)
  );
  return (m && (Math.abs(v) < 1 || !o) || !m && (Math.abs(C) < 1 || !o)) && (p = !0), p;
}, Bs = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, L0 = function(e) {
  return [e.deltaX, e.deltaY];
}, M0 = function(e) {
  return e && "current" in e ? e.current : e;
}, oO = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, iO = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, aO = 0, Xo = [];
function sO(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), o = d.useState(aO++)[0], i = d.useState(Zl)[0], l = d.useRef(e);
  d.useEffect(function() {
    l.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = wi([e.lockRef.current], (e.shards || []).map(M0), !0).filter(Boolean);
      return h.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = d.useCallback(function(h, b) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !l.current.allowPinchZoom;
    var w = Bs(h), N = n.current, _ = "deltaX" in h ? h.deltaX : N[0] - w[0], P = "deltaY" in h ? h.deltaY : N[1] - w[1], A, I = h.target, T = Math.abs(_) > Math.abs(P) ? "h" : "v";
    if ("touches" in h && T === "h" && I.type === "range")
      return !1;
    var M = $0(T, I);
    if (!M)
      return !0;
    if (M ? A = T : (A = T === "v" ? "h" : "v", M = $0(T, I)), !M)
      return !1;
    if (!r.current && "changedTouches" in h && (_ || P) && (r.current = A), !A)
      return !0;
    var D = r.current || A;
    return rO(D, b, h, D === "h" ? _ : P, !0);
  }, []), f = d.useCallback(function(h) {
    var b = h;
    if (!(!Xo.length || Xo[Xo.length - 1] !== i)) {
      var w = "deltaY" in b ? L0(b) : Bs(b), N = t.current.filter(function(A) {
        return A.name === b.type && (A.target === b.target || b.target === A.shadowParent) && oO(A.delta, w);
      })[0];
      if (N && N.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!N) {
        var _ = (l.current.shards || []).map(M0).filter(Boolean).filter(function(A) {
          return A.contains(b.target);
        }), P = _.length > 0 ? c(b, _[0]) : !l.current.noIsolation;
        P && b.cancelable && b.preventDefault();
      }
    }
  }, []), p = d.useCallback(function(h, b, w, N) {
    var _ = { name: h, delta: b, target: w, should: N, shadowParent: lO(w) };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(P) {
        return P !== _;
      });
    }, 1);
  }, []), m = d.useCallback(function(h) {
    n.current = Bs(h), r.current = void 0;
  }, []), v = d.useCallback(function(h) {
    p(h.type, L0(h), h.target, c(h, e.lockRef.current));
  }, []), C = d.useCallback(function(h) {
    p(h.type, Bs(h), h.target, c(h, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return Xo.push(i), e.setCallbacks({
      onScrollCapture: v,
      onWheelCapture: v,
      onTouchMoveCapture: C
    }), document.addEventListener("wheel", f, Zo), document.addEventListener("touchmove", f, Zo), document.addEventListener("touchstart", m, Zo), function() {
      Xo = Xo.filter(function(h) {
        return h !== i;
      }), document.removeEventListener("wheel", f, Zo), document.removeEventListener("touchmove", f, Zo), document.removeEventListener("touchstart", m, Zo);
    };
  }, []);
  var x = e.removeScrollBar, y = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    y ? d.createElement(i, { styles: iO(o) }) : null,
    x ? d.createElement(U1, { gapMode: e.gapMode }) : null
  );
}
function lO(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const cO = H1(D4, sO);
var W4 = d.forwardRef(function(e, t) {
  return d.createElement(oc, Ae({}, e, { ref: t, sideCar: cO }));
});
W4.classNames = oc.classNames;
var tp = "Dialog", [H4, QY] = TI(tp), [uO, Ln] = H4(tp), U4 = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: l = !0
  } = e, c = d.useRef(null), f = d.useRef(null), [p = !1, m] = et({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ s(
    uO,
    {
      scope: t,
      triggerRef: c,
      contentRef: f,
      contentId: it(),
      titleId: it(),
      descriptionId: it(),
      open: p,
      onOpenChange: m,
      onOpenToggle: d.useCallback(() => m((v) => !v), [m]),
      modal: l,
      children: n
    }
  );
};
U4.displayName = tp;
var G4 = "DialogTrigger", z4 = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ln(G4, n), i = ke(t, o.triggerRef);
    return /* @__PURE__ */ s(
      ve.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": op(o.open),
        ...r,
        ref: i,
        onClick: he(e.onClick, o.onOpenToggle)
      }
    );
  }
);
z4.displayName = G4;
var np = "DialogPortal", [dO, q4] = H4(np, {
  forceMount: void 0
}), K4 = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = Ln(np, t);
  return /* @__PURE__ */ s(dO, { scope: t, forceMount: n, children: d.Children.map(r, (l) => /* @__PURE__ */ s(rc, { present: n || i.open, children: /* @__PURE__ */ s(k4, { asChild: !0, container: o, children: l }) })) });
};
K4.displayName = np;
var gl = "DialogOverlay", Y4 = d.forwardRef(
  (e, t) => {
    const n = q4(gl, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Ln(gl, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ s(rc, { present: r || i.open, children: /* @__PURE__ */ s(fO, { ...o, ref: t }) }) : null;
  }
);
Y4.displayName = gl;
var fO = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ln(gl, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ s(W4, { as: mi, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ s(
        ve.div,
        {
          "data-state": op(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), vo = "DialogContent", Z4 = d.forwardRef(
  (e, t) => {
    const n = q4(vo, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Ln(vo, e.__scopeDialog);
    return /* @__PURE__ */ s(rc, { present: r || i.open, children: i.modal ? /* @__PURE__ */ s(pO, { ...o, ref: t }) : /* @__PURE__ */ s(mO, { ...o, ref: t }) });
  }
);
Z4.displayName = vo;
var pO = d.forwardRef(
  (e, t) => {
    const n = Ln(vo, e.__scopeDialog), r = d.useRef(null), o = ke(t, n.contentRef, r);
    return d.useEffect(() => {
      const i = r.current;
      if (i) return Si(i);
    }, []), /* @__PURE__ */ s(
      X4,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: he(e.onCloseAutoFocus, (i) => {
          var l;
          i.preventDefault(), (l = n.triggerRef.current) == null || l.focus();
        }),
        onPointerDownOutside: he(e.onPointerDownOutside, (i) => {
          const l = i.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0;
          (l.button === 2 || c) && i.preventDefault();
        }),
        onFocusOutside: he(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), mO = d.forwardRef(
  (e, t) => {
    const n = Ln(vo, e.__scopeDialog), r = d.useRef(!1), o = d.useRef(!1);
    return /* @__PURE__ */ s(
      X4,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var l, c;
          (l = e.onCloseAutoFocus) == null || l.call(e, i), i.defaultPrevented || (r.current || (c = n.triggerRef.current) == null || c.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var f, p;
          (f = e.onInteractOutside) == null || f.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const l = i.target;
          ((p = n.triggerRef.current) == null ? void 0 : p.contains(l)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), X4 = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...l } = e, c = Ln(vo, n), f = d.useRef(null), p = ke(t, f);
    return XI(), /* @__PURE__ */ R(le, { children: [
      /* @__PURE__ */ s(
        ep,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ s(
            M4,
            {
              role: "dialog",
              id: c.contentId,
              "aria-describedby": c.descriptionId,
              "aria-labelledby": c.titleId,
              "data-state": op(c.open),
              ...l,
              ref: p,
              onDismiss: () => c.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ R(le, { children: [
        /* @__PURE__ */ s(hO, { titleId: c.titleId }),
        /* @__PURE__ */ s(vO, { contentRef: f, descriptionId: c.descriptionId })
      ] })
    ] });
  }
), rp = "DialogTitle", j4 = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ln(rp, n);
    return /* @__PURE__ */ s(ve.h2, { id: o.titleId, ...r, ref: t });
  }
);
j4.displayName = rp;
var Q4 = "DialogDescription", J4 = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ln(Q4, n);
    return /* @__PURE__ */ s(ve.p, { id: o.descriptionId, ...r, ref: t });
  }
);
J4.displayName = Q4;
var e5 = "DialogClose", t5 = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ln(e5, n);
    return /* @__PURE__ */ s(
      ve.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: he(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
t5.displayName = e5;
function op(e) {
  return e ? "open" : "closed";
}
var n5 = "DialogTitleWarning", [JY, r5] = AI(n5, {
  contentName: vo,
  titleName: rp,
  docsSlug: "dialog"
}), hO = ({ titleId: e }) => {
  const t = r5(n5), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return d.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, gO = "DialogDescriptionWarning", vO = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${r5(gO).contentName}}.`;
  return d.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, o5 = U4, i5 = z4, a5 = K4, ic = Y4, ac = Z4, wa = j4, sc = J4, lc = t5;
const s5 = o5, eZ = i5, CO = a5, tZ = lc, l5 = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  ic,
  {
    ref: n,
    className: F(
      "bg-background/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 backdrop-blur-xs fixed inset-0 z-50",
      e
    ),
    ...t
  }
));
l5.displayName = ic.displayName;
const ip = q(
  ({
    className: e,
    children: t,
    disableAnimation: n,
    hideCloseButton: r,
    portalContainer: o,
    ...i
  }, l) => /* @__PURE__ */ R(CO, { container: o, children: [
    /* @__PURE__ */ s(l5, {}),
    /* @__PURE__ */ R(
      ac,
      {
        ref: l,
        className: F(
          "bg-background border-border fixed left-[50%] top-[50%] z-50 grid translate-x-[-50%] translate-y-[-50%] gap-4 border shadow-lg sm:rounded-lg",
          !n && "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-top-[48%] duration-200",
          "w-full max-w-[calc(100%-2.25rem)] p-6 md:max-w-lg",
          e
        ),
        ...i,
        children: [
          t,
          r ? null : /* @__PURE__ */ R(lc, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground rounded-xs focus:outline-hidden absolute right-4 top-4 opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none", children: [
            /* @__PURE__ */ s(Ll, { className: "h-4 w-4" }),
            /* @__PURE__ */ s("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] })
);
ip.displayName = ac.displayName;
const xO = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  "div",
  {
    className: F(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      e
    ),
    ...t
  }
);
xO.displayName = "DialogHeader";
const c5 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  "div",
  {
    className: F(
      "flex flex-col-reverse gap-3 sm:flex-row sm:justify-end",
      e
    ),
    ...t
  }
);
c5.displayName = "DialogFooter";
const u5 = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  wa,
  {
    ref: n,
    className: F(
      "text-headingxl leading-none tracking-tight",
      e
    ),
    ...t
  }
));
u5.displayName = wa.displayName;
const bO = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  sc,
  {
    ref: n,
    className: F("text-muted-foreground text-sm", e),
    ...t
  }
));
bO.displayName = sc.displayName;
const yO = "data:image/svg+xml,%3csvg%20width='63'%20height='63'%20viewBox='0%200%2063%2063'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M43.6098%2014.4513L40.9935%2017.0676L39.3672%2015.4413L46.2968%208.51164L47.9232%2010.138L45.3069%2012.7543L52.5901%2020.0375L50.893%2021.7345L43.6098%2014.4513Z'%20fill='black'%20fill-opacity='0.04'/%3e%3cpath%20d='M32.8652%2021.9434L38.8049%2016.0037L40.4313%2017.63L36.1886%2021.8726L38.3807%2024.0647L41.8455%2020.5999L43.4718%2022.2262L40.007%2025.691L43.4718%2029.1558L41.7748%2030.8529L32.8652%2021.9434Z'%20fill='black'%20fill-opacity='0.04'/%3e%3cpath%20d='M27.1335%2027.6754L28.6891%2026.1197L40.922%2031.7059L39.1543%2033.4737L36.6794%2032.2716L33.2853%2035.6657L34.4874%2038.1406L32.7196%2039.9083L27.1335%2027.6754ZM34.5581%2031.2816L30.174%2029.1603L32.2953%2033.5444L34.5581%2031.2816Z'%20fill='black'%20fill-opacity='0.04'/%3e%3cpath%20d='M16.8862%2037.9223L20.4218%2034.3868C20.846%2033.9625%2021.3127%2033.6467%2021.8218%2033.4392C22.331%2033.213%2022.8448%2033.0951%2023.3633%2033.0857C23.8819%2033.0763%2024.3863%2033.1658%2024.8765%2033.3544C25.3574%2033.5335%2025.7816%2033.8069%2026.1493%2034.1746C26.649%2034.6743%2026.9649%2035.1882%2027.0969%2035.7161C27.2288%2036.2441%2027.276%2036.7344%2027.2383%2037.1869C27.2006%2037.7149%2027.0733%2038.2193%2026.8564%2038.7001L32.5133%2040.1143L30.6041%2042.0235L25.5129%2040.6093L24.2401%2041.8821L27.4928%2045.1348L25.7958%2046.8318L16.8862%2037.9223ZM24.4523%2038.4173C24.8105%2038.059%2024.9944%2037.6395%2025.0038%2037.1586C25.0038%2036.6684%2024.8435%2036.263%2024.523%2035.9424C24.2024%2035.6218%2023.8017%2035.4663%2023.3209%2035.4757C22.8306%2035.4757%2022.4064%2035.6548%2022.0481%2036.0131L20.2096%2037.8516L22.6138%2040.2558L24.4523%2038.4173Z'%20fill='black'%20fill-opacity='0.04'/%3e%3cpath%20d='M8.32373%2046.4849L11.1522%2043.6565C11.7367%2043.072%2012.4155%2042.6383%2013.1886%2042.3554C13.9523%2042.0632%2014.7395%2041.917%2015.5504%2041.917C16.3612%2041.917%2017.1531%2042.0679%2017.9262%2042.3696C18.6993%2042.6713%2019.3876%2043.1238%2019.991%2043.7272C20.5944%2044.3306%2021.0469%2045.0189%2021.3486%2045.792C21.6503%2046.5651%2021.8012%2047.357%2021.8012%2048.1678C21.8012%2048.9787%2021.6598%2049.7706%2021.3769%2050.5437C21.0847%2051.3074%2020.6462%2051.9815%2020.0617%2052.566L17.2333%2055.3945L8.32373%2046.4849ZM18.4354%2050.9397C18.7842%2050.5909%2019.0435%2050.1807%2019.2132%2049.7093C19.3923%2049.2285%2019.4772%2048.7382%2019.4677%2048.2385C19.4677%2047.7294%2019.3687%2047.2345%2019.1707%2046.7536C18.9728%2046.2539%2018.6805%2045.8108%2018.2939%2045.4243C17.9074%2045.0377%2017.469%2044.7502%2016.9787%2044.5616C16.4885%2044.3542%2015.9888%2044.2505%2015.4797%2044.2505C14.98%2044.241%2014.4897%2044.3259%2014.0089%2044.505C13.5375%2044.6747%2013.1273%2044.934%2012.7785%2045.2828L11.6471%2046.4142L17.304%2052.0711L18.4354%2050.9397Z'%20fill='black'%20fill-opacity='0.04'/%3e%3c/svg%3e";
function wO() {
  return /* @__PURE__ */ s(
    "div",
    {
      className: "absolute inset-0",
      style: {
        backgroundImage: `url("${yO}")`,
        backgroundSize: "100px 100px",
        pointerEvents: "none"
      }
    }
  );
}
function vl(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function I0(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function d5(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = I0(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : I0(e[o], null);
        }
      };
  };
}
function SO(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    const p = (v) => {
      var w;
      const { scope: C, children: x, ...y } = v, h = ((w = C == null ? void 0 : C[e]) == null ? void 0 : w[f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    };
    p.displayName = i + "Provider";
    function m(v, C) {
      var h;
      const x = ((h = C == null ? void 0 : C[e]) == null ? void 0 : h[f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, NO(o, ...t)];
}
function NO(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var f5 = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = d.Children.toArray(n), i = o.find(RO);
  if (i) {
    const l = i.props.children, c = o.map((f) => f === i ? d.Children.count(l) > 1 ? d.Children.only(null) : d.isValidElement(l) ? l.props.children : null : f);
    return /* @__PURE__ */ s(Lf, { ...r, ref: t, children: d.isValidElement(l) ? d.cloneElement(l, void 0, c) : null });
  }
  return /* @__PURE__ */ s(Lf, { ...r, ref: t, children: n });
});
f5.displayName = "Slot";
var Lf = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const o = PO(n);
    return d.cloneElement(n, {
      ...EO(r, n.props),
      // @ts-ignore
      ref: t ? d5(t, o) : o
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
Lf.displayName = "SlotClone";
var _O = ({ children: e }) => /* @__PURE__ */ s(le, { children: e });
function RO(e) {
  return d.isValidElement(e) && e.type === _O;
}
function EO(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function PO(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var AO = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], TO = AO.reduce((e, t) => {
  const n = d.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, c = i ? f5 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(c, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Xe(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function cc(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    const p = (v) => {
      var w;
      const { scope: C, children: x, ...y } = v, h = ((w = C == null ? void 0 : C[e]) == null ? void 0 : w[f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    };
    p.displayName = i + "Provider";
    function m(v, C) {
      var h;
      const x = ((h = C == null ? void 0 : C[e]) == null ? void 0 : h[f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, $O(o, ...t)];
}
function $O(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function O0(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function ap(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = O0(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : O0(e[o], null);
        }
      };
  };
}
function Gt(...e) {
  return d.useCallback(ap(...e), e);
}
var ca = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = d.Children.toArray(n), i = o.find(MO);
  if (i) {
    const l = i.props.children, c = o.map((f) => f === i ? d.Children.count(l) > 1 ? d.Children.only(null) : d.isValidElement(l) ? l.props.children : null : f);
    return /* @__PURE__ */ s(Mf, { ...r, ref: t, children: d.isValidElement(l) ? d.cloneElement(l, void 0, c) : null });
  }
  return /* @__PURE__ */ s(Mf, { ...r, ref: t, children: n });
});
ca.displayName = "Slot";
var Mf = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const o = OO(n);
    return d.cloneElement(n, {
      ...IO(r, n.props),
      // @ts-ignore
      ref: t ? ap(t, o) : o
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
Mf.displayName = "SlotClone";
var LO = ({ children: e }) => /* @__PURE__ */ s(le, { children: e });
function MO(e) {
  return d.isValidElement(e) && e.type === LO;
}
function IO(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function OO(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function p5(e) {
  const t = e + "CollectionProvider", [n, r] = cc(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), l = (x) => {
    const { scope: y, children: h } = x, b = ae.useRef(null), w = ae.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ s(o, { scope: y, itemMap: w, collectionRef: b, children: h });
  };
  l.displayName = t;
  const c = e + "CollectionSlot", f = ae.forwardRef(
    (x, y) => {
      const { scope: h, children: b } = x, w = i(c, h), N = Gt(y, w.collectionRef);
      return /* @__PURE__ */ s(ca, { ref: N, children: b });
    }
  );
  f.displayName = c;
  const p = e + "CollectionItemSlot", m = "data-radix-collection-item", v = ae.forwardRef(
    (x, y) => {
      const { scope: h, children: b, ...w } = x, N = ae.useRef(null), _ = Gt(y, N), P = i(p, h);
      return ae.useEffect(() => (P.itemMap.set(N, { ref: N, ...w }), () => void P.itemMap.delete(N))), /* @__PURE__ */ s(ca, { [m]: "", ref: _, children: b });
    }
  );
  v.displayName = p;
  function C(x) {
    const y = i(e + "CollectionConsumer", x);
    return ae.useCallback(() => {
      const b = y.collectionRef.current;
      if (!b) return [];
      const w = Array.from(b.querySelectorAll(`[${m}]`));
      return Array.from(y.itemMap.values()).sort(
        (P, A) => w.indexOf(P.ref.current) - w.indexOf(A.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: l, Slot: f, ItemSlot: v },
    C,
    r
  ];
}
var kO = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], qt = kO.reduce((e, t) => {
  const n = d.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, c = i ? ca : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(c, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function m5(e, t) {
  e && Tn.flushSync(() => e.dispatchEvent(t));
}
var DO = "DismissableLayer", If = "dismissableLayer.update", FO = "dismissableLayer.pointerDownOutside", BO = "dismissableLayer.focusOutside", k0, h5 = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), g5 = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: l,
      onDismiss: c,
      ...f
    } = e, p = d.useContext(h5), [m, v] = d.useState(null), C = (m == null ? void 0 : m.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, x] = d.useState({}), y = Gt(t, (T) => v(T)), h = Array.from(p.layers), [b] = [...p.layersWithOutsidePointerEventsDisabled].slice(-1), w = h.indexOf(b), N = m ? h.indexOf(m) : -1, _ = p.layersWithOutsidePointerEventsDisabled.size > 0, P = N >= w, A = HO((T) => {
      const M = T.target, D = [...p.branches].some((W) => W.contains(M));
      !P || D || (o == null || o(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C), I = UO((T) => {
      const M = T.target;
      [...p.branches].some((W) => W.contains(M)) || (i == null || i(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C);
    return Wr((T) => {
      N === p.layers.size - 1 && (r == null || r(T), !T.defaultPrevented && c && (T.preventDefault(), c()));
    }, C), d.useEffect(() => {
      if (m)
        return n && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (k0 = C.body.style.pointerEvents, C.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(m)), p.layers.add(m), D0(), () => {
          n && p.layersWithOutsidePointerEventsDisabled.size === 1 && (C.body.style.pointerEvents = k0);
        };
    }, [m, C, n, p]), d.useEffect(() => () => {
      m && (p.layers.delete(m), p.layersWithOutsidePointerEventsDisabled.delete(m), D0());
    }, [m, p]), d.useEffect(() => {
      const T = () => x({});
      return document.addEventListener(If, T), () => document.removeEventListener(If, T);
    }, []), /* @__PURE__ */ s(
      qt.div,
      {
        ...f,
        ref: y,
        style: {
          pointerEvents: _ ? P ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Xe(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: Xe(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: Xe(
          e.onPointerDownCapture,
          A.onPointerDownCapture
        )
      }
    );
  }
);
g5.displayName = DO;
var VO = "DismissableLayerBranch", WO = d.forwardRef((e, t) => {
  const n = d.useContext(h5), r = d.useRef(null), o = Gt(t, r);
  return d.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ s(qt.div, { ...e, ref: o });
});
WO.displayName = VO;
function HO(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1), o = d.useRef(() => {
  });
  return d.useEffect(() => {
    const i = (c) => {
      if (c.target && !r.current) {
        let f = function() {
          v5(
            FO,
            n,
            p,
            { discrete: !0 }
          );
        };
        const p = { originalEvent: c };
        c.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = f, t.addEventListener("click", o.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function UO(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && v5(BO, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function D0() {
  const e = new CustomEvent(If);
  document.dispatchEvent(e);
}
function v5(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? m5(o, i) : o.dispatchEvent(i);
}
var Wd = "focusScope.autoFocusOnMount", Hd = "focusScope.autoFocusOnUnmount", F0 = { bubbles: !1, cancelable: !0 }, GO = "FocusScope", C5 = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...l
  } = e, [c, f] = d.useState(null), p = xe(o), m = xe(i), v = d.useRef(null), C = Gt(t, (h) => f(h)), x = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (r) {
      let h = function(_) {
        if (x.paused || !c) return;
        const P = _.target;
        c.contains(P) ? v.current = P : Rr(v.current, { select: !0 });
      }, b = function(_) {
        if (x.paused || !c) return;
        const P = _.relatedTarget;
        P !== null && (c.contains(P) || Rr(v.current, { select: !0 }));
      }, w = function(_) {
        if (document.activeElement === document.body)
          for (const A of _)
            A.removedNodes.length > 0 && Rr(c);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", b);
      const N = new MutationObserver(w);
      return c && N.observe(c, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", b), N.disconnect();
      };
    }
  }, [r, c, x.paused]), d.useEffect(() => {
    if (c) {
      V0.add(x);
      const h = document.activeElement;
      if (!c.contains(h)) {
        const w = new CustomEvent(Wd, F0);
        c.addEventListener(Wd, p), c.dispatchEvent(w), w.defaultPrevented || (zO(XO(x5(c)), { select: !0 }), document.activeElement === h && Rr(c));
      }
      return () => {
        c.removeEventListener(Wd, p), setTimeout(() => {
          const w = new CustomEvent(Hd, F0);
          c.addEventListener(Hd, m), c.dispatchEvent(w), w.defaultPrevented || Rr(h ?? document.body, { select: !0 }), c.removeEventListener(Hd, m), V0.remove(x);
        }, 0);
      };
    }
  }, [c, p, m, x]);
  const y = d.useCallback(
    (h) => {
      if (!n && !r || x.paused) return;
      const b = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, w = document.activeElement;
      if (b && w) {
        const N = h.currentTarget, [_, P] = qO(N);
        _ && P ? !h.shiftKey && w === P ? (h.preventDefault(), n && Rr(_, { select: !0 })) : h.shiftKey && w === _ && (h.preventDefault(), n && Rr(P, { select: !0 })) : w === N && h.preventDefault();
      }
    },
    [n, r, x.paused]
  );
  return /* @__PURE__ */ s(qt.div, { tabIndex: -1, ...l, ref: C, onKeyDown: y });
});
C5.displayName = GO;
function zO(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Rr(r, { select: t }), document.activeElement !== n) return;
}
function qO(e) {
  const t = x5(e), n = B0(t, e), r = B0(t.reverse(), e);
  return [n, r];
}
function x5(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function B0(e, t) {
  for (const n of e)
    if (!KO(n, { upTo: t })) return n;
}
function KO(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function YO(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Rr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && YO(e) && t && e.select();
  }
}
var V0 = ZO();
function ZO() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = W0(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = W0(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function W0(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function XO(e) {
  return e.filter((t) => t.tagName !== "A");
}
const jO = ["top", "right", "bottom", "left"], Dn = Math.min, en = Math.max, Cl = Math.round, Vs = Math.floor, kr = (e) => ({
  x: e,
  y: e
}), QO = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, JO = {
  start: "end",
  end: "start"
};
function Of(e, t, n) {
  return en(e, Dn(t, n));
}
function ir(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ar(e) {
  return e.split("-")[0];
}
function _i(e) {
  return e.split("-")[1];
}
function sp(e) {
  return e === "x" ? "y" : "x";
}
function lp(e) {
  return e === "y" ? "height" : "width";
}
function Dr(e) {
  return ["top", "bottom"].includes(ar(e)) ? "y" : "x";
}
function cp(e) {
  return sp(Dr(e));
}
function ek(e, t, n) {
  n === void 0 && (n = !1);
  const r = _i(e), o = cp(e), i = lp(o);
  let l = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (l = xl(l)), [l, xl(l)];
}
function tk(e) {
  const t = xl(e);
  return [kf(e), t, kf(t)];
}
function kf(e) {
  return e.replace(/start|end/g, (t) => JO[t]);
}
function nk(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], l = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : l;
    default:
      return [];
  }
}
function rk(e, t, n, r) {
  const o = _i(e);
  let i = nk(ar(e), n === "start", r);
  return o && (i = i.map((l) => l + "-" + o), t && (i = i.concat(i.map(kf)))), i;
}
function xl(e) {
  return e.replace(/left|right|bottom|top/g, (t) => QO[t]);
}
function ok(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function b5(e) {
  return typeof e != "number" ? ok(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function bl(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function H0(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = Dr(t), l = cp(t), c = lp(l), f = ar(t), p = i === "y", m = r.x + r.width / 2 - o.width / 2, v = r.y + r.height / 2 - o.height / 2, C = r[c] / 2 - o[c] / 2;
  let x;
  switch (f) {
    case "top":
      x = {
        x: m,
        y: r.y - o.height
      };
      break;
    case "bottom":
      x = {
        x: m,
        y: r.y + r.height
      };
      break;
    case "right":
      x = {
        x: r.x + r.width,
        y: v
      };
      break;
    case "left":
      x = {
        x: r.x - o.width,
        y: v
      };
      break;
    default:
      x = {
        x: r.x,
        y: r.y
      };
  }
  switch (_i(t)) {
    case "start":
      x[l] -= C * (n && p ? -1 : 1);
      break;
    case "end":
      x[l] += C * (n && p ? -1 : 1);
      break;
  }
  return x;
}
const ik = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: l
  } = n, c = i.filter(Boolean), f = await (l.isRTL == null ? void 0 : l.isRTL(t));
  let p = await l.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: m,
    y: v
  } = H0(p, r, f), C = r, x = {}, y = 0;
  for (let h = 0; h < c.length; h++) {
    const {
      name: b,
      fn: w
    } = c[h], {
      x: N,
      y: _,
      data: P,
      reset: A
    } = await w({
      x: m,
      y: v,
      initialPlacement: r,
      placement: C,
      strategy: o,
      middlewareData: x,
      rects: p,
      platform: l,
      elements: {
        reference: e,
        floating: t
      }
    });
    m = N ?? m, v = _ ?? v, x = {
      ...x,
      [b]: {
        ...x[b],
        ...P
      }
    }, A && y <= 50 && (y++, typeof A == "object" && (A.placement && (C = A.placement), A.rects && (p = A.rects === !0 ? await l.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : A.rects), {
      x: m,
      y: v
    } = H0(p, C, f)), h = -1);
  }
  return {
    x: m,
    y: v,
    placement: C,
    strategy: o,
    middlewareData: x
  };
};
async function ua(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: l,
    elements: c,
    strategy: f
  } = e, {
    boundary: p = "clippingAncestors",
    rootBoundary: m = "viewport",
    elementContext: v = "floating",
    altBoundary: C = !1,
    padding: x = 0
  } = ir(t, e), y = b5(x), b = c[C ? v === "floating" ? "reference" : "floating" : v], w = bl(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(b))) == null || n ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(c.floating)),
    boundary: p,
    rootBoundary: m,
    strategy: f
  })), N = v === "floating" ? {
    x: r,
    y: o,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c.floating)), P = await (i.isElement == null ? void 0 : i.isElement(_)) ? await (i.getScale == null ? void 0 : i.getScale(_)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, A = bl(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: N,
    offsetParent: _,
    strategy: f
  }) : N);
  return {
    top: (w.top - A.top + y.top) / P.y,
    bottom: (A.bottom - w.bottom + y.bottom) / P.y,
    left: (w.left - A.left + y.left) / P.x,
    right: (A.right - w.right + y.right) / P.x
  };
}
const ak = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: l,
      elements: c,
      middlewareData: f
    } = t, {
      element: p,
      padding: m = 0
    } = ir(e, t) || {};
    if (p == null)
      return {};
    const v = b5(m), C = {
      x: n,
      y: r
    }, x = cp(o), y = lp(x), h = await l.getDimensions(p), b = x === "y", w = b ? "top" : "left", N = b ? "bottom" : "right", _ = b ? "clientHeight" : "clientWidth", P = i.reference[y] + i.reference[x] - C[x] - i.floating[y], A = C[x] - i.reference[x], I = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(p));
    let T = I ? I[_] : 0;
    (!T || !await (l.isElement == null ? void 0 : l.isElement(I))) && (T = c.floating[_] || i.floating[y]);
    const M = P / 2 - A / 2, D = T / 2 - h[y] / 2 - 1, W = Dn(v[w], D), U = Dn(v[N], D), re = W, j = T - h[y] - U, X = T / 2 - h[y] / 2 + M, oe = Of(re, X, j), G = !f.arrow && _i(o) != null && X !== oe && i.reference[y] / 2 - (X < re ? W : U) - h[y] / 2 < 0, Q = G ? X < re ? X - re : X - j : 0;
    return {
      [x]: C[x] + Q,
      data: {
        [x]: oe,
        centerOffset: X - oe - Q,
        ...G && {
          alignmentOffset: Q
        }
      },
      reset: G
    };
  }
}), sk = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: l,
        initialPlacement: c,
        platform: f,
        elements: p
      } = t, {
        mainAxis: m = !0,
        crossAxis: v = !0,
        fallbackPlacements: C,
        fallbackStrategy: x = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: h = !0,
        ...b
      } = ir(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const w = ar(o), N = Dr(c), _ = ar(c) === c, P = await (f.isRTL == null ? void 0 : f.isRTL(p.floating)), A = C || (_ || !h ? [xl(c)] : tk(c)), I = y !== "none";
      !C && I && A.push(...rk(c, h, y, P));
      const T = [c, ...A], M = await ua(t, b), D = [];
      let W = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (m && D.push(M[w]), v) {
        const X = ek(o, l, P);
        D.push(M[X[0]], M[X[1]]);
      }
      if (W = [...W, {
        placement: o,
        overflows: D
      }], !D.every((X) => X <= 0)) {
        var U, re;
        const X = (((U = i.flip) == null ? void 0 : U.index) || 0) + 1, oe = T[X];
        if (oe)
          return {
            data: {
              index: X,
              overflows: W
            },
            reset: {
              placement: oe
            }
          };
        let G = (re = W.filter((Q) => Q.overflows[0] <= 0).sort((Q, te) => Q.overflows[1] - te.overflows[1])[0]) == null ? void 0 : re.placement;
        if (!G)
          switch (x) {
            case "bestFit": {
              var j;
              const Q = (j = W.filter((te) => {
                if (I) {
                  const ee = Dr(te.placement);
                  return ee === N || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ee === "y";
                }
                return !0;
              }).map((te) => [te.placement, te.overflows.filter((ee) => ee > 0).reduce((ee, Pe) => ee + Pe, 0)]).sort((te, ee) => te[1] - ee[1])[0]) == null ? void 0 : j[0];
              Q && (G = Q);
              break;
            }
            case "initialPlacement":
              G = c;
              break;
          }
        if (o !== G)
          return {
            reset: {
              placement: G
            }
          };
      }
      return {};
    }
  };
};
function U0(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function G0(e) {
  return jO.some((t) => e[t] >= 0);
}
const lk = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = ir(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await ua(t, {
            ...o,
            elementContext: "reference"
          }), l = U0(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: l,
              referenceHidden: G0(l)
            }
          };
        }
        case "escaped": {
          const i = await ua(t, {
            ...o,
            altBoundary: !0
          }), l = U0(i, n.floating);
          return {
            data: {
              escapedOffsets: l,
              escaped: G0(l)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function ck(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), l = ar(n), c = _i(n), f = Dr(n) === "y", p = ["left", "top"].includes(l) ? -1 : 1, m = i && f ? -1 : 1, v = ir(t, e);
  let {
    mainAxis: C,
    crossAxis: x,
    alignmentAxis: y
  } = typeof v == "number" ? {
    mainAxis: v,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...v
  };
  return c && typeof y == "number" && (x = c === "end" ? y * -1 : y), f ? {
    x: x * m,
    y: C * p
  } : {
    x: C * p,
    y: x * m
  };
}
const uk = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: l,
        middlewareData: c
      } = t, f = await ck(t, e);
      return l === ((n = c.offset) == null ? void 0 : n.placement) && (r = c.arrow) != null && r.alignmentOffset ? {} : {
        x: o + f.x,
        y: i + f.y,
        data: {
          ...f,
          placement: l
        }
      };
    }
  };
}, dk = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: l = !1,
        limiter: c = {
          fn: (b) => {
            let {
              x: w,
              y: N
            } = b;
            return {
              x: w,
              y: N
            };
          }
        },
        ...f
      } = ir(e, t), p = {
        x: n,
        y: r
      }, m = await ua(t, f), v = Dr(ar(o)), C = sp(v);
      let x = p[C], y = p[v];
      if (i) {
        const b = C === "y" ? "top" : "left", w = C === "y" ? "bottom" : "right", N = x + m[b], _ = x - m[w];
        x = Of(N, x, _);
      }
      if (l) {
        const b = v === "y" ? "top" : "left", w = v === "y" ? "bottom" : "right", N = y + m[b], _ = y - m[w];
        y = Of(N, y, _);
      }
      const h = c.fn({
        ...t,
        [C]: x,
        [v]: y
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - r
        }
      };
    }
  };
}, fk = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: l
      } = t, {
        offset: c = 0,
        mainAxis: f = !0,
        crossAxis: p = !0
      } = ir(e, t), m = {
        x: n,
        y: r
      }, v = Dr(o), C = sp(v);
      let x = m[C], y = m[v];
      const h = ir(c, t), b = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (f) {
        const _ = C === "y" ? "height" : "width", P = i.reference[C] - i.floating[_] + b.mainAxis, A = i.reference[C] + i.reference[_] - b.mainAxis;
        x < P ? x = P : x > A && (x = A);
      }
      if (p) {
        var w, N;
        const _ = C === "y" ? "width" : "height", P = ["top", "left"].includes(ar(o)), A = i.reference[v] - i.floating[_] + (P && ((w = l.offset) == null ? void 0 : w[v]) || 0) + (P ? 0 : b.crossAxis), I = i.reference[v] + i.reference[_] + (P ? 0 : ((N = l.offset) == null ? void 0 : N[v]) || 0) - (P ? b.crossAxis : 0);
        y < A ? y = A : y > I && (y = I);
      }
      return {
        [C]: x,
        [v]: y
      };
    }
  };
}, pk = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: i
      } = t, {
        apply: l = () => {
        },
        ...c
      } = ir(e, t), f = await ua(t, c), p = ar(n), m = _i(n), v = Dr(n) === "y", {
        width: C,
        height: x
      } = r.floating;
      let y, h;
      p === "top" || p === "bottom" ? (y = p, h = m === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (h = p, y = m === "end" ? "top" : "bottom");
      const b = x - f.top - f.bottom, w = C - f.left - f.right, N = Dn(x - f[y], b), _ = Dn(C - f[h], w), P = !t.middlewareData.shift;
      let A = N, I = _;
      if (v ? I = m || P ? Dn(_, w) : w : A = m || P ? Dn(N, b) : b, P && !m) {
        const M = en(f.left, 0), D = en(f.right, 0), W = en(f.top, 0), U = en(f.bottom, 0);
        v ? I = C - 2 * (M !== 0 || D !== 0 ? M + D : en(f.left, f.right)) : A = x - 2 * (W !== 0 || U !== 0 ? W + U : en(f.top, f.bottom));
      }
      await l({
        ...t,
        availableWidth: I,
        availableHeight: A
      });
      const T = await o.getDimensions(i.floating);
      return C !== T.width || x !== T.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ri(e) {
  return y5(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function tn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function pr(e) {
  var t;
  return (t = (y5(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function y5(e) {
  return e instanceof Node || e instanceof tn(e).Node;
}
function Pn(e) {
  return e instanceof Element || e instanceof tn(e).Element;
}
function Vn(e) {
  return e instanceof HTMLElement || e instanceof tn(e).HTMLElement;
}
function z0(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof tn(e).ShadowRoot;
}
function Sa(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = An(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function mk(e) {
  return ["table", "td", "th"].includes(Ri(e));
}
function uc(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function up(e) {
  const t = dp(), n = Pn(e) ? An(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function hk(e) {
  let t = Fr(e);
  for (; Vn(t) && !gi(t); ) {
    if (up(t))
      return t;
    if (uc(t))
      return null;
    t = Fr(t);
  }
  return null;
}
function dp() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function gi(e) {
  return ["html", "body", "#document"].includes(Ri(e));
}
function An(e) {
  return tn(e).getComputedStyle(e);
}
function dc(e) {
  return Pn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Fr(e) {
  if (Ri(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    z0(e) && e.host || // Fallback.
    pr(e)
  );
  return z0(t) ? t.host : t;
}
function w5(e) {
  const t = Fr(e);
  return gi(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Vn(t) && Sa(t) ? t : w5(t);
}
function da(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = w5(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), l = tn(o);
  if (i) {
    const c = Df(l);
    return t.concat(l, l.visualViewport || [], Sa(o) ? o : [], c && n ? da(c) : []);
  }
  return t.concat(o, da(o, [], n));
}
function Df(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function S5(e) {
  const t = An(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Vn(e), i = o ? e.offsetWidth : n, l = o ? e.offsetHeight : r, c = Cl(n) !== i || Cl(r) !== l;
  return c && (n = i, r = l), {
    width: n,
    height: r,
    $: c
  };
}
function fp(e) {
  return Pn(e) ? e : e.contextElement;
}
function ui(e) {
  const t = fp(e);
  if (!Vn(t))
    return kr(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = S5(t);
  let l = (i ? Cl(n.width) : n.width) / r, c = (i ? Cl(n.height) : n.height) / o;
  return (!l || !Number.isFinite(l)) && (l = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: l,
    y: c
  };
}
const gk = /* @__PURE__ */ kr(0);
function N5(e) {
  const t = tn(e);
  return !dp() || !t.visualViewport ? gk : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function vk(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== tn(e) ? !1 : t;
}
function Co(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = fp(e);
  let l = kr(1);
  t && (r ? Pn(r) && (l = ui(r)) : l = ui(e));
  const c = vk(i, n, r) ? N5(i) : kr(0);
  let f = (o.left + c.x) / l.x, p = (o.top + c.y) / l.y, m = o.width / l.x, v = o.height / l.y;
  if (i) {
    const C = tn(i), x = r && Pn(r) ? tn(r) : r;
    let y = C, h = Df(y);
    for (; h && r && x !== y; ) {
      const b = ui(h), w = h.getBoundingClientRect(), N = An(h), _ = w.left + (h.clientLeft + parseFloat(N.paddingLeft)) * b.x, P = w.top + (h.clientTop + parseFloat(N.paddingTop)) * b.y;
      f *= b.x, p *= b.y, m *= b.x, v *= b.y, f += _, p += P, y = tn(h), h = Df(y);
    }
  }
  return bl({
    width: m,
    height: v,
    x: f,
    y: p
  });
}
function Ck(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", l = pr(r), c = t ? uc(t.floating) : !1;
  if (r === l || c && i)
    return n;
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  }, p = kr(1);
  const m = kr(0), v = Vn(r);
  if ((v || !v && !i) && ((Ri(r) !== "body" || Sa(l)) && (f = dc(r)), Vn(r))) {
    const C = Co(r);
    p = ui(r), m.x = C.x + r.clientLeft, m.y = C.y + r.clientTop;
  }
  return {
    width: n.width * p.x,
    height: n.height * p.y,
    x: n.x * p.x - f.scrollLeft * p.x + m.x,
    y: n.y * p.y - f.scrollTop * p.y + m.y
  };
}
function xk(e) {
  return Array.from(e.getClientRects());
}
function _5(e) {
  return Co(pr(e)).left + dc(e).scrollLeft;
}
function bk(e) {
  const t = pr(e), n = dc(e), r = e.ownerDocument.body, o = en(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = en(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let l = -n.scrollLeft + _5(e);
  const c = -n.scrollTop;
  return An(r).direction === "rtl" && (l += en(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: l,
    y: c
  };
}
function yk(e, t) {
  const n = tn(e), r = pr(e), o = n.visualViewport;
  let i = r.clientWidth, l = r.clientHeight, c = 0, f = 0;
  if (o) {
    i = o.width, l = o.height;
    const p = dp();
    (!p || p && t === "fixed") && (c = o.offsetLeft, f = o.offsetTop);
  }
  return {
    width: i,
    height: l,
    x: c,
    y: f
  };
}
function wk(e, t) {
  const n = Co(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Vn(e) ? ui(e) : kr(1), l = e.clientWidth * i.x, c = e.clientHeight * i.y, f = o * i.x, p = r * i.y;
  return {
    width: l,
    height: c,
    x: f,
    y: p
  };
}
function q0(e, t, n) {
  let r;
  if (t === "viewport")
    r = yk(e, n);
  else if (t === "document")
    r = bk(pr(e));
  else if (Pn(t))
    r = wk(t, n);
  else {
    const o = N5(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return bl(r);
}
function R5(e, t) {
  const n = Fr(e);
  return n === t || !Pn(n) || gi(n) ? !1 : An(n).position === "fixed" || R5(n, t);
}
function Sk(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = da(e, [], !1).filter((c) => Pn(c) && Ri(c) !== "body"), o = null;
  const i = An(e).position === "fixed";
  let l = i ? Fr(e) : e;
  for (; Pn(l) && !gi(l); ) {
    const c = An(l), f = up(l);
    !f && c.position === "fixed" && (o = null), (i ? !f && !o : !f && c.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Sa(l) && !f && R5(e, l)) ? r = r.filter((m) => m !== l) : o = c, l = Fr(l);
  }
  return t.set(e, r), r;
}
function Nk(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const l = [...n === "clippingAncestors" ? uc(t) ? [] : Sk(t, this._c) : [].concat(n), r], c = l[0], f = l.reduce((p, m) => {
    const v = q0(t, m, o);
    return p.top = en(v.top, p.top), p.right = Dn(v.right, p.right), p.bottom = Dn(v.bottom, p.bottom), p.left = en(v.left, p.left), p;
  }, q0(t, c, o));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function _k(e) {
  const {
    width: t,
    height: n
  } = S5(e);
  return {
    width: t,
    height: n
  };
}
function Rk(e, t, n) {
  const r = Vn(t), o = pr(t), i = n === "fixed", l = Co(e, !0, i, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const f = kr(0);
  if (r || !r && !i)
    if ((Ri(t) !== "body" || Sa(o)) && (c = dc(t)), r) {
      const v = Co(t, !0, i, t);
      f.x = v.x + t.clientLeft, f.y = v.y + t.clientTop;
    } else o && (f.x = _5(o));
  const p = l.left + c.scrollLeft - f.x, m = l.top + c.scrollTop - f.y;
  return {
    x: p,
    y: m,
    width: l.width,
    height: l.height
  };
}
function Ud(e) {
  return An(e).position === "static";
}
function K0(e, t) {
  return !Vn(e) || An(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function E5(e, t) {
  const n = tn(e);
  if (uc(e))
    return n;
  if (!Vn(e)) {
    let o = Fr(e);
    for (; o && !gi(o); ) {
      if (Pn(o) && !Ud(o))
        return o;
      o = Fr(o);
    }
    return n;
  }
  let r = K0(e, t);
  for (; r && mk(r) && Ud(r); )
    r = K0(r, t);
  return r && gi(r) && Ud(r) && !up(r) ? n : r || hk(e) || n;
}
const Ek = async function(e) {
  const t = this.getOffsetParent || E5, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Rk(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Pk(e) {
  return An(e).direction === "rtl";
}
const Ak = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ck,
  getDocumentElement: pr,
  getClippingRect: Nk,
  getOffsetParent: E5,
  getElementRects: Ek,
  getClientRects: xk,
  getDimensions: _k,
  getScale: ui,
  isElement: Pn,
  isRTL: Pk
};
function Tk(e, t) {
  let n = null, r;
  const o = pr(e);
  function i() {
    var c;
    clearTimeout(r), (c = n) == null || c.disconnect(), n = null;
  }
  function l(c, f) {
    c === void 0 && (c = !1), f === void 0 && (f = 1), i();
    const {
      left: p,
      top: m,
      width: v,
      height: C
    } = e.getBoundingClientRect();
    if (c || t(), !v || !C)
      return;
    const x = Vs(m), y = Vs(o.clientWidth - (p + v)), h = Vs(o.clientHeight - (m + C)), b = Vs(p), N = {
      rootMargin: -x + "px " + -y + "px " + -h + "px " + -b + "px",
      threshold: en(0, Dn(1, f)) || 1
    };
    let _ = !0;
    function P(A) {
      const I = A[0].intersectionRatio;
      if (I !== f) {
        if (!_)
          return l();
        I ? l(!1, I) : r = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      _ = !1;
    }
    try {
      n = new IntersectionObserver(P, {
        ...N,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(P, N);
    }
    n.observe(e);
  }
  return l(!0), i;
}
function fc(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: l = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: f = !1
  } = r, p = fp(e), m = o || i ? [...p ? da(p) : [], ...da(t)] : [];
  m.forEach((w) => {
    o && w.addEventListener("scroll", n, {
      passive: !0
    }), i && w.addEventListener("resize", n);
  });
  const v = p && c ? Tk(p, n) : null;
  let C = -1, x = null;
  l && (x = new ResizeObserver((w) => {
    let [N] = w;
    N && N.target === p && x && (x.unobserve(t), cancelAnimationFrame(C), C = requestAnimationFrame(() => {
      var _;
      (_ = x) == null || _.observe(t);
    })), n();
  }), p && !f && x.observe(p), x.observe(t));
  let y, h = f ? Co(e) : null;
  f && b();
  function b() {
    const w = Co(e);
    h && (w.x !== h.x || w.y !== h.y || w.width !== h.width || w.height !== h.height) && n(), h = w, y = requestAnimationFrame(b);
  }
  return n(), () => {
    var w;
    m.forEach((N) => {
      o && N.removeEventListener("scroll", n), i && N.removeEventListener("resize", n);
    }), v == null || v(), (w = x) == null || w.disconnect(), x = null, f && cancelAnimationFrame(y);
  };
}
const $k = uk, Lk = dk, Mk = sk, Ik = pk, Ok = lk, Y0 = ak, kk = fk, Dk = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: Ak,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return ik(e, t, {
    ...o,
    platform: i
  });
};
var rl = typeof document < "u" ? y1 : Oe;
function yl(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!yl(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !yl(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function P5(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Z0(e, t) {
  const n = P5(e);
  return Math.round(t * n) / n;
}
function X0(e) {
  const t = d.useRef(e);
  return rl(() => {
    t.current = e;
  }), t;
}
function pc(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: l
    } = {},
    transform: c = !0,
    whileElementsMounted: f,
    open: p
  } = e, [m, v] = d.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [C, x] = d.useState(r);
  yl(C, r) || x(r);
  const [y, h] = d.useState(null), [b, w] = d.useState(null), N = d.useCallback((Q) => {
    Q !== I.current && (I.current = Q, h(Q));
  }, []), _ = d.useCallback((Q) => {
    Q !== T.current && (T.current = Q, w(Q));
  }, []), P = i || y, A = l || b, I = d.useRef(null), T = d.useRef(null), M = d.useRef(m), D = f != null, W = X0(f), U = X0(o), re = d.useCallback(() => {
    if (!I.current || !T.current)
      return;
    const Q = {
      placement: t,
      strategy: n,
      middleware: C
    };
    U.current && (Q.platform = U.current), Dk(I.current, T.current, Q).then((te) => {
      const ee = {
        ...te,
        isPositioned: !0
      };
      j.current && !yl(M.current, ee) && (M.current = ee, Tn.flushSync(() => {
        v(ee);
      }));
    });
  }, [C, t, n, U]);
  rl(() => {
    p === !1 && M.current.isPositioned && (M.current.isPositioned = !1, v((Q) => ({
      ...Q,
      isPositioned: !1
    })));
  }, [p]);
  const j = d.useRef(!1);
  rl(() => (j.current = !0, () => {
    j.current = !1;
  }), []), rl(() => {
    if (P && (I.current = P), A && (T.current = A), P && A) {
      if (W.current)
        return W.current(P, A, re);
      re();
    }
  }, [P, A, re, W, D]);
  const X = d.useMemo(() => ({
    reference: I,
    floating: T,
    setReference: N,
    setFloating: _
  }), [N, _]), oe = d.useMemo(() => ({
    reference: P,
    floating: A
  }), [P, A]), G = d.useMemo(() => {
    const Q = {
      position: n,
      left: 0,
      top: 0
    };
    if (!oe.floating)
      return Q;
    const te = Z0(oe.floating, m.x), ee = Z0(oe.floating, m.y);
    return c ? {
      ...Q,
      transform: "translate(" + te + "px, " + ee + "px)",
      ...P5(oe.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: te,
      top: ee
    };
  }, [n, c, oe.floating, m.x, m.y]);
  return d.useMemo(() => ({
    ...m,
    update: re,
    refs: X,
    elements: oe,
    floatingStyles: G
  }), [m, re, X, oe, G]);
}
const Fk = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Y0({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Y0({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, mc = (e, t) => ({
  ...$k(e),
  options: [e, t]
}), hc = (e, t) => ({
  ...Lk(e),
  options: [e, t]
}), gc = (e, t) => ({
  ...kk(e),
  options: [e, t]
}), vc = (e, t) => ({
  ...Mk(e),
  options: [e, t]
}), Cc = (e, t) => ({
  ...Ik(e),
  options: [e, t]
}), xc = (e, t) => ({
  ...Ok(e),
  options: [e, t]
}), bc = (e, t) => ({
  ...Fk(e),
  options: [e, t]
});
var Bk = "Arrow", A5 = d.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ s(
    qt.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ s("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
A5.displayName = Bk;
var Vk = A5, pp = "Popper", [T5, $5] = cc(pp), [Wk, L5] = T5(pp), M5 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = d.useState(null);
  return /* @__PURE__ */ s(Wk, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
M5.displayName = pp;
var I5 = "PopperAnchor", O5 = d.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = L5(I5, n), l = d.useRef(null), c = Gt(t, l);
    return d.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || l.current);
    }), r ? null : /* @__PURE__ */ s(qt.div, { ...o, ref: c });
  }
);
O5.displayName = I5;
var mp = "PopperContent", [Hk, Uk] = T5(mp), k5 = d.forwardRef(
  (e, t) => {
    var ie, Ce, _e, Te, Me, Ie;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: l = 0,
      arrowPadding: c = 0,
      avoidCollisions: f = !0,
      collisionBoundary: p = [],
      collisionPadding: m = 0,
      sticky: v = "partial",
      hideWhenDetached: C = !1,
      updatePositionStrategy: x = "optimized",
      onPlaced: y,
      ...h
    } = e, b = L5(mp, n), [w, N] = d.useState(null), _ = Gt(t, (ze) => N(ze)), [P, A] = d.useState(null), I = Hr(P), T = (I == null ? void 0 : I.width) ?? 0, M = (I == null ? void 0 : I.height) ?? 0, D = r + (i !== "center" ? "-" + i : ""), W = typeof m == "number" ? m : { top: 0, right: 0, bottom: 0, left: 0, ...m }, U = Array.isArray(p) ? p : [p], re = U.length > 0, j = {
      padding: W,
      boundary: U.filter(zk),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: re
    }, { refs: X, floatingStyles: oe, placement: G, isPositioned: Q, middlewareData: te } = pc({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: D,
      whileElementsMounted: (...ze) => fc(...ze, {
        animationFrame: x === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        mc({ mainAxis: o + M, alignmentAxis: l }),
        f && hc({
          mainAxis: !0,
          crossAxis: !1,
          limiter: v === "partial" ? gc() : void 0,
          ...j
        }),
        f && vc({ ...j }),
        Cc({
          ...j,
          apply: ({ elements: ze, rects: Ke, availableWidth: St, availableHeight: Kt }) => {
            const { width: ut, height: Mn } = Ke.reference, dt = ze.floating.style;
            dt.setProperty("--radix-popper-available-width", `${St}px`), dt.setProperty("--radix-popper-available-height", `${Kt}px`), dt.setProperty("--radix-popper-anchor-width", `${ut}px`), dt.setProperty("--radix-popper-anchor-height", `${Mn}px`);
          }
        }),
        P && bc({ element: P, padding: c }),
        qk({ arrowWidth: T, arrowHeight: M }),
        C && xc({ strategy: "referenceHidden", ...j })
      ]
    }), [ee, Pe] = B5(G), ce = xe(y);
    be(() => {
      Q && (ce == null || ce());
    }, [Q, ce]);
    const K = (ie = te.arrow) == null ? void 0 : ie.x, pe = (Ce = te.arrow) == null ? void 0 : Ce.y, ge = ((_e = te.arrow) == null ? void 0 : _e.centerOffset) !== 0, [ue, ye] = d.useState();
    return be(() => {
      w && ye(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ s(
      "div",
      {
        ref: X.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...oe,
          transform: Q ? oe.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ue,
          "--radix-popper-transform-origin": [
            (Te = te.transformOrigin) == null ? void 0 : Te.x,
            (Me = te.transformOrigin) == null ? void 0 : Me.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Ie = te.hide) == null ? void 0 : Ie.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ s(
          Hk,
          {
            scope: n,
            placedSide: ee,
            onArrowChange: A,
            arrowX: K,
            arrowY: pe,
            shouldHideArrow: ge,
            children: /* @__PURE__ */ s(
              qt.div,
              {
                "data-side": ee,
                "data-align": Pe,
                ...h,
                ref: _,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: Q ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
k5.displayName = mp;
var D5 = "PopperArrow", Gk = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, F5 = d.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = Uk(D5, r), l = Gk[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ s(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [l]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ s(
          Vk,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
F5.displayName = D5;
function zk(e) {
  return e !== null;
}
var qk = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var b, w, N;
    const { placement: n, rects: r, middlewareData: o } = t, l = ((b = o.arrow) == null ? void 0 : b.centerOffset) !== 0, c = l ? 0 : e.arrowWidth, f = l ? 0 : e.arrowHeight, [p, m] = B5(n), v = { start: "0%", center: "50%", end: "100%" }[m], C = (((w = o.arrow) == null ? void 0 : w.x) ?? 0) + c / 2, x = (((N = o.arrow) == null ? void 0 : N.y) ?? 0) + f / 2;
    let y = "", h = "";
    return p === "bottom" ? (y = l ? v : `${C}px`, h = `${-f}px`) : p === "top" ? (y = l ? v : `${C}px`, h = `${r.floating.height + f}px`) : p === "right" ? (y = `${-f}px`, h = l ? v : `${x}px`) : p === "left" && (y = `${r.floating.width + f}px`, h = l ? v : `${x}px`), { data: { x: y, y: h } };
  }
});
function B5(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var V5 = M5, Kk = O5, Yk = k5, Zk = F5, Xk = "Portal", W5 = d.forwardRef((e, t) => {
  var c;
  const { container: n, ...r } = e, [o, i] = d.useState(!1);
  be(() => i(!0), []);
  const l = n || o && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return l ? Br.createPortal(/* @__PURE__ */ s(qt.div, { ...r, ref: t }), l) : null;
});
W5.displayName = Xk;
function jk(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var Na = (e) => {
  const { present: t, children: n } = e, r = Qk(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), i = Gt(r.ref, Jk(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: i }) : null;
};
Na.displayName = "Presence";
function Qk(e) {
  const [t, n] = d.useState(), r = d.useRef({}), o = d.useRef(e), i = d.useRef("none"), l = e ? "mounted" : "unmounted", [c, f] = jk(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const p = Ws(r.current);
    i.current = c === "mounted" ? p : "none";
  }, [c]), be(() => {
    const p = r.current, m = o.current;
    if (m !== e) {
      const C = i.current, x = Ws(p);
      e ? f("MOUNT") : x === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && C !== x ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), be(() => {
    if (t) {
      let p;
      const m = t.ownerDocument.defaultView ?? window, v = (x) => {
        const h = Ws(r.current).includes(x.animationName);
        if (x.target === t && h && (f("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, C = (x) => {
        x.target === t && (i.current = Ws(r.current));
      };
      return t.addEventListener("animationstart", C), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        m.clearTimeout(p), t.removeEventListener("animationstart", C), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: d.useCallback((p) => {
      p && (r.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function Ws(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Jk(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Gd = "rovingFocusGroup.onEntryFocus", eD = { bubbles: !1, cancelable: !0 }, yc = "RovingFocusGroup", [Ff, H5, tD] = p5(yc), [nD, U5] = cc(
  yc,
  [tD]
), [rD, oD] = nD(yc), G5 = d.forwardRef(
  (e, t) => /* @__PURE__ */ s(Ff.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ s(Ff.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ s(iD, { ...e, ref: t }) }) })
);
G5.displayName = yc;
var iD = d.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: l,
    defaultCurrentTabStopId: c,
    onCurrentTabStopIdChange: f,
    onEntryFocus: p,
    preventScrollOnEntryFocus: m = !1,
    ...v
  } = e, C = d.useRef(null), x = Gt(t, C), y = vn(i), [h = null, b] = et({
    prop: l,
    defaultProp: c,
    onChange: f
  }), [w, N] = d.useState(!1), _ = xe(p), P = H5(n), A = d.useRef(!1), [I, T] = d.useState(0);
  return d.useEffect(() => {
    const M = C.current;
    if (M)
      return M.addEventListener(Gd, _), () => M.removeEventListener(Gd, _);
  }, [_]), /* @__PURE__ */ s(
    rD,
    {
      scope: n,
      orientation: r,
      dir: y,
      loop: o,
      currentTabStopId: h,
      onItemFocus: d.useCallback(
        (M) => b(M),
        [b]
      ),
      onItemShiftTab: d.useCallback(() => N(!0), []),
      onFocusableItemAdd: d.useCallback(
        () => T((M) => M + 1),
        []
      ),
      onFocusableItemRemove: d.useCallback(
        () => T((M) => M - 1),
        []
      ),
      children: /* @__PURE__ */ s(
        qt.div,
        {
          tabIndex: w || I === 0 ? -1 : 0,
          "data-orientation": r,
          ...v,
          ref: x,
          style: { outline: "none", ...e.style },
          onMouseDown: Xe(e.onMouseDown, () => {
            A.current = !0;
          }),
          onFocus: Xe(e.onFocus, (M) => {
            const D = !A.current;
            if (M.target === M.currentTarget && D && !w) {
              const W = new CustomEvent(Gd, eD);
              if (M.currentTarget.dispatchEvent(W), !W.defaultPrevented) {
                const U = P().filter((G) => G.focusable), re = U.find((G) => G.active), j = U.find((G) => G.id === h), oe = [re, j, ...U].filter(
                  Boolean
                ).map((G) => G.ref.current);
                K5(oe, m);
              }
            }
            A.current = !1;
          }),
          onBlur: Xe(e.onBlur, () => N(!1))
        }
      )
    }
  );
}), z5 = "RovingFocusGroupItem", q5 = d.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      ...l
    } = e, c = it(), f = i || c, p = oD(z5, n), m = p.currentTabStopId === f, v = H5(n), { onFocusableItemAdd: C, onFocusableItemRemove: x } = p;
    return d.useEffect(() => {
      if (r)
        return C(), () => x();
    }, [r, C, x]), /* @__PURE__ */ s(
      Ff.ItemSlot,
      {
        scope: n,
        id: f,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ s(
          qt.span,
          {
            tabIndex: m ? 0 : -1,
            "data-orientation": p.orientation,
            ...l,
            ref: t,
            onMouseDown: Xe(e.onMouseDown, (y) => {
              r ? p.onItemFocus(f) : y.preventDefault();
            }),
            onFocus: Xe(e.onFocus, () => p.onItemFocus(f)),
            onKeyDown: Xe(e.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                p.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget) return;
              const h = lD(y, p.orientation, p.dir);
              if (h !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey) return;
                y.preventDefault();
                let w = v().filter((N) => N.focusable).map((N) => N.ref.current);
                if (h === "last") w.reverse();
                else if (h === "prev" || h === "next") {
                  h === "prev" && w.reverse();
                  const N = w.indexOf(y.currentTarget);
                  w = p.loop ? cD(w, N + 1) : w.slice(N + 1);
                }
                setTimeout(() => K5(w));
              }
            })
          }
        )
      }
    );
  }
);
q5.displayName = z5;
var aD = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function sD(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function lD(e, t, n) {
  const r = sD(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return aD[r];
}
function K5(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function cD(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var uD = G5, dD = q5, ol = "right-scroll-bar-position", il = "width-before-scroll-bar", fD = "with-scroll-bars-hidden", pD = "--removed-body-scroll-bar-size";
function zd(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function mD(e, t) {
  var n = ne(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var hD = typeof window < "u" ? d.useLayoutEffect : d.useEffect, j0 = /* @__PURE__ */ new WeakMap();
function gD(e, t) {
  var n = mD(null, function(r) {
    return e.forEach(function(o) {
      return zd(o, r);
    });
  });
  return hD(function() {
    var r = j0.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), l = n.current;
      o.forEach(function(c) {
        i.has(c) || zd(c, null);
      }), i.forEach(function(c) {
        o.has(c) || zd(c, l);
      });
    }
    j0.set(n, e);
  }, [e]), n;
}
function vD(e) {
  return e;
}
function CD(e, t) {
  t === void 0 && (t = vD);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var l = t(i, r);
      return n.push(l), function() {
        n = n.filter(function(c) {
          return c !== l;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var l = n;
        n = [], l.forEach(i);
      }
      n = {
        push: function(c) {
          return i(c);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var l = [];
      if (n.length) {
        var c = n;
        n = [], c.forEach(i), l = n;
      }
      var f = function() {
        var m = l;
        l = [], m.forEach(i);
      }, p = function() {
        return Promise.resolve().then(f);
      };
      p(), n = {
        push: function(m) {
          l.push(m), p();
        },
        filter: function(m) {
          return l = l.filter(m), n;
        }
      };
    }
  };
  return o;
}
function xD(e) {
  e === void 0 && (e = {});
  var t = CD(null);
  return t.options = Ae({ async: !0, ssr: !1 }, e), t;
}
var Y5 = function(e) {
  var t = e.sideCar, n = Hn(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return d.createElement(r, Ae({}, n));
};
Y5.isSideCarExport = !0;
function bD(e, t) {
  return e.useMedium(t), Y5;
}
var Z5 = xD(), qd = function() {
}, wc = d.forwardRef(function(e, t) {
  var n = d.useRef(null), r = d.useState({
    onScrollCapture: qd,
    onWheelCapture: qd,
    onTouchMoveCapture: qd
  }), o = r[0], i = r[1], l = e.forwardProps, c = e.children, f = e.className, p = e.removeScrollBar, m = e.enabled, v = e.shards, C = e.sideCar, x = e.noIsolation, y = e.inert, h = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, N = e.gapMode, _ = Hn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), P = C, A = gD([n, t]), I = Ae(Ae({}, _), o);
  return d.createElement(
    d.Fragment,
    null,
    m && d.createElement(P, { sideCar: Z5, removeScrollBar: p, shards: v, noIsolation: x, inert: y, setCallbacks: i, allowPinchZoom: !!h, lockRef: n, gapMode: N }),
    l ? d.cloneElement(d.Children.only(c), Ae(Ae({}, I), { ref: A })) : d.createElement(w, Ae({}, I, { className: f, ref: A }), c)
  );
});
wc.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
wc.classNames = {
  fullWidth: il,
  zeroRight: ol
};
function yD() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Gl();
  return t && e.setAttribute("nonce", t), e;
}
function wD(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function SD(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var ND = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = yD()) && (wD(t, n), SD(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, _D = function() {
  var e = ND();
  return function(t, n) {
    d.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, X5 = function() {
  var e = _D(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, RD = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Kd = function(e) {
  return parseInt(e || "", 10) || 0;
}, ED = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Kd(n), Kd(r), Kd(o)];
}, PD = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return RD;
  var t = ED(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, AD = X5(), di = "data-scroll-locked", TD = function(e, t, n, r) {
  var o = e.left, i = e.top, l = e.right, c = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(fD, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(c, "px ").concat(r, `;
  }
  body[`).concat(di, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(l, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(c, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ol, ` {
    right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(il, ` {
    margin-right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(ol, " .").concat(ol, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(il, " .").concat(il, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(di, `] {
    `).concat(pD, ": ").concat(c, `px;
  }
`);
}, Q0 = function() {
  var e = parseInt(document.body.getAttribute(di) || "0", 10);
  return isFinite(e) ? e : 0;
}, $D = function() {
  d.useEffect(function() {
    return document.body.setAttribute(di, (Q0() + 1).toString()), function() {
      var e = Q0() - 1;
      e <= 0 ? document.body.removeAttribute(di) : document.body.setAttribute(di, e.toString());
    };
  }, []);
}, LD = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  $D();
  var i = d.useMemo(function() {
    return PD(o);
  }, [o]);
  return d.createElement(AD, { styles: TD(i, !t, o, n ? "" : "!important") });
}, Bf = !1;
if (typeof window < "u")
  try {
    var Hs = Object.defineProperty({}, "passive", {
      get: function() {
        return Bf = !0, !0;
      }
    });
    window.addEventListener("test", Hs, Hs), window.removeEventListener("test", Hs, Hs);
  } catch {
    Bf = !1;
  }
var jo = Bf ? { passive: !1 } : !1, MD = function(e) {
  return e.tagName === "TEXTAREA";
}, j5 = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !MD(e) && n[t] === "visible")
  );
}, ID = function(e) {
  return j5(e, "overflowY");
}, OD = function(e) {
  return j5(e, "overflowX");
}, J0 = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Q5(e, r);
    if (o) {
      var i = J5(e, r), l = i[1], c = i[2];
      if (l > c)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, kD = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, DD = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Q5 = function(e, t) {
  return e === "v" ? ID(t) : OD(t);
}, J5 = function(e, t) {
  return e === "v" ? kD(t) : DD(t);
}, FD = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, BD = function(e, t, n, r, o) {
  var i = FD(e, window.getComputedStyle(t).direction), l = i * r, c = n.target, f = t.contains(c), p = !1, m = l > 0, v = 0, C = 0;
  do {
    var x = J5(e, c), y = x[0], h = x[1], b = x[2], w = h - b - i * y;
    (y || w) && Q5(e, c) && (v += w, C += y), c instanceof ShadowRoot ? c = c.host : c = c.parentNode;
  } while (
    // portaled content
    !f && c !== document.body || // self content
    f && (t.contains(c) || t === c)
  );
  return (m && (Math.abs(v) < 1 || !o) || !m && (Math.abs(C) < 1 || !o)) && (p = !0), p;
}, Us = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, e2 = function(e) {
  return [e.deltaX, e.deltaY];
}, t2 = function(e) {
  return e && "current" in e ? e.current : e;
}, VD = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, WD = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, HD = 0, Qo = [];
function UD(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), o = d.useState(HD++)[0], i = d.useState(X5)[0], l = d.useRef(e);
  d.useEffect(function() {
    l.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = wi([e.lockRef.current], (e.shards || []).map(t2), !0).filter(Boolean);
      return h.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = d.useCallback(function(h, b) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !l.current.allowPinchZoom;
    var w = Us(h), N = n.current, _ = "deltaX" in h ? h.deltaX : N[0] - w[0], P = "deltaY" in h ? h.deltaY : N[1] - w[1], A, I = h.target, T = Math.abs(_) > Math.abs(P) ? "h" : "v";
    if ("touches" in h && T === "h" && I.type === "range")
      return !1;
    var M = J0(T, I);
    if (!M)
      return !0;
    if (M ? A = T : (A = T === "v" ? "h" : "v", M = J0(T, I)), !M)
      return !1;
    if (!r.current && "changedTouches" in h && (_ || P) && (r.current = A), !A)
      return !0;
    var D = r.current || A;
    return BD(D, b, h, D === "h" ? _ : P, !0);
  }, []), f = d.useCallback(function(h) {
    var b = h;
    if (!(!Qo.length || Qo[Qo.length - 1] !== i)) {
      var w = "deltaY" in b ? e2(b) : Us(b), N = t.current.filter(function(A) {
        return A.name === b.type && (A.target === b.target || b.target === A.shadowParent) && VD(A.delta, w);
      })[0];
      if (N && N.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!N) {
        var _ = (l.current.shards || []).map(t2).filter(Boolean).filter(function(A) {
          return A.contains(b.target);
        }), P = _.length > 0 ? c(b, _[0]) : !l.current.noIsolation;
        P && b.cancelable && b.preventDefault();
      }
    }
  }, []), p = d.useCallback(function(h, b, w, N) {
    var _ = { name: h, delta: b, target: w, should: N, shadowParent: GD(w) };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(P) {
        return P !== _;
      });
    }, 1);
  }, []), m = d.useCallback(function(h) {
    n.current = Us(h), r.current = void 0;
  }, []), v = d.useCallback(function(h) {
    p(h.type, e2(h), h.target, c(h, e.lockRef.current));
  }, []), C = d.useCallback(function(h) {
    p(h.type, Us(h), h.target, c(h, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return Qo.push(i), e.setCallbacks({
      onScrollCapture: v,
      onWheelCapture: v,
      onTouchMoveCapture: C
    }), document.addEventListener("wheel", f, jo), document.addEventListener("touchmove", f, jo), document.addEventListener("touchstart", m, jo), function() {
      Qo = Qo.filter(function(h) {
        return h !== i;
      }), document.removeEventListener("wheel", f, jo), document.removeEventListener("touchmove", f, jo), document.removeEventListener("touchstart", m, jo);
    };
  }, []);
  var x = e.removeScrollBar, y = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    y ? d.createElement(i, { styles: WD(o) }) : null,
    x ? d.createElement(LD, { gapMode: e.gapMode }) : null
  );
}
function GD(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const zD = bD(Z5, UD);
var e8 = d.forwardRef(function(e, t) {
  return d.createElement(wc, Ae({}, e, { ref: t, sideCar: zD }));
});
e8.classNames = wc.classNames;
var Vf = ["Enter", " "], qD = ["ArrowDown", "PageUp", "Home"], t8 = ["ArrowUp", "PageDown", "End"], KD = [...qD, ...t8], YD = {
  ltr: [...Vf, "ArrowRight"],
  rtl: [...Vf, "ArrowLeft"]
}, ZD = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, _a = "Menu", [fa, XD, jD] = p5(_a), [_o, n8] = cc(_a, [
  jD,
  $5,
  U5
]), Ra = $5(), r8 = U5(), [o8, Ur] = _o(_a), [QD, Ea] = _o(_a), i8 = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: i, modal: l = !0 } = e, c = Ra(t), [f, p] = d.useState(null), m = d.useRef(!1), v = xe(i), C = vn(o);
  return d.useEffect(() => {
    const x = () => {
      m.current = !0, document.addEventListener("pointerdown", y, { capture: !0, once: !0 }), document.addEventListener("pointermove", y, { capture: !0, once: !0 });
    }, y = () => m.current = !1;
    return document.addEventListener("keydown", x, { capture: !0 }), () => {
      document.removeEventListener("keydown", x, { capture: !0 }), document.removeEventListener("pointerdown", y, { capture: !0 }), document.removeEventListener("pointermove", y, { capture: !0 });
    };
  }, []), /* @__PURE__ */ s(V5, { ...c, children: /* @__PURE__ */ s(
    o8,
    {
      scope: t,
      open: n,
      onOpenChange: v,
      content: f,
      onContentChange: p,
      children: /* @__PURE__ */ s(
        QD,
        {
          scope: t,
          onClose: d.useCallback(() => v(!1), [v]),
          isUsingKeyboardRef: m,
          dir: C,
          modal: l,
          children: r
        }
      )
    }
  ) });
};
i8.displayName = _a;
var JD = "MenuAnchor", hp = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Ra(n);
    return /* @__PURE__ */ s(Kk, { ...o, ...r, ref: t });
  }
);
hp.displayName = JD;
var gp = "MenuPortal", [eF, a8] = _o(gp, {
  forceMount: void 0
}), s8 = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, i = Ur(gp, t);
  return /* @__PURE__ */ s(eF, { scope: t, forceMount: n, children: /* @__PURE__ */ s(Na, { present: n || i.open, children: /* @__PURE__ */ s(W5, { asChild: !0, container: o, children: r }) }) });
};
s8.displayName = gp;
var mn = "MenuContent", [tF, vp] = _o(mn), l8 = d.forwardRef(
  (e, t) => {
    const n = a8(mn, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = Ur(mn, e.__scopeMenu), l = Ea(mn, e.__scopeMenu);
    return /* @__PURE__ */ s(fa.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ s(Na, { present: r || i.open, children: /* @__PURE__ */ s(fa.Slot, { scope: e.__scopeMenu, children: l.modal ? /* @__PURE__ */ s(nF, { ...o, ref: t }) : /* @__PURE__ */ s(rF, { ...o, ref: t }) }) }) });
  }
), nF = d.forwardRef(
  (e, t) => {
    const n = Ur(mn, e.__scopeMenu), r = d.useRef(null), o = Gt(t, r);
    return d.useEffect(() => {
      const i = r.current;
      if (i) return Si(i);
    }, []), /* @__PURE__ */ s(
      Cp,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: Xe(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), rF = d.forwardRef((e, t) => {
  const n = Ur(mn, e.__scopeMenu);
  return /* @__PURE__ */ s(
    Cp,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Cp = d.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: l,
      disableOutsidePointerEvents: c,
      onEntryFocus: f,
      onEscapeKeyDown: p,
      onPointerDownOutside: m,
      onFocusOutside: v,
      onInteractOutside: C,
      onDismiss: x,
      disableOutsideScroll: y,
      ...h
    } = e, b = Ur(mn, n), w = Ea(mn, n), N = Ra(n), _ = r8(n), P = XD(n), [A, I] = d.useState(null), T = d.useRef(null), M = Gt(t, T, b.onContentChange), D = d.useRef(0), W = d.useRef(""), U = d.useRef(0), re = d.useRef(null), j = d.useRef("right"), X = d.useRef(0), oe = y ? e8 : d.Fragment, G = y ? { as: ca, allowPinchZoom: !0 } : void 0, Q = (ee) => {
      var ie, Ce;
      const Pe = W.current + ee, ce = P().filter((_e) => !_e.disabled), K = document.activeElement, pe = (ie = ce.find((_e) => _e.ref.current === K)) == null ? void 0 : ie.textValue, ge = ce.map((_e) => _e.textValue), ue = hF(ge, Pe, pe), ye = (Ce = ce.find((_e) => _e.textValue === ue)) == null ? void 0 : Ce.ref.current;
      (function _e(Te) {
        W.current = Te, window.clearTimeout(D.current), Te !== "" && (D.current = window.setTimeout(() => _e(""), 1e3));
      })(Pe), ye && setTimeout(() => ye.focus());
    };
    d.useEffect(() => () => window.clearTimeout(D.current), []), M1();
    const te = d.useCallback((ee) => {
      var ce, K;
      return j.current === ((ce = re.current) == null ? void 0 : ce.side) && vF(ee, (K = re.current) == null ? void 0 : K.area);
    }, []);
    return /* @__PURE__ */ s(
      tF,
      {
        scope: n,
        searchRef: W,
        onItemEnter: d.useCallback(
          (ee) => {
            te(ee) && ee.preventDefault();
          },
          [te]
        ),
        onItemLeave: d.useCallback(
          (ee) => {
            var Pe;
            te(ee) || ((Pe = T.current) == null || Pe.focus(), I(null));
          },
          [te]
        ),
        onTriggerLeave: d.useCallback(
          (ee) => {
            te(ee) && ee.preventDefault();
          },
          [te]
        ),
        pointerGraceTimerRef: U,
        onPointerGraceIntentChange: d.useCallback((ee) => {
          re.current = ee;
        }, []),
        children: /* @__PURE__ */ s(oe, { ...G, children: /* @__PURE__ */ s(
          C5,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: Xe(i, (ee) => {
              var Pe;
              ee.preventDefault(), (Pe = T.current) == null || Pe.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: l,
            children: /* @__PURE__ */ s(
              g5,
              {
                asChild: !0,
                disableOutsidePointerEvents: c,
                onEscapeKeyDown: p,
                onPointerDownOutside: m,
                onFocusOutside: v,
                onInteractOutside: C,
                onDismiss: x,
                children: /* @__PURE__ */ s(
                  uD,
                  {
                    asChild: !0,
                    ..._,
                    dir: w.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: A,
                    onCurrentTabStopIdChange: I,
                    onEntryFocus: Xe(f, (ee) => {
                      w.isUsingKeyboardRef.current || ee.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ s(
                      Yk,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": _8(b.open),
                        "data-radix-menu-content": "",
                        dir: w.dir,
                        ...N,
                        ...h,
                        ref: M,
                        style: { outline: "none", ...h.style },
                        onKeyDown: Xe(h.onKeyDown, (ee) => {
                          const ce = ee.target.closest("[data-radix-menu-content]") === ee.currentTarget, K = ee.ctrlKey || ee.altKey || ee.metaKey, pe = ee.key.length === 1;
                          ce && (ee.key === "Tab" && ee.preventDefault(), !K && pe && Q(ee.key));
                          const ge = T.current;
                          if (ee.target !== ge || !KD.includes(ee.key)) return;
                          ee.preventDefault();
                          const ye = P().filter((ie) => !ie.disabled).map((ie) => ie.ref.current);
                          t8.includes(ee.key) && ye.reverse(), pF(ye);
                        }),
                        onBlur: Xe(e.onBlur, (ee) => {
                          ee.currentTarget.contains(ee.target) || (window.clearTimeout(D.current), W.current = "");
                        }),
                        onPointerMove: Xe(
                          e.onPointerMove,
                          pa((ee) => {
                            const Pe = ee.target, ce = X.current !== ee.clientX;
                            if (ee.currentTarget.contains(Pe) && ce) {
                              const K = ee.clientX > X.current ? "right" : "left";
                              j.current = K, X.current = ee.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
l8.displayName = mn;
var oF = "MenuGroup", xp = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ s(qt.div, { role: "group", ...r, ref: t });
  }
);
xp.displayName = oF;
var iF = "MenuLabel", c8 = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ s(qt.div, { ...r, ref: t });
  }
);
c8.displayName = iF;
var wl = "MenuItem", n2 = "menu.itemSelect", Sc = d.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, i = d.useRef(null), l = Ea(wl, e.__scopeMenu), c = vp(wl, e.__scopeMenu), f = Gt(t, i), p = d.useRef(!1), m = () => {
      const v = i.current;
      if (!n && v) {
        const C = new CustomEvent(n2, { bubbles: !0, cancelable: !0 });
        v.addEventListener(n2, (x) => r == null ? void 0 : r(x), { once: !0 }), m5(v, C), C.defaultPrevented ? p.current = !1 : l.onClose();
      }
    };
    return /* @__PURE__ */ s(
      u8,
      {
        ...o,
        ref: f,
        disabled: n,
        onClick: Xe(e.onClick, m),
        onPointerDown: (v) => {
          var C;
          (C = e.onPointerDown) == null || C.call(e, v), p.current = !0;
        },
        onPointerUp: Xe(e.onPointerUp, (v) => {
          var C;
          p.current || (C = v.currentTarget) == null || C.click();
        }),
        onKeyDown: Xe(e.onKeyDown, (v) => {
          const C = c.searchRef.current !== "";
          n || C && v.key === " " || Vf.includes(v.key) && (v.currentTarget.click(), v.preventDefault());
        })
      }
    );
  }
);
Sc.displayName = wl;
var u8 = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, l = vp(wl, n), c = r8(n), f = d.useRef(null), p = Gt(t, f), [m, v] = d.useState(!1), [C, x] = d.useState("");
    return d.useEffect(() => {
      const y = f.current;
      y && x((y.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ s(
      fa.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? C,
        children: /* @__PURE__ */ s(dD, { asChild: !0, ...c, focusable: !r, children: /* @__PURE__ */ s(
          qt.div,
          {
            role: "menuitem",
            "data-highlighted": m ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: p,
            onPointerMove: Xe(
              e.onPointerMove,
              pa((y) => {
                r ? l.onItemLeave(y) : (l.onItemEnter(y), y.defaultPrevented || y.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: Xe(
              e.onPointerLeave,
              pa((y) => l.onItemLeave(y))
            ),
            onFocus: Xe(e.onFocus, () => v(!0)),
            onBlur: Xe(e.onBlur, () => v(!1))
          }
        ) })
      }
    );
  }
), aF = "MenuCheckboxItem", d8 = d.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ s(g8, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ s(
      Sc,
      {
        role: "menuitemcheckbox",
        "aria-checked": Sl(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": wp(n),
        onSelect: Xe(
          o.onSelect,
          () => r == null ? void 0 : r(Sl(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
d8.displayName = aF;
var f8 = "MenuRadioGroup", [sF, lF] = _o(
  f8,
  { value: void 0, onValueChange: () => {
  } }
), p8 = d.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, i = xe(r);
    return /* @__PURE__ */ s(sF, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ s(xp, { ...o, ref: t }) });
  }
);
p8.displayName = f8;
var m8 = "MenuRadioItem", h8 = d.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = lF(m8, e.__scopeMenu), i = n === o.value;
    return /* @__PURE__ */ s(g8, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ s(
      Sc,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": wp(i),
        onSelect: Xe(
          r.onSelect,
          () => {
            var l;
            return (l = o.onValueChange) == null ? void 0 : l.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
h8.displayName = m8;
var bp = "MenuItemIndicator", [g8, cF] = _o(
  bp,
  { checked: !1 }
), v8 = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, i = cF(bp, n);
    return /* @__PURE__ */ s(
      Na,
      {
        present: r || Sl(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ s(
          qt.span,
          {
            ...o,
            ref: t,
            "data-state": wp(i.checked)
          }
        )
      }
    );
  }
);
v8.displayName = bp;
var uF = "MenuSeparator", C8 = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ s(
      qt.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
C8.displayName = uF;
var dF = "MenuArrow", x8 = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Ra(n);
    return /* @__PURE__ */ s(Zk, { ...o, ...r, ref: t });
  }
);
x8.displayName = dF;
var yp = "MenuSub", [fF, b8] = _o(yp), y8 = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, i = Ur(yp, t), l = Ra(t), [c, f] = d.useState(null), [p, m] = d.useState(null), v = xe(o);
  return d.useEffect(() => (i.open === !1 && v(!1), () => v(!1)), [i.open, v]), /* @__PURE__ */ s(V5, { ...l, children: /* @__PURE__ */ s(
    o8,
    {
      scope: t,
      open: r,
      onOpenChange: v,
      content: p,
      onContentChange: m,
      children: /* @__PURE__ */ s(
        fF,
        {
          scope: t,
          contentId: it(),
          triggerId: it(),
          trigger: c,
          onTriggerChange: f,
          children: n
        }
      )
    }
  ) });
};
y8.displayName = yp;
var ea = "MenuSubTrigger", w8 = d.forwardRef(
  (e, t) => {
    const n = Ur(ea, e.__scopeMenu), r = Ea(ea, e.__scopeMenu), o = b8(ea, e.__scopeMenu), i = vp(ea, e.__scopeMenu), l = d.useRef(null), { pointerGraceTimerRef: c, onPointerGraceIntentChange: f } = i, p = { __scopeMenu: e.__scopeMenu }, m = d.useCallback(() => {
      l.current && window.clearTimeout(l.current), l.current = null;
    }, []);
    return d.useEffect(() => m, [m]), d.useEffect(() => {
      const v = c.current;
      return () => {
        window.clearTimeout(v), f(null);
      };
    }, [c, f]), /* @__PURE__ */ s(hp, { asChild: !0, ...p, children: /* @__PURE__ */ s(
      u8,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": _8(n.open),
        ...e,
        ref: ap(t, o.onTriggerChange),
        onClick: (v) => {
          var C;
          (C = e.onClick) == null || C.call(e, v), !(e.disabled || v.defaultPrevented) && (v.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: Xe(
          e.onPointerMove,
          pa((v) => {
            i.onItemEnter(v), !v.defaultPrevented && !e.disabled && !n.open && !l.current && (i.onPointerGraceIntentChange(null), l.current = window.setTimeout(() => {
              n.onOpenChange(!0), m();
            }, 100));
          })
        ),
        onPointerLeave: Xe(
          e.onPointerLeave,
          pa((v) => {
            var x, y;
            m();
            const C = (x = n.content) == null ? void 0 : x.getBoundingClientRect();
            if (C) {
              const h = (y = n.content) == null ? void 0 : y.dataset.side, b = h === "right", w = b ? -5 : 5, N = C[b ? "left" : "right"], _ = C[b ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: v.clientX + w, y: v.clientY },
                  { x: N, y: C.top },
                  { x: _, y: C.top },
                  { x: _, y: C.bottom },
                  { x: N, y: C.bottom }
                ],
                side: h
              }), window.clearTimeout(c.current), c.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(v), v.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: Xe(e.onKeyDown, (v) => {
          var x;
          const C = i.searchRef.current !== "";
          e.disabled || C && v.key === " " || YD[r.dir].includes(v.key) && (n.onOpenChange(!0), (x = n.content) == null || x.focus(), v.preventDefault());
        })
      }
    ) });
  }
);
w8.displayName = ea;
var S8 = "MenuSubContent", N8 = d.forwardRef(
  (e, t) => {
    const n = a8(mn, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = Ur(mn, e.__scopeMenu), l = Ea(mn, e.__scopeMenu), c = b8(S8, e.__scopeMenu), f = d.useRef(null), p = Gt(t, f);
    return /* @__PURE__ */ s(fa.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ s(Na, { present: r || i.open, children: /* @__PURE__ */ s(fa.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ s(
      Cp,
      {
        id: c.contentId,
        "aria-labelledby": c.triggerId,
        ...o,
        ref: p,
        align: "start",
        side: l.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (m) => {
          var v;
          l.isUsingKeyboardRef.current && ((v = f.current) == null || v.focus()), m.preventDefault();
        },
        onCloseAutoFocus: (m) => m.preventDefault(),
        onFocusOutside: Xe(e.onFocusOutside, (m) => {
          m.target !== c.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: Xe(e.onEscapeKeyDown, (m) => {
          l.onClose(), m.preventDefault();
        }),
        onKeyDown: Xe(e.onKeyDown, (m) => {
          var x;
          const v = m.currentTarget.contains(m.target), C = ZD[l.dir].includes(m.key);
          v && C && (i.onOpenChange(!1), (x = c.trigger) == null || x.focus(), m.preventDefault());
        })
      }
    ) }) }) });
  }
);
N8.displayName = S8;
function _8(e) {
  return e ? "open" : "closed";
}
function Sl(e) {
  return e === "indeterminate";
}
function wp(e) {
  return Sl(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function pF(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function mF(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function hF(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((p) => p === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let l = mF(e, Math.max(i, 0));
  o.length === 1 && (l = l.filter((p) => p !== n));
  const f = l.find(
    (p) => p.toLowerCase().startsWith(o.toLowerCase())
  );
  return f !== n ? f : void 0;
}
function gF(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, l = t.length - 1; i < t.length; l = i++) {
    const c = t[i].x, f = t[i].y, p = t[l].x, m = t[l].y;
    f > r != m > r && n < (p - c) * (r - f) / (m - f) + c && (o = !o);
  }
  return o;
}
function vF(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return gF(n, t);
}
function pa(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var CF = i8, xF = hp, bF = s8, yF = l8, wF = xp, SF = c8, NF = Sc, _F = d8, RF = p8, EF = h8, PF = v8, AF = C8, TF = x8, $F = y8, LF = w8, MF = N8, Sp = "DropdownMenu", [IF, nZ] = SO(
  Sp,
  [n8]
), It = n8(), [OF, R8] = IF(Sp), E8 = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: i,
    onOpenChange: l,
    modal: c = !0
  } = e, f = It(t), p = d.useRef(null), [m = !1, v] = et({
    prop: o,
    defaultProp: i,
    onChange: l
  });
  return /* @__PURE__ */ s(
    OF,
    {
      scope: t,
      triggerId: it(),
      triggerRef: p,
      contentId: it(),
      open: m,
      onOpenChange: v,
      onOpenToggle: d.useCallback(() => v((C) => !C), [v]),
      modal: c,
      children: /* @__PURE__ */ s(CF, { ...f, open: m, onOpenChange: v, dir: r, modal: c, children: n })
    }
  );
};
E8.displayName = Sp;
var P8 = "DropdownMenuTrigger", A8 = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = R8(P8, n), l = It(n);
    return /* @__PURE__ */ s(xF, { asChild: !0, ...l, children: /* @__PURE__ */ s(
      TO.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: d5(t, i.triggerRef),
        onPointerDown: vl(e.onPointerDown, (c) => {
          !r && c.button === 0 && c.ctrlKey === !1 && (i.onOpenToggle(), i.open || c.preventDefault());
        }),
        onKeyDown: vl(e.onKeyDown, (c) => {
          r || (["Enter", " "].includes(c.key) && i.onOpenToggle(), c.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(c.key) && c.preventDefault());
        })
      }
    ) });
  }
);
A8.displayName = P8;
var kF = "DropdownMenuPortal", T8 = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = It(t);
  return /* @__PURE__ */ s(bF, { ...r, ...n });
};
T8.displayName = kF;
var $8 = "DropdownMenuContent", L8 = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = R8($8, n), i = It(n), l = d.useRef(!1);
    return /* @__PURE__ */ s(
      yF,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: vl(e.onCloseAutoFocus, (c) => {
          var f;
          l.current || (f = o.triggerRef.current) == null || f.focus(), l.current = !1, c.preventDefault();
        }),
        onInteractOutside: vl(e.onInteractOutside, (c) => {
          const f = c.detail.originalEvent, p = f.button === 0 && f.ctrlKey === !0, m = f.button === 2 || p;
          (!o.modal || m) && (l.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
L8.displayName = $8;
var DF = "DropdownMenuGroup", M8 = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = It(n);
    return /* @__PURE__ */ s(wF, { ...o, ...r, ref: t });
  }
);
M8.displayName = DF;
var FF = "DropdownMenuLabel", I8 = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = It(n);
    return /* @__PURE__ */ s(SF, { ...o, ...r, ref: t });
  }
);
I8.displayName = FF;
var BF = "DropdownMenuItem", O8 = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = It(n);
    return /* @__PURE__ */ s(NF, { ...o, ...r, ref: t });
  }
);
O8.displayName = BF;
var VF = "DropdownMenuCheckboxItem", k8 = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = It(n);
  return /* @__PURE__ */ s(_F, { ...o, ...r, ref: t });
});
k8.displayName = VF;
var WF = "DropdownMenuRadioGroup", D8 = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = It(n);
  return /* @__PURE__ */ s(RF, { ...o, ...r, ref: t });
});
D8.displayName = WF;
var HF = "DropdownMenuRadioItem", F8 = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = It(n);
  return /* @__PURE__ */ s(EF, { ...o, ...r, ref: t });
});
F8.displayName = HF;
var UF = "DropdownMenuItemIndicator", B8 = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = It(n);
  return /* @__PURE__ */ s(PF, { ...o, ...r, ref: t });
});
B8.displayName = UF;
var GF = "DropdownMenuSeparator", V8 = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = It(n);
  return /* @__PURE__ */ s(AF, { ...o, ...r, ref: t });
});
V8.displayName = GF;
var zF = "DropdownMenuArrow", qF = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = It(n);
    return /* @__PURE__ */ s(TF, { ...o, ...r, ref: t });
  }
);
qF.displayName = zF;
var KF = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: i } = e, l = It(t), [c = !1, f] = et({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ s($F, { ...l, open: c, onOpenChange: f, children: n });
}, YF = "DropdownMenuSubTrigger", W8 = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = It(n);
  return /* @__PURE__ */ s(LF, { ...o, ...r, ref: t });
});
W8.displayName = YF;
var ZF = "DropdownMenuSubContent", H8 = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = It(n);
  return /* @__PURE__ */ s(
    MF,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
H8.displayName = ZF;
var XF = E8, jF = A8, U8 = T8, G8 = L8, QF = M8, z8 = I8, q8 = O8, K8 = k8, JF = D8, Y8 = F8, Z8 = B8, X8 = V8, eB = KF, j8 = W8, Q8 = H8;
const rZ = XF, oZ = jF, iZ = QF, aZ = U8, sZ = eB, lZ = JF, tB = q(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ R(
  j8,
  {
    ref: o,
    className: F(
      "focus:bg-accent data-[state=open]:bg-accent flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ s(fP, { className: "ml-auto" })
    ]
  }
));
tB.displayName = j8.displayName;
const nB = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Q8,
  {
    ref: n,
    className: F(
      "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] overflow-hidden rounded-md border p-1 shadow-lg",
      e
    ),
    ...t
  }
));
nB.displayName = Q8.displayName;
const rB = q(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ s(U8, { children: /* @__PURE__ */ s(
  G8,
  {
    ref: r,
    sideOffset: t,
    className: F(
      "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 border-border z-50 min-w-[8rem] overflow-hidden rounded-md border p-1 shadow-md",
      e
    ),
    ...n
  }
) }));
rB.displayName = G8.displayName;
const oB = q(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ s(
  q8,
  {
    ref: r,
    className: F(
      "focus:bg-accent focus:text-accent-foreground relative flex cursor-pointer select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...n
  }
));
oB.displayName = q8.displayName;
const iB = q(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ R(
  K8,
  {
    ref: o,
    className: F(
      "focus:bg-accent focus:text-accent-foreground relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ s("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ s(Z8, { children: /* @__PURE__ */ s(wo, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
iB.displayName = K8.displayName;
const aB = q(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ R(
  Y8,
  {
    ref: r,
    className: F(
      "focus:bg-accent focus:text-accent-foreground relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ s("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ s(Z8, { children: /* @__PURE__ */ s(S1, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
aB.displayName = Y8.displayName;
const sB = q(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ s(
  z8,
  {
    ref: r,
    className: F(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
sB.displayName = z8.displayName;
const lB = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  X8,
  {
    ref: n,
    className: F("bg-muted -mx-1 my-1 h-px", e),
    ...t
  }
));
lB.displayName = X8.displayName;
const cB = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  "span",
  {
    className: F("ml-auto text-xs tracking-widest opacity-60", e),
    ...t
  }
);
cB.displayName = "DropdownMenuShortcut";
var uB = (e) => e.type === "checkbox", dB = (e) => e instanceof Date, J8 = (e) => e == null;
const fB = (e) => typeof e == "object";
var Ei = (e) => !J8(e) && !Array.isArray(e) && fB(e) && !dB(e), pB = (e) => Ei(e) && e.target ? uB(e.target) ? e.target.checked : e.target.value : e, mB = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, hB = (e, t) => e.has(mB(t)), gB = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Ei(t) && t.hasOwnProperty("isPrototypeOf");
}, vB = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Np(e) {
  let t;
  const n = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(vB && (e instanceof Blob || e instanceof FileList)) && (n || Ei(e)))
    if (t = n ? [] : {}, !n && !gB(e))
      t = e;
    else
      for (const r in e)
        e.hasOwnProperty(r) && (t[r] = Np(e[r]));
  else
    return e;
  return t;
}
var e6 = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Wf = (e) => e === void 0, Tt = (e, t, n) => {
  if (!t || !Ei(e))
    return n;
  const r = e6(t.split(/[,[\].]+?/)).reduce((o, i) => J8(o) ? o : o[i], e);
  return Wf(r) || r === e ? Wf(e[t]) ? n : e[t] : r;
}, r2 = (e) => typeof e == "boolean", CB = (e) => /^\w*$/.test(e), xB = (e) => e6(e.replace(/["|']|\]/g, "").split(/\.|\[/)), o2 = (e, t, n) => {
  let r = -1;
  const o = CB(t) ? [t] : xB(t), i = o.length, l = i - 1;
  for (; ++r < i; ) {
    const c = o[r];
    let f = n;
    if (r !== l) {
      const p = e[c];
      f = Ei(p) || Array.isArray(p) ? p : isNaN(+o[r + 1]) ? {} : [];
    }
    if (c === "__proto__")
      return;
    e[c] = f, e = e[c];
  }
  return e;
};
const i2 = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, a2 = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, t6 = ae.createContext(null), Nc = () => ae.useContext(t6), cZ = (e) => {
  const { children: t, ...n } = e;
  return ae.createElement(t6.Provider, { value: n }, t);
};
var bB = (e, t, n, r = !0) => {
  const o = {
    defaultValues: t._defaultValues
  };
  for (const i in e)
    Object.defineProperty(o, i, {
      get: () => {
        const l = i;
        return t._proxyFormState[l] !== a2.all && (t._proxyFormState[l] = !r || a2.all), n && (n[l] = !0), e[l];
      }
    });
  return o;
}, yB = (e) => Ei(e) && !Object.keys(e).length, wB = (e, t, n, r) => {
  n(e);
  const { name: o, ...i } = e;
  return yB(i) || Object.keys(i).length >= Object.keys(t).length || Object.keys(i).find((l) => t[l] === !r);
}, SB = (e) => Array.isArray(e) ? e : [e], n6 = (e, t, n) => !e || !t || e === t || SB(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r)));
function r6(e) {
  const t = ae.useRef(e);
  t.current = e, ae.useEffect(() => {
    const n = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [e.disabled]);
}
function NB(e) {
  const t = Nc(), { control: n = t.control, disabled: r, name: o, exact: i } = e || {}, [l, c] = ae.useState(n._formState), f = ae.useRef(!0), p = ae.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = ae.useRef(o);
  return m.current = o, r6({
    disabled: r,
    next: (v) => f.current && n6(m.current, v.name, i) && wB(v, p.current, n._updateFormState) && c({
      ...n._formState,
      ...v
    }),
    subject: n._subjects.state
  }), ae.useEffect(() => (f.current = !0, p.current.isValid && n._updateValid(!0), () => {
    f.current = !1;
  }), [n]), bB(l, n, p.current, !1);
}
var _B = (e) => typeof e == "string", RB = (e, t, n, r, o) => _B(e) ? Tt(n, e, o) : Array.isArray(e) ? e.map((i) => Tt(n, i)) : n;
function EB(e) {
  const t = Nc(), { control: n = t.control, name: r, defaultValue: o, disabled: i, exact: l } = e || {}, c = ae.useRef(r);
  c.current = r, r6({
    disabled: i,
    subject: n._subjects.values,
    next: (m) => {
      n6(c.current, m.name, l) && p(Np(RB(c.current, n._names, m.values || n._formValues, !1, o)));
    }
  });
  const [f, p] = ae.useState(n._getWatch(r, o));
  return ae.useEffect(() => n._removeUnmounted()), f;
}
function PB(e) {
  const t = Nc(), { name: n, disabled: r, control: o = t.control, shouldUnregister: i } = e, l = hB(o._names.array, n), c = EB({
    control: o,
    name: n,
    defaultValue: Tt(o._formValues, n, Tt(o._defaultValues, n, e.defaultValue)),
    exact: !0
  }), f = NB({
    control: o,
    name: n,
    exact: !0
  }), p = ae.useRef(o.register(n, {
    ...e.rules,
    value: c,
    ...r2(e.disabled) ? { disabled: e.disabled } : {}
  }));
  return ae.useEffect(() => {
    const m = o._options.shouldUnregister || i, v = (C, x) => {
      const y = Tt(o._fields, C);
      y && y._f && (y._f.mount = x);
    };
    if (v(n, !0), m) {
      const C = Np(Tt(o._options.defaultValues, n));
      o2(o._defaultValues, n, C), Wf(Tt(o._formValues, n)) && o2(o._formValues, n, C);
    }
    return () => {
      (l ? m && !o._state.action : m) ? o.unregister(n) : v(n, !1);
    };
  }, [n, o, l, i]), ae.useEffect(() => {
    Tt(o._fields, n) && o._updateDisabledField({
      disabled: r,
      fields: o._fields,
      name: n,
      value: Tt(o._fields, n)._f.value
    });
  }, [r, n, o]), {
    field: {
      name: n,
      value: c,
      ...r2(r) || f.disabled ? { disabled: f.disabled || r } : {},
      onChange: ae.useCallback((m) => p.current.onChange({
        target: {
          value: pB(m),
          name: n
        },
        type: i2.CHANGE
      }), [n]),
      onBlur: ae.useCallback(() => p.current.onBlur({
        target: {
          value: Tt(o._formValues, n),
          name: n
        },
        type: i2.BLUR
      }), [n, o]),
      ref: ae.useCallback((m) => {
        const v = Tt(o._fields, n);
        v && m && (v._f.ref = {
          focus: () => m.focus(),
          select: () => m.select(),
          setCustomValidity: (C) => m.setCustomValidity(C),
          reportValidity: () => m.reportValidity()
        });
      }, [o._fields, n])
    },
    formState: f,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!Tt(f.errors, n)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!Tt(f.dirtyFields, n)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!Tt(f.touchedFields, n)
      },
      isValidating: {
        enumerable: !0,
        get: () => !!Tt(f.validatingFields, n)
      },
      error: {
        enumerable: !0,
        get: () => Tt(f.errors, n)
      }
    })
  };
}
const AB = (e) => e.render(PB(e)), o6 = Mr(
  {}
), uZ = ({
  ...e
}) => /* @__PURE__ */ s(o6.Provider, { value: { name: e.name }, children: /* @__PURE__ */ s(AB, { ...e }) }), _c = () => {
  const e = lo(o6), t = lo(i6), { getFieldState: n, formState: r } = Nc(), o = n(e.name, r);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: i } = t;
  return {
    id: i,
    name: e.name,
    formItemId: `${i}-form-item`,
    formDescriptionId: `${i}-form-item-description`,
    formMessageId: `${i}-form-item-message`,
    ...o
  };
}, i6 = Mr(
  {}
), TB = q(
  ({ className: e, ...t }, n) => {
    const r = nP();
    return /* @__PURE__ */ s(i6.Provider, { value: { id: r }, children: /* @__PURE__ */ s("div", { ref: n, className: F("space-y-2", e), ...t }) });
  }
);
TB.displayName = "FormItem";
const $B = q(({ className: e, ...t }, n) => {
  const { error: r, formItemId: o } = _c();
  return /* @__PURE__ */ s(
    nt,
    {
      ref: n,
      className: F(r && "text-destructive", e),
      htmlFor: o,
      ...t
    }
  );
});
$B.displayName = "FormLabel";
const LB = q(({ ...e }, t) => {
  const { error: n, formItemId: r, formDescriptionId: o, formMessageId: i } = _c();
  return /* @__PURE__ */ s(
    rn,
    {
      ref: t,
      id: r,
      "aria-describedby": n ? `${o} ${i}` : `${o}`,
      "aria-invalid": !!n,
      ...e
    }
  );
});
LB.displayName = "FormControl";
const MB = q(({ className: e, ...t }, n) => {
  const { formDescriptionId: r } = _c();
  return /* @__PURE__ */ s(
    "p",
    {
      ref: n,
      id: r,
      className: F("text-muted-foreground text-sm", e),
      ...t
    }
  );
});
MB.displayName = "FormDescription";
const IB = q(({ className: e, children: t, ...n }, r) => {
  const { error: o, formMessageId: i } = _c(), l = o ? String(o == null ? void 0 : o.message) : t;
  return l ? /* @__PURE__ */ s(
    "p",
    {
      ref: r,
      id: i,
      className: F("text-destructive text-sm font-medium", e),
      ...n,
      children: l
    }
  ) : null;
});
IB.displayName = "FormMessage";
function a6(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    const p = (v) => {
      var w;
      const { scope: C, children: x, ...y } = v, h = ((w = C == null ? void 0 : C[e]) == null ? void 0 : w[f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    };
    p.displayName = i + "Provider";
    function m(v, C) {
      var h;
      const x = ((h = C == null ? void 0 : C[e]) == null ? void 0 : h[f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, OB(o, ...t)];
}
function OB(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Yd = "rovingFocusGroup.onEntryFocus", kB = { bubbles: !1, cancelable: !0 }, Rc = "RovingFocusGroup", [Hf, s6, DB] = Dl(Rc), [FB, Ec] = Vr(
  Rc,
  [DB]
), [BB, VB] = FB(Rc), l6 = d.forwardRef(
  (e, t) => /* @__PURE__ */ s(Hf.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ s(Hf.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ s(WB, { ...e, ref: t }) }) })
);
l6.displayName = Rc;
var WB = d.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: l,
    defaultCurrentTabStopId: c,
    onCurrentTabStopIdChange: f,
    onEntryFocus: p,
    preventScrollOnEntryFocus: m = !1,
    ...v
  } = e, C = d.useRef(null), x = ke(t, C), y = vn(i), [h = null, b] = et({
    prop: l,
    defaultProp: c,
    onChange: f
  }), [w, N] = d.useState(!1), _ = xe(p), P = s6(n), A = d.useRef(!1), [I, T] = d.useState(0);
  return d.useEffect(() => {
    const M = C.current;
    if (M)
      return M.addEventListener(Yd, _), () => M.removeEventListener(Yd, _);
  }, [_]), /* @__PURE__ */ s(
    BB,
    {
      scope: n,
      orientation: r,
      dir: y,
      loop: o,
      currentTabStopId: h,
      onItemFocus: d.useCallback(
        (M) => b(M),
        [b]
      ),
      onItemShiftTab: d.useCallback(() => N(!0), []),
      onFocusableItemAdd: d.useCallback(
        () => T((M) => M + 1),
        []
      ),
      onFocusableItemRemove: d.useCallback(
        () => T((M) => M - 1),
        []
      ),
      children: /* @__PURE__ */ s(
        ve.div,
        {
          tabIndex: w || I === 0 ? -1 : 0,
          "data-orientation": r,
          ...v,
          ref: x,
          style: { outline: "none", ...e.style },
          onMouseDown: he(e.onMouseDown, () => {
            A.current = !0;
          }),
          onFocus: he(e.onFocus, (M) => {
            const D = !A.current;
            if (M.target === M.currentTarget && D && !w) {
              const W = new CustomEvent(Yd, kB);
              if (M.currentTarget.dispatchEvent(W), !W.defaultPrevented) {
                const U = P().filter((G) => G.focusable), re = U.find((G) => G.active), j = U.find((G) => G.id === h), oe = [re, j, ...U].filter(
                  Boolean
                ).map((G) => G.ref.current);
                d6(oe, m);
              }
            }
            A.current = !1;
          }),
          onBlur: he(e.onBlur, () => N(!1))
        }
      )
    }
  );
}), c6 = "RovingFocusGroupItem", u6 = d.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      ...l
    } = e, c = it(), f = i || c, p = VB(c6, n), m = p.currentTabStopId === f, v = s6(n), { onFocusableItemAdd: C, onFocusableItemRemove: x } = p;
    return d.useEffect(() => {
      if (r)
        return C(), () => x();
    }, [r, C, x]), /* @__PURE__ */ s(
      Hf.ItemSlot,
      {
        scope: n,
        id: f,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ s(
          ve.span,
          {
            tabIndex: m ? 0 : -1,
            "data-orientation": p.orientation,
            ...l,
            ref: t,
            onMouseDown: he(e.onMouseDown, (y) => {
              r ? p.onItemFocus(f) : y.preventDefault();
            }),
            onFocus: he(e.onFocus, () => p.onItemFocus(f)),
            onKeyDown: he(e.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                p.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget) return;
              const h = GB(y, p.orientation, p.dir);
              if (h !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey) return;
                y.preventDefault();
                let w = v().filter((N) => N.focusable).map((N) => N.ref.current);
                if (h === "last") w.reverse();
                else if (h === "prev" || h === "next") {
                  h === "prev" && w.reverse();
                  const N = w.indexOf(y.currentTarget);
                  w = p.loop ? zB(w, N + 1) : w.slice(N + 1);
                }
                setTimeout(() => d6(w));
              }
            })
          }
        )
      }
    );
  }
);
u6.displayName = c6;
var HB = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function UB(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function GB(e, t, n) {
  const r = UB(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return HB[r];
}
function d6(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function zB(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var f6 = l6, p6 = u6;
function qB(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var m6 = (e) => {
  const { present: t, children: n } = e, r = KB(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), i = ke(r.ref, YB(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: i }) : null;
};
m6.displayName = "Presence";
function KB(e) {
  const [t, n] = d.useState(), r = d.useRef({}), o = d.useRef(e), i = d.useRef("none"), l = e ? "mounted" : "unmounted", [c, f] = qB(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const p = Gs(r.current);
    i.current = c === "mounted" ? p : "none";
  }, [c]), be(() => {
    const p = r.current, m = o.current;
    if (m !== e) {
      const C = i.current, x = Gs(p);
      e ? f("MOUNT") : x === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && C !== x ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), be(() => {
    if (t) {
      let p;
      const m = t.ownerDocument.defaultView ?? window, v = (x) => {
        const h = Gs(r.current).includes(x.animationName);
        if (x.target === t && h && (f("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, C = (x) => {
        x.target === t && (i.current = Gs(r.current));
      };
      return t.addEventListener("animationstart", C), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        m.clearTimeout(p), t.removeEventListener("animationstart", C), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: d.useCallback((p) => {
      p && (r.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function Gs(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function YB(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var _p = "Radio", [ZB, h6] = a6(_p), [XB, jB] = ZB(_p), g6 = d.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: o = !1,
      required: i,
      disabled: l,
      value: c = "on",
      onCheck: f,
      form: p,
      ...m
    } = e, [v, C] = d.useState(null), x = ke(t, (b) => C(b)), y = d.useRef(!1), h = v ? p || !!v.closest("form") : !0;
    return /* @__PURE__ */ R(XB, { scope: n, checked: o, disabled: l, children: [
      /* @__PURE__ */ s(
        ve.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": x6(o),
          "data-disabled": l ? "" : void 0,
          disabled: l,
          value: c,
          ...m,
          ref: x,
          onClick: he(e.onClick, (b) => {
            o || f == null || f(), h && (y.current = b.isPropagationStopped(), y.current || b.stopPropagation());
          })
        }
      ),
      h && /* @__PURE__ */ s(
        QB,
        {
          control: v,
          bubbles: !y.current,
          name: r,
          value: c,
          checked: o,
          required: i,
          disabled: l,
          form: p,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
g6.displayName = _p;
var v6 = "RadioIndicator", C6 = d.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: r, ...o } = e, i = jB(v6, n);
    return /* @__PURE__ */ s(m6, { present: r || i.checked, children: /* @__PURE__ */ s(
      ve.span,
      {
        "data-state": x6(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
C6.displayName = v6;
var QB = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, i = d.useRef(null), l = Ni(n), c = Hr(t);
  return d.useEffect(() => {
    const f = i.current, p = window.HTMLInputElement.prototype, v = Object.getOwnPropertyDescriptor(p, "checked").set;
    if (l !== n && v) {
      const C = new Event("click", { bubbles: r });
      v.call(f, n), f.dispatchEvent(C);
    }
  }, [l, n, r]), /* @__PURE__ */ s(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...c,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function x6(e) {
  return e ? "checked" : "unchecked";
}
var JB = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Rp = "RadioGroup", [eV, dZ] = a6(Rp, [
  Ec,
  h6
]), b6 = Ec(), y6 = h6(), [tV, nV] = eV(Rp), w6 = d.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: o,
      value: i,
      required: l = !1,
      disabled: c = !1,
      orientation: f,
      dir: p,
      loop: m = !0,
      onValueChange: v,
      ...C
    } = e, x = b6(n), y = vn(p), [h, b] = et({
      prop: i,
      defaultProp: o,
      onChange: v
    });
    return /* @__PURE__ */ s(
      tV,
      {
        scope: n,
        name: r,
        required: l,
        disabled: c,
        value: h,
        onValueChange: b,
        children: /* @__PURE__ */ s(
          f6,
          {
            asChild: !0,
            ...x,
            orientation: f,
            dir: y,
            loop: m,
            children: /* @__PURE__ */ s(
              ve.div,
              {
                role: "radiogroup",
                "aria-required": l,
                "aria-orientation": f,
                "data-disabled": c ? "" : void 0,
                dir: y,
                ...C,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
w6.displayName = Rp;
var S6 = "RadioGroupItem", N6 = d.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: r, ...o } = e, i = nV(S6, n), l = i.disabled || r, c = b6(n), f = y6(n), p = d.useRef(null), m = ke(t, p), v = i.value === o.value, C = d.useRef(!1);
    return d.useEffect(() => {
      const x = (h) => {
        JB.includes(h.key) && (C.current = !0);
      }, y = () => C.current = !1;
      return document.addEventListener("keydown", x), document.addEventListener("keyup", y), () => {
        document.removeEventListener("keydown", x), document.removeEventListener("keyup", y);
      };
    }, []), /* @__PURE__ */ s(
      p6,
      {
        asChild: !0,
        ...c,
        focusable: !l,
        active: v,
        children: /* @__PURE__ */ s(
          g6,
          {
            disabled: l,
            required: i.required,
            checked: v,
            ...f,
            ...o,
            name: i.name,
            ref: m,
            onCheck: () => i.onValueChange(o.value),
            onKeyDown: he((x) => {
              x.key === "Enter" && x.preventDefault();
            }),
            onFocus: he(o.onFocus, () => {
              var x;
              C.current && ((x = p.current) == null || x.click());
            })
          }
        )
      }
    );
  }
);
N6.displayName = S6;
var rV = "RadioGroupIndicator", _6 = d.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...r } = e, o = y6(n);
    return /* @__PURE__ */ s(C6, { ...o, ...r, ref: t });
  }
);
_6.displayName = rV;
var Pa = w6, Tr = N6, oV = _6;
function so({
  options: e,
  radioValue: t,
  setRadioValue: n
}) {
  return /* @__PURE__ */ s(
    Pa,
    {
      className: "flex flex-row",
      value: t,
      onValueChange: (r) => {
        n(r);
      },
      "aria-label": "View density",
      children: /* @__PURE__ */ s("div", { className: "flex items-center gap-x-1", children: e.length > 0 && e.map((r, o) => /* @__PURE__ */ R(
        Tr,
        {
          className: F(
            "data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:border-interactiveBorderHover data-[state=unchecked]:hover:bg-interfaceBgDefault flex h-12 w-12 flex-col items-center justify-center rounded border p-2 data-[state=checked]:border-2",
            r.bgColor,
            r.borderColor,
            r.textColor
          ),
          onClick: () => {
            r.text === t && n("");
          },
          tabIndex: 1,
          value: r.text,
          children: [
            r.icon,
            /* @__PURE__ */ s("p", { className: "mt-1 text-xs font-normal leading-[14px]", children: r.text })
          ]
        },
        o
      )) })
    }
  );
}
const Ep = q(
  ({ className: e, type: t, ...n }, r) => /* @__PURE__ */ s(
    "input",
    {
      type: t,
      className: F(
        "border-input bg-background ring-offset-background placeholder:text-muted-foreground placeholder:text-[1rem] placeholder:leading-[1.25rem] focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-[1rem] leading-[1.25rem] file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: r,
      ...n
    }
  )
);
Ep.displayName = "Input";
var iV = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], aV = iV.reduce((e, t) => {
  const n = d.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, c = i ? rn : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(c, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), sV = "Label", R6 = d.forwardRef((e, t) => /* @__PURE__ */ s(
  aV.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var o;
      n.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
R6.displayName = sV;
var E6 = R6;
const lV = cr(
  "font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), nt = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  E6,
  {
    ref: n,
    className: F(lV(), e),
    ...t
  }
));
nt.displayName = E6.displayName;
function fZ({
  allowMultiSelect: e = !0,
  className: t,
  disabled: n,
  // noOptionsFoundMessage,
  filter: r,
  onChange: o,
  onInputChange: i,
  options: l,
  placeholder: c,
  values: f
}) {
  const p = Je(null), [m, v] = ne(!1), [C, x] = ne(""), y = hn(
    (b) => {
      const w = f.filter((N) => N.value !== b.value);
      o(w);
    },
    [o, f]
  ), h = hn(
    (b) => {
      const w = p.current;
      if (w) {
        if ((b.key === "Delete" || b.key === "Backspace") && w.value === "") {
          const N = [...f];
          N.pop(), o(N);
        }
        b.key === "Escape" && w.blur();
      }
    },
    [o, f]
  );
  return /* @__PURE__ */ R(
    ya,
    {
      className: "overflow-visible bg-transparent",
      filter: r,
      onKeyDown: h,
      children: [
        /* @__PURE__ */ s(
          "div",
          {
            className: F(
              "border-input bg-interfaceWhite ring-offset-background focus-within:ring-ring group rounded-md border px-3 py-2 text-sm focus:outline-hidden focus-within:ring-2 focus-within:ring-offset-2",
              t
            ),
            children: /* @__PURE__ */ R("div", { className: "flex flex-wrap gap-1", children: [
              f.map((b) => /* @__PURE__ */ R(n$, { variant: "secondary", children: [
                b.label,
                /* @__PURE__ */ s(
                  "button",
                  {
                    className: "ring-offset-background focus:ring-ring ml-1 rounded-full outline-hidden focus:ring-2 focus:ring-offset-2",
                    onKeyDown: (w) => {
                      w.key === "Enter" && y(b);
                    },
                    onMouseDown: (w) => {
                      w.preventDefault(), w.stopPropagation();
                    },
                    onClick: () => y(b),
                    children: /* @__PURE__ */ s(Ll, { className: "text-muted-foreground hover:text-foreground h-3 w-3" })
                  }
                )
              ] }, b.value)),
              /* @__PURE__ */ s(
                Mt.Input,
                {
                  className: "placeholder:text-muted-foreground ml-2 flex-1 bg-transparent outline-hidden",
                  disabled: n,
                  onBlur: () => v(!1),
                  onFocus: () => v(!0),
                  onValueChange: (b) => {
                    x(b), i == null || i(b);
                  },
                  placeholder: c,
                  ref: p,
                  value: C
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ s("div", { className: "relative", children: /* @__PURE__ */ s(jl, { children: m && l.length > 0 ? /* @__PURE__ */ s("div", { className: "mt-2 bg-popover text-popover-foreground animate-in absolute top-0 z-10 w-full rounded-md shadow-md outline-hidden max-h-64 overflow-auto border", children: /* @__PURE__ */ s(Ql, { className: "h-full", children: l.map((b) => /* @__PURE__ */ s(
          Jl,
          {
            className: "cursor-pointer",
            disabled: n,
            keywords: b.keywords,
            onMouseDown: (w) => {
              w.preventDefault(), w.stopPropagation();
            },
            onSelect: (w) => {
              x(""), i == null || i(""), o(e ? [...f, b] : [b]);
            },
            children: b.label
          },
          b.value
        )) }) }) : null }) })
      ]
    }
  );
}
function P6(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    const p = (v) => {
      var w;
      const { scope: C, children: x, ...y } = v, h = ((w = C == null ? void 0 : C[e]) == null ? void 0 : w[f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    };
    p.displayName = i + "Provider";
    function m(v, C) {
      var h;
      const x = ((h = C == null ? void 0 : C[e]) == null ? void 0 : h[f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, cV(o, ...t)];
}
function cV(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function wt(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function s2(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Pp(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = s2(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : s2(e[o], null);
        }
      };
  };
}
function Wn(...e) {
  return d.useCallback(Pp(...e), e);
}
var Nl = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = d.Children.toArray(n), i = o.find(dV);
  if (i) {
    const l = i.props.children, c = o.map((f) => f === i ? d.Children.count(l) > 1 ? d.Children.only(null) : d.isValidElement(l) ? l.props.children : null : f);
    return /* @__PURE__ */ s(Uf, { ...r, ref: t, children: d.isValidElement(l) ? d.cloneElement(l, void 0, c) : null });
  }
  return /* @__PURE__ */ s(Uf, { ...r, ref: t, children: n });
});
Nl.displayName = "Slot";
var Uf = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const o = pV(n);
    return d.cloneElement(n, {
      ...fV(r, n.props),
      // @ts-ignore
      ref: t ? Pp(t, o) : o
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
Uf.displayName = "SlotClone";
var uV = ({ children: e }) => /* @__PURE__ */ s(le, { children: e });
function dV(e) {
  return d.isValidElement(e) && e.type === uV;
}
function fV(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function pV(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var mV = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], zt = mV.reduce((e, t) => {
  const n = d.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, c = i ? Nl : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(c, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Gf(e, t) {
  e && Tn.flushSync(() => e.dispatchEvent(t));
}
function hV(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var Aa = (e) => {
  const { present: t, children: n } = e, r = gV(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), i = Wn(r.ref, vV(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: i }) : null;
};
Aa.displayName = "Presence";
function gV(e) {
  const [t, n] = d.useState(), r = d.useRef({}), o = d.useRef(e), i = d.useRef("none"), l = e ? "mounted" : "unmounted", [c, f] = hV(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const p = zs(r.current);
    i.current = c === "mounted" ? p : "none";
  }, [c]), be(() => {
    const p = r.current, m = o.current;
    if (m !== e) {
      const C = i.current, x = zs(p);
      e ? f("MOUNT") : x === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && C !== x ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), be(() => {
    if (t) {
      let p;
      const m = t.ownerDocument.defaultView ?? window, v = (x) => {
        const h = zs(r.current).includes(x.animationName);
        if (x.target === t && h && (f("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, C = (x) => {
        x.target === t && (i.current = zs(r.current));
      };
      return t.addEventListener("animationstart", C), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        m.clearTimeout(p), t.removeEventListener("animationstart", C), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: d.useCallback((p) => {
      p && (r.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function zs(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function vV(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function A6(e) {
  const t = e + "CollectionProvider", [n, r] = P6(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), l = (x) => {
    const { scope: y, children: h } = x, b = ae.useRef(null), w = ae.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ s(o, { scope: y, itemMap: w, collectionRef: b, children: h });
  };
  l.displayName = t;
  const c = e + "CollectionSlot", f = ae.forwardRef(
    (x, y) => {
      const { scope: h, children: b } = x, w = i(c, h), N = Wn(y, w.collectionRef);
      return /* @__PURE__ */ s(Nl, { ref: N, children: b });
    }
  );
  f.displayName = c;
  const p = e + "CollectionItemSlot", m = "data-radix-collection-item", v = ae.forwardRef(
    (x, y) => {
      const { scope: h, children: b, ...w } = x, N = ae.useRef(null), _ = Wn(y, N), P = i(p, h);
      return ae.useEffect(() => (P.itemMap.set(N, { ref: N, ...w }), () => void P.itemMap.delete(N))), /* @__PURE__ */ s(Nl, { [m]: "", ref: _, children: b });
    }
  );
  v.displayName = p;
  function C(x) {
    const y = i(e + "CollectionConsumer", x);
    return ae.useCallback(() => {
      const b = y.collectionRef.current;
      if (!b) return [];
      const w = Array.from(b.querySelectorAll(`[${m}]`));
      return Array.from(y.itemMap.values()).sort(
        (P, A) => w.indexOf(P.ref.current) - w.indexOf(A.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: l, Slot: f, ItemSlot: v },
    C,
    r
  ];
}
var CV = "DismissableLayer", zf = "dismissableLayer.update", xV = "dismissableLayer.pointerDownOutside", bV = "dismissableLayer.focusOutside", l2, T6 = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), $6 = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: l,
      onDismiss: c,
      ...f
    } = e, p = d.useContext(T6), [m, v] = d.useState(null), C = (m == null ? void 0 : m.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, x] = d.useState({}), y = Wn(t, (T) => v(T)), h = Array.from(p.layers), [b] = [...p.layersWithOutsidePointerEventsDisabled].slice(-1), w = h.indexOf(b), N = m ? h.indexOf(m) : -1, _ = p.layersWithOutsidePointerEventsDisabled.size > 0, P = N >= w, A = SV((T) => {
      const M = T.target, D = [...p.branches].some((W) => W.contains(M));
      !P || D || (o == null || o(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C), I = NV((T) => {
      const M = T.target;
      [...p.branches].some((W) => W.contains(M)) || (i == null || i(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C);
    return Wr((T) => {
      N === p.layers.size - 1 && (r == null || r(T), !T.defaultPrevented && c && (T.preventDefault(), c()));
    }, C), d.useEffect(() => {
      if (m)
        return n && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (l2 = C.body.style.pointerEvents, C.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(m)), p.layers.add(m), c2(), () => {
          n && p.layersWithOutsidePointerEventsDisabled.size === 1 && (C.body.style.pointerEvents = l2);
        };
    }, [m, C, n, p]), d.useEffect(() => () => {
      m && (p.layers.delete(m), p.layersWithOutsidePointerEventsDisabled.delete(m), c2());
    }, [m, p]), d.useEffect(() => {
      const T = () => x({});
      return document.addEventListener(zf, T), () => document.removeEventListener(zf, T);
    }, []), /* @__PURE__ */ s(
      zt.div,
      {
        ...f,
        ref: y,
        style: {
          pointerEvents: _ ? P ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: wt(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: wt(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: wt(
          e.onPointerDownCapture,
          A.onPointerDownCapture
        )
      }
    );
  }
);
$6.displayName = CV;
var yV = "DismissableLayerBranch", wV = d.forwardRef((e, t) => {
  const n = d.useContext(T6), r = d.useRef(null), o = Wn(t, r);
  return d.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ s(zt.div, { ...e, ref: o });
});
wV.displayName = yV;
function SV(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1), o = d.useRef(() => {
  });
  return d.useEffect(() => {
    const i = (c) => {
      if (c.target && !r.current) {
        let f = function() {
          L6(
            xV,
            n,
            p,
            { discrete: !0 }
          );
        };
        const p = { originalEvent: c };
        c.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = f, t.addEventListener("click", o.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function NV(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && L6(bV, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function c2() {
  const e = new CustomEvent(zf);
  document.dispatchEvent(e);
}
function L6(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Gf(o, i) : o.dispatchEvent(i);
}
var _V = "VisuallyHidden", M6 = d.forwardRef(
  (e, t) => /* @__PURE__ */ s(
    zt.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
M6.displayName = _V;
var RV = M6, Pi = "NavigationMenu", [Ap, I6, EV] = A6(Pi), [qf, PV, AV] = A6(Pi), [Tp, pZ] = P6(
  Pi,
  [EV, AV]
), [TV, xn] = Tp(Pi), [$V, LV] = Tp(Pi), O6 = d.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: r,
      onValueChange: o,
      defaultValue: i,
      delayDuration: l = 200,
      skipDelayDuration: c = 300,
      orientation: f = "horizontal",
      dir: p,
      ...m
    } = e, [v, C] = d.useState(null), x = Wn(t, (D) => C(D)), y = vn(p), h = d.useRef(0), b = d.useRef(0), w = d.useRef(0), [N, _] = d.useState(!0), [P = "", A] = et({
      prop: r,
      onChange: (D) => {
        const W = D !== "", U = c > 0;
        W ? (window.clearTimeout(w.current), U && _(!1)) : (window.clearTimeout(w.current), w.current = window.setTimeout(
          () => _(!0),
          c
        )), o == null || o(D);
      },
      defaultProp: i
    }), I = d.useCallback(() => {
      window.clearTimeout(b.current), b.current = window.setTimeout(() => A(""), 150);
    }, [A]), T = d.useCallback(
      (D) => {
        window.clearTimeout(b.current), A(D);
      },
      [A]
    ), M = d.useCallback(
      (D) => {
        P === D ? window.clearTimeout(b.current) : h.current = window.setTimeout(() => {
          window.clearTimeout(b.current), A(D);
        }, l);
      },
      [P, A, l]
    );
    return d.useEffect(() => () => {
      window.clearTimeout(h.current), window.clearTimeout(b.current), window.clearTimeout(w.current);
    }, []), /* @__PURE__ */ s(
      D6,
      {
        scope: n,
        isRootMenu: !0,
        value: P,
        dir: y,
        orientation: f,
        rootNavigationMenu: v,
        onTriggerEnter: (D) => {
          window.clearTimeout(h.current), N ? M(D) : T(D);
        },
        onTriggerLeave: () => {
          window.clearTimeout(h.current), I();
        },
        onContentEnter: () => window.clearTimeout(b.current),
        onContentLeave: I,
        onItemSelect: (D) => {
          A((W) => W === D ? "" : D);
        },
        onItemDismiss: () => A(""),
        children: /* @__PURE__ */ s(
          zt.nav,
          {
            "aria-label": "Main",
            "data-orientation": f,
            dir: y,
            ...m,
            ref: x
          }
        )
      }
    );
  }
);
O6.displayName = Pi;
var k6 = "NavigationMenuSub", MV = d.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: r,
      onValueChange: o,
      defaultValue: i,
      orientation: l = "horizontal",
      ...c
    } = e, f = xn(k6, n), [p = "", m] = et({
      prop: r,
      onChange: o,
      defaultProp: i
    });
    return /* @__PURE__ */ s(
      D6,
      {
        scope: n,
        isRootMenu: !1,
        value: p,
        dir: f.dir,
        orientation: l,
        rootNavigationMenu: f.rootNavigationMenu,
        onTriggerEnter: (v) => m(v),
        onItemSelect: (v) => m(v),
        onItemDismiss: () => m(""),
        children: /* @__PURE__ */ s(zt.div, { "data-orientation": l, ...c, ref: t })
      }
    );
  }
);
MV.displayName = k6;
var D6 = (e) => {
  const {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: r,
    dir: o,
    orientation: i,
    children: l,
    value: c,
    onItemSelect: f,
    onItemDismiss: p,
    onTriggerEnter: m,
    onTriggerLeave: v,
    onContentEnter: C,
    onContentLeave: x
  } = e, [y, h] = d.useState(null), [b, w] = d.useState(/* @__PURE__ */ new Map()), [N, _] = d.useState(null);
  return /* @__PURE__ */ s(
    TV,
    {
      scope: t,
      isRootMenu: n,
      rootNavigationMenu: r,
      value: c,
      previousValue: Ni(c),
      baseId: it(),
      dir: o,
      orientation: i,
      viewport: y,
      onViewportChange: h,
      indicatorTrack: N,
      onIndicatorTrackChange: _,
      onTriggerEnter: xe(m),
      onTriggerLeave: xe(v),
      onContentEnter: xe(C),
      onContentLeave: xe(x),
      onItemSelect: xe(f),
      onItemDismiss: xe(p),
      onViewportContentChange: d.useCallback((P, A) => {
        w((I) => (I.set(P, A), new Map(I)));
      }, []),
      onViewportContentRemove: d.useCallback((P) => {
        w((A) => A.has(P) ? (A.delete(P), new Map(A)) : A);
      }, []),
      children: /* @__PURE__ */ s(Ap.Provider, { scope: t, children: /* @__PURE__ */ s($V, { scope: t, items: b, children: l }) })
    }
  );
}, F6 = "NavigationMenuList", B6 = d.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, o = xn(F6, n), i = /* @__PURE__ */ s(zt.ul, { "data-orientation": o.orientation, ...r, ref: t });
    return /* @__PURE__ */ s(zt.div, { style: { position: "relative" }, ref: o.onIndicatorTrackChange, children: /* @__PURE__ */ s(Ap.Slot, { scope: n, children: o.isRootMenu ? /* @__PURE__ */ s(Z6, { asChild: !0, children: i }) : i }) });
  }
);
B6.displayName = F6;
var V6 = "NavigationMenuItem", [IV, W6] = Tp(V6), H6 = d.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, value: r, ...o } = e, i = it(), l = r || i || "LEGACY_REACT_AUTO_VALUE", c = d.useRef(null), f = d.useRef(null), p = d.useRef(null), m = d.useRef(() => {
    }), v = d.useRef(!1), C = d.useCallback((y = "start") => {
      if (c.current) {
        m.current();
        const h = Yf(c.current);
        h.length && Mp(y === "start" ? h : h.reverse());
      }
    }, []), x = d.useCallback(() => {
      if (c.current) {
        const y = Yf(c.current);
        y.length && (m.current = WV(y));
      }
    }, []);
    return /* @__PURE__ */ s(
      IV,
      {
        scope: n,
        value: l,
        triggerRef: f,
        contentRef: c,
        focusProxyRef: p,
        wasEscapeCloseRef: v,
        onEntryKeyDown: C,
        onFocusProxyEnter: C,
        onRootContentClose: x,
        onContentFocusOutside: x,
        children: /* @__PURE__ */ s(zt.li, { ...o, ref: t })
      }
    );
  }
);
H6.displayName = V6;
var Kf = "NavigationMenuTrigger", U6 = d.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, disabled: r, ...o } = e, i = xn(Kf, e.__scopeNavigationMenu), l = W6(Kf, e.__scopeNavigationMenu), c = d.useRef(null), f = Wn(c, l.triggerRef, t), p = j6(i.baseId, l.value), m = Q6(i.baseId, l.value), v = d.useRef(!1), C = d.useRef(!1), x = l.value === i.value;
  return /* @__PURE__ */ R(le, { children: [
    /* @__PURE__ */ s(Ap.ItemSlot, { scope: n, value: l.value, children: /* @__PURE__ */ s(X6, { asChild: !0, children: /* @__PURE__ */ s(
      zt.button,
      {
        id: p,
        disabled: r,
        "data-disabled": r ? "" : void 0,
        "data-state": Ip(x),
        "aria-expanded": x,
        "aria-controls": m,
        ...o,
        ref: f,
        onPointerEnter: wt(e.onPointerEnter, () => {
          C.current = !1, l.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: wt(
          e.onPointerMove,
          _l(() => {
            r || C.current || l.wasEscapeCloseRef.current || v.current || (i.onTriggerEnter(l.value), v.current = !0);
          })
        ),
        onPointerLeave: wt(
          e.onPointerLeave,
          _l(() => {
            r || (i.onTriggerLeave(), v.current = !1);
          })
        ),
        onClick: wt(e.onClick, () => {
          i.onItemSelect(l.value), C.current = x;
        }),
        onKeyDown: wt(e.onKeyDown, (y) => {
          const b = { horizontal: "ArrowDown", vertical: i.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[i.orientation];
          x && y.key === b && (l.onEntryKeyDown(), y.preventDefault());
        })
      }
    ) }) }),
    x && /* @__PURE__ */ R(le, { children: [
      /* @__PURE__ */ s(
        RV,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: l.focusProxyRef,
          onFocus: (y) => {
            const h = l.contentRef.current, b = y.relatedTarget, w = b === c.current, N = h == null ? void 0 : h.contains(b);
            (w || !N) && l.onFocusProxyEnter(w ? "start" : "end");
          }
        }
      ),
      i.viewport && /* @__PURE__ */ s("span", { "aria-owns": m })
    ] })
  ] });
});
U6.displayName = Kf;
var OV = "NavigationMenuLink", u2 = "navigationMenu.linkSelect", G6 = d.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, active: r, onSelect: o, ...i } = e;
    return /* @__PURE__ */ s(X6, { asChild: !0, children: /* @__PURE__ */ s(
      zt.a,
      {
        "data-active": r ? "" : void 0,
        "aria-current": r ? "page" : void 0,
        ...i,
        ref: t,
        onClick: wt(
          e.onClick,
          (l) => {
            const c = l.target, f = new CustomEvent(u2, {
              bubbles: !0,
              cancelable: !0
            });
            if (c.addEventListener(u2, (p) => o == null ? void 0 : o(p), { once: !0 }), Gf(c, f), !f.defaultPrevented && !l.metaKey) {
              const p = new CustomEvent(al, {
                bubbles: !0,
                cancelable: !0
              });
              Gf(c, p);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
G6.displayName = OV;
var $p = "NavigationMenuIndicator", z6 = d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = xn($p, e.__scopeNavigationMenu), i = !!o.value;
  return o.indicatorTrack ? Br.createPortal(
    /* @__PURE__ */ s(Aa, { present: n || i, children: /* @__PURE__ */ s(kV, { ...r, ref: t }) }),
    o.indicatorTrack
  ) : null;
});
z6.displayName = $p;
var kV = d.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, ...r } = e, o = xn($p, n), i = I6(n), [l, c] = d.useState(
    null
  ), [f, p] = d.useState(null), m = o.orientation === "horizontal", v = !!o.value;
  d.useEffect(() => {
    var h;
    const y = (h = i().find((b) => b.value === o.value)) == null ? void 0 : h.ref.current;
    y && c(y);
  }, [i, o.value]);
  const C = () => {
    l && p({
      size: m ? l.offsetWidth : l.offsetHeight,
      offset: m ? l.offsetLeft : l.offsetTop
    });
  };
  return Zf(l, C), Zf(o.indicatorTrack, C), f ? /* @__PURE__ */ s(
    zt.div,
    {
      "aria-hidden": !0,
      "data-state": v ? "visible" : "hidden",
      "data-orientation": o.orientation,
      ...r,
      ref: t,
      style: {
        position: "absolute",
        ...m ? {
          left: 0,
          width: f.size + "px",
          transform: `translateX(${f.offset}px)`
        } : {
          top: 0,
          height: f.size + "px",
          transform: `translateY(${f.offset}px)`
        },
        ...r.style
      }
    }
  ) : null;
}), vi = "NavigationMenuContent", q6 = d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = xn(vi, e.__scopeNavigationMenu), i = W6(vi, e.__scopeNavigationMenu), l = Wn(i.contentRef, t), c = i.value === o.value, f = {
    value: i.value,
    triggerRef: i.triggerRef,
    focusProxyRef: i.focusProxyRef,
    wasEscapeCloseRef: i.wasEscapeCloseRef,
    onContentFocusOutside: i.onContentFocusOutside,
    onRootContentClose: i.onRootContentClose,
    ...r
  };
  return o.viewport ? /* @__PURE__ */ s(DV, { forceMount: n, ...f, ref: l }) : /* @__PURE__ */ s(Aa, { present: n || c, children: /* @__PURE__ */ s(
    K6,
    {
      "data-state": Ip(c),
      ...f,
      ref: l,
      onPointerEnter: wt(e.onPointerEnter, o.onContentEnter),
      onPointerLeave: wt(
        e.onPointerLeave,
        _l(o.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !c && o.isRootMenu ? "none" : void 0,
        ...f.style
      }
    }
  ) });
});
q6.displayName = vi;
var DV = d.forwardRef((e, t) => {
  const n = xn(vi, e.__scopeNavigationMenu), { onViewportContentChange: r, onViewportContentRemove: o } = n;
  return be(() => {
    r(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, r]), be(() => () => o(e.value), [e.value, o]), null;
}), al = "navigationMenu.rootContentDismiss", K6 = d.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: n,
    value: r,
    triggerRef: o,
    focusProxyRef: i,
    wasEscapeCloseRef: l,
    onRootContentClose: c,
    onContentFocusOutside: f,
    ...p
  } = e, m = xn(vi, n), v = d.useRef(null), C = Wn(v, t), x = j6(m.baseId, r), y = Q6(m.baseId, r), h = I6(n), b = d.useRef(null), { onItemDismiss: w } = m;
  d.useEffect(() => {
    const _ = v.current;
    if (m.isRootMenu && _) {
      const P = () => {
        var A;
        w(), c(), _.contains(document.activeElement) && ((A = o.current) == null || A.focus());
      };
      return _.addEventListener(al, P), () => _.removeEventListener(al, P);
    }
  }, [m.isRootMenu, e.value, o, w, c]);
  const N = d.useMemo(() => {
    const P = h().map((W) => W.value);
    m.dir === "rtl" && P.reverse();
    const A = P.indexOf(m.value), I = P.indexOf(m.previousValue), T = r === m.value, M = I === P.indexOf(r);
    if (!T && !M) return b.current;
    const D = (() => {
      if (A !== I) {
        if (T && I !== -1) return A > I ? "from-end" : "from-start";
        if (M && A !== -1) return A > I ? "to-start" : "to-end";
      }
      return null;
    })();
    return b.current = D, D;
  }, [m.previousValue, m.value, m.dir, h, r]);
  return /* @__PURE__ */ s(Z6, { asChild: !0, children: /* @__PURE__ */ s(
    $6,
    {
      id: y,
      "aria-labelledby": x,
      "data-motion": N,
      "data-orientation": m.orientation,
      ...p,
      ref: C,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        var P;
        const _ = new Event(al, {
          bubbles: !0,
          cancelable: !0
        });
        (P = v.current) == null || P.dispatchEvent(_);
      },
      onFocusOutside: wt(e.onFocusOutside, (_) => {
        var A;
        f();
        const P = _.target;
        (A = m.rootNavigationMenu) != null && A.contains(P) && _.preventDefault();
      }),
      onPointerDownOutside: wt(e.onPointerDownOutside, (_) => {
        var T;
        const P = _.target, A = h().some((M) => {
          var D;
          return (D = M.ref.current) == null ? void 0 : D.contains(P);
        }), I = m.isRootMenu && ((T = m.viewport) == null ? void 0 : T.contains(P));
        (A || I || !m.isRootMenu) && _.preventDefault();
      }),
      onKeyDown: wt(e.onKeyDown, (_) => {
        var I;
        const P = _.altKey || _.ctrlKey || _.metaKey;
        if (_.key === "Tab" && !P) {
          const T = Yf(_.currentTarget), M = document.activeElement, D = T.findIndex((re) => re === M), U = _.shiftKey ? T.slice(0, D).reverse() : T.slice(D + 1, T.length);
          Mp(U) ? _.preventDefault() : (I = i.current) == null || I.focus();
        }
      }),
      onEscapeKeyDown: wt(e.onEscapeKeyDown, (_) => {
        l.current = !0;
      })
    }
  ) });
}), Lp = "NavigationMenuViewport", Y6 = d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = !!xn(Lp, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ s(Aa, { present: n || i, children: /* @__PURE__ */ s(FV, { ...r, ref: t }) });
});
Y6.displayName = Lp;
var FV = d.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, children: r, ...o } = e, i = xn(Lp, n), l = Wn(t, i.onViewportChange), c = LV(
    vi,
    e.__scopeNavigationMenu
  ), [f, p] = d.useState(null), [m, v] = d.useState(null), C = f ? (f == null ? void 0 : f.width) + "px" : void 0, x = f ? (f == null ? void 0 : f.height) + "px" : void 0, y = !!i.value, h = y ? i.value : i.previousValue;
  return Zf(m, () => {
    m && p({ width: m.offsetWidth, height: m.offsetHeight });
  }), /* @__PURE__ */ s(
    zt.div,
    {
      "data-state": Ip(y),
      "data-orientation": i.orientation,
      ...o,
      ref: l,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !y && i.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": C,
        "--radix-navigation-menu-viewport-height": x,
        ...o.style
      },
      onPointerEnter: wt(e.onPointerEnter, i.onContentEnter),
      onPointerLeave: wt(e.onPointerLeave, _l(i.onContentLeave)),
      children: Array.from(c.items).map(([w, { ref: N, forceMount: _, ...P }]) => {
        const A = h === w;
        return /* @__PURE__ */ s(Aa, { present: _ || A, children: /* @__PURE__ */ s(
          K6,
          {
            ...P,
            ref: Pp(N, (I) => {
              A && I && v(I);
            })
          }
        ) }, w);
      })
    }
  );
}), BV = "FocusGroup", Z6 = d.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, o = xn(BV, n);
    return /* @__PURE__ */ s(qf.Provider, { scope: n, children: /* @__PURE__ */ s(qf.Slot, { scope: n, children: /* @__PURE__ */ s(zt.div, { dir: o.dir, ...r, ref: t }) }) });
  }
), d2 = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], VV = "FocusGroupItem", X6 = d.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, o = PV(n), i = xn(VV, n);
    return /* @__PURE__ */ s(qf.ItemSlot, { scope: n, children: /* @__PURE__ */ s(
      zt.button,
      {
        ...r,
        ref: t,
        onKeyDown: wt(e.onKeyDown, (l) => {
          if (["Home", "End", ...d2].includes(l.key)) {
            let f = o().map((v) => v.ref.current);
            if ([i.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(l.key) && f.reverse(), d2.includes(l.key)) {
              const v = f.indexOf(l.currentTarget);
              f = f.slice(v + 1);
            }
            setTimeout(() => Mp(f)), l.preventDefault();
          }
        })
      }
    ) });
  }
);
function Yf(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Mp(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function WV(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function Zf(e, t) {
  const n = xe(t);
  be(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [e, n]);
}
function Ip(e) {
  return e ? "open" : "closed";
}
function j6(e, t) {
  return `${e}-trigger-${t}`;
}
function Q6(e, t) {
  return `${e}-content-${t}`;
}
function _l(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var J6 = O6, e7 = B6, HV = H6, t7 = U6, UV = G6, n7 = z6, r7 = q6, o7 = Y6;
const GV = q(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ R(
  J6,
  {
    ref: r,
    className: F(
      "relative z-10 flex max-w-max flex-1 items-center justify-center",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ s(i7, {})
    ]
  }
));
GV.displayName = J6.displayName;
const zV = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  e7,
  {
    ref: n,
    className: F(
      "group flex flex-1 list-none items-center justify-center space-x-1",
      e
    ),
    ...t
  }
));
zV.displayName = e7.displayName;
const mZ = HV, qV = cr(
  "group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-hidden disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50"
), KV = q(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ R(
  t7,
  {
    ref: r,
    className: F(qV(), "group", e),
    ...n,
    children: [
      t,
      " ",
      /* @__PURE__ */ s(
        va,
        {
          className: "relative top-[1px] ml-1 h-3 w-3 transition duration-200 group-data-[state=open]:rotate-180",
          "aria-hidden": "true"
        }
      )
    ]
  }
));
KV.displayName = t7.displayName;
const YV = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  r7,
  {
    ref: n,
    className: F(
      "data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 left-0 top-0 w-full md:absolute md:w-auto ",
      e
    ),
    ...t
  }
));
YV.displayName = r7.displayName;
const hZ = UV, i7 = q(({ className: e, ...t }, n) => /* @__PURE__ */ s("div", { className: F("absolute left-0 top-full flex justify-center"), children: /* @__PURE__ */ s(
  o7,
  {
    className: F(
      "origin-top-center bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90 relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-md border shadow-lg md:w-[var(--radix-navigation-menu-viewport-width)]",
      e
    ),
    ref: n,
    ...t
  }
) }));
i7.displayName = o7.displayName;
const ZV = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  n7,
  {
    ref: n,
    className: F(
      "data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:fade-in top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden",
      e
    ),
    ...t,
    children: /* @__PURE__ */ s("div", { className: "bg-border relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm shadow-md" })
  }
));
ZV.displayName = n7.displayName;
function XV(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    const p = (v) => {
      var w;
      const { scope: C, children: x, ...y } = v, h = ((w = C == null ? void 0 : C[e]) == null ? void 0 : w[f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    };
    p.displayName = i + "Provider";
    function m(v, C) {
      var h;
      const x = ((h = C == null ? void 0 : C[e]) == null ? void 0 : h[f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, jV(o, ...t)];
}
function jV(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var QV = "DismissableLayer", Xf = "dismissableLayer.update", JV = "dismissableLayer.pointerDownOutside", eW = "dismissableLayer.focusOutside", f2, a7 = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), s7 = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: l,
      onDismiss: c,
      ...f
    } = e, p = d.useContext(a7), [m, v] = d.useState(null), C = (m == null ? void 0 : m.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, x] = d.useState({}), y = ke(t, (T) => v(T)), h = Array.from(p.layers), [b] = [...p.layersWithOutsidePointerEventsDisabled].slice(-1), w = h.indexOf(b), N = m ? h.indexOf(m) : -1, _ = p.layersWithOutsidePointerEventsDisabled.size > 0, P = N >= w, A = rW((T) => {
      const M = T.target, D = [...p.branches].some((W) => W.contains(M));
      !P || D || (o == null || o(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C), I = oW((T) => {
      const M = T.target;
      [...p.branches].some((W) => W.contains(M)) || (i == null || i(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C);
    return Wr((T) => {
      N === p.layers.size - 1 && (r == null || r(T), !T.defaultPrevented && c && (T.preventDefault(), c()));
    }, C), d.useEffect(() => {
      if (m)
        return n && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (f2 = C.body.style.pointerEvents, C.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(m)), p.layers.add(m), p2(), () => {
          n && p.layersWithOutsidePointerEventsDisabled.size === 1 && (C.body.style.pointerEvents = f2);
        };
    }, [m, C, n, p]), d.useEffect(() => () => {
      m && (p.layers.delete(m), p.layersWithOutsidePointerEventsDisabled.delete(m), p2());
    }, [m, p]), d.useEffect(() => {
      const T = () => x({});
      return document.addEventListener(Xf, T), () => document.removeEventListener(Xf, T);
    }, []), /* @__PURE__ */ s(
      ve.div,
      {
        ...f,
        ref: y,
        style: {
          pointerEvents: _ ? P ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: he(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: he(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: he(
          e.onPointerDownCapture,
          A.onPointerDownCapture
        )
      }
    );
  }
);
s7.displayName = QV;
var tW = "DismissableLayerBranch", nW = d.forwardRef((e, t) => {
  const n = d.useContext(a7), r = d.useRef(null), o = ke(t, r);
  return d.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ s(ve.div, { ...e, ref: o });
});
nW.displayName = tW;
function rW(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1), o = d.useRef(() => {
  });
  return d.useEffect(() => {
    const i = (c) => {
      if (c.target && !r.current) {
        let f = function() {
          l7(
            JV,
            n,
            p,
            { discrete: !0 }
          );
        };
        const p = { originalEvent: c };
        c.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = f, t.addEventListener("click", o.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function oW(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && l7(eW, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function p2() {
  const e = new CustomEvent(Xf);
  document.dispatchEvent(e);
}
function l7(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Fl(o, i) : o.dispatchEvent(i);
}
var Zd = 0;
function iW() {
  d.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? m2()), document.body.insertAdjacentElement("beforeend", e[1] ?? m2()), Zd++, () => {
      Zd === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Zd--;
    };
  }, []);
}
function m2() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var aW = "Arrow", c7 = d.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ s(
    ve.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ s("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
c7.displayName = aW;
var sW = c7, Op = "Popper", [u7, d7] = Vr(Op), [lW, f7] = u7(Op), p7 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = d.useState(null);
  return /* @__PURE__ */ s(lW, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
p7.displayName = Op;
var m7 = "PopperAnchor", h7 = d.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = f7(m7, n), l = d.useRef(null), c = ke(t, l);
    return d.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || l.current);
    }), r ? null : /* @__PURE__ */ s(ve.div, { ...o, ref: c });
  }
);
h7.displayName = m7;
var kp = "PopperContent", [cW, uW] = u7(kp), g7 = d.forwardRef(
  (e, t) => {
    var ie, Ce, _e, Te, Me, Ie;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: l = 0,
      arrowPadding: c = 0,
      avoidCollisions: f = !0,
      collisionBoundary: p = [],
      collisionPadding: m = 0,
      sticky: v = "partial",
      hideWhenDetached: C = !1,
      updatePositionStrategy: x = "optimized",
      onPlaced: y,
      ...h
    } = e, b = f7(kp, n), [w, N] = d.useState(null), _ = ke(t, (ze) => N(ze)), [P, A] = d.useState(null), I = Hr(P), T = (I == null ? void 0 : I.width) ?? 0, M = (I == null ? void 0 : I.height) ?? 0, D = r + (i !== "center" ? "-" + i : ""), W = typeof m == "number" ? m : { top: 0, right: 0, bottom: 0, left: 0, ...m }, U = Array.isArray(p) ? p : [p], re = U.length > 0, j = {
      padding: W,
      boundary: U.filter(fW),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: re
    }, { refs: X, floatingStyles: oe, placement: G, isPositioned: Q, middlewareData: te } = pc({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: D,
      whileElementsMounted: (...ze) => fc(...ze, {
        animationFrame: x === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        mc({ mainAxis: o + M, alignmentAxis: l }),
        f && hc({
          mainAxis: !0,
          crossAxis: !1,
          limiter: v === "partial" ? gc() : void 0,
          ...j
        }),
        f && vc({ ...j }),
        Cc({
          ...j,
          apply: ({ elements: ze, rects: Ke, availableWidth: St, availableHeight: Kt }) => {
            const { width: ut, height: Mn } = Ke.reference, dt = ze.floating.style;
            dt.setProperty("--radix-popper-available-width", `${St}px`), dt.setProperty("--radix-popper-available-height", `${Kt}px`), dt.setProperty("--radix-popper-anchor-width", `${ut}px`), dt.setProperty("--radix-popper-anchor-height", `${Mn}px`);
          }
        }),
        P && bc({ element: P, padding: c }),
        pW({ arrowWidth: T, arrowHeight: M }),
        C && xc({ strategy: "referenceHidden", ...j })
      ]
    }), [ee, Pe] = x7(G), ce = xe(y);
    be(() => {
      Q && (ce == null || ce());
    }, [Q, ce]);
    const K = (ie = te.arrow) == null ? void 0 : ie.x, pe = (Ce = te.arrow) == null ? void 0 : Ce.y, ge = ((_e = te.arrow) == null ? void 0 : _e.centerOffset) !== 0, [ue, ye] = d.useState();
    return be(() => {
      w && ye(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ s(
      "div",
      {
        ref: X.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...oe,
          transform: Q ? oe.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ue,
          "--radix-popper-transform-origin": [
            (Te = te.transformOrigin) == null ? void 0 : Te.x,
            (Me = te.transformOrigin) == null ? void 0 : Me.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Ie = te.hide) == null ? void 0 : Ie.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ s(
          cW,
          {
            scope: n,
            placedSide: ee,
            onArrowChange: A,
            arrowX: K,
            arrowY: pe,
            shouldHideArrow: ge,
            children: /* @__PURE__ */ s(
              ve.div,
              {
                "data-side": ee,
                "data-align": Pe,
                ...h,
                ref: _,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: Q ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
g7.displayName = kp;
var v7 = "PopperArrow", dW = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, C7 = d.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = uW(v7, r), l = dW[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ s(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [l]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ s(
          sW,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
C7.displayName = v7;
function fW(e) {
  return e !== null;
}
var pW = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var b, w, N;
    const { placement: n, rects: r, middlewareData: o } = t, l = ((b = o.arrow) == null ? void 0 : b.centerOffset) !== 0, c = l ? 0 : e.arrowWidth, f = l ? 0 : e.arrowHeight, [p, m] = x7(n), v = { start: "0%", center: "50%", end: "100%" }[m], C = (((w = o.arrow) == null ? void 0 : w.x) ?? 0) + c / 2, x = (((N = o.arrow) == null ? void 0 : N.y) ?? 0) + f / 2;
    let y = "", h = "";
    return p === "bottom" ? (y = l ? v : `${C}px`, h = `${-f}px`) : p === "top" ? (y = l ? v : `${C}px`, h = `${r.floating.height + f}px`) : p === "right" ? (y = `${-f}px`, h = l ? v : `${x}px`) : p === "left" && (y = `${r.floating.width + f}px`, h = l ? v : `${x}px`), { data: { x: y, y: h } };
  }
});
function x7(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var mW = p7, b7 = h7, hW = g7, gW = C7, vW = "Portal", y7 = d.forwardRef((e, t) => {
  var c;
  const { container: n, ...r } = e, [o, i] = d.useState(!1);
  be(() => i(!0), []);
  const l = n || o && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return l ? Br.createPortal(/* @__PURE__ */ s(ve.div, { ...r, ref: t }), l) : null;
});
y7.displayName = vW;
function CW(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var Dp = (e) => {
  const { present: t, children: n } = e, r = xW(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), i = ke(r.ref, bW(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: i }) : null;
};
Dp.displayName = "Presence";
function xW(e) {
  const [t, n] = d.useState(), r = d.useRef({}), o = d.useRef(e), i = d.useRef("none"), l = e ? "mounted" : "unmounted", [c, f] = CW(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const p = qs(r.current);
    i.current = c === "mounted" ? p : "none";
  }, [c]), be(() => {
    const p = r.current, m = o.current;
    if (m !== e) {
      const C = i.current, x = qs(p);
      e ? f("MOUNT") : x === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && C !== x ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), be(() => {
    if (t) {
      let p;
      const m = t.ownerDocument.defaultView ?? window, v = (x) => {
        const h = qs(r.current).includes(x.animationName);
        if (x.target === t && h && (f("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, C = (x) => {
        x.target === t && (i.current = qs(r.current));
      };
      return t.addEventListener("animationstart", C), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        m.clearTimeout(p), t.removeEventListener("animationstart", C), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: d.useCallback((p) => {
      p && (r.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function qs(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function bW(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var w7 = W1(), Xd = function() {
}, Pc = d.forwardRef(function(e, t) {
  var n = d.useRef(null), r = d.useState({
    onScrollCapture: Xd,
    onWheelCapture: Xd,
    onTouchMoveCapture: Xd
  }), o = r[0], i = r[1], l = e.forwardProps, c = e.children, f = e.className, p = e.removeScrollBar, m = e.enabled, v = e.shards, C = e.sideCar, x = e.noIsolation, y = e.inert, h = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, N = e.gapMode, _ = Hn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), P = C, A = V1([n, t]), I = Ae(Ae({}, _), o);
  return d.createElement(
    d.Fragment,
    null,
    m && d.createElement(P, { sideCar: w7, removeScrollBar: p, shards: v, noIsolation: x, inert: y, setCallbacks: i, allowPinchZoom: !!h, lockRef: n, gapMode: N }),
    l ? d.cloneElement(d.Children.only(c), Ae(Ae({}, I), { ref: A })) : d.createElement(w, Ae({}, I, { className: f, ref: A }), c)
  );
});
Pc.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Pc.classNames = {
  fullWidth: li,
  zeroRight: si
};
var jf = !1;
if (typeof window < "u")
  try {
    var Ks = Object.defineProperty({}, "passive", {
      get: function() {
        return jf = !0, !0;
      }
    });
    window.addEventListener("test", Ks, Ks), window.removeEventListener("test", Ks, Ks);
  } catch {
    jf = !1;
  }
var Jo = jf ? { passive: !1 } : !1, yW = function(e) {
  return e.tagName === "TEXTAREA";
}, S7 = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !yW(e) && n[t] === "visible")
  );
}, wW = function(e) {
  return S7(e, "overflowY");
}, SW = function(e) {
  return S7(e, "overflowX");
}, h2 = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = N7(e, r);
    if (o) {
      var i = _7(e, r), l = i[1], c = i[2];
      if (l > c)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, NW = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, _W = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, N7 = function(e, t) {
  return e === "v" ? wW(t) : SW(t);
}, _7 = function(e, t) {
  return e === "v" ? NW(t) : _W(t);
}, RW = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, EW = function(e, t, n, r, o) {
  var i = RW(e, window.getComputedStyle(t).direction), l = i * r, c = n.target, f = t.contains(c), p = !1, m = l > 0, v = 0, C = 0;
  do {
    var x = _7(e, c), y = x[0], h = x[1], b = x[2], w = h - b - i * y;
    (y || w) && N7(e, c) && (v += w, C += y), c instanceof ShadowRoot ? c = c.host : c = c.parentNode;
  } while (
    // portaled content
    !f && c !== document.body || // self content
    f && (t.contains(c) || t === c)
  );
  return (m && (Math.abs(v) < 1 || !o) || !m && (Math.abs(C) < 1 || !o)) && (p = !0), p;
}, Ys = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, g2 = function(e) {
  return [e.deltaX, e.deltaY];
}, v2 = function(e) {
  return e && "current" in e ? e.current : e;
}, PW = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, AW = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, TW = 0, ei = [];
function $W(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), o = d.useState(TW++)[0], i = d.useState(Zl)[0], l = d.useRef(e);
  d.useEffect(function() {
    l.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = wi([e.lockRef.current], (e.shards || []).map(v2), !0).filter(Boolean);
      return h.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = d.useCallback(function(h, b) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !l.current.allowPinchZoom;
    var w = Ys(h), N = n.current, _ = "deltaX" in h ? h.deltaX : N[0] - w[0], P = "deltaY" in h ? h.deltaY : N[1] - w[1], A, I = h.target, T = Math.abs(_) > Math.abs(P) ? "h" : "v";
    if ("touches" in h && T === "h" && I.type === "range")
      return !1;
    var M = h2(T, I);
    if (!M)
      return !0;
    if (M ? A = T : (A = T === "v" ? "h" : "v", M = h2(T, I)), !M)
      return !1;
    if (!r.current && "changedTouches" in h && (_ || P) && (r.current = A), !A)
      return !0;
    var D = r.current || A;
    return EW(D, b, h, D === "h" ? _ : P, !0);
  }, []), f = d.useCallback(function(h) {
    var b = h;
    if (!(!ei.length || ei[ei.length - 1] !== i)) {
      var w = "deltaY" in b ? g2(b) : Ys(b), N = t.current.filter(function(A) {
        return A.name === b.type && (A.target === b.target || b.target === A.shadowParent) && PW(A.delta, w);
      })[0];
      if (N && N.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!N) {
        var _ = (l.current.shards || []).map(v2).filter(Boolean).filter(function(A) {
          return A.contains(b.target);
        }), P = _.length > 0 ? c(b, _[0]) : !l.current.noIsolation;
        P && b.cancelable && b.preventDefault();
      }
    }
  }, []), p = d.useCallback(function(h, b, w, N) {
    var _ = { name: h, delta: b, target: w, should: N, shadowParent: LW(w) };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(P) {
        return P !== _;
      });
    }, 1);
  }, []), m = d.useCallback(function(h) {
    n.current = Ys(h), r.current = void 0;
  }, []), v = d.useCallback(function(h) {
    p(h.type, g2(h), h.target, c(h, e.lockRef.current));
  }, []), C = d.useCallback(function(h) {
    p(h.type, Ys(h), h.target, c(h, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return ei.push(i), e.setCallbacks({
      onScrollCapture: v,
      onWheelCapture: v,
      onTouchMoveCapture: C
    }), document.addEventListener("wheel", f, Jo), document.addEventListener("touchmove", f, Jo), document.addEventListener("touchstart", m, Jo), function() {
      ei = ei.filter(function(h) {
        return h !== i;
      }), document.removeEventListener("wheel", f, Jo), document.removeEventListener("touchmove", f, Jo), document.removeEventListener("touchstart", m, Jo);
    };
  }, []);
  var x = e.removeScrollBar, y = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    y ? d.createElement(i, { styles: AW(o) }) : null,
    x ? d.createElement(U1, { gapMode: e.gapMode }) : null
  );
}
function LW(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const MW = H1(w7, $W);
var R7 = d.forwardRef(function(e, t) {
  return d.createElement(Pc, Ae({}, e, { ref: t, sideCar: MW }));
});
R7.classNames = Pc.classNames;
var Fp = "Popover", [E7, gZ] = XV(Fp, [
  d7
]), Ta = d7(), [IW, Gr] = E7(Fp), P7 = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: l = !1
  } = e, c = Ta(t), f = d.useRef(null), [p, m] = d.useState(!1), [v = !1, C] = et({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ s(mW, { ...c, children: /* @__PURE__ */ s(
    IW,
    {
      scope: t,
      contentId: it(),
      triggerRef: f,
      open: v,
      onOpenChange: C,
      onOpenToggle: d.useCallback(() => C((x) => !x), [C]),
      hasCustomAnchor: p,
      onCustomAnchorAdd: d.useCallback(() => m(!0), []),
      onCustomAnchorRemove: d.useCallback(() => m(!1), []),
      modal: l,
      children: n
    }
  ) });
};
P7.displayName = Fp;
var A7 = "PopoverAnchor", T7 = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Gr(A7, n), i = Ta(n), { onCustomAnchorAdd: l, onCustomAnchorRemove: c } = o;
    return d.useEffect(() => (l(), () => c()), [l, c]), /* @__PURE__ */ s(b7, { ...i, ...r, ref: t });
  }
);
T7.displayName = A7;
var $7 = "PopoverTrigger", L7 = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Gr($7, n), i = Ta(n), l = ke(t, o.triggerRef), c = /* @__PURE__ */ s(
      ve.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": D7(o.open),
        ...r,
        ref: l,
        onClick: he(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? c : /* @__PURE__ */ s(b7, { asChild: !0, ...i, children: c });
  }
);
L7.displayName = $7;
var Bp = "PopoverPortal", [OW, kW] = E7(Bp, {
  forceMount: void 0
}), M7 = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, i = Gr(Bp, t);
  return /* @__PURE__ */ s(OW, { scope: t, forceMount: n, children: /* @__PURE__ */ s(Dp, { present: n || i.open, children: /* @__PURE__ */ s(y7, { asChild: !0, container: o, children: r }) }) });
};
M7.displayName = Bp;
var Ci = "PopoverContent", I7 = d.forwardRef(
  (e, t) => {
    const n = kW(Ci, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, i = Gr(Ci, e.__scopePopover);
    return /* @__PURE__ */ s(Dp, { present: r || i.open, children: i.modal ? /* @__PURE__ */ s(DW, { ...o, ref: t }) : /* @__PURE__ */ s(FW, { ...o, ref: t }) });
  }
);
I7.displayName = Ci;
var DW = d.forwardRef(
  (e, t) => {
    const n = Gr(Ci, e.__scopePopover), r = d.useRef(null), o = ke(t, r), i = d.useRef(!1);
    return d.useEffect(() => {
      const l = r.current;
      if (l) return Si(l);
    }, []), /* @__PURE__ */ s(R7, { as: mi, allowPinchZoom: !0, children: /* @__PURE__ */ s(
      O7,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: he(e.onCloseAutoFocus, (l) => {
          var c;
          l.preventDefault(), i.current || (c = n.triggerRef.current) == null || c.focus();
        }),
        onPointerDownOutside: he(
          e.onPointerDownOutside,
          (l) => {
            const c = l.detail.originalEvent, f = c.button === 0 && c.ctrlKey === !0, p = c.button === 2 || f;
            i.current = p;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: he(
          e.onFocusOutside,
          (l) => l.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), FW = d.forwardRef(
  (e, t) => {
    const n = Gr(Ci, e.__scopePopover), r = d.useRef(!1), o = d.useRef(!1);
    return /* @__PURE__ */ s(
      O7,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var l, c;
          (l = e.onCloseAutoFocus) == null || l.call(e, i), i.defaultPrevented || (r.current || (c = n.triggerRef.current) == null || c.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var f, p;
          (f = e.onInteractOutside) == null || f.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const l = i.target;
          ((p = n.triggerRef.current) == null ? void 0 : p.contains(l)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), O7 = d.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: f,
      onFocusOutside: p,
      onInteractOutside: m,
      ...v
    } = e, C = Gr(Ci, n), x = Ta(n);
    return iW(), /* @__PURE__ */ s(
      ep,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ s(
          s7,
          {
            asChild: !0,
            disableOutsidePointerEvents: l,
            onInteractOutside: m,
            onEscapeKeyDown: c,
            onPointerDownOutside: f,
            onFocusOutside: p,
            onDismiss: () => C.onOpenChange(!1),
            children: /* @__PURE__ */ s(
              hW,
              {
                "data-state": D7(C.open),
                role: "dialog",
                id: C.contentId,
                ...x,
                ...v,
                ref: t,
                style: {
                  ...v.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), k7 = "PopoverClose", BW = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Gr(k7, n);
    return /* @__PURE__ */ s(
      ve.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: he(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
BW.displayName = k7;
var VW = "PopoverArrow", WW = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Ta(n);
    return /* @__PURE__ */ s(gW, { ...o, ...r, ref: t });
  }
);
WW.displayName = VW;
function D7(e) {
  return e ? "open" : "closed";
}
var HW = P7, UW = T7, GW = L7, zW = M7, F7 = I7;
const B7 = HW, V7 = GW, vZ = UW, Vp = q(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ s(zW, { children: /* @__PURE__ */ s(
  F7,
  {
    ref: o,
    align: t,
    sideOffset: n,
    className: F(
      "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 rounded-md border p-4 shadow-md outline-hidden",
      e
    ),
    ...r
  }
) }));
Vp.displayName = F7.displayName;
const qW = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Pa,
  {
    className: F("grid gap-2", e),
    ...t,
    ref: n
  }
));
qW.displayName = Pa.displayName;
const KW = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Tr,
  {
    ref: n,
    className: F(
      "border-primary text-primary ring-offset-background focus-visible:ring-ring aspect-square h-4 w-4 rounded-full focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border",
      e
    ),
    ...t,
    children: /* @__PURE__ */ s(oV, { className: "flex items-center justify-center", children: /* @__PURE__ */ s(S1, { className: "h-2.5 w-2.5 fill-current text-current" }) })
  }
));
KW.displayName = Tr.displayName;
function YW({ checked: e, className: t }) {
  return /* @__PURE__ */ R(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      className: t,
      children: [
        /* @__PURE__ */ s("rect", { x: "1", y: "1", width: "22", height: "22", rx: "11", fill: "none" }),
        /* @__PURE__ */ s(
          "rect",
          {
            x: "1",
            y: "1",
            width: "22",
            height: "22",
            rx: "11",
            stroke: "currentcolor",
            strokeWidth: "2"
          }
        ),
        /* @__PURE__ */ s("circle", { cx: "12", cy: "12", r: "8", fill: e ? "currentcolor" : "none" })
      ]
    }
  );
}
function W7({
  allowMultiSelect: e = !0,
  className: t,
  disabled: n,
  filter: r,
  hideHeader: o,
  hideSearch: i,
  onChange: l,
  onInputChange: c,
  options: f,
  placeholder: p,
  renderInline: m = !1,
  values: v
}) {
  const C = Je(null), [x, y] = ne(m), [h, b] = ne(""), w = hn(
    (N) => {
      const _ = C.current;
      if (_) {
        if ((N.key === "Delete" || N.key === "Backspace") && _.value === "") {
          const P = [...v];
          P.pop(), l(P);
        }
        N.key === "Escape" && _.blur();
      }
    },
    [l, v]
  );
  return /* @__PURE__ */ R(
    ya,
    {
      className: "overflow-visible bg-transparent",
      filter: r,
      onKeyDown: w,
      children: [
        o ? null : /* @__PURE__ */ R(
          "div",
          {
            className: F(
              "flex justify-between items-center w-full border-input bg-interfaceWhite ring-offset-background focus-within:ring-ring group rounded-md border px-3 py-2 text-bodysm focus:outline-hidden focus-within:ring-2 focus-within:ring-offset-2",
              t
            ),
            ...i ? {
              tabIndex: 0,
              onBlur: () => {
                m || y(!1);
              },
              onFocus: () => y(!0)
            } : {},
            children: [
              /* @__PURE__ */ R("div", { className: "flex flex-wrap gap-1 text-ellipsis", children: [
                v.map((N, _) => {
                  const P = _ === v.length - 1;
                  return /* @__PURE__ */ R("span", { children: [
                    N.label,
                    P ? null : ", "
                  ] }, N.value);
                }),
                i ? null : /* @__PURE__ */ s(
                  Mt.Input,
                  {
                    className: "placeholder:text-muted-foreground ml-2 flex-1 bg-transparent outline-hidden",
                    disabled: n,
                    onBlur: () => {
                      m || y(!1);
                    },
                    onFocus: () => y(!0),
                    onValueChange: (N) => {
                      b(N), c == null || c(N);
                    },
                    placeholder: p,
                    ref: C,
                    value: h
                  }
                )
              ] }),
              /* @__PURE__ */ s(
                "div",
                {
                  onClick: () => {
                    var N;
                    y((_) => !_), i || (N = C.current) == null || N.focus();
                  },
                  children: /* @__PURE__ */ s(va, { className: "h-4 w-4" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ s("div", { className: "relative", children: /* @__PURE__ */ s(jl, { children: x && f.length > 0 ? /* @__PURE__ */ s(
          "div",
          {
            className: F(
              "mt-2 text-popover-foreground animate-in w-full rounded-md shadow-md outline-hidden max-h-64 overflow-auto",
              m ? "" : "absolute top-0 z-10 bg-popover border border-border"
            ),
            children: /* @__PURE__ */ s(Ql, { className: "h-full", children: f.map((N) => {
              const _ = v.some((P) => P.value === N.value);
              return /* @__PURE__ */ R(
                Jl,
                {
                  className: "cursor-pointer text-bodymd gap-2",
                  disabled: n,
                  keywords: N.keywords,
                  onMouseDown: (P) => {
                    P.preventDefault(), P.stopPropagation();
                  },
                  onSelect: (P) => {
                    b(""), c == null || c(""), l(e ? [...v, N] : [N]);
                  },
                  children: [
                    e ? /* @__PURE__ */ s(io, { checked: _ }) : /* @__PURE__ */ s(
                      YW,
                      {
                        checked: _,
                        className: F(
                          "min-w-6 min-h-6",
                          _ ? "text-textLink" : "text-interactiveBorder"
                        )
                      }
                    ),
                    N.label
                  ]
                },
                N.value
              );
            }) })
          }
        ) : null }) })
      ]
    }
  );
}
var ZW = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Qf = ZW.reduce((e, t) => {
  const n = d.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, c = i ? rn : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(c, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function fi(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function C2(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function XW(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = C2(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : C2(e[o], null);
        }
      };
  };
}
function x2(...e) {
  return d.useCallback(XW(...e), e);
}
function jW(e) {
  const t = e + "CollectionProvider", [n, r] = ec(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), l = (x) => {
    const { scope: y, children: h } = x, b = ae.useRef(null), w = ae.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ s(o, { scope: y, itemMap: w, collectionRef: b, children: h });
  };
  l.displayName = t;
  const c = e + "CollectionSlot", f = ae.forwardRef(
    (x, y) => {
      const { scope: h, children: b } = x, w = i(c, h), N = x2(y, w.collectionRef);
      return /* @__PURE__ */ s(rn, { ref: N, children: b });
    }
  );
  f.displayName = c;
  const p = e + "CollectionItemSlot", m = "data-radix-collection-item", v = ae.forwardRef(
    (x, y) => {
      const { scope: h, children: b, ...w } = x, N = ae.useRef(null), _ = x2(y, N), P = i(p, h);
      return ae.useEffect(() => (P.itemMap.set(N, { ref: N, ...w }), () => void P.itemMap.delete(N))), /* @__PURE__ */ s(rn, { [m]: "", ref: _, children: b });
    }
  );
  v.displayName = p;
  function C(x) {
    const y = i(e + "CollectionConsumer", x);
    return ae.useCallback(() => {
      const b = y.collectionRef.current;
      if (!b) return [];
      const w = Array.from(b.querySelectorAll(`[${m}]`));
      return Array.from(y.itemMap.values()).sort(
        (P, A) => w.indexOf(P.ref.current) - w.indexOf(A.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: l, Slot: f, ItemSlot: v },
    C,
    r
  ];
}
function b2(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function QW(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = b2(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : b2(e[o], null);
        }
      };
  };
}
function JW(...e) {
  return d.useCallback(QW(...e), e);
}
var eH = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], H7 = eH.reduce((e, t) => {
  const n = d.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, c = i ? rn : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(c, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), jd = "rovingFocusGroup.onEntryFocus", tH = { bubbles: !1, cancelable: !0 }, Ac = "RovingFocusGroup", [Jf, U7, nH] = jW(Ac), [rH, G7] = ec(
  Ac,
  [nH]
), [oH, iH] = rH(Ac), z7 = d.forwardRef(
  (e, t) => /* @__PURE__ */ s(Jf.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ s(Jf.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ s(aH, { ...e, ref: t }) }) })
);
z7.displayName = Ac;
var aH = d.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: l,
    defaultCurrentTabStopId: c,
    onCurrentTabStopIdChange: f,
    onEntryFocus: p,
    preventScrollOnEntryFocus: m = !1,
    ...v
  } = e, C = d.useRef(null), x = JW(t, C), y = vn(i), [h = null, b] = et({
    prop: l,
    defaultProp: c,
    onChange: f
  }), [w, N] = d.useState(!1), _ = xe(p), P = U7(n), A = d.useRef(!1), [I, T] = d.useState(0);
  return d.useEffect(() => {
    const M = C.current;
    if (M)
      return M.addEventListener(jd, _), () => M.removeEventListener(jd, _);
  }, [_]), /* @__PURE__ */ s(
    oH,
    {
      scope: n,
      orientation: r,
      dir: y,
      loop: o,
      currentTabStopId: h,
      onItemFocus: d.useCallback(
        (M) => b(M),
        [b]
      ),
      onItemShiftTab: d.useCallback(() => N(!0), []),
      onFocusableItemAdd: d.useCallback(
        () => T((M) => M + 1),
        []
      ),
      onFocusableItemRemove: d.useCallback(
        () => T((M) => M - 1),
        []
      ),
      children: /* @__PURE__ */ s(
        H7.div,
        {
          tabIndex: w || I === 0 ? -1 : 0,
          "data-orientation": r,
          ...v,
          ref: x,
          style: { outline: "none", ...e.style },
          onMouseDown: fi(e.onMouseDown, () => {
            A.current = !0;
          }),
          onFocus: fi(e.onFocus, (M) => {
            const D = !A.current;
            if (M.target === M.currentTarget && D && !w) {
              const W = new CustomEvent(jd, tH);
              if (M.currentTarget.dispatchEvent(W), !W.defaultPrevented) {
                const U = P().filter((G) => G.focusable), re = U.find((G) => G.active), j = U.find((G) => G.id === h), oe = [re, j, ...U].filter(
                  Boolean
                ).map((G) => G.ref.current);
                Y7(oe, m);
              }
            }
            A.current = !1;
          }),
          onBlur: fi(e.onBlur, () => N(!1))
        }
      )
    }
  );
}), q7 = "RovingFocusGroupItem", K7 = d.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      ...l
    } = e, c = it(), f = i || c, p = iH(q7, n), m = p.currentTabStopId === f, v = U7(n), { onFocusableItemAdd: C, onFocusableItemRemove: x } = p;
    return d.useEffect(() => {
      if (r)
        return C(), () => x();
    }, [r, C, x]), /* @__PURE__ */ s(
      Jf.ItemSlot,
      {
        scope: n,
        id: f,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ s(
          H7.span,
          {
            tabIndex: m ? 0 : -1,
            "data-orientation": p.orientation,
            ...l,
            ref: t,
            onMouseDown: fi(e.onMouseDown, (y) => {
              r ? p.onItemFocus(f) : y.preventDefault();
            }),
            onFocus: fi(e.onFocus, () => p.onItemFocus(f)),
            onKeyDown: fi(e.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                p.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget) return;
              const h = cH(y, p.orientation, p.dir);
              if (h !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey) return;
                y.preventDefault();
                let w = v().filter((N) => N.focusable).map((N) => N.ref.current);
                if (h === "last") w.reverse();
                else if (h === "prev" || h === "next") {
                  h === "prev" && w.reverse();
                  const N = w.indexOf(y.currentTarget);
                  w = p.loop ? uH(w, N + 1) : w.slice(N + 1);
                }
                setTimeout(() => Y7(w));
              }
            })
          }
        )
      }
    );
  }
);
K7.displayName = q7;
var sH = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function lH(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function cH(e, t, n) {
  const r = lH(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return sH[r];
}
function Y7(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function uH(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var dH = z7, fH = K7;
function pH(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
var mH = "Toggle", Z7 = d.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: o, ...i } = e, [l = !1, c] = et({
    prop: n,
    onChange: o,
    defaultProp: r
  });
  return /* @__PURE__ */ s(
    Qf.button,
    {
      type: "button",
      "aria-pressed": l,
      "data-state": l ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...i,
      ref: t,
      onClick: pH(e.onClick, () => {
        e.disabled || c(!l);
      })
    }
  );
});
Z7.displayName = mH;
var Ai = "ToggleGroup", [X7, CZ] = ec(Ai, [
  G7
]), j7 = G7(), Wp = ae.forwardRef((e, t) => {
  const { type: n, ...r } = e;
  if (n === "single")
    return /* @__PURE__ */ s(hH, { ...r, ref: t });
  if (n === "multiple")
    return /* @__PURE__ */ s(gH, { ...r, ref: t });
  throw new Error(`Missing prop \`type\` expected on \`${Ai}\``);
});
Wp.displayName = Ai;
var [Q7, J7] = X7(Ai), hH = ae.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...i
  } = e, [l, c] = et({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ s(
    Q7,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: l ? [l] : [],
      onItemActivate: c,
      onItemDeactivate: ae.useCallback(() => c(""), [c]),
      children: /* @__PURE__ */ s(e9, { ...i, ref: t })
    }
  );
}), gH = ae.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...i
  } = e, [l = [], c] = et({
    prop: n,
    defaultProp: r,
    onChange: o
  }), f = ae.useCallback(
    (m) => c((v = []) => [...v, m]),
    [c]
  ), p = ae.useCallback(
    (m) => c((v = []) => v.filter((C) => C !== m)),
    [c]
  );
  return /* @__PURE__ */ s(
    Q7,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: l,
      onItemActivate: f,
      onItemDeactivate: p,
      children: /* @__PURE__ */ s(e9, { ...i, ref: t })
    }
  );
});
Wp.displayName = Ai;
var [vH, CH] = X7(Ai), e9 = ae.forwardRef(
  (e, t) => {
    const {
      __scopeToggleGroup: n,
      disabled: r = !1,
      rovingFocus: o = !0,
      orientation: i,
      dir: l,
      loop: c = !0,
      ...f
    } = e, p = j7(n), m = vn(l), v = { role: "group", dir: m, ...f };
    return /* @__PURE__ */ s(vH, { scope: n, rovingFocus: o, disabled: r, children: o ? /* @__PURE__ */ s(
      dH,
      {
        asChild: !0,
        ...p,
        orientation: i,
        dir: m,
        loop: c,
        children: /* @__PURE__ */ s(Qf.div, { ...v, ref: t })
      }
    ) : /* @__PURE__ */ s(Qf.div, { ...v, ref: t }) });
  }
), Rl = "ToggleGroupItem", t9 = ae.forwardRef(
  (e, t) => {
    const n = J7(Rl, e.__scopeToggleGroup), r = CH(Rl, e.__scopeToggleGroup), o = j7(e.__scopeToggleGroup), i = n.value.includes(e.value), l = r.disabled || e.disabled, c = { ...e, pressed: i, disabled: l }, f = ae.useRef(null);
    return r.rovingFocus ? /* @__PURE__ */ s(
      fH,
      {
        asChild: !0,
        ...o,
        focusable: !l,
        active: i,
        ref: f,
        children: /* @__PURE__ */ s(y2, { ...c, ref: t })
      }
    ) : /* @__PURE__ */ s(y2, { ...c, ref: t });
  }
);
t9.displayName = Rl;
var y2 = ae.forwardRef(
  (e, t) => {
    const { __scopeToggleGroup: n, value: r, ...o } = e, i = J7(Rl, n), l = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, c = i.type === "single" ? l : void 0;
    return /* @__PURE__ */ s(
      Z7,
      {
        ...c,
        ...o,
        ref: t,
        onPressedChange: (f) => {
          f ? i.onItemActivate(r) : i.onItemDeactivate(r);
        }
      }
    );
  }
), xH = Wp, bH = t9;
function yH({
  options: e,
  groupValue: t,
  setGroupValue: n
}) {
  return /* @__PURE__ */ s("div", { children: /* @__PURE__ */ s(
    xH,
    {
      className: "flex flex-row flex-wrap gap-1",
      type: "multiple",
      orientation: "horizontal",
      value: t,
      onValueChange: (r) => n(r),
      "aria-label": "Text alignment",
      children: e.length > 0 && e.map((r, o) => /* @__PURE__ */ R(
        bH,
        {
          className: "data-[state=on]:bg-actionBgSelect data-[state=on]:text-actionHover data-[state=on]:border-actionBorder border-interactiveBorder bg-interfaceWhite data-[state=off]:hover:bg-interfaceBgDefault data-[state=off]:hover:border-interactiveBorderHover flex flex-row items-center rounded-sm border px-3 py-2 text-base font-normal leading-5 data-[state=on]:border-2",
          value: r,
          children: [
            /* @__PURE__ */ s(
              "div",
              {
                className: `${t.includes(r) ? "bg-actionDefault border-none" : "bg-interfaceWhite"} border-interactiveBorder mr-1.5 flex h-3 w-3 items-center justify-center rounded-xs border`,
                children: t.includes(r) && /* @__PURE__ */ s(wo, { className: "text-textWhite h-3 w-3" })
              }
            ),
            /* @__PURE__ */ s("div", { children: r })
          ]
        },
        o
      ))
    }
  ) });
}
function wH(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var $a = (e) => {
  const { present: t, children: n } = e, r = SH(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), i = ke(r.ref, NH(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: i }) : null;
};
$a.displayName = "Presence";
function SH(e) {
  const [t, n] = d.useState(), r = d.useRef({}), o = d.useRef(e), i = d.useRef("none"), l = e ? "mounted" : "unmounted", [c, f] = wH(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const p = Zs(r.current);
    i.current = c === "mounted" ? p : "none";
  }, [c]), be(() => {
    const p = r.current, m = o.current;
    if (m !== e) {
      const C = i.current, x = Zs(p);
      e ? f("MOUNT") : x === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && C !== x ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), be(() => {
    if (t) {
      let p;
      const m = t.ownerDocument.defaultView ?? window, v = (x) => {
        const h = Zs(r.current).includes(x.animationName);
        if (x.target === t && h && (f("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, C = (x) => {
        x.target === t && (i.current = Zs(r.current));
      };
      return t.addEventListener("animationstart", C), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        m.clearTimeout(p), t.removeEventListener("animationstart", C), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: d.useCallback((p) => {
      p && (r.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function Zs(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function NH(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function _H(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    const p = (v) => {
      var w;
      const { scope: C, children: x, ...y } = v, h = ((w = C == null ? void 0 : C[e]) == null ? void 0 : w[f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    };
    p.displayName = i + "Provider";
    function m(v, C) {
      var h;
      const x = ((h = C == null ? void 0 : C[e]) == null ? void 0 : h[f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, RH(o, ...t)];
}
function RH(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function ma(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function EH(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var Hp = "ScrollArea", [n9, xZ] = _H(Hp), [PH, bn] = n9(Hp), r9 = d.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: r = "hover",
      dir: o,
      scrollHideDelay: i = 600,
      ...l
    } = e, [c, f] = d.useState(null), [p, m] = d.useState(null), [v, C] = d.useState(null), [x, y] = d.useState(null), [h, b] = d.useState(null), [w, N] = d.useState(0), [_, P] = d.useState(0), [A, I] = d.useState(!1), [T, M] = d.useState(!1), D = ke(t, (U) => f(U)), W = vn(o);
    return /* @__PURE__ */ s(
      PH,
      {
        scope: n,
        type: r,
        dir: W,
        scrollHideDelay: i,
        scrollArea: c,
        viewport: p,
        onViewportChange: m,
        content: v,
        onContentChange: C,
        scrollbarX: x,
        onScrollbarXChange: y,
        scrollbarXEnabled: A,
        onScrollbarXEnabledChange: I,
        scrollbarY: h,
        onScrollbarYChange: b,
        scrollbarYEnabled: T,
        onScrollbarYEnabledChange: M,
        onCornerWidthChange: N,
        onCornerHeightChange: P,
        children: /* @__PURE__ */ s(
          ve.div,
          {
            dir: W,
            ...l,
            ref: D,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": _ + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
r9.displayName = Hp;
var o9 = "ScrollAreaViewport", i9 = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: r, nonce: o, ...i } = e, l = bn(o9, n), c = d.useRef(null), f = ke(t, c, l.onViewportChange);
    return /* @__PURE__ */ R(le, { children: [
      /* @__PURE__ */ s(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ s(
        ve.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...i,
          ref: f,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: l.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: l.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ s("div", { ref: l.onContentChange, style: { minWidth: "100%", display: "table" }, children: r })
        }
      )
    ] });
  }
);
i9.displayName = o9;
var Un = "ScrollAreaScrollbar", Up = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = bn(Un, e.__scopeScrollArea), { onScrollbarXEnabledChange: i, onScrollbarYEnabledChange: l } = o, c = e.orientation === "horizontal";
    return d.useEffect(() => (c ? i(!0) : l(!0), () => {
      c ? i(!1) : l(!1);
    }), [c, i, l]), o.type === "hover" ? /* @__PURE__ */ s(AH, { ...r, ref: t, forceMount: n }) : o.type === "scroll" ? /* @__PURE__ */ s(TH, { ...r, ref: t, forceMount: n }) : o.type === "auto" ? /* @__PURE__ */ s(a9, { ...r, ref: t, forceMount: n }) : o.type === "always" ? /* @__PURE__ */ s(Gp, { ...r, ref: t }) : null;
  }
);
Up.displayName = Un;
var AH = d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = bn(Un, e.__scopeScrollArea), [i, l] = d.useState(!1);
  return d.useEffect(() => {
    const c = o.scrollArea;
    let f = 0;
    if (c) {
      const p = () => {
        window.clearTimeout(f), l(!0);
      }, m = () => {
        f = window.setTimeout(() => l(!1), o.scrollHideDelay);
      };
      return c.addEventListener("pointerenter", p), c.addEventListener("pointerleave", m), () => {
        window.clearTimeout(f), c.removeEventListener("pointerenter", p), c.removeEventListener("pointerleave", m);
      };
    }
  }, [o.scrollArea, o.scrollHideDelay]), /* @__PURE__ */ s($a, { present: n || i, children: /* @__PURE__ */ s(
    a9,
    {
      "data-state": i ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), TH = d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = bn(Un, e.__scopeScrollArea), i = e.orientation === "horizontal", l = $c(() => f("SCROLL_END"), 100), [c, f] = EH("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return d.useEffect(() => {
    if (c === "idle") {
      const p = window.setTimeout(() => f("HIDE"), o.scrollHideDelay);
      return () => window.clearTimeout(p);
    }
  }, [c, o.scrollHideDelay, f]), d.useEffect(() => {
    const p = o.viewport, m = i ? "scrollLeft" : "scrollTop";
    if (p) {
      let v = p[m];
      const C = () => {
        const x = p[m];
        v !== x && (f("SCROLL"), l()), v = x;
      };
      return p.addEventListener("scroll", C), () => p.removeEventListener("scroll", C);
    }
  }, [o.viewport, i, f, l]), /* @__PURE__ */ s($a, { present: n || c !== "hidden", children: /* @__PURE__ */ s(
    Gp,
    {
      "data-state": c === "hidden" ? "hidden" : "visible",
      ...r,
      ref: t,
      onPointerEnter: he(e.onPointerEnter, () => f("POINTER_ENTER")),
      onPointerLeave: he(e.onPointerLeave, () => f("POINTER_LEAVE"))
    }
  ) });
}), a9 = d.forwardRef((e, t) => {
  const n = bn(Un, e.__scopeScrollArea), { forceMount: r, ...o } = e, [i, l] = d.useState(!1), c = e.orientation === "horizontal", f = $c(() => {
    if (n.viewport) {
      const p = n.viewport.offsetWidth < n.viewport.scrollWidth, m = n.viewport.offsetHeight < n.viewport.scrollHeight;
      l(c ? p : m);
    }
  }, 10);
  return xi(n.viewport, f), xi(n.content, f), /* @__PURE__ */ s($a, { present: r || i, children: /* @__PURE__ */ s(
    Gp,
    {
      "data-state": i ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), Gp = d.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...r } = e, o = bn(Un, e.__scopeScrollArea), i = d.useRef(null), l = d.useRef(0), [c, f] = d.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), p = d9(c.viewport, c.content), m = {
    ...r,
    sizes: c,
    onSizesChange: f,
    hasThumb: p > 0 && p < 1,
    onThumbChange: (C) => i.current = C,
    onThumbPointerUp: () => l.current = 0,
    onThumbPointerDown: (C) => l.current = C
  };
  function v(C, x) {
    return kH(C, l.current, c, x);
  }
  return n === "horizontal" ? /* @__PURE__ */ s(
    $H,
    {
      ...m,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const C = o.viewport.scrollLeft, x = w2(C, c, o.dir);
          i.current.style.transform = `translate3d(${x}px, 0, 0)`;
        }
      },
      onWheelScroll: (C) => {
        o.viewport && (o.viewport.scrollLeft = C);
      },
      onDragScroll: (C) => {
        o.viewport && (o.viewport.scrollLeft = v(C, o.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ s(
    LH,
    {
      ...m,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const C = o.viewport.scrollTop, x = w2(C, c);
          i.current.style.transform = `translate3d(0, ${x}px, 0)`;
        }
      },
      onWheelScroll: (C) => {
        o.viewport && (o.viewport.scrollTop = C);
      },
      onDragScroll: (C) => {
        o.viewport && (o.viewport.scrollTop = v(C));
      }
    }
  ) : null;
}), $H = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, i = bn(Un, e.__scopeScrollArea), [l, c] = d.useState(), f = d.useRef(null), p = ke(t, f, i.onScrollbarXChange);
  return d.useEffect(() => {
    f.current && c(getComputedStyle(f.current));
  }, [f]), /* @__PURE__ */ s(
    l9,
    {
      "data-orientation": "horizontal",
      ...o,
      ref: p,
      sizes: n,
      style: {
        bottom: 0,
        left: i.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: i.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Tc(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (m) => e.onThumbPointerDown(m.x),
      onDragScroll: (m) => e.onDragScroll(m.x),
      onWheelScroll: (m, v) => {
        if (i.viewport) {
          const C = i.viewport.scrollLeft + m.deltaX;
          e.onWheelScroll(C), p9(C, v) && m.preventDefault();
        }
      },
      onResize: () => {
        f.current && i.viewport && l && r({
          content: i.viewport.scrollWidth,
          viewport: i.viewport.offsetWidth,
          scrollbar: {
            size: f.current.clientWidth,
            paddingStart: Pl(l.paddingLeft),
            paddingEnd: Pl(l.paddingRight)
          }
        });
      }
    }
  );
}), LH = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, i = bn(Un, e.__scopeScrollArea), [l, c] = d.useState(), f = d.useRef(null), p = ke(t, f, i.onScrollbarYChange);
  return d.useEffect(() => {
    f.current && c(getComputedStyle(f.current));
  }, [f]), /* @__PURE__ */ s(
    l9,
    {
      "data-orientation": "vertical",
      ...o,
      ref: p,
      sizes: n,
      style: {
        top: 0,
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Tc(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (m) => e.onThumbPointerDown(m.y),
      onDragScroll: (m) => e.onDragScroll(m.y),
      onWheelScroll: (m, v) => {
        if (i.viewport) {
          const C = i.viewport.scrollTop + m.deltaY;
          e.onWheelScroll(C), p9(C, v) && m.preventDefault();
        }
      },
      onResize: () => {
        f.current && i.viewport && l && r({
          content: i.viewport.scrollHeight,
          viewport: i.viewport.offsetHeight,
          scrollbar: {
            size: f.current.clientHeight,
            paddingStart: Pl(l.paddingTop),
            paddingEnd: Pl(l.paddingBottom)
          }
        });
      }
    }
  );
}), [MH, s9] = n9(Un), l9 = d.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: r,
    hasThumb: o,
    onThumbChange: i,
    onThumbPointerUp: l,
    onThumbPointerDown: c,
    onThumbPositionChange: f,
    onDragScroll: p,
    onWheelScroll: m,
    onResize: v,
    ...C
  } = e, x = bn(Un, n), [y, h] = d.useState(null), b = ke(t, (D) => h(D)), w = d.useRef(null), N = d.useRef(""), _ = x.viewport, P = r.content - r.viewport, A = xe(m), I = xe(f), T = $c(v, 10);
  function M(D) {
    if (w.current) {
      const W = D.clientX - w.current.left, U = D.clientY - w.current.top;
      p({ x: W, y: U });
    }
  }
  return d.useEffect(() => {
    const D = (W) => {
      const U = W.target;
      (y == null ? void 0 : y.contains(U)) && A(W, P);
    };
    return document.addEventListener("wheel", D, { passive: !1 }), () => document.removeEventListener("wheel", D, { passive: !1 });
  }, [_, y, P, A]), d.useEffect(I, [r, I]), xi(y, T), xi(x.content, T), /* @__PURE__ */ s(
    MH,
    {
      scope: n,
      scrollbar: y,
      hasThumb: o,
      onThumbChange: xe(i),
      onThumbPointerUp: xe(l),
      onThumbPositionChange: I,
      onThumbPointerDown: xe(c),
      children: /* @__PURE__ */ s(
        ve.div,
        {
          ...C,
          ref: b,
          style: { position: "absolute", ...C.style },
          onPointerDown: he(e.onPointerDown, (D) => {
            D.button === 0 && (D.target.setPointerCapture(D.pointerId), w.current = y.getBoundingClientRect(), N.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", x.viewport && (x.viewport.style.scrollBehavior = "auto"), M(D));
          }),
          onPointerMove: he(e.onPointerMove, M),
          onPointerUp: he(e.onPointerUp, (D) => {
            const W = D.target;
            W.hasPointerCapture(D.pointerId) && W.releasePointerCapture(D.pointerId), document.body.style.webkitUserSelect = N.current, x.viewport && (x.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), El = "ScrollAreaThumb", c9 = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = s9(El, e.__scopeScrollArea);
    return /* @__PURE__ */ s($a, { present: n || o.hasThumb, children: /* @__PURE__ */ s(IH, { ref: t, ...r }) });
  }
), IH = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: r, ...o } = e, i = bn(El, n), l = s9(El, n), { onThumbPositionChange: c } = l, f = ke(
      t,
      (v) => l.onThumbChange(v)
    ), p = d.useRef(), m = $c(() => {
      p.current && (p.current(), p.current = void 0);
    }, 100);
    return d.useEffect(() => {
      const v = i.viewport;
      if (v) {
        const C = () => {
          if (m(), !p.current) {
            const x = DH(v, c);
            p.current = x, c();
          }
        };
        return c(), v.addEventListener("scroll", C), () => v.removeEventListener("scroll", C);
      }
    }, [i.viewport, m, c]), /* @__PURE__ */ s(
      ve.div,
      {
        "data-state": l.hasThumb ? "visible" : "hidden",
        ...o,
        ref: f,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...r
        },
        onPointerDownCapture: he(e.onPointerDownCapture, (v) => {
          const x = v.target.getBoundingClientRect(), y = v.clientX - x.left, h = v.clientY - x.top;
          l.onThumbPointerDown({ x: y, y: h });
        }),
        onPointerUp: he(e.onPointerUp, l.onThumbPointerUp)
      }
    );
  }
);
c9.displayName = El;
var zp = "ScrollAreaCorner", u9 = d.forwardRef(
  (e, t) => {
    const n = bn(zp, e.__scopeScrollArea), r = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && r ? /* @__PURE__ */ s(OH, { ...e, ref: t }) : null;
  }
);
u9.displayName = zp;
var OH = d.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...r } = e, o = bn(zp, n), [i, l] = d.useState(0), [c, f] = d.useState(0), p = !!(i && c);
  return xi(o.scrollbarX, () => {
    var v;
    const m = ((v = o.scrollbarX) == null ? void 0 : v.offsetHeight) || 0;
    o.onCornerHeightChange(m), f(m);
  }), xi(o.scrollbarY, () => {
    var v;
    const m = ((v = o.scrollbarY) == null ? void 0 : v.offsetWidth) || 0;
    o.onCornerWidthChange(m), l(m);
  }), p ? /* @__PURE__ */ s(
    ve.div,
    {
      ...r,
      ref: t,
      style: {
        width: i,
        height: c,
        position: "absolute",
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Pl(e) {
  return e ? parseInt(e, 10) : 0;
}
function d9(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function Tc(e) {
  const t = d9(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function kH(e, t, n, r = "ltr") {
  const o = Tc(n), i = o / 2, l = t || i, c = o - l, f = n.scrollbar.paddingStart + l, p = n.scrollbar.size - n.scrollbar.paddingEnd - c, m = n.content - n.viewport, v = r === "ltr" ? [0, m] : [m * -1, 0];
  return f9([f, p], v)(e);
}
function w2(e, t, n = "ltr") {
  const r = Tc(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, i = t.scrollbar.size - o, l = t.content - t.viewport, c = i - r, f = n === "ltr" ? [0, l] : [l * -1, 0], p = ma(e, f);
  return f9([0, l], [0, c])(p);
}
function f9(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function p9(e, t) {
  return e > 0 && e < t;
}
var DH = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, r = 0;
  return function o() {
    const i = { left: e.scrollLeft, top: e.scrollTop }, l = n.left !== i.left, c = n.top !== i.top;
    (l || c) && t(), n = i, r = window.requestAnimationFrame(o);
  }(), () => window.cancelAnimationFrame(r);
};
function $c(e, t) {
  const n = xe(e), r = d.useRef(0);
  return d.useEffect(() => () => window.clearTimeout(r.current), []), d.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [n, t]);
}
function xi(e, t) {
  const n = xe(t);
  be(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [e, n]);
}
var m9 = r9, FH = i9, BH = u9;
const VH = q(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ R(
  m9,
  {
    ref: r,
    className: F("relative overflow-hidden", e),
    ...n,
    children: [
      /* @__PURE__ */ s(FH, { className: "h-full w-full rounded-[inherit]", children: t }),
      /* @__PURE__ */ s(h9, {}),
      /* @__PURE__ */ s(BH, {})
    ]
  }
));
VH.displayName = m9.displayName;
const h9 = q(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ s(
  Up,
  {
    ref: r,
    orientation: t,
    className: F(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...n,
    children: /* @__PURE__ */ s(c9, { className: "bg-border relative flex-1 rounded-full" })
  }
));
h9.displayName = Up.displayName;
function ht(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function qp(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    const p = (v) => {
      var w;
      const { scope: C, children: x, ...y } = v, h = ((w = C == null ? void 0 : C[e]) == null ? void 0 : w[f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    };
    p.displayName = i + "Provider";
    function m(v, C) {
      var h;
      const x = ((h = C == null ? void 0 : C[e]) == null ? void 0 : h[f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, WH(o, ...t)];
}
function WH(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function S2(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function g9(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = S2(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : S2(e[o], null);
        }
      };
  };
}
function Rt(...e) {
  return d.useCallback(g9(...e), e);
}
var ha = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = d.Children.toArray(n), i = o.find(UH);
  if (i) {
    const l = i.props.children, c = o.map((f) => f === i ? d.Children.count(l) > 1 ? d.Children.only(null) : d.isValidElement(l) ? l.props.children : null : f);
    return /* @__PURE__ */ s(e1, { ...r, ref: t, children: d.isValidElement(l) ? d.cloneElement(l, void 0, c) : null });
  }
  return /* @__PURE__ */ s(e1, { ...r, ref: t, children: n });
});
ha.displayName = "Slot";
var e1 = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const o = zH(n);
    return d.cloneElement(n, {
      ...GH(r, n.props),
      // @ts-ignore
      ref: t ? g9(t, o) : o
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
e1.displayName = "SlotClone";
var HH = ({ children: e }) => /* @__PURE__ */ s(le, { children: e });
function UH(e) {
  return d.isValidElement(e) && e.type === HH;
}
function GH(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function zH(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function qH(e) {
  const t = e + "CollectionProvider", [n, r] = qp(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), l = (x) => {
    const { scope: y, children: h } = x, b = ae.useRef(null), w = ae.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ s(o, { scope: y, itemMap: w, collectionRef: b, children: h });
  };
  l.displayName = t;
  const c = e + "CollectionSlot", f = ae.forwardRef(
    (x, y) => {
      const { scope: h, children: b } = x, w = i(c, h), N = Rt(y, w.collectionRef);
      return /* @__PURE__ */ s(ha, { ref: N, children: b });
    }
  );
  f.displayName = c;
  const p = e + "CollectionItemSlot", m = "data-radix-collection-item", v = ae.forwardRef(
    (x, y) => {
      const { scope: h, children: b, ...w } = x, N = ae.useRef(null), _ = Rt(y, N), P = i(p, h);
      return ae.useEffect(() => (P.itemMap.set(N, { ref: N, ...w }), () => void P.itemMap.delete(N))), /* @__PURE__ */ s(ha, { [m]: "", ref: _, children: b });
    }
  );
  v.displayName = p;
  function C(x) {
    const y = i(e + "CollectionConsumer", x);
    return ae.useCallback(() => {
      const b = y.collectionRef.current;
      if (!b) return [];
      const w = Array.from(b.querySelectorAll(`[${m}]`));
      return Array.from(y.itemMap.values()).sort(
        (P, A) => w.indexOf(P.ref.current) - w.indexOf(A.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: l, Slot: f, ItemSlot: v },
    C,
    r
  ];
}
var KH = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], vt = KH.reduce((e, t) => {
  const n = d.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, c = i ? ha : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(c, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function YH(e, t) {
  e && Tn.flushSync(() => e.dispatchEvent(t));
}
var ZH = "DismissableLayer", t1 = "dismissableLayer.update", XH = "dismissableLayer.pointerDownOutside", jH = "dismissableLayer.focusOutside", N2, v9 = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), C9 = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: l,
      onDismiss: c,
      ...f
    } = e, p = d.useContext(v9), [m, v] = d.useState(null), C = (m == null ? void 0 : m.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, x] = d.useState({}), y = Rt(t, (T) => v(T)), h = Array.from(p.layers), [b] = [...p.layersWithOutsidePointerEventsDisabled].slice(-1), w = h.indexOf(b), N = m ? h.indexOf(m) : -1, _ = p.layersWithOutsidePointerEventsDisabled.size > 0, P = N >= w, A = eU((T) => {
      const M = T.target, D = [...p.branches].some((W) => W.contains(M));
      !P || D || (o == null || o(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C), I = tU((T) => {
      const M = T.target;
      [...p.branches].some((W) => W.contains(M)) || (i == null || i(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C);
    return Wr((T) => {
      N === p.layers.size - 1 && (r == null || r(T), !T.defaultPrevented && c && (T.preventDefault(), c()));
    }, C), d.useEffect(() => {
      if (m)
        return n && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (N2 = C.body.style.pointerEvents, C.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(m)), p.layers.add(m), _2(), () => {
          n && p.layersWithOutsidePointerEventsDisabled.size === 1 && (C.body.style.pointerEvents = N2);
        };
    }, [m, C, n, p]), d.useEffect(() => () => {
      m && (p.layers.delete(m), p.layersWithOutsidePointerEventsDisabled.delete(m), _2());
    }, [m, p]), d.useEffect(() => {
      const T = () => x({});
      return document.addEventListener(t1, T), () => document.removeEventListener(t1, T);
    }, []), /* @__PURE__ */ s(
      vt.div,
      {
        ...f,
        ref: y,
        style: {
          pointerEvents: _ ? P ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ht(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: ht(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: ht(
          e.onPointerDownCapture,
          A.onPointerDownCapture
        )
      }
    );
  }
);
C9.displayName = ZH;
var QH = "DismissableLayerBranch", JH = d.forwardRef((e, t) => {
  const n = d.useContext(v9), r = d.useRef(null), o = Rt(t, r);
  return d.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ s(vt.div, { ...e, ref: o });
});
JH.displayName = QH;
function eU(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1), o = d.useRef(() => {
  });
  return d.useEffect(() => {
    const i = (c) => {
      if (c.target && !r.current) {
        let f = function() {
          x9(
            XH,
            n,
            p,
            { discrete: !0 }
          );
        };
        const p = { originalEvent: c };
        c.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = f, t.addEventListener("click", o.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function tU(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && x9(jH, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function _2() {
  const e = new CustomEvent(t1);
  document.dispatchEvent(e);
}
function x9(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? YH(o, i) : o.dispatchEvent(i);
}
var Qd = "focusScope.autoFocusOnMount", Jd = "focusScope.autoFocusOnUnmount", R2 = { bubbles: !1, cancelable: !0 }, nU = "FocusScope", b9 = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...l
  } = e, [c, f] = d.useState(null), p = xe(o), m = xe(i), v = d.useRef(null), C = Rt(t, (h) => f(h)), x = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (r) {
      let h = function(_) {
        if (x.paused || !c) return;
        const P = _.target;
        c.contains(P) ? v.current = P : Er(v.current, { select: !0 });
      }, b = function(_) {
        if (x.paused || !c) return;
        const P = _.relatedTarget;
        P !== null && (c.contains(P) || Er(v.current, { select: !0 }));
      }, w = function(_) {
        if (document.activeElement === document.body)
          for (const A of _)
            A.removedNodes.length > 0 && Er(c);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", b);
      const N = new MutationObserver(w);
      return c && N.observe(c, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", b), N.disconnect();
      };
    }
  }, [r, c, x.paused]), d.useEffect(() => {
    if (c) {
      P2.add(x);
      const h = document.activeElement;
      if (!c.contains(h)) {
        const w = new CustomEvent(Qd, R2);
        c.addEventListener(Qd, p), c.dispatchEvent(w), w.defaultPrevented || (rU(lU(y9(c)), { select: !0 }), document.activeElement === h && Er(c));
      }
      return () => {
        c.removeEventListener(Qd, p), setTimeout(() => {
          const w = new CustomEvent(Jd, R2);
          c.addEventListener(Jd, m), c.dispatchEvent(w), w.defaultPrevented || Er(h ?? document.body, { select: !0 }), c.removeEventListener(Jd, m), P2.remove(x);
        }, 0);
      };
    }
  }, [c, p, m, x]);
  const y = d.useCallback(
    (h) => {
      if (!n && !r || x.paused) return;
      const b = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, w = document.activeElement;
      if (b && w) {
        const N = h.currentTarget, [_, P] = oU(N);
        _ && P ? !h.shiftKey && w === P ? (h.preventDefault(), n && Er(_, { select: !0 })) : h.shiftKey && w === _ && (h.preventDefault(), n && Er(P, { select: !0 })) : w === N && h.preventDefault();
      }
    },
    [n, r, x.paused]
  );
  return /* @__PURE__ */ s(vt.div, { tabIndex: -1, ...l, ref: C, onKeyDown: y });
});
b9.displayName = nU;
function rU(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Er(r, { select: t }), document.activeElement !== n) return;
}
function oU(e) {
  const t = y9(e), n = E2(t, e), r = E2(t.reverse(), e);
  return [n, r];
}
function y9(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function E2(e, t) {
  for (const n of e)
    if (!iU(n, { upTo: t })) return n;
}
function iU(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function aU(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Er(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && aU(e) && t && e.select();
  }
}
var P2 = sU();
function sU() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = A2(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = A2(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function A2(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function lU(e) {
  return e.filter((t) => t.tagName !== "A");
}
var cU = "Arrow", w9 = d.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ s(
    vt.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ s("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
w9.displayName = cU;
var uU = w9, Kp = "Popper", [S9, N9] = qp(Kp), [dU, _9] = S9(Kp), R9 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = d.useState(null);
  return /* @__PURE__ */ s(dU, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
R9.displayName = Kp;
var E9 = "PopperAnchor", P9 = d.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = _9(E9, n), l = d.useRef(null), c = Rt(t, l);
    return d.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || l.current);
    }), r ? null : /* @__PURE__ */ s(vt.div, { ...o, ref: c });
  }
);
P9.displayName = E9;
var Yp = "PopperContent", [fU, pU] = S9(Yp), A9 = d.forwardRef(
  (e, t) => {
    var ie, Ce, _e, Te, Me, Ie;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: l = 0,
      arrowPadding: c = 0,
      avoidCollisions: f = !0,
      collisionBoundary: p = [],
      collisionPadding: m = 0,
      sticky: v = "partial",
      hideWhenDetached: C = !1,
      updatePositionStrategy: x = "optimized",
      onPlaced: y,
      ...h
    } = e, b = _9(Yp, n), [w, N] = d.useState(null), _ = Rt(t, (ze) => N(ze)), [P, A] = d.useState(null), I = Hr(P), T = (I == null ? void 0 : I.width) ?? 0, M = (I == null ? void 0 : I.height) ?? 0, D = r + (i !== "center" ? "-" + i : ""), W = typeof m == "number" ? m : { top: 0, right: 0, bottom: 0, left: 0, ...m }, U = Array.isArray(p) ? p : [p], re = U.length > 0, j = {
      padding: W,
      boundary: U.filter(hU),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: re
    }, { refs: X, floatingStyles: oe, placement: G, isPositioned: Q, middlewareData: te } = pc({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: D,
      whileElementsMounted: (...ze) => fc(...ze, {
        animationFrame: x === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        mc({ mainAxis: o + M, alignmentAxis: l }),
        f && hc({
          mainAxis: !0,
          crossAxis: !1,
          limiter: v === "partial" ? gc() : void 0,
          ...j
        }),
        f && vc({ ...j }),
        Cc({
          ...j,
          apply: ({ elements: ze, rects: Ke, availableWidth: St, availableHeight: Kt }) => {
            const { width: ut, height: Mn } = Ke.reference, dt = ze.floating.style;
            dt.setProperty("--radix-popper-available-width", `${St}px`), dt.setProperty("--radix-popper-available-height", `${Kt}px`), dt.setProperty("--radix-popper-anchor-width", `${ut}px`), dt.setProperty("--radix-popper-anchor-height", `${Mn}px`);
          }
        }),
        P && bc({ element: P, padding: c }),
        gU({ arrowWidth: T, arrowHeight: M }),
        C && xc({ strategy: "referenceHidden", ...j })
      ]
    }), [ee, Pe] = L9(G), ce = xe(y);
    be(() => {
      Q && (ce == null || ce());
    }, [Q, ce]);
    const K = (ie = te.arrow) == null ? void 0 : ie.x, pe = (Ce = te.arrow) == null ? void 0 : Ce.y, ge = ((_e = te.arrow) == null ? void 0 : _e.centerOffset) !== 0, [ue, ye] = d.useState();
    return be(() => {
      w && ye(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ s(
      "div",
      {
        ref: X.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...oe,
          transform: Q ? oe.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ue,
          "--radix-popper-transform-origin": [
            (Te = te.transformOrigin) == null ? void 0 : Te.x,
            (Me = te.transformOrigin) == null ? void 0 : Me.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Ie = te.hide) == null ? void 0 : Ie.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ s(
          fU,
          {
            scope: n,
            placedSide: ee,
            onArrowChange: A,
            arrowX: K,
            arrowY: pe,
            shouldHideArrow: ge,
            children: /* @__PURE__ */ s(
              vt.div,
              {
                "data-side": ee,
                "data-align": Pe,
                ...h,
                ref: _,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: Q ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
A9.displayName = Yp;
var T9 = "PopperArrow", mU = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, $9 = d.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = pU(T9, r), l = mU[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ s(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [l]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ s(
          uU,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
$9.displayName = T9;
function hU(e) {
  return e !== null;
}
var gU = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var b, w, N;
    const { placement: n, rects: r, middlewareData: o } = t, l = ((b = o.arrow) == null ? void 0 : b.centerOffset) !== 0, c = l ? 0 : e.arrowWidth, f = l ? 0 : e.arrowHeight, [p, m] = L9(n), v = { start: "0%", center: "50%", end: "100%" }[m], C = (((w = o.arrow) == null ? void 0 : w.x) ?? 0) + c / 2, x = (((N = o.arrow) == null ? void 0 : N.y) ?? 0) + f / 2;
    let y = "", h = "";
    return p === "bottom" ? (y = l ? v : `${C}px`, h = `${-f}px`) : p === "top" ? (y = l ? v : `${C}px`, h = `${r.floating.height + f}px`) : p === "right" ? (y = `${-f}px`, h = l ? v : `${x}px`) : p === "left" && (y = `${r.floating.width + f}px`, h = l ? v : `${x}px`), { data: { x: y, y: h } };
  }
});
function L9(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var vU = R9, CU = P9, xU = A9, bU = $9, yU = "Portal", M9 = d.forwardRef((e, t) => {
  var c;
  const { container: n, ...r } = e, [o, i] = d.useState(!1);
  be(() => i(!0), []);
  const l = n || o && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return l ? Br.createPortal(/* @__PURE__ */ s(vt.div, { ...r, ref: t }), l) : null;
});
M9.displayName = yU;
var wU = "VisuallyHidden", I9 = d.forwardRef(
  (e, t) => /* @__PURE__ */ s(
    vt.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
I9.displayName = wU;
var sl = "right-scroll-bar-position", ll = "width-before-scroll-bar", SU = "with-scroll-bars-hidden", NU = "--removed-body-scroll-bar-size";
function ef(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function _U(e, t) {
  var n = ne(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var RU = typeof window < "u" ? d.useLayoutEffect : d.useEffect, T2 = /* @__PURE__ */ new WeakMap();
function EU(e, t) {
  var n = _U(null, function(r) {
    return e.forEach(function(o) {
      return ef(o, r);
    });
  });
  return RU(function() {
    var r = T2.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), l = n.current;
      o.forEach(function(c) {
        i.has(c) || ef(c, null);
      }), i.forEach(function(c) {
        o.has(c) || ef(c, l);
      });
    }
    T2.set(n, e);
  }, [e]), n;
}
function PU(e) {
  return e;
}
function AU(e, t) {
  t === void 0 && (t = PU);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var l = t(i, r);
      return n.push(l), function() {
        n = n.filter(function(c) {
          return c !== l;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var l = n;
        n = [], l.forEach(i);
      }
      n = {
        push: function(c) {
          return i(c);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var l = [];
      if (n.length) {
        var c = n;
        n = [], c.forEach(i), l = n;
      }
      var f = function() {
        var m = l;
        l = [], m.forEach(i);
      }, p = function() {
        return Promise.resolve().then(f);
      };
      p(), n = {
        push: function(m) {
          l.push(m), p();
        },
        filter: function(m) {
          return l = l.filter(m), n;
        }
      };
    }
  };
  return o;
}
function TU(e) {
  e === void 0 && (e = {});
  var t = AU(null);
  return t.options = Ae({ async: !0, ssr: !1 }, e), t;
}
var O9 = function(e) {
  var t = e.sideCar, n = Hn(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return d.createElement(r, Ae({}, n));
};
O9.isSideCarExport = !0;
function $U(e, t) {
  return e.useMedium(t), O9;
}
var k9 = TU(), tf = function() {
}, Lc = d.forwardRef(function(e, t) {
  var n = d.useRef(null), r = d.useState({
    onScrollCapture: tf,
    onWheelCapture: tf,
    onTouchMoveCapture: tf
  }), o = r[0], i = r[1], l = e.forwardProps, c = e.children, f = e.className, p = e.removeScrollBar, m = e.enabled, v = e.shards, C = e.sideCar, x = e.noIsolation, y = e.inert, h = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, N = e.gapMode, _ = Hn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), P = C, A = EU([n, t]), I = Ae(Ae({}, _), o);
  return d.createElement(
    d.Fragment,
    null,
    m && d.createElement(P, { sideCar: k9, removeScrollBar: p, shards: v, noIsolation: x, inert: y, setCallbacks: i, allowPinchZoom: !!h, lockRef: n, gapMode: N }),
    l ? d.cloneElement(d.Children.only(c), Ae(Ae({}, I), { ref: A })) : d.createElement(w, Ae({}, I, { className: f, ref: A }), c)
  );
});
Lc.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Lc.classNames = {
  fullWidth: ll,
  zeroRight: sl
};
function LU() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Gl();
  return t && e.setAttribute("nonce", t), e;
}
function MU(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function IU(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var OU = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = LU()) && (MU(t, n), IU(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, kU = function() {
  var e = OU();
  return function(t, n) {
    d.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, D9 = function() {
  var e = kU(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, DU = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, nf = function(e) {
  return parseInt(e || "", 10) || 0;
}, FU = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [nf(n), nf(r), nf(o)];
}, BU = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return DU;
  var t = FU(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, VU = D9(), pi = "data-scroll-locked", WU = function(e, t, n, r) {
  var o = e.left, i = e.top, l = e.right, c = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(SU, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(c, "px ").concat(r, `;
  }
  body[`).concat(pi, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(l, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(c, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(sl, ` {
    right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(ll, ` {
    margin-right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(sl, " .").concat(sl, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(ll, " .").concat(ll, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(pi, `] {
    `).concat(NU, ": ").concat(c, `px;
  }
`);
}, $2 = function() {
  var e = parseInt(document.body.getAttribute(pi) || "0", 10);
  return isFinite(e) ? e : 0;
}, HU = function() {
  d.useEffect(function() {
    return document.body.setAttribute(pi, ($2() + 1).toString()), function() {
      var e = $2() - 1;
      e <= 0 ? document.body.removeAttribute(pi) : document.body.setAttribute(pi, e.toString());
    };
  }, []);
}, UU = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  HU();
  var i = d.useMemo(function() {
    return BU(o);
  }, [o]);
  return d.createElement(VU, { styles: WU(i, !t, o, n ? "" : "!important") });
}, n1 = !1;
if (typeof window < "u")
  try {
    var Xs = Object.defineProperty({}, "passive", {
      get: function() {
        return n1 = !0, !0;
      }
    });
    window.addEventListener("test", Xs, Xs), window.removeEventListener("test", Xs, Xs);
  } catch {
    n1 = !1;
  }
var ti = n1 ? { passive: !1 } : !1, GU = function(e) {
  return e.tagName === "TEXTAREA";
}, F9 = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !GU(e) && n[t] === "visible")
  );
}, zU = function(e) {
  return F9(e, "overflowY");
}, qU = function(e) {
  return F9(e, "overflowX");
}, L2 = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = B9(e, r);
    if (o) {
      var i = V9(e, r), l = i[1], c = i[2];
      if (l > c)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, KU = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, YU = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, B9 = function(e, t) {
  return e === "v" ? zU(t) : qU(t);
}, V9 = function(e, t) {
  return e === "v" ? KU(t) : YU(t);
}, ZU = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, XU = function(e, t, n, r, o) {
  var i = ZU(e, window.getComputedStyle(t).direction), l = i * r, c = n.target, f = t.contains(c), p = !1, m = l > 0, v = 0, C = 0;
  do {
    var x = V9(e, c), y = x[0], h = x[1], b = x[2], w = h - b - i * y;
    (y || w) && B9(e, c) && (v += w, C += y), c instanceof ShadowRoot ? c = c.host : c = c.parentNode;
  } while (
    // portaled content
    !f && c !== document.body || // self content
    f && (t.contains(c) || t === c)
  );
  return (m && (Math.abs(v) < 1 || !o) || !m && (Math.abs(C) < 1 || !o)) && (p = !0), p;
}, js = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, M2 = function(e) {
  return [e.deltaX, e.deltaY];
}, I2 = function(e) {
  return e && "current" in e ? e.current : e;
}, jU = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, QU = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, JU = 0, ni = [];
function eG(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), o = d.useState(JU++)[0], i = d.useState(D9)[0], l = d.useRef(e);
  d.useEffect(function() {
    l.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = wi([e.lockRef.current], (e.shards || []).map(I2), !0).filter(Boolean);
      return h.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = d.useCallback(function(h, b) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !l.current.allowPinchZoom;
    var w = js(h), N = n.current, _ = "deltaX" in h ? h.deltaX : N[0] - w[0], P = "deltaY" in h ? h.deltaY : N[1] - w[1], A, I = h.target, T = Math.abs(_) > Math.abs(P) ? "h" : "v";
    if ("touches" in h && T === "h" && I.type === "range")
      return !1;
    var M = L2(T, I);
    if (!M)
      return !0;
    if (M ? A = T : (A = T === "v" ? "h" : "v", M = L2(T, I)), !M)
      return !1;
    if (!r.current && "changedTouches" in h && (_ || P) && (r.current = A), !A)
      return !0;
    var D = r.current || A;
    return XU(D, b, h, D === "h" ? _ : P, !0);
  }, []), f = d.useCallback(function(h) {
    var b = h;
    if (!(!ni.length || ni[ni.length - 1] !== i)) {
      var w = "deltaY" in b ? M2(b) : js(b), N = t.current.filter(function(A) {
        return A.name === b.type && (A.target === b.target || b.target === A.shadowParent) && jU(A.delta, w);
      })[0];
      if (N && N.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!N) {
        var _ = (l.current.shards || []).map(I2).filter(Boolean).filter(function(A) {
          return A.contains(b.target);
        }), P = _.length > 0 ? c(b, _[0]) : !l.current.noIsolation;
        P && b.cancelable && b.preventDefault();
      }
    }
  }, []), p = d.useCallback(function(h, b, w, N) {
    var _ = { name: h, delta: b, target: w, should: N, shadowParent: tG(w) };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(P) {
        return P !== _;
      });
    }, 1);
  }, []), m = d.useCallback(function(h) {
    n.current = js(h), r.current = void 0;
  }, []), v = d.useCallback(function(h) {
    p(h.type, M2(h), h.target, c(h, e.lockRef.current));
  }, []), C = d.useCallback(function(h) {
    p(h.type, js(h), h.target, c(h, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return ni.push(i), e.setCallbacks({
      onScrollCapture: v,
      onWheelCapture: v,
      onTouchMoveCapture: C
    }), document.addEventListener("wheel", f, ti), document.addEventListener("touchmove", f, ti), document.addEventListener("touchstart", m, ti), function() {
      ni = ni.filter(function(h) {
        return h !== i;
      }), document.removeEventListener("wheel", f, ti), document.removeEventListener("touchmove", f, ti), document.removeEventListener("touchstart", m, ti);
    };
  }, []);
  var x = e.removeScrollBar, y = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    y ? d.createElement(i, { styles: QU(o) }) : null,
    x ? d.createElement(UU, { gapMode: e.gapMode }) : null
  );
}
function tG(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const nG = $U(k9, eG);
var W9 = d.forwardRef(function(e, t) {
  return d.createElement(Lc, Ae({}, e, { ref: t, sideCar: nG }));
});
W9.classNames = Lc.classNames;
var rG = [" ", "Enter", "ArrowUp", "ArrowDown"], oG = [" ", "Enter"], La = "Select", [Mc, Ic, iG] = qH(La), [Ti, bZ] = qp(La, [
  iG,
  N9
]), Oc = N9(), [aG, zr] = Ti(La), [sG, lG] = Ti(La), H9 = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    value: l,
    defaultValue: c,
    onValueChange: f,
    dir: p,
    name: m,
    autoComplete: v,
    disabled: C,
    required: x,
    form: y
  } = e, h = Oc(t), [b, w] = d.useState(null), [N, _] = d.useState(null), [P, A] = d.useState(!1), I = vn(p), [T = !1, M] = et({
    prop: r,
    defaultProp: o,
    onChange: i
  }), [D, W] = et({
    prop: l,
    defaultProp: c,
    onChange: f
  }), U = d.useRef(null), re = b ? y || !!b.closest("form") : !0, [j, X] = d.useState(/* @__PURE__ */ new Set()), oe = Array.from(j).map((G) => G.props.value).join(";");
  return /* @__PURE__ */ s(vU, { ...h, children: /* @__PURE__ */ R(
    aG,
    {
      required: x,
      scope: t,
      trigger: b,
      onTriggerChange: w,
      valueNode: N,
      onValueNodeChange: _,
      valueNodeHasChildren: P,
      onValueNodeHasChildrenChange: A,
      contentId: it(),
      value: D,
      onValueChange: W,
      open: T,
      onOpenChange: M,
      dir: I,
      triggerPointerDownPosRef: U,
      disabled: C,
      children: [
        /* @__PURE__ */ s(Mc.Provider, { scope: t, children: /* @__PURE__ */ s(
          sG,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: d.useCallback((G) => {
              X((Q) => new Set(Q).add(G));
            }, []),
            onNativeOptionRemove: d.useCallback((G) => {
              X((Q) => {
                const te = new Set(Q);
                return te.delete(G), te;
              });
            }, []),
            children: n
          }
        ) }),
        re ? /* @__PURE__ */ R(
          fC,
          {
            "aria-hidden": !0,
            required: x,
            tabIndex: -1,
            name: m,
            autoComplete: v,
            value: D,
            onChange: (G) => W(G.target.value),
            disabled: C,
            form: y,
            children: [
              D === void 0 ? /* @__PURE__ */ s("option", { value: "" }) : null,
              Array.from(j)
            ]
          },
          oe
        ) : null
      ]
    }
  ) });
};
H9.displayName = La;
var U9 = "SelectTrigger", G9 = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, i = Oc(n), l = zr(U9, n), c = l.disabled || r, f = Rt(t, l.onTriggerChange), p = Ic(n), m = d.useRef("touch"), [v, C, x] = pC((h) => {
      const b = p().filter((_) => !_.disabled), w = b.find((_) => _.value === l.value), N = mC(b, h, w);
      N !== void 0 && l.onValueChange(N.value);
    }), y = (h) => {
      c || (l.onOpenChange(!0), x()), h && (l.triggerPointerDownPosRef.current = {
        x: Math.round(h.pageX),
        y: Math.round(h.pageY)
      });
    };
    return /* @__PURE__ */ s(CU, { asChild: !0, ...i, children: /* @__PURE__ */ s(
      vt.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": l.contentId,
        "aria-expanded": l.open,
        "aria-required": l.required,
        "aria-autocomplete": "none",
        dir: l.dir,
        "data-state": l.open ? "open" : "closed",
        disabled: c,
        "data-disabled": c ? "" : void 0,
        "data-placeholder": dC(l.value) ? "" : void 0,
        ...o,
        ref: f,
        onClick: ht(o.onClick, (h) => {
          h.currentTarget.focus(), m.current !== "mouse" && y(h);
        }),
        onPointerDown: ht(o.onPointerDown, (h) => {
          m.current = h.pointerType;
          const b = h.target;
          b.hasPointerCapture(h.pointerId) && b.releasePointerCapture(h.pointerId), h.button === 0 && h.ctrlKey === !1 && h.pointerType === "mouse" && (y(h), h.preventDefault());
        }),
        onKeyDown: ht(o.onKeyDown, (h) => {
          const b = v.current !== "";
          !(h.ctrlKey || h.altKey || h.metaKey) && h.key.length === 1 && C(h.key), !(b && h.key === " ") && rG.includes(h.key) && (y(), h.preventDefault());
        })
      }
    ) });
  }
);
G9.displayName = U9;
var z9 = "SelectValue", q9 = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: i, placeholder: l = "", ...c } = e, f = zr(z9, n), { onValueNodeHasChildrenChange: p } = f, m = i !== void 0, v = Rt(t, f.onValueNodeChange);
    return be(() => {
      p(m);
    }, [p, m]), /* @__PURE__ */ s(
      vt.span,
      {
        ...c,
        ref: v,
        style: { pointerEvents: "none" },
        children: dC(f.value) ? /* @__PURE__ */ s(le, { children: l }) : i
      }
    );
  }
);
q9.displayName = z9;
var cG = "SelectIcon", K9 = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ s(vt.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
K9.displayName = cG;
var uG = "SelectPortal", Y9 = (e) => /* @__PURE__ */ s(M9, { asChild: !0, ...e });
Y9.displayName = uG;
var xo = "SelectContent", Z9 = d.forwardRef(
  (e, t) => {
    const n = zr(xo, e.__scopeSelect), [r, o] = d.useState();
    if (be(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? Tn.createPortal(
        /* @__PURE__ */ s(X9, { scope: e.__scopeSelect, children: /* @__PURE__ */ s(Mc.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ s("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ s(j9, { ...e, ref: t });
  }
);
Z9.displayName = xo;
var Rn = 10, [X9, qr] = Ti(xo), dG = "SelectContentImpl", j9 = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: l,
      //
      // PopperContent props
      side: c,
      sideOffset: f,
      align: p,
      alignOffset: m,
      arrowPadding: v,
      collisionBoundary: C,
      collisionPadding: x,
      sticky: y,
      hideWhenDetached: h,
      avoidCollisions: b,
      //
      ...w
    } = e, N = zr(xo, n), [_, P] = d.useState(null), [A, I] = d.useState(null), T = Rt(t, (ie) => P(ie)), [M, D] = d.useState(null), [W, U] = d.useState(
      null
    ), re = Ic(n), [j, X] = d.useState(!1), oe = d.useRef(!1);
    d.useEffect(() => {
      if (_) return Si(_);
    }, [_]), M1();
    const G = d.useCallback(
      (ie) => {
        const [Ce, ..._e] = re().map((Ie) => Ie.ref.current), [Te] = _e.slice(-1), Me = document.activeElement;
        for (const Ie of ie)
          if (Ie === Me || (Ie == null || Ie.scrollIntoView({ block: "nearest" }), Ie === Ce && A && (A.scrollTop = 0), Ie === Te && A && (A.scrollTop = A.scrollHeight), Ie == null || Ie.focus(), document.activeElement !== Me)) return;
      },
      [re, A]
    ), Q = d.useCallback(
      () => G([M, _]),
      [G, M, _]
    );
    d.useEffect(() => {
      j && Q();
    }, [j, Q]);
    const { onOpenChange: te, triggerPointerDownPosRef: ee } = N;
    d.useEffect(() => {
      if (_) {
        let ie = { x: 0, y: 0 };
        const Ce = (Te) => {
          var Me, Ie;
          ie = {
            x: Math.abs(Math.round(Te.pageX) - (((Me = ee.current) == null ? void 0 : Me.x) ?? 0)),
            y: Math.abs(Math.round(Te.pageY) - (((Ie = ee.current) == null ? void 0 : Ie.y) ?? 0))
          };
        }, _e = (Te) => {
          ie.x <= 10 && ie.y <= 10 ? Te.preventDefault() : _.contains(Te.target) || te(!1), document.removeEventListener("pointermove", Ce), ee.current = null;
        };
        return ee.current !== null && (document.addEventListener("pointermove", Ce), document.addEventListener("pointerup", _e, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Ce), document.removeEventListener("pointerup", _e, { capture: !0 });
        };
      }
    }, [_, te, ee]), d.useEffect(() => {
      const ie = () => te(!1);
      return window.addEventListener("blur", ie), window.addEventListener("resize", ie), () => {
        window.removeEventListener("blur", ie), window.removeEventListener("resize", ie);
      };
    }, [te]);
    const [Pe, ce] = pC((ie) => {
      const Ce = re().filter((Me) => !Me.disabled), _e = Ce.find((Me) => Me.ref.current === document.activeElement), Te = mC(Ce, ie, _e);
      Te && setTimeout(() => Te.ref.current.focus());
    }), K = d.useCallback(
      (ie, Ce, _e) => {
        const Te = !oe.current && !_e;
        (N.value !== void 0 && N.value === Ce || Te) && (D(ie), Te && (oe.current = !0));
      },
      [N.value]
    ), pe = d.useCallback(() => _ == null ? void 0 : _.focus(), [_]), ge = d.useCallback(
      (ie, Ce, _e) => {
        const Te = !oe.current && !_e;
        (N.value !== void 0 && N.value === Ce || Te) && U(ie);
      },
      [N.value]
    ), ue = r === "popper" ? r1 : Q9, ye = ue === r1 ? {
      side: c,
      sideOffset: f,
      align: p,
      alignOffset: m,
      arrowPadding: v,
      collisionBoundary: C,
      collisionPadding: x,
      sticky: y,
      hideWhenDetached: h,
      avoidCollisions: b
    } : {};
    return /* @__PURE__ */ s(
      X9,
      {
        scope: n,
        content: _,
        viewport: A,
        onViewportChange: I,
        itemRefCallback: K,
        selectedItem: M,
        onItemLeave: pe,
        itemTextRefCallback: ge,
        focusSelectedItem: Q,
        selectedItemText: W,
        position: r,
        isPositioned: j,
        searchRef: Pe,
        children: /* @__PURE__ */ s(W9, { as: ha, allowPinchZoom: !0, children: /* @__PURE__ */ s(
          b9,
          {
            asChild: !0,
            trapped: N.open,
            onMountAutoFocus: (ie) => {
              ie.preventDefault();
            },
            onUnmountAutoFocus: ht(o, (ie) => {
              var Ce;
              (Ce = N.trigger) == null || Ce.focus({ preventScroll: !0 }), ie.preventDefault();
            }),
            children: /* @__PURE__ */ s(
              C9,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: l,
                onFocusOutside: (ie) => ie.preventDefault(),
                onDismiss: () => N.onOpenChange(!1),
                children: /* @__PURE__ */ s(
                  ue,
                  {
                    role: "listbox",
                    id: N.contentId,
                    "data-state": N.open ? "open" : "closed",
                    dir: N.dir,
                    onContextMenu: (ie) => ie.preventDefault(),
                    ...w,
                    ...ye,
                    onPlaced: () => X(!0),
                    ref: T,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: ht(w.onKeyDown, (ie) => {
                      const Ce = ie.ctrlKey || ie.altKey || ie.metaKey;
                      if (ie.key === "Tab" && ie.preventDefault(), !Ce && ie.key.length === 1 && ce(ie.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(ie.key)) {
                        let Te = re().filter((Me) => !Me.disabled).map((Me) => Me.ref.current);
                        if (["ArrowUp", "End"].includes(ie.key) && (Te = Te.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(ie.key)) {
                          const Me = ie.target, Ie = Te.indexOf(Me);
                          Te = Te.slice(Ie + 1);
                        }
                        setTimeout(() => G(Te)), ie.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
j9.displayName = dG;
var fG = "SelectItemAlignedPosition", Q9 = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, i = zr(xo, n), l = qr(xo, n), [c, f] = d.useState(null), [p, m] = d.useState(null), v = Rt(t, (T) => m(T)), C = Ic(n), x = d.useRef(!1), y = d.useRef(!0), { viewport: h, selectedItem: b, selectedItemText: w, focusSelectedItem: N } = l, _ = d.useCallback(() => {
    if (i.trigger && i.valueNode && c && p && h && b && w) {
      const T = i.trigger.getBoundingClientRect(), M = p.getBoundingClientRect(), D = i.valueNode.getBoundingClientRect(), W = w.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const Me = W.left - M.left, Ie = D.left - Me, ze = T.left - Ie, Ke = T.width + ze, St = Math.max(Ke, M.width), Kt = window.innerWidth - Rn, ut = ma(Ie, [
          Rn,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Rn, Kt - St)
        ]);
        c.style.minWidth = Ke + "px", c.style.left = ut + "px";
      } else {
        const Me = M.right - W.right, Ie = window.innerWidth - D.right - Me, ze = window.innerWidth - T.right - Ie, Ke = T.width + ze, St = Math.max(Ke, M.width), Kt = window.innerWidth - Rn, ut = ma(Ie, [
          Rn,
          Math.max(Rn, Kt - St)
        ]);
        c.style.minWidth = Ke + "px", c.style.right = ut + "px";
      }
      const U = C(), re = window.innerHeight - Rn * 2, j = h.scrollHeight, X = window.getComputedStyle(p), oe = parseInt(X.borderTopWidth, 10), G = parseInt(X.paddingTop, 10), Q = parseInt(X.borderBottomWidth, 10), te = parseInt(X.paddingBottom, 10), ee = oe + G + j + te + Q, Pe = Math.min(b.offsetHeight * 5, ee), ce = window.getComputedStyle(h), K = parseInt(ce.paddingTop, 10), pe = parseInt(ce.paddingBottom, 10), ge = T.top + T.height / 2 - Rn, ue = re - ge, ye = b.offsetHeight / 2, ie = b.offsetTop + ye, Ce = oe + G + ie, _e = ee - Ce;
      if (Ce <= ge) {
        const Me = U.length > 0 && b === U[U.length - 1].ref.current;
        c.style.bottom = "0px";
        const Ie = p.clientHeight - h.offsetTop - h.offsetHeight, ze = Math.max(
          ue,
          ye + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (Me ? pe : 0) + Ie + Q
        ), Ke = Ce + ze;
        c.style.height = Ke + "px";
      } else {
        const Me = U.length > 0 && b === U[0].ref.current;
        c.style.top = "0px";
        const ze = Math.max(
          ge,
          oe + h.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (Me ? K : 0) + ye
        ) + _e;
        c.style.height = ze + "px", h.scrollTop = Ce - ge + h.offsetTop;
      }
      c.style.margin = `${Rn}px 0`, c.style.minHeight = Pe + "px", c.style.maxHeight = re + "px", r == null || r(), requestAnimationFrame(() => x.current = !0);
    }
  }, [
    C,
    i.trigger,
    i.valueNode,
    c,
    p,
    h,
    b,
    w,
    i.dir,
    r
  ]);
  be(() => _(), [_]);
  const [P, A] = d.useState();
  be(() => {
    p && A(window.getComputedStyle(p).zIndex);
  }, [p]);
  const I = d.useCallback(
    (T) => {
      T && y.current === !0 && (_(), N == null || N(), y.current = !1);
    },
    [_, N]
  );
  return /* @__PURE__ */ s(
    mG,
    {
      scope: n,
      contentWrapper: c,
      shouldExpandOnScrollRef: x,
      onScrollButtonChange: I,
      children: /* @__PURE__ */ s(
        "div",
        {
          ref: f,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: P
          },
          children: /* @__PURE__ */ s(
            vt.div,
            {
              ...o,
              ref: v,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
Q9.displayName = fG;
var pG = "SelectPopperPosition", r1 = d.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = Rn,
    ...i
  } = e, l = Oc(n);
  return /* @__PURE__ */ s(
    xU,
    {
      ...l,
      ...i,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
r1.displayName = pG;
var [mG, Zp] = Ti(xo, {}), o1 = "SelectViewport", J9 = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, i = qr(o1, n), l = Zp(o1, n), c = Rt(t, i.onViewportChange), f = d.useRef(0);
    return /* @__PURE__ */ R(le, { children: [
      /* @__PURE__ */ s(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ s(Mc.Slot, { scope: n, children: /* @__PURE__ */ s(
        vt.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: c,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: ht(o.onScroll, (p) => {
            const m = p.currentTarget, { contentWrapper: v, shouldExpandOnScrollRef: C } = l;
            if (C != null && C.current && v) {
              const x = Math.abs(f.current - m.scrollTop);
              if (x > 0) {
                const y = window.innerHeight - Rn * 2, h = parseFloat(v.style.minHeight), b = parseFloat(v.style.height), w = Math.max(h, b);
                if (w < y) {
                  const N = w + x, _ = Math.min(y, N), P = N - _;
                  v.style.height = _ + "px", v.style.bottom === "0px" && (m.scrollTop = P > 0 ? P : 0, v.style.justifyContent = "flex-end");
                }
              }
            }
            f.current = m.scrollTop;
          })
        }
      ) })
    ] });
  }
);
J9.displayName = o1;
var eC = "SelectGroup", [hG, gG] = Ti(eC), tC = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = it();
    return /* @__PURE__ */ s(hG, { scope: n, id: o, children: /* @__PURE__ */ s(vt.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
tC.displayName = eC;
var nC = "SelectLabel", rC = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = gG(nC, n);
    return /* @__PURE__ */ s(vt.div, { id: o.id, ...r, ref: t });
  }
);
rC.displayName = nC;
var Al = "SelectItem", [vG, oC] = Ti(Al), iC = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: i,
      ...l
    } = e, c = zr(Al, n), f = qr(Al, n), p = c.value === r, [m, v] = d.useState(i ?? ""), [C, x] = d.useState(!1), y = Rt(
      t,
      (N) => {
        var _;
        return (_ = f.itemRefCallback) == null ? void 0 : _.call(f, N, r, o);
      }
    ), h = it(), b = d.useRef("touch"), w = () => {
      o || (c.onValueChange(r), c.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ s(
      vG,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: h,
        isSelected: p,
        onItemTextChange: d.useCallback((N) => {
          v((_) => _ || ((N == null ? void 0 : N.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ s(
          Mc.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: m,
            children: /* @__PURE__ */ s(
              vt.div,
              {
                role: "option",
                "aria-labelledby": h,
                "data-highlighted": C ? "" : void 0,
                "aria-selected": p && C,
                "data-state": p ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...l,
                ref: y,
                onFocus: ht(l.onFocus, () => x(!0)),
                onBlur: ht(l.onBlur, () => x(!1)),
                onClick: ht(l.onClick, () => {
                  b.current !== "mouse" && w();
                }),
                onPointerUp: ht(l.onPointerUp, () => {
                  b.current === "mouse" && w();
                }),
                onPointerDown: ht(l.onPointerDown, (N) => {
                  b.current = N.pointerType;
                }),
                onPointerMove: ht(l.onPointerMove, (N) => {
                  var _;
                  b.current = N.pointerType, o ? (_ = f.onItemLeave) == null || _.call(f) : b.current === "mouse" && N.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: ht(l.onPointerLeave, (N) => {
                  var _;
                  N.currentTarget === document.activeElement && ((_ = f.onItemLeave) == null || _.call(f));
                }),
                onKeyDown: ht(l.onKeyDown, (N) => {
                  var P;
                  ((P = f.searchRef) == null ? void 0 : P.current) !== "" && N.key === " " || (oG.includes(N.key) && w(), N.key === " " && N.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
iC.displayName = Al;
var ta = "SelectItemText", aC = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...i } = e, l = zr(ta, n), c = qr(ta, n), f = oC(ta, n), p = lG(ta, n), [m, v] = d.useState(null), C = Rt(
      t,
      (w) => v(w),
      f.onItemTextChange,
      (w) => {
        var N;
        return (N = c.itemTextRefCallback) == null ? void 0 : N.call(c, w, f.value, f.disabled);
      }
    ), x = m == null ? void 0 : m.textContent, y = d.useMemo(
      () => /* @__PURE__ */ s("option", { value: f.value, disabled: f.disabled, children: x }, f.value),
      [f.disabled, f.value, x]
    ), { onNativeOptionAdd: h, onNativeOptionRemove: b } = p;
    return be(() => (h(y), () => b(y)), [h, b, y]), /* @__PURE__ */ R(le, { children: [
      /* @__PURE__ */ s(vt.span, { id: f.textId, ...i, ref: C }),
      f.isSelected && l.valueNode && !l.valueNodeHasChildren ? Tn.createPortal(i.children, l.valueNode) : null
    ] });
  }
);
aC.displayName = ta;
var sC = "SelectItemIndicator", lC = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return oC(sC, n).isSelected ? /* @__PURE__ */ s(vt.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
lC.displayName = sC;
var i1 = "SelectScrollUpButton", CG = d.forwardRef((e, t) => {
  const n = qr(i1, e.__scopeSelect), r = Zp(i1, e.__scopeSelect), [o, i] = d.useState(!1), l = Rt(t, r.onScrollButtonChange);
  return be(() => {
    if (n.viewport && n.isPositioned) {
      let c = function() {
        const p = f.scrollTop > 0;
        i(p);
      };
      const f = n.viewport;
      return c(), f.addEventListener("scroll", c), () => f.removeEventListener("scroll", c);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ s(
    cC,
    {
      ...e,
      ref: l,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: f } = n;
        c && f && (c.scrollTop = c.scrollTop - f.offsetHeight);
      }
    }
  ) : null;
});
CG.displayName = i1;
var a1 = "SelectScrollDownButton", xG = d.forwardRef((e, t) => {
  const n = qr(a1, e.__scopeSelect), r = Zp(a1, e.__scopeSelect), [o, i] = d.useState(!1), l = Rt(t, r.onScrollButtonChange);
  return be(() => {
    if (n.viewport && n.isPositioned) {
      let c = function() {
        const p = f.scrollHeight - f.clientHeight, m = Math.ceil(f.scrollTop) < p;
        i(m);
      };
      const f = n.viewport;
      return c(), f.addEventListener("scroll", c), () => f.removeEventListener("scroll", c);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ s(
    cC,
    {
      ...e,
      ref: l,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: f } = n;
        c && f && (c.scrollTop = c.scrollTop + f.offsetHeight);
      }
    }
  ) : null;
});
xG.displayName = a1;
var cC = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, i = qr("SelectScrollButton", n), l = d.useRef(null), c = Ic(n), f = d.useCallback(() => {
    l.current !== null && (window.clearInterval(l.current), l.current = null);
  }, []);
  return d.useEffect(() => () => f(), [f]), be(() => {
    var m;
    const p = c().find((v) => v.ref.current === document.activeElement);
    (m = p == null ? void 0 : p.ref.current) == null || m.scrollIntoView({ block: "nearest" });
  }, [c]), /* @__PURE__ */ s(
    vt.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: ht(o.onPointerDown, () => {
        l.current === null && (l.current = window.setInterval(r, 50));
      }),
      onPointerMove: ht(o.onPointerMove, () => {
        var p;
        (p = i.onItemLeave) == null || p.call(i), l.current === null && (l.current = window.setInterval(r, 50));
      }),
      onPointerLeave: ht(o.onPointerLeave, () => {
        f();
      })
    }
  );
}), bG = "SelectSeparator", uC = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ s(vt.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
uC.displayName = bG;
var s1 = "SelectArrow", yG = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Oc(n), i = zr(s1, n), l = qr(s1, n);
    return i.open && l.position === "popper" ? /* @__PURE__ */ s(bU, { ...o, ...r, ref: t }) : null;
  }
);
yG.displayName = s1;
function dC(e) {
  return e === "" || e === void 0;
}
var fC = d.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = d.useRef(null), i = Rt(t, o), l = Ni(n);
    return d.useEffect(() => {
      const c = o.current, f = window.HTMLSelectElement.prototype, m = Object.getOwnPropertyDescriptor(
        f,
        "value"
      ).set;
      if (l !== n && m) {
        const v = new Event("change", { bubbles: !0 });
        m.call(c, n), c.dispatchEvent(v);
      }
    }, [l, n]), /* @__PURE__ */ s(I9, { asChild: !0, children: /* @__PURE__ */ s("select", { ...r, ref: i, defaultValue: n }) });
  }
);
fC.displayName = "BubbleSelect";
function pC(e) {
  const t = xe(e), n = d.useRef(""), r = d.useRef(0), o = d.useCallback(
    (l) => {
      const c = n.current + l;
      t(c), function f(p) {
        n.current = p, window.clearTimeout(r.current), p !== "" && (r.current = window.setTimeout(() => f(""), 1e3));
      }(c);
    },
    [t]
  ), i = d.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return d.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, i];
}
function mC(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((p) => p === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let l = wG(e, Math.max(i, 0));
  o.length === 1 && (l = l.filter((p) => p !== n));
  const f = l.find(
    (p) => p.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return f !== n ? f : void 0;
}
function wG(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var SG = H9, hC = G9, NG = q9, _G = K9, RG = Y9, gC = Z9, EG = J9, PG = tC, vC = rC, CC = iC, AG = aC, TG = lC, xC = uC;
const yZ = SG, wZ = PG, SZ = NG, $G = q(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ R(
  hC,
  {
    ref: r,
    className: F(
      "border-input bg-background ring-offset-background placeholder:text-muted-foreground focus:ring-ring flex h-10 w-full items-center justify-between rounded-md border px-3 py-2 text-sm focus:outline-hidden focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ s(_G, { asChild: !0, children: /* @__PURE__ */ s(va, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
$G.displayName = hC.displayName;
const LG = q(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ s(RG, { children: /* @__PURE__ */ s(
  gC,
  {
    ref: o,
    className: F(
      "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 min-w-[8rem] overflow-hidden rounded-md border border-border shadow-md",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: /* @__PURE__ */ s(
      EG,
      {
        className: F(
          "p-1",
          n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
        ),
        children: t
      }
    )
  }
) }));
LG.displayName = gC.displayName;
const MG = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  vC,
  {
    ref: n,
    className: F("py-1.5 pl-8 pr-2 text-sm font-semibold", e),
    ...t
  }
));
MG.displayName = vC.displayName;
const IG = q(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ R(
  CC,
  {
    ref: r,
    className: F(
      "focus:bg-accent focus:text-accent-foreground relative flex w-full cursor-default select-none items-center rounded-xs py-1.5 pl-8 pr-2 text-sm outline-hidden data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ s("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ s(TG, { children: /* @__PURE__ */ s(wo, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ s(AG, { children: t })
    ]
  }
));
IG.displayName = CC.displayName;
const OG = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  xC,
  {
    ref: n,
    className: F("bg-muted -mx-1 my-1 h-px", e),
    ...t
  }
));
OG.displayName = xC.displayName;
var kG = "Separator", O2 = "horizontal", DG = ["horizontal", "vertical"], bC = d.forwardRef((e, t) => {
  const { decorative: n, orientation: r = O2, ...o } = e, i = FG(r) ? r : O2, c = n ? { role: "none" } : { "aria-orientation": i === "vertical" ? i : void 0, role: "separator" };
  return /* @__PURE__ */ s(
    ve.div,
    {
      "data-orientation": i,
      ...c,
      ...o,
      ref: t
    }
  );
});
bC.displayName = kG;
function FG(e) {
  return DG.includes(e);
}
var yC = bC;
const ga = q(
  ({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, o) => /* @__PURE__ */ s(
    yC,
    {
      ref: o,
      decorative: n,
      orientation: t,
      className: F(
        "bg-border shrink-0",
        t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        e
      ),
      ...r
    }
  )
);
ga.displayName = yC.displayName;
const wC = o5, BG = i5, NZ = lc, VG = a5, SC = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  ic,
  {
    className: F(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/80",
      e
    ),
    ...t,
    ref: n
  }
));
SC.displayName = ic.displayName;
const WG = cr(
  "fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), Xp = q(
  ({ side: e = "right", className: t, children: n, showOverlay: r = !0, ...o }, i) => /* @__PURE__ */ R(VG, { children: [
    r && /* @__PURE__ */ s(SC, {}),
    /* @__PURE__ */ R(
      ac,
      {
        "aria-describedby": void 0,
        ref: i,
        className: F(WG({ side: e }), t),
        ...o,
        children: [
          /* @__PURE__ */ s(wa, { children: o.title }),
          n,
          /* @__PURE__ */ R(lc, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-secondary absolute right-4 top-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:outline-hidden focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none", children: [
            /* @__PURE__ */ s(Ll, { className: "h-4 w-4" }),
            /* @__PURE__ */ s("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] })
);
Xp.displayName = ac.displayName;
const HG = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  "div",
  {
    className: F(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
HG.displayName = "SheetHeader";
const NC = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s(
  "div",
  {
    className: F(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
NC.displayName = "SheetFooter";
const UG = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  wa,
  {
    ref: n,
    className: F("text-foreground text-lg font-semibold", e),
    ...t
  }
));
UG.displayName = wa.displayName;
const GG = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  sc,
  {
    ref: n,
    className: F("text-muted-foreground text-sm", e),
    ...t
  }
));
GG.displayName = sc.displayName;
var na = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var zG = na.exports, k2;
function qG() {
  return k2 || (k2 = 1, function(e, t) {
    (function() {
      var n, r = "4.17.21", o = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", c = "Invalid `variable` option passed into `_.template`", f = "__lodash_hash_undefined__", p = 500, m = "__lodash_placeholder__", v = 1, C = 2, x = 4, y = 1, h = 2, b = 1, w = 2, N = 4, _ = 8, P = 16, A = 32, I = 64, T = 128, M = 256, D = 512, W = 30, U = "...", re = 800, j = 16, X = 1, oe = 2, G = 3, Q = 1 / 0, te = 9007199254740991, ee = 17976931348623157e292, Pe = NaN, ce = 4294967295, K = ce - 1, pe = ce >>> 1, ge = [
        ["ary", T],
        ["bind", b],
        ["bindKey", w],
        ["curry", _],
        ["curryRight", P],
        ["flip", D],
        ["partial", A],
        ["partialRight", I],
        ["rearg", M]
      ], ue = "[object Arguments]", ye = "[object Array]", ie = "[object AsyncFunction]", Ce = "[object Boolean]", _e = "[object Date]", Te = "[object DOMException]", Me = "[object Error]", Ie = "[object Function]", ze = "[object GeneratorFunction]", Ke = "[object Map]", St = "[object Number]", Kt = "[object Null]", ut = "[object Object]", Mn = "[object Promise]", dt = "[object Proxy]", Li = "[object RegExp]", yn = "[object Set]", Mi = "[object String]", Ma = "[object Symbol]", xb = "[object Undefined]", Ii = "[object WeakMap]", bb = "[object WeakSet]", Oi = "[object ArrayBuffer]", Po = "[object DataView]", zc = "[object Float32Array]", qc = "[object Float64Array]", Kc = "[object Int8Array]", Yc = "[object Int16Array]", Zc = "[object Int32Array]", Xc = "[object Uint8Array]", jc = "[object Uint8ClampedArray]", Qc = "[object Uint16Array]", Jc = "[object Uint32Array]", yb = /\b__p \+= '';/g, wb = /\b(__p \+=) '' \+/g, Sb = /(__e\(.*?\)|\b__t\)) \+\n'';/g, cm = /&(?:amp|lt|gt|quot|#39);/g, um = /[&<>"']/g, Nb = RegExp(cm.source), _b = RegExp(um.source), Rb = /<%-([\s\S]+?)%>/g, Eb = /<%([\s\S]+?)%>/g, dm = /<%=([\s\S]+?)%>/g, Pb = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ab = /^\w*$/, Tb = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, eu = /[\\^$.*+?()[\]{}|]/g, $b = RegExp(eu.source), tu = /^\s+/, Lb = /\s/, Mb = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ib = /\{\n\/\* \[wrapped with (.+)\] \*/, Ob = /,? & /, kb = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Db = /[()=,{}\[\]\/\s]/, Fb = /\\(\\)?/g, Bb = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, fm = /\w*$/, Vb = /^[-+]0x[0-9a-f]+$/i, Wb = /^0b[01]+$/i, Hb = /^\[object .+?Constructor\]$/, Ub = /^0o[0-7]+$/i, Gb = /^(?:0|[1-9]\d*)$/, zb = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ia = /($^)/, qb = /['\n\r\u2028\u2029\\]/g, Oa = "\\ud800-\\udfff", Kb = "\\u0300-\\u036f", Yb = "\\ufe20-\\ufe2f", Zb = "\\u20d0-\\u20ff", pm = Kb + Yb + Zb, mm = "\\u2700-\\u27bf", hm = "a-z\\xdf-\\xf6\\xf8-\\xff", Xb = "\\xac\\xb1\\xd7\\xf7", jb = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Qb = "\\u2000-\\u206f", Jb = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", gm = "A-Z\\xc0-\\xd6\\xd8-\\xde", vm = "\\ufe0e\\ufe0f", Cm = Xb + jb + Qb + Jb, nu = "['’]", ey = "[" + Oa + "]", xm = "[" + Cm + "]", ka = "[" + pm + "]", bm = "\\d+", ty = "[" + mm + "]", ym = "[" + hm + "]", wm = "[^" + Oa + Cm + bm + mm + hm + gm + "]", ru = "\\ud83c[\\udffb-\\udfff]", ny = "(?:" + ka + "|" + ru + ")", Sm = "[^" + Oa + "]", ou = "(?:\\ud83c[\\udde6-\\uddff]){2}", iu = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ao = "[" + gm + "]", Nm = "\\u200d", _m = "(?:" + ym + "|" + wm + ")", ry = "(?:" + Ao + "|" + wm + ")", Rm = "(?:" + nu + "(?:d|ll|m|re|s|t|ve))?", Em = "(?:" + nu + "(?:D|LL|M|RE|S|T|VE))?", Pm = ny + "?", Am = "[" + vm + "]?", oy = "(?:" + Nm + "(?:" + [Sm, ou, iu].join("|") + ")" + Am + Pm + ")*", iy = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ay = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Tm = Am + Pm + oy, sy = "(?:" + [ty, ou, iu].join("|") + ")" + Tm, ly = "(?:" + [Sm + ka + "?", ka, ou, iu, ey].join("|") + ")", cy = RegExp(nu, "g"), uy = RegExp(ka, "g"), au = RegExp(ru + "(?=" + ru + ")|" + ly + Tm, "g"), dy = RegExp([
        Ao + "?" + ym + "+" + Rm + "(?=" + [xm, Ao, "$"].join("|") + ")",
        ry + "+" + Em + "(?=" + [xm, Ao + _m, "$"].join("|") + ")",
        Ao + "?" + _m + "+" + Rm,
        Ao + "+" + Em,
        ay,
        iy,
        bm,
        sy
      ].join("|"), "g"), fy = RegExp("[" + Nm + Oa + pm + vm + "]"), py = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, my = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], hy = -1, rt = {};
      rt[zc] = rt[qc] = rt[Kc] = rt[Yc] = rt[Zc] = rt[Xc] = rt[jc] = rt[Qc] = rt[Jc] = !0, rt[ue] = rt[ye] = rt[Oi] = rt[Ce] = rt[Po] = rt[_e] = rt[Me] = rt[Ie] = rt[Ke] = rt[St] = rt[ut] = rt[Li] = rt[yn] = rt[Mi] = rt[Ii] = !1;
      var tt = {};
      tt[ue] = tt[ye] = tt[Oi] = tt[Po] = tt[Ce] = tt[_e] = tt[zc] = tt[qc] = tt[Kc] = tt[Yc] = tt[Zc] = tt[Ke] = tt[St] = tt[ut] = tt[Li] = tt[yn] = tt[Mi] = tt[Ma] = tt[Xc] = tt[jc] = tt[Qc] = tt[Jc] = !0, tt[Me] = tt[Ie] = tt[Ii] = !1;
      var gy = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, vy = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Cy = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, xy = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, by = parseFloat, yy = parseInt, $m = typeof ws == "object" && ws && ws.Object === Object && ws, wy = typeof self == "object" && self && self.Object === Object && self, Nt = $m || wy || Function("return this")(), su = t && !t.nodeType && t, Kr = su && !0 && e && !e.nodeType && e, Lm = Kr && Kr.exports === su, lu = Lm && $m.process, an = function() {
        try {
          var B = Kr && Kr.require && Kr.require("util").types;
          return B || lu && lu.binding && lu.binding("util");
        } catch {
        }
      }(), Mm = an && an.isArrayBuffer, Im = an && an.isDate, Om = an && an.isMap, km = an && an.isRegExp, Dm = an && an.isSet, Fm = an && an.isTypedArray;
      function Yt(B, z, H) {
        switch (H.length) {
          case 0:
            return B.call(z);
          case 1:
            return B.call(z, H[0]);
          case 2:
            return B.call(z, H[0], H[1]);
          case 3:
            return B.call(z, H[0], H[1], H[2]);
        }
        return B.apply(z, H);
      }
      function Sy(B, z, H, fe) {
        for (var $e = -1, Ye = B == null ? 0 : B.length; ++$e < Ye; ) {
          var Ct = B[$e];
          z(fe, Ct, H(Ct), B);
        }
        return fe;
      }
      function sn(B, z) {
        for (var H = -1, fe = B == null ? 0 : B.length; ++H < fe && z(B[H], H, B) !== !1; )
          ;
        return B;
      }
      function Ny(B, z) {
        for (var H = B == null ? 0 : B.length; H-- && z(B[H], H, B) !== !1; )
          ;
        return B;
      }
      function Bm(B, z) {
        for (var H = -1, fe = B == null ? 0 : B.length; ++H < fe; )
          if (!z(B[H], H, B))
            return !1;
        return !0;
      }
      function mr(B, z) {
        for (var H = -1, fe = B == null ? 0 : B.length, $e = 0, Ye = []; ++H < fe; ) {
          var Ct = B[H];
          z(Ct, H, B) && (Ye[$e++] = Ct);
        }
        return Ye;
      }
      function Da(B, z) {
        var H = B == null ? 0 : B.length;
        return !!H && To(B, z, 0) > -1;
      }
      function cu(B, z, H) {
        for (var fe = -1, $e = B == null ? 0 : B.length; ++fe < $e; )
          if (H(z, B[fe]))
            return !0;
        return !1;
      }
      function ot(B, z) {
        for (var H = -1, fe = B == null ? 0 : B.length, $e = Array(fe); ++H < fe; )
          $e[H] = z(B[H], H, B);
        return $e;
      }
      function hr(B, z) {
        for (var H = -1, fe = z.length, $e = B.length; ++H < fe; )
          B[$e + H] = z[H];
        return B;
      }
      function uu(B, z, H, fe) {
        var $e = -1, Ye = B == null ? 0 : B.length;
        for (fe && Ye && (H = B[++$e]); ++$e < Ye; )
          H = z(H, B[$e], $e, B);
        return H;
      }
      function _y(B, z, H, fe) {
        var $e = B == null ? 0 : B.length;
        for (fe && $e && (H = B[--$e]); $e--; )
          H = z(H, B[$e], $e, B);
        return H;
      }
      function du(B, z) {
        for (var H = -1, fe = B == null ? 0 : B.length; ++H < fe; )
          if (z(B[H], H, B))
            return !0;
        return !1;
      }
      var Ry = fu("length");
      function Ey(B) {
        return B.split("");
      }
      function Py(B) {
        return B.match(kb) || [];
      }
      function Vm(B, z, H) {
        var fe;
        return H(B, function($e, Ye, Ct) {
          if (z($e, Ye, Ct))
            return fe = Ye, !1;
        }), fe;
      }
      function Fa(B, z, H, fe) {
        for (var $e = B.length, Ye = H + (fe ? 1 : -1); fe ? Ye-- : ++Ye < $e; )
          if (z(B[Ye], Ye, B))
            return Ye;
        return -1;
      }
      function To(B, z, H) {
        return z === z ? Vy(B, z, H) : Fa(B, Wm, H);
      }
      function Ay(B, z, H, fe) {
        for (var $e = H - 1, Ye = B.length; ++$e < Ye; )
          if (fe(B[$e], z))
            return $e;
        return -1;
      }
      function Wm(B) {
        return B !== B;
      }
      function Hm(B, z) {
        var H = B == null ? 0 : B.length;
        return H ? mu(B, z) / H : Pe;
      }
      function fu(B) {
        return function(z) {
          return z == null ? n : z[B];
        };
      }
      function pu(B) {
        return function(z) {
          return B == null ? n : B[z];
        };
      }
      function Um(B, z, H, fe, $e) {
        return $e(B, function(Ye, Ct, Qe) {
          H = fe ? (fe = !1, Ye) : z(H, Ye, Ct, Qe);
        }), H;
      }
      function Ty(B, z) {
        var H = B.length;
        for (B.sort(z); H--; )
          B[H] = B[H].value;
        return B;
      }
      function mu(B, z) {
        for (var H, fe = -1, $e = B.length; ++fe < $e; ) {
          var Ye = z(B[fe]);
          Ye !== n && (H = H === n ? Ye : H + Ye);
        }
        return H;
      }
      function hu(B, z) {
        for (var H = -1, fe = Array(B); ++H < B; )
          fe[H] = z(H);
        return fe;
      }
      function $y(B, z) {
        return ot(z, function(H) {
          return [H, B[H]];
        });
      }
      function Gm(B) {
        return B && B.slice(0, Ym(B) + 1).replace(tu, "");
      }
      function Zt(B) {
        return function(z) {
          return B(z);
        };
      }
      function gu(B, z) {
        return ot(z, function(H) {
          return B[H];
        });
      }
      function ki(B, z) {
        return B.has(z);
      }
      function zm(B, z) {
        for (var H = -1, fe = B.length; ++H < fe && To(z, B[H], 0) > -1; )
          ;
        return H;
      }
      function qm(B, z) {
        for (var H = B.length; H-- && To(z, B[H], 0) > -1; )
          ;
        return H;
      }
      function Ly(B, z) {
        for (var H = B.length, fe = 0; H--; )
          B[H] === z && ++fe;
        return fe;
      }
      var My = pu(gy), Iy = pu(vy);
      function Oy(B) {
        return "\\" + xy[B];
      }
      function ky(B, z) {
        return B == null ? n : B[z];
      }
      function $o(B) {
        return fy.test(B);
      }
      function Dy(B) {
        return py.test(B);
      }
      function Fy(B) {
        for (var z, H = []; !(z = B.next()).done; )
          H.push(z.value);
        return H;
      }
      function vu(B) {
        var z = -1, H = Array(B.size);
        return B.forEach(function(fe, $e) {
          H[++z] = [$e, fe];
        }), H;
      }
      function Km(B, z) {
        return function(H) {
          return B(z(H));
        };
      }
      function gr(B, z) {
        for (var H = -1, fe = B.length, $e = 0, Ye = []; ++H < fe; ) {
          var Ct = B[H];
          (Ct === z || Ct === m) && (B[H] = m, Ye[$e++] = H);
        }
        return Ye;
      }
      function Ba(B) {
        var z = -1, H = Array(B.size);
        return B.forEach(function(fe) {
          H[++z] = fe;
        }), H;
      }
      function By(B) {
        var z = -1, H = Array(B.size);
        return B.forEach(function(fe) {
          H[++z] = [fe, fe];
        }), H;
      }
      function Vy(B, z, H) {
        for (var fe = H - 1, $e = B.length; ++fe < $e; )
          if (B[fe] === z)
            return fe;
        return -1;
      }
      function Wy(B, z, H) {
        for (var fe = H + 1; fe--; )
          if (B[fe] === z)
            return fe;
        return fe;
      }
      function Lo(B) {
        return $o(B) ? Uy(B) : Ry(B);
      }
      function wn(B) {
        return $o(B) ? Gy(B) : Ey(B);
      }
      function Ym(B) {
        for (var z = B.length; z-- && Lb.test(B.charAt(z)); )
          ;
        return z;
      }
      var Hy = pu(Cy);
      function Uy(B) {
        for (var z = au.lastIndex = 0; au.test(B); )
          ++z;
        return z;
      }
      function Gy(B) {
        return B.match(au) || [];
      }
      function zy(B) {
        return B.match(dy) || [];
      }
      var qy = function B(z) {
        z = z == null ? Nt : Mo.defaults(Nt.Object(), z, Mo.pick(Nt, my));
        var H = z.Array, fe = z.Date, $e = z.Error, Ye = z.Function, Ct = z.Math, Qe = z.Object, Cu = z.RegExp, Ky = z.String, ln = z.TypeError, Va = H.prototype, Yy = Ye.prototype, Io = Qe.prototype, Wa = z["__core-js_shared__"], Ha = Yy.toString, je = Io.hasOwnProperty, Zy = 0, Zm = function() {
          var a = /[^.]+$/.exec(Wa && Wa.keys && Wa.keys.IE_PROTO || "");
          return a ? "Symbol(src)_1." + a : "";
        }(), Ua = Io.toString, Xy = Ha.call(Qe), jy = Nt._, Qy = Cu(
          "^" + Ha.call(je).replace(eu, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Ga = Lm ? z.Buffer : n, vr = z.Symbol, za = z.Uint8Array, Xm = Ga ? Ga.allocUnsafe : n, qa = Km(Qe.getPrototypeOf, Qe), jm = Qe.create, Qm = Io.propertyIsEnumerable, Ka = Va.splice, Jm = vr ? vr.isConcatSpreadable : n, Di = vr ? vr.iterator : n, Yr = vr ? vr.toStringTag : n, Ya = function() {
          try {
            var a = Jr(Qe, "defineProperty");
            return a({}, "", {}), a;
          } catch {
          }
        }(), Jy = z.clearTimeout !== Nt.clearTimeout && z.clearTimeout, ew = fe && fe.now !== Nt.Date.now && fe.now, tw = z.setTimeout !== Nt.setTimeout && z.setTimeout, Za = Ct.ceil, Xa = Ct.floor, xu = Qe.getOwnPropertySymbols, nw = Ga ? Ga.isBuffer : n, eh = z.isFinite, rw = Va.join, ow = Km(Qe.keys, Qe), xt = Ct.max, Et = Ct.min, iw = fe.now, aw = z.parseInt, th = Ct.random, sw = Va.reverse, bu = Jr(z, "DataView"), Fi = Jr(z, "Map"), yu = Jr(z, "Promise"), Oo = Jr(z, "Set"), Bi = Jr(z, "WeakMap"), Vi = Jr(Qe, "create"), ja = Bi && new Bi(), ko = {}, lw = eo(bu), cw = eo(Fi), uw = eo(yu), dw = eo(Oo), fw = eo(Bi), Qa = vr ? vr.prototype : n, Wi = Qa ? Qa.valueOf : n, nh = Qa ? Qa.toString : n;
        function $(a) {
          if (lt(a) && !Le(a) && !(a instanceof He)) {
            if (a instanceof cn)
              return a;
            if (je.call(a, "__wrapped__"))
              return rg(a);
          }
          return new cn(a);
        }
        var Do = /* @__PURE__ */ function() {
          function a() {
          }
          return function(u) {
            if (!at(u))
              return {};
            if (jm)
              return jm(u);
            a.prototype = u;
            var g = new a();
            return a.prototype = n, g;
          };
        }();
        function Ja() {
        }
        function cn(a, u) {
          this.__wrapped__ = a, this.__actions__ = [], this.__chain__ = !!u, this.__index__ = 0, this.__values__ = n;
        }
        $.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: Rb,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Eb,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: dm,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: $
          }
        }, $.prototype = Ja.prototype, $.prototype.constructor = $, cn.prototype = Do(Ja.prototype), cn.prototype.constructor = cn;
        function He(a) {
          this.__wrapped__ = a, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ce, this.__views__ = [];
        }
        function pw() {
          var a = new He(this.__wrapped__);
          return a.__actions__ = Vt(this.__actions__), a.__dir__ = this.__dir__, a.__filtered__ = this.__filtered__, a.__iteratees__ = Vt(this.__iteratees__), a.__takeCount__ = this.__takeCount__, a.__views__ = Vt(this.__views__), a;
        }
        function mw() {
          if (this.__filtered__) {
            var a = new He(this);
            a.__dir__ = -1, a.__filtered__ = !0;
          } else
            a = this.clone(), a.__dir__ *= -1;
          return a;
        }
        function hw() {
          var a = this.__wrapped__.value(), u = this.__dir__, g = Le(a), S = u < 0, E = g ? a.length : 0, L = ES(0, E, this.__views__), O = L.start, k = L.end, V = k - O, Y = S ? k : O - 1, Z = this.__iteratees__, J = Z.length, se = 0, me = Et(V, this.__takeCount__);
          if (!g || !S && E == V && me == V)
            return Rh(a, this.__actions__);
          var Se = [];
          e:
            for (; V-- && se < me; ) {
              Y += u;
              for (var Fe = -1, Ne = a[Y]; ++Fe < J; ) {
                var We = Z[Fe], Ue = We.iteratee, Qt = We.type, Dt = Ue(Ne);
                if (Qt == oe)
                  Ne = Dt;
                else if (!Dt) {
                  if (Qt == X)
                    continue e;
                  break e;
                }
              }
              Se[se++] = Ne;
            }
          return Se;
        }
        He.prototype = Do(Ja.prototype), He.prototype.constructor = He;
        function Zr(a) {
          var u = -1, g = a == null ? 0 : a.length;
          for (this.clear(); ++u < g; ) {
            var S = a[u];
            this.set(S[0], S[1]);
          }
        }
        function gw() {
          this.__data__ = Vi ? Vi(null) : {}, this.size = 0;
        }
        function vw(a) {
          var u = this.has(a) && delete this.__data__[a];
          return this.size -= u ? 1 : 0, u;
        }
        function Cw(a) {
          var u = this.__data__;
          if (Vi) {
            var g = u[a];
            return g === f ? n : g;
          }
          return je.call(u, a) ? u[a] : n;
        }
        function xw(a) {
          var u = this.__data__;
          return Vi ? u[a] !== n : je.call(u, a);
        }
        function bw(a, u) {
          var g = this.__data__;
          return this.size += this.has(a) ? 0 : 1, g[a] = Vi && u === n ? f : u, this;
        }
        Zr.prototype.clear = gw, Zr.prototype.delete = vw, Zr.prototype.get = Cw, Zr.prototype.has = xw, Zr.prototype.set = bw;
        function Gn(a) {
          var u = -1, g = a == null ? 0 : a.length;
          for (this.clear(); ++u < g; ) {
            var S = a[u];
            this.set(S[0], S[1]);
          }
        }
        function yw() {
          this.__data__ = [], this.size = 0;
        }
        function ww(a) {
          var u = this.__data__, g = es(u, a);
          if (g < 0)
            return !1;
          var S = u.length - 1;
          return g == S ? u.pop() : Ka.call(u, g, 1), --this.size, !0;
        }
        function Sw(a) {
          var u = this.__data__, g = es(u, a);
          return g < 0 ? n : u[g][1];
        }
        function Nw(a) {
          return es(this.__data__, a) > -1;
        }
        function _w(a, u) {
          var g = this.__data__, S = es(g, a);
          return S < 0 ? (++this.size, g.push([a, u])) : g[S][1] = u, this;
        }
        Gn.prototype.clear = yw, Gn.prototype.delete = ww, Gn.prototype.get = Sw, Gn.prototype.has = Nw, Gn.prototype.set = _w;
        function zn(a) {
          var u = -1, g = a == null ? 0 : a.length;
          for (this.clear(); ++u < g; ) {
            var S = a[u];
            this.set(S[0], S[1]);
          }
        }
        function Rw() {
          this.size = 0, this.__data__ = {
            hash: new Zr(),
            map: new (Fi || Gn)(),
            string: new Zr()
          };
        }
        function Ew(a) {
          var u = fs(this, a).delete(a);
          return this.size -= u ? 1 : 0, u;
        }
        function Pw(a) {
          return fs(this, a).get(a);
        }
        function Aw(a) {
          return fs(this, a).has(a);
        }
        function Tw(a, u) {
          var g = fs(this, a), S = g.size;
          return g.set(a, u), this.size += g.size == S ? 0 : 1, this;
        }
        zn.prototype.clear = Rw, zn.prototype.delete = Ew, zn.prototype.get = Pw, zn.prototype.has = Aw, zn.prototype.set = Tw;
        function Xr(a) {
          var u = -1, g = a == null ? 0 : a.length;
          for (this.__data__ = new zn(); ++u < g; )
            this.add(a[u]);
        }
        function $w(a) {
          return this.__data__.set(a, f), this;
        }
        function Lw(a) {
          return this.__data__.has(a);
        }
        Xr.prototype.add = Xr.prototype.push = $w, Xr.prototype.has = Lw;
        function Sn(a) {
          var u = this.__data__ = new Gn(a);
          this.size = u.size;
        }
        function Mw() {
          this.__data__ = new Gn(), this.size = 0;
        }
        function Iw(a) {
          var u = this.__data__, g = u.delete(a);
          return this.size = u.size, g;
        }
        function Ow(a) {
          return this.__data__.get(a);
        }
        function kw(a) {
          return this.__data__.has(a);
        }
        function Dw(a, u) {
          var g = this.__data__;
          if (g instanceof Gn) {
            var S = g.__data__;
            if (!Fi || S.length < o - 1)
              return S.push([a, u]), this.size = ++g.size, this;
            g = this.__data__ = new zn(S);
          }
          return g.set(a, u), this.size = g.size, this;
        }
        Sn.prototype.clear = Mw, Sn.prototype.delete = Iw, Sn.prototype.get = Ow, Sn.prototype.has = kw, Sn.prototype.set = Dw;
        function rh(a, u) {
          var g = Le(a), S = !g && to(a), E = !g && !S && wr(a), L = !g && !S && !E && Wo(a), O = g || S || E || L, k = O ? hu(a.length, Ky) : [], V = k.length;
          for (var Y in a)
            (u || je.call(a, Y)) && !(O && // Safari 9 has enumerable `arguments.length` in strict mode.
            (Y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            E && (Y == "offset" || Y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            L && (Y == "buffer" || Y == "byteLength" || Y == "byteOffset") || // Skip index properties.
            Zn(Y, V))) && k.push(Y);
          return k;
        }
        function oh(a) {
          var u = a.length;
          return u ? a[Lu(0, u - 1)] : n;
        }
        function Fw(a, u) {
          return ps(Vt(a), jr(u, 0, a.length));
        }
        function Bw(a) {
          return ps(Vt(a));
        }
        function wu(a, u, g) {
          (g !== n && !Nn(a[u], g) || g === n && !(u in a)) && qn(a, u, g);
        }
        function Hi(a, u, g) {
          var S = a[u];
          (!(je.call(a, u) && Nn(S, g)) || g === n && !(u in a)) && qn(a, u, g);
        }
        function es(a, u) {
          for (var g = a.length; g--; )
            if (Nn(a[g][0], u))
              return g;
          return -1;
        }
        function Vw(a, u, g, S) {
          return Cr(a, function(E, L, O) {
            u(S, E, g(E), O);
          }), S;
        }
        function ih(a, u) {
          return a && On(u, yt(u), a);
        }
        function Ww(a, u) {
          return a && On(u, Ht(u), a);
        }
        function qn(a, u, g) {
          u == "__proto__" && Ya ? Ya(a, u, {
            configurable: !0,
            enumerable: !0,
            value: g,
            writable: !0
          }) : a[u] = g;
        }
        function Su(a, u) {
          for (var g = -1, S = u.length, E = H(S), L = a == null; ++g < S; )
            E[g] = L ? n : rd(a, u[g]);
          return E;
        }
        function jr(a, u, g) {
          return a === a && (g !== n && (a = a <= g ? a : g), u !== n && (a = a >= u ? a : u)), a;
        }
        function un(a, u, g, S, E, L) {
          var O, k = u & v, V = u & C, Y = u & x;
          if (g && (O = E ? g(a, S, E, L) : g(a)), O !== n)
            return O;
          if (!at(a))
            return a;
          var Z = Le(a);
          if (Z) {
            if (O = AS(a), !k)
              return Vt(a, O);
          } else {
            var J = Pt(a), se = J == Ie || J == ze;
            if (wr(a))
              return Ah(a, k);
            if (J == ut || J == ue || se && !E) {
              if (O = V || se ? {} : Yh(a), !k)
                return V ? CS(a, Ww(O, a)) : vS(a, ih(O, a));
            } else {
              if (!tt[J])
                return E ? a : {};
              O = TS(a, J, k);
            }
          }
          L || (L = new Sn());
          var me = L.get(a);
          if (me)
            return me;
          L.set(a, O), Sg(a) ? a.forEach(function(Ne) {
            O.add(un(Ne, u, g, Ne, a, L));
          }) : yg(a) && a.forEach(function(Ne, We) {
            O.set(We, un(Ne, u, g, We, a, L));
          });
          var Se = Y ? V ? Uu : Hu : V ? Ht : yt, Fe = Z ? n : Se(a);
          return sn(Fe || a, function(Ne, We) {
            Fe && (We = Ne, Ne = a[We]), Hi(O, We, un(Ne, u, g, We, a, L));
          }), O;
        }
        function Hw(a) {
          var u = yt(a);
          return function(g) {
            return ah(g, a, u);
          };
        }
        function ah(a, u, g) {
          var S = g.length;
          if (a == null)
            return !S;
          for (a = Qe(a); S--; ) {
            var E = g[S], L = u[E], O = a[E];
            if (O === n && !(E in a) || !L(O))
              return !1;
          }
          return !0;
        }
        function sh(a, u, g) {
          if (typeof a != "function")
            throw new ln(l);
          return Zi(function() {
            a.apply(n, g);
          }, u);
        }
        function Ui(a, u, g, S) {
          var E = -1, L = Da, O = !0, k = a.length, V = [], Y = u.length;
          if (!k)
            return V;
          g && (u = ot(u, Zt(g))), S ? (L = cu, O = !1) : u.length >= o && (L = ki, O = !1, u = new Xr(u));
          e:
            for (; ++E < k; ) {
              var Z = a[E], J = g == null ? Z : g(Z);
              if (Z = S || Z !== 0 ? Z : 0, O && J === J) {
                for (var se = Y; se--; )
                  if (u[se] === J)
                    continue e;
                V.push(Z);
              } else L(u, J, S) || V.push(Z);
            }
          return V;
        }
        var Cr = Ih(In), lh = Ih(_u, !0);
        function Uw(a, u) {
          var g = !0;
          return Cr(a, function(S, E, L) {
            return g = !!u(S, E, L), g;
          }), g;
        }
        function ts(a, u, g) {
          for (var S = -1, E = a.length; ++S < E; ) {
            var L = a[S], O = u(L);
            if (O != null && (k === n ? O === O && !jt(O) : g(O, k)))
              var k = O, V = L;
          }
          return V;
        }
        function Gw(a, u, g, S) {
          var E = a.length;
          for (g = De(g), g < 0 && (g = -g > E ? 0 : E + g), S = S === n || S > E ? E : De(S), S < 0 && (S += E), S = g > S ? 0 : _g(S); g < S; )
            a[g++] = u;
          return a;
        }
        function ch(a, u) {
          var g = [];
          return Cr(a, function(S, E, L) {
            u(S, E, L) && g.push(S);
          }), g;
        }
        function _t(a, u, g, S, E) {
          var L = -1, O = a.length;
          for (g || (g = LS), E || (E = []); ++L < O; ) {
            var k = a[L];
            u > 0 && g(k) ? u > 1 ? _t(k, u - 1, g, S, E) : hr(E, k) : S || (E[E.length] = k);
          }
          return E;
        }
        var Nu = Oh(), uh = Oh(!0);
        function In(a, u) {
          return a && Nu(a, u, yt);
        }
        function _u(a, u) {
          return a && uh(a, u, yt);
        }
        function ns(a, u) {
          return mr(u, function(g) {
            return Xn(a[g]);
          });
        }
        function Qr(a, u) {
          u = br(u, a);
          for (var g = 0, S = u.length; a != null && g < S; )
            a = a[kn(u[g++])];
          return g && g == S ? a : n;
        }
        function dh(a, u, g) {
          var S = u(a);
          return Le(a) ? S : hr(S, g(a));
        }
        function Ot(a) {
          return a == null ? a === n ? xb : Kt : Yr && Yr in Qe(a) ? RS(a) : BS(a);
        }
        function Ru(a, u) {
          return a > u;
        }
        function zw(a, u) {
          return a != null && je.call(a, u);
        }
        function qw(a, u) {
          return a != null && u in Qe(a);
        }
        function Kw(a, u, g) {
          return a >= Et(u, g) && a < xt(u, g);
        }
        function Eu(a, u, g) {
          for (var S = g ? cu : Da, E = a[0].length, L = a.length, O = L, k = H(L), V = 1 / 0, Y = []; O--; ) {
            var Z = a[O];
            O && u && (Z = ot(Z, Zt(u))), V = Et(Z.length, V), k[O] = !g && (u || E >= 120 && Z.length >= 120) ? new Xr(O && Z) : n;
          }
          Z = a[0];
          var J = -1, se = k[0];
          e:
            for (; ++J < E && Y.length < V; ) {
              var me = Z[J], Se = u ? u(me) : me;
              if (me = g || me !== 0 ? me : 0, !(se ? ki(se, Se) : S(Y, Se, g))) {
                for (O = L; --O; ) {
                  var Fe = k[O];
                  if (!(Fe ? ki(Fe, Se) : S(a[O], Se, g)))
                    continue e;
                }
                se && se.push(Se), Y.push(me);
              }
            }
          return Y;
        }
        function Yw(a, u, g, S) {
          return In(a, function(E, L, O) {
            u(S, g(E), L, O);
          }), S;
        }
        function Gi(a, u, g) {
          u = br(u, a), a = Qh(a, u);
          var S = a == null ? a : a[kn(fn(u))];
          return S == null ? n : Yt(S, a, g);
        }
        function fh(a) {
          return lt(a) && Ot(a) == ue;
        }
        function Zw(a) {
          return lt(a) && Ot(a) == Oi;
        }
        function Xw(a) {
          return lt(a) && Ot(a) == _e;
        }
        function zi(a, u, g, S, E) {
          return a === u ? !0 : a == null || u == null || !lt(a) && !lt(u) ? a !== a && u !== u : jw(a, u, g, S, zi, E);
        }
        function jw(a, u, g, S, E, L) {
          var O = Le(a), k = Le(u), V = O ? ye : Pt(a), Y = k ? ye : Pt(u);
          V = V == ue ? ut : V, Y = Y == ue ? ut : Y;
          var Z = V == ut, J = Y == ut, se = V == Y;
          if (se && wr(a)) {
            if (!wr(u))
              return !1;
            O = !0, Z = !1;
          }
          if (se && !Z)
            return L || (L = new Sn()), O || Wo(a) ? zh(a, u, g, S, E, L) : NS(a, u, V, g, S, E, L);
          if (!(g & y)) {
            var me = Z && je.call(a, "__wrapped__"), Se = J && je.call(u, "__wrapped__");
            if (me || Se) {
              var Fe = me ? a.value() : a, Ne = Se ? u.value() : u;
              return L || (L = new Sn()), E(Fe, Ne, g, S, L);
            }
          }
          return se ? (L || (L = new Sn()), _S(a, u, g, S, E, L)) : !1;
        }
        function Qw(a) {
          return lt(a) && Pt(a) == Ke;
        }
        function Pu(a, u, g, S) {
          var E = g.length, L = E, O = !S;
          if (a == null)
            return !L;
          for (a = Qe(a); E--; ) {
            var k = g[E];
            if (O && k[2] ? k[1] !== a[k[0]] : !(k[0] in a))
              return !1;
          }
          for (; ++E < L; ) {
            k = g[E];
            var V = k[0], Y = a[V], Z = k[1];
            if (O && k[2]) {
              if (Y === n && !(V in a))
                return !1;
            } else {
              var J = new Sn();
              if (S)
                var se = S(Y, Z, V, a, u, J);
              if (!(se === n ? zi(Z, Y, y | h, S, J) : se))
                return !1;
            }
          }
          return !0;
        }
        function ph(a) {
          if (!at(a) || IS(a))
            return !1;
          var u = Xn(a) ? Qy : Hb;
          return u.test(eo(a));
        }
        function Jw(a) {
          return lt(a) && Ot(a) == Li;
        }
        function eS(a) {
          return lt(a) && Pt(a) == yn;
        }
        function tS(a) {
          return lt(a) && xs(a.length) && !!rt[Ot(a)];
        }
        function mh(a) {
          return typeof a == "function" ? a : a == null ? Ut : typeof a == "object" ? Le(a) ? vh(a[0], a[1]) : gh(a) : kg(a);
        }
        function Au(a) {
          if (!Yi(a))
            return ow(a);
          var u = [];
          for (var g in Qe(a))
            je.call(a, g) && g != "constructor" && u.push(g);
          return u;
        }
        function nS(a) {
          if (!at(a))
            return FS(a);
          var u = Yi(a), g = [];
          for (var S in a)
            S == "constructor" && (u || !je.call(a, S)) || g.push(S);
          return g;
        }
        function Tu(a, u) {
          return a < u;
        }
        function hh(a, u) {
          var g = -1, S = Wt(a) ? H(a.length) : [];
          return Cr(a, function(E, L, O) {
            S[++g] = u(E, L, O);
          }), S;
        }
        function gh(a) {
          var u = zu(a);
          return u.length == 1 && u[0][2] ? Xh(u[0][0], u[0][1]) : function(g) {
            return g === a || Pu(g, a, u);
          };
        }
        function vh(a, u) {
          return Ku(a) && Zh(u) ? Xh(kn(a), u) : function(g) {
            var S = rd(g, a);
            return S === n && S === u ? od(g, a) : zi(u, S, y | h);
          };
        }
        function rs(a, u, g, S, E) {
          a !== u && Nu(u, function(L, O) {
            if (E || (E = new Sn()), at(L))
              rS(a, u, O, g, rs, S, E);
            else {
              var k = S ? S(Zu(a, O), L, O + "", a, u, E) : n;
              k === n && (k = L), wu(a, O, k);
            }
          }, Ht);
        }
        function rS(a, u, g, S, E, L, O) {
          var k = Zu(a, g), V = Zu(u, g), Y = O.get(V);
          if (Y) {
            wu(a, g, Y);
            return;
          }
          var Z = L ? L(k, V, g + "", a, u, O) : n, J = Z === n;
          if (J) {
            var se = Le(V), me = !se && wr(V), Se = !se && !me && Wo(V);
            Z = V, se || me || Se ? Le(k) ? Z = k : ft(k) ? Z = Vt(k) : me ? (J = !1, Z = Ah(V, !0)) : Se ? (J = !1, Z = Th(V, !0)) : Z = [] : Xi(V) || to(V) ? (Z = k, to(k) ? Z = Rg(k) : (!at(k) || Xn(k)) && (Z = Yh(V))) : J = !1;
          }
          J && (O.set(V, Z), E(Z, V, S, L, O), O.delete(V)), wu(a, g, Z);
        }
        function Ch(a, u) {
          var g = a.length;
          if (g)
            return u += u < 0 ? g : 0, Zn(u, g) ? a[u] : n;
        }
        function xh(a, u, g) {
          u.length ? u = ot(u, function(L) {
            return Le(L) ? function(O) {
              return Qr(O, L.length === 1 ? L[0] : L);
            } : L;
          }) : u = [Ut];
          var S = -1;
          u = ot(u, Zt(we()));
          var E = hh(a, function(L, O, k) {
            var V = ot(u, function(Y) {
              return Y(L);
            });
            return { criteria: V, index: ++S, value: L };
          });
          return Ty(E, function(L, O) {
            return gS(L, O, g);
          });
        }
        function oS(a, u) {
          return bh(a, u, function(g, S) {
            return od(a, S);
          });
        }
        function bh(a, u, g) {
          for (var S = -1, E = u.length, L = {}; ++S < E; ) {
            var O = u[S], k = Qr(a, O);
            g(k, O) && qi(L, br(O, a), k);
          }
          return L;
        }
        function iS(a) {
          return function(u) {
            return Qr(u, a);
          };
        }
        function $u(a, u, g, S) {
          var E = S ? Ay : To, L = -1, O = u.length, k = a;
          for (a === u && (u = Vt(u)), g && (k = ot(a, Zt(g))); ++L < O; )
            for (var V = 0, Y = u[L], Z = g ? g(Y) : Y; (V = E(k, Z, V, S)) > -1; )
              k !== a && Ka.call(k, V, 1), Ka.call(a, V, 1);
          return a;
        }
        function yh(a, u) {
          for (var g = a ? u.length : 0, S = g - 1; g--; ) {
            var E = u[g];
            if (g == S || E !== L) {
              var L = E;
              Zn(E) ? Ka.call(a, E, 1) : Ou(a, E);
            }
          }
          return a;
        }
        function Lu(a, u) {
          return a + Xa(th() * (u - a + 1));
        }
        function aS(a, u, g, S) {
          for (var E = -1, L = xt(Za((u - a) / (g || 1)), 0), O = H(L); L--; )
            O[S ? L : ++E] = a, a += g;
          return O;
        }
        function Mu(a, u) {
          var g = "";
          if (!a || u < 1 || u > te)
            return g;
          do
            u % 2 && (g += a), u = Xa(u / 2), u && (a += a);
          while (u);
          return g;
        }
        function Ve(a, u) {
          return Xu(jh(a, u, Ut), a + "");
        }
        function sS(a) {
          return oh(Ho(a));
        }
        function lS(a, u) {
          var g = Ho(a);
          return ps(g, jr(u, 0, g.length));
        }
        function qi(a, u, g, S) {
          if (!at(a))
            return a;
          u = br(u, a);
          for (var E = -1, L = u.length, O = L - 1, k = a; k != null && ++E < L; ) {
            var V = kn(u[E]), Y = g;
            if (V === "__proto__" || V === "constructor" || V === "prototype")
              return a;
            if (E != O) {
              var Z = k[V];
              Y = S ? S(Z, V, k) : n, Y === n && (Y = at(Z) ? Z : Zn(u[E + 1]) ? [] : {});
            }
            Hi(k, V, Y), k = k[V];
          }
          return a;
        }
        var wh = ja ? function(a, u) {
          return ja.set(a, u), a;
        } : Ut, cS = Ya ? function(a, u) {
          return Ya(a, "toString", {
            configurable: !0,
            enumerable: !1,
            value: ad(u),
            writable: !0
          });
        } : Ut;
        function uS(a) {
          return ps(Ho(a));
        }
        function dn(a, u, g) {
          var S = -1, E = a.length;
          u < 0 && (u = -u > E ? 0 : E + u), g = g > E ? E : g, g < 0 && (g += E), E = u > g ? 0 : g - u >>> 0, u >>>= 0;
          for (var L = H(E); ++S < E; )
            L[S] = a[S + u];
          return L;
        }
        function dS(a, u) {
          var g;
          return Cr(a, function(S, E, L) {
            return g = u(S, E, L), !g;
          }), !!g;
        }
        function os(a, u, g) {
          var S = 0, E = a == null ? S : a.length;
          if (typeof u == "number" && u === u && E <= pe) {
            for (; S < E; ) {
              var L = S + E >>> 1, O = a[L];
              O !== null && !jt(O) && (g ? O <= u : O < u) ? S = L + 1 : E = L;
            }
            return E;
          }
          return Iu(a, u, Ut, g);
        }
        function Iu(a, u, g, S) {
          var E = 0, L = a == null ? 0 : a.length;
          if (L === 0)
            return 0;
          u = g(u);
          for (var O = u !== u, k = u === null, V = jt(u), Y = u === n; E < L; ) {
            var Z = Xa((E + L) / 2), J = g(a[Z]), se = J !== n, me = J === null, Se = J === J, Fe = jt(J);
            if (O)
              var Ne = S || Se;
            else Y ? Ne = Se && (S || se) : k ? Ne = Se && se && (S || !me) : V ? Ne = Se && se && !me && (S || !Fe) : me || Fe ? Ne = !1 : Ne = S ? J <= u : J < u;
            Ne ? E = Z + 1 : L = Z;
          }
          return Et(L, K);
        }
        function Sh(a, u) {
          for (var g = -1, S = a.length, E = 0, L = []; ++g < S; ) {
            var O = a[g], k = u ? u(O) : O;
            if (!g || !Nn(k, V)) {
              var V = k;
              L[E++] = O === 0 ? 0 : O;
            }
          }
          return L;
        }
        function Nh(a) {
          return typeof a == "number" ? a : jt(a) ? Pe : +a;
        }
        function Xt(a) {
          if (typeof a == "string")
            return a;
          if (Le(a))
            return ot(a, Xt) + "";
          if (jt(a))
            return nh ? nh.call(a) : "";
          var u = a + "";
          return u == "0" && 1 / a == -Q ? "-0" : u;
        }
        function xr(a, u, g) {
          var S = -1, E = Da, L = a.length, O = !0, k = [], V = k;
          if (g)
            O = !1, E = cu;
          else if (L >= o) {
            var Y = u ? null : wS(a);
            if (Y)
              return Ba(Y);
            O = !1, E = ki, V = new Xr();
          } else
            V = u ? [] : k;
          e:
            for (; ++S < L; ) {
              var Z = a[S], J = u ? u(Z) : Z;
              if (Z = g || Z !== 0 ? Z : 0, O && J === J) {
                for (var se = V.length; se--; )
                  if (V[se] === J)
                    continue e;
                u && V.push(J), k.push(Z);
              } else E(V, J, g) || (V !== k && V.push(J), k.push(Z));
            }
          return k;
        }
        function Ou(a, u) {
          return u = br(u, a), a = Qh(a, u), a == null || delete a[kn(fn(u))];
        }
        function _h(a, u, g, S) {
          return qi(a, u, g(Qr(a, u)), S);
        }
        function is(a, u, g, S) {
          for (var E = a.length, L = S ? E : -1; (S ? L-- : ++L < E) && u(a[L], L, a); )
            ;
          return g ? dn(a, S ? 0 : L, S ? L + 1 : E) : dn(a, S ? L + 1 : 0, S ? E : L);
        }
        function Rh(a, u) {
          var g = a;
          return g instanceof He && (g = g.value()), uu(u, function(S, E) {
            return E.func.apply(E.thisArg, hr([S], E.args));
          }, g);
        }
        function ku(a, u, g) {
          var S = a.length;
          if (S < 2)
            return S ? xr(a[0]) : [];
          for (var E = -1, L = H(S); ++E < S; )
            for (var O = a[E], k = -1; ++k < S; )
              k != E && (L[E] = Ui(L[E] || O, a[k], u, g));
          return xr(_t(L, 1), u, g);
        }
        function Eh(a, u, g) {
          for (var S = -1, E = a.length, L = u.length, O = {}; ++S < E; ) {
            var k = S < L ? u[S] : n;
            g(O, a[S], k);
          }
          return O;
        }
        function Du(a) {
          return ft(a) ? a : [];
        }
        function Fu(a) {
          return typeof a == "function" ? a : Ut;
        }
        function br(a, u) {
          return Le(a) ? a : Ku(a, u) ? [a] : ng(Ze(a));
        }
        var fS = Ve;
        function yr(a, u, g) {
          var S = a.length;
          return g = g === n ? S : g, !u && g >= S ? a : dn(a, u, g);
        }
        var Ph = Jy || function(a) {
          return Nt.clearTimeout(a);
        };
        function Ah(a, u) {
          if (u)
            return a.slice();
          var g = a.length, S = Xm ? Xm(g) : new a.constructor(g);
          return a.copy(S), S;
        }
        function Bu(a) {
          var u = new a.constructor(a.byteLength);
          return new za(u).set(new za(a)), u;
        }
        function pS(a, u) {
          var g = u ? Bu(a.buffer) : a.buffer;
          return new a.constructor(g, a.byteOffset, a.byteLength);
        }
        function mS(a) {
          var u = new a.constructor(a.source, fm.exec(a));
          return u.lastIndex = a.lastIndex, u;
        }
        function hS(a) {
          return Wi ? Qe(Wi.call(a)) : {};
        }
        function Th(a, u) {
          var g = u ? Bu(a.buffer) : a.buffer;
          return new a.constructor(g, a.byteOffset, a.length);
        }
        function $h(a, u) {
          if (a !== u) {
            var g = a !== n, S = a === null, E = a === a, L = jt(a), O = u !== n, k = u === null, V = u === u, Y = jt(u);
            if (!k && !Y && !L && a > u || L && O && V && !k && !Y || S && O && V || !g && V || !E)
              return 1;
            if (!S && !L && !Y && a < u || Y && g && E && !S && !L || k && g && E || !O && E || !V)
              return -1;
          }
          return 0;
        }
        function gS(a, u, g) {
          for (var S = -1, E = a.criteria, L = u.criteria, O = E.length, k = g.length; ++S < O; ) {
            var V = $h(E[S], L[S]);
            if (V) {
              if (S >= k)
                return V;
              var Y = g[S];
              return V * (Y == "desc" ? -1 : 1);
            }
          }
          return a.index - u.index;
        }
        function Lh(a, u, g, S) {
          for (var E = -1, L = a.length, O = g.length, k = -1, V = u.length, Y = xt(L - O, 0), Z = H(V + Y), J = !S; ++k < V; )
            Z[k] = u[k];
          for (; ++E < O; )
            (J || E < L) && (Z[g[E]] = a[E]);
          for (; Y--; )
            Z[k++] = a[E++];
          return Z;
        }
        function Mh(a, u, g, S) {
          for (var E = -1, L = a.length, O = -1, k = g.length, V = -1, Y = u.length, Z = xt(L - k, 0), J = H(Z + Y), se = !S; ++E < Z; )
            J[E] = a[E];
          for (var me = E; ++V < Y; )
            J[me + V] = u[V];
          for (; ++O < k; )
            (se || E < L) && (J[me + g[O]] = a[E++]);
          return J;
        }
        function Vt(a, u) {
          var g = -1, S = a.length;
          for (u || (u = H(S)); ++g < S; )
            u[g] = a[g];
          return u;
        }
        function On(a, u, g, S) {
          var E = !g;
          g || (g = {});
          for (var L = -1, O = u.length; ++L < O; ) {
            var k = u[L], V = S ? S(g[k], a[k], k, g, a) : n;
            V === n && (V = a[k]), E ? qn(g, k, V) : Hi(g, k, V);
          }
          return g;
        }
        function vS(a, u) {
          return On(a, qu(a), u);
        }
        function CS(a, u) {
          return On(a, qh(a), u);
        }
        function as(a, u) {
          return function(g, S) {
            var E = Le(g) ? Sy : Vw, L = u ? u() : {};
            return E(g, a, we(S, 2), L);
          };
        }
        function Fo(a) {
          return Ve(function(u, g) {
            var S = -1, E = g.length, L = E > 1 ? g[E - 1] : n, O = E > 2 ? g[2] : n;
            for (L = a.length > 3 && typeof L == "function" ? (E--, L) : n, O && kt(g[0], g[1], O) && (L = E < 3 ? n : L, E = 1), u = Qe(u); ++S < E; ) {
              var k = g[S];
              k && a(u, k, S, L);
            }
            return u;
          });
        }
        function Ih(a, u) {
          return function(g, S) {
            if (g == null)
              return g;
            if (!Wt(g))
              return a(g, S);
            for (var E = g.length, L = u ? E : -1, O = Qe(g); (u ? L-- : ++L < E) && S(O[L], L, O) !== !1; )
              ;
            return g;
          };
        }
        function Oh(a) {
          return function(u, g, S) {
            for (var E = -1, L = Qe(u), O = S(u), k = O.length; k--; ) {
              var V = O[a ? k : ++E];
              if (g(L[V], V, L) === !1)
                break;
            }
            return u;
          };
        }
        function xS(a, u, g) {
          var S = u & b, E = Ki(a);
          function L() {
            var O = this && this !== Nt && this instanceof L ? E : a;
            return O.apply(S ? g : this, arguments);
          }
          return L;
        }
        function kh(a) {
          return function(u) {
            u = Ze(u);
            var g = $o(u) ? wn(u) : n, S = g ? g[0] : u.charAt(0), E = g ? yr(g, 1).join("") : u.slice(1);
            return S[a]() + E;
          };
        }
        function Bo(a) {
          return function(u) {
            return uu(Ig(Mg(u).replace(cy, "")), a, "");
          };
        }
        function Ki(a) {
          return function() {
            var u = arguments;
            switch (u.length) {
              case 0:
                return new a();
              case 1:
                return new a(u[0]);
              case 2:
                return new a(u[0], u[1]);
              case 3:
                return new a(u[0], u[1], u[2]);
              case 4:
                return new a(u[0], u[1], u[2], u[3]);
              case 5:
                return new a(u[0], u[1], u[2], u[3], u[4]);
              case 6:
                return new a(u[0], u[1], u[2], u[3], u[4], u[5]);
              case 7:
                return new a(u[0], u[1], u[2], u[3], u[4], u[5], u[6]);
            }
            var g = Do(a.prototype), S = a.apply(g, u);
            return at(S) ? S : g;
          };
        }
        function bS(a, u, g) {
          var S = Ki(a);
          function E() {
            for (var L = arguments.length, O = H(L), k = L, V = Vo(E); k--; )
              O[k] = arguments[k];
            var Y = L < 3 && O[0] !== V && O[L - 1] !== V ? [] : gr(O, V);
            if (L -= Y.length, L < g)
              return Wh(
                a,
                u,
                ss,
                E.placeholder,
                n,
                O,
                Y,
                n,
                n,
                g - L
              );
            var Z = this && this !== Nt && this instanceof E ? S : a;
            return Yt(Z, this, O);
          }
          return E;
        }
        function Dh(a) {
          return function(u, g, S) {
            var E = Qe(u);
            if (!Wt(u)) {
              var L = we(g, 3);
              u = yt(u), g = function(k) {
                return L(E[k], k, E);
              };
            }
            var O = a(u, g, S);
            return O > -1 ? E[L ? u[O] : O] : n;
          };
        }
        function Fh(a) {
          return Yn(function(u) {
            var g = u.length, S = g, E = cn.prototype.thru;
            for (a && u.reverse(); S--; ) {
              var L = u[S];
              if (typeof L != "function")
                throw new ln(l);
              if (E && !O && ds(L) == "wrapper")
                var O = new cn([], !0);
            }
            for (S = O ? S : g; ++S < g; ) {
              L = u[S];
              var k = ds(L), V = k == "wrapper" ? Gu(L) : n;
              V && Yu(V[0]) && V[1] == (T | _ | A | M) && !V[4].length && V[9] == 1 ? O = O[ds(V[0])].apply(O, V[3]) : O = L.length == 1 && Yu(L) ? O[k]() : O.thru(L);
            }
            return function() {
              var Y = arguments, Z = Y[0];
              if (O && Y.length == 1 && Le(Z))
                return O.plant(Z).value();
              for (var J = 0, se = g ? u[J].apply(this, Y) : Z; ++J < g; )
                se = u[J].call(this, se);
              return se;
            };
          });
        }
        function ss(a, u, g, S, E, L, O, k, V, Y) {
          var Z = u & T, J = u & b, se = u & w, me = u & (_ | P), Se = u & D, Fe = se ? n : Ki(a);
          function Ne() {
            for (var We = arguments.length, Ue = H(We), Qt = We; Qt--; )
              Ue[Qt] = arguments[Qt];
            if (me)
              var Dt = Vo(Ne), Jt = Ly(Ue, Dt);
            if (S && (Ue = Lh(Ue, S, E, me)), L && (Ue = Mh(Ue, L, O, me)), We -= Jt, me && We < Y) {
              var pt = gr(Ue, Dt);
              return Wh(
                a,
                u,
                ss,
                Ne.placeholder,
                g,
                Ue,
                pt,
                k,
                V,
                Y - We
              );
            }
            var _n = J ? g : this, Qn = se ? _n[a] : a;
            return We = Ue.length, k ? Ue = VS(Ue, k) : Se && We > 1 && Ue.reverse(), Z && V < We && (Ue.length = V), this && this !== Nt && this instanceof Ne && (Qn = Fe || Ki(Qn)), Qn.apply(_n, Ue);
          }
          return Ne;
        }
        function Bh(a, u) {
          return function(g, S) {
            return Yw(g, a, u(S), {});
          };
        }
        function ls(a, u) {
          return function(g, S) {
            var E;
            if (g === n && S === n)
              return u;
            if (g !== n && (E = g), S !== n) {
              if (E === n)
                return S;
              typeof g == "string" || typeof S == "string" ? (g = Xt(g), S = Xt(S)) : (g = Nh(g), S = Nh(S)), E = a(g, S);
            }
            return E;
          };
        }
        function Vu(a) {
          return Yn(function(u) {
            return u = ot(u, Zt(we())), Ve(function(g) {
              var S = this;
              return a(u, function(E) {
                return Yt(E, S, g);
              });
            });
          });
        }
        function cs(a, u) {
          u = u === n ? " " : Xt(u);
          var g = u.length;
          if (g < 2)
            return g ? Mu(u, a) : u;
          var S = Mu(u, Za(a / Lo(u)));
          return $o(u) ? yr(wn(S), 0, a).join("") : S.slice(0, a);
        }
        function yS(a, u, g, S) {
          var E = u & b, L = Ki(a);
          function O() {
            for (var k = -1, V = arguments.length, Y = -1, Z = S.length, J = H(Z + V), se = this && this !== Nt && this instanceof O ? L : a; ++Y < Z; )
              J[Y] = S[Y];
            for (; V--; )
              J[Y++] = arguments[++k];
            return Yt(se, E ? g : this, J);
          }
          return O;
        }
        function Vh(a) {
          return function(u, g, S) {
            return S && typeof S != "number" && kt(u, g, S) && (g = S = n), u = jn(u), g === n ? (g = u, u = 0) : g = jn(g), S = S === n ? u < g ? 1 : -1 : jn(S), aS(u, g, S, a);
          };
        }
        function us(a) {
          return function(u, g) {
            return typeof u == "string" && typeof g == "string" || (u = pn(u), g = pn(g)), a(u, g);
          };
        }
        function Wh(a, u, g, S, E, L, O, k, V, Y) {
          var Z = u & _, J = Z ? O : n, se = Z ? n : O, me = Z ? L : n, Se = Z ? n : L;
          u |= Z ? A : I, u &= ~(Z ? I : A), u & N || (u &= ~(b | w));
          var Fe = [
            a,
            u,
            E,
            me,
            J,
            Se,
            se,
            k,
            V,
            Y
          ], Ne = g.apply(n, Fe);
          return Yu(a) && Jh(Ne, Fe), Ne.placeholder = S, eg(Ne, a, u);
        }
        function Wu(a) {
          var u = Ct[a];
          return function(g, S) {
            if (g = pn(g), S = S == null ? 0 : Et(De(S), 292), S && eh(g)) {
              var E = (Ze(g) + "e").split("e"), L = u(E[0] + "e" + (+E[1] + S));
              return E = (Ze(L) + "e").split("e"), +(E[0] + "e" + (+E[1] - S));
            }
            return u(g);
          };
        }
        var wS = Oo && 1 / Ba(new Oo([, -0]))[1] == Q ? function(a) {
          return new Oo(a);
        } : cd;
        function Hh(a) {
          return function(u) {
            var g = Pt(u);
            return g == Ke ? vu(u) : g == yn ? By(u) : $y(u, a(u));
          };
        }
        function Kn(a, u, g, S, E, L, O, k) {
          var V = u & w;
          if (!V && typeof a != "function")
            throw new ln(l);
          var Y = S ? S.length : 0;
          if (Y || (u &= ~(A | I), S = E = n), O = O === n ? O : xt(De(O), 0), k = k === n ? k : De(k), Y -= E ? E.length : 0, u & I) {
            var Z = S, J = E;
            S = E = n;
          }
          var se = V ? n : Gu(a), me = [
            a,
            u,
            g,
            S,
            E,
            Z,
            J,
            L,
            O,
            k
          ];
          if (se && DS(me, se), a = me[0], u = me[1], g = me[2], S = me[3], E = me[4], k = me[9] = me[9] === n ? V ? 0 : a.length : xt(me[9] - Y, 0), !k && u & (_ | P) && (u &= ~(_ | P)), !u || u == b)
            var Se = xS(a, u, g);
          else u == _ || u == P ? Se = bS(a, u, k) : (u == A || u == (b | A)) && !E.length ? Se = yS(a, u, g, S) : Se = ss.apply(n, me);
          var Fe = se ? wh : Jh;
          return eg(Fe(Se, me), a, u);
        }
        function Uh(a, u, g, S) {
          return a === n || Nn(a, Io[g]) && !je.call(S, g) ? u : a;
        }
        function Gh(a, u, g, S, E, L) {
          return at(a) && at(u) && (L.set(u, a), rs(a, u, n, Gh, L), L.delete(u)), a;
        }
        function SS(a) {
          return Xi(a) ? n : a;
        }
        function zh(a, u, g, S, E, L) {
          var O = g & y, k = a.length, V = u.length;
          if (k != V && !(O && V > k))
            return !1;
          var Y = L.get(a), Z = L.get(u);
          if (Y && Z)
            return Y == u && Z == a;
          var J = -1, se = !0, me = g & h ? new Xr() : n;
          for (L.set(a, u), L.set(u, a); ++J < k; ) {
            var Se = a[J], Fe = u[J];
            if (S)
              var Ne = O ? S(Fe, Se, J, u, a, L) : S(Se, Fe, J, a, u, L);
            if (Ne !== n) {
              if (Ne)
                continue;
              se = !1;
              break;
            }
            if (me) {
              if (!du(u, function(We, Ue) {
                if (!ki(me, Ue) && (Se === We || E(Se, We, g, S, L)))
                  return me.push(Ue);
              })) {
                se = !1;
                break;
              }
            } else if (!(Se === Fe || E(Se, Fe, g, S, L))) {
              se = !1;
              break;
            }
          }
          return L.delete(a), L.delete(u), se;
        }
        function NS(a, u, g, S, E, L, O) {
          switch (g) {
            case Po:
              if (a.byteLength != u.byteLength || a.byteOffset != u.byteOffset)
                return !1;
              a = a.buffer, u = u.buffer;
            case Oi:
              return !(a.byteLength != u.byteLength || !L(new za(a), new za(u)));
            case Ce:
            case _e:
            case St:
              return Nn(+a, +u);
            case Me:
              return a.name == u.name && a.message == u.message;
            case Li:
            case Mi:
              return a == u + "";
            case Ke:
              var k = vu;
            case yn:
              var V = S & y;
              if (k || (k = Ba), a.size != u.size && !V)
                return !1;
              var Y = O.get(a);
              if (Y)
                return Y == u;
              S |= h, O.set(a, u);
              var Z = zh(k(a), k(u), S, E, L, O);
              return O.delete(a), Z;
            case Ma:
              if (Wi)
                return Wi.call(a) == Wi.call(u);
          }
          return !1;
        }
        function _S(a, u, g, S, E, L) {
          var O = g & y, k = Hu(a), V = k.length, Y = Hu(u), Z = Y.length;
          if (V != Z && !O)
            return !1;
          for (var J = V; J--; ) {
            var se = k[J];
            if (!(O ? se in u : je.call(u, se)))
              return !1;
          }
          var me = L.get(a), Se = L.get(u);
          if (me && Se)
            return me == u && Se == a;
          var Fe = !0;
          L.set(a, u), L.set(u, a);
          for (var Ne = O; ++J < V; ) {
            se = k[J];
            var We = a[se], Ue = u[se];
            if (S)
              var Qt = O ? S(Ue, We, se, u, a, L) : S(We, Ue, se, a, u, L);
            if (!(Qt === n ? We === Ue || E(We, Ue, g, S, L) : Qt)) {
              Fe = !1;
              break;
            }
            Ne || (Ne = se == "constructor");
          }
          if (Fe && !Ne) {
            var Dt = a.constructor, Jt = u.constructor;
            Dt != Jt && "constructor" in a && "constructor" in u && !(typeof Dt == "function" && Dt instanceof Dt && typeof Jt == "function" && Jt instanceof Jt) && (Fe = !1);
          }
          return L.delete(a), L.delete(u), Fe;
        }
        function Yn(a) {
          return Xu(jh(a, n, ag), a + "");
        }
        function Hu(a) {
          return dh(a, yt, qu);
        }
        function Uu(a) {
          return dh(a, Ht, qh);
        }
        var Gu = ja ? function(a) {
          return ja.get(a);
        } : cd;
        function ds(a) {
          for (var u = a.name + "", g = ko[u], S = je.call(ko, u) ? g.length : 0; S--; ) {
            var E = g[S], L = E.func;
            if (L == null || L == a)
              return E.name;
          }
          return u;
        }
        function Vo(a) {
          var u = je.call($, "placeholder") ? $ : a;
          return u.placeholder;
        }
        function we() {
          var a = $.iteratee || sd;
          return a = a === sd ? mh : a, arguments.length ? a(arguments[0], arguments[1]) : a;
        }
        function fs(a, u) {
          var g = a.__data__;
          return MS(u) ? g[typeof u == "string" ? "string" : "hash"] : g.map;
        }
        function zu(a) {
          for (var u = yt(a), g = u.length; g--; ) {
            var S = u[g], E = a[S];
            u[g] = [S, E, Zh(E)];
          }
          return u;
        }
        function Jr(a, u) {
          var g = ky(a, u);
          return ph(g) ? g : n;
        }
        function RS(a) {
          var u = je.call(a, Yr), g = a[Yr];
          try {
            a[Yr] = n;
            var S = !0;
          } catch {
          }
          var E = Ua.call(a);
          return S && (u ? a[Yr] = g : delete a[Yr]), E;
        }
        var qu = xu ? function(a) {
          return a == null ? [] : (a = Qe(a), mr(xu(a), function(u) {
            return Qm.call(a, u);
          }));
        } : ud, qh = xu ? function(a) {
          for (var u = []; a; )
            hr(u, qu(a)), a = qa(a);
          return u;
        } : ud, Pt = Ot;
        (bu && Pt(new bu(new ArrayBuffer(1))) != Po || Fi && Pt(new Fi()) != Ke || yu && Pt(yu.resolve()) != Mn || Oo && Pt(new Oo()) != yn || Bi && Pt(new Bi()) != Ii) && (Pt = function(a) {
          var u = Ot(a), g = u == ut ? a.constructor : n, S = g ? eo(g) : "";
          if (S)
            switch (S) {
              case lw:
                return Po;
              case cw:
                return Ke;
              case uw:
                return Mn;
              case dw:
                return yn;
              case fw:
                return Ii;
            }
          return u;
        });
        function ES(a, u, g) {
          for (var S = -1, E = g.length; ++S < E; ) {
            var L = g[S], O = L.size;
            switch (L.type) {
              case "drop":
                a += O;
                break;
              case "dropRight":
                u -= O;
                break;
              case "take":
                u = Et(u, a + O);
                break;
              case "takeRight":
                a = xt(a, u - O);
                break;
            }
          }
          return { start: a, end: u };
        }
        function PS(a) {
          var u = a.match(Ib);
          return u ? u[1].split(Ob) : [];
        }
        function Kh(a, u, g) {
          u = br(u, a);
          for (var S = -1, E = u.length, L = !1; ++S < E; ) {
            var O = kn(u[S]);
            if (!(L = a != null && g(a, O)))
              break;
            a = a[O];
          }
          return L || ++S != E ? L : (E = a == null ? 0 : a.length, !!E && xs(E) && Zn(O, E) && (Le(a) || to(a)));
        }
        function AS(a) {
          var u = a.length, g = new a.constructor(u);
          return u && typeof a[0] == "string" && je.call(a, "index") && (g.index = a.index, g.input = a.input), g;
        }
        function Yh(a) {
          return typeof a.constructor == "function" && !Yi(a) ? Do(qa(a)) : {};
        }
        function TS(a, u, g) {
          var S = a.constructor;
          switch (u) {
            case Oi:
              return Bu(a);
            case Ce:
            case _e:
              return new S(+a);
            case Po:
              return pS(a, g);
            case zc:
            case qc:
            case Kc:
            case Yc:
            case Zc:
            case Xc:
            case jc:
            case Qc:
            case Jc:
              return Th(a, g);
            case Ke:
              return new S();
            case St:
            case Mi:
              return new S(a);
            case Li:
              return mS(a);
            case yn:
              return new S();
            case Ma:
              return hS(a);
          }
        }
        function $S(a, u) {
          var g = u.length;
          if (!g)
            return a;
          var S = g - 1;
          return u[S] = (g > 1 ? "& " : "") + u[S], u = u.join(g > 2 ? ", " : " "), a.replace(Mb, `{
/* [wrapped with ` + u + `] */
`);
        }
        function LS(a) {
          return Le(a) || to(a) || !!(Jm && a && a[Jm]);
        }
        function Zn(a, u) {
          var g = typeof a;
          return u = u ?? te, !!u && (g == "number" || g != "symbol" && Gb.test(a)) && a > -1 && a % 1 == 0 && a < u;
        }
        function kt(a, u, g) {
          if (!at(g))
            return !1;
          var S = typeof u;
          return (S == "number" ? Wt(g) && Zn(u, g.length) : S == "string" && u in g) ? Nn(g[u], a) : !1;
        }
        function Ku(a, u) {
          if (Le(a))
            return !1;
          var g = typeof a;
          return g == "number" || g == "symbol" || g == "boolean" || a == null || jt(a) ? !0 : Ab.test(a) || !Pb.test(a) || u != null && a in Qe(u);
        }
        function MS(a) {
          var u = typeof a;
          return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? a !== "__proto__" : a === null;
        }
        function Yu(a) {
          var u = ds(a), g = $[u];
          if (typeof g != "function" || !(u in He.prototype))
            return !1;
          if (a === g)
            return !0;
          var S = Gu(g);
          return !!S && a === S[0];
        }
        function IS(a) {
          return !!Zm && Zm in a;
        }
        var OS = Wa ? Xn : dd;
        function Yi(a) {
          var u = a && a.constructor, g = typeof u == "function" && u.prototype || Io;
          return a === g;
        }
        function Zh(a) {
          return a === a && !at(a);
        }
        function Xh(a, u) {
          return function(g) {
            return g == null ? !1 : g[a] === u && (u !== n || a in Qe(g));
          };
        }
        function kS(a) {
          var u = vs(a, function(S) {
            return g.size === p && g.clear(), S;
          }), g = u.cache;
          return u;
        }
        function DS(a, u) {
          var g = a[1], S = u[1], E = g | S, L = E < (b | w | T), O = S == T && g == _ || S == T && g == M && a[7].length <= u[8] || S == (T | M) && u[7].length <= u[8] && g == _;
          if (!(L || O))
            return a;
          S & b && (a[2] = u[2], E |= g & b ? 0 : N);
          var k = u[3];
          if (k) {
            var V = a[3];
            a[3] = V ? Lh(V, k, u[4]) : k, a[4] = V ? gr(a[3], m) : u[4];
          }
          return k = u[5], k && (V = a[5], a[5] = V ? Mh(V, k, u[6]) : k, a[6] = V ? gr(a[5], m) : u[6]), k = u[7], k && (a[7] = k), S & T && (a[8] = a[8] == null ? u[8] : Et(a[8], u[8])), a[9] == null && (a[9] = u[9]), a[0] = u[0], a[1] = E, a;
        }
        function FS(a) {
          var u = [];
          if (a != null)
            for (var g in Qe(a))
              u.push(g);
          return u;
        }
        function BS(a) {
          return Ua.call(a);
        }
        function jh(a, u, g) {
          return u = xt(u === n ? a.length - 1 : u, 0), function() {
            for (var S = arguments, E = -1, L = xt(S.length - u, 0), O = H(L); ++E < L; )
              O[E] = S[u + E];
            E = -1;
            for (var k = H(u + 1); ++E < u; )
              k[E] = S[E];
            return k[u] = g(O), Yt(a, this, k);
          };
        }
        function Qh(a, u) {
          return u.length < 2 ? a : Qr(a, dn(u, 0, -1));
        }
        function VS(a, u) {
          for (var g = a.length, S = Et(u.length, g), E = Vt(a); S--; ) {
            var L = u[S];
            a[S] = Zn(L, g) ? E[L] : n;
          }
          return a;
        }
        function Zu(a, u) {
          if (!(u === "constructor" && typeof a[u] == "function") && u != "__proto__")
            return a[u];
        }
        var Jh = tg(wh), Zi = tw || function(a, u) {
          return Nt.setTimeout(a, u);
        }, Xu = tg(cS);
        function eg(a, u, g) {
          var S = u + "";
          return Xu(a, $S(S, WS(PS(S), g)));
        }
        function tg(a) {
          var u = 0, g = 0;
          return function() {
            var S = iw(), E = j - (S - g);
            if (g = S, E > 0) {
              if (++u >= re)
                return arguments[0];
            } else
              u = 0;
            return a.apply(n, arguments);
          };
        }
        function ps(a, u) {
          var g = -1, S = a.length, E = S - 1;
          for (u = u === n ? S : u; ++g < u; ) {
            var L = Lu(g, E), O = a[L];
            a[L] = a[g], a[g] = O;
          }
          return a.length = u, a;
        }
        var ng = kS(function(a) {
          var u = [];
          return a.charCodeAt(0) === 46 && u.push(""), a.replace(Tb, function(g, S, E, L) {
            u.push(E ? L.replace(Fb, "$1") : S || g);
          }), u;
        });
        function kn(a) {
          if (typeof a == "string" || jt(a))
            return a;
          var u = a + "";
          return u == "0" && 1 / a == -Q ? "-0" : u;
        }
        function eo(a) {
          if (a != null) {
            try {
              return Ha.call(a);
            } catch {
            }
            try {
              return a + "";
            } catch {
            }
          }
          return "";
        }
        function WS(a, u) {
          return sn(ge, function(g) {
            var S = "_." + g[0];
            u & g[1] && !Da(a, S) && a.push(S);
          }), a.sort();
        }
        function rg(a) {
          if (a instanceof He)
            return a.clone();
          var u = new cn(a.__wrapped__, a.__chain__);
          return u.__actions__ = Vt(a.__actions__), u.__index__ = a.__index__, u.__values__ = a.__values__, u;
        }
        function HS(a, u, g) {
          (g ? kt(a, u, g) : u === n) ? u = 1 : u = xt(De(u), 0);
          var S = a == null ? 0 : a.length;
          if (!S || u < 1)
            return [];
          for (var E = 0, L = 0, O = H(Za(S / u)); E < S; )
            O[L++] = dn(a, E, E += u);
          return O;
        }
        function US(a) {
          for (var u = -1, g = a == null ? 0 : a.length, S = 0, E = []; ++u < g; ) {
            var L = a[u];
            L && (E[S++] = L);
          }
          return E;
        }
        function GS() {
          var a = arguments.length;
          if (!a)
            return [];
          for (var u = H(a - 1), g = arguments[0], S = a; S--; )
            u[S - 1] = arguments[S];
          return hr(Le(g) ? Vt(g) : [g], _t(u, 1));
        }
        var zS = Ve(function(a, u) {
          return ft(a) ? Ui(a, _t(u, 1, ft, !0)) : [];
        }), qS = Ve(function(a, u) {
          var g = fn(u);
          return ft(g) && (g = n), ft(a) ? Ui(a, _t(u, 1, ft, !0), we(g, 2)) : [];
        }), KS = Ve(function(a, u) {
          var g = fn(u);
          return ft(g) && (g = n), ft(a) ? Ui(a, _t(u, 1, ft, !0), n, g) : [];
        });
        function YS(a, u, g) {
          var S = a == null ? 0 : a.length;
          return S ? (u = g || u === n ? 1 : De(u), dn(a, u < 0 ? 0 : u, S)) : [];
        }
        function ZS(a, u, g) {
          var S = a == null ? 0 : a.length;
          return S ? (u = g || u === n ? 1 : De(u), u = S - u, dn(a, 0, u < 0 ? 0 : u)) : [];
        }
        function XS(a, u) {
          return a && a.length ? is(a, we(u, 3), !0, !0) : [];
        }
        function jS(a, u) {
          return a && a.length ? is(a, we(u, 3), !0) : [];
        }
        function QS(a, u, g, S) {
          var E = a == null ? 0 : a.length;
          return E ? (g && typeof g != "number" && kt(a, u, g) && (g = 0, S = E), Gw(a, u, g, S)) : [];
        }
        function og(a, u, g) {
          var S = a == null ? 0 : a.length;
          if (!S)
            return -1;
          var E = g == null ? 0 : De(g);
          return E < 0 && (E = xt(S + E, 0)), Fa(a, we(u, 3), E);
        }
        function ig(a, u, g) {
          var S = a == null ? 0 : a.length;
          if (!S)
            return -1;
          var E = S - 1;
          return g !== n && (E = De(g), E = g < 0 ? xt(S + E, 0) : Et(E, S - 1)), Fa(a, we(u, 3), E, !0);
        }
        function ag(a) {
          var u = a == null ? 0 : a.length;
          return u ? _t(a, 1) : [];
        }
        function JS(a) {
          var u = a == null ? 0 : a.length;
          return u ? _t(a, Q) : [];
        }
        function eN(a, u) {
          var g = a == null ? 0 : a.length;
          return g ? (u = u === n ? 1 : De(u), _t(a, u)) : [];
        }
        function tN(a) {
          for (var u = -1, g = a == null ? 0 : a.length, S = {}; ++u < g; ) {
            var E = a[u];
            S[E[0]] = E[1];
          }
          return S;
        }
        function sg(a) {
          return a && a.length ? a[0] : n;
        }
        function nN(a, u, g) {
          var S = a == null ? 0 : a.length;
          if (!S)
            return -1;
          var E = g == null ? 0 : De(g);
          return E < 0 && (E = xt(S + E, 0)), To(a, u, E);
        }
        function rN(a) {
          var u = a == null ? 0 : a.length;
          return u ? dn(a, 0, -1) : [];
        }
        var oN = Ve(function(a) {
          var u = ot(a, Du);
          return u.length && u[0] === a[0] ? Eu(u) : [];
        }), iN = Ve(function(a) {
          var u = fn(a), g = ot(a, Du);
          return u === fn(g) ? u = n : g.pop(), g.length && g[0] === a[0] ? Eu(g, we(u, 2)) : [];
        }), aN = Ve(function(a) {
          var u = fn(a), g = ot(a, Du);
          return u = typeof u == "function" ? u : n, u && g.pop(), g.length && g[0] === a[0] ? Eu(g, n, u) : [];
        });
        function sN(a, u) {
          return a == null ? "" : rw.call(a, u);
        }
        function fn(a) {
          var u = a == null ? 0 : a.length;
          return u ? a[u - 1] : n;
        }
        function lN(a, u, g) {
          var S = a == null ? 0 : a.length;
          if (!S)
            return -1;
          var E = S;
          return g !== n && (E = De(g), E = E < 0 ? xt(S + E, 0) : Et(E, S - 1)), u === u ? Wy(a, u, E) : Fa(a, Wm, E, !0);
        }
        function cN(a, u) {
          return a && a.length ? Ch(a, De(u)) : n;
        }
        var uN = Ve(lg);
        function lg(a, u) {
          return a && a.length && u && u.length ? $u(a, u) : a;
        }
        function dN(a, u, g) {
          return a && a.length && u && u.length ? $u(a, u, we(g, 2)) : a;
        }
        function fN(a, u, g) {
          return a && a.length && u && u.length ? $u(a, u, n, g) : a;
        }
        var pN = Yn(function(a, u) {
          var g = a == null ? 0 : a.length, S = Su(a, u);
          return yh(a, ot(u, function(E) {
            return Zn(E, g) ? +E : E;
          }).sort($h)), S;
        });
        function mN(a, u) {
          var g = [];
          if (!(a && a.length))
            return g;
          var S = -1, E = [], L = a.length;
          for (u = we(u, 3); ++S < L; ) {
            var O = a[S];
            u(O, S, a) && (g.push(O), E.push(S));
          }
          return yh(a, E), g;
        }
        function ju(a) {
          return a == null ? a : sw.call(a);
        }
        function hN(a, u, g) {
          var S = a == null ? 0 : a.length;
          return S ? (g && typeof g != "number" && kt(a, u, g) ? (u = 0, g = S) : (u = u == null ? 0 : De(u), g = g === n ? S : De(g)), dn(a, u, g)) : [];
        }
        function gN(a, u) {
          return os(a, u);
        }
        function vN(a, u, g) {
          return Iu(a, u, we(g, 2));
        }
        function CN(a, u) {
          var g = a == null ? 0 : a.length;
          if (g) {
            var S = os(a, u);
            if (S < g && Nn(a[S], u))
              return S;
          }
          return -1;
        }
        function xN(a, u) {
          return os(a, u, !0);
        }
        function bN(a, u, g) {
          return Iu(a, u, we(g, 2), !0);
        }
        function yN(a, u) {
          var g = a == null ? 0 : a.length;
          if (g) {
            var S = os(a, u, !0) - 1;
            if (Nn(a[S], u))
              return S;
          }
          return -1;
        }
        function wN(a) {
          return a && a.length ? Sh(a) : [];
        }
        function SN(a, u) {
          return a && a.length ? Sh(a, we(u, 2)) : [];
        }
        function NN(a) {
          var u = a == null ? 0 : a.length;
          return u ? dn(a, 1, u) : [];
        }
        function _N(a, u, g) {
          return a && a.length ? (u = g || u === n ? 1 : De(u), dn(a, 0, u < 0 ? 0 : u)) : [];
        }
        function RN(a, u, g) {
          var S = a == null ? 0 : a.length;
          return S ? (u = g || u === n ? 1 : De(u), u = S - u, dn(a, u < 0 ? 0 : u, S)) : [];
        }
        function EN(a, u) {
          return a && a.length ? is(a, we(u, 3), !1, !0) : [];
        }
        function PN(a, u) {
          return a && a.length ? is(a, we(u, 3)) : [];
        }
        var AN = Ve(function(a) {
          return xr(_t(a, 1, ft, !0));
        }), TN = Ve(function(a) {
          var u = fn(a);
          return ft(u) && (u = n), xr(_t(a, 1, ft, !0), we(u, 2));
        }), $N = Ve(function(a) {
          var u = fn(a);
          return u = typeof u == "function" ? u : n, xr(_t(a, 1, ft, !0), n, u);
        });
        function LN(a) {
          return a && a.length ? xr(a) : [];
        }
        function MN(a, u) {
          return a && a.length ? xr(a, we(u, 2)) : [];
        }
        function IN(a, u) {
          return u = typeof u == "function" ? u : n, a && a.length ? xr(a, n, u) : [];
        }
        function Qu(a) {
          if (!(a && a.length))
            return [];
          var u = 0;
          return a = mr(a, function(g) {
            if (ft(g))
              return u = xt(g.length, u), !0;
          }), hu(u, function(g) {
            return ot(a, fu(g));
          });
        }
        function cg(a, u) {
          if (!(a && a.length))
            return [];
          var g = Qu(a);
          return u == null ? g : ot(g, function(S) {
            return Yt(u, n, S);
          });
        }
        var ON = Ve(function(a, u) {
          return ft(a) ? Ui(a, u) : [];
        }), kN = Ve(function(a) {
          return ku(mr(a, ft));
        }), DN = Ve(function(a) {
          var u = fn(a);
          return ft(u) && (u = n), ku(mr(a, ft), we(u, 2));
        }), FN = Ve(function(a) {
          var u = fn(a);
          return u = typeof u == "function" ? u : n, ku(mr(a, ft), n, u);
        }), BN = Ve(Qu);
        function VN(a, u) {
          return Eh(a || [], u || [], Hi);
        }
        function WN(a, u) {
          return Eh(a || [], u || [], qi);
        }
        var HN = Ve(function(a) {
          var u = a.length, g = u > 1 ? a[u - 1] : n;
          return g = typeof g == "function" ? (a.pop(), g) : n, cg(a, g);
        });
        function ug(a) {
          var u = $(a);
          return u.__chain__ = !0, u;
        }
        function UN(a, u) {
          return u(a), a;
        }
        function ms(a, u) {
          return u(a);
        }
        var GN = Yn(function(a) {
          var u = a.length, g = u ? a[0] : 0, S = this.__wrapped__, E = function(L) {
            return Su(L, a);
          };
          return u > 1 || this.__actions__.length || !(S instanceof He) || !Zn(g) ? this.thru(E) : (S = S.slice(g, +g + (u ? 1 : 0)), S.__actions__.push({
            func: ms,
            args: [E],
            thisArg: n
          }), new cn(S, this.__chain__).thru(function(L) {
            return u && !L.length && L.push(n), L;
          }));
        });
        function zN() {
          return ug(this);
        }
        function qN() {
          return new cn(this.value(), this.__chain__);
        }
        function KN() {
          this.__values__ === n && (this.__values__ = Ng(this.value()));
          var a = this.__index__ >= this.__values__.length, u = a ? n : this.__values__[this.__index__++];
          return { done: a, value: u };
        }
        function YN() {
          return this;
        }
        function ZN(a) {
          for (var u, g = this; g instanceof Ja; ) {
            var S = rg(g);
            S.__index__ = 0, S.__values__ = n, u ? E.__wrapped__ = S : u = S;
            var E = S;
            g = g.__wrapped__;
          }
          return E.__wrapped__ = a, u;
        }
        function XN() {
          var a = this.__wrapped__;
          if (a instanceof He) {
            var u = a;
            return this.__actions__.length && (u = new He(this)), u = u.reverse(), u.__actions__.push({
              func: ms,
              args: [ju],
              thisArg: n
            }), new cn(u, this.__chain__);
          }
          return this.thru(ju);
        }
        function jN() {
          return Rh(this.__wrapped__, this.__actions__);
        }
        var QN = as(function(a, u, g) {
          je.call(a, g) ? ++a[g] : qn(a, g, 1);
        });
        function JN(a, u, g) {
          var S = Le(a) ? Bm : Uw;
          return g && kt(a, u, g) && (u = n), S(a, we(u, 3));
        }
        function e_(a, u) {
          var g = Le(a) ? mr : ch;
          return g(a, we(u, 3));
        }
        var t_ = Dh(og), n_ = Dh(ig);
        function r_(a, u) {
          return _t(hs(a, u), 1);
        }
        function o_(a, u) {
          return _t(hs(a, u), Q);
        }
        function i_(a, u, g) {
          return g = g === n ? 1 : De(g), _t(hs(a, u), g);
        }
        function dg(a, u) {
          var g = Le(a) ? sn : Cr;
          return g(a, we(u, 3));
        }
        function fg(a, u) {
          var g = Le(a) ? Ny : lh;
          return g(a, we(u, 3));
        }
        var a_ = as(function(a, u, g) {
          je.call(a, g) ? a[g].push(u) : qn(a, g, [u]);
        });
        function s_(a, u, g, S) {
          a = Wt(a) ? a : Ho(a), g = g && !S ? De(g) : 0;
          var E = a.length;
          return g < 0 && (g = xt(E + g, 0)), bs(a) ? g <= E && a.indexOf(u, g) > -1 : !!E && To(a, u, g) > -1;
        }
        var l_ = Ve(function(a, u, g) {
          var S = -1, E = typeof u == "function", L = Wt(a) ? H(a.length) : [];
          return Cr(a, function(O) {
            L[++S] = E ? Yt(u, O, g) : Gi(O, u, g);
          }), L;
        }), c_ = as(function(a, u, g) {
          qn(a, g, u);
        });
        function hs(a, u) {
          var g = Le(a) ? ot : hh;
          return g(a, we(u, 3));
        }
        function u_(a, u, g, S) {
          return a == null ? [] : (Le(u) || (u = u == null ? [] : [u]), g = S ? n : g, Le(g) || (g = g == null ? [] : [g]), xh(a, u, g));
        }
        var d_ = as(function(a, u, g) {
          a[g ? 0 : 1].push(u);
        }, function() {
          return [[], []];
        });
        function f_(a, u, g) {
          var S = Le(a) ? uu : Um, E = arguments.length < 3;
          return S(a, we(u, 4), g, E, Cr);
        }
        function p_(a, u, g) {
          var S = Le(a) ? _y : Um, E = arguments.length < 3;
          return S(a, we(u, 4), g, E, lh);
        }
        function m_(a, u) {
          var g = Le(a) ? mr : ch;
          return g(a, Cs(we(u, 3)));
        }
        function h_(a) {
          var u = Le(a) ? oh : sS;
          return u(a);
        }
        function g_(a, u, g) {
          (g ? kt(a, u, g) : u === n) ? u = 1 : u = De(u);
          var S = Le(a) ? Fw : lS;
          return S(a, u);
        }
        function v_(a) {
          var u = Le(a) ? Bw : uS;
          return u(a);
        }
        function C_(a) {
          if (a == null)
            return 0;
          if (Wt(a))
            return bs(a) ? Lo(a) : a.length;
          var u = Pt(a);
          return u == Ke || u == yn ? a.size : Au(a).length;
        }
        function x_(a, u, g) {
          var S = Le(a) ? du : dS;
          return g && kt(a, u, g) && (u = n), S(a, we(u, 3));
        }
        var b_ = Ve(function(a, u) {
          if (a == null)
            return [];
          var g = u.length;
          return g > 1 && kt(a, u[0], u[1]) ? u = [] : g > 2 && kt(u[0], u[1], u[2]) && (u = [u[0]]), xh(a, _t(u, 1), []);
        }), gs = ew || function() {
          return Nt.Date.now();
        };
        function y_(a, u) {
          if (typeof u != "function")
            throw new ln(l);
          return a = De(a), function() {
            if (--a < 1)
              return u.apply(this, arguments);
          };
        }
        function pg(a, u, g) {
          return u = g ? n : u, u = a && u == null ? a.length : u, Kn(a, T, n, n, n, n, u);
        }
        function mg(a, u) {
          var g;
          if (typeof u != "function")
            throw new ln(l);
          return a = De(a), function() {
            return --a > 0 && (g = u.apply(this, arguments)), a <= 1 && (u = n), g;
          };
        }
        var Ju = Ve(function(a, u, g) {
          var S = b;
          if (g.length) {
            var E = gr(g, Vo(Ju));
            S |= A;
          }
          return Kn(a, S, u, g, E);
        }), hg = Ve(function(a, u, g) {
          var S = b | w;
          if (g.length) {
            var E = gr(g, Vo(hg));
            S |= A;
          }
          return Kn(u, S, a, g, E);
        });
        function gg(a, u, g) {
          u = g ? n : u;
          var S = Kn(a, _, n, n, n, n, n, u);
          return S.placeholder = gg.placeholder, S;
        }
        function vg(a, u, g) {
          u = g ? n : u;
          var S = Kn(a, P, n, n, n, n, n, u);
          return S.placeholder = vg.placeholder, S;
        }
        function Cg(a, u, g) {
          var S, E, L, O, k, V, Y = 0, Z = !1, J = !1, se = !0;
          if (typeof a != "function")
            throw new ln(l);
          u = pn(u) || 0, at(g) && (Z = !!g.leading, J = "maxWait" in g, L = J ? xt(pn(g.maxWait) || 0, u) : L, se = "trailing" in g ? !!g.trailing : se);
          function me(pt) {
            var _n = S, Qn = E;
            return S = E = n, Y = pt, O = a.apply(Qn, _n), O;
          }
          function Se(pt) {
            return Y = pt, k = Zi(We, u), Z ? me(pt) : O;
          }
          function Fe(pt) {
            var _n = pt - V, Qn = pt - Y, Dg = u - _n;
            return J ? Et(Dg, L - Qn) : Dg;
          }
          function Ne(pt) {
            var _n = pt - V, Qn = pt - Y;
            return V === n || _n >= u || _n < 0 || J && Qn >= L;
          }
          function We() {
            var pt = gs();
            if (Ne(pt))
              return Ue(pt);
            k = Zi(We, Fe(pt));
          }
          function Ue(pt) {
            return k = n, se && S ? me(pt) : (S = E = n, O);
          }
          function Qt() {
            k !== n && Ph(k), Y = 0, S = V = E = k = n;
          }
          function Dt() {
            return k === n ? O : Ue(gs());
          }
          function Jt() {
            var pt = gs(), _n = Ne(pt);
            if (S = arguments, E = this, V = pt, _n) {
              if (k === n)
                return Se(V);
              if (J)
                return Ph(k), k = Zi(We, u), me(V);
            }
            return k === n && (k = Zi(We, u)), O;
          }
          return Jt.cancel = Qt, Jt.flush = Dt, Jt;
        }
        var w_ = Ve(function(a, u) {
          return sh(a, 1, u);
        }), S_ = Ve(function(a, u, g) {
          return sh(a, pn(u) || 0, g);
        });
        function N_(a) {
          return Kn(a, D);
        }
        function vs(a, u) {
          if (typeof a != "function" || u != null && typeof u != "function")
            throw new ln(l);
          var g = function() {
            var S = arguments, E = u ? u.apply(this, S) : S[0], L = g.cache;
            if (L.has(E))
              return L.get(E);
            var O = a.apply(this, S);
            return g.cache = L.set(E, O) || L, O;
          };
          return g.cache = new (vs.Cache || zn)(), g;
        }
        vs.Cache = zn;
        function Cs(a) {
          if (typeof a != "function")
            throw new ln(l);
          return function() {
            var u = arguments;
            switch (u.length) {
              case 0:
                return !a.call(this);
              case 1:
                return !a.call(this, u[0]);
              case 2:
                return !a.call(this, u[0], u[1]);
              case 3:
                return !a.call(this, u[0], u[1], u[2]);
            }
            return !a.apply(this, u);
          };
        }
        function __(a) {
          return mg(2, a);
        }
        var R_ = fS(function(a, u) {
          u = u.length == 1 && Le(u[0]) ? ot(u[0], Zt(we())) : ot(_t(u, 1), Zt(we()));
          var g = u.length;
          return Ve(function(S) {
            for (var E = -1, L = Et(S.length, g); ++E < L; )
              S[E] = u[E].call(this, S[E]);
            return Yt(a, this, S);
          });
        }), ed = Ve(function(a, u) {
          var g = gr(u, Vo(ed));
          return Kn(a, A, n, u, g);
        }), xg = Ve(function(a, u) {
          var g = gr(u, Vo(xg));
          return Kn(a, I, n, u, g);
        }), E_ = Yn(function(a, u) {
          return Kn(a, M, n, n, n, u);
        });
        function P_(a, u) {
          if (typeof a != "function")
            throw new ln(l);
          return u = u === n ? u : De(u), Ve(a, u);
        }
        function A_(a, u) {
          if (typeof a != "function")
            throw new ln(l);
          return u = u == null ? 0 : xt(De(u), 0), Ve(function(g) {
            var S = g[u], E = yr(g, 0, u);
            return S && hr(E, S), Yt(a, this, E);
          });
        }
        function T_(a, u, g) {
          var S = !0, E = !0;
          if (typeof a != "function")
            throw new ln(l);
          return at(g) && (S = "leading" in g ? !!g.leading : S, E = "trailing" in g ? !!g.trailing : E), Cg(a, u, {
            leading: S,
            maxWait: u,
            trailing: E
          });
        }
        function $_(a) {
          return pg(a, 1);
        }
        function L_(a, u) {
          return ed(Fu(u), a);
        }
        function M_() {
          if (!arguments.length)
            return [];
          var a = arguments[0];
          return Le(a) ? a : [a];
        }
        function I_(a) {
          return un(a, x);
        }
        function O_(a, u) {
          return u = typeof u == "function" ? u : n, un(a, x, u);
        }
        function k_(a) {
          return un(a, v | x);
        }
        function D_(a, u) {
          return u = typeof u == "function" ? u : n, un(a, v | x, u);
        }
        function F_(a, u) {
          return u == null || ah(a, u, yt(u));
        }
        function Nn(a, u) {
          return a === u || a !== a && u !== u;
        }
        var B_ = us(Ru), V_ = us(function(a, u) {
          return a >= u;
        }), to = fh(/* @__PURE__ */ function() {
          return arguments;
        }()) ? fh : function(a) {
          return lt(a) && je.call(a, "callee") && !Qm.call(a, "callee");
        }, Le = H.isArray, W_ = Mm ? Zt(Mm) : Zw;
        function Wt(a) {
          return a != null && xs(a.length) && !Xn(a);
        }
        function ft(a) {
          return lt(a) && Wt(a);
        }
        function H_(a) {
          return a === !0 || a === !1 || lt(a) && Ot(a) == Ce;
        }
        var wr = nw || dd, U_ = Im ? Zt(Im) : Xw;
        function G_(a) {
          return lt(a) && a.nodeType === 1 && !Xi(a);
        }
        function z_(a) {
          if (a == null)
            return !0;
          if (Wt(a) && (Le(a) || typeof a == "string" || typeof a.splice == "function" || wr(a) || Wo(a) || to(a)))
            return !a.length;
          var u = Pt(a);
          if (u == Ke || u == yn)
            return !a.size;
          if (Yi(a))
            return !Au(a).length;
          for (var g in a)
            if (je.call(a, g))
              return !1;
          return !0;
        }
        function q_(a, u) {
          return zi(a, u);
        }
        function K_(a, u, g) {
          g = typeof g == "function" ? g : n;
          var S = g ? g(a, u) : n;
          return S === n ? zi(a, u, n, g) : !!S;
        }
        function td(a) {
          if (!lt(a))
            return !1;
          var u = Ot(a);
          return u == Me || u == Te || typeof a.message == "string" && typeof a.name == "string" && !Xi(a);
        }
        function Y_(a) {
          return typeof a == "number" && eh(a);
        }
        function Xn(a) {
          if (!at(a))
            return !1;
          var u = Ot(a);
          return u == Ie || u == ze || u == ie || u == dt;
        }
        function bg(a) {
          return typeof a == "number" && a == De(a);
        }
        function xs(a) {
          return typeof a == "number" && a > -1 && a % 1 == 0 && a <= te;
        }
        function at(a) {
          var u = typeof a;
          return a != null && (u == "object" || u == "function");
        }
        function lt(a) {
          return a != null && typeof a == "object";
        }
        var yg = Om ? Zt(Om) : Qw;
        function Z_(a, u) {
          return a === u || Pu(a, u, zu(u));
        }
        function X_(a, u, g) {
          return g = typeof g == "function" ? g : n, Pu(a, u, zu(u), g);
        }
        function j_(a) {
          return wg(a) && a != +a;
        }
        function Q_(a) {
          if (OS(a))
            throw new $e(i);
          return ph(a);
        }
        function J_(a) {
          return a === null;
        }
        function eR(a) {
          return a == null;
        }
        function wg(a) {
          return typeof a == "number" || lt(a) && Ot(a) == St;
        }
        function Xi(a) {
          if (!lt(a) || Ot(a) != ut)
            return !1;
          var u = qa(a);
          if (u === null)
            return !0;
          var g = je.call(u, "constructor") && u.constructor;
          return typeof g == "function" && g instanceof g && Ha.call(g) == Xy;
        }
        var nd = km ? Zt(km) : Jw;
        function tR(a) {
          return bg(a) && a >= -te && a <= te;
        }
        var Sg = Dm ? Zt(Dm) : eS;
        function bs(a) {
          return typeof a == "string" || !Le(a) && lt(a) && Ot(a) == Mi;
        }
        function jt(a) {
          return typeof a == "symbol" || lt(a) && Ot(a) == Ma;
        }
        var Wo = Fm ? Zt(Fm) : tS;
        function nR(a) {
          return a === n;
        }
        function rR(a) {
          return lt(a) && Pt(a) == Ii;
        }
        function oR(a) {
          return lt(a) && Ot(a) == bb;
        }
        var iR = us(Tu), aR = us(function(a, u) {
          return a <= u;
        });
        function Ng(a) {
          if (!a)
            return [];
          if (Wt(a))
            return bs(a) ? wn(a) : Vt(a);
          if (Di && a[Di])
            return Fy(a[Di]());
          var u = Pt(a), g = u == Ke ? vu : u == yn ? Ba : Ho;
          return g(a);
        }
        function jn(a) {
          if (!a)
            return a === 0 ? a : 0;
          if (a = pn(a), a === Q || a === -Q) {
            var u = a < 0 ? -1 : 1;
            return u * ee;
          }
          return a === a ? a : 0;
        }
        function De(a) {
          var u = jn(a), g = u % 1;
          return u === u ? g ? u - g : u : 0;
        }
        function _g(a) {
          return a ? jr(De(a), 0, ce) : 0;
        }
        function pn(a) {
          if (typeof a == "number")
            return a;
          if (jt(a))
            return Pe;
          if (at(a)) {
            var u = typeof a.valueOf == "function" ? a.valueOf() : a;
            a = at(u) ? u + "" : u;
          }
          if (typeof a != "string")
            return a === 0 ? a : +a;
          a = Gm(a);
          var g = Wb.test(a);
          return g || Ub.test(a) ? yy(a.slice(2), g ? 2 : 8) : Vb.test(a) ? Pe : +a;
        }
        function Rg(a) {
          return On(a, Ht(a));
        }
        function sR(a) {
          return a ? jr(De(a), -te, te) : a === 0 ? a : 0;
        }
        function Ze(a) {
          return a == null ? "" : Xt(a);
        }
        var lR = Fo(function(a, u) {
          if (Yi(u) || Wt(u)) {
            On(u, yt(u), a);
            return;
          }
          for (var g in u)
            je.call(u, g) && Hi(a, g, u[g]);
        }), Eg = Fo(function(a, u) {
          On(u, Ht(u), a);
        }), ys = Fo(function(a, u, g, S) {
          On(u, Ht(u), a, S);
        }), cR = Fo(function(a, u, g, S) {
          On(u, yt(u), a, S);
        }), uR = Yn(Su);
        function dR(a, u) {
          var g = Do(a);
          return u == null ? g : ih(g, u);
        }
        var fR = Ve(function(a, u) {
          a = Qe(a);
          var g = -1, S = u.length, E = S > 2 ? u[2] : n;
          for (E && kt(u[0], u[1], E) && (S = 1); ++g < S; )
            for (var L = u[g], O = Ht(L), k = -1, V = O.length; ++k < V; ) {
              var Y = O[k], Z = a[Y];
              (Z === n || Nn(Z, Io[Y]) && !je.call(a, Y)) && (a[Y] = L[Y]);
            }
          return a;
        }), pR = Ve(function(a) {
          return a.push(n, Gh), Yt(Pg, n, a);
        });
        function mR(a, u) {
          return Vm(a, we(u, 3), In);
        }
        function hR(a, u) {
          return Vm(a, we(u, 3), _u);
        }
        function gR(a, u) {
          return a == null ? a : Nu(a, we(u, 3), Ht);
        }
        function vR(a, u) {
          return a == null ? a : uh(a, we(u, 3), Ht);
        }
        function CR(a, u) {
          return a && In(a, we(u, 3));
        }
        function xR(a, u) {
          return a && _u(a, we(u, 3));
        }
        function bR(a) {
          return a == null ? [] : ns(a, yt(a));
        }
        function yR(a) {
          return a == null ? [] : ns(a, Ht(a));
        }
        function rd(a, u, g) {
          var S = a == null ? n : Qr(a, u);
          return S === n ? g : S;
        }
        function wR(a, u) {
          return a != null && Kh(a, u, zw);
        }
        function od(a, u) {
          return a != null && Kh(a, u, qw);
        }
        var SR = Bh(function(a, u, g) {
          u != null && typeof u.toString != "function" && (u = Ua.call(u)), a[u] = g;
        }, ad(Ut)), NR = Bh(function(a, u, g) {
          u != null && typeof u.toString != "function" && (u = Ua.call(u)), je.call(a, u) ? a[u].push(g) : a[u] = [g];
        }, we), _R = Ve(Gi);
        function yt(a) {
          return Wt(a) ? rh(a) : Au(a);
        }
        function Ht(a) {
          return Wt(a) ? rh(a, !0) : nS(a);
        }
        function RR(a, u) {
          var g = {};
          return u = we(u, 3), In(a, function(S, E, L) {
            qn(g, u(S, E, L), S);
          }), g;
        }
        function ER(a, u) {
          var g = {};
          return u = we(u, 3), In(a, function(S, E, L) {
            qn(g, E, u(S, E, L));
          }), g;
        }
        var PR = Fo(function(a, u, g) {
          rs(a, u, g);
        }), Pg = Fo(function(a, u, g, S) {
          rs(a, u, g, S);
        }), AR = Yn(function(a, u) {
          var g = {};
          if (a == null)
            return g;
          var S = !1;
          u = ot(u, function(L) {
            return L = br(L, a), S || (S = L.length > 1), L;
          }), On(a, Uu(a), g), S && (g = un(g, v | C | x, SS));
          for (var E = u.length; E--; )
            Ou(g, u[E]);
          return g;
        });
        function TR(a, u) {
          return Ag(a, Cs(we(u)));
        }
        var $R = Yn(function(a, u) {
          return a == null ? {} : oS(a, u);
        });
        function Ag(a, u) {
          if (a == null)
            return {};
          var g = ot(Uu(a), function(S) {
            return [S];
          });
          return u = we(u), bh(a, g, function(S, E) {
            return u(S, E[0]);
          });
        }
        function LR(a, u, g) {
          u = br(u, a);
          var S = -1, E = u.length;
          for (E || (E = 1, a = n); ++S < E; ) {
            var L = a == null ? n : a[kn(u[S])];
            L === n && (S = E, L = g), a = Xn(L) ? L.call(a) : L;
          }
          return a;
        }
        function MR(a, u, g) {
          return a == null ? a : qi(a, u, g);
        }
        function IR(a, u, g, S) {
          return S = typeof S == "function" ? S : n, a == null ? a : qi(a, u, g, S);
        }
        var Tg = Hh(yt), $g = Hh(Ht);
        function OR(a, u, g) {
          var S = Le(a), E = S || wr(a) || Wo(a);
          if (u = we(u, 4), g == null) {
            var L = a && a.constructor;
            E ? g = S ? new L() : [] : at(a) ? g = Xn(L) ? Do(qa(a)) : {} : g = {};
          }
          return (E ? sn : In)(a, function(O, k, V) {
            return u(g, O, k, V);
          }), g;
        }
        function kR(a, u) {
          return a == null ? !0 : Ou(a, u);
        }
        function DR(a, u, g) {
          return a == null ? a : _h(a, u, Fu(g));
        }
        function FR(a, u, g, S) {
          return S = typeof S == "function" ? S : n, a == null ? a : _h(a, u, Fu(g), S);
        }
        function Ho(a) {
          return a == null ? [] : gu(a, yt(a));
        }
        function BR(a) {
          return a == null ? [] : gu(a, Ht(a));
        }
        function VR(a, u, g) {
          return g === n && (g = u, u = n), g !== n && (g = pn(g), g = g === g ? g : 0), u !== n && (u = pn(u), u = u === u ? u : 0), jr(pn(a), u, g);
        }
        function WR(a, u, g) {
          return u = jn(u), g === n ? (g = u, u = 0) : g = jn(g), a = pn(a), Kw(a, u, g);
        }
        function HR(a, u, g) {
          if (g && typeof g != "boolean" && kt(a, u, g) && (u = g = n), g === n && (typeof u == "boolean" ? (g = u, u = n) : typeof a == "boolean" && (g = a, a = n)), a === n && u === n ? (a = 0, u = 1) : (a = jn(a), u === n ? (u = a, a = 0) : u = jn(u)), a > u) {
            var S = a;
            a = u, u = S;
          }
          if (g || a % 1 || u % 1) {
            var E = th();
            return Et(a + E * (u - a + by("1e-" + ((E + "").length - 1))), u);
          }
          return Lu(a, u);
        }
        var UR = Bo(function(a, u, g) {
          return u = u.toLowerCase(), a + (g ? Lg(u) : u);
        });
        function Lg(a) {
          return id(Ze(a).toLowerCase());
        }
        function Mg(a) {
          return a = Ze(a), a && a.replace(zb, My).replace(uy, "");
        }
        function GR(a, u, g) {
          a = Ze(a), u = Xt(u);
          var S = a.length;
          g = g === n ? S : jr(De(g), 0, S);
          var E = g;
          return g -= u.length, g >= 0 && a.slice(g, E) == u;
        }
        function zR(a) {
          return a = Ze(a), a && _b.test(a) ? a.replace(um, Iy) : a;
        }
        function qR(a) {
          return a = Ze(a), a && $b.test(a) ? a.replace(eu, "\\$&") : a;
        }
        var KR = Bo(function(a, u, g) {
          return a + (g ? "-" : "") + u.toLowerCase();
        }), YR = Bo(function(a, u, g) {
          return a + (g ? " " : "") + u.toLowerCase();
        }), ZR = kh("toLowerCase");
        function XR(a, u, g) {
          a = Ze(a), u = De(u);
          var S = u ? Lo(a) : 0;
          if (!u || S >= u)
            return a;
          var E = (u - S) / 2;
          return cs(Xa(E), g) + a + cs(Za(E), g);
        }
        function jR(a, u, g) {
          a = Ze(a), u = De(u);
          var S = u ? Lo(a) : 0;
          return u && S < u ? a + cs(u - S, g) : a;
        }
        function QR(a, u, g) {
          a = Ze(a), u = De(u);
          var S = u ? Lo(a) : 0;
          return u && S < u ? cs(u - S, g) + a : a;
        }
        function JR(a, u, g) {
          return g || u == null ? u = 0 : u && (u = +u), aw(Ze(a).replace(tu, ""), u || 0);
        }
        function eE(a, u, g) {
          return (g ? kt(a, u, g) : u === n) ? u = 1 : u = De(u), Mu(Ze(a), u);
        }
        function tE() {
          var a = arguments, u = Ze(a[0]);
          return a.length < 3 ? u : u.replace(a[1], a[2]);
        }
        var nE = Bo(function(a, u, g) {
          return a + (g ? "_" : "") + u.toLowerCase();
        });
        function rE(a, u, g) {
          return g && typeof g != "number" && kt(a, u, g) && (u = g = n), g = g === n ? ce : g >>> 0, g ? (a = Ze(a), a && (typeof u == "string" || u != null && !nd(u)) && (u = Xt(u), !u && $o(a)) ? yr(wn(a), 0, g) : a.split(u, g)) : [];
        }
        var oE = Bo(function(a, u, g) {
          return a + (g ? " " : "") + id(u);
        });
        function iE(a, u, g) {
          return a = Ze(a), g = g == null ? 0 : jr(De(g), 0, a.length), u = Xt(u), a.slice(g, g + u.length) == u;
        }
        function aE(a, u, g) {
          var S = $.templateSettings;
          g && kt(a, u, g) && (u = n), a = Ze(a), u = ys({}, u, S, Uh);
          var E = ys({}, u.imports, S.imports, Uh), L = yt(E), O = gu(E, L), k, V, Y = 0, Z = u.interpolate || Ia, J = "__p += '", se = Cu(
            (u.escape || Ia).source + "|" + Z.source + "|" + (Z === dm ? Bb : Ia).source + "|" + (u.evaluate || Ia).source + "|$",
            "g"
          ), me = "//# sourceURL=" + (je.call(u, "sourceURL") ? (u.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++hy + "]") + `
`;
          a.replace(se, function(Ne, We, Ue, Qt, Dt, Jt) {
            return Ue || (Ue = Qt), J += a.slice(Y, Jt).replace(qb, Oy), We && (k = !0, J += `' +
__e(` + We + `) +
'`), Dt && (V = !0, J += `';
` + Dt + `;
__p += '`), Ue && (J += `' +
((__t = (` + Ue + `)) == null ? '' : __t) +
'`), Y = Jt + Ne.length, Ne;
          }), J += `';
`;
          var Se = je.call(u, "variable") && u.variable;
          if (!Se)
            J = `with (obj) {
` + J + `
}
`;
          else if (Db.test(Se))
            throw new $e(c);
          J = (V ? J.replace(yb, "") : J).replace(wb, "$1").replace(Sb, "$1;"), J = "function(" + (Se || "obj") + `) {
` + (Se ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (k ? ", __e = _.escape" : "") + (V ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + J + `return __p
}`;
          var Fe = Og(function() {
            return Ye(L, me + "return " + J).apply(n, O);
          });
          if (Fe.source = J, td(Fe))
            throw Fe;
          return Fe;
        }
        function sE(a) {
          return Ze(a).toLowerCase();
        }
        function lE(a) {
          return Ze(a).toUpperCase();
        }
        function cE(a, u, g) {
          if (a = Ze(a), a && (g || u === n))
            return Gm(a);
          if (!a || !(u = Xt(u)))
            return a;
          var S = wn(a), E = wn(u), L = zm(S, E), O = qm(S, E) + 1;
          return yr(S, L, O).join("");
        }
        function uE(a, u, g) {
          if (a = Ze(a), a && (g || u === n))
            return a.slice(0, Ym(a) + 1);
          if (!a || !(u = Xt(u)))
            return a;
          var S = wn(a), E = qm(S, wn(u)) + 1;
          return yr(S, 0, E).join("");
        }
        function dE(a, u, g) {
          if (a = Ze(a), a && (g || u === n))
            return a.replace(tu, "");
          if (!a || !(u = Xt(u)))
            return a;
          var S = wn(a), E = zm(S, wn(u));
          return yr(S, E).join("");
        }
        function fE(a, u) {
          var g = W, S = U;
          if (at(u)) {
            var E = "separator" in u ? u.separator : E;
            g = "length" in u ? De(u.length) : g, S = "omission" in u ? Xt(u.omission) : S;
          }
          a = Ze(a);
          var L = a.length;
          if ($o(a)) {
            var O = wn(a);
            L = O.length;
          }
          if (g >= L)
            return a;
          var k = g - Lo(S);
          if (k < 1)
            return S;
          var V = O ? yr(O, 0, k).join("") : a.slice(0, k);
          if (E === n)
            return V + S;
          if (O && (k += V.length - k), nd(E)) {
            if (a.slice(k).search(E)) {
              var Y, Z = V;
              for (E.global || (E = Cu(E.source, Ze(fm.exec(E)) + "g")), E.lastIndex = 0; Y = E.exec(Z); )
                var J = Y.index;
              V = V.slice(0, J === n ? k : J);
            }
          } else if (a.indexOf(Xt(E), k) != k) {
            var se = V.lastIndexOf(E);
            se > -1 && (V = V.slice(0, se));
          }
          return V + S;
        }
        function pE(a) {
          return a = Ze(a), a && Nb.test(a) ? a.replace(cm, Hy) : a;
        }
        var mE = Bo(function(a, u, g) {
          return a + (g ? " " : "") + u.toUpperCase();
        }), id = kh("toUpperCase");
        function Ig(a, u, g) {
          return a = Ze(a), u = g ? n : u, u === n ? Dy(a) ? zy(a) : Py(a) : a.match(u) || [];
        }
        var Og = Ve(function(a, u) {
          try {
            return Yt(a, n, u);
          } catch (g) {
            return td(g) ? g : new $e(g);
          }
        }), hE = Yn(function(a, u) {
          return sn(u, function(g) {
            g = kn(g), qn(a, g, Ju(a[g], a));
          }), a;
        });
        function gE(a) {
          var u = a == null ? 0 : a.length, g = we();
          return a = u ? ot(a, function(S) {
            if (typeof S[1] != "function")
              throw new ln(l);
            return [g(S[0]), S[1]];
          }) : [], Ve(function(S) {
            for (var E = -1; ++E < u; ) {
              var L = a[E];
              if (Yt(L[0], this, S))
                return Yt(L[1], this, S);
            }
          });
        }
        function vE(a) {
          return Hw(un(a, v));
        }
        function ad(a) {
          return function() {
            return a;
          };
        }
        function CE(a, u) {
          return a == null || a !== a ? u : a;
        }
        var xE = Fh(), bE = Fh(!0);
        function Ut(a) {
          return a;
        }
        function sd(a) {
          return mh(typeof a == "function" ? a : un(a, v));
        }
        function yE(a) {
          return gh(un(a, v));
        }
        function wE(a, u) {
          return vh(a, un(u, v));
        }
        var SE = Ve(function(a, u) {
          return function(g) {
            return Gi(g, a, u);
          };
        }), NE = Ve(function(a, u) {
          return function(g) {
            return Gi(a, g, u);
          };
        });
        function ld(a, u, g) {
          var S = yt(u), E = ns(u, S);
          g == null && !(at(u) && (E.length || !S.length)) && (g = u, u = a, a = this, E = ns(u, yt(u)));
          var L = !(at(g) && "chain" in g) || !!g.chain, O = Xn(a);
          return sn(E, function(k) {
            var V = u[k];
            a[k] = V, O && (a.prototype[k] = function() {
              var Y = this.__chain__;
              if (L || Y) {
                var Z = a(this.__wrapped__), J = Z.__actions__ = Vt(this.__actions__);
                return J.push({ func: V, args: arguments, thisArg: a }), Z.__chain__ = Y, Z;
              }
              return V.apply(a, hr([this.value()], arguments));
            });
          }), a;
        }
        function _E() {
          return Nt._ === this && (Nt._ = jy), this;
        }
        function cd() {
        }
        function RE(a) {
          return a = De(a), Ve(function(u) {
            return Ch(u, a);
          });
        }
        var EE = Vu(ot), PE = Vu(Bm), AE = Vu(du);
        function kg(a) {
          return Ku(a) ? fu(kn(a)) : iS(a);
        }
        function TE(a) {
          return function(u) {
            return a == null ? n : Qr(a, u);
          };
        }
        var $E = Vh(), LE = Vh(!0);
        function ud() {
          return [];
        }
        function dd() {
          return !1;
        }
        function ME() {
          return {};
        }
        function IE() {
          return "";
        }
        function OE() {
          return !0;
        }
        function kE(a, u) {
          if (a = De(a), a < 1 || a > te)
            return [];
          var g = ce, S = Et(a, ce);
          u = we(u), a -= ce;
          for (var E = hu(S, u); ++g < a; )
            u(g);
          return E;
        }
        function DE(a) {
          return Le(a) ? ot(a, kn) : jt(a) ? [a] : Vt(ng(Ze(a)));
        }
        function FE(a) {
          var u = ++Zy;
          return Ze(a) + u;
        }
        var BE = ls(function(a, u) {
          return a + u;
        }, 0), VE = Wu("ceil"), WE = ls(function(a, u) {
          return a / u;
        }, 1), HE = Wu("floor");
        function UE(a) {
          return a && a.length ? ts(a, Ut, Ru) : n;
        }
        function GE(a, u) {
          return a && a.length ? ts(a, we(u, 2), Ru) : n;
        }
        function zE(a) {
          return Hm(a, Ut);
        }
        function qE(a, u) {
          return Hm(a, we(u, 2));
        }
        function KE(a) {
          return a && a.length ? ts(a, Ut, Tu) : n;
        }
        function YE(a, u) {
          return a && a.length ? ts(a, we(u, 2), Tu) : n;
        }
        var ZE = ls(function(a, u) {
          return a * u;
        }, 1), XE = Wu("round"), jE = ls(function(a, u) {
          return a - u;
        }, 0);
        function QE(a) {
          return a && a.length ? mu(a, Ut) : 0;
        }
        function JE(a, u) {
          return a && a.length ? mu(a, we(u, 2)) : 0;
        }
        return $.after = y_, $.ary = pg, $.assign = lR, $.assignIn = Eg, $.assignInWith = ys, $.assignWith = cR, $.at = uR, $.before = mg, $.bind = Ju, $.bindAll = hE, $.bindKey = hg, $.castArray = M_, $.chain = ug, $.chunk = HS, $.compact = US, $.concat = GS, $.cond = gE, $.conforms = vE, $.constant = ad, $.countBy = QN, $.create = dR, $.curry = gg, $.curryRight = vg, $.debounce = Cg, $.defaults = fR, $.defaultsDeep = pR, $.defer = w_, $.delay = S_, $.difference = zS, $.differenceBy = qS, $.differenceWith = KS, $.drop = YS, $.dropRight = ZS, $.dropRightWhile = XS, $.dropWhile = jS, $.fill = QS, $.filter = e_, $.flatMap = r_, $.flatMapDeep = o_, $.flatMapDepth = i_, $.flatten = ag, $.flattenDeep = JS, $.flattenDepth = eN, $.flip = N_, $.flow = xE, $.flowRight = bE, $.fromPairs = tN, $.functions = bR, $.functionsIn = yR, $.groupBy = a_, $.initial = rN, $.intersection = oN, $.intersectionBy = iN, $.intersectionWith = aN, $.invert = SR, $.invertBy = NR, $.invokeMap = l_, $.iteratee = sd, $.keyBy = c_, $.keys = yt, $.keysIn = Ht, $.map = hs, $.mapKeys = RR, $.mapValues = ER, $.matches = yE, $.matchesProperty = wE, $.memoize = vs, $.merge = PR, $.mergeWith = Pg, $.method = SE, $.methodOf = NE, $.mixin = ld, $.negate = Cs, $.nthArg = RE, $.omit = AR, $.omitBy = TR, $.once = __, $.orderBy = u_, $.over = EE, $.overArgs = R_, $.overEvery = PE, $.overSome = AE, $.partial = ed, $.partialRight = xg, $.partition = d_, $.pick = $R, $.pickBy = Ag, $.property = kg, $.propertyOf = TE, $.pull = uN, $.pullAll = lg, $.pullAllBy = dN, $.pullAllWith = fN, $.pullAt = pN, $.range = $E, $.rangeRight = LE, $.rearg = E_, $.reject = m_, $.remove = mN, $.rest = P_, $.reverse = ju, $.sampleSize = g_, $.set = MR, $.setWith = IR, $.shuffle = v_, $.slice = hN, $.sortBy = b_, $.sortedUniq = wN, $.sortedUniqBy = SN, $.split = rE, $.spread = A_, $.tail = NN, $.take = _N, $.takeRight = RN, $.takeRightWhile = EN, $.takeWhile = PN, $.tap = UN, $.throttle = T_, $.thru = ms, $.toArray = Ng, $.toPairs = Tg, $.toPairsIn = $g, $.toPath = DE, $.toPlainObject = Rg, $.transform = OR, $.unary = $_, $.union = AN, $.unionBy = TN, $.unionWith = $N, $.uniq = LN, $.uniqBy = MN, $.uniqWith = IN, $.unset = kR, $.unzip = Qu, $.unzipWith = cg, $.update = DR, $.updateWith = FR, $.values = Ho, $.valuesIn = BR, $.without = ON, $.words = Ig, $.wrap = L_, $.xor = kN, $.xorBy = DN, $.xorWith = FN, $.zip = BN, $.zipObject = VN, $.zipObjectDeep = WN, $.zipWith = HN, $.entries = Tg, $.entriesIn = $g, $.extend = Eg, $.extendWith = ys, ld($, $), $.add = BE, $.attempt = Og, $.camelCase = UR, $.capitalize = Lg, $.ceil = VE, $.clamp = VR, $.clone = I_, $.cloneDeep = k_, $.cloneDeepWith = D_, $.cloneWith = O_, $.conformsTo = F_, $.deburr = Mg, $.defaultTo = CE, $.divide = WE, $.endsWith = GR, $.eq = Nn, $.escape = zR, $.escapeRegExp = qR, $.every = JN, $.find = t_, $.findIndex = og, $.findKey = mR, $.findLast = n_, $.findLastIndex = ig, $.findLastKey = hR, $.floor = HE, $.forEach = dg, $.forEachRight = fg, $.forIn = gR, $.forInRight = vR, $.forOwn = CR, $.forOwnRight = xR, $.get = rd, $.gt = B_, $.gte = V_, $.has = wR, $.hasIn = od, $.head = sg, $.identity = Ut, $.includes = s_, $.indexOf = nN, $.inRange = WR, $.invoke = _R, $.isArguments = to, $.isArray = Le, $.isArrayBuffer = W_, $.isArrayLike = Wt, $.isArrayLikeObject = ft, $.isBoolean = H_, $.isBuffer = wr, $.isDate = U_, $.isElement = G_, $.isEmpty = z_, $.isEqual = q_, $.isEqualWith = K_, $.isError = td, $.isFinite = Y_, $.isFunction = Xn, $.isInteger = bg, $.isLength = xs, $.isMap = yg, $.isMatch = Z_, $.isMatchWith = X_, $.isNaN = j_, $.isNative = Q_, $.isNil = eR, $.isNull = J_, $.isNumber = wg, $.isObject = at, $.isObjectLike = lt, $.isPlainObject = Xi, $.isRegExp = nd, $.isSafeInteger = tR, $.isSet = Sg, $.isString = bs, $.isSymbol = jt, $.isTypedArray = Wo, $.isUndefined = nR, $.isWeakMap = rR, $.isWeakSet = oR, $.join = sN, $.kebabCase = KR, $.last = fn, $.lastIndexOf = lN, $.lowerCase = YR, $.lowerFirst = ZR, $.lt = iR, $.lte = aR, $.max = UE, $.maxBy = GE, $.mean = zE, $.meanBy = qE, $.min = KE, $.minBy = YE, $.stubArray = ud, $.stubFalse = dd, $.stubObject = ME, $.stubString = IE, $.stubTrue = OE, $.multiply = ZE, $.nth = cN, $.noConflict = _E, $.noop = cd, $.now = gs, $.pad = XR, $.padEnd = jR, $.padStart = QR, $.parseInt = JR, $.random = HR, $.reduce = f_, $.reduceRight = p_, $.repeat = eE, $.replace = tE, $.result = LR, $.round = XE, $.runInContext = B, $.sample = h_, $.size = C_, $.snakeCase = nE, $.some = x_, $.sortedIndex = gN, $.sortedIndexBy = vN, $.sortedIndexOf = CN, $.sortedLastIndex = xN, $.sortedLastIndexBy = bN, $.sortedLastIndexOf = yN, $.startCase = oE, $.startsWith = iE, $.subtract = jE, $.sum = QE, $.sumBy = JE, $.template = aE, $.times = kE, $.toFinite = jn, $.toInteger = De, $.toLength = _g, $.toLower = sE, $.toNumber = pn, $.toSafeInteger = sR, $.toString = Ze, $.toUpper = lE, $.trim = cE, $.trimEnd = uE, $.trimStart = dE, $.truncate = fE, $.unescape = pE, $.uniqueId = FE, $.upperCase = mE, $.upperFirst = id, $.each = dg, $.eachRight = fg, $.first = sg, ld($, function() {
          var a = {};
          return In($, function(u, g) {
            je.call($.prototype, g) || (a[g] = u);
          }), a;
        }(), { chain: !1 }), $.VERSION = r, sn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(a) {
          $[a].placeholder = $;
        }), sn(["drop", "take"], function(a, u) {
          He.prototype[a] = function(g) {
            g = g === n ? 1 : xt(De(g), 0);
            var S = this.__filtered__ && !u ? new He(this) : this.clone();
            return S.__filtered__ ? S.__takeCount__ = Et(g, S.__takeCount__) : S.__views__.push({
              size: Et(g, ce),
              type: a + (S.__dir__ < 0 ? "Right" : "")
            }), S;
          }, He.prototype[a + "Right"] = function(g) {
            return this.reverse()[a](g).reverse();
          };
        }), sn(["filter", "map", "takeWhile"], function(a, u) {
          var g = u + 1, S = g == X || g == G;
          He.prototype[a] = function(E) {
            var L = this.clone();
            return L.__iteratees__.push({
              iteratee: we(E, 3),
              type: g
            }), L.__filtered__ = L.__filtered__ || S, L;
          };
        }), sn(["head", "last"], function(a, u) {
          var g = "take" + (u ? "Right" : "");
          He.prototype[a] = function() {
            return this[g](1).value()[0];
          };
        }), sn(["initial", "tail"], function(a, u) {
          var g = "drop" + (u ? "" : "Right");
          He.prototype[a] = function() {
            return this.__filtered__ ? new He(this) : this[g](1);
          };
        }), He.prototype.compact = function() {
          return this.filter(Ut);
        }, He.prototype.find = function(a) {
          return this.filter(a).head();
        }, He.prototype.findLast = function(a) {
          return this.reverse().find(a);
        }, He.prototype.invokeMap = Ve(function(a, u) {
          return typeof a == "function" ? new He(this) : this.map(function(g) {
            return Gi(g, a, u);
          });
        }), He.prototype.reject = function(a) {
          return this.filter(Cs(we(a)));
        }, He.prototype.slice = function(a, u) {
          a = De(a);
          var g = this;
          return g.__filtered__ && (a > 0 || u < 0) ? new He(g) : (a < 0 ? g = g.takeRight(-a) : a && (g = g.drop(a)), u !== n && (u = De(u), g = u < 0 ? g.dropRight(-u) : g.take(u - a)), g);
        }, He.prototype.takeRightWhile = function(a) {
          return this.reverse().takeWhile(a).reverse();
        }, He.prototype.toArray = function() {
          return this.take(ce);
        }, In(He.prototype, function(a, u) {
          var g = /^(?:filter|find|map|reject)|While$/.test(u), S = /^(?:head|last)$/.test(u), E = $[S ? "take" + (u == "last" ? "Right" : "") : u], L = S || /^find/.test(u);
          E && ($.prototype[u] = function() {
            var O = this.__wrapped__, k = S ? [1] : arguments, V = O instanceof He, Y = k[0], Z = V || Le(O), J = function(We) {
              var Ue = E.apply($, hr([We], k));
              return S && se ? Ue[0] : Ue;
            };
            Z && g && typeof Y == "function" && Y.length != 1 && (V = Z = !1);
            var se = this.__chain__, me = !!this.__actions__.length, Se = L && !se, Fe = V && !me;
            if (!L && Z) {
              O = Fe ? O : new He(this);
              var Ne = a.apply(O, k);
              return Ne.__actions__.push({ func: ms, args: [J], thisArg: n }), new cn(Ne, se);
            }
            return Se && Fe ? a.apply(this, k) : (Ne = this.thru(J), Se ? S ? Ne.value()[0] : Ne.value() : Ne);
          });
        }), sn(["pop", "push", "shift", "sort", "splice", "unshift"], function(a) {
          var u = Va[a], g = /^(?:push|sort|unshift)$/.test(a) ? "tap" : "thru", S = /^(?:pop|shift)$/.test(a);
          $.prototype[a] = function() {
            var E = arguments;
            if (S && !this.__chain__) {
              var L = this.value();
              return u.apply(Le(L) ? L : [], E);
            }
            return this[g](function(O) {
              return u.apply(Le(O) ? O : [], E);
            });
          };
        }), In(He.prototype, function(a, u) {
          var g = $[u];
          if (g) {
            var S = g.name + "";
            je.call(ko, S) || (ko[S] = []), ko[S].push({ name: u, func: g });
          }
        }), ko[ss(n, w).name] = [{
          name: "wrapper",
          func: n
        }], He.prototype.clone = pw, He.prototype.reverse = mw, He.prototype.value = hw, $.prototype.at = GN, $.prototype.chain = zN, $.prototype.commit = qN, $.prototype.next = KN, $.prototype.plant = ZN, $.prototype.reverse = XN, $.prototype.toJSON = $.prototype.valueOf = $.prototype.value = jN, $.prototype.first = $.prototype.head, Di && ($.prototype[Di] = YN), $;
      }, Mo = qy();
      Kr ? ((Kr.exports = Mo)._ = Mo, su._ = Mo) : Nt._ = Mo;
    }).call(zG);
  }(na, na.exports)), na.exports;
}
var KG = qG();
const _C = Mr([
  !1,
  () => {
  }
]), RC = Mr([
  0,
  () => {
  }
]);
function YG() {
  const [e, t] = lo(_C), [n, r] = lo(RC);
  return /* @__PURE__ */ s(le, { children: n > 100 && /* @__PURE__ */ R(
    ct,
    {
      className: "text-textLink underline pl-0 pr-0 items-center !justify-start",
      onClick: () => t(!e),
      variant: "link",
      children: [
        "Show ",
        e ? "less" : "more",
        e ? /* @__PURE__ */ s(pP, { className: "w-4 h-4" }) : /* @__PURE__ */ s(va, { className: "w-4 h-4" })
      ]
    }
  ) });
}
function qe({
  children: e,
  className: t,
  maxHeight: n = 150
}) {
  const [r, o] = ne(!1), [i, l] = ne(0), c = Je(null);
  Oe(() => {
    c.current && l(c.current.scrollHeight);
  }, []);
  let f = KG.debounce(() => {
    c.current && l(c.current.scrollHeight);
  });
  return Oe(() => (window.addEventListener("resize", f), () => {
    window.removeEventListener("resize", f);
  })), /* @__PURE__ */ s(_C.Provider, { value: [r, o], children: /* @__PURE__ */ R(RC.Provider, { value: [i, l], children: [
    /* @__PURE__ */ s(
      "div",
      {
        className: F("overflow-hidden", t),
        ref: c,
        style: {
          maxHeight: r ? i : n,
          transition: "all .5s ease",
          ...!r && i >= n ? {
            maskImage: "linear-gradient(to bottom, black 50%, transparent 100%)"
          } : {}
        },
        children: e
      }
    ),
    i >= n ? /* @__PURE__ */ s(YG, {}) : null
  ] }) });
}
const ZG = "sidebar_state", XG = 60 * 60 * 24 * 7, jG = "16rem", QG = "18rem", JG = "3rem", ez = "b", EC = Mr(null);
function kc() {
  const e = lo(EC);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider.");
  return e;
}
const tz = q(
  ({
    defaultOpen: e = !0,
    open: t,
    onOpenChange: n,
    className: r,
    style: o,
    children: i,
    ...l
  }, c) => {
    const f = aP(), [p, m] = ne(!1), [v, C] = ne(e), x = t ?? v, y = hn(
      (N) => {
        const _ = typeof N == "function" ? N(x) : N;
        n ? n(_) : C(_), document.cookie = `${ZG}=${_}; path=/; max-age=${XG}`;
      },
      [n, x]
    ), h = hn(() => f ? m((N) => !N) : y((N) => !N), [f, y, m]);
    Oe(() => {
      const N = (_) => {
        _.key === ez && (_.metaKey || _.ctrlKey) && (_.preventDefault(), h());
      };
      return window.addEventListener("keydown", N), () => window.removeEventListener("keydown", N);
    }, [h]);
    const b = x ? "expanded" : "collapsed", w = gn(
      () => ({
        state: b,
        open: x,
        setOpen: y,
        isMobile: f,
        openMobile: p,
        setOpenMobile: m,
        toggleSidebar: h
      }),
      [
        b,
        x,
        y,
        f,
        p,
        m,
        h
      ]
    );
    return /* @__PURE__ */ s(EC.Provider, { value: w, children: /* @__PURE__ */ s(fb, { delayDuration: 0, children: /* @__PURE__ */ s(
      "div",
      {
        style: {
          "--sidebar-width": jG,
          "--sidebar-width-icon": JG,
          ...o
        },
        className: F(
          "group/sidebar-wrapper has-[[data-variant=inset]]:bg-sidebar flex min-h-svh w-full",
          r
        ),
        ref: c,
        ...l,
        children: i
      }
    ) }) });
  }
);
tz.displayName = "SidebarProvider";
const nz = q(
  ({
    side: e = "left",
    variant: t = "sidebar",
    collapsible: n = "offcanvas",
    className: r,
    children: o,
    ...i
  }, l) => {
    const { isMobile: c, state: f, openMobile: p, setOpenMobile: m } = kc();
    return n === "none" ? /* @__PURE__ */ s(
      "div",
      {
        className: F(
          "bg-sidebar text-sidebar-foreground flex h-full w-(--sidebar-width) flex-col",
          r
        ),
        ref: l,
        ...i,
        children: o
      }
    ) : c ? /* @__PURE__ */ s(wC, { open: p, onOpenChange: m, ...i, children: /* @__PURE__ */ s(
      Xp,
      {
        "data-sidebar": "sidebar",
        "data-mobile": "true",
        className: "bg-sidebar text-sidebar-foreground w-(--sidebar-width) p-0 [&>button]:hidden",
        style: {
          "--sidebar-width": QG
        },
        side: e,
        children: /* @__PURE__ */ s("div", { className: "flex h-full w-full flex-col", children: o })
      }
    ) }) : /* @__PURE__ */ R(
      "div",
      {
        ref: l,
        className: "text-sidebar-foreground group peer hidden md:block",
        "data-state": f,
        "data-collapsible": f === "collapsed" ? n : "",
        "data-variant": t,
        "data-side": e,
        children: [
          /* @__PURE__ */ s(
            "div",
            {
              className: F(
                "relative h-svh w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-linear",
                "group-data-[collapsible=offcanvas]:w-0",
                "group-data-[side=right]:rotate-180",
                t === "floating" || t === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4))]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon)"
              )
            }
          ),
          /* @__PURE__ */ s(
            "div",
            {
              className: F(
                "fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear md:flex",
                e === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]",
                // Adjust the padding for floating and inset variants.
                t === "floating" || t === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4)_+2px)]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l",
                r
              ),
              ...i,
              children: /* @__PURE__ */ s(
                "div",
                {
                  "data-sidebar": "sidebar",
                  className: "bg-sidebar group-data-[variant=floating]:border-sidebar-border flex h-full w-full flex-col group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:shadow",
                  children: o
                }
              )
            }
          )
        ]
      }
    );
  }
);
nz.displayName = "Sidebar";
const rz = q(({ className: e, onClick: t, ...n }, r) => {
  const { toggleSidebar: o } = kc();
  return /* @__PURE__ */ R(
    ct,
    {
      ref: r,
      "data-sidebar": "trigger",
      variant: "ghost",
      size: "icon",
      className: F("h-7 w-7", e),
      onClick: (i) => {
        t == null || t(i), o();
      },
      ...n,
      children: [
        /* @__PURE__ */ s(yP, {}),
        /* @__PURE__ */ s("span", { className: "sr-only", children: "Toggle Sidebar" })
      ]
    }
  );
});
rz.displayName = "SidebarTrigger";
const oz = q(({ className: e, ...t }, n) => {
  const { toggleSidebar: r } = kc();
  return /* @__PURE__ */ s(
    "button",
    {
      ref: n,
      "data-sidebar": "rail",
      "aria-label": "Toggle Sidebar",
      tabIndex: -1,
      onClick: r,
      title: "Toggle Sidebar",
      className: F(
        "hover:after:bg-sidebar-border absolute inset-y-0 z-20 hidden w-4 -translate-x-1/2 transition-all ease-linear after:absolute after:inset-y-0 after:left-1/2 after:w-[2px] group-data-[side=left]:-right-4 group-data-[side=right]:left-0 sm:flex",
        "[[data-side=left]_&]:cursor-w-resize [[data-side=right]_&]:cursor-e-resize",
        "[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize",
        "group-data-[collapsible=offcanvas]:hover:bg-sidebar group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full",
        "[[data-side=left][data-collapsible=offcanvas]_&]:-right-2",
        "[[data-side=right][data-collapsible=offcanvas]_&]:-left-2",
        e
      ),
      ...t
    }
  );
});
oz.displayName = "SidebarRail";
const iz = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "main",
  {
    ref: n,
    className: F(
      "bg-background relative flex min-h-svh flex-1 flex-col",
      "peer-data-[variant=inset]:min-h-[calc(100svh-theme(spacing.4))] md:peer-data-[variant=inset]:m-2 md:peer-data-[state=collapsed]:peer-data-[variant=inset]:ml-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow",
      e
    ),
    ...t
  }
));
iz.displayName = "SidebarInset";
const az = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Ep,
  {
    ref: n,
    "data-sidebar": "input",
    className: F(
      "bg-background focus-visible:ring-sidebar-ring h-8 w-full shadow-none focus-visible:ring-2",
      e
    ),
    ...t
  }
));
az.displayName = "SidebarInput";
const sz = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "div",
  {
    ref: n,
    "data-sidebar": "header",
    className: F("flex flex-col gap-2 p-2", e),
    ...t
  }
));
sz.displayName = "SidebarHeader";
const lz = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "div",
  {
    ref: n,
    "data-sidebar": "footer",
    className: F("flex flex-col gap-2 p-2", e),
    ...t
  }
));
lz.displayName = "SidebarFooter";
const cz = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  ga,
  {
    ref: n,
    "data-sidebar": "separator",
    className: F("bg-sidebar-border mx-2 w-auto", e),
    ...t
  }
));
cz.displayName = "SidebarSeparator";
const uz = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "div",
  {
    ref: n,
    "data-sidebar": "content",
    className: F(
      "flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden",
      e
    ),
    ...t
  }
));
uz.displayName = "SidebarContent";
const dz = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "div",
  {
    ref: n,
    "data-sidebar": "group",
    className: F("relative flex w-full min-w-0 flex-col p-2", e),
    ...t
  }
));
dz.displayName = "SidebarGroup";
const fz = q(({ className: e, asChild: t = !1, ...n }, r) => /* @__PURE__ */ s(
  t ? rn : "div",
  {
    ref: r,
    "data-sidebar": "group-label",
    className: F(
      "text-sidebar-foreground/70 ring-sidebar-ring flex h-8 shrink-0 items-center rounded-md px-2 text-xs font-medium outline-none transition-[margin,opa] duration-200 ease-linear focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
      "group-data-[collapsible=icon]:-mt-8 group-data-[collapsible=icon]:opacity-0",
      e
    ),
    ...n
  }
));
fz.displayName = "SidebarGroupLabel";
const pz = q(({ className: e, asChild: t = !1, ...n }, r) => /* @__PURE__ */ s(
  t ? rn : "button",
  {
    ref: r,
    "data-sidebar": "group-action",
    className: F(
      "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground absolute right-3 top-3.5 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-none transition-transform focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
      // Increases the hit area of the button on mobile.
      "after:absolute after:-inset-2 after:md:hidden",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...n
  }
));
pz.displayName = "SidebarGroupAction";
const mz = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "div",
  {
    ref: n,
    "data-sidebar": "group-content",
    className: F("w-full text-sm", e),
    ...t
  }
));
mz.displayName = "SidebarGroupContent";
const hz = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "ul",
  {
    ref: n,
    "data-sidebar": "menu",
    className: F("flex w-full min-w-0 flex-col gap-1", e),
    ...t
  }
));
hz.displayName = "SidebarMenu";
const gz = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "li",
  {
    ref: n,
    "data-sidebar": "menu-item",
    className: F("group/menu-item relative", e),
    ...t
  }
));
gz.displayName = "SidebarMenuItem";
const vz = cr(
  "peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-none ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-[[data-sidebar=menu-action]]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:!size-8 group-data-[collapsible=icon]:!p-2 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
        outline: "bg-background shadow-[0_0_0_1px_hsl(var(--sidebar-border))] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]"
      },
      size: {
        default: "h-8 text-sm",
        sm: "h-7 text-xs",
        lg: "h-12 text-sm group-data-[collapsible=icon]:!p-0"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Cz = q(
  ({
    asChild: e = !1,
    isActive: t = !1,
    variant: n = "default",
    size: r = "default",
    tooltip: o,
    className: i,
    ...l
  }, c) => {
    const f = e ? rn : "button", { isMobile: p, state: m } = kc(), v = /* @__PURE__ */ s(
      f,
      {
        ref: c,
        "data-sidebar": "menu-button",
        "data-size": r,
        "data-active": t,
        className: F(vz({ variant: n, size: r }), i),
        ...l
      }
    );
    return o ? (typeof o == "string" && (o = {
      children: o
    }), /* @__PURE__ */ R(pb, { children: [
      /* @__PURE__ */ s(mb, { asChild: !0, children: v }),
      /* @__PURE__ */ s(
        lm,
        {
          side: "right",
          align: "center",
          hidden: m !== "collapsed" || p,
          ...o
        }
      )
    ] })) : v;
  }
);
Cz.displayName = "SidebarMenuButton";
const xz = q(({ className: e, asChild: t = !1, showOnHover: n = !1, ...r }, o) => /* @__PURE__ */ s(
  t ? rn : "button",
  {
    ref: o,
    "data-sidebar": "menu-action",
    className: F(
      "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground peer-hover/menu-button:text-sidebar-accent-foreground absolute right-1 top-1.5 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-none transition-transform focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
      // Increases the hit area of the button on mobile.
      "after:absolute after:-inset-2 after:md:hidden",
      "peer-data-[size=sm]/menu-button:top-1",
      "peer-data-[size=default]/menu-button:top-1.5",
      "peer-data-[size=lg]/menu-button:top-2.5",
      "group-data-[collapsible=icon]:hidden",
      n && "peer-data-[active=true]/menu-button:text-sidebar-accent-foreground group-focus-within/menu-item:opacity-100 group-hover/menu-item:opacity-100 data-[state=open]:opacity-100 md:opacity-0",
      e
    ),
    ...r
  }
));
xz.displayName = "SidebarMenuAction";
const bz = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "div",
  {
    ref: n,
    "data-sidebar": "menu-badge",
    className: F(
      "text-sidebar-foreground pointer-events-none absolute right-1 flex h-5 min-w-5 select-none items-center justify-center rounded-md px-1 text-xs font-medium tabular-nums",
      "peer-hover/menu-button:text-sidebar-accent-foreground peer-data-[active=true]/menu-button:text-sidebar-accent-foreground",
      "peer-data-[size=sm]/menu-button:top-1",
      "peer-data-[size=default]/menu-button:top-1.5",
      "peer-data-[size=lg]/menu-button:top-2.5",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...t
  }
));
bz.displayName = "SidebarMenuBadge";
const yz = q(({ className: e, showIcon: t = !1, ...n }, r) => {
  const o = gn(() => `${Math.floor(Math.random() * 40) + 50}%`, []);
  return /* @__PURE__ */ R(
    "div",
    {
      ref: r,
      "data-sidebar": "menu-skeleton",
      className: F("flex h-8 items-center gap-2 rounded-md px-2", e),
      ...n,
      children: [
        t && /* @__PURE__ */ s(
          D2,
          {
            className: "size-4 rounded-md",
            "data-sidebar": "menu-skeleton-icon"
          }
        ),
        /* @__PURE__ */ s(
          D2,
          {
            className: "h-4 max-w-(--skeleton-width) flex-1",
            "data-sidebar": "menu-skeleton-text",
            style: {
              "--skeleton-width": o
            }
          }
        )
      ]
    }
  );
});
yz.displayName = "SidebarMenuSkeleton";
const wz = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  "ul",
  {
    ref: n,
    "data-sidebar": "menu-sub",
    className: F(
      "border-sidebar-border mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l px-2.5 py-0.5",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...t
  }
));
wz.displayName = "SidebarMenuSub";
const Sz = q(({ ...e }, t) => /* @__PURE__ */ s("li", { ref: t, ...e }));
Sz.displayName = "SidebarMenuSubItem";
const Nz = q(({ asChild: e = !1, size: t = "md", isActive: n, className: r, ...o }, i) => /* @__PURE__ */ s(
  e ? rn : "a",
  {
    ref: i,
    "data-sidebar": "menu-sub-button",
    "data-size": t,
    "data-active": n,
    className: F(
      "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground active:bg-sidebar-accent active:text-sidebar-accent-foreground [&>svg]:text-sidebar-accent-foreground flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 outline-none focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
      "data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground",
      t === "sm" && "text-xs",
      t === "md" && "text-sm",
      "group-data-[collapsible=icon]:hidden",
      r
    ),
    ...o
  }
));
Nz.displayName = "SidebarMenuSubButton";
function D2({ className: e, ...t }) {
  return /* @__PURE__ */ s(
    "div",
    {
      className: F("bg-muted animate-pulse rounded-md", e),
      ...t
    }
  );
}
function _z(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    const p = (v) => {
      var w;
      const { scope: C, children: x, ...y } = v, h = ((w = C == null ? void 0 : C[e]) == null ? void 0 : w[f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    };
    p.displayName = i + "Provider";
    function m(v, C) {
      var h;
      const x = ((h = C == null ? void 0 : C[e]) == null ? void 0 : h[f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, Rz(o, ...t)];
}
function Rz(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var PC = ["PageUp", "PageDown"], AC = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], TC = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, $i = "Slider", [l1, Ez, Pz] = Dl($i), [$C, _Z] = _z($i, [
  Pz
]), [Az, Dc] = $C($i), LC = d.forwardRef(
  (e, t) => {
    const {
      name: n,
      min: r = 0,
      max: o = 100,
      step: i = 1,
      orientation: l = "horizontal",
      disabled: c = !1,
      minStepsBetweenThumbs: f = 0,
      defaultValue: p = [r],
      value: m,
      onValueChange: v = () => {
      },
      onValueCommit: C = () => {
      },
      inverted: x = !1,
      form: y,
      ...h
    } = e, b = d.useRef(/* @__PURE__ */ new Set()), w = d.useRef(0), _ = l === "horizontal" ? Tz : $z, [P = [], A] = et({
      prop: m,
      defaultProp: p,
      onChange: (U) => {
        var j;
        (j = [...b.current][w.current]) == null || j.focus(), v(U);
      }
    }), I = d.useRef(P);
    function T(U) {
      const re = kz(P, U);
      W(U, re);
    }
    function M(U) {
      W(U, w.current);
    }
    function D() {
      const U = I.current[w.current];
      P[w.current] !== U && C(P);
    }
    function W(U, re, { commit: j } = { commit: !1 }) {
      const X = Vz(i), oe = Wz(Math.round((U - r) / i) * i + r, X), G = ma(oe, [r, o]);
      A((Q = []) => {
        const te = Iz(Q, G, re);
        if (Bz(te, f * i)) {
          w.current = te.indexOf(G);
          const ee = String(te) !== String(Q);
          return ee && j && C(te), ee ? te : Q;
        } else
          return Q;
      });
    }
    return /* @__PURE__ */ s(
      Az,
      {
        scope: e.__scopeSlider,
        name: n,
        disabled: c,
        min: r,
        max: o,
        valueIndexToChangeRef: w,
        thumbs: b.current,
        values: P,
        orientation: l,
        form: y,
        children: /* @__PURE__ */ s(l1.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ s(l1.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ s(
          _,
          {
            "aria-disabled": c,
            "data-disabled": c ? "" : void 0,
            ...h,
            ref: t,
            onPointerDown: he(h.onPointerDown, () => {
              c || (I.current = P);
            }),
            min: r,
            max: o,
            inverted: x,
            onSlideStart: c ? void 0 : T,
            onSlideMove: c ? void 0 : M,
            onSlideEnd: c ? void 0 : D,
            onHomeKeyDown: () => !c && W(r, 0, { commit: !0 }),
            onEndKeyDown: () => !c && W(o, P.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: U, direction: re }) => {
              if (!c) {
                const oe = PC.includes(U.key) || U.shiftKey && AC.includes(U.key) ? 10 : 1, G = w.current, Q = P[G], te = i * oe * re;
                W(Q + te, G, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
LC.displayName = $i;
var [MC, IC] = $C($i, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), Tz = d.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      dir: o,
      inverted: i,
      onSlideStart: l,
      onSlideMove: c,
      onSlideEnd: f,
      onStepKeyDown: p,
      ...m
    } = e, [v, C] = d.useState(null), x = ke(t, (_) => C(_)), y = d.useRef(), h = vn(o), b = h === "ltr", w = b && !i || !b && i;
    function N(_) {
      const P = y.current || v.getBoundingClientRect(), A = [0, P.width], T = jp(A, w ? [n, r] : [r, n]);
      return y.current = P, T(_ - P.left);
    }
    return /* @__PURE__ */ s(
      MC,
      {
        scope: e.__scopeSlider,
        startEdge: w ? "left" : "right",
        endEdge: w ? "right" : "left",
        direction: w ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ s(
          OC,
          {
            dir: h,
            "data-orientation": "horizontal",
            ...m,
            ref: x,
            style: {
              ...m.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (_) => {
              const P = N(_.clientX);
              l == null || l(P);
            },
            onSlideMove: (_) => {
              const P = N(_.clientX);
              c == null || c(P);
            },
            onSlideEnd: () => {
              y.current = void 0, f == null || f();
            },
            onStepKeyDown: (_) => {
              const A = TC[w ? "from-left" : "from-right"].includes(_.key);
              p == null || p({ event: _, direction: A ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), $z = d.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      inverted: o,
      onSlideStart: i,
      onSlideMove: l,
      onSlideEnd: c,
      onStepKeyDown: f,
      ...p
    } = e, m = d.useRef(null), v = ke(t, m), C = d.useRef(), x = !o;
    function y(h) {
      const b = C.current || m.current.getBoundingClientRect(), w = [0, b.height], _ = jp(w, x ? [r, n] : [n, r]);
      return C.current = b, _(h - b.top);
    }
    return /* @__PURE__ */ s(
      MC,
      {
        scope: e.__scopeSlider,
        startEdge: x ? "bottom" : "top",
        endEdge: x ? "top" : "bottom",
        size: "height",
        direction: x ? 1 : -1,
        children: /* @__PURE__ */ s(
          OC,
          {
            "data-orientation": "vertical",
            ...p,
            ref: v,
            style: {
              ...p.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (h) => {
              const b = y(h.clientY);
              i == null || i(b);
            },
            onSlideMove: (h) => {
              const b = y(h.clientY);
              l == null || l(b);
            },
            onSlideEnd: () => {
              C.current = void 0, c == null || c();
            },
            onStepKeyDown: (h) => {
              const w = TC[x ? "from-bottom" : "from-top"].includes(h.key);
              f == null || f({ event: h, direction: w ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), OC = d.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: n,
      onSlideStart: r,
      onSlideMove: o,
      onSlideEnd: i,
      onHomeKeyDown: l,
      onEndKeyDown: c,
      onStepKeyDown: f,
      ...p
    } = e, m = Dc($i, n);
    return /* @__PURE__ */ s(
      ve.span,
      {
        ...p,
        ref: t,
        onKeyDown: he(e.onKeyDown, (v) => {
          v.key === "Home" ? (l(v), v.preventDefault()) : v.key === "End" ? (c(v), v.preventDefault()) : PC.concat(AC).includes(v.key) && (f(v), v.preventDefault());
        }),
        onPointerDown: he(e.onPointerDown, (v) => {
          const C = v.target;
          C.setPointerCapture(v.pointerId), v.preventDefault(), m.thumbs.has(C) ? C.focus() : r(v);
        }),
        onPointerMove: he(e.onPointerMove, (v) => {
          v.target.hasPointerCapture(v.pointerId) && o(v);
        }),
        onPointerUp: he(e.onPointerUp, (v) => {
          const C = v.target;
          C.hasPointerCapture(v.pointerId) && (C.releasePointerCapture(v.pointerId), i(v));
        })
      }
    );
  }
), kC = "SliderTrack", DC = d.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, o = Dc(kC, n);
    return /* @__PURE__ */ s(
      ve.span,
      {
        "data-disabled": o.disabled ? "" : void 0,
        "data-orientation": o.orientation,
        ...r,
        ref: t
      }
    );
  }
);
DC.displayName = kC;
var c1 = "SliderRange", FC = d.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, o = Dc(c1, n), i = IC(c1, n), l = d.useRef(null), c = ke(t, l), f = o.values.length, p = o.values.map(
      (C) => VC(C, o.min, o.max)
    ), m = f > 1 ? Math.min(...p) : 0, v = 100 - Math.max(...p);
    return /* @__PURE__ */ s(
      ve.span,
      {
        "data-orientation": o.orientation,
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: c,
        style: {
          ...e.style,
          [i.startEdge]: m + "%",
          [i.endEdge]: v + "%"
        }
      }
    );
  }
);
FC.displayName = c1;
var u1 = "SliderThumb", BC = d.forwardRef(
  (e, t) => {
    const n = Ez(e.__scopeSlider), [r, o] = d.useState(null), i = ke(t, (c) => o(c)), l = d.useMemo(
      () => r ? n().findIndex((c) => c.ref.current === r) : -1,
      [n, r]
    );
    return /* @__PURE__ */ s(Lz, { ...e, ref: i, index: l });
  }
), Lz = d.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, index: r, name: o, ...i } = e, l = Dc(u1, n), c = IC(u1, n), [f, p] = d.useState(null), m = ke(t, (N) => p(N)), v = f ? l.form || !!f.closest("form") : !0, C = Hr(f), x = l.values[r], y = x === void 0 ? 0 : VC(x, l.min, l.max), h = Oz(r, l.values.length), b = C == null ? void 0 : C[c.size], w = b ? Dz(b, y, c.direction) : 0;
    return d.useEffect(() => {
      if (f)
        return l.thumbs.add(f), () => {
          l.thumbs.delete(f);
        };
    }, [f, l.thumbs]), /* @__PURE__ */ R(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [c.startEdge]: `calc(${y}% + ${w}px)`
        },
        children: [
          /* @__PURE__ */ s(l1.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ s(
            ve.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || h,
              "aria-valuemin": l.min,
              "aria-valuenow": x,
              "aria-valuemax": l.max,
              "aria-orientation": l.orientation,
              "data-orientation": l.orientation,
              "data-disabled": l.disabled ? "" : void 0,
              tabIndex: l.disabled ? void 0 : 0,
              ...i,
              ref: m,
              style: x === void 0 ? { display: "none" } : e.style,
              onFocus: he(e.onFocus, () => {
                l.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          v && /* @__PURE__ */ s(
            Mz,
            {
              name: o ?? (l.name ? l.name + (l.values.length > 1 ? "[]" : "") : void 0),
              form: l.form,
              value: x
            },
            r
          )
        ]
      }
    );
  }
);
BC.displayName = u1;
var Mz = (e) => {
  const { value: t, ...n } = e, r = d.useRef(null), o = Ni(t);
  return d.useEffect(() => {
    const i = r.current, l = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(l, "value").set;
    if (o !== t && f) {
      const p = new Event("input", { bubbles: !0 });
      f.call(i, t), i.dispatchEvent(p);
    }
  }, [o, t]), /* @__PURE__ */ s("input", { style: { display: "none" }, ...n, ref: r, defaultValue: t });
};
function Iz(e = [], t, n) {
  const r = [...e];
  return r[n] = t, r.sort((o, i) => o - i);
}
function VC(e, t, n) {
  const i = 100 / (n - t) * (e - t);
  return ma(i, [0, 100]);
}
function Oz(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function kz(e, t) {
  if (e.length === 1) return 0;
  const n = e.map((o) => Math.abs(o - t)), r = Math.min(...n);
  return n.indexOf(r);
}
function Dz(e, t, n) {
  const r = e / 2, i = jp([0, 50], [0, r]);
  return (r - i(t) * n) * n;
}
function Fz(e) {
  return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
function Bz(e, t) {
  if (t > 0) {
    const n = Fz(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function jp(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function Vz(e) {
  return (String(e).split(".")[1] || "").length;
}
function Wz(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
var WC = LC, Hz = DC, Uz = FC, Gz = BC;
const zz = q(({ className: e, ...t }, n) => /* @__PURE__ */ R(
  WC,
  {
    ref: n,
    className: F(
      "relative flex w-full touch-none select-none items-center",
      e
    ),
    ...t,
    children: [
      /* @__PURE__ */ s(Hz, { className: "bg-secondary relative h-2 w-full grow overflow-hidden rounded-full", children: /* @__PURE__ */ s(Uz, { className: "bg-primary absolute h-full" }) }),
      /* @__PURE__ */ s(Gz, { className: "border-primary bg-background ring-offset-background focus-visible:ring-ring block h-5 w-5 rounded-full border-2 transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" })
    ]
  }
));
zz.displayName = WC.displayName;
var Qp = "Switch", [qz, RZ] = Vr(Qp), [Kz, Yz] = qz(Qp), HC = d.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: l,
      disabled: c,
      value: f = "on",
      onCheckedChange: p,
      ...m
    } = e, [v, C] = d.useState(null), x = ke(t, (N) => C(N)), y = d.useRef(!1), h = v ? !!v.closest("form") : !0, [b = !1, w] = et({
      prop: o,
      defaultProp: i,
      onChange: p
    });
    return /* @__PURE__ */ R(Kz, { scope: n, checked: b, disabled: c, children: [
      /* @__PURE__ */ s(
        ve.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": b,
          "aria-required": l,
          "data-state": zC(b),
          "data-disabled": c ? "" : void 0,
          disabled: c,
          value: f,
          ...m,
          ref: x,
          onClick: he(e.onClick, (N) => {
            w((_) => !_), h && (y.current = N.isPropagationStopped(), y.current || N.stopPropagation());
          })
        }
      ),
      h && /* @__PURE__ */ s(
        Zz,
        {
          control: v,
          bubbles: !y.current,
          name: r,
          value: f,
          checked: b,
          required: l,
          disabled: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
HC.displayName = Qp;
var UC = "SwitchThumb", GC = d.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, o = Yz(UC, n);
    return /* @__PURE__ */ s(
      ve.span,
      {
        "data-state": zC(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
GC.displayName = UC;
var Zz = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, i = d.useRef(null), l = Ni(n), c = Hr(t);
  return d.useEffect(() => {
    const f = i.current, p = window.HTMLInputElement.prototype, v = Object.getOwnPropertyDescriptor(p, "checked").set;
    if (l !== n && v) {
      const C = new Event("click", { bubbles: r });
      v.call(f, n), f.dispatchEvent(C);
    }
  }, [l, n, r]), /* @__PURE__ */ s(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...c,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function zC(e) {
  return e ? "checked" : "unchecked";
}
var qC = HC, Xz = GC;
const KC = q(({ className: e, thumbClassName: t, ...n }, r) => /* @__PURE__ */ s(
  qC,
  {
    className: F(
      "bg-interfaceBgDefault data-[state=checked]:bg-actionDefault focus-visible:ring-ring focus-visible:ring-offset-background data-[state=unchecked]:bg-input inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 peer",
      e
    ),
    ...n,
    ref: r,
    children: /* @__PURE__ */ s(
      Xz,
      {
        className: F(
          "bg-interfaceWhite pointer-events-none block h-5 w-5 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0",
          t
        )
      }
    )
  }
));
KC.displayName = qC.displayName;
function EZ({ className: e, items: t }) {
  return /* @__PURE__ */ s("div", { className: F("flex flex-col", e), children: t.map((n, r) => {
    const o = r === t.length - 1;
    return /* @__PURE__ */ R("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ R("div", { className: "flex flex-col items-center", children: [
        /* @__PURE__ */ s("div", { className: "flex min-h-[20px] items-center", children: /* @__PURE__ */ s(
          "div",
          {
            className: "bg-textLink data-[disabled=true]:bg-blueDisabled text-textWhite flex h-4 w-4 items-center justify-center rounded-full",
            "data-disabled": n.disabled,
            children: n.icon
          }
        ) }),
        /* @__PURE__ */ s(
          "div",
          {
            className: F(
              "bg-textLink data-[disabled=true]:bg-blueDisabled w-[1px] h-full",
              o && "hidden"
            ),
            "data-disabled": n.disabled
          }
        )
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("div", { className: "text-headingsm text-textPrimary", children: n.title }),
        /* @__PURE__ */ s(
          "p",
          {
            className: F(
              "text-bodymd text-textPrimary data-[disabled=true]:text-textSubdued",
              !o && "mb-2"
            ),
            "data-disabled": n.disabled,
            children: n.content
          }
        )
      ] })
    ] }, r);
  }) });
}
var Jp = "Tabs", [jz, PZ] = Vr(Jp, [
  Ec
]), YC = Ec(), [Qz, em] = jz(Jp), ZC = d.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: o,
      defaultValue: i,
      orientation: l = "horizontal",
      dir: c,
      activationMode: f = "automatic",
      ...p
    } = e, m = vn(c), [v, C] = et({
      prop: r,
      onChange: o,
      defaultProp: i
    });
    return /* @__PURE__ */ s(
      Qz,
      {
        scope: n,
        baseId: it(),
        value: v,
        onValueChange: C,
        orientation: l,
        dir: m,
        activationMode: f,
        children: /* @__PURE__ */ s(
          ve.div,
          {
            dir: m,
            "data-orientation": l,
            ...p,
            ref: t
          }
        )
      }
    );
  }
);
ZC.displayName = Jp;
var XC = "TabsList", jC = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...o } = e, i = em(XC, n), l = YC(n);
    return /* @__PURE__ */ s(
      f6,
      {
        asChild: !0,
        ...l,
        orientation: i.orientation,
        dir: i.dir,
        loop: r,
        children: /* @__PURE__ */ s(
          ve.div,
          {
            role: "tablist",
            "aria-orientation": i.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
jC.displayName = XC;
var QC = "TabsTrigger", JC = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: o = !1, ...i } = e, l = em(QC, n), c = YC(n), f = nx(l.baseId, r), p = rx(l.baseId, r), m = r === l.value;
    return /* @__PURE__ */ s(
      p6,
      {
        asChild: !0,
        ...c,
        focusable: !o,
        active: m,
        children: /* @__PURE__ */ s(
          ve.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": m,
            "aria-controls": p,
            "data-state": m ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: f,
            ...i,
            ref: t,
            onMouseDown: he(e.onMouseDown, (v) => {
              !o && v.button === 0 && v.ctrlKey === !1 ? l.onValueChange(r) : v.preventDefault();
            }),
            onKeyDown: he(e.onKeyDown, (v) => {
              [" ", "Enter"].includes(v.key) && l.onValueChange(r);
            }),
            onFocus: he(e.onFocus, () => {
              const v = l.activationMode !== "manual";
              !m && !o && v && l.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
JC.displayName = QC;
var ex = "TabsContent", tx = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: o, children: i, ...l } = e, c = em(ex, n), f = nx(c.baseId, r), p = rx(c.baseId, r), m = r === c.value, v = d.useRef(m);
    return d.useEffect(() => {
      const C = requestAnimationFrame(() => v.current = !1);
      return () => cancelAnimationFrame(C);
    }, []), /* @__PURE__ */ s(Bl, { present: o || m, children: ({ present: C }) => /* @__PURE__ */ s(
      ve.div,
      {
        "data-state": m ? "active" : "inactive",
        "data-orientation": c.orientation,
        role: "tabpanel",
        "aria-labelledby": f,
        hidden: !C,
        id: p,
        tabIndex: 0,
        ...l,
        ref: t,
        style: {
          ...e.style,
          animationDuration: v.current ? "0s" : void 0
        },
        children: C && i
      }
    ) });
  }
);
tx.displayName = ex;
function nx(e, t) {
  return `${e}-trigger-${t}`;
}
function rx(e, t) {
  return `${e}-content-${t}`;
}
var Jz = ZC, ox = jC, ix = JC, ax = tx;
const nr = Jz, Fn = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  ox,
  {
    ref: n,
    className: F("inline-flex items-center justify-center", e),
    ...t
  }
));
Fn.displayName = ox.displayName;
const bt = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  ix,
  {
    ref: n,
    className: F(
      "data-[state=active]:bg-background data-[state=active]:border-b-3 inline-flex items-center justify-center whitespace-nowrap border-b border-[#E3E2E1] py-3 text-base font-semibold text-[#7D7C78] transition-all disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-[#0060EA] data-[state=active]:text-black",
      e
    ),
    ...t
  }
));
bt.displayName = ix.displayName;
const gt = q(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  ax,
  {
    ref: n,
    className: F(
      "ring-offset-background focus-visible:ring-ring focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2",
      e
    ),
    ...t
  }
));
gt.displayName = ax.displayName;
const eq = q(
  ({ className: e, ...t }, n) => /* @__PURE__ */ s(
    "textarea",
    {
      className: F(
        "border-input bg-background ring-offset-background placeholder:text-[1rem] placeholder:leading-[1.25rem] placeholder:text-muted-foreground focus-visible:ring-ring flex min-h-[80px] w-full rounded-md border px-3 py-2 text-[1rem] leading-[1.25rem] focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: n,
      ...t
    }
  )
);
eq.displayName = "Textarea";
var tq = "DismissableLayer", d1 = "dismissableLayer.update", nq = "dismissableLayer.pointerDownOutside", rq = "dismissableLayer.focusOutside", F2, sx = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), lx = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: l,
      onDismiss: c,
      ...f
    } = e, p = d.useContext(sx), [m, v] = d.useState(null), C = (m == null ? void 0 : m.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, x] = d.useState({}), y = ke(t, (T) => v(T)), h = Array.from(p.layers), [b] = [...p.layersWithOutsidePointerEventsDisabled].slice(-1), w = h.indexOf(b), N = m ? h.indexOf(m) : -1, _ = p.layersWithOutsidePointerEventsDisabled.size > 0, P = N >= w, A = iq((T) => {
      const M = T.target, D = [...p.branches].some((W) => W.contains(M));
      !P || D || (o == null || o(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C), I = aq((T) => {
      const M = T.target;
      [...p.branches].some((W) => W.contains(M)) || (i == null || i(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C);
    return Wr((T) => {
      N === p.layers.size - 1 && (r == null || r(T), !T.defaultPrevented && c && (T.preventDefault(), c()));
    }, C), d.useEffect(() => {
      if (m)
        return n && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (F2 = C.body.style.pointerEvents, C.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(m)), p.layers.add(m), B2(), () => {
          n && p.layersWithOutsidePointerEventsDisabled.size === 1 && (C.body.style.pointerEvents = F2);
        };
    }, [m, C, n, p]), d.useEffect(() => () => {
      m && (p.layers.delete(m), p.layersWithOutsidePointerEventsDisabled.delete(m), B2());
    }, [m, p]), d.useEffect(() => {
      const T = () => x({});
      return document.addEventListener(d1, T), () => document.removeEventListener(d1, T);
    }, []), /* @__PURE__ */ s(
      ve.div,
      {
        ...f,
        ref: y,
        style: {
          pointerEvents: _ ? P ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: he(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: he(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: he(
          e.onPointerDownCapture,
          A.onPointerDownCapture
        )
      }
    );
  }
);
lx.displayName = tq;
var oq = "DismissableLayerBranch", cx = d.forwardRef((e, t) => {
  const n = d.useContext(sx), r = d.useRef(null), o = ke(t, r);
  return d.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ s(ve.div, { ...e, ref: o });
});
cx.displayName = oq;
function iq(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1), o = d.useRef(() => {
  });
  return d.useEffect(() => {
    const i = (c) => {
      if (c.target && !r.current) {
        let f = function() {
          ux(
            nq,
            n,
            p,
            { discrete: !0 }
          );
        };
        const p = { originalEvent: c };
        c.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = f, t.addEventListener("click", o.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function aq(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && ux(rq, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function B2() {
  const e = new CustomEvent(d1);
  document.dispatchEvent(e);
}
function ux(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Fl(o, i) : o.dispatchEvent(i);
}
var sq = lx, lq = cx, cq = "Portal", dx = d.forwardRef((e, t) => {
  var c;
  const { container: n, ...r } = e, [o, i] = d.useState(!1);
  be(() => i(!0), []);
  const l = n || o && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return l ? Br.createPortal(/* @__PURE__ */ s(ve.div, { ...r, ref: t }), l) : null;
});
dx.displayName = cq;
var uq = "VisuallyHidden", tm = d.forwardRef(
  (e, t) => /* @__PURE__ */ s(
    ve.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
tm.displayName = uq;
var nm = "ToastProvider", [rm, dq, fq] = Dl("Toast"), [fx, AZ] = Vr("Toast", [fq]), [pq, Fc] = fx(nm), px = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: i = 50,
    children: l
  } = e, [c, f] = d.useState(null), [p, m] = d.useState(0), v = d.useRef(!1), C = d.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${nm}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ s(rm.Provider, { scope: t, children: /* @__PURE__ */ s(
    pq,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: i,
      toastCount: p,
      viewport: c,
      onViewportChange: f,
      onToastAdd: d.useCallback(() => m((x) => x + 1), []),
      onToastRemove: d.useCallback(() => m((x) => x - 1), []),
      isFocusedToastEscapeKeyDownRef: v,
      isClosePausedRef: C,
      children: l
    }
  ) });
};
px.displayName = nm;
var mx = "ToastViewport", mq = ["F8"], f1 = "toast.viewportPause", p1 = "toast.viewportResume", hx = d.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = mq,
      label: o = "Notifications ({hotkey})",
      ...i
    } = e, l = Fc(mx, n), c = dq(n), f = d.useRef(null), p = d.useRef(null), m = d.useRef(null), v = d.useRef(null), C = ke(t, v, l.onViewportChange), x = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), y = l.toastCount > 0;
    d.useEffect(() => {
      const b = (w) => {
        var _;
        r.every((P) => w[P] || w.code === P) && ((_ = v.current) == null || _.focus());
      };
      return document.addEventListener("keydown", b), () => document.removeEventListener("keydown", b);
    }, [r]), d.useEffect(() => {
      const b = f.current, w = v.current;
      if (y && b && w) {
        const N = () => {
          if (!l.isClosePausedRef.current) {
            const I = new CustomEvent(f1);
            w.dispatchEvent(I), l.isClosePausedRef.current = !0;
          }
        }, _ = () => {
          if (l.isClosePausedRef.current) {
            const I = new CustomEvent(p1);
            w.dispatchEvent(I), l.isClosePausedRef.current = !1;
          }
        }, P = (I) => {
          !b.contains(I.relatedTarget) && _();
        }, A = () => {
          b.contains(document.activeElement) || _();
        };
        return b.addEventListener("focusin", N), b.addEventListener("focusout", P), b.addEventListener("pointermove", N), b.addEventListener("pointerleave", A), window.addEventListener("blur", N), window.addEventListener("focus", _), () => {
          b.removeEventListener("focusin", N), b.removeEventListener("focusout", P), b.removeEventListener("pointermove", N), b.removeEventListener("pointerleave", A), window.removeEventListener("blur", N), window.removeEventListener("focus", _);
        };
      }
    }, [y, l.isClosePausedRef]);
    const h = d.useCallback(
      ({ tabbingDirection: b }) => {
        const N = c().map((_) => {
          const P = _.ref.current, A = [P, ...Eq(P)];
          return b === "forwards" ? A : A.reverse();
        });
        return (b === "forwards" ? N.reverse() : N).flat();
      },
      [c]
    );
    return d.useEffect(() => {
      const b = v.current;
      if (b) {
        const w = (N) => {
          var A, I, T;
          const _ = N.altKey || N.ctrlKey || N.metaKey;
          if (N.key === "Tab" && !_) {
            const M = document.activeElement, D = N.shiftKey;
            if (N.target === b && D) {
              (A = p.current) == null || A.focus();
              return;
            }
            const re = h({ tabbingDirection: D ? "backwards" : "forwards" }), j = re.findIndex((X) => X === M);
            rf(re.slice(j + 1)) ? N.preventDefault() : D ? (I = p.current) == null || I.focus() : (T = m.current) == null || T.focus();
          }
        };
        return b.addEventListener("keydown", w), () => b.removeEventListener("keydown", w);
      }
    }, [c, h]), /* @__PURE__ */ R(
      lq,
      {
        ref: f,
        role: "region",
        "aria-label": o.replace("{hotkey}", x),
        tabIndex: -1,
        style: { pointerEvents: y ? void 0 : "none" },
        children: [
          y && /* @__PURE__ */ s(
            m1,
            {
              ref: p,
              onFocusFromOutsideViewport: () => {
                const b = h({
                  tabbingDirection: "forwards"
                });
                rf(b);
              }
            }
          ),
          /* @__PURE__ */ s(rm.Slot, { scope: n, children: /* @__PURE__ */ s(ve.ol, { tabIndex: -1, ...i, ref: C }) }),
          y && /* @__PURE__ */ s(
            m1,
            {
              ref: m,
              onFocusFromOutsideViewport: () => {
                const b = h({
                  tabbingDirection: "backwards"
                });
                rf(b);
              }
            }
          )
        ]
      }
    );
  }
);
hx.displayName = mx;
var gx = "ToastFocusProxy", m1 = d.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, i = Fc(gx, n);
    return /* @__PURE__ */ s(
      tm,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (l) => {
          var p;
          const c = l.relatedTarget;
          !((p = i.viewport) != null && p.contains(c)) && r();
        }
      }
    );
  }
);
m1.displayName = gx;
var Bc = "Toast", hq = "toast.swipeStart", gq = "toast.swipeMove", vq = "toast.swipeCancel", Cq = "toast.swipeEnd", vx = d.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: i, ...l } = e, [c = !0, f] = et({
      prop: r,
      defaultProp: o,
      onChange: i
    });
    return /* @__PURE__ */ s(Bl, { present: n || c, children: /* @__PURE__ */ s(
      yq,
      {
        open: c,
        ...l,
        ref: t,
        onClose: () => f(!1),
        onPause: xe(e.onPause),
        onResume: xe(e.onResume),
        onSwipeStart: he(e.onSwipeStart, (p) => {
          p.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: he(e.onSwipeMove, (p) => {
          const { x: m, y: v } = p.detail.delta;
          p.currentTarget.setAttribute("data-swipe", "move"), p.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${m}px`), p.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${v}px`);
        }),
        onSwipeCancel: he(e.onSwipeCancel, (p) => {
          p.currentTarget.setAttribute("data-swipe", "cancel"), p.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), p.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), p.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), p.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: he(e.onSwipeEnd, (p) => {
          const { x: m, y: v } = p.detail.delta;
          p.currentTarget.setAttribute("data-swipe", "end"), p.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), p.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), p.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${m}px`), p.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${v}px`), f(!1);
        })
      }
    ) });
  }
);
vx.displayName = Bc;
var [xq, bq] = fx(Bc, {
  onClose() {
  }
}), yq = d.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: i,
      onClose: l,
      onEscapeKeyDown: c,
      onPause: f,
      onResume: p,
      onSwipeStart: m,
      onSwipeMove: v,
      onSwipeCancel: C,
      onSwipeEnd: x,
      ...y
    } = e, h = Fc(Bc, n), [b, w] = d.useState(null), N = ke(t, (X) => w(X)), _ = d.useRef(null), P = d.useRef(null), A = o || h.duration, I = d.useRef(0), T = d.useRef(A), M = d.useRef(0), { onToastAdd: D, onToastRemove: W } = h, U = xe(() => {
      var oe;
      (b == null ? void 0 : b.contains(document.activeElement)) && ((oe = h.viewport) == null || oe.focus()), l();
    }), re = d.useCallback(
      (X) => {
        !X || X === 1 / 0 || (window.clearTimeout(M.current), I.current = (/* @__PURE__ */ new Date()).getTime(), M.current = window.setTimeout(U, X));
      },
      [U]
    );
    d.useEffect(() => {
      const X = h.viewport;
      if (X) {
        const oe = () => {
          re(T.current), p == null || p();
        }, G = () => {
          const Q = (/* @__PURE__ */ new Date()).getTime() - I.current;
          T.current = T.current - Q, window.clearTimeout(M.current), f == null || f();
        };
        return X.addEventListener(f1, G), X.addEventListener(p1, oe), () => {
          X.removeEventListener(f1, G), X.removeEventListener(p1, oe);
        };
      }
    }, [h.viewport, A, f, p, re]), d.useEffect(() => {
      i && !h.isClosePausedRef.current && re(A);
    }, [i, A, h.isClosePausedRef, re]), d.useEffect(() => (D(), () => W()), [D, W]);
    const j = d.useMemo(() => b ? Nx(b) : null, [b]);
    return h.viewport ? /* @__PURE__ */ R(le, { children: [
      j && /* @__PURE__ */ s(
        wq,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: j
        }
      ),
      /* @__PURE__ */ s(xq, { scope: n, onClose: U, children: Tn.createPortal(
        /* @__PURE__ */ s(rm.ItemSlot, { scope: n, children: /* @__PURE__ */ s(
          sq,
          {
            asChild: !0,
            onEscapeKeyDown: he(c, () => {
              h.isFocusedToastEscapeKeyDownRef.current || U(), h.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ s(
              ve.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": i ? "open" : "closed",
                "data-swipe-direction": h.swipeDirection,
                ...y,
                ref: N,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: he(e.onKeyDown, (X) => {
                  X.key === "Escape" && (c == null || c(X.nativeEvent), X.nativeEvent.defaultPrevented || (h.isFocusedToastEscapeKeyDownRef.current = !0, U()));
                }),
                onPointerDown: he(e.onPointerDown, (X) => {
                  X.button === 0 && (_.current = { x: X.clientX, y: X.clientY });
                }),
                onPointerMove: he(e.onPointerMove, (X) => {
                  if (!_.current) return;
                  const oe = X.clientX - _.current.x, G = X.clientY - _.current.y, Q = !!P.current, te = ["left", "right"].includes(h.swipeDirection), ee = ["left", "up"].includes(h.swipeDirection) ? Math.min : Math.max, Pe = te ? ee(0, oe) : 0, ce = te ? 0 : ee(0, G), K = X.pointerType === "touch" ? 10 : 2, pe = { x: Pe, y: ce }, ge = { originalEvent: X, delta: pe };
                  Q ? (P.current = pe, Qs(gq, v, ge, {
                    discrete: !1
                  })) : V2(pe, h.swipeDirection, K) ? (P.current = pe, Qs(hq, m, ge, {
                    discrete: !1
                  }), X.target.setPointerCapture(X.pointerId)) : (Math.abs(oe) > K || Math.abs(G) > K) && (_.current = null);
                }),
                onPointerUp: he(e.onPointerUp, (X) => {
                  const oe = P.current, G = X.target;
                  if (G.hasPointerCapture(X.pointerId) && G.releasePointerCapture(X.pointerId), P.current = null, _.current = null, oe) {
                    const Q = X.currentTarget, te = { originalEvent: X, delta: oe };
                    V2(oe, h.swipeDirection, h.swipeThreshold) ? Qs(Cq, x, te, {
                      discrete: !0
                    }) : Qs(
                      vq,
                      C,
                      te,
                      {
                        discrete: !0
                      }
                    ), Q.addEventListener("click", (ee) => ee.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        h.viewport
      ) })
    ] }) : null;
  }
), wq = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = Fc(Bc, t), [i, l] = d.useState(!1), [c, f] = d.useState(!1);
  return _q(() => l(!0)), d.useEffect(() => {
    const p = window.setTimeout(() => f(!0), 1e3);
    return () => window.clearTimeout(p);
  }, []), c ? null : /* @__PURE__ */ s(dx, { asChild: !0, children: /* @__PURE__ */ s(tm, { ...r, children: i && /* @__PURE__ */ R(le, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, Sq = "ToastTitle", Cx = d.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ s(ve.div, { ...r, ref: t });
  }
);
Cx.displayName = Sq;
var Nq = "ToastDescription", xx = d.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ s(ve.div, { ...r, ref: t });
  }
);
xx.displayName = Nq;
var bx = "ToastAction", yx = d.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ s(Sx, { altText: n, asChild: !0, children: /* @__PURE__ */ s(om, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${bx}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
yx.displayName = bx;
var wx = "ToastClose", om = d.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, o = bq(wx, n);
    return /* @__PURE__ */ s(Sx, { asChild: !0, children: /* @__PURE__ */ s(
      ve.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: he(e.onClick, o.onClose)
      }
    ) });
  }
);
om.displayName = wx;
var Sx = d.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ s(
    ve.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: t
    }
  );
});
function Nx(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), Rq(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", i = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (i) {
          const l = r.dataset.radixToastAnnounceAlt;
          l && t.push(l);
        } else
          t.push(...Nx(r));
    }
  }), t;
}
function Qs(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, i = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Fl(o, i) : o.dispatchEvent(i);
}
var V2 = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), i = r > o;
  return t === "left" || t === "right" ? i && r > n : !i && o > n;
};
function _q(e = () => {
}) {
  const t = xe(e);
  be(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function Rq(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function Eq(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function rf(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var Pq = px, _x = hx, Rx = vx, Ex = Cx, Px = xx, Ax = yx, Tx = om;
const Aq = Pq, $x = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  _x,
  {
    ref: n,
    className: F(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
$x.displayName = _x.displayName;
const Tq = cr(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Lx = d.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ s(
  Rx,
  {
    ref: r,
    className: F(Tq({ variant: t }), e),
    ...n
  }
));
Lx.displayName = Rx.displayName;
const $q = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Ax,
  {
    ref: n,
    className: F(
      "ring-offset-background hover:bg-secondary focus:ring-ring group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium transition-colors focus:outline-hidden focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      e
    ),
    ...t
  }
));
$q.displayName = Ax.displayName;
const Mx = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Tx,
  {
    ref: n,
    className: F(
      "text-foreground/50 hover:text-foreground absolute right-2 top-2 rounded-md p-1 opacity-0 transition-opacity focus:opacity-100 focus:outline-hidden focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ s(Ll, { className: "h-4 w-4" })
  }
));
Mx.displayName = Tx.displayName;
const Ix = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Ex,
  {
    ref: n,
    className: F("text-sm font-semibold", e),
    ...t
  }
));
Ix.displayName = Ex.displayName;
const Ox = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ s(
  Px,
  {
    ref: n,
    className: F("text-sm opacity-90", e),
    ...t
  }
));
Ox.displayName = Px.displayName;
const Lq = 1, Mq = 15e5;
let of = 0;
function Iq() {
  return of = (of + 1) % Number.MAX_VALUE, of.toString();
}
const af = /* @__PURE__ */ new Map(), W2 = (e) => {
  if (af.has(e))
    return;
  const t = setTimeout(() => {
    af.delete(e), oa({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, Mq);
  af.set(e, t);
}, Oq = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, Lq)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map(
          (n) => n.id === t.toast.id ? { ...n, ...t.toast } : n
        )
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? W2(n) : e.toasts.forEach((r) => {
        W2(r.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, cl = [];
let ul = { toasts: [] };
function oa(e) {
  ul = Oq(ul, e), cl.forEach((t) => {
    t(ul);
  });
}
function kq({ ...e }) {
  const t = Iq(), n = (o) => oa({
    type: "UPDATE_TOAST",
    toast: { ...o, id: t }
  }), r = () => oa({ type: "DISMISS_TOAST", toastId: t });
  return oa({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (o) => {
        o || r();
      }
    }
  }), {
    id: t,
    dismiss: r,
    update: n
  };
}
function Dq() {
  const [e, t] = ne(ul);
  return Oe(() => (cl.push(t), () => {
    const n = cl.indexOf(t);
    n > -1 && cl.splice(n, 1);
  }), [e]), {
    ...e,
    toast: kq,
    dismiss: (n) => oa({ type: "DISMISS_TOAST", toastId: n })
  };
}
function TZ() {
  const { toasts: e } = Dq();
  return /* @__PURE__ */ R(Aq, { children: [
    e.map(function({ id: t, title: n, description: r, action: o, ...i }) {
      return /* @__PURE__ */ R(Lx, { ...i, children: [
        /* @__PURE__ */ R("div", { className: "grid gap-1", children: [
          n && /* @__PURE__ */ s(Ix, { children: n }),
          r && /* @__PURE__ */ s(Ox, { children: r })
        ] }),
        o,
        /* @__PURE__ */ s(Mx, {})
      ] }, t);
    }),
    /* @__PURE__ */ s($x, {})
  ] });
}
var Fq = "Toggle", kx = d.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: o, ...i } = e, [l = !1, c] = et({
    prop: n,
    onChange: o,
    defaultProp: r
  });
  return /* @__PURE__ */ s(
    ve.button,
    {
      type: "button",
      "aria-pressed": l,
      "data-state": l ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...i,
      ref: t,
      onClick: he(e.onClick, () => {
        e.disabled || c(!l);
      })
    }
  );
});
kx.displayName = Fq;
var Dx = kx;
const Bq = cr(
  "inline-flex items-center justify-center gap-1 rounded-lg text-textSubdued text-bodymd data-[state=on]:bg-textLink data-[state=on]:text-textWhite transition-colors hover:bg-interactiveBgHover focus-visible:outline-hidden data-[state=off]:focus-visible:!bg-interfaceWhite focus-visible:shadow-[0_0_2px_2px_rgba(1,87,255,0.75)] disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border-2 border-blueDisabled bg-transparent data-[state=on]:bg-textLink data-[state=on]:text-textWhite hover:border-blueDefault disabled:border-interactiveBorder data-[state=on]:border-textLink",
        rounded: "border-2 border-blueDisabled bg-transparent data-[state=on]:bg-textLink data-[state=on]:text-textWhite hover:border-blueDefault disabled:border-interactiveBorder data-[state=on]:border-textLink !rounded-[44px]"
      },
      size: {
        default: "h-auto px-2.5 py-1",
        sm: "h-9 px-1",
        lg: "h-11 px-5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Vq = q(
  ({ children: e, className: t, disabled: n, pressed: r, size: o, variant: i, ...l }, c) => /* @__PURE__ */ R(
    Dx,
    {
      className: F(Bq({ variant: i, size: o, className: t })),
      disabled: n,
      pressed: r,
      ref: c,
      ...l,
      children: [
        r ? /* @__PURE__ */ s(hP, { className: "fill-interfaceWhite stroke-textLink h-4 w-4" }) : /* @__PURE__ */ s(
          S1,
          {
            className: F(
              "text-textLink h-4 w-4",
              n ? "text-textSubdued" : ""
            )
          }
        ),
        e
      ]
    }
  )
);
Vq.displayName = Dx.displayName;
function er(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function H2(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Fx(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = H2(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : H2(e[o], null);
        }
      };
  };
}
function Ro(...e) {
  return d.useCallback(Fx(...e), e);
}
function Bx(e, t = []) {
  let n = [];
  function r(i, l) {
    const c = d.createContext(l), f = n.length;
    n = [...n, l];
    const p = (v) => {
      var w;
      const { scope: C, children: x, ...y } = v, h = ((w = C == null ? void 0 : C[e]) == null ? void 0 : w[f]) || c, b = d.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ s(h.Provider, { value: b, children: x });
    };
    p.displayName = i + "Provider";
    function m(v, C) {
      var h;
      const x = ((h = C == null ? void 0 : C[e]) == null ? void 0 : h[f]) || c, y = d.useContext(x);
      if (y) return y;
      if (l !== void 0) return l;
      throw new Error(`\`${v}\` must be used within \`${i}\``);
    }
    return [p, m];
  }
  const o = () => {
    const i = n.map((l) => d.createContext(l));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [r, Wq(o, ...t)];
}
function Wq(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const l = r.reduce((c, { useScope: f, scopeName: p }) => {
        const v = f(i)[`__scope${p}`];
        return { ...c, ...v };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Vx = d.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = d.Children.toArray(n), i = o.find(Hq);
  if (i) {
    const l = i.props.children, c = o.map((f) => f === i ? d.Children.count(l) > 1 ? d.Children.only(null) : d.isValidElement(l) ? l.props.children : null : f);
    return /* @__PURE__ */ s(h1, { ...r, ref: t, children: d.isValidElement(l) ? d.cloneElement(l, void 0, c) : null });
  }
  return /* @__PURE__ */ s(h1, { ...r, ref: t, children: n });
});
Vx.displayName = "Slot";
var h1 = d.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (d.isValidElement(n)) {
    const o = Gq(n);
    return d.cloneElement(n, {
      ...Uq(r, n.props),
      // @ts-ignore
      ref: t ? Fx(t, o) : o
    });
  }
  return d.Children.count(n) > 1 ? d.Children.only(null) : null;
});
h1.displayName = "SlotClone";
var Wx = ({ children: e }) => /* @__PURE__ */ s(le, { children: e });
function Hq(e) {
  return d.isValidElement(e) && e.type === Wx;
}
function Uq(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Gq(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var zq = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Eo = zq.reduce((e, t) => {
  const n = d.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, c = i ? Vx : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(c, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function qq(e, t) {
  e && Tn.flushSync(() => e.dispatchEvent(t));
}
var Kq = "DismissableLayer", g1 = "dismissableLayer.update", Yq = "dismissableLayer.pointerDownOutside", Zq = "dismissableLayer.focusOutside", U2, Hx = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ux = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: l,
      onDismiss: c,
      ...f
    } = e, p = d.useContext(Hx), [m, v] = d.useState(null), C = (m == null ? void 0 : m.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, x] = d.useState({}), y = Ro(t, (T) => v(T)), h = Array.from(p.layers), [b] = [...p.layersWithOutsidePointerEventsDisabled].slice(-1), w = h.indexOf(b), N = m ? h.indexOf(m) : -1, _ = p.layersWithOutsidePointerEventsDisabled.size > 0, P = N >= w, A = Qq((T) => {
      const M = T.target, D = [...p.branches].some((W) => W.contains(M));
      !P || D || (o == null || o(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C), I = Jq((T) => {
      const M = T.target;
      [...p.branches].some((W) => W.contains(M)) || (i == null || i(T), l == null || l(T), T.defaultPrevented || c == null || c());
    }, C);
    return Wr((T) => {
      N === p.layers.size - 1 && (r == null || r(T), !T.defaultPrevented && c && (T.preventDefault(), c()));
    }, C), d.useEffect(() => {
      if (m)
        return n && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (U2 = C.body.style.pointerEvents, C.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(m)), p.layers.add(m), G2(), () => {
          n && p.layersWithOutsidePointerEventsDisabled.size === 1 && (C.body.style.pointerEvents = U2);
        };
    }, [m, C, n, p]), d.useEffect(() => () => {
      m && (p.layers.delete(m), p.layersWithOutsidePointerEventsDisabled.delete(m), G2());
    }, [m, p]), d.useEffect(() => {
      const T = () => x({});
      return document.addEventListener(g1, T), () => document.removeEventListener(g1, T);
    }, []), /* @__PURE__ */ s(
      Eo.div,
      {
        ...f,
        ref: y,
        style: {
          pointerEvents: _ ? P ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: er(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: er(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: er(
          e.onPointerDownCapture,
          A.onPointerDownCapture
        )
      }
    );
  }
);
Ux.displayName = Kq;
var Xq = "DismissableLayerBranch", jq = d.forwardRef((e, t) => {
  const n = d.useContext(Hx), r = d.useRef(null), o = Ro(t, r);
  return d.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ s(Eo.div, { ...e, ref: o });
});
jq.displayName = Xq;
function Qq(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1), o = d.useRef(() => {
  });
  return d.useEffect(() => {
    const i = (c) => {
      if (c.target && !r.current) {
        let f = function() {
          Gx(
            Yq,
            n,
            p,
            { discrete: !0 }
          );
        };
        const p = { originalEvent: c };
        c.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = f, t.addEventListener("click", o.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Jq(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xe(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && Gx(Zq, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function G2() {
  const e = new CustomEvent(g1);
  document.dispatchEvent(e);
}
function Gx(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? qq(o, i) : o.dispatchEvent(i);
}
var eK = "Arrow", zx = d.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ s(
    Eo.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ s("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
zx.displayName = eK;
var tK = zx, im = "Popper", [qx, Kx] = Bx(im), [nK, Yx] = qx(im), Zx = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = d.useState(null);
  return /* @__PURE__ */ s(nK, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
Zx.displayName = im;
var Xx = "PopperAnchor", jx = d.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = Yx(Xx, n), l = d.useRef(null), c = Ro(t, l);
    return d.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || l.current);
    }), r ? null : /* @__PURE__ */ s(Eo.div, { ...o, ref: c });
  }
);
jx.displayName = Xx;
var am = "PopperContent", [rK, oK] = qx(am), Qx = d.forwardRef(
  (e, t) => {
    var ie, Ce, _e, Te, Me, Ie;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: l = 0,
      arrowPadding: c = 0,
      avoidCollisions: f = !0,
      collisionBoundary: p = [],
      collisionPadding: m = 0,
      sticky: v = "partial",
      hideWhenDetached: C = !1,
      updatePositionStrategy: x = "optimized",
      onPlaced: y,
      ...h
    } = e, b = Yx(am, n), [w, N] = d.useState(null), _ = Ro(t, (ze) => N(ze)), [P, A] = d.useState(null), I = Hr(P), T = (I == null ? void 0 : I.width) ?? 0, M = (I == null ? void 0 : I.height) ?? 0, D = r + (i !== "center" ? "-" + i : ""), W = typeof m == "number" ? m : { top: 0, right: 0, bottom: 0, left: 0, ...m }, U = Array.isArray(p) ? p : [p], re = U.length > 0, j = {
      padding: W,
      boundary: U.filter(aK),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: re
    }, { refs: X, floatingStyles: oe, placement: G, isPositioned: Q, middlewareData: te } = pc({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: D,
      whileElementsMounted: (...ze) => fc(...ze, {
        animationFrame: x === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        mc({ mainAxis: o + M, alignmentAxis: l }),
        f && hc({
          mainAxis: !0,
          crossAxis: !1,
          limiter: v === "partial" ? gc() : void 0,
          ...j
        }),
        f && vc({ ...j }),
        Cc({
          ...j,
          apply: ({ elements: ze, rects: Ke, availableWidth: St, availableHeight: Kt }) => {
            const { width: ut, height: Mn } = Ke.reference, dt = ze.floating.style;
            dt.setProperty("--radix-popper-available-width", `${St}px`), dt.setProperty("--radix-popper-available-height", `${Kt}px`), dt.setProperty("--radix-popper-anchor-width", `${ut}px`), dt.setProperty("--radix-popper-anchor-height", `${Mn}px`);
          }
        }),
        P && bc({ element: P, padding: c }),
        sK({ arrowWidth: T, arrowHeight: M }),
        C && xc({ strategy: "referenceHidden", ...j })
      ]
    }), [ee, Pe] = tb(G), ce = xe(y);
    be(() => {
      Q && (ce == null || ce());
    }, [Q, ce]);
    const K = (ie = te.arrow) == null ? void 0 : ie.x, pe = (Ce = te.arrow) == null ? void 0 : Ce.y, ge = ((_e = te.arrow) == null ? void 0 : _e.centerOffset) !== 0, [ue, ye] = d.useState();
    return be(() => {
      w && ye(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ s(
      "div",
      {
        ref: X.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...oe,
          transform: Q ? oe.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ue,
          "--radix-popper-transform-origin": [
            (Te = te.transformOrigin) == null ? void 0 : Te.x,
            (Me = te.transformOrigin) == null ? void 0 : Me.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Ie = te.hide) == null ? void 0 : Ie.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ s(
          rK,
          {
            scope: n,
            placedSide: ee,
            onArrowChange: A,
            arrowX: K,
            arrowY: pe,
            shouldHideArrow: ge,
            children: /* @__PURE__ */ s(
              Eo.div,
              {
                "data-side": ee,
                "data-align": Pe,
                ...h,
                ref: _,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: Q ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Qx.displayName = am;
var Jx = "PopperArrow", iK = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, eb = d.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = oK(Jx, r), l = iK[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ s(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [l]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ s(
          tK,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
eb.displayName = Jx;
function aK(e) {
  return e !== null;
}
var sK = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var b, w, N;
    const { placement: n, rects: r, middlewareData: o } = t, l = ((b = o.arrow) == null ? void 0 : b.centerOffset) !== 0, c = l ? 0 : e.arrowWidth, f = l ? 0 : e.arrowHeight, [p, m] = tb(n), v = { start: "0%", center: "50%", end: "100%" }[m], C = (((w = o.arrow) == null ? void 0 : w.x) ?? 0) + c / 2, x = (((N = o.arrow) == null ? void 0 : N.y) ?? 0) + f / 2;
    let y = "", h = "";
    return p === "bottom" ? (y = l ? v : `${C}px`, h = `${-f}px`) : p === "top" ? (y = l ? v : `${C}px`, h = `${r.floating.height + f}px`) : p === "right" ? (y = `${-f}px`, h = l ? v : `${x}px`) : p === "left" && (y = `${r.floating.width + f}px`, h = l ? v : `${x}px`), { data: { x: y, y: h } };
  }
});
function tb(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var lK = Zx, cK = jx, uK = Qx, dK = eb;
function fK(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var nb = (e) => {
  const { present: t, children: n } = e, r = pK(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), i = Ro(r.ref, mK(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: i }) : null;
};
nb.displayName = "Presence";
function pK(e) {
  const [t, n] = d.useState(), r = d.useRef({}), o = d.useRef(e), i = d.useRef("none"), l = e ? "mounted" : "unmounted", [c, f] = fK(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const p = Js(r.current);
    i.current = c === "mounted" ? p : "none";
  }, [c]), be(() => {
    const p = r.current, m = o.current;
    if (m !== e) {
      const C = i.current, x = Js(p);
      e ? f("MOUNT") : x === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && C !== x ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), be(() => {
    if (t) {
      let p;
      const m = t.ownerDocument.defaultView ?? window, v = (x) => {
        const h = Js(r.current).includes(x.animationName);
        if (x.target === t && h && (f("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, C = (x) => {
        x.target === t && (i.current = Js(r.current));
      };
      return t.addEventListener("animationstart", C), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        m.clearTimeout(p), t.removeEventListener("animationstart", C), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: d.useCallback((p) => {
      p && (r.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function Js(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function mK(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var hK = "VisuallyHidden", rb = d.forwardRef(
  (e, t) => /* @__PURE__ */ s(
    Eo.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
rb.displayName = hK;
var gK = rb, [Vc, $Z] = Bx("Tooltip", [
  Kx
]), Wc = Kx(), ob = "TooltipProvider", vK = 700, v1 = "tooltip.open", [CK, sm] = Vc(ob), ib = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = vK,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, [l, c] = d.useState(!0), f = d.useRef(!1), p = d.useRef(0);
  return d.useEffect(() => {
    const m = p.current;
    return () => window.clearTimeout(m);
  }, []), /* @__PURE__ */ s(
    CK,
    {
      scope: t,
      isOpenDelayed: l,
      delayDuration: n,
      onOpen: d.useCallback(() => {
        window.clearTimeout(p.current), c(!1);
      }, []),
      onClose: d.useCallback(() => {
        window.clearTimeout(p.current), p.current = window.setTimeout(
          () => c(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: f,
      onPointerInTransitChange: d.useCallback((m) => {
        f.current = m;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
ib.displayName = ob;
var Hc = "Tooltip", [xK, Uc] = Vc(Hc), ab = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o = !1,
    onOpenChange: i,
    disableHoverableContent: l,
    delayDuration: c
  } = e, f = sm(Hc, e.__scopeTooltip), p = Wc(t), [m, v] = d.useState(null), C = it(), x = d.useRef(0), y = l ?? f.disableHoverableContent, h = c ?? f.delayDuration, b = d.useRef(!1), [w = !1, N] = et({
    prop: r,
    defaultProp: o,
    onChange: (T) => {
      T ? (f.onOpen(), document.dispatchEvent(new CustomEvent(v1))) : f.onClose(), i == null || i(T);
    }
  }), _ = d.useMemo(() => w ? b.current ? "delayed-open" : "instant-open" : "closed", [w]), P = d.useCallback(() => {
    window.clearTimeout(x.current), x.current = 0, b.current = !1, N(!0);
  }, [N]), A = d.useCallback(() => {
    window.clearTimeout(x.current), x.current = 0, N(!1);
  }, [N]), I = d.useCallback(() => {
    window.clearTimeout(x.current), x.current = window.setTimeout(() => {
      b.current = !0, N(!0), x.current = 0;
    }, h);
  }, [h, N]);
  return d.useEffect(() => () => {
    x.current && (window.clearTimeout(x.current), x.current = 0);
  }, []), /* @__PURE__ */ s(lK, { ...p, children: /* @__PURE__ */ s(
    xK,
    {
      scope: t,
      contentId: C,
      open: w,
      stateAttribute: _,
      trigger: m,
      onTriggerChange: v,
      onTriggerEnter: d.useCallback(() => {
        f.isOpenDelayed ? I() : P();
      }, [f.isOpenDelayed, I, P]),
      onTriggerLeave: d.useCallback(() => {
        y ? A() : (window.clearTimeout(x.current), x.current = 0);
      }, [A, y]),
      onOpen: P,
      onClose: A,
      disableHoverableContent: y,
      children: n
    }
  ) });
};
ab.displayName = Hc;
var C1 = "TooltipTrigger", sb = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Uc(C1, n), i = sm(C1, n), l = Wc(n), c = d.useRef(null), f = Ro(t, c, o.onTriggerChange), p = d.useRef(!1), m = d.useRef(!1), v = d.useCallback(() => p.current = !1, []);
    return d.useEffect(() => () => document.removeEventListener("pointerup", v), [v]), /* @__PURE__ */ s(cK, { asChild: !0, ...l, children: /* @__PURE__ */ s(
      Eo.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: f,
        onPointerMove: er(e.onPointerMove, (C) => {
          C.pointerType !== "touch" && !m.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), m.current = !0);
        }),
        onPointerLeave: er(e.onPointerLeave, () => {
          o.onTriggerLeave(), m.current = !1;
        }),
        onPointerDown: er(e.onPointerDown, () => {
          p.current = !0, document.addEventListener("pointerup", v, { once: !0 });
        }),
        onFocus: er(e.onFocus, () => {
          p.current || o.onOpen();
        }),
        onBlur: er(e.onBlur, o.onClose),
        onClick: er(e.onClick, o.onClose)
      }
    ) });
  }
);
sb.displayName = C1;
var bK = "TooltipPortal", [LZ, yK] = Vc(bK, {
  forceMount: void 0
}), bi = "TooltipContent", lb = d.forwardRef(
  (e, t) => {
    const n = yK(bi, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = e, l = Uc(bi, e.__scopeTooltip);
    return /* @__PURE__ */ s(nb, { present: r || l.open, children: l.disableHoverableContent ? /* @__PURE__ */ s(cb, { side: o, ...i, ref: t }) : /* @__PURE__ */ s(wK, { side: o, ...i, ref: t }) });
  }
), wK = d.forwardRef((e, t) => {
  const n = Uc(bi, e.__scopeTooltip), r = sm(bi, e.__scopeTooltip), o = d.useRef(null), i = Ro(t, o), [l, c] = d.useState(null), { trigger: f, onClose: p } = n, m = o.current, { onPointerInTransitChange: v } = r, C = d.useCallback(() => {
    c(null), v(!1);
  }, [v]), x = d.useCallback(
    (y, h) => {
      const b = y.currentTarget, w = { x: y.clientX, y: y.clientY }, N = RK(w, b.getBoundingClientRect()), _ = EK(w, N), P = PK(h.getBoundingClientRect()), A = TK([..._, ...P]);
      c(A), v(!0);
    },
    [v]
  );
  return d.useEffect(() => () => C(), [C]), d.useEffect(() => {
    if (f && m) {
      const y = (b) => x(b, m), h = (b) => x(b, f);
      return f.addEventListener("pointerleave", y), m.addEventListener("pointerleave", h), () => {
        f.removeEventListener("pointerleave", y), m.removeEventListener("pointerleave", h);
      };
    }
  }, [f, m, x, C]), d.useEffect(() => {
    if (l) {
      const y = (h) => {
        const b = h.target, w = { x: h.clientX, y: h.clientY }, N = (f == null ? void 0 : f.contains(b)) || (m == null ? void 0 : m.contains(b)), _ = !AK(w, l);
        N ? C() : _ && (C(), p());
      };
      return document.addEventListener("pointermove", y), () => document.removeEventListener("pointermove", y);
    }
  }, [f, m, l, p, C]), /* @__PURE__ */ s(cb, { ...e, ref: i });
}), [SK, NK] = Vc(Hc, { isInside: !1 }), cb = d.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: l,
      ...c
    } = e, f = Uc(bi, n), p = Wc(n), { onClose: m } = f;
    return d.useEffect(() => (document.addEventListener(v1, m), () => document.removeEventListener(v1, m)), [m]), d.useEffect(() => {
      if (f.trigger) {
        const v = (C) => {
          const x = C.target;
          x != null && x.contains(f.trigger) && m();
        };
        return window.addEventListener("scroll", v, { capture: !0 }), () => window.removeEventListener("scroll", v, { capture: !0 });
      }
    }, [f.trigger, m]), /* @__PURE__ */ s(
      Ux,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: l,
        onFocusOutside: (v) => v.preventDefault(),
        onDismiss: m,
        children: /* @__PURE__ */ R(
          uK,
          {
            "data-state": f.stateAttribute,
            ...p,
            ...c,
            ref: t,
            style: {
              ...c.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ s(Wx, { children: r }),
              /* @__PURE__ */ s(SK, { scope: n, isInside: !0, children: /* @__PURE__ */ s(gK, { id: f.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
lb.displayName = bi;
var ub = "TooltipArrow", _K = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Wc(n);
    return NK(
      ub,
      n
    ).isInside ? null : /* @__PURE__ */ s(dK, { ...o, ...r, ref: t });
  }
);
_K.displayName = ub;
function RK(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function EK(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function PK(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function AK(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, l = t.length - 1; i < t.length; l = i++) {
    const c = t[i].x, f = t[i].y, p = t[l].x, m = t[l].y;
    f > r != m > r && n < (p - c) * (r - f) / (m - f) + c && (o = !o);
  }
  return o;
}
function TK(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), $K(t);
}
function $K(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], l = t[t.length - 2];
      if ((i.x - l.x) * (o.y - l.y) >= (i.y - l.y) * (o.x - l.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], l = n[n.length - 2];
      if ((i.x - l.x) * (o.y - l.y) >= (i.y - l.y) * (o.x - l.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var LK = ib, MK = ab, IK = sb, db = lb;
const fb = LK, pb = MK, mb = IK, lm = d.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ s(
  db,
  {
    ref: r,
    sideOffset: t,
    className: F(
      "bg-popover text-popover-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 border-border text-bodysm z-50 max-w-[225px] overflow-hidden rounded-md border px-3 py-1.5 shadow-md",
      e
    ),
    ...n
  }
));
lm.displayName = db.displayName;
function yi({
  className: e,
  options: t,
  radioValue: n,
  setRadioValue: r
}) {
  return /* @__PURE__ */ s(
    Pa,
    {
      className: F("flex w-full flex-col", e),
      value: n,
      onValueChange: (o) => {
        r(o);
      },
      children: t.length > 0 && t.map((o) => /* @__PURE__ */ R(
        Tr,
        {
          className: F(
            "data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:border-interactiveBorderHover data-[state=unchecked]:hover:bg-interfaceBgDefault w-full rounded-sm border text-left data-[state=checked]:border-2",
            o.bgColor,
            o.borderColor,
            o.textColor
          ),
          onClick: () => {
            n === o.value && r("");
          },
          tabIndex: 1,
          value: o.value,
          children: [
            o.icon,
            o.text ? /* @__PURE__ */ s("p", { className: "mt-1 text-xs font-normal leading-[14px]", children: o.text }) : null
          ]
        },
        o.value
      ))
    }
  );
}
function OK({
  radioValue: e,
  setRadioValue: t
}) {
  return /* @__PURE__ */ R(
    Pa,
    {
      className: F(
        "flex w-full flex-col overflow-clip rounded border",
        e !== "" ? "border-actionBorder" : "border-interactiveBorder"
      ),
      value: e,
      onValueChange: (n) => {
        t(n);
      },
      "aria-label": "View density",
      children: [
        /* @__PURE__ */ s(
          Tr,
          {
            onClick: () => {
              e === "1" && t("");
            },
            className: "data-[state=checked]:border-actionBorder peer/1 data-[state=checked]:text-actionHover data-[state=checked]:bg-actionBgSelect data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:bg-interfaceBgDefault w-full border-t p-2 text-left first:border-t-0",
            value: "1",
            children: /* @__PURE__ */ R("div", { className: "flex flex-row items-center gap-x-2", children: [
              /* @__PURE__ */ s("div", { className: "text-[21px] font-normal", children: "😃" }),
              /* @__PURE__ */ R("div", { children: [
                /* @__PURE__ */ s("p", { className: "text-xs leading-[14px]", children: "Mostly/all correct" }),
                /* @__PURE__ */ s(
                  "p",
                  {
                    className: F(
                      "text-xs font-normal leading-[14px]",
                      e === "1" ? "text-actionHover" : "text-textSubdued"
                    ),
                    children: "Insignificant errors, if any"
                  }
                )
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ s(
          Tr,
          {
            onClick: () => {
              e === "2" && t("");
            },
            className: "data-[state=checked]:border-actionBorder peer-data-[state=checked]/1:border-actionBorder peer/2 data-[state=checked]:text-actionHover data-[state=checked]:bg-actionBgSelect data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:bg-interfaceBgDefault w-full border-t p-2 text-left first:border-t-0",
            value: "2",
            children: /* @__PURE__ */ R("div", { className: "flex flex-row items-center gap-x-2", children: [
              /* @__PURE__ */ s("div", { className: "text-[21px] font-normal", children: "🙂" }),
              /* @__PURE__ */ R("div", { children: [
                /* @__PURE__ */ s("p", { className: "text-xs leading-[14px]", children: "Partly correct" }),
                /* @__PURE__ */ s(
                  "p",
                  {
                    className: F(
                      "text-xs font-normal leading-[14px]",
                      e === "2" ? "text-actionHover" : "text-textSubdued"
                    ),
                    children: "Correct outcome, but got there the wrong way"
                  }
                )
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ s(
          Tr,
          {
            onClick: () => {
              e === "3" && t("");
            },
            className: "data-[state=checked]:border-actionBorder peer-data-[state=checked]/2:border-actionBorder peer/3 data-[state=checked]:text-actionHover data-[state=checked]:bg-actionBgSelect data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:bg-interfaceBgDefault w-full border-t p-2 text-left first:border-t-0",
            value: "3",
            children: /* @__PURE__ */ R("div", { className: "flex flex-row items-center gap-x-2", children: [
              /* @__PURE__ */ s("div", { className: "text-[21px] font-normal", children: "😕" }),
              /* @__PURE__ */ R("div", { children: [
                /* @__PURE__ */ s("p", { className: "text-xs leading-[14px]", children: "Partly incorrect" }),
                /* @__PURE__ */ s(
                  "p",
                  {
                    className: F(
                      "text-xs font-normal leading-[14px]",
                      e === "3" ? "text-actionHover" : "text-textSubdued"
                    ),
                    children: "Incorrect outcome, but some other correct reasoning"
                  }
                )
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ s(
          Tr,
          {
            onClick: () => {
              e === "4" && t("");
            },
            className: "data-[state=checked]:border-actionBorder peer-data-[state=checked]/3:border-actionBorder peer/4 data-[state=checked]:text-actionHover data-[state=checked]:bg-actionBgSelect data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:bg-interfaceBgDefault w-full border-b border-t p-2 text-left first:border-t-0 last:border-b-0",
            value: "4",
            children: /* @__PURE__ */ R("div", { className: "flex flex-row items-center gap-x-2", children: [
              /* @__PURE__ */ s("div", { className: "text-[21px] font-normal", children: "☹️" }),
              /* @__PURE__ */ R("div", { children: [
                /* @__PURE__ */ s("p", { className: "text-xs leading-[14px]", children: "Mostly incorrect" }),
                /* @__PURE__ */ s(
                  "p",
                  {
                    className: F(
                      "text-xs font-normal leading-[14px]",
                      e === "4" ? "text-actionHover" : "text-textSubdued"
                    ),
                    children: "Major policy or reasoning issues that need resolution"
                  }
                )
              ] })
            ] })
          }
        )
      ]
    }
  );
}
function kK({
  onClickAdjustProposal: e
}) {
  return /* @__PURE__ */ R("div", { className: "bg-actionBgLight border-l-actionBorder rounded-xs border-l-4 px-5 py-3", children: [
    /* @__PURE__ */ s("h3", { className: "text-textPrimary text-lg font-semibold", children: "What you need to do" }),
    /* @__PURE__ */ s("p", { className: "text-textPrimary mt-1 text-base leading-5", children: "We're close to determining if your proposal needs a planning permit, but it isn’t clear based on the description you’ve provided so far." }),
    /* @__PURE__ */ R("ul", { className: "mt-1 list-decimal pl-6", children: [
      /* @__PURE__ */ s("li", { className: "mb-1", children: "Review the summary below for the specific information required." }),
      /* @__PURE__ */ s("li", { className: "mb-1", children: "Gather the necessary information. You may need to consult a planning or building professional." }),
      /* @__PURE__ */ R("li", { className: "mb-1", children: [
        "Update these details by",
        " ",
        /* @__PURE__ */ s(
          "span",
          {
            className: e ? "text-textLink cursor-pointer underline" : "",
            onClick: e,
            role: "button",
            tabIndex: 0,
            children: "adjusting your proposal"
          }
        ),
        "."
      ] }),
      /* @__PURE__ */ s("li", { className: "mb-1", children: "Once completed, we'll be able to provide a clear answer on permit requirements." })
    ] })
  ] });
}
const DK = {
  [de.NoPermitRequired]: {
    text: "text-successHover",
    border: "!border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [de.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "!border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [de.RequiresPermit]: {
    text: "text-warningHover",
    border: "!border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [de.Prohibited]: {
    text: "text-destructiveHover",
    border: "!border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function MZ({
  allowDraftWatermark: e = !0,
  conversation: t,
  expertMap: n,
  flowType: r,
  noticeboardData: o,
  onClickAdjustReport: i
}) {
  const [l, c] = ne({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), [f, p] = ne("assessment"), { getLocalisationEntry: m } = sr(t), v = m("councilOrdinanceLink"), C = yo(t, o);
  Oe(() => {
    C && ["1", "2", "3", "4"].includes(C.toString()) ? c(DK[C.toString()]) : c({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [C, t == null ? void 0 : t.phase]);
  const x = () => {
    let M = "";
    return t != null && t.created_at && (M = new Intl.DateTimeFormat("en-AU", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit"
    }).format(new Date(t.created_at))), M;
  }, y = () => {
    let M = "";
    return t != null && t.updated_at && (M = new Intl.DateTimeFormat("en-AU", {
      hour: "numeric",
      minute: "2-digit"
    }).format(new Date(t.updated_at))), M;
  };
  function h() {
    var W, U, re, j, X, oe, G, Q, te;
    const { expert_name: M = "", output_key: D = "" } = (n == null ? void 0 : n.report_summary) || {};
    return (U = (W = o == null ? void 0 : o[M]) == null ? void 0 : W.parsed_output) != null && U[D] ? (j = (re = o == null ? void 0 : o[M]) == null ? void 0 : re.parsed_output) == null ? void 0 : j[D] : (X = o == null ? void 0 : o[M]) != null && X.raw_output ? (oe = o == null ? void 0 : o[M]) == null ? void 0 : oe.raw_output : (G = o == null ? void 0 : o.buildings_works_final) != null && G.raw_output ? o.buildings_works_final.raw_output : (Q = o == null ? void 0 : o.report_summary_legalese) != null && Q.raw_output ? o.report_summary_legalese.raw_output : (te = o == null ? void 0 : o.report_summary) != null && te.raw_output ? o.report_summary.raw_output : "";
  }
  function b() {
    var M;
    return ((M = o == null ? void 0 : o.lodgement_requirements) == null ? void 0 : M.raw_output) || "";
  }
  const w = () => {
    var U, re, j, X, oe, G;
    const { expert_name: M = "", output_key: D = "" } = (n == null ? void 0 : n.easy_read_report) || {};
    let W = "";
    return (re = (U = o == null ? void 0 : o[M]) == null ? void 0 : U.parsed_output) != null && re[D] ? W = (X = (j = o == null ? void 0 : o[M]) == null ? void 0 : j.parsed_output) == null ? void 0 : X[D] : (oe = o == null ? void 0 : o[M]) != null && oe.raw_output && (W = (G = o == null ? void 0 : o[M]) == null ? void 0 : G.raw_output), /* @__PURE__ */ s("div", { children: Be(W, { ordinanceLink: v }) });
  }, N = () => {
    if (C)
      switch (C.toString()) {
        case de.NoPermitRequired:
          return /* @__PURE__ */ R("div", { children: [
            /* @__PURE__ */ s("p", { className: "text-textPrimary", children: "Based on your responses, it’s likely you don’t need to apply for a planning permit." }),
            /* @__PURE__ */ s("p", { className: "text-textPrimary", children: "However, you may still require a building permit. Building permits are issued separately from planning permits and are required to ensure construction work complies with national building regulations." }),
            /* @__PURE__ */ s(
              "a",
              {
                href: "https://www.yarraranges.vic.gov.au/Development/Building-advice/Do-I-need-a-building-permit",
                className: "text-blue-500 underline hover:text-blue-800",
                onClick: () => window.open(
                  "https://www.yarraranges.vic.gov.au/Development/Building-advice/Do-I-need-a-building-permit"
                ),
                tabIndex: 0,
                children: "Click here if you need a building permit"
              }
            )
          ] });
        case de.MoreInformationRequired:
          return /* @__PURE__ */ R("div", { children: [
            /* @__PURE__ */ s("p", { className: "text-textPrimary text-base leading-5", children: "The application checklist tells you what documents you’ll need to provide when you apply for a planning permit." }),
            /* @__PURE__ */ s("p", { className: "text-textPrimary mt-2 text-base leading-5", children: "More information is needed to determine your personalised application checklist." }),
            /* @__PURE__ */ R("ul", { className: "mt-1 list-decimal pl-6", children: [
              /* @__PURE__ */ R("li", { className: "mb-1", children: [
                "Review the summary under",
                " ",
                /* @__PURE__ */ s(
                  "span",
                  {
                    className: "text-textLink cursor-pointer underline",
                    onClick: () => p("assessment"),
                    role: "button",
                    tabIndex: 0,
                    children: "Assessment"
                  }
                ),
                " ",
                "for any mention of further information required."
              ] }),
              /* @__PURE__ */ s("li", { className: "mb-1", children: "Gather the necessary information. You may need to consult a planning or building professional." }),
              /* @__PURE__ */ R("li", { className: "mb-1", children: [
                "Update these details by",
                " ",
                /* @__PURE__ */ s(
                  "span",
                  {
                    className: i ? "text-textLink cursor-pointer underline" : "",
                    onClick: i,
                    role: "button",
                    tabIndex: 0,
                    children: "adjusting your proposal"
                  }
                ),
                "."
              ] }),
              /* @__PURE__ */ s("li", { className: "mb-1", children: "Once completed, we’ll determine if your proposal requires a planning permit or not, and if it does, generate an application checklist." })
            ] })
          ] });
        case de.RequiresPermit:
          return /* @__PURE__ */ R(le, { children: [
            /* @__PURE__ */ s("p", { className: "text-textPrimary", children: "☝️ Use this checklist as a starting point only. Talk to a planner before preparing any reports or plans." }),
            /* @__PURE__ */ s(
              "div",
              {
                className: `mb-7 mt-6 h-px w-full border-t ${l.border}`
              }
            ),
            Be(b(), {
              ordinanceLink: v
            })
          ] });
        case de.Prohibited:
          return /* @__PURE__ */ R(le, { children: [
            /* @__PURE__ */ s("p", { className: "text-textPrimary", children: "Based on your responses, it’s likely your plans are prohibited. We don’t recommend applying for a planning permit because it’s unlikely Council will support your proposal." }),
            /* @__PURE__ */ R("p", { className: "text-textPrimary", children: [
              "If you have questions about your result,",
              " ",
              /* @__PURE__ */ s(
                "a",
                {
                  className: "text-blue-500 underline hover:text-blue-800",
                  href: "mailto:mail@yarraranges.vic.gov.au",
                  children: "contact Yarra Ranges Council"
                }
              ),
              " ",
              "to talk to one of our planners."
            ] })
          ] });
      }
  }, _ = () => null, P = () => {
    switch ((C || 0).toString()) {
      case de.NoPermitRequired:
        return /* @__PURE__ */ R(le, { children: [
          /* @__PURE__ */ s(
            "div",
            {
              className: `mb-7 mt-6 h-px w-full border-t ${l.border}`
            }
          ),
          /* @__PURE__ */ s("p", { className: "text-base text-textPrimary", children: "☝️ This service only checks for planning permit triggers. Even if you don’t need a planning permit, there may be other requirements in the planning scheme that your proposal will need to comply to." })
        ] });
      case de.MoreInformationRequired:
        return /* @__PURE__ */ R(le, { children: [
          /* @__PURE__ */ s(
            "div",
            {
              className: `mb-7 mt-6 h-px w-full border-t ${l.border}`
            }
          ),
          /* @__PURE__ */ s("p", { className: "text-base text-textPrimary", children: "☝️ This service only checks for planning permit triggers. Even if you don’t need a planning permit, there may be other requirements in the planning scheme that your proposal will need to comply to." })
        ] });
      case de.RequiresPermit:
        return /* @__PURE__ */ R(le, { children: [
          /* @__PURE__ */ s(
            "div",
            {
              className: `mb-7 mt-6 h-px w-full border-t ${l.border}`
            }
          ),
          /* @__PURE__ */ s("p", { className: "text-base text-textPrimary", children: "☝️ This service only checks for planning permit triggers. There may be other requirements in the planning scheme that your proposal will need to comply to." })
        ] });
      case de.Prohibited:
        return null;
    }
  }, A = () => /* @__PURE__ */ R("div", { className: "", children: [
    (C || 0).toString() === de.MoreInformationRequired && r !== Uo.fast_enquiry ? /* @__PURE__ */ s("div", { className: "mb-6", children: /* @__PURE__ */ s(
      kK,
      {
        onClickAdjustProposal: i
      }
    ) }) : null,
    /* @__PURE__ */ s(qe, { children: Be(h(), { ordinanceLink: v }) }),
    r === Uo.fast_enquiry ? _() : null,
    r !== Uo.fast_enquiry ? P() : null
  ] }), I = () => {
    var M, D, W, U, re, j;
    if (r === Uo.fast_enquiry) {
      const { expert_name: X = "", output_key: oe = "" } = (n == null ? void 0 : n.report_heading) || {};
      return (D = (M = o == null ? void 0 : o[X]) == null ? void 0 : M.parsed_output) != null && D[oe] ? (U = (W = o == null ? void 0 : o[X]) == null ? void 0 : W.parsed_output) == null ? void 0 : U[oe] : (re = o == null ? void 0 : o[X]) != null && re.raw_output ? (j = o == null ? void 0 : o[X]) == null ? void 0 : j.raw_output : "Your planning enquiry report";
    }
    if (C)
      switch (C.toString()) {
        case de.NoPermitRequired:
          return "Your proposal likely doesn’t require a planning permit.";
        case de.MoreInformationRequired:
          return "Additional information is required, please keep refining your proposal.";
        case de.RequiresPermit:
          return "Your proposal likely requires a planning permit.";
        case de.Prohibited:
          return "Your proposal is likely prohibited.";
      }
  }, T = () => /* @__PURE__ */ R(
    "div",
    {
      className: `content-start justify-start rounded-t-md border-x border-t ${l.border} ${l.bgLight} p-5 md:px-10 md:pb-6 md:pt-8`,
      children: [
        /* @__PURE__ */ s("div", { className: "mb-2 inline-flex", children: /* @__PURE__ */ s("div", { className: "", children: /* @__PURE__ */ s(
          "h2",
          {
            className: `text-[28px] font-semibold leading-8 ${l.text}`,
            children: I()
          }
        ) }) }),
        /* @__PURE__ */ R("p", { className: "mb-2 text-xs leading-[14px]", children: [
          "Generated at ",
          y(),
          " on ",
          x(),
          " using planning legislation accessed on 31/03/24"
        ] })
      ]
    }
  );
  return /* @__PURE__ */ s("div", { "data-testid": "assessment-report", children: /* @__PURE__ */ R("div", { className: "relative", children: [
    e && ["ready_for_assessment", "report_ready", "amendment"].includes(
      (t == null ? void 0 : t.phase) || ""
    ) ? /* @__PURE__ */ s(wO, {}) : null,
    /* @__PURE__ */ s("div", { children: T() }),
    /* @__PURE__ */ s(
      "div",
      {
        className: `${l.border} border-interactiveBorder flex flex-col ${l.bgLight}`,
        children: /* @__PURE__ */ R(
          nr,
          {
            className: `${l.border} w-full overflow-hidden rounded-b-lg border-x border-b`,
            onValueChange: (M) => p(M),
            value: f,
            children: [
              /* @__PURE__ */ R(
                Fn,
                {
                  className: `!flex w-full items-end justify-start ${l.border}`,
                  children: [
                    /* @__PURE__ */ s(
                      "div",
                      {
                        className: `self-end w-5 border-b md:w-10 ${l.border}`
                      }
                    ),
                    r === Uo.fast_enquiry || r === Uo.forced_fast_enquiry ? /* @__PURE__ */ R(le, { children: [
                      /* @__PURE__ */ s(
                        bt,
                        {
                          type: void 0,
                          value: "assessment",
                          className: `data-[state=active]:!border-r-0 !rounded-tl !border !border-r-0 ${l.bgDark} data-[state=active]:bg-interfaceWhite ${l.border} data-[state=active]:${l.border} text-textPrimary data-[state=active]:!border-b-interfaceWhite border-b px-4 py-2 text-lg font-semibold leading-[22px] data-[state=active]:border focus:outline-hidden`,
                          children: "Assessment"
                        }
                      ),
                      /* @__PURE__ */ s(
                        bt,
                        {
                          type: void 0,
                          value: "easy-read",
                          className: `data-[state=active]:!border-l-0 !rounded-tr-sm !border ${l.bgDark} data-[state=active]:bg-interfaceWhite ${l.border} data-[state=active]:${l.border} text-textPrimary data-[state=active]:!border-b-interfaceWhite border-b px-4 py-2 text-lg font-semibold leading-[22px] data-[state=active]:border focus:outline-hidden`,
                          children: "Easy read"
                        }
                      )
                    ] }) : null,
                    /* @__PURE__ */ s(
                      "div",
                      {
                        className: `self-end flex-1 border-b ${l.border}`
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ R("div", { className: "bg-interfaceWhite px-5 py-4 md:px-10 md:py-8", children: [
                /* @__PURE__ */ s(gt, { value: "assessment", className: "", children: A() }),
                /* @__PURE__ */ s(gt, { value: "easy-read", className: "", children: /* @__PURE__ */ s("div", { children: w() }) }),
                /* @__PURE__ */ s(gt, { value: "application", className: "", children: /* @__PURE__ */ s("div", { children: N() }) })
              ] })
            ]
          }
        )
      }
    )
  ] }) });
}
function z2({
  expertMap: e,
  noticeboardData: t,
  ordinanceLink: n
}) {
  const r = aa(
    e,
    t
  );
  return /* @__PURE__ */ R(le, { children: [
    /* @__PURE__ */ s("h3", { className: "text-headingmd text-textPrimary mb-1", children: "Required documents and information" }),
    /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-5", children: "If your proposal requires a planning permit and isn’t eligible for VicSmart, use this list to check off what you’ll need to provide when you apply." }),
    /* @__PURE__ */ s(qe, { children: Be(r, {
      ordinanceLink: n
    }) })
  ] });
}
function q2({
  expertMap: e,
  noticeboardData: t,
  ordinanceLink: n
}) {
  const r = kl(
    e,
    t
  ), o = Ol(e, t), i = r === void 0 || !o;
  return /* @__PURE__ */ R(le, { children: [
    /* @__PURE__ */ s("h3", { className: "text-headingmd text-textPrimary mb-1", children: "VicSmart eligibility" }),
    /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-5", children: "VicSmart is a faster approval process for straightforward planning applications. If your proposal requires a planning permit and meets certain criteria, you may be able to apply with VicSmart." }),
    i ? /* @__PURE__ */ R("div", { className: "mb-2 items-center flex gap-1", children: [
      /* @__PURE__ */ s(So, { className: "animate-spin min-h-5 min-w-5" }),
      /* @__PURE__ */ s("span", { className: "text-bodymd text-textPrimary", children: "Assessing VicSmart eligibility" })
    ] }) : null,
    i ? null : /* @__PURE__ */ s("div", { className: "mb-2", children: /* @__PURE__ */ s(N1, { eligibility: r }) }),
    !i && r === Ir.eligible ? /* @__PURE__ */ s(qe, { children: Be(o, {
      ordinanceLink: n
    }) }) : null,
    !i && r !== Ir.eligible ? /* @__PURE__ */ s("p", { className: "text-bodymd text-textPrimary", children: "Your proposal is likely ineligible for VicSmart because it doesn't meet the criteria, or you’ve triggered a planning requirement that has no associated VicSmart approval pathway." }) : null
  ] });
}
function hb({
  conversation: e
}) {
  const { getLocalisationEntry: t } = sr(e), n = t("councilContactLink");
  return /* @__PURE__ */ R("div", { className: "rounded border border-interfaceBorder bg-interfaceBgLight text-bodymd text-textPrimary px-6 py-5", children: [
    /* @__PURE__ */ s("h3", { className: "text-headingmd mb-1", children: "✨ This service uses AI to analyse proposals" }),
    /* @__PURE__ */ s("p", { className: "mb-2", children: "It can sometimes make mistakes. It also doesn’t account for a few things, such as:" }),
    /* @__PURE__ */ R("ul", { className: "list-disc list-inside pl-2 mb-2", children: [
      /* @__PURE__ */ s("li", { children: "overlays only applying to part of a property" }),
      /* @__PURE__ */ R("li", { children: [
        "covenants, 173 agreements and other restrictions found on a",
        " ",
        /* @__PURE__ */ s(
          "a",
          {
            className: "text-textLink hover:text-textLinkHover inline-flex cursor-pointer underline",
            href: "https://www.land.vic.gov.au/land-registration/for-individuals/property-and-land-titles-information",
            rel: "noreferrer",
            tabIndex: 0,
            target: "_blank",
            children: "Certificate of Title"
          }
        )
      ] }),
      /* @__PURE__ */ s("li", { children: "factors introduced by past planning approvals or existing permit applications" }),
      /* @__PURE__ */ s("li", { children: "other approvals that may be required, such as building and asset protection permits." })
    ] }),
    /* @__PURE__ */ R("p", { children: [
      "This list is not exhaustive. The information provided by this service is intended as a helpful guide and is not a final planning decision.",
      " ",
      /* @__PURE__ */ s(
        "a",
        {
          className: "text-textLink hover:text-textLinkHover inline-flex cursor-pointer underline",
          href: n,
          rel: "noreferrer",
          tabIndex: 0,
          target: "_blank",
          children: "Contact council"
        }
      ),
      " ",
      "to talk to a planner if you’re unsure about anything."
    ] })
  ] });
}
const FK = {
  [de.NoPermitRequired]: {
    text: "text-successHover",
    border: "!border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [de.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "!border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [de.RequiresPermit]: {
    text: "text-warningHover",
    border: "!border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [de.Prohibited]: {
    text: "text-destructiveHover",
    border: "!border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function IZ({
  conversation: e,
  expertMap: t,
  noticeboardData: n
}) {
  const [r, o] = ne({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), { getLocalisationEntry: i } = sr(e), l = i("councilOrdinanceLink"), c = yo(e, n);
  Oe(() => {
    c && ["1", "2", "3", "4"].includes(c.toString()) ? o(FK[c.toString()]) : o({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [c, e == null ? void 0 : e.phase]);
  const f = () => {
    let C = "";
    return e != null && e.created_at && (C = new Intl.DateTimeFormat("en-AU", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit"
    }).format(new Date(e.created_at))), C;
  }, p = () => {
    let C = "";
    return e != null && e.updated_at && (C = new Intl.DateTimeFormat("en-AU", {
      hour: "numeric",
      minute: "2-digit"
    }).format(new Date(e.updated_at))), C;
  }, m = () => {
    switch (c) {
      case de.NoPermitRequired:
        return /* @__PURE__ */ R(le, { children: [
          /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why your proposal likely doesn’t require a planning permit." }),
          /* @__PURE__ */ R(nr, { defaultValue: "summary", children: [
            /* @__PURE__ */ R(Fn, { className: "pb-3", children: [
              /* @__PURE__ */ R(
                bt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "summary",
                  children: [
                    /* @__PURE__ */ s(ro, {}),
                    " Full assessment"
                  ]
                }
              ),
              /* @__PURE__ */ R(
                bt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "easy-read",
                  children: [
                    /* @__PURE__ */ s(oo, {}),
                    " Easy read"
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ s(gt, { value: "summary", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: Be(
              tr(t, n),
              { ordinanceLink: l }
            ) }) }),
            /* @__PURE__ */ s(gt, { value: "easy-read", className: "", children: /* @__PURE__ */ s("div", { children: v() }) })
          ] })
        ] });
      case de.MoreInformationRequired:
        return /* @__PURE__ */ R(le, { children: [
          /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why your proposal may or may not need a planning permit." }),
          /* @__PURE__ */ R(nr, { defaultValue: "summary", children: [
            /* @__PURE__ */ R(Fn, { className: "pb-3 w-full items-stretch", children: [
              /* @__PURE__ */ R(
                bt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "summary",
                  children: [
                    /* @__PURE__ */ s(ro, {}),
                    " Full assessment"
                  ]
                }
              ),
              /* @__PURE__ */ R(
                bt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "easy-read",
                  children: [
                    /* @__PURE__ */ s(oo, {}),
                    " Easy read"
                  ]
                }
              ),
              /* @__PURE__ */ s("div", { className: "w-full border-b" })
            ] }),
            /* @__PURE__ */ s(gt, { value: "summary", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: Be(
              tr(t, n),
              { ordinanceLink: l }
            ) }) }),
            /* @__PURE__ */ s(gt, { value: "easy-read", className: "", children: /* @__PURE__ */ s("div", { children: v() }) })
          ] }),
          /* @__PURE__ */ s(
            "div",
            {
              className: F(
                "w-full border-b my-6",
                r.border
              )
            }
          ),
          /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary mb-5", children: "Application requirements" }),
          /* @__PURE__ */ s(
            q2,
            {
              expertMap: t,
              noticeboardData: n,
              ordinanceLink: l
            }
          ),
          /* @__PURE__ */ s("div", { className: "mt-4", children: /* @__PURE__ */ s(
            z2,
            {
              expertMap: t,
              noticeboardData: n,
              ordinanceLink: l
            }
          ) })
        ] });
      case de.RequiresPermit:
        return /* @__PURE__ */ R(le, { children: [
          /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why it’s likely your proposal requires a planning permit." }),
          /* @__PURE__ */ R(nr, { defaultValue: "summary", children: [
            /* @__PURE__ */ R(Fn, { className: "pb-3 w-full items-stretch", children: [
              /* @__PURE__ */ R(
                bt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "summary",
                  children: [
                    /* @__PURE__ */ s(ro, {}),
                    " Full assessment"
                  ]
                }
              ),
              /* @__PURE__ */ R(
                bt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "easy-read",
                  children: [
                    /* @__PURE__ */ s(oo, {}),
                    " Easy read"
                  ]
                }
              ),
              /* @__PURE__ */ s("div", { className: "w-full border-b" })
            ] }),
            /* @__PURE__ */ s(gt, { value: "summary", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: Be(
              tr(t, n),
              { ordinanceLink: l }
            ) }) }),
            /* @__PURE__ */ s(gt, { value: "easy-read", className: "", children: /* @__PURE__ */ s("div", { children: v() }) })
          ] }),
          /* @__PURE__ */ s(
            "div",
            {
              className: F(
                "w-full border-b my-6",
                r.border
              )
            }
          ),
          /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary mb-5", children: "Application requirements" }),
          /* @__PURE__ */ s(
            q2,
            {
              expertMap: t,
              noticeboardData: n,
              ordinanceLink: l
            }
          ),
          /* @__PURE__ */ s("div", { className: "mt-4", children: /* @__PURE__ */ s(
            z2,
            {
              expertMap: t,
              noticeboardData: n,
              ordinanceLink: l
            }
          ) })
        ] });
      case de.Prohibited:
        return /* @__PURE__ */ R(le, { children: [
          /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary", children: "Why your proposal is likely prohibited" }),
          /* @__PURE__ */ s(qe, { maxHeight: 300, children: Be(
            tr(t, n),
            { ordinanceLink: l }
          ) })
        ] });
    }
  }, v = () => {
    var h, b, w, N, _, P;
    const { expert_name: C = "", output_key: x = "" } = (t == null ? void 0 : t.easy_read_report) || {};
    let y = "";
    return (b = (h = n == null ? void 0 : n[C]) == null ? void 0 : h.parsed_output) != null && b[x] ? y = (N = (w = n == null ? void 0 : n[C]) == null ? void 0 : w.parsed_output) == null ? void 0 : N[x] : (_ = n == null ? void 0 : n[C]) != null && _.raw_output && (y = (P = n == null ? void 0 : n[C]) == null ? void 0 : P.raw_output), /* @__PURE__ */ s("div", { children: Be(y, { ordinanceLink: l }) });
  };
  return /* @__PURE__ */ R("div", { "data-testid": "assessment-report", children: [
    /* @__PURE__ */ R(
      "div",
      {
        className: F(
          "content-start justify-start rounded-t-lg border-x border-t p-5 md:px-10 md:pb-6 md:pt-8",
          r.border,
          r.bgLight
        ),
        children: [
          /* @__PURE__ */ s("div", { className: "mb-2 inline-flex", children: /* @__PURE__ */ s(
            "h2",
            {
              className: `text-[28px] font-semibold leading-8 ${r.text}`,
              children: Ca(t, n)
            }
          ) }),
          /* @__PURE__ */ R("p", { className: "mb-2 text-bodysm", children: [
            "Generated at ",
            p(),
            " on ",
            f()
          ] })
        ]
      }
    ),
    /* @__PURE__ */ R(
      "div",
      {
        className: F(
          "border-interactiveBorder flex flex-col bg-interfaceWhite px-5 py-4 md:px-10 md:py-8 border rounded-b-lg",
          r.border
        ),
        children: [
          m(),
          /* @__PURE__ */ s(
            "div",
            {
              className: F("w-full border-b my-6", r.border)
            }
          ),
          /* @__PURE__ */ s(hb, { conversation: e })
        ]
      }
    )
  ] });
}
function x1({
  title: e,
  content: t
}) {
  const [n, r] = ne(!1);
  return /* @__PURE__ */ s(
    hi,
    {
      type: "single",
      value: n ? "application_requirements" : "",
      children: /* @__PURE__ */ R(
        co,
        {
          className: "border border-interactiveBorder rounded p-1",
          value: "application_requirements",
          children: [
            /* @__PURE__ */ s(
              uo,
              {
                className: "text-headingmd px-2 py-1",
                onClick: () => r((o) => !o),
                children: e
              }
            ),
            /* @__PURE__ */ s(fo, { className: "px-2", children: t })
          ]
        }
      )
    }
  );
}
function K2({
  assessmentLights: e,
  expertMap: t,
  noticeboardData: n,
  ordinanceLink: r
}) {
  const o = kl(
    t,
    n
  ), i = Ol(t, n), l = l3(t, n), c = o === void 0 || !i;
  return /* @__PURE__ */ R(le, { children: [
    /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary mb-1", children: "VicSmart eligibility" }),
    /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-5", children: "VicSmart is a faster approval process for straightforward planning applications. If your proposal requires a planning permit and meets certain criteria, you may be able to apply with VicSmart." }),
    c ? /* @__PURE__ */ R("div", { className: "mb-2 items-center flex gap-1", children: [
      /* @__PURE__ */ s(So, { className: "animate-spin min-h-5 min-w-5" }),
      /* @__PURE__ */ s("span", { className: "text-bodymd text-textPrimary", children: "Assessing VicSmart eligibility" })
    ] }) : null,
    c ? null : /* @__PURE__ */ s("div", { className: "mb-2", children: /* @__PURE__ */ s(N1, { eligibility: o }) }),
    !c && o === Ir.eligible ? /* @__PURE__ */ R(le, { children: [
      /* @__PURE__ */ s(qe, { children: Be(i, {
        ordinanceLink: r
      }) }),
      l ? /* @__PURE__ */ s("div", { className: "mt-4", children: /* @__PURE__ */ s(
        x1,
        {
          title: "Preparing your VicSmart application",
          content: /* @__PURE__ */ R(le, { children: [
            e === de.MoreInformationRequired ? /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued", children: "If you’ve determined your proposal requires a planning permit and that it’s eligible for VicSmart, use this checklist as a starting point for what information is likely required in your application." }) : null,
            e === de.RequiresPermit ? /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued", children: "If you’ve determined your proposal is eligible for VicSmart and you’re ready to apply, use this checklist as a starting point for what information is likely required when you apply." }) : null,
            /* @__PURE__ */ s(ga, { className: "border-interactiveBorder my-3" }),
            /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued", children: Be(l, {
              ordinanceLink: r
            }) })
          ] })
        }
      ) }) : null
    ] }) : null,
    !c && o !== Ir.eligible ? /* @__PURE__ */ s("p", { className: "text-bodymd text-textPrimary", children: "Your proposal is likely ineligible for VicSmart because it doesn't meet the criteria, or you’ve triggered a planning requirement that has no associated VicSmart approval pathway." }) : null
  ] });
}
const BK = {
  [de.NoPermitRequired]: {
    text: "text-successHover",
    border: "!border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [de.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "!border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [de.RequiresPermit]: {
    text: "text-warningHover",
    border: "!border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [de.Prohibited]: {
    text: "text-destructiveHover",
    border: "!border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function OZ({
  conversation: e,
  expertMap: t,
  noticeboardData: n
}) {
  const [r, o] = ne({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), { getLocalisationEntry: i } = sr(e), l = i("councilOrdinanceLink"), c = yo(e, n);
  Oe(() => {
    c && ["1", "2", "3", "4"].includes(c.toString()) ? o(BK[c.toString()]) : o({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [c, e == null ? void 0 : e.phase]);
  const f = () => {
    let v = "";
    return e != null && e.created_at && (v = new Intl.DateTimeFormat("en-AU", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit"
    }).format(new Date(e.created_at))), v;
  }, p = () => {
    let v = "";
    return e != null && e.updated_at && (v = new Intl.DateTimeFormat("en-AU", {
      hour: "numeric",
      minute: "2-digit"
    }).format(new Date(e.updated_at))), v;
  }, m = () => {
    const v = aa(
      t,
      n
    ), C = Ml(
      t,
      n
    ), x = Il(
      t,
      n
    );
    switch (c) {
      case de.NoPermitRequired:
        return /* @__PURE__ */ R(le, { children: [
          /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why your proposal likely doesn’t require a planning permit." }),
          /* @__PURE__ */ s(qe, { maxHeight: 300, children: Be(
            tr(t, n),
            { ordinanceLink: l }
          ) }),
          C && x ? /* @__PURE__ */ R(le, { children: [
            /* @__PURE__ */ s(
              "div",
              {
                className: F(
                  "w-full border-b my-6",
                  r.border
                )
              }
            ),
            /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-5", children: "Even though your proposal likely doesn’t require a planning permit, it still likely needs to meet the following requirements for it to be permissible." }),
            /* @__PURE__ */ s(qe, { children: Be(x, {
              ordinanceLink: l
            }) })
          ] }) : null
        ] });
      case de.MoreInformationRequired:
        return /* @__PURE__ */ R(le, { children: [
          /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why your proposal may or may not need a planning permit." }),
          /* @__PURE__ */ s(qe, { maxHeight: 300, children: Be(
            tr(t, n),
            { ordinanceLink: l }
          ) }),
          v ? /* @__PURE__ */ s("div", { className: "mt-4", children: /* @__PURE__ */ s(
            x1,
            {
              title: "Preparing your planning permit application",
              content: /* @__PURE__ */ R(le, { children: [
                /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued", children: "If you’ve determined your proposal requires a planning permit and you’re ready to apply, use this checklist as a starting point for what information is likely required as part of your application." }),
                /* @__PURE__ */ s(ga, { className: "border-interactiveBorder my-3" }),
                /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued", children: Be(v, {
                  ordinanceLink: l
                }) })
              ] })
            }
          ) }) : null,
          C && x ? /* @__PURE__ */ R(le, { children: [
            /* @__PURE__ */ s(
              "div",
              {
                className: F(
                  "w-full border-b my-6",
                  r.border
                )
              }
            ),
            /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-5", children: "Regardless of whether your proposal requires a planning permit or not, it will also likely need to meet the following requirements for it to be permissible." }),
            /* @__PURE__ */ s(qe, { children: Be(x, {
              ordinanceLink: l
            }) })
          ] }) : null,
          pl(t) ? /* @__PURE__ */ R(le, { children: [
            /* @__PURE__ */ s(
              "div",
              {
                className: F(
                  "w-full border-b my-6",
                  r.border
                )
              }
            ),
            /* @__PURE__ */ s(
              K2,
              {
                assessmentLights: c,
                expertMap: t,
                noticeboardData: n,
                ordinanceLink: l
              }
            )
          ] }) : null
        ] });
      case de.RequiresPermit:
        return /* @__PURE__ */ R(le, { children: [
          /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why it’s likely your proposal requires a planning permit." }),
          /* @__PURE__ */ s(qe, { maxHeight: 300, children: Be(
            tr(t, n),
            { ordinanceLink: l }
          ) }),
          v ? /* @__PURE__ */ s("div", { className: "mt-4", children: /* @__PURE__ */ s(
            x1,
            {
              title: "Preparing your planning permit application",
              content: /* @__PURE__ */ R(le, { children: [
                /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued", children: "If you’re ready to apply for a planning permit, use this checklist as a starting point for what information is likely required as part of your application." }),
                /* @__PURE__ */ s(ga, { className: "border-interactiveBorder my-3" }),
                /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued", children: Be(v, {
                  ordinanceLink: l
                }) })
              ] })
            }
          ) }) : null,
          C && x ? /* @__PURE__ */ R(le, { children: [
            /* @__PURE__ */ s(
              "div",
              {
                className: F(
                  "w-full border-b my-6",
                  r.border
                )
              }
            ),
            /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued mb-5", children: "Regardless of whether your proposal requires a planning permit or not, it will also likely need to meet the following requirements for it to be permissible." }),
            /* @__PURE__ */ s(qe, { children: Be(x, {
              ordinanceLink: l
            }) })
          ] }) : null,
          pl(t) ? /* @__PURE__ */ R(le, { children: [
            /* @__PURE__ */ s(
              "div",
              {
                className: F(
                  "w-full border-b my-6",
                  r.border
                )
              }
            ),
            /* @__PURE__ */ s(
              K2,
              {
                assessmentLights: c,
                expertMap: t,
                noticeboardData: n,
                ordinanceLink: l
              }
            )
          ] }) : null
        ] });
      case de.Prohibited:
        return /* @__PURE__ */ R(le, { children: [
          /* @__PURE__ */ s("h2", { className: "text-headinglg text-textPrimary", children: "Why your proposal is likely prohibited" }),
          /* @__PURE__ */ s(qe, { maxHeight: 300, children: Be(
            tr(t, n),
            { ordinanceLink: l }
          ) })
        ] });
    }
  };
  return /* @__PURE__ */ R("div", { "data-testid": "assessment-report", children: [
    /* @__PURE__ */ R(
      "div",
      {
        className: F(
          "content-start justify-start rounded-t-lg border-x border-t p-5 md:px-10 md:pb-6 md:pt-8",
          r.border,
          r.bgLight
        ),
        children: [
          /* @__PURE__ */ s("div", { className: "mb-2 inline-flex", children: /* @__PURE__ */ s(
            "h2",
            {
              className: `text-[28px] font-semibold leading-8 ${r.text}`,
              children: Ca(t, n)
            }
          ) }),
          /* @__PURE__ */ R("p", { className: "mb-2 text-bodysm", children: [
            "Generated at ",
            p(),
            " on ",
            f()
          ] })
        ]
      }
    ),
    /* @__PURE__ */ R(
      "div",
      {
        className: F(
          "border-interactiveBorder flex flex-col bg-interfaceWhite px-5 py-4 md:px-10 md:py-8 border rounded-b-lg",
          r.border
        ),
        children: [
          m(),
          /* @__PURE__ */ s(
            "div",
            {
              className: F("w-full border-b my-6", r.border)
            }
          ),
          /* @__PURE__ */ s(hb, { conversation: e })
        ]
      }
    )
  ] });
}
function kZ() {
  return /* @__PURE__ */ R("div", { className: "rounded-lg border border-interfaceBorder bg-interfaceWhite flex flex-col", children: [
    /* @__PURE__ */ s("div", { className: "rounded-t-lg bg-interfaceBgLight border-b border-interfaceBorder flex items-center justify-center px-10 py-8", children: /* @__PURE__ */ s("h2", { className: "text-[28px] font-semibold leading-[32px] text-textSubdued", children: "A report hasn’t been generated for this conversation yet." }) }),
    /* @__PURE__ */ s("div", { className: "rounded-b-lg bg-interfaceWhite flex items-center justify-center px-10 py-8", children: /* @__PURE__ */ s("p", { className: "text-lg leading-[22px] font-normal text-textSubdued", children: "A report is generated after the customer has answered all the questions in the chat. Once the customer has done this, allow 2–3 minutes for myLot to generate the report." }) })
  ] });
}
const VK = {
  [de.NoPermitRequired]: {
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [de.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [de.RequiresPermit]: {
    text: "text-warningHover",
    border: "border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [de.Prohibited]: {
    text: "text-destructiveHover",
    border: "border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function DZ({
  conversation: e,
  expertMap: t,
  noticeboardData: n
}) {
  const [r, o] = ne({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), { getLocalisationEntry: i } = sr(e), l = i("councilOrdinanceLink"), c = yo(e, n);
  Oe(() => {
    c && ["1", "2", "3", "4"].includes(c.toString()) ? o(VK[c.toString()]) : o({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [c, e == null ? void 0 : e.phase]);
  const f = () => {
    const x = s3(t, n);
    if (x)
      return /* @__PURE__ */ s("div", { className: "text-bodylg text-textPrimary mb-1", children: Be(x, { ordinanceLink: l }) });
  }, p = () => {
    const x = Ml(
      t,
      n
    ), y = Il(
      t,
      n
    );
    if (x && y)
      return /* @__PURE__ */ R(le, { children: [
        /* @__PURE__ */ s("div", { className: F("w-full border-b", r.border) }),
        /* @__PURE__ */ s(hi, { collapsible: !0, type: "single", children: /* @__PURE__ */ R(
          co,
          {
            className: "border-b-0",
            value: "mandatory-requirements",
            children: [
              /* @__PURE__ */ s(uo, { className: "!py-0", children: /* @__PURE__ */ R("div", { className: "text-left", children: [
                /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary", children: "Mandatory requirements" }),
                /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued", children: "Check your proposal complies with these requirements or it won’t be accepted." })
              ] }) }),
              /* @__PURE__ */ s(fo, { className: "!pb-0 pt-5", children: Be(y, {
                ordinanceLink: l
              }) })
            ]
          }
        ) })
      ] });
  }, m = () => /* @__PURE__ */ s("div", { className: "flex flex-col gap-5", children: [
    {
      expert_name: "landuse_report",
      title: "Land use"
    },
    {
      expert_name: "zone_works_report",
      title: "Buildings and works"
    },
    {
      expert_name: "provisions_assessor_report",
      title: "Particular provisions"
    },
    {
      expert_name: "bmo_overlay_report",
      title: "Bushfire Management Overlay"
    },
    {
      expert_name: "ddo_overlay_report",
      title: "Design and Development Overlay"
    },
    {
      expert_name: "emo_overlay_report",
      title: "Erosion Management Overlay"
    },
    {
      expert_name: "eso_overlay_report",
      title: "Environmental Significance Overlay"
    },
    {
      expert_name: "ho_overlay_report",
      title: "Heritage Overlay"
    },
    {
      expert_name: "lsio_overlay_report",
      title: "Land Subject to Inundation Overlay"
    },
    {
      expert_name: "sbo_overlay_report",
      title: "Special Building Overlay"
    },
    {
      expert_name: "slo_overlay_report",
      title: "Significant Landscape Overlay"
    },
    {
      expert_name: "vpo_overlay_report",
      title: "Vegetation Protection Overlay"
    },
    {
      expert_name: "tree_policy_assessor",
      title: "Local policies"
    }
  ].map((y, h) => {
    var P, A, I, T, M, D;
    const { expert_name: b = "", output_key: w = "", title: N } = y;
    let _ = "";
    return w && ((A = (P = n == null ? void 0 : n[b]) == null ? void 0 : P.parsed_output) != null && A[w]) ? _ = (T = (I = n == null ? void 0 : n[b]) == null ? void 0 : I.parsed_output) == null ? void 0 : T[w] : (M = n == null ? void 0 : n[b]) != null && M.raw_output && (_ = (D = n == null ? void 0 : n[b]) == null ? void 0 : D.raw_output), !_ || _.trim().toLowerCase().startsWith("no content") || /^no (.+) at this address/.test(_.trim().toLowerCase()) ? null : /* @__PURE__ */ R("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ s("h3", { className: "text-headingsm text-textPrimary", children: N }),
      Be(_, {
        components: {
          h1({ children: W }) {
            return /* @__PURE__ */ s("h4", { className: "text-headingsm", children: W });
          },
          h2({ children: W }) {
            return /* @__PURE__ */ s("h4", { className: "text-headingsm", children: W });
          },
          h3({ children: W }) {
            return /* @__PURE__ */ s("h4", { className: "text-headingsm", children: W });
          },
          h4({ children: W }) {
            return /* @__PURE__ */ s("h4", { className: "text-headingsm", children: W });
          }
        },
        ordinanceLink: l
      })
    ] }, h);
  }) }), v = () => /* @__PURE__ */ R(le, { children: [
    /* @__PURE__ */ s("div", { className: F("w-full border-b", r.border) }),
    /* @__PURE__ */ s(hi, { collapsible: !0, type: "single", children: /* @__PURE__ */ R(co, { className: "border-b-0", value: "detailed-analysis", children: [
      /* @__PURE__ */ s(uo, { className: "!py-0", children: /* @__PURE__ */ R("div", { className: "text-left", children: [
        /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary", children: "Detailed analysis" }),
        /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued", children: "Breakdown by the zone, overlays, and other controls relevant to your proposal." })
      ] }) }),
      /* @__PURE__ */ s(fo, { className: "!pb-0 pt-5", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: m() }) })
    ] }) })
  ] }), C = () => {
    switch (c) {
      case de.NoPermitRequired:
        return /* @__PURE__ */ R("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ R("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary", children: "Why your proposal likely doesn’t require a planning permit." }),
            f()
          ] }),
          p(),
          v()
        ] });
      case de.MoreInformationRequired:
        return /* @__PURE__ */ R("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ R("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary", children: "Why a planning permit could be required" }),
            f()
          ] }),
          p(),
          v()
        ] });
      case de.RequiresPermit:
        return /* @__PURE__ */ R("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ R("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary", children: "Why a permit is likely required" }),
            f()
          ] }),
          p(),
          v()
        ] });
      case de.Prohibited:
        return /* @__PURE__ */ s("div", { className: "flex flex-col gap-6", children: /* @__PURE__ */ R("div", { className: "flex flex-col gap-1", children: [
          /* @__PURE__ */ s("h2", { className: "text-headingmd text-textPrimary", children: "Why your proposal is likely prohibited" }),
          f()
        ] }) });
    }
  };
  return /* @__PURE__ */ R(
    "div",
    {
      className: F(
        "rounded-lg border border-l-[12px] p-5 md:p-8 flex flex-col gap-6",
        r.border,
        r.bgLight
      ),
      "data-testid": "assessment-report",
      children: [
        /* @__PURE__ */ s("h2", { className: "text-[32px] font-medium leading-[38px] text-textPrimary", children: Ca(t, n) }),
        C()
      ]
    }
  );
}
const Y2 = {
  [de.NoPermitRequired]: {
    text: "text-textPrimary",
    border: "border-interactiveBorder",
    bgLight: "bg-interfaceBgLight",
    bgDark: "bg-interfaceBgDefault"
  },
  [de.MoreInformationRequired]: {
    text: "text-textPrimary",
    border: "border-interactiveBorder",
    bgLight: "bg-interfaceBgLight",
    bgDark: "bg-interfaceBgDefault"
  },
  [`${de.RequiresPermit}Standard`]: {
    text: "text-actionDefault",
    border: "border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [`${de.RequiresPermit}VicSmart`]: {
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [de.Prohibited]: {
    text: "text-textPrimary",
    border: "border-interactiveBorder",
    bgLight: "bg-interfaceBgLight",
    bgDark: "bg-interfaceBgDefault"
  }
};
function FZ({
  conversation: e,
  expertMap: t,
  noticeboardData: n,
  onClickAnswerQuestions: r,
  publicView: o = !1
}) {
  const [i, l] = ne({
    text: "text-textPrimary",
    border: "border-interactiveBorder",
    bgLight: "bg-interfaceBgLight",
    bgDark: "bg-interfaceBgDefault"
  }), { getLocalisationEntry: c } = sr(e), f = c("councilOrdinanceLink"), p = sP({
    conversation: e,
    noticeboardData: n
  }), m = yo(e, n), v = kl(
    t,
    n
  ), C = pl(t), x = v === Ir.eligible;
  Oe(() => {
    m && ["1", "2", "4"].includes(m.toString()) ? l(Y2[m.toString()]) : m.toString() === de.RequiresPermit ? l(
      Y2[`${de.RequiresPermit}${C && x ? "VicSmart" : "Standard"}`]
    ) : l({
      text: "text-textPrimary",
      border: "border-interactiveBorder",
      bgLight: "bg-interfaceBgLight",
      bgDark: "bg-interfaceBgDefault"
    });
  }, [m, e, x, C]);
  const y = (N) => Be(N, {
    components: {
      h1({ children: _ }) {
        return /* @__PURE__ */ s("h5", { className: "text-base font-bold", children: _ });
      },
      h2({ children: _ }) {
        return /* @__PURE__ */ s("h5", { className: "text-base font-bold", children: _ });
      },
      h3({ children: _ }) {
        return /* @__PURE__ */ s("h5", { className: "text-base font-bold", children: _ });
      },
      h4({ children: _ }) {
        return /* @__PURE__ */ s("h5", { className: "text-base font-bold", children: _ });
      }
    },
    ordinanceLink: f
  }), h = () => {
    const N = l3(t, n), _ = aa(
      t,
      n
    );
    return /* @__PURE__ */ R(nr, { defaultValue: "vicsmart", children: [
      /* @__PURE__ */ R(Fn, { className: "pb-3", children: [
        /* @__PURE__ */ s(
          bt,
          {
            className: F(
              "data-[state=active]:text-textPrimary flex gap-1 !bg-transparent px-2",
              "border-successBorder data-[state=active]:border-successBorder"
            ),
            value: "vicsmart",
            children: "VicSmart requirements"
          }
        ),
        /* @__PURE__ */ s(
          bt,
          {
            className: F(
              "data-[state=active]:text-textPrimary flex gap-1 !bg-transparent px-2",
              "border-successBorder data-[state=active]:border-successBorder"
            ),
            value: "standard",
            children: "Standard requirements"
          }
        )
      ] }),
      /* @__PURE__ */ s(gt, { value: "vicsmart", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: y(N) }) }),
      /* @__PURE__ */ s(gt, { value: "standard", children: /* @__PURE__ */ s(qe, { maxHeight: 300, children: y(_) }) })
    ] });
  }, b = () => {
    const N = aa(
      t,
      n
    );
    return /* @__PURE__ */ s(le, { children: y(N) });
  }, w = () => {
    switch (m) {
      case de.NoPermitRequired:
        return /* @__PURE__ */ R("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ s("h2", { className: "text-headingxl text-textPrimary", children: "No application requirements are relevant to your proposal" }),
          /* @__PURE__ */ s("p", { className: "text-bodylg text-textPrimary mb-1", children: "Your proposal likely doesn’t require a planning permit, so no application requirements have been generated." }),
          /* @__PURE__ */ s("p", { className: "text-bodylg text-textPrimary", children: "However, you may still require other permits, such as a building permit. Building permits are issued separately from planning permits and are required to ensure construction work complies with national building regulations." }),
          /* @__PURE__ */ R(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover flex cursor-pointer gap-1 underline",
              href: c("councilPlanningPermitChecklistLink"),
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: [
                "Check if you need a building permit ",
                /* @__PURE__ */ s(vP, {})
              ]
            }
          )
        ] });
      case de.MoreInformationRequired:
        return /* @__PURE__ */ R("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ s("h2", { className: "text-headingxl text-textPrimary", children: "We can’t determine your application requirements yet" }),
          /* @__PURE__ */ R("p", { className: "text-bodylg text-textPrimary", children: [
            "There are ",
            p == null ? void 0 : p.length,
            " outstanding questions about your lot and proposal that you need to answer before we can determine your proposal’s approval pathway and application requirements."
          ] }),
          o ? null : /* @__PURE__ */ R(
            ct,
            {
              className: "w-min",
              onClick: r,
              variant: "link",
              children: [
                /* @__PURE__ */ s(bP, {}),
                "Answer questions"
              ]
            }
          )
        ] });
      case de.RequiresPermit: {
        const N = Ol(
          t,
          n
        );
        return C && x ? /* @__PURE__ */ R("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ s("h2", { className: "text-headingxl text-textPrimary", children: "You may be able to apply for a planning permit with VicSmart" }),
          /* @__PURE__ */ s(qe, { className: "mt-2", children: y(N) }),
          /* @__PURE__ */ s(
            "div",
            {
              className: F(
                "my-2 w-full border-b md:my-2.5",
                i.border
              )
            }
          ),
          /* @__PURE__ */ R("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ s("h3", { className: "text-headinglg text-textPrimary", children: "What you’ll need to provide when you apply" }),
            /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued", children: "This list should be used as a guide only. Always speak to a Council planner before preparing a planning permit application." })
          ] }),
          h()
        ] }) : /* @__PURE__ */ R("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ s("h2", { className: "text-headingxl text-textPrimary", children: "You likely need to apply through the standard planning permit approval pathway" }),
          /* @__PURE__ */ s(qe, { className: "mt-2", children: y(N) }),
          /* @__PURE__ */ s(
            "div",
            {
              className: F(
                "my-2 my-2.5 w-full border-b",
                i.border
              )
            }
          ),
          /* @__PURE__ */ R("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ s("h3", { className: "text-headinglg text-textPrimary", children: "What you’ll need to provide when you apply" }),
            /* @__PURE__ */ s("p", { className: "text-bodymd text-textSubdued", children: "This list should be used as a guide only. Always speak to a Council planner before preparing a planning permit application." })
          ] }),
          b()
        ] });
      }
      case de.Prohibited:
        return /* @__PURE__ */ R("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ s("h2", { className: "text-headingxl text-textPrimary", children: "We haven’t generated application requirements because your proposal is likely prohibited" }),
          /* @__PURE__ */ s("p", { className: "text-bodylg text-textPrimary", children: "Based on our analysis of your responses, it’s likely your proposal is prohibited. We don’t recommend applying for a planning permit because it’s unlikely Council will support your proposal." }),
          /* @__PURE__ */ R("p", { className: "text-bodylg text-textPrimary", children: [
            "If you have questions about your result,",
            " ",
            /* @__PURE__ */ s(
              "a",
              {
                className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                href: c("councilContactLink"),
                rel: "noreferrer",
                tabIndex: 0,
                target: "_blank",
                children: "contact Council"
              }
            ),
            " ",
            "to talk to one of our planners."
          ] })
        ] });
    }
  };
  return /* @__PURE__ */ s(
    "div",
    {
      className: F(
        "flex flex-col gap-6 rounded-lg border border-l-[12px] p-5 md:p-8",
        i.border,
        i.bgLight
      ),
      "data-testid": "assessment-report",
      children: w()
    }
  );
}
function WK({
  filter: e,
  filterDescriptor: t,
  onChangeFilter: n,
  renderingInHeader: r
}) {
  const o = gn(() => !e || (e == null ? void 0 : e.length) === 0 ? t.options.filter((i) => i.value === "") : t.options.filter(
    (i) => e.includes(i.value)
  ), [e, t]);
  return /* @__PURE__ */ R(
    "div",
    {
      className: F(
        "flex flex-col",
        r ? t.headerClassName : null
      ),
      children: [
        r ? null : /* @__PURE__ */ s(nt, { className: "text-headingsm text-textPrimary", children: t.label }),
        /* @__PURE__ */ s(
          W7,
          {
            allowMultiSelect: !t.singleSelect,
            className: F(
              "text-base leading-5 text-textSubdued border-interactiveBorder",
              (e == null ? void 0 : e.length) === 1 && e[0] !== "" ? "text-textPrimary border-interactiveBorderSelect" : "",
              (e == null ? void 0 : e.length) > 1 ? "text-textPrimary border-interactiveBorderSelect" : ""
            ),
            filter: (i, l, c) => {
              var f;
              return (f = c == null ? void 0 : c[0]) != null && f.includes(l.toLowerCase()) ? 1 : 0;
            },
            hideHeader: !r,
            hideSearch: !0,
            options: t.options,
            onChange: (i) => {
              i.length > 0 ? n(i.map((l) => l.value)) : n([]);
            },
            renderInline: !r,
            values: o
          }
        )
      ]
    }
  );
}
function HK({
  filter: e,
  filterDescriptor: t,
  onChangeFilter: n,
  renderingInHeader: r
}) {
  const o = gn(() => !e || (e == null ? void 0 : e.length) === 0 ? t.options.filter((i) => i.value === "") : t.options.filter(
    (i) => e.includes(i.value)
  ), [e, t]);
  return /* @__PURE__ */ R(
    "div",
    {
      className: F(
        "flex flex-col gap-1",
        r ? t.headerClassName : null
      ),
      children: [
        r ? null : /* @__PURE__ */ s(nt, { className: "text-headingsm text-textPrimary", children: t.label }),
        /* @__PURE__ */ s(
          W7,
          {
            allowMultiSelect: !t.singleSelect,
            className: F(
              "text-base leading-5 text-textSubdued border-interactiveBorder",
              (e == null ? void 0 : e.length) === 1 && e[0] !== "" ? "text-textPrimary border-interactiveBorderSelect" : "",
              (e == null ? void 0 : e.length) > 1 ? "text-textPrimary border-interactiveBorderSelect" : ""
            ),
            filter: (i, l, c) => {
              var f;
              return (f = c == null ? void 0 : c[0]) != null && f.includes(l.toLowerCase()) ? 1 : 0;
            },
            options: t.options,
            onChange: (i) => {
              i.length > 0 ? n(i.map((l) => l.value)) : n([]);
            },
            placeholder: t.placeholder,
            values: o
          }
        )
      ]
    }
  );
}
function UK({
  filter: e,
  filterDescriptor: t,
  onChangeFilter: n,
  renderingInHeader: r
}) {
  return /* @__PURE__ */ R(
    "div",
    {
      className: F(
        "flex flex-col gap-1",
        r ? t.headerClassName : ""
      ),
      children: [
        r ? null : /* @__PURE__ */ s(nt, { className: "text-headingsm text-textPrimary", children: t.label }),
        /* @__PURE__ */ s(
          Ep,
          {
            className: F(
              "placeholder:text-textSubdued text-textPrimary focus:border-interactiveBorderSelect text-bodysm",
              e ? "border-interactiveBorderSelect" : "!border-interactiveBorder"
            ),
            onChange: (o) => {
              n(o.target.value);
            },
            placeholder: t.placeholder,
            value: e ?? ""
          }
        )
      ]
    }
  );
}
function BZ({
  filters: e,
  filterDescriptors: t,
  onChangeFilter: n,
  onClearFilters: r
}) {
  const [o, i] = ne(!1), l = Je(null);
  Oe(() => {
    o && l.current && l.current.scroll({ top: 0, behavior: "instant" });
  }, [o]);
  const c = gn(() => Object.values(e).filter((C) => typeof C == "string" ? C.length > 0 : Array.isArray(C) && C.length === 1 && C[0] !== "" ? !0 : Array.isArray(C) && C.length > 1).length, [e]), f = (C) => {
    n(C);
  }, p = (C, x) => {
    switch (C.type) {
      case sf.OPTIONS:
        return /* @__PURE__ */ s(
          WK,
          {
            filter: e[C.key],
            filterDescriptor: C,
            onChangeFilter: (y) => {
              f({
                ...e,
                [C.key]: y
              });
            },
            renderingInHeader: x
          }
        );
      case sf.SEARCHABLE_OPTIONS:
        return /* @__PURE__ */ s(
          HK,
          {
            filter: e[C.key],
            filterDescriptor: C,
            onChangeFilter: (y) => {
              f({
                ...e,
                [C.key]: y
              });
            },
            renderingInHeader: x
          }
        );
      case sf.STRING:
        return /* @__PURE__ */ s(
          UK,
          {
            filter: e[C.key],
            filterDescriptor: C,
            onChangeFilter: (y) => {
              f({
                ...e,
                [C.key]: y
              });
            },
            renderingInHeader: x
          }
        );
    }
  }, m = () => t.filter(
    (x) => x.alwaysShow
  ).map((x) => /* @__PURE__ */ s(ia, { children: p(x, !0) }, x.key)), v = () => t.map((C) => /* @__PURE__ */ s(ia, { children: p(C) }, C.key));
  return /* @__PURE__ */ R("div", { className: "flex gap-3 grow flex-wrap", children: [
    m(),
    /* @__PURE__ */ R(wC, { onOpenChange: i, children: [
      /* @__PURE__ */ s(BG, { asChild: !0, children: /* @__PURE__ */ R(
        ct,
        {
          className: F(
            "text-textPrimary !rounded !border-interactiveBorder",
            c === 0 ? "!border-interactiveBorder" : "!border-blueBorder bg-blueBgDefault"
          ),
          variant: "outline",
          children: [
            /* @__PURE__ */ s(wP, { className: "h-4 w-4" }),
            " ",
            c > 0 ? `${c} filter${c > 1 ? "s" : ""} applied` : "All filters"
          ]
        }
      ) }),
      /* @__PURE__ */ R(
        Xp,
        {
          className: "flex flex-col gap-0 !p-0 xl:max-w-[720px] !bg-[#FCFCF9] border-l border-interactiveBorder",
          onOpenAutoFocus: (C) => {
            C.preventDefault();
          },
          showOverlay: !1,
          children: [
            /* @__PURE__ */ s(
              "div",
              {
                className: "h-full flex flex-col gap-3 overflow-y-auto px-8 py-6",
                ref: l,
                children: v()
              }
            ),
            /* @__PURE__ */ s(NC, { className: "px-5 py-2 border-interactiveBorder border-t bg-[#F3F3EE]", children: /* @__PURE__ */ s(
              ct,
              {
                className: "w-full !h-min py-2 !text-bodysm !border-interactiveBorder text-textPrimary",
                onClick: r,
                variant: "outline",
                children: "Clear filters"
              }
            ) })
          ]
        }
      )
    ] })
  ] });
}
const sf = {
  STRING: "STRING",
  OPTIONS: "OPTIONS",
  SEARCHABLE_OPTIONS: "SEARCHABLE_OPTIONS"
};
function VZ(e) {
  return /* @__PURE__ */ R(
    "svg",
    {
      width: "208px",
      height: "66px",
      viewBox: "0 0 208 66",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "none",
      ...e,
      children: [
        /* @__PURE__ */ s("title", { children: "Bayside_City_Council_Logo_Landscape_-_RGB" }),
        /* @__PURE__ */ s(
          "g",
          {
            id: "Styleguide",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /* @__PURE__ */ s(
              "g",
              {
                id: "Artboard",
                transform: "translate(-227.000000, -185.000000)",
                fillRule: "nonzero",
                children: /* @__PURE__ */ R(
                  "g",
                  {
                    id: "Bayside_City_Council_Logo_Landscape_-_RGB",
                    transform: "translate(227.000000, 185.000000)",
                    children: [
                      /* @__PURE__ */ R(
                        "g",
                        {
                          id: "Group",
                          transform: "translate(27.000000, 1.000000)",
                          fill: "#2954A2",
                          children: [
                            /* @__PURE__ */ s(
                              "path",
                              {
                                d: "M29.0985052,23.8258427 C29.036701,21.2247191 28.6321649,19.7865169 28.0984021,17.988764 C29.8626289,15.8314607 30.3795361,13.6460674 29.7671134,10.8707865 C30.963866,9.08988764 31.1717526,6.57865169 30.2727835,4.53932584 C30.7840722,2.87078652 30.1885052,1.34831461 29.3681959,0.516853933 L27.845567,2.09550562 C28.0534536,2.29213483 28.682732,3.04494382 28.1939175,4.20224719 L27.9916495,4.66853933 L28.2220103,5.11235955 C29.0423196,6.63483146 28.8737629,8.7247191 27.845567,9.98314607 L27.5084536,10.3876404 L27.6376804,10.9044944 C28.2950515,13.4550562 27.896134,15.1179775 26.1712371,17.0561798 L25.7779381,17.5 L25.9521134,18.0505618 C26.5364433,19.9438202 27.0926804,21.4494382 27.0758247,24.011236 L27.0870619,24.011236 C27.0364948,28.9325843 26.1319072,36.7640449 20.5807732,41.8820225 C14.563299,47.3595506 9.19757732,48.3483146 0.219123711,49.9494382 C8.82113402,49.7022472 16.8725258,49.9550562 23.777732,44.5674157 C31.3515464,38.6348315 32.1999485,29.1348315 32.1999485,23.8370787 L29.0985052,23.8370787 L29.0985052,23.8258427 Z",
                                id: "Path"
                              }
                            ),
                            /* @__PURE__ */ s(
                              "path",
                              {
                                d: "M108.814588,42.1179775 C107.79201,41.752809 106.926753,41.5449438 105.965979,41.5449438 C104.066907,41.5449438 102.662268,42.4719101 102.662268,43.747191 C102.662268,45.1516854 104.027577,46.0224719 106.005309,46.0224719 C106.949227,46.0224719 107.966186,45.7808989 108.893247,45.3202247 L108.893247,46.3089888 C108.095412,46.6292135 107.196443,46.7921348 105.909794,46.7921348 C102.802732,46.7921348 101.437423,45.1573034 101.437423,43.8314607 C101.437423,42.0617978 103.336495,40.7191011 105.971598,40.7191011 C106.825619,40.7191011 107.685258,40.8707865 108.808969,41.2303371 L108.808969,42.1179775 L108.814588,42.1179775 Z",
                                id: "Path"
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ s(
                        "rect",
                        {
                          id: "Rectangle",
                          fill: "#2954A2",
                          x: "137",
                          y: "42",
                          width: "1",
                          height: "6"
                        }
                      ),
                      /* @__PURE__ */ s(
                        "polygon",
                        {
                          id: "Path",
                          fill: "#2954A2",
                          points: "146 42.8225352 143.100895 42.8225352 143.100895 48 141.882018 48 141.882018 42.8225352 139 42.8225352 139 42 146 42"
                        }
                      ),
                      /* @__PURE__ */ s(
                        "polygon",
                        {
                          id: "Path",
                          fill: "#2954A2",
                          points: "151.423313 42 153 42 149.650307 44.828169 149.650307 48 148.349693 48 148.349693 44.828169 145 42 146.558282 42 148.981595 44.0788732"
                        }
                      ),
                      /* @__PURE__ */ R(
                        "g",
                        {
                          id: "Group",
                          transform: "translate(156.000000, 42.000000)",
                          fill: "#2954A2",
                          children: [
                            /* @__PURE__ */ s(
                              "path",
                              {
                                d: "M7.50608696,1.7325 C6.4773913,1.35333333 5.60130435,1.1375 4.64043478,1.1375 C2.72434783,1.1375 1.30565217,2.1 1.30565217,3.42416667 C1.30565217,4.8825 2.67913043,5.78666667 4.68,5.78666667 C5.62391304,5.78666667 6.64695652,5.53583333 7.57956522,5.0575 L7.57956522,6.08416667 C6.76,6.41666667 5.88391304,6.58583333 4.57826087,6.58583333 C1.44695652,6.58583333 0.0904347826,4.88833333 0.0904347826,3.51166667 C0.0904347826,1.67416667 2.00086957,0.28 4.64043478,0.28 C5.49956522,0.28 6.35869565,0.4375 7.50608696,0.810833333 L7.50608696,1.7325 L7.50608696,1.7325 Z",
                                id: "Path"
                              }
                            ),
                            /* @__PURE__ */ s(
                              "path",
                              {
                                d: "M12.8982609,5.78666667 C14.7691304,5.78666667 16.1482609,4.84166667 16.1482609,3.40666667 C16.1482609,2.0825 14.7747826,1.1375 12.8982609,1.1375 C11.05,1.1375 9.65954805,2.07666667 9.65954805,3.40666667 C9.65391304,4.84166667 11.0443478,5.78666667 12.8982609,5.78666667 M12.8982609,0.28 C15.6565217,0.28 17.3747826,1.72666667 17.3747826,3.4125 C17.3747826,5.075 15.6904348,6.59166667 12.8756522,6.59166667 C10.1682609,6.59166667 8.43868223,5.0925 8.43868223,3.4125 C8.43304348,1.7325 10.2134783,0.28 12.8982609,0.28",
                                id: "Shape"
                              }
                            ),
                            /* @__PURE__ */ s(
                              "path",
                              {
                                d: "M25.5873913,4.1125 C25.5873913,5.60583333 24.3665217,6.58583333 21.8965217,6.58583333 C20.1386957,6.58583333 18.4373913,5.88583333 18.4373913,4.2175 L18.4373913,0.361666667 L19.6243478,0.361666667 L19.6243478,4.01333333 C19.6243478,4.74833333 19.7486957,4.94666667 20.1330435,5.23833333 C20.5908696,5.6175 21.2069565,5.7925 21.9191304,5.7925 C22.8291304,5.7925 23.4847826,5.57083333 23.8691304,5.27333333 C24.2930435,4.94666667 24.3891304,4.5675 24.3891304,3.955 L24.3891304,0.361666667 L25.5817391,0.361666667 L25.5817391,4.1125 L25.5873913,4.1125 Z",
                                id: "Path"
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ s(
                        "polygon",
                        {
                          id: "Path",
                          fill: "#2954A2",
                          points: "191 48 189.921612 48 184.154579 43.3577465 184.154579 48 183 48 183 42 183.972894 42 189.821978 46.5802817 189.821978 42 191 42"
                        }
                      ),
                      /* @__PURE__ */ s(
                        "path",
                        {
                          d: "M198.909228,43.3820537 C197.844175,43.0212766 196.906203,42.8159112 195.859304,42.8159112 C193.813918,42.8159112 192.301059,43.7317299 192.301059,44.9916744 C192.301059,46.3792784 193.77761,47.239593 195.901664,47.239593 C196.93646,47.239593 198.037821,47.0009251 199,46.5457909 L199,47.5226642 C198.170953,47.8390379 197.19062,48 195.792738,48 C192.446293,48 191,46.3848289 191,45.0749306 C191,43.3265495 193.075643,42 195.865356,42 C196.827534,42 197.723147,42.1498612 198.91528,42.5050879 L198.91528,43.3820537 L198.909228,43.3820537 Z",
                          id: "Path",
                          fill: "#2954A2"
                        }
                      ),
                      /* @__PURE__ */ s(
                        "rect",
                        {
                          id: "Rectangle",
                          fill: "#2954A2",
                          x: "200",
                          y: "42",
                          width: "1",
                          height: "6"
                        }
                      ),
                      /* @__PURE__ */ s(
                        "polygon",
                        {
                          id: "Path",
                          fill: "#2954A2",
                          points: "203 42 203 48 208 48 208 47.1943662 204.190205 47.1943662 204.190205 42"
                        }
                      ),
                      /* @__PURE__ */ R("g", { id: "Group", children: [
                        /* @__PURE__ */ s(
                          "path",
                          {
                            d: "M77.238973,23.8830508 C77.238973,24.8562712 77.2893243,24.9122034 79.9243784,24.8562712 C85.2112703,24.7108475 88.0533243,23.6816949 88.0533243,20.4432203 C88.0533243,17.0649153 84.2881622,15.7840678 80.343973,15.7840678 C79.2082703,15.7840678 78.4362162,15.8455932 77.9662703,15.9854237 C77.4515676,16.0916949 77.238973,16.2650847 77.238973,16.8915254 L77.238973,23.8830508 Z M77.238973,31.9037288 C77.238973,33.1454237 77.3396757,34.9184746 78.3299189,35.6288136 C79.3145676,36.4733898 80.8698649,36.6244068 82.4083784,36.6244068 C87.0183243,36.6244068 90.5429189,35.2261017 90.5429189,31.7862712 C90.5429189,29.0511864 88.4841081,25.8798305 80.2432703,25.8798305 C77.4571622,25.8798305 77.238973,26.0923729 77.238973,26.7915254 L77.238973,31.9037288 Z M72.9870811,19.2910169 C72.9870811,16.7516949 72.7856757,16.119661 70.4527297,15.940678 L68.8023243,15.84 C68.3827297,15.6498305 68.4386757,15.129661 68.8526757,14.9898305 C71.6443784,14.8164407 75.168973,14.7045763 79.9747297,14.7045763 C83.2363784,14.7045763 86.346973,14.8779661 88.6799189,15.6722034 C90.9065676,16.399322 92.6073243,17.7808475 92.6073243,19.9845763 C92.6073243,22.4735593 90.431027,23.7432203 87.326027,24.7052542 C87.326027,25.0520339 87.7344324,25.1694915 88.3050811,25.2366102 C91.107973,25.5722034 95.2535676,27.2949153 95.2535676,30.969661 C95.2535676,35.0079661 90.8002703,37.6927119 81.4852703,37.6927119 C79.9747297,37.6927119 77.4515676,37.5752542 75.2696757,37.5752542 C72.9870811,37.5752542 71.235973,37.6647458 69.3114324,37.6927119 C69.0093243,37.5752542 68.8918378,36.9935593 69.2107297,36.8089831 L70.1394324,36.7138983 C72.891973,36.4677966 72.9870811,36.0259322 72.9870811,32.390339 L72.9870811,19.2910169 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ s(
                          "path",
                          {
                            d: "M104.663676,36.5349153 C105.709865,36.5349153 107.309919,35.9979661 107.830216,35.6344068 C108.462405,35.2316949 108.507162,34.7730508 108.507162,34.0123729 L108.60227,32.0044068 C108.60227,31.629661 108.39527,31.5625424 108.098757,31.5625424 C107.779865,31.5625424 106.890324,31.7079661 105.956027,31.909322 C102.912568,32.5637288 101.407622,33.1174576 101.407622,34.4486441 C101.407622,35.0415254 102.034216,36.5349153 104.663676,36.5349153 M107.880568,30.4438983 C108.658216,30.2816949 108.702973,29.979661 108.758919,29.4315254 L108.80927,27.8486441 C108.859622,26.5845763 108.238622,24.8562712 105.038514,24.8562712 C103.583919,24.8562712 101.821622,25.3484746 101.726514,26.4055932 C101.664973,26.959322 101.625811,27.3732203 101.195027,27.5689831 C100.434162,27.9828814 99.0243243,28.2401695 98.2578649,28.2401695 C97.7879189,28.2401695 97.5193784,28.0555932 97.5193784,27.7535593 C97.5193784,25.9637288 103.376919,23.5083051 107.15327,23.5083051 C110.884865,23.5083051 112.697514,24.9625424 112.546459,27.5410169 L112.221973,33.5537288 C112.132459,35.1477966 112.602405,36.5628814 114.610865,36.5628814 C115.131162,36.5628814 115.595514,36.4789831 115.903216,36.3783051 C116.154973,36.2608475 116.423514,36.1210169 116.580162,36.1210169 C116.781568,36.1210169 116.949405,36.3223729 116.949405,36.5628814 C116.949405,36.7250847 115.131162,38.0954237 112.596811,38.0954237 C111.343622,38.0954237 110.107216,37.7766102 109.217676,36.9767797 C109.01627,36.7866102 108.702973,36.5405085 108.39527,36.5405085 C108.037216,36.5405085 107.405027,36.8201695 106.381216,37.1837288 C105.22873,37.6144068 104.093027,38.0954237 102.644027,38.0954237 C101.139081,38.0954237 99.9082703,37.8101695 99.0187297,37.2620339 C98.0396757,36.6915254 97.4186757,35.8133898 97.4186757,34.879322 C97.4186757,33.5201695 98.4089189,32.7035593 101.726514,31.9316949 L107.880568,30.4438983 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ s(
                          "path",
                          {
                            d: "M115.690622,44.6450847 C115.690622,43.7557627 116.630514,43.2747458 117.755027,43.2747458 L118.74527,43.2747458 C119.567676,43.2747458 120.093568,43.0398305 120.457216,42.7210169 C121.950973,41.1661017 122.991568,39.7118644 123.455919,38.8449153 C123.606973,38.5484746 123.970622,37.8772881 123.970622,37.3627119 C123.970622,36.6915254 123.758027,36.2944068 123.097865,35.0135593 L119.041784,27.6137288 C118.180216,25.9916949 117.799784,25.1750847 115.998324,24.9122034 L114.705973,24.7444068 C114.387081,24.5766102 114.448622,23.9949153 114.857027,23.8830508 C116.513027,23.9613559 118.06273,23.9949153 119.774676,23.9949153 C121.16773,23.9949153 122.622324,23.9613559 124.278324,23.8830508 C124.692324,23.9949153 124.742676,24.5766102 124.384622,24.7444068 L123.09227,24.9122034 C122.359378,25.0184746 121.945378,25.130339 121.945378,25.3708475 C121.945378,25.7847458 123.137027,28.0164407 123.450324,28.6261017 L125.10073,31.7918644 C125.408432,32.3288136 126.398676,34.1466102 126.605676,34.2305085 C126.751135,34.1466102 127.595919,33.1174576 128.519027,31.7079661 L130.281324,28.9616949 C131.417027,27.1774576 132.088378,25.8854237 132.088378,25.5162712 C132.088378,25.2757627 131.78627,25.0240678 130.851973,24.9177966 L129.24073,24.75 C128.871486,24.5822034 128.927432,24.0005085 129.335838,23.8886441 C131.008622,23.9669492 132.55273,24.0005085 133.901027,24.0005085 C135.198973,24.0005085 136.390622,23.9669492 137.828432,23.8886441 C138.253622,24.0340678 138.309568,24.5430508 137.945919,24.75 L137.056378,24.8618644 C135.344432,25.0632203 134.426919,26.0644068 132.664622,28.5254237 L129.766622,32.4686441 C128.06027,34.8177966 123.813973,40.8137288 121.285216,44.55 C120.384486,45.9147458 119.148081,46.1328814 117.956432,46.1328814 C116.46827,46.1272881 115.690622,45.5679661 115.690622,44.6450847",
                            id: "Path",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ s(
                          "path",
                          {
                            d: "M151.305811,24.1235593 C151.781351,24.8786441 152.122622,25.9861017 152.122622,26.9313559 C151.921216,27.1718644 151.137973,27.2333898 150.886216,27.0320339 C150.019054,25.510678 148.458162,24.5038983 146.332216,24.5038983 C144.306973,24.5038983 143.014622,25.3652542 143.014622,26.6069492 C143.014622,28.0052542 145.202108,28.7827119 147.014757,29.4483051 C149.761703,30.4998305 152.284865,31.6967797 152.284865,34.1074576 C152.284865,36.7474576 148.659568,38.0842373 144.832865,38.0842373 C142.404811,38.0842373 140.592162,37.720678 139.294216,36.9935593 C138.885811,36.3950847 138.578108,34.6891525 138.673216,33.5425424 C138.936162,33.3411864 139.607514,33.3188136 139.870459,33.5089831 C140.737622,35.3771186 142.404811,37.0327119 145.364351,37.0327119 C147.221757,37.0327119 148.827405,36.3671186 148.827405,34.8737288 C148.827405,33.279661 146.746216,32.390339 144.832865,31.7023729 C141.834162,30.5389831 139.708216,29.3252542 139.708216,27.4347458 C139.708216,24.9122034 142.807622,23.5027119 146.746216,23.5027119 C148.916919,23.5027119 150.83027,23.8494915 151.305811,24.1235593",
                            id: "Path",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ s(
                          "path",
                          {
                            d: "M161.085162,16.5 C161.085162,17.7137288 159.798405,18.2618644 158.399757,18.2618644 C156.788514,18.2618644 155.753514,17.4955932 155.753514,16.5727119 C155.753514,15.4428814 157.051459,14.7381356 158.550811,14.7381356 C160.106108,14.7381356 161.085162,15.5379661 161.085162,16.5 M156.838865,27.6752542 C156.838865,26.3272881 156.838865,26.1594915 155.445811,25.5442373 L154.987054,25.3428814 C154.785649,25.2030508 154.785649,24.8115254 155.031811,24.7052542 C156.223459,24.4423729 159.177405,23.5362712 160.363459,23.0272881 C160.632,23.0272881 160.822216,23.0888136 160.889351,23.2286441 C160.777459,24.4423729 160.682351,26.0867797 160.682351,27.5018644 L160.682351,33.710339 C160.682351,36.2161017 160.783054,36.5516949 162.646054,36.7138983 L163.737,36.8089831 C164.089459,36.9655932 163.988757,37.5808475 163.619514,37.6927119 C162.075405,37.6032203 160.576054,37.5752542 158.757811,37.5752542 C156.900405,37.5752542 155.345108,37.6032203 153.896108,37.6927119 C153.526865,37.5752542 153.431757,36.9655932 153.784216,36.8089831 L154.869568,36.7138983 C156.788514,36.5516949 156.838865,36.2161017 156.838865,33.710339 L156.838865,27.6752542 L156.838865,27.6752542 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ s(
                          "path",
                          {
                            d: "M181.113811,27.3732203 C181.113811,26.679661 180.906811,26.3608475 180.548757,26.0252542 C179.776703,25.3149153 178.221405,24.5766102 176.196162,24.5766102 C171.485514,24.5766102 169.040676,27.3061017 169.040676,30.3152542 C169.040676,33.4474576 171.67573,36.4342373 176.772405,36.4342373 C178.159865,36.4342373 179.922162,35.9979661 180.761351,35.4274576 C181.05227,35.2372881 181.113811,34.7450847 181.113811,34.1466102 L181.113811,27.3732203 Z M184.946108,32.5245763 C184.946108,35.2652542 184.990865,36.5572881 186.456649,36.5572881 C187.004919,36.5572881 187.888865,36.4062712 188.677703,36.2216949 C189.041351,36.2888136 189.097297,37.1054237 188.616162,37.2955932 C186.456649,37.5249153 183.228568,38.0618644 181.796351,38.4030508 C181.471865,38.4030508 181.225703,38.3079661 181.225703,38.1513559 L181.225703,37.5472881 C181.225703,36.9991525 181.225703,36.6244068 181.113811,36.4957627 L180.906811,36.4957627 C178.629811,37.5137288 176.861919,38.0842373 174.394703,38.0842373 C168.637865,38.0842373 164.816757,35.0694915 164.816757,31.4450847 C164.816757,26.6069492 170.282676,23.4971186 177.331865,23.4971186 C179.099757,23.4971186 180.235459,23.6761017 180.800514,23.8159322 C181.046676,23.8159322 181.113811,23.6033898 181.113811,23.3237288 L181.113811,18.1108475 C181.113811,16.0805085 181.05227,15.8735593 179.502568,15.2694915 L178.98227,15.0457627 C178.719324,14.9450847 178.719324,14.4584746 178.98227,14.3522034 C180.291405,14.0837288 182.713865,13.5691525 184.576865,12.9035593 C184.789459,12.9035593 184.98527,12.9762712 185.097162,13.1105085 C185.046811,14.1620339 184.940514,15.8735593 184.940514,17.3949153 L184.940514,32.5245763 L184.946108,32.5245763 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ s(
                          "path",
                          {
                            d: "M197.19827,27.7144068 C201.030568,27.7144068 202.138297,27.5633898 202.574676,27.3676271 C202.742514,27.2949153 202.910351,27.1662712 202.910351,26.7132203 C202.910351,25.7455932 201.908919,24.5318644 198.899027,24.5318644 C195.844378,24.5318644 193.214919,26.4055932 193.153378,27.5354237 C193.153378,27.6081356 193.153378,27.7144068 193.539405,27.7144068 L197.19827,27.7144068 Z M194.009351,28.7547458 C192.649865,28.7547458 192.599514,28.810678 192.599514,29.6776271 C192.599514,33.1901695 195.648568,36.1433898 201.192811,36.1433898 C202.910351,36.1433898 204.364946,35.7686441 205.959405,34.4374576 C206.507676,34.3367797 206.798595,34.549322 206.854541,34.8737288 C205.137,37.1781356 201.466946,38.0842373 198.759162,38.0842373 C195.419189,38.0842373 192.744973,37.060678 191.245622,35.7686441 C189.68473,34.4374576 189.086108,32.8154237 189.086108,31.2940678 C189.086108,27.0655932 193.259676,23.5027119 199.47527,23.5027119 C203.917378,23.5027119 206.798595,25.5442373 206.798595,27.6081356 C206.798595,28.0835593 206.697892,28.38 206.586,28.5142373 C206.507676,28.7155932 205.741216,28.7547458 203.542541,28.7547458 L194.009351,28.7547458 L194.009351,28.7547458 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ s(
                          "path",
                          {
                            d: "M43.47,63.4215254 C36.9019459,63.8801695 28.9296486,59.3049153 23.0329459,57.6828814 C14.1263514,55.2889831 8.32475676,58.2254237 4.75540541,62.5657627 C7.70375676,60.4067797 12.5207027,59.5062712 20.4818108,61.5925424 C26.3952973,63.1530508 32.4822162,66.3579661 39.0670541,65.899322 C48.5722703,65.1945763 50.5863243,61.9952542 50.5863243,61.9952542 C50.5863243,61.9952542 49.6128649,62.9852542 43.47,63.4215254",
                            id: "Path",
                            fill: "#009CCD"
                          }
                        ),
                        /* @__PURE__ */ s(
                          "path",
                          {
                            d: "M25.8134595,56.5194915 C31.698973,58.1750847 37.7243514,61.810678 44.3315676,61.7155932 C52.8409459,61.5869492 57.4005405,56.6928814 57.4005405,56.6928814 L57.4117297,56.3349153 C57.4117297,56.3349153 55.0955676,58.3372881 48.4883514,58.8854237 C41.9202973,59.4894915 33.9424054,54.7967797 28.0401081,53.1635593 C20.051027,50.9262712 14.1431351,55.6413559 14.1431351,55.6413559 C14.1431351,55.6413559 16.4984595,53.9018644 25.8134595,56.5194915",
                            id: "Path",
                            fill: "#009CCD"
                          }
                        ),
                        /* @__PURE__ */ s(
                          "path",
                          {
                            d: "M51.4590811,1.10745763 C47.2687297,-0.285254237 44.6112973,0.945254237 41.5286757,3.40067797 C36.5998378,3.10983051 33.4612703,4.53610169 31.0332162,6.5440678 C23.0665135,6.3259322 15.9837568,9.06661017 9.36535135,15.6722034 C-2.80289189,27.8318644 -1.48256757,44.7569492 4.16237838,53.6837288 C4.16237838,53.6837288 5.10786486,50.9933898 8.04502703,47.3354237 C16.8788919,36.0427119 25.9477297,33.9788136 29.2373514,42.2008475 C29.9366757,37.6927119 29.187,36.0762712 27.4135135,34.6947458 C24.0679459,32.0827119 17.774027,32.3120339 10.2101351,42.2455932 C8.15132432,44.9079661 7.93313514,45.1316949 6.94848649,46.6698305 C2.18748649,38.5037288 4.11202703,26.5733898 12.1906216,18.4408475 C18.2495676,12.310678 24.3700541,9.51966102 31.436027,9.41898305 C31.436027,9.41898305 36.2921351,8.87084746 45.2211081,12.6910169 L35.576027,7.52847458 C39.7663784,5.12338983 46.1833784,6.19169492 50.2338649,7.75779661 L44.8798378,4.77661017 C46.8379459,3.32237288 47.9792432,2.41627119 51.6548919,3.46220339 L52.0912703,3.53491525 L52.5108649,3.36711864 C53.5962162,2.9140678 54.3458919,2.98118644 54.6032432,3.22169492 L56.1417568,1.63881356 C55.2466216,0.749491525 53.4899189,-0.00559322034 51.4590811,1.10745763",
                            id: "Path",
                            fill: "#F7941E"
                          }
                        )
                      ] })
                    ]
                  }
                )
              }
            )
          }
        )
      ]
    }
  );
}
function WZ(e) {
  return /* @__PURE__ */ R(
    "svg",
    {
      version: "1.1",
      id: "Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 229.4 57.2",
      ...e,
      children: [
        /* @__PURE__ */ s(
          "path",
          {
            fill: "#F58220",
            d: `M5.5,33.3c0-8.3,5.5-16.4,10.2-21c1.9-2.3,3.5-4.6,3.5-12c0-0.4-0.5-0.4-0.7,0.1c-1,3.3-2,4.4-3.2,5.6
	c-3.1,2.6-4.7,2.8-6.6,5.1c-1.3,1.5-1.5,3.7-3.1,7.3c-1.3,2.9-5,5.5-5.5,10c-0.4,3.9,1.7,7.3,2.1,10.8`
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fill: "#084323",
            d: `M19.4,27.5c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3C16,26.1,17.5,27.5,19.4,27.5 M32.8,33
	c0,10.7-8.9,20.7-13.5,23.7V9.4C24,12.3,32.8,22.3,32.8,33`
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fill: "#F58220",
            d: `M2.3,39.1c0.4,3.5-0.2,5.4,1.8,8.5c2.1,3.5,13.2,9.1,13.9,9.5c0.7,0.4,0.8-0.2,0.5-0.3
	c-4.7-3.3-13-13.1-13-23.5`
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fill: "#084323",
            d: `M43.6,30.1h1c3.1,0,5.2-1.3,5.2-3.9c0-2.7-1.5-4.1-4-4.1c-1.9,0-2.2,0.5-2.2,1.7V30.1z M43.6,38
	c0,1.9,1,2.3,2.8,2.3c2.9,0,4.8-1.5,4.8-4.5c0-3.4-2.6-4.7-5.6-4.7c-0.7,0-1.4,0.1-2,0.2C43.6,31.3,43.6,38,43.6,38z M41.1,24
	c0-1.7-1.1-1.7-2.9-1.8c-0.3,0-0.3-0.1-0.3-0.5s0.2-0.4,0.6-0.4c1.1,0,2.2,0.1,3.3,0.1s2.2-0.1,3.3-0.1c3.4,0,7.5,0.6,7.5,5
	c0,3.1-3.1,3.6-4.4,4v0.1c0.6,0,5.9,0.8,5.9,5.3c0,4.3-3.6,5.8-7.4,5.8c-2,0-3.3-0.1-4.5-0.1s-2.3,0.1-3.7,0.1
	c-0.5,0-0.6-0.1-0.6-0.3v-0.3c0-0.2,0.2-0.3,0.3-0.3c2.9,0,2.9-0.6,2.9-2.7C41.1,37.9,41.1,24,41.1,24z`
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fill: "#084323",
            d: `M73.1,33.1c0-4-2.7-8.1-7-8.1c-4.4,0-6.5,3.5-6.5,7.5c0,4.1,2.5,8.3,6.9,8.3C70.9,40.8,73.1,37.2,73.1,33.1
	 M57.1,33.3c0-5,4.3-9.1,9.2-9.1c5,0,9.4,3.4,9.4,8.4c0,4.8-4.6,9.1-9.3,9.1C61.4,41.8,57.1,38.5,57.1,33.3`
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fill: "#084323",
            d: `M81.3,32.2c0.3,0,0.6,0,0.9,0c1.9,0,4.3-0.7,4.3-3.5c0-2.1-1.4-3.5-3.5-3.5c-1.6,0-1.7,0.4-1.7,1.1
	C81.3,26.3,81.3,32.2,81.3,32.2z M79.1,27.2c0-1.2,0-1.8-1.5-1.8h-1c-0.1,0-0.2-0.3-0.2-0.5c0-0.1,0.1-0.3,0.2-0.3
	c1.4,0,2.8,0.1,4.2,0.1c1.1,0,2.2-0.1,3.3-0.1c2.4,0,4.8,1.6,4.8,4.1c0,2.2-2,3.6-3.8,3.9l0,0c0.9,0.2,1.9,2,2.1,2.3l2.6,4
	c0.8,1.3,1.4,1.5,2.8,1.6l0.1,0.1v0.5c0,0.2-0.2,0.2-0.3,0.2c-0.5,0-1.2-0.1-1.6-0.1c-0.6,0-1.1,0.1-1.7,0.1c-0.5,0-1.6-1.6-3-4.1
	c-1.5-2.7-2.4-4.2-4-4.2c-0.2,0-0.5,0-0.8,0v5.8c0,0.9,0,1.7,1.2,1.7c0.9,0,1.3,0,1.3,0.2c0,0.5-0.1,0.6-0.4,0.6
	c-1.2,0-2.3-0.1-3.3-0.1c-0.4,0-3,0.1-3.4,0.1c-0.1,0-0.2-0.3-0.2-0.5s0.1-0.3,0.6-0.3c1.6-0.1,2.1-0.3,2.1-2L79.1,27.2L79.1,27.2z`
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fill: "#084323",
            d: `M109.1,33.1c0-4-2.7-8.1-7-8.1c-4.4,0-6.5,3.5-6.5,7.5c0,4.1,2.5,8.3,6.9,8.3C106.8,40.8,109.1,37.2,109.1,33.1
	 M93,33.3c0-5,4.3-9.1,9.2-9.1c5,0,9.4,3.4,9.4,8.4c0,4.8-4.6,9.1-9.3,9.1C97.3,41.8,93,38.5,93,33.3`
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fill: "#084323",
            d: `M130.5,33.1c0-4-2.7-8.1-7-8.1c-4.4,0-6.5,3.5-6.5,7.5c0,4.1,2.5,8.3,6.9,8.3C128.2,40.8,130.5,37.2,130.5,33.1
	 M114.4,33.3c0-5,4.3-9.1,9.2-9.1c5,0,9.4,3.4,9.4,8.4c0,4.8-4.6,9.1-9.3,9.1C118.7,41.8,114.4,38.5,114.4,33.3`
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fill: "#084323",
            d: `M137.7,27.5c0-0.5,0-0.6-0.1-0.8c-0.2-0.4-1.3-1.3-1.7-1.3l-1.3-0.1c-0.1,0-0.1-0.2-0.1-0.4
	c0-0.1,0-0.3,0.1-0.3c0.7,0,1.3,0,1.9,0c1.1,0,2.8,0.1,3.3,0.1l7.2,8.7c1.1,1.3,2.2,2.6,3.9,4.3h0.1V27.3c0-1.6-0.6-1.8-1.3-1.8h-1
	c-0.1,0-0.1-0.2-0.1-0.4c0-0.1,0.1-0.4,0.2-0.4c0.5,0,1.8,0.1,2.9,0.1c1.1,0,2.2-0.1,2.9-0.1c0.1,0,0.1,0.1,0.1,0.2v0.5
	c0,0.1,0,0.1-0.2,0.1h-0.6c-1.6,0-1.6,0.8-1.6,2.9v13.8h-0.6l-12.8-14.7v10.9c0,2.1,0.3,2.3,2.3,2.4c0.1,0,0.2,0.2,0.2,0.4
	s0,0.4-0.1,0.4c-0.5,0-2-0.1-3-0.1c-1.2,0-1.7,0.1-2.8,0.1c-0.1,0-0.2-0.2-0.2-0.5c0-0.2,0-0.3,0.3-0.3c1,0,2.1-0.2,2.1-1.5
	L137.7,27.5L137.7,27.5z`
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fill: "#084323",
            d: `M161.8,38c0,2.6,2.7,2.6,3.7,2.6c3.3,0,6.7-2.7,6.7-7.7c0-4.2-2.3-6.3-3.9-7.3c-1.1-0.5-2.6-0.6-3.7-0.6
	c-1.9,0-2.9,0.1-2.9,1.7L161.8,38L161.8,38z M159.7,27.4c0-0.9-0.2-1.8-1.1-1.8c-0.3,0-1,0.1-1.5,0.1c-0.1,0-0.1-0.4-0.1-0.5
	s0-0.2,0.4-0.3c1.6-0.3,5.4-0.6,7.4-0.6c1.3,0,2.5,0.1,3.7,0.4c3.2,0.9,6.3,3.8,6.3,8.2c0,5.9-4.9,8.6-9.4,8.6
	c-2.3,0-3.4-0.1-4.6-0.1c-1.2,0-2.4,0.1-3.6,0.1c-0.1,0-0.1-0.2-0.1-0.4s0.1-0.4,0.2-0.4c0.8-0.1,1.4-0.1,1.8-0.4
	c0.4-0.2,0.6-0.6,0.6-1.4L159.7,27.4L159.7,27.4z`
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fill: "#084323",
            d: `M185.8,33.8l-2.6-6.8l0,0l-2.3,6.8H185.8z M180.5,34.7l-1,3.4c-0.2,0.6-0.3,1.2-0.3,1.5c0,0.8,1.1,1,1.8,1
	c0.2,0,0.3,0.1,0.3,0.5c0,0.2,0,0.3-0.2,0.3c-0.5,0-2.3-0.1-2.9-0.1c-0.6,0-1.6,0.1-2.4,0.1c-0.5,0-0.5-0.1-0.5-0.4v-0.3
	c0-0.1,0.2-0.2,0.8-0.2c1.2-0.1,1.4-0.4,1.9-1.7l4.7-13.7c0.5-0.4,1-1,1.6-1.1l6,15.1c0.4,1,0.8,1.5,2.2,1.5c0.3,0,0.3,0.3,0.3,0.5
	c0,0.3-0.2,0.3-0.5,0.3c-0.4,0-1.9-0.1-2.8-0.1c-1,0-1.9,0-2.9,0.1c-0.4,0-0.4-0.1-0.4-0.4c0-0.3,0.1-0.4,0.5-0.4s1.5-0.1,1.5-0.6
	c0-0.2-0.1-0.6-0.4-1.4l-1.5-3.8L180.5,34.7L180.5,34.7z`
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fill: "#084323",
            d: `M199.5,32.2c0.3,0,0.6,0,0.9,0c1.9,0,4.3-0.7,4.3-3.5c0-2.1-1.4-3.5-3.5-3.5c-1.6,0-1.7,0.4-1.7,1.1V32.2z
	 M197.3,27.2c0-1.2,0-1.8-1.5-1.8h-1c-0.1,0-0.2-0.3-0.2-0.5c0-0.1,0.1-0.3,0.2-0.3c1.4,0,2.8,0.1,4.2,0.1c1.1,0,2.2-0.1,3.3-0.1
	c2.4,0,4.8,1.6,4.8,4.1c0,2.2-2,3.6-3.8,3.9l0,0c0.9,0.2,1.9,2,2.1,2.3l2.6,4c0.8,1.3,1.4,1.5,2.8,1.6l0.1,0.1v0.5
	c0,0.2-0.2,0.2-0.3,0.2c-0.5,0-1.2-0.1-1.6-0.1c-0.6,0-1.1,0.1-1.7,0.1c-0.5,0-1.6-1.6-3-4.1c-1.5-2.7-2.5-4.2-4-4.2
	c-0.2,0-0.5,0-0.8,0v5.8c0,0.9,0,1.7,1.2,1.7c0.9,0,1.3,0,1.3,0.2c0,0.5-0.1,0.6-0.4,0.6c-1.2,0-2.3-0.1-3.3-0.1
	c-0.4,0-3,0.1-3.4,0.1c-0.1,0-0.2-0.3-0.2-0.5s0.1-0.3,0.6-0.3c1.6-0.1,2.1-0.3,2.1-2V27.2H197.3z`
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fill: "#084323",
            d: `M222.4,33.8l-2.6-6.8l0,0l-2.3,6.8H222.4z M217.1,34.7l-1,3.4c-0.2,0.6-0.3,1.2-0.3,1.5c0,0.8,1.1,1,1.8,1
	c0.2,0,0.3,0.1,0.3,0.5c0,0.2,0,0.3-0.2,0.3c-0.5,0-2.3-0.1-2.9-0.1c-0.6,0-1.6,0.1-2.4,0.1c-0.5,0-0.5-0.1-0.5-0.4v-0.3
	c0-0.1,0.2-0.2,0.8-0.2c1.2-0.1,1.4-0.4,1.9-1.7l4.7-13.7c0.5-0.4,1-1,1.6-1.1l6,15.1c0.4,1,0.8,1.5,2.2,1.5c0.3,0,0.3,0.3,0.3,0.5
	c0,0.3-0.2,0.3-0.5,0.3c-0.4,0-1.9-0.1-2.8-0.1c-1,0-1.9,0-2.9,0.1c-0.4,0-0.4-0.1-0.4-0.4c0-0.3,0.1-0.4,0.5-0.4s1.5-0.1,1.5-0.6
	c0-0.2-0.1-0.6-0.4-1.4l-1.5-3.8L217.1,34.7L217.1,34.7z`
          }
        )
      ]
    }
  );
}
function HZ({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      className: F("h-4 w-4", e),
      viewBox: "0 0 256 256",
      ...t,
      children: /* @__PURE__ */ s("path", { d: "M224 104a8 8 0 0 1-16 0V59.32l-66.33 66.34a8 8 0 0 1-11.32-11.32L196.68 48H152a8 8 0 0 1 0-16h64a8 8 0 0 1 8 8Zm-40 24a8 8 0 0 0-8 8v72H48V80h72a8 8 0 0 0 0-16H48a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-72a8 8 0 0 0-8-8Z" })
    }
  );
}
function GK() {
  return /* @__PURE__ */ R(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      children: [
        /* @__PURE__ */ s(
          "mask",
          {
            id: "mask0_7106_5812",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20",
            children: /* @__PURE__ */ s("path", { d: "M20 0H0V20H20V0Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ R("g", { mask: "url(#mask0_7106_5812)", children: [
          /* @__PURE__ */ s(
            "path",
            {
              d: "M19.6 10.2274C19.6 9.51828 19.5364 8.83648 19.4182 8.18188H10V12.0501H15.3818C15.15 13.3001 14.4455 14.3592 13.3864 15.0683V17.5774H16.6182C18.5091 15.8365 19.6 13.2728 19.6 10.2274Z",
              fill: "#4285F4"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              d: "M9.99988 19.9999C12.6999 19.9999 14.9635 19.1044 16.618 17.5772L13.3862 15.0681C12.4908 15.6681 11.3453 16.0226 9.99988 16.0226C7.39528 16.0226 5.19078 14.2635 4.40438 11.8999H1.06348V14.4908C2.70898 17.759 6.09078 19.9999 9.99988 19.9999Z",
              fill: "#34A853"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              d: "M4.4045 11.8999C4.2045 11.2999 4.0909 10.659 4.0909 9.99993C4.0909 9.34083 4.2045 8.69993 4.4045 8.09993V5.50903H1.0636C0.3864 6.85903 0 8.38633 0 9.99993C0 11.6135 0.3864 13.1408 1.0636 14.4908L4.4045 11.8999Z",
              fill: "#FBBC04"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              d: "M9.99988 3.9773C11.468 3.9773 12.7862 4.4818 13.8226 5.4727L16.6908 2.6045C14.959 0.9909 12.6953 0 9.99988 0C6.09078 0 2.70898 2.2409 1.06348 5.5091L4.40438 8.1C5.19078 5.7364 7.39528 3.9773 9.99988 3.9773Z",
              fill: "#E94235"
            }
          )
        ] })
      ]
    }
  );
}
function zK() {
  return /* @__PURE__ */ R("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", children: [
    /* @__PURE__ */ R("g", { clipPath: "url(#clip0_7106_5805)", children: [
      /* @__PURE__ */ s("path", { d: "M9.52358 0.952393H0.952148V9.52382H9.52358V0.952393Z", fill: "#F25022" }),
      /* @__PURE__ */ s("path", { d: "M9.52358 10.4761H0.952148V19.0475H9.52358V10.4761Z", fill: "#00A4EF" }),
      /* @__PURE__ */ s("path", { d: "M19.048 0.952393H10.4766V9.52382H19.048V0.952393Z", fill: "#7FBA00" }),
      /* @__PURE__ */ s("path", { d: "M19.048 10.4761H10.4766V19.0475H19.048V10.4761Z", fill: "#FFB900" })
    ] }),
    /* @__PURE__ */ s("defs", { children: /* @__PURE__ */ s("clipPath", { id: "clip0_7106_5805", children: /* @__PURE__ */ s("rect", { width: "20", height: "20", fill: "white" }) }) })
  ] });
}
function UZ(e) {
  return /* @__PURE__ */ R(
    "svg",
    {
      width: "188",
      height: "142",
      viewBox: "0 0 188 142",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s(
          "path",
          {
            d: "M46.6052 16.0616C47.2546 16.3283 48.4722 16.6762 49.6782 16.6646C51.754 19.3201 55.7663 21.6162 58.3986 21.9409C58.7581 21.9757 59.1176 21.9757 59.4191 21.9525C62.0514 25.9184 67.722 29.9423 71.7111 30.3597C72.3488 30.4177 72.8939 30.3829 73.3693 30.3134C76.825 36.6449 85.2322 43.3707 90.8912 43.9273C91.9696 44.0201 92.8394 43.9041 93.5699 43.6606C93.6047 43.9389 93.6395 44.2056 93.7091 44.4955C93.8019 45.6899 94.3005 46.7568 95.1238 47.5337C96.0051 48.3687 97.1763 48.7977 98.4171 48.7514C98.8114 48.7514 99.0086 48.9137 99.0202 49.2964L99.0317 49.5399L99.1017 49.795C99.4377 51.0126 100.226 51.9867 101.282 52.5781C102.337 53.1695 103.555 53.2855 104.784 52.9376C105.155 52.81 105.398 52.9608 105.491 53.3203L105.549 53.5638L105.688 53.8073C106.326 54.8742 107.323 55.6511 108.483 55.9526C109.643 56.2425 110.895 56.057 111.985 55.4076C112.321 55.2104 112.565 55.2916 112.774 55.6163L112.901 55.8134L113.063 56.0106C113.968 56.8919 115.104 57.3905 116.31 57.3905C117.505 57.3905 118.676 56.9035 119.581 56.0106C119.847 55.7207 120.137 55.7207 120.415 55.999L120.589 56.1729L120.81 56.3005C123.036 57.6225 125.831 56.8919 127.13 54.6538C127.327 54.3059 127.617 54.2364 127.941 54.4219L128.173 54.5611L128.417 54.6538C129.623 54.9785 130.887 54.851 131.931 54.2596C132.997 53.6566 133.774 52.6593 134.111 51.4301C134.157 51.2909 134.238 51.117 134.389 51.0358C134.551 50.943 134.737 50.9894 134.853 51.001L135.108 51.0822L135.363 51.0938C137.961 51.1286 140.013 49.1572 140.071 46.5365C140.094 46.1422 140.303 45.9219 140.674 45.9451H140.941L141.184 45.8871C143.295 45.3884 144.768 43.5446 144.744 41.3877L144.733 36.5057L144.721 35.207L143.515 34.6619C136.986 31.8093 132.835 26.6721 128.672 16.3515C125.506 8.48927 120.74 3.41012 114.525 1.20684C106.465 -1.65743 98.6723 1.21844 94.7064 3.21299C89.7432 -0.880489 80.9532 -0.915277 74.3782 3.21299C70.7486 0.916929 64.8577 0.928519 60.3236 3.35214C57.6796 2.04177 53.7137 2.05336 50.5248 3.52608C48.5418 2.76073 45.376 2.49402 43.138 3.57247C41.3058 4.46538 40.3085 6.10045 40.3085 8.15298C40.3085 12.2465 43.5438 14.9136 46.6052 16.0616Z",
            fill: "#FFF1CC"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M44.831 7.26007C45.7703 6.72664 47.4518 6.8426 48.5418 7.10932L48.507 12.4436C47.7185 12.2117 46.7212 11.771 45.8283 11.0173C44.8194 10.1707 44.3208 9.20823 44.3208 8.14138C44.3324 7.63115 44.5063 7.41082 44.831 7.26007ZM52.6005 7.01655C54.5602 6.2512 56.8911 6.27439 58.2594 6.8426L58.2942 17.8242C56.6476 17.3836 53.6557 15.5282 52.6005 13.8351V7.01655ZM62.3645 6.8542C65.797 5.06838 70.1456 5.25392 72.2909 6.69185V26.3591C71.943 26.3359 71.3052 26.2315 70.4587 25.8836C67.2697 24.6196 63.6169 21.5002 62.3645 19.0302V6.8542ZM76.3379 6.74983C81.4983 3.44491 88.8039 3.34055 92.3407 6.52951V39.7875C92.1436 39.8571 91.8305 39.9266 91.2739 39.8686C86.9369 39.4628 78.634 32.8877 76.3148 27.1708L76.3379 6.74983ZM96.3646 6.90058C102.07 4.01313 108.286 3.29416 113.179 5.022C118.259 6.81941 122.236 11.1448 124.938 17.8706C129.252 28.5623 133.879 34.4648 140.697 37.8393C140.697 39.2656 140.72 41.4109 140.72 41.4341C140.732 41.724 140.547 41.8632 140.384 41.9444C137.972 42.0719 136.094 43.9969 136.036 46.4669C136.024 46.8844 135.78 47.0235 135.56 47.0351C134.482 46.8264 133.368 46.9887 132.429 47.5221C131.351 48.102 130.574 49.1108 130.237 50.3284C130.191 50.4676 130.122 50.6415 129.959 50.7227C129.866 50.7923 129.762 50.8039 129.623 50.7923C127.454 49.7022 124.892 50.4792 123.651 52.6013C123.43 52.9724 123.152 52.9724 122.943 52.8912C121.111 51.3025 118.444 51.3953 116.693 53.1347C116.6 53.2275 116.45 53.355 116.276 53.355C116.171 53.355 116.079 53.2855 115.997 53.2391C114.594 51.2329 112.055 50.6415 109.909 51.9287C109.793 51.9867 109.619 52.0795 109.469 52.0331C109.364 51.9983 109.272 51.9287 109.225 51.8359C108.355 49.5399 106.036 48.3687 103.636 49.0528C103.52 49.0876 103.334 49.1108 103.183 49.0297C103.091 48.9833 103.033 48.9021 102.986 48.7977C102.731 46.3393 100.771 44.6115 98.2896 44.6927C98.0925 44.6927 97.9649 44.6463 97.8605 44.5535C97.7562 44.4723 97.6982 44.2984 97.6982 44.0897V43.9041L97.6518 43.6954C97.5822 43.3475 97.5126 42.9532 97.4547 42.5938C97.3387 41.6777 97.1648 40.4601 96.3762 39.5555V6.90058H96.3646ZM46.6052 16.0616C47.2546 16.3283 48.4722 16.6762 49.6782 16.6646C51.754 19.3201 55.7663 21.6162 58.3986 21.9409C58.7581 21.9757 59.1176 21.9757 59.4191 21.9525C62.0514 25.9184 67.722 29.9423 71.7111 30.3597C72.3488 30.4177 72.8939 30.3829 73.3693 30.3134C76.825 36.6449 85.2322 43.3707 90.8912 43.9273C91.9696 44.0201 92.8394 43.9041 93.5699 43.6606C93.6047 43.9389 93.6395 44.2056 93.7091 44.4955C93.8019 45.6899 94.3005 46.7568 95.1238 47.5337C96.0051 48.3687 97.1763 48.7977 98.4171 48.7514C98.8114 48.7514 99.0086 48.9137 99.0202 49.2964L99.0317 49.5399L99.1017 49.795C99.4377 51.0126 100.226 51.9867 101.282 52.5781C102.337 53.1695 103.555 53.2855 104.784 52.9376C105.155 52.81 105.398 52.9608 105.491 53.3203L105.549 53.5638L105.688 53.8073C106.326 54.8742 107.323 55.6511 108.483 55.9526C109.643 56.2425 110.895 56.057 111.985 55.4076C112.321 55.2104 112.565 55.2916 112.774 55.6163L112.901 55.8134L113.063 56.0106C113.968 56.8919 115.104 57.3905 116.31 57.3905C117.505 57.3905 118.676 56.9035 119.581 56.0106C119.847 55.7207 120.137 55.7207 120.415 55.999L120.589 56.1729L120.81 56.3005C123.036 57.6225 125.831 56.8919 127.13 54.6538C127.327 54.3059 127.617 54.2364 127.941 54.4219L128.173 54.5611L128.417 54.6538C129.623 54.9785 130.887 54.851 131.931 54.2596C132.997 53.6566 133.774 52.6593 134.111 51.4301C134.157 51.2909 134.238 51.117 134.389 51.0358C134.551 50.943 134.737 50.9894 134.853 51.001L135.108 51.0822L135.363 51.0938C137.961 51.1286 140.013 49.1572 140.071 46.5365C140.094 46.1422 140.303 45.9219 140.674 45.9451H140.941L141.184 45.8871C143.295 45.3884 144.768 43.5446 144.744 41.3877L144.733 36.5057L144.721 35.207L143.515 34.6619C136.986 31.8093 132.835 26.6721 128.672 16.3515C125.506 8.48927 120.74 3.41012 114.525 1.20684C106.465 -1.65743 98.6723 1.21844 94.7064 3.21299C89.7432 -0.880489 80.9532 -0.915277 74.3782 3.21299C70.7486 0.916929 64.8577 0.928519 60.3236 3.35214C57.6796 2.04177 53.7137 2.05336 50.5248 3.52608C48.5418 2.76073 45.376 2.49402 43.138 3.57247C41.3058 4.46538 40.3085 6.10045 40.3085 8.15298C40.3085 12.2465 43.5438 14.9136 46.6052 16.0616Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M98.7998 10.3982C98.4867 10.5722 98.2896 10.9317 98.2896 11.3027C98.2896 11.9057 98.7766 12.3928 99.3797 12.3928C99.9597 12.3928 100.458 11.8941 100.458 11.3027C100.458 10.8621 100.168 10.491 99.8087 10.3171C100.11 10.1431 100.331 9.78361 100.331 9.38936C100.331 8.78636 99.8437 8.29932 99.2407 8.29932C98.6491 8.29932 98.1504 8.78636 98.1504 9.38936C98.1504 9.84161 98.4287 10.2243 98.7998 10.3982Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M78.8427 10.1917C79.4457 10.1917 79.9328 9.70464 79.9328 9.09004C79.9328 8.49864 79.4457 8 78.8427 8C78.2513 8 77.7759 8.48704 77.7759 9.09004C77.7759 9.70464 78.2513 10.1917 78.8427 10.1917Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M64.7649 9.6953C65.3563 9.6953 65.8434 9.20825 65.8434 8.60524C65.8434 7.99064 65.3563 7.5152 64.7649 7.5152C64.1619 7.5152 63.6633 7.99064 63.6633 8.60524C63.6633 9.20825 64.1503 9.6953 64.7649 9.6953Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M54.6646 9.81116C55.2676 9.81116 55.7547 9.32416 55.7547 8.70956C55.7547 8.10655 55.2676 7.61951 54.6646 7.61951C54.0616 7.61951 53.5746 8.11815 53.5746 8.70956C53.5746 9.32416 54.0616 9.81116 54.6646 9.81116Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M54.5718 13.6844C54.6762 13.6844 54.7806 13.6728 54.8849 13.638C54.8965 14.2294 55.3836 14.7165 55.9866 14.7165C56.5664 14.7165 57.065 14.2294 57.065 13.638C57.065 13.0234 56.5664 12.5364 55.9866 12.5364C55.8706 12.5364 55.7662 12.548 55.6619 12.5827C55.6503 12.2928 55.5227 12.0145 55.3256 11.8058C55.5923 11.6203 55.7662 11.284 55.7662 10.9245C55.7662 10.3331 55.2908 9.83435 54.6878 9.83435C54.0964 9.83435 53.6094 10.3215 53.6094 10.9245C53.6094 11.226 53.7253 11.5043 53.934 11.713C53.6673 11.887 53.4934 12.2117 53.4934 12.5943C53.505 13.1858 53.9804 13.6844 54.5718 13.6844Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M65.5651 19.8304C65.7274 19.8304 65.8666 19.784 65.9941 19.7376V19.784C65.9941 20.3754 66.4812 20.874 67.0726 20.874L67.1421 20.8624C67.1653 21.4423 67.6524 21.9061 68.209 21.9061C68.325 21.9061 68.4525 21.8713 68.5453 21.8365V21.9525C68.5453 22.5555 69.0323 23.0425 69.6237 23.0425C70.2267 23.0425 70.7138 22.5671 70.7138 21.9525C70.7138 21.3379 69.5889 20.8624 69.7629 20.8624C70.3543 20.8624 70.8413 20.3638 70.8413 19.7724C70.8413 19.181 70.3543 18.6824 69.7629 18.6824L69.5658 18.7171C69.5542 18.1373 69.0787 17.6619 68.4989 17.6619C68.2438 17.6619 68.0119 17.7431 67.8379 17.9054C67.6408 17.7199 67.3857 17.5923 67.0958 17.5923C66.7943 17.5923 66.5276 17.7199 66.3188 17.917L66.1681 17.8126C66.2145 17.6967 66.226 17.2444 66.226 17.1285L66.2145 17.0125C66.4 17.1401 66.5971 17.2212 66.8406 17.2212C67.4437 17.2212 67.9191 16.8154 67.9191 16.2124C67.9191 15.5978 67.4321 15.3542 66.8406 15.3542C66.7363 15.3542 66.6551 15.3658 66.5623 15.4006C66.4928 15.2847 66.4116 15.1919 66.2956 15.0991C66.5971 14.902 66.8059 14.5541 66.8059 14.1598C66.8059 13.7192 66.516 13.3365 66.1449 13.1742C66.0637 12.9306 65.8782 12.7567 65.6462 12.6407C65.9941 12.4552 66.226 12.1073 66.226 11.6782C66.226 11.0752 65.7506 10.5882 65.136 10.5882C64.533 10.5882 64.0576 11.0752 64.0576 11.6782C64.0576 12.1073 64.3011 12.4552 64.6374 12.6407C64.3011 12.8263 64.0576 13.1857 64.0576 13.6032C64.0576 13.9047 64.1967 14.2062 64.3938 14.4149C63.9068 14.5077 63.5473 14.9484 63.5473 15.4586C63.5473 16.05 63.988 16.5023 64.533 16.5487C64.2547 16.7342 64.0692 17.0705 64.0692 17.4648C64.0692 17.8358 64.2663 18.1721 64.5562 18.3693C64.5214 18.4968 64.4982 18.6012 64.4982 18.7287C64.4866 19.3317 64.9737 19.8304 65.5651 19.8304Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M81.3011 30.0003C81.2316 30.1742 81.1736 30.3481 81.1736 30.4989C81.1736 30.9975 81.4983 31.3918 81.9389 31.5542C81.8925 31.6585 81.8577 31.7977 81.8577 31.9484C81.8577 32.5514 82.3564 33.0385 82.9594 33.0385C83.1333 33.0385 83.3305 32.9805 83.4928 32.8877V32.9457C83.4928 33.5487 83.9567 34.0126 84.5713 34.0126C84.7684 34.0126 84.9655 33.9662 85.1395 33.8734L85.1163 34.0937C85.1163 34.6967 85.5917 35.207 86.2179 35.207L86.4035 35.1722C86.6122 35.3461 86.8557 35.4621 87.1224 35.4621C87.679 35.4621 88.1545 35.033 88.2009 34.488L88.2704 34.4532C88.3748 34.6272 88.514 34.8127 88.6763 34.9287C88.3168 35.1142 88.0849 35.4737 88.0849 35.8911C88.0849 36.5173 88.572 37.0044 89.175 37.0044C89.7664 37.0044 90.2418 36.5173 90.2418 35.8911C90.2418 35.5433 90.0679 35.2186 89.7896 35.0098C90.1259 34.8243 90.3694 34.4648 90.3694 34.0241C90.3694 33.4559 89.9055 32.9805 89.3141 32.9573V32.9457C89.8939 32.9225 90.3694 32.4587 90.3694 31.8673C90.3694 31.2642 89.8823 30.754 89.2909 30.754C88.8039 30.754 88.4096 31.0787 88.2589 31.5194L88.1893 31.4846C88.2589 31.3338 88.3284 31.1483 88.3284 30.9627C88.3284 30.3597 87.8414 29.8727 87.2616 29.8727C86.9833 29.8727 86.7745 29.9655 86.589 30.1162C86.6702 29.9423 86.7513 29.7567 86.7513 29.5712C86.7513 28.945 86.2643 28.4812 85.6729 28.4812C85.3366 28.4812 85.0583 28.6087 84.8612 28.8406C84.896 28.7363 84.9076 28.6435 84.9076 28.5275C84.9076 27.9477 84.4205 27.4259 83.8059 27.4259L83.7363 27.4491C83.8059 27.3215 83.8639 27.1708 83.8639 27.0084C84.0262 27.1128 84.235 27.194 84.4321 27.194C85.0351 27.194 85.5222 26.6953 85.5222 26.0807C85.5222 25.4545 85.0351 24.9907 84.4321 24.9907C83.8755 24.9907 83.4232 25.4429 83.3653 25.988C83.2029 25.8836 82.9942 25.8256 82.7854 25.8256C82.5071 25.8256 82.0085 26.0228 81.9737 25.9996C82.1824 25.8024 82.2984 25.5357 82.2984 25.2458C82.2984 24.6428 81.7998 24.1442 81.22 24.1442C81.1272 24.1442 81.1852 23.7731 81.1852 23.518C81.1852 22.915 80.7097 22.4279 80.1067 22.4279C80.0487 22.4279 81.0692 21.9525 81.0692 21.3495C81.0692 20.7697 80.6169 20.2942 80.0255 20.2594L80.0371 20.2478C80.0371 19.8536 79.8052 19.5173 79.5037 19.3085C79.782 19.1114 79.9444 18.8099 79.9444 18.4272C79.9444 18.2533 79.898 18.1141 79.8284 17.9402C80.1995 17.7547 80.4662 17.4068 80.4662 16.9661C80.4662 16.6066 80.3038 16.2819 80.0371 16.0848C80.3154 15.8761 80.5474 15.5514 80.5474 15.1571C80.5474 14.7048 80.2691 14.3222 79.8864 14.1598C79.782 13.9163 79.5965 13.7424 79.3877 13.6148C79.724 13.4177 79.9676 13.0698 79.9676 12.6523C79.9676 12.0493 79.4805 11.5739 78.8775 11.5739C78.2861 11.5739 77.8107 12.0377 77.8107 12.6523C77.8107 13.0698 78.031 13.4177 78.3905 13.6148C78.031 13.8119 77.8107 14.1598 77.8107 14.5657C77.8107 14.8904 77.9382 15.1803 78.147 15.3658C77.6483 15.4586 77.2888 15.8993 77.2888 16.4327C77.2888 17.0125 77.7295 17.4647 78.2745 17.5111C77.9846 17.7083 77.8107 18.0446 77.8107 18.4156C77.8107 18.8099 78.0078 19.1694 78.3093 19.3549C78.0426 19.5521 77.8802 19.8768 77.8802 20.2246C77.8802 20.6769 78.1701 21.0712 78.5644 21.2335C78.1238 21.3727 77.7991 21.7669 77.7991 22.2772C77.7991 22.7642 78.1238 23.1817 78.5644 23.3208C78.4021 23.4948 78.3093 23.7267 78.3093 24.0282C78.3093 24.4921 78.6224 24.9095 79.0631 25.0487V25.0603L78.8427 25.0255C78.2513 25.0255 77.7759 25.5473 77.7759 26.1387C77.7759 26.6953 78.2049 27.194 78.7732 27.2172L78.75 27.4259C78.75 28.0405 79.237 28.5275 79.8284 28.5275L80.0023 28.5159C79.9328 28.6551 79.9096 28.8058 79.9096 28.9914C79.9096 29.5944 80.3966 30.0814 80.9996 30.0814C81.104 30.0698 81.2084 30.035 81.3011 30.0003Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M89.2909 30.0003C89.8823 30.0003 90.3694 29.5364 90.3694 28.9218C90.3694 28.3188 89.8823 27.8434 89.2909 27.8434C88.6879 27.8434 88.2125 28.3188 88.2125 28.9218C88.2125 29.5248 88.6879 30.0003 89.2909 30.0003Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M98.765 24.8007C98.4635 24.9863 98.278 25.3342 98.278 25.7052C98.278 26.2966 98.7187 26.7489 99.2757 26.7953V27.062C98.765 27.1548 98.3476 27.5954 98.3476 28.152C98.3476 28.4188 98.4287 28.6275 98.5679 28.8014C98.3824 29.0102 98.2664 29.2653 98.2664 29.5668C98.2664 30.0654 98.5911 30.4481 99.0317 30.5873C98.8694 30.796 98.7766 31.0279 98.7766 31.283C98.7766 31.6425 98.9274 31.944 99.1827 32.1411V32.3499C98.6491 32.4311 98.2664 32.8717 98.2664 33.4283C98.2664 33.8342 98.4983 34.1937 98.8462 34.3908C98.5099 34.5763 98.2664 34.9358 98.2664 35.3301C98.2664 35.6548 98.4171 35.9679 98.6375 36.1534C98.2316 36.3158 97.9533 36.6985 97.9533 37.1739C97.9533 37.6957 98.336 38.1364 98.8346 38.2408C98.4983 38.4263 98.278 38.7858 98.278 39.1916C98.278 39.7831 98.765 40.2817 99.3677 40.2817L99.5647 40.2585C99.6467 40.7803 100.087 41.1862 100.644 41.1862C100.911 41.1862 101.166 41.0934 101.351 40.9079L101.34 41.0586C101.34 41.6732 101.827 42.1603 102.418 42.1603C102.905 42.1603 103.323 41.8356 103.439 41.3833C103.589 41.8008 103.995 42.0907 104.447 42.0907C104.819 42.0907 105.155 41.8936 105.364 41.6384C105.503 42.0443 105.897 42.3458 106.372 42.3458C106.581 42.3458 106.778 42.2878 106.941 42.1835C106.964 42.7749 107.428 43.2503 108.019 43.2503C108.622 43.2503 109.109 42.7517 109.109 42.1603C109.109 42.0791 109.643 42.6357 110.095 42.6357C110.246 42.6357 110.396 42.6009 110.512 42.5545C110.709 42.7749 110.999 42.9256 111.347 42.9256C111.834 42.9256 112.24 42.5893 112.368 42.1255C112.542 42.5082 112.924 42.8097 113.388 42.8097C113.968 42.8097 114.467 42.3226 114.467 41.708C114.467 41.6269 115 42.4154 115.545 42.4154C115.789 42.4154 116.009 42.3342 116.183 42.2183C116.38 42.485 116.705 42.6705 117.064 42.6705C117.54 42.6705 117.945 42.369 118.073 41.9515C118.27 42.0907 118.491 42.1719 118.722 42.1719C119.325 42.1719 119.812 41.6848 119.812 41.0702L119.952 40.9543C119.952 41.5573 120.415 42.0443 121.018 42.0443C121.575 42.0443 122.016 41.6384 122.097 41.1166C122.294 41.2906 122.549 41.3949 122.816 41.3949C123.268 41.3949 123.651 41.1166 123.802 40.7339C124.103 40.5716 124.312 40.2585 124.358 39.9222C124.509 40.3165 124.892 40.618 125.355 40.618C125.947 40.618 126.434 40.1425 126.434 39.5279C126.434 38.9365 125.947 38.4379 125.355 38.4379C124.81 38.4379 124.358 38.8554 124.277 39.3772C124.184 39.1453 124.01 38.9597 123.813 38.8322C123.651 38.4263 123.257 38.1132 122.793 38.1132C122.375 38.1132 122.004 38.3683 121.83 38.7046C121.645 38.4727 121.343 38.3335 120.984 38.3335C120.903 38.3335 120.787 38.3567 120.671 38.3915C120.671 38.2292 120.636 38.0784 120.601 37.9393C120.937 37.7653 121.192 37.4058 121.192 36.9768C121.192 36.3622 120.694 35.8635 120.114 35.8635C119.499 35.8635 119.012 36.3622 119.012 36.9768C119.012 37.1159 119.059 37.2783 119.117 37.4058C118.757 37.5914 118.409 38.4263 118.375 38.4263L118.398 38.2639C118.398 37.6378 117.911 37.1855 117.296 37.1855C117.18 37.1855 117.076 37.1855 116.96 37.2319C116.902 36.6985 116.45 36.2578 115.893 36.2578C115.487 36.2578 115.139 36.5013 114.942 36.8492C114.757 36.5013 114.409 36.2578 113.98 36.2578C113.539 36.2578 113.145 36.5477 112.982 36.9304C112.843 36.4665 112.449 36.1302 111.927 36.1302C111.544 36.1302 110.965 36.6521 110.941 36.6521C111.046 36.4665 111.104 36.2694 111.104 36.0955C111.104 35.4693 110.628 34.9938 110.025 34.9938C109.469 34.9938 109.19 35.3881 109.19 35.0518L109.179 34.8547C109.701 34.7503 110.106 34.3096 110.106 33.7762C110.106 33.1848 109.608 32.663 109.005 32.663C108.413 32.663 107.926 33.1848 107.926 33.7762L107.95 33.9965H107.602L107.683 33.6023C107.683 32.7905 106.859 32.7094 106.755 32.6746C106.314 32.6862 105.967 32.9529 105.781 33.3356C105.688 32.8369 105.271 32.4658 104.772 32.4658C104.935 32.2687 105.027 32.0136 105.027 31.7353C105.027 31.1207 104.552 30.6452 103.949 30.6452C103.752 30.6452 103.589 30.7032 103.439 30.7612C103.485 30.6684 103.497 30.5641 103.497 30.4481L103.485 30.251H103.694C104.285 30.251 104.772 29.7639 104.772 29.1493C104.772 28.5695 104.517 28.1752 103.926 28.1752C103.334 28.1752 102.812 28.4304 102.812 29.0218L102.673 29.5668L102.349 29.648C101.977 29.648 101.827 29.8335 101.63 30.0886C101.572 29.9842 101.456 29.5784 101.398 29.474L101.514 29.4972C102.128 29.4972 102.615 29.0102 102.615 28.3956C102.615 27.781 102.128 27.3171 101.514 27.3171L101.363 27.3287C101.653 27.1896 101.873 26.9228 101.931 26.5866C102.337 26.4242 102.615 26.0299 102.615 25.5777C102.615 24.9631 102.128 24.4644 101.514 24.4644C101.27 24.4644 101.05 24.5688 100.876 24.708C100.922 24.5804 100.957 24.4413 100.957 24.2905C100.957 23.931 100.783 23.6295 100.528 23.3976C100.725 23.27 100.887 23.0729 100.957 22.8294C101.189 22.6438 101.351 22.3539 101.351 22.0176C101.351 21.403 100.853 20.916 100.261 20.916C100.145 20.916 100.029 20.9392 99.9127 20.974L99.8667 20.9508C100.215 20.7537 100.458 20.4058 100.458 19.9767C100.458 19.5824 100.261 19.2461 99.9477 19.049C100.458 18.9446 100.841 18.5156 100.841 17.9822C100.841 17.4951 100.516 17.0893 100.076 16.9501C100.308 16.7298 100.47 16.4399 100.47 16.1152C100.47 15.6977 100.226 15.3382 99.8787 15.1759C100.226 14.9787 100.47 14.6077 100.47 14.2134C100.47 13.5872 99.9707 13.1233 99.3917 13.1233C98.7882 13.1233 98.3012 13.5872 98.3012 14.2134C98.3012 14.6077 98.5331 14.9787 98.881 15.1759C98.5447 15.3498 98.3012 15.6977 98.3012 16.1152C98.3012 16.6254 98.6259 17.0197 99.0667 17.1472C98.823 17.3792 98.6839 17.6575 98.6839 17.9822C98.6839 18.3532 98.881 18.7011 99.1827 18.8983C98.6839 19.0026 98.3128 19.4201 98.3128 19.9767C98.3128 20.3942 98.5447 20.7421 98.8926 20.9508C98.5563 21.1247 98.3128 21.4958 98.3128 21.9133C98.3128 22.2264 98.4403 22.5047 98.6491 22.6902C98.162 22.7946 97.8025 23.2352 97.8025 23.7571C97.7678 24.2673 98.22 24.7428 98.765 24.8007Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M128.208 39.4468C128.811 39.4468 129.275 38.9597 129.275 38.3451C129.275 37.7537 128.811 37.2551 128.208 37.2551C127.605 37.2551 127.13 37.7421 127.13 38.3451C127.13 38.9597 127.605 39.4468 128.208 39.4468Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M125.854 44.0041L125.866 44.12C125.773 44.236 125.703 44.3404 125.645 44.4911C125.471 44.3404 125.263 44.2476 125.019 44.2476C124.521 44.2476 124.103 44.5955 123.964 45.0709C123.778 44.897 123.512 44.781 123.222 44.781C122.851 44.781 122.549 44.955 122.34 45.2333C122.143 45.0361 121.865 44.9086 121.564 44.9086C120.972 44.9086 120.473 45.3956 120.473 45.987C120.473 46.59 120.972 47.0887 121.564 47.0887C121.935 47.0887 122.248 46.9147 122.456 46.6248C122.642 46.822 122.92 46.9611 123.222 46.9611C123.72 46.9611 124.138 46.6016 124.277 46.1494C124.474 46.3233 124.729 46.4393 125.019 46.4393C125.471 46.4393 125.889 46.1378 126.028 45.7087C126.214 45.8595 126.434 45.9291 126.666 45.9291C127.107 45.9291 127.478 45.6739 127.652 45.2913C127.837 45.4536 128.081 45.5348 128.336 45.5348C128.881 45.5348 129.321 45.1289 129.403 44.5955C129.565 44.6998 129.762 44.781 130.006 44.781C130.516 44.781 130.98 44.3752 131.061 43.8533C131.246 44.0157 131.501 44.1316 131.791 44.1316C132.394 44.1316 132.87 43.6446 132.87 43.0416L132.835 42.7981C133.009 42.914 133.218 42.9836 133.438 42.9836C134.029 42.9836 134.516 42.4966 134.516 41.9168C134.69 42.0211 134.888 42.0791 135.108 42.0791C135.699 42.0791 136.186 41.5921 136.186 41.0007L136.175 40.8151C136.302 40.8731 136.465 40.9311 136.627 40.9311C137.23 40.9311 137.729 40.444 137.729 39.841C137.729 39.2148 137.23 38.7278 136.627 38.7278C136.349 38.7278 136.105 38.8438 135.896 39.0293C135.699 38.7046 135.363 38.4959 134.969 38.4959C134.366 38.4959 133.879 38.9829 133.879 39.5627C133.879 39.8874 134.006 40.1541 134.215 40.3629L134.134 40.5136C134.041 39.9802 133.612 39.5627 133.067 39.5627C132.452 39.5627 131.965 40.0614 131.965 40.6644C131.965 40.7455 131.977 40.8267 132.012 40.9311C131.815 40.7919 131.629 40.7339 131.386 40.7339C130.794 40.7339 130.307 41.221 130.307 41.824C130.307 42.2067 130.493 42.4966 130.759 42.7053L130.701 42.8792C130.585 42.7981 130.469 42.7169 130.33 42.6705C130.145 42.2878 129.785 42.0327 129.345 42.0327C128.742 42.0327 128.266 42.5198 128.266 43.1344L128.301 43.3895C128.15 43.4011 127.999 43.4243 127.86 43.4822C127.686 43.1576 127.315 42.9372 126.909 42.9372C126.33 42.914 125.854 43.3895 125.854 44.0041Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M113.527 35.0054C114.119 35.0054 114.606 34.5184 114.606 33.927C114.606 33.324 114.119 32.8369 113.527 32.8369C112.901 32.8369 112.426 33.3356 112.426 33.927C112.414 34.5184 112.901 35.0054 113.527 35.0054Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M106.755 31.0859C107.381 31.0859 107.868 30.5989 107.868 30.0074C107.868 29.3928 107.381 28.9174 106.755 28.9174C106.164 28.9174 105.677 29.3928 105.677 30.0074C105.677 30.5989 106.164 31.0859 106.755 31.0859Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M103.578 24.4065C104.181 24.4065 104.656 23.931 104.656 23.328C104.656 22.725 104.169 22.238 103.578 22.238C102.986 22.238 102.511 22.725 102.511 23.328C102.499 23.931 102.986 24.4065 103.578 24.4065Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M119.267 45.0361C118.676 45.0361 118.189 45.5348 118.189 46.1262C118.189 46.7292 118.676 47.2162 119.267 47.2162C119.87 47.2162 120.358 46.7292 120.358 46.1262C120.358 45.5348 119.87 45.0361 119.267 45.0361Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M116.461 45.0361C115.87 45.0361 115.383 45.5348 115.383 46.1262C115.383 46.7292 115.881 47.2162 116.461 47.2162C117.076 47.2162 117.551 46.7292 117.551 46.1262C117.551 45.5348 117.076 45.0361 116.461 45.0361Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M112.507 45.1637C111.904 45.1637 111.417 45.6391 111.417 46.2422C111.417 46.8452 111.892 47.3322 112.507 47.3322C113.121 47.3322 113.585 46.8452 113.585 46.2422C113.585 45.6276 113.121 45.1637 112.507 45.1637Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M66.829 41.7008C66.829 41.0978 66.3304 40.6224 65.7506 40.6224C65.1476 40.6224 64.649 41.0978 64.649 41.7008C64.649 42.3038 65.136 42.7909 65.7506 42.7909C66.3304 42.7909 66.829 42.3038 66.829 41.7008Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M69.9948 45.1101C69.9948 44.5303 69.5078 44.0201 68.8932 44.0201C68.3018 44.0201 67.8147 44.5187 67.8147 45.1101C67.8147 45.7247 68.3134 46.2234 68.8932 46.2234C69.5078 46.2234 69.9948 45.7363 69.9948 45.1101Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M80.7097 49.0761C80.7097 48.473 80.2111 47.9744 79.6197 47.9744C79.0051 47.9744 78.5412 48.473 78.5412 49.0761C78.5412 49.6791 79.0051 50.1661 79.6197 50.1661C80.2111 50.1661 80.7097 49.6791 80.7097 49.0761Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M85.5801 54.2828C85.5801 53.6797 85.1047 53.1927 84.4901 53.1927C83.8871 53.1927 83.4116 53.6913 83.4116 54.2828C83.4116 54.8742 83.8987 55.3612 84.4901 55.3612C85.1047 55.3728 85.5801 54.8742 85.5801 54.2828Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M87.9342 62.3885C88.5488 62.3885 89.0242 61.9015 89.0242 61.3101C89.0242 60.7071 88.5488 60.1968 87.9342 60.1968C87.3428 60.1968 86.8557 60.6955 86.8557 61.3101C86.8557 61.9015 87.3428 62.3885 87.9342 62.3885Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M78.9239 46.2234C78.9703 46.7916 79.4225 47.2438 80.0139 47.2438C80.2923 47.2438 80.559 47.1395 80.7445 46.9307V47.0351C80.7445 47.6497 81.2315 48.1367 81.8114 48.1367C82.2984 48.1367 82.6927 47.8121 82.8318 47.383L82.8898 47.4758C82.8086 47.6497 82.7391 47.8352 82.7391 48.044C82.7391 48.6354 83.2145 49.134 83.8175 49.134C84.4089 49.134 84.9076 48.647 84.9076 48.044C84.9076 47.9396 84.9887 47.4642 84.9539 47.383C85.1279 47.7657 85.3946 48.4151 85.8468 48.4151C86.2527 48.4151 86.6006 48.2063 86.7861 47.8932C86.9601 48.2411 87.3312 48.473 87.7486 48.473C88.0965 48.473 88.398 48.3107 88.6067 48.0556V48.4846C88.6067 48.6354 88.6183 48.7629 88.6879 48.8905C88.1777 48.9949 87.8066 49.4355 87.8066 49.9689C87.8066 50.0269 87.737 50.3632 87.7022 50.4792C87.5979 50.4096 87.4819 50.4096 87.3544 50.4096C87.0181 50.4096 86.7166 50.5604 86.5194 50.8039L86.3803 50.7923C85.8005 50.7923 85.3018 51.2793 85.3018 51.9055C85.3018 52.4969 85.8005 52.9724 86.3803 52.9724C86.7282 52.9724 86.8673 52.5781 87.0644 52.3346L87.3544 52.2998C87.4703 52.2998 87.5747 52.5781 87.6675 52.5549C87.6559 52.6129 87.6443 52.7868 87.2036 52.8448C86.7282 52.9144 86.6006 53.0767 86.6006 53.6797C86.6006 54.0508 86.589 54.5031 86.8673 54.7234C86.589 54.9089 86.3803 55.2452 86.3803 55.6163C86.3803 55.8598 86.473 56.0918 86.6238 56.2889L86.3803 56.2541C85.7889 56.2541 85.3018 56.7411 85.3018 57.3557C85.3018 57.9587 85.7889 58.4458 86.3803 58.4458C86.7977 58.4458 87.134 58.2255 87.3312 57.9124C87.5167 58.1327 87.8182 58.2602 88.1197 58.2602C88.2473 58.2602 88.3632 58.2255 88.4792 58.2023C88.456 58.295 88.4444 58.3646 88.4444 58.4458C88.4444 59.0488 88.9314 59.5474 89.5112 59.5474C90.1142 59.5474 90.6129 59.0488 90.6129 58.4458L90.5897 58.353C90.7057 58.4226 91.1231 58.5386 91.2507 58.6197C90.9608 58.8169 90.752 59.1532 90.752 59.5474C90.752 60.1504 90.9492 60.5911 91.5522 60.5911C91.7725 60.5911 91.9696 60.5215 92.132 60.4171C92.2132 60.939 92.6654 61.3448 93.2104 61.3448C93.4772 61.3448 93.7091 61.2637 93.9178 61.0897C94.0222 61.1825 94.1497 61.2637 94.2657 61.2869C93.7091 61.3332 93.2684 61.8087 93.2684 62.4001C93.2684 62.9915 93.7439 63.4785 94.3469 63.4785C94.9267 63.4785 95.4253 62.9915 95.4253 62.4001C95.4253 61.9015 95.1006 61.484 94.6948 61.3564C94.8455 61.3448 94.9847 61.3217 95.1238 61.2405C95.3094 61.5536 95.6457 61.7391 96.0283 61.7391C96.4342 61.7391 96.7937 61.5188 96.9792 61.1825V61.1941C96.9792 61.7855 97.4779 62.2841 98.0693 62.2841C98.6839 62.2841 99.1477 61.7855 99.1477 61.1941V61.1825L99.2867 61.1941V61.2985C99.2867 61.8203 99.6467 62.2493 100.11 62.3769C99.8317 62.574 99.6577 62.9103 99.6577 63.2698C99.6577 63.8612 100.134 64.3599 100.748 64.3599C101.351 64.3599 101.815 63.8612 101.815 63.2698C101.815 63.1423 101.815 63.0263 101.769 62.9219C101.92 63.0031 102.093 63.0495 102.291 63.0495C102.847 63.0495 103.311 62.6204 103.346 62.0638C103.485 62.4929 103.891 62.8292 104.378 62.8292C104.749 62.8292 105.074 62.6552 105.271 62.3421C105.271 62.9451 105.758 63.4438 106.361 63.4438L106.419 63.4322C106.523 63.9424 106.952 64.3367 107.497 64.3367C108.089 64.3367 108.576 63.8496 108.576 63.2466L108.564 63.0495C109.144 63.0379 109.596 62.5508 109.596 61.971C109.596 61.7971 109.561 61.6463 109.503 61.4956H109.654C109.759 61.9015 110.13 62.2262 110.559 62.2725C110.512 62.3769 110.501 62.4813 110.501 62.6088C110.501 63.2118 110.988 63.6989 111.591 63.6989C112.194 63.6989 112.681 63.2002 112.681 62.6088L112.623 62.3421L112.75 62.3537C113.295 62.3537 113.771 61.9478 113.84 61.4144C114.038 61.6347 114.327 61.7739 114.652 61.7739C115.116 61.7739 115.522 61.484 115.661 61.0549C115.835 61.484 116.229 61.7739 116.705 61.7739C117.203 61.7739 117.632 61.4376 117.737 60.9854C117.934 61.1593 118.201 61.2753 118.479 61.2753C119.001 61.2753 119.43 60.9042 119.534 60.4519C119.696 60.5679 119.905 60.6491 120.149 60.6491C120.729 60.6491 121.227 60.1504 121.227 59.5474C121.227 58.9444 120.729 58.4458 120.149 58.4458C119.639 58.4458 119.209 58.7937 119.094 59.2923C118.92 59.1532 118.711 59.1068 118.479 59.1068C117.992 59.1068 117.551 59.4547 117.447 59.8953C117.238 59.7098 116.971 59.6054 116.705 59.6054C116.229 59.6054 115.835 59.9185 115.661 60.3592C115.522 59.9185 115.128 59.6054 114.652 59.6054C114.385 59.6054 114.119 59.7098 113.922 59.8953C113.852 59.3967 113.411 58.9676 112.855 58.9676L112.774 58.9792C112.704 58.4806 112.24 58.0863 111.695 58.0863C111.347 58.0863 111.057 58.2371 110.849 58.4922C110.767 58.4922 110.663 58.4458 110.559 58.4458C109.967 58.4458 109.492 58.9328 109.492 59.5242C109.48 58.9328 108.993 58.4458 108.39 58.4458C107.903 58.4458 107.497 58.7937 107.358 59.2111L107.138 59.13L107.184 58.898C107.184 58.295 106.674 57.8196 106.083 57.8196C105.688 57.8196 105.34 58.0399 105.132 58.3762C105.213 58.2139 105.259 58.0399 105.259 57.8776C105.259 57.263 104.772 56.7875 104.181 56.7875C104.204 56.6832 104.227 56.5672 104.227 56.4512C104.227 55.8598 103.74 55.3612 103.149 55.3612C102.557 55.3612 102.465 55.7671 102.465 56.3701C102.465 56.602 102.151 56.9035 102.279 57.1006C102.151 57.031 102.024 56.9615 101.908 56.9035C102.024 56.7411 102.082 56.544 102.082 56.3237C102.082 55.7207 101.583 55.2336 100.992 55.2336C100.76 55.2336 100.551 55.3264 100.389 55.4424C100.273 54.9437 99.8317 54.5958 99.3447 54.5958L99.1247 54.619C99.0317 54.1088 98.6143 53.7029 98.0577 53.7029C97.7678 53.7029 97.5126 53.8421 97.3039 54.016C97.4894 53.8189 97.6054 53.5522 97.6054 53.2739C97.6054 52.7868 97.2923 52.3694 96.8401 52.2186C96.9096 52.0679 96.956 51.8939 96.956 51.7084C96.956 51.117 96.4806 50.6183 95.8776 50.6183C95.5877 50.6183 95.3094 50.7575 95.1006 50.9314C94.9383 50.5256 94.5556 50.2357 94.0918 50.2357L93.883 50.2705C93.8019 49.737 93.3496 49.3428 92.8046 49.3428L92.5611 49.3891C92.677 49.2036 92.7582 48.9949 92.7582 48.7629C92.7582 48.1715 92.2712 47.7077 91.6913 47.6845C91.7957 47.5105 91.8653 47.325 91.8653 47.1047C91.8653 46.4785 91.3666 46.0146 90.7868 46.0146C90.2882 46.0146 89.8591 46.3509 89.72 46.8148H89.6736L89.6852 46.7104C89.6852 46.1074 89.2213 45.632 88.6067 45.632C88.4444 45.632 88.2705 45.6783 88.1313 45.7363C87.9226 45.4348 87.5863 45.2261 87.2268 45.2261C86.9833 45.2261 86.7977 45.2957 86.6122 45.4116C86.5658 44.8666 86.102 44.4607 85.5569 44.4607C85.267 44.4607 85.0003 44.5767 84.8148 44.7507C84.6872 44.2984 84.2698 43.9505 83.7595 43.9505C83.5624 43.9505 83.3421 44.0201 83.1797 44.1245L83.1913 44.0201C83.1913 43.4171 82.7043 42.93 82.1013 42.93C81.823 42.93 81.5678 43.0228 81.3823 43.1852C81.3011 42.6865 80.8837 42.3386 80.3618 42.2807L80.3734 42.2111C80.3734 41.6081 79.8748 41.1326 79.295 41.1326L79.0515 41.1558C79.0862 41.0631 79.0862 40.9587 79.0862 40.8543C79.0862 40.2397 78.6224 39.7527 78.0078 39.7527C77.4976 39.7527 77.4396 39.8918 77.4396 39.4396C77.4396 38.825 76.9525 38.3611 76.3611 38.3611C76.2336 38.3611 76.1408 38.3843 76.048 38.4075C76.1292 38.2568 76.1756 38.0828 76.1756 37.9089C76.1756 37.3059 75.6886 36.8304 75.0971 36.8304C74.958 36.8304 74.8072 36.842 74.6913 36.9C74.7377 36.7956 74.7609 36.6449 74.7609 36.5057C74.7609 35.9027 74.2738 35.3925 73.6824 35.3925L73.6128 35.4157V35.207C73.6128 34.604 73.1258 34.0937 72.546 34.0937H72.5112C72.5344 34.0357 72.5576 33.9546 72.5576 33.8502C72.5576 33.2588 72.0589 32.737 71.4559 32.737C71.2008 32.737 70.9573 32.8645 70.7718 33.0153C70.6326 32.563 70.2267 32.2499 69.7513 32.2499C69.5426 32.2499 69.357 32.3195 69.1947 32.3891C69.0555 32.3195 68.87 32.2499 68.6729 32.2499C68.4989 31.8673 68.1394 31.6121 67.6872 31.6121C67.2581 31.6121 66.8522 31.8788 66.6899 32.2847H66.6783C66.8059 32.0876 66.8522 31.8788 66.8522 31.6585C66.8522 31.0555 66.3768 30.5685 65.7738 30.5685C65.6346 30.5685 65.4723 30.6265 65.3447 30.696C65.1708 30.325 64.7997 30.0582 64.3822 30.0582C64.0807 30.0582 63.8024 30.1858 63.6053 30.4061C63.6517 30.2786 63.6749 30.151 63.6749 30.0003C63.6749 29.3857 63.1994 28.8986 62.5848 28.8986C62.2717 28.8986 61.9818 29.0726 61.7963 29.2929L61.7383 29.2581C61.8311 29.0842 61.8891 28.8986 61.8891 28.7015C61.8891 28.0985 61.402 27.6114 60.8106 27.6114C60.6831 27.6114 60.5787 27.6346 60.4511 27.6694L60.4859 27.4143C60.4859 26.8113 59.9989 26.3127 59.4075 26.3127L59.3495 26.3243L59.3263 26.2431C59.3263 25.8372 59.1176 25.4893 58.7697 25.3038C58.8045 25.211 58.8393 25.0835 58.8393 24.9675C58.8393 24.3645 58.3522 23.8891 57.7492 23.8891C57.3433 23.8891 56.9723 24.1326 56.7983 24.4689C56.6012 24.1326 56.2533 23.8891 55.8358 23.8891C55.6271 23.8891 55.4068 23.9354 55.256 24.0514C55.1864 23.518 54.7458 23.1121 54.1892 23.1121C53.8645 23.1121 53.563 23.2629 53.3426 23.5064C53.3195 23.0077 52.9484 22.5787 52.4497 22.4743C52.4381 21.9061 51.9511 21.4423 51.3713 21.4423C51.2321 21.4423 51.0698 21.4886 50.9306 21.5466V21.5002C50.9306 20.8972 50.4436 20.4218 49.8406 20.4218C49.6898 20.4218 49.5739 20.4334 49.4695 20.4914L49.4811 20.3174C49.4811 19.7028 48.9941 19.2158 48.4027 19.2158C48.1939 19.2158 48.0432 19.2622 47.8924 19.3433C47.7533 18.8911 47.3474 18.5896 46.8604 18.5896C46.5009 18.5896 46.1994 18.7635 45.9906 19.007C45.9559 18.462 45.492 18.0098 44.9122 18.0098L44.7383 18.0214C44.6223 17.5227 44.1932 17.1516 43.6598 17.1516C43.3235 17.1516 42.9988 17.3256 42.8133 17.6039C42.8249 17.5227 42.8365 17.4416 42.8365 17.3372C42.8365 16.7226 42.361 16.2355 41.758 16.2355C41.6305 16.2355 41.4913 16.2819 41.3638 16.3283C41.4101 16.224 41.4217 16.1196 41.4217 16.0036C41.4217 15.4006 40.9347 14.902 40.3317 14.902L40.1809 14.9136L40.2157 14.7048C40.2157 14.2758 39.949 13.8815 39.5547 13.7076C39.5084 13.151 39.0445 12.7219 38.4763 12.7219C38.0356 12.7219 37.6414 12.9886 37.4906 13.3829C37.3051 13.1857 37.0268 13.0698 36.7253 13.0698C36.1339 13.0698 35.6352 13.5684 35.6352 14.1714C35.6352 14.4961 35.7744 14.7744 35.9947 14.9716C35.8324 15.1571 35.728 15.389 35.728 15.6789C35.728 16.2819 36.215 16.769 36.8064 16.769C36.9456 16.769 37.05 16.7342 37.1775 16.6878L37.2007 16.8617C36.7137 16.9777 36.3658 17.4068 36.3658 17.9054C36.3658 18.5084 36.8644 18.9954 37.4558 18.9954C38.0588 18.9954 38.5459 18.52 38.5459 17.9054L38.5227 17.7199C38.6618 17.6735 38.7894 17.6387 38.917 17.5227C38.9633 18.0909 39.4272 18.52 39.9838 18.52C40.3781 18.52 40.7144 18.3229 40.9115 18.0098C41.097 18.2649 41.4101 18.4156 41.7464 18.4156C42.0943 18.4156 42.4074 18.2533 42.6045 17.975L42.5814 18.2533C42.5814 18.8447 43.0568 19.3433 43.6598 19.3433L43.8453 19.3317C43.9381 19.7956 44.344 20.1319 44.8194 20.1899L44.7035 20.3174C44.1584 20.3638 43.7178 20.8045 43.7178 21.3843C43.7178 21.9409 44.1584 22.4163 44.7035 22.4627L44.6687 22.7294C44.6687 23.3208 45.1673 23.8195 45.7471 23.8195C46.1414 23.8195 46.4777 23.6223 46.6632 23.3092C46.7212 23.8659 47.1735 24.3065 47.7417 24.3065C48.2287 24.3065 48.623 23.9934 48.7737 23.5528L49.0057 23.7151L48.9593 23.9818C48.9593 24.5964 49.4347 25.0603 50.0493 25.0603C50.3276 25.0603 50.5943 24.9559 50.7915 24.782H50.919C51.0118 24.782 51.1046 24.782 51.2089 24.7356C51.3249 25.2226 51.754 25.5589 52.2642 25.5589C52.7512 25.5589 53.1455 25.2342 53.2731 24.7936C53.4818 25.1067 53.8297 25.3154 54.2124 25.3154C54.4211 25.3154 54.6298 25.2342 54.7806 25.1183C54.8038 25.3038 54.8733 25.4545 54.9545 25.5705C54.8386 25.5125 54.6994 25.4893 54.5603 25.4893C54.0268 25.4893 53.5862 25.872 53.4818 26.3822C52.9832 26.475 52.6121 26.9273 52.6121 27.4491C52.6121 28.0405 53.0991 28.5623 53.7021 28.5623L53.9225 28.5275C53.8529 28.6783 53.8297 28.7943 53.8297 28.9682C53.8297 29.5828 54.3167 30.0466 54.9081 30.0466C55.1633 30.0466 55.4068 29.9539 55.5923 29.8147L55.5691 29.8727C55.5691 30.4641 56.0678 30.9512 56.6708 30.9512C56.8331 30.9512 56.9839 30.9048 57.123 30.8584L57.1114 30.9396C57.1114 31.0439 57.1462 31.1599 57.181 31.2874C57.0766 31.2526 56.9607 31.2063 56.8331 31.2063C56.2301 31.2063 55.7547 31.7049 55.7547 32.3195C55.7547 32.9109 56.2417 33.398 56.8331 33.398C57.4245 33.398 57.9232 32.9109 57.9232 32.3195C57.9232 32.1803 57.8884 32.076 57.8536 31.9484C57.9579 32.0064 58.0739 32.018 58.1899 32.018C58.5493 32.018 58.8856 31.8441 59.0828 31.5426C59.1524 31.7513 59.2799 31.96 59.477 32.0876C59.3611 32.2383 59.3147 32.4471 59.3147 32.6558C59.3147 33.2588 59.8017 33.7458 60.3931 33.7458C60.857 33.7458 61.2513 33.4559 61.402 33.0385C61.5528 33.1196 61.7267 33.166 61.9238 33.166C62.2601 33.166 62.5616 33.0037 62.7704 32.7602L62.7472 32.8529C62.7472 33.4559 63.2458 33.943 63.8372 33.943C64.0692 33.943 64.2779 33.885 64.4634 33.7458C64.6606 33.9778 64.9505 34.1285 65.2752 34.1285C65.4259 34.1285 65.5767 34.0821 65.6926 34.0357C65.9014 34.2793 66.1913 34.4184 66.5275 34.4184C66.9682 34.4184 67.3625 34.1633 67.5248 33.7574L67.7104 33.769C67.8727 34.1517 68.2438 34.4068 68.696 34.4068C68.8932 34.4068 69.0787 34.3488 69.2295 34.2445C69.3454 34.3141 69.4498 34.372 69.5774 34.3836C69.5542 34.4764 69.5426 34.5692 69.5426 34.6619L69.299 34.6387C68.754 34.6387 68.3018 35.0446 68.2206 35.578L68.0003 35.5548C67.3973 35.5548 66.9102 36.0303 66.9102 36.6333C66.9102 36.8072 66.945 36.9696 67.0262 37.0971C66.829 36.8768 66.5159 36.7145 66.2028 36.7145C65.5998 36.7145 65.1128 37.2015 65.1128 37.8045C65.1128 38.4191 65.5998 38.8946 66.2028 38.8946C66.4464 38.8946 66.6899 38.8018 66.8754 38.6394C66.9102 38.8946 66.9914 39.1149 67.1769 39.2772C66.7827 39.4396 66.5044 39.8223 66.5044 40.2861C66.5044 40.8891 66.9914 41.3877 67.5828 41.3877C67.7452 41.3877 67.9075 41.3414 68.0582 41.2834C67.9655 41.4341 67.9191 41.6197 67.9191 41.7936C67.9191 42.3966 68.4061 42.8953 68.9975 42.8953C69.1367 42.8953 69.2643 42.8373 69.3802 42.8257C69.4846 43.3359 69.9136 43.707 70.4587 43.707C70.621 43.707 70.795 43.6722 70.9457 43.6026C70.9457 44.0317 71.1892 44.4144 71.5719 44.5767L71.5487 44.7854C71.5487 45.3884 72.0358 45.8755 72.6388 45.8755C73.0098 45.8755 73.3345 45.6899 73.5433 45.4C73.7056 45.516 73.8564 45.4116 74.0767 45.4116C74.297 45.4116 74.3898 45.3884 74.5637 45.2725L74.6449 45.6436L74.5637 45.6204C73.9607 45.6204 73.4737 46.0958 73.4737 46.6988C73.4737 47.3018 73.9607 47.812 74.5637 47.812C75.0856 47.812 75.5146 47.4294 75.6306 46.9307L75.7118 46.9423C76.3032 46.9423 76.7902 46.4553 76.7902 45.8291L76.7554 45.574L77.1265 45.6088C77.0917 45.7131 76.9757 45.8755 76.9757 45.9914C76.9757 46.606 77.312 47.0467 77.8918 47.0467C78.3789 46.9887 78.7963 46.664 78.9239 46.2234Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M123.802 59.9881C123.802 59.3851 123.303 58.8864 122.7 58.8864C122.109 58.8864 121.633 59.3851 121.633 59.9881C121.633 60.5911 122.109 61.0665 122.7 61.0665C123.303 61.0665 123.802 60.6027 123.802 59.9881Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M127.246 59.0836C127.246 58.4922 126.759 58.0051 126.144 58.0051C125.564 58.0051 125.077 58.4922 125.077 59.0836C125.077 59.6982 125.564 60.1852 126.144 60.1852C126.759 60.1852 127.246 59.6982 127.246 59.0836Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M53.389 30.209C53.389 29.5944 52.902 29.1074 52.3106 29.1074C51.7192 29.1074 51.2437 29.5944 51.2437 30.209C51.2437 30.8004 51.7308 31.2874 52.3106 31.2874C52.902 31.2874 53.389 30.7888 53.389 30.209Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M48.8201 26.046C48.8201 25.443 48.3447 24.9675 47.7533 24.9675C47.1503 24.9675 46.6516 25.4546 46.6516 26.046C46.6516 26.6606 47.1387 27.136 47.7533 27.136C48.3447 27.136 48.8201 26.649 48.8201 26.046Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M43.2887 22.5671C43.2887 21.9525 42.8017 21.4539 42.2103 21.4539C41.6189 21.4539 41.1202 21.9409 41.1202 22.5671C41.1202 23.1585 41.6189 23.6455 42.2103 23.6455C42.7901 23.6455 43.2887 23.1585 43.2887 22.5671Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M34.1741 16.4559C34.7655 16.4559 35.2525 15.9688 35.2525 15.3542C35.2525 14.7512 34.7655 14.2758 34.1741 14.2758C33.5711 14.2758 33.0724 14.7512 33.0724 15.3542C33.0724 15.9688 33.5595 16.4559 34.1741 16.4559Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M71.9778 124.266C69.0787 124.266 67.1305 126.04 67.1305 128.696C67.1305 130.992 68.6497 132.059 70.9341 132.963C73.1142 133.821 74.4362 134.482 74.4362 136.477C74.4362 138.564 72.9982 139.863 70.6906 139.863C68.0582 139.863 66.7247 138.471 66.7247 135.735V135.41H65.3911V135.955C65.3911 139.26 67.2697 141.162 70.563 141.162C73.81 141.162 75.8161 139.364 75.8161 136.477C75.8161 134.447 74.7841 133.137 72.3604 132.105L71.7922 131.861C69.8093 131.027 68.5105 130.482 68.5105 128.649C68.5105 126.748 69.8673 125.565 72.0473 125.565C74.3434 125.565 75.6074 126.794 75.6074 129.044V129.519H76.6394L76.9641 129.461V129.136C76.9525 126.075 75.0972 124.266 71.9778 124.266Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M87.3196 128.73C85.9396 128.73 84.7336 129.218 83.7363 130.18L84.9191 124.591H83.5972L80.1647 140.814H81.4867L82.7275 134.9C83.4116 131.63 84.9539 129.971 87.308 129.971C88.7575 129.971 89.4881 130.644 89.4881 131.966C89.4881 132.244 89.4533 132.557 89.3837 132.917L87.7254 140.814H89.0474L90.5201 133.763L90.5433 133.636C90.6709 133.021 90.7868 132.43 90.7868 131.873C90.7868 129.902 89.4881 128.73 87.3196 128.73Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M97.3619 128.904L94.8455 140.814H96.1675L98.6955 128.904H97.3619Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M97.675 127.061H99.1477L99.6697 124.591H98.1968L97.675 127.061Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M107.892 128.754C107.103 128.754 106.384 129.055 105.793 129.612L105.943 128.904H104.61L102.105 140.802H103.404L104.842 134.042C105.375 131.502 106.488 130.052 107.868 130.052C108.089 130.052 108.355 130.11 108.692 130.192L109.005 130.273L109.306 128.997L109.005 128.916C108.587 128.812 108.239 128.754 107.892 128.754Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M117.98 129.948C120.613 129.948 121.169 132.024 121.169 133.763C121.169 133.81 121.169 133.868 121.169 133.914H113.864C114.536 131.49 116.113 129.948 117.98 129.948ZM118.108 128.684C114.745 128.684 112.205 131.885 112.205 136.117C112.205 139.132 113.933 141.08 116.624 141.08C118.954 141.08 120.949 139.538 121.842 137.045L121.993 136.616H120.578L120.497 136.825C119.754 138.703 118.259 139.828 116.508 139.828C114.745 139.828 113.551 138.379 113.551 136.222C113.551 136.024 113.551 135.677 113.585 135.155H122.41L122.433 134.853C122.48 134.227 122.48 133.856 122.48 133.728C122.48 130.574 120.845 128.684 118.108 128.684Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M15.6201 75.701L9.65967 88.8743L3.84994 75.701H0V92.0052H2.80629L2.69032 79.203L8.32609 92.0052H10.9816L16.7334 79.1798L16.6174 92.0052H19.4121V75.701H15.6201Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M38.4067 83.8531C38.4067 87.5639 36.2498 89.686 32.5042 89.686C28.7355 89.686 26.5786 87.5639 26.5786 83.8531C26.5786 80.1423 28.7355 78.0202 32.4926 78.0202C36.2382 78.0086 38.4067 80.1423 38.4067 83.8531ZM41.329 83.8531C41.329 78.6464 37.8617 75.2835 32.4926 75.2835C27.0308 75.2835 23.6331 78.5652 23.6331 83.8531C23.6331 89.0598 27.1004 92.4227 32.4694 92.4227C37.9313 92.4111 41.329 89.1294 41.329 83.8531Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M48.3679 78.2289H53.0064C56.1489 78.2289 57.065 78.7276 57.065 80.467C57.065 82.1369 56.0909 82.7051 53.2035 82.7051H48.3795V78.2289H48.3679ZM48.3679 85.2794H53.8877C55.975 85.2794 56.5316 85.7665 56.6939 87.761L56.8911 90.0803C56.9259 90.6949 56.9955 91.3211 57.1926 91.8081L57.2738 92.0052H60.6715L60.312 91.495C59.9177 90.95 59.8713 90.3354 59.8133 89.6164L59.6162 87.0769C59.5002 85.465 58.9784 84.5141 57.9 84.0618C59.2335 83.3313 59.8945 82.0673 59.8945 80.2931C59.8945 77.3244 57.8188 75.701 54.0616 75.701H45.55V92.0052H48.3679V85.2794Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M77.486 88.3988L68.1626 75.701H64.7069V92.0052H67.5016V79.3074L76.8018 92.0052H80.2575V75.701H77.486V88.3988Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M88.3516 75.701H85.5106V92.0052H88.3516V75.701Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M96.3878 79.3074L105.688 92.0052H109.144V75.701H106.372V88.3988L97.0488 75.701H93.5931V92.0052H96.3878V79.3074Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M121.714 92.4111C124.207 92.4111 126.19 91.5646 127.501 89.9527L127.663 92.0053H129.808V82.9602H122.19V85.6621H127.083C126.677 88.1089 124.613 89.6744 121.737 89.6744C118.363 89.6744 116.264 87.4363 116.264 83.8415C116.264 80.2467 118.386 78.0086 121.807 78.0086C124.474 78.0086 126.248 79.0871 126.805 81.0468L126.875 81.2788H129.716L129.681 80.9193C129.356 77.6491 126.121 75.2719 121.993 75.2719C116.705 75.2719 113.423 78.5536 113.423 83.8415C113.388 88.9786 116.739 92.4111 121.714 92.4111Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M141.393 92.0052V78.3797H147.319V75.701H132.649V78.3797H138.564V92.0052H141.393Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M158.509 89.686C154.74 89.686 152.583 87.5639 152.583 83.8531C152.583 80.1423 154.74 78.0202 158.497 78.0202C162.266 78.0202 164.423 80.1423 164.423 83.8531C164.412 87.5639 162.255 89.686 158.509 89.686ZM167.334 83.8531C167.334 78.6464 163.867 75.2835 158.497 75.2835C153.036 75.2835 149.638 78.5652 149.638 83.8531C149.638 89.0598 153.105 92.4227 158.474 92.4227C163.948 92.4111 167.334 89.1294 167.334 83.8531Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M184.345 75.701V88.3988L175.022 75.701H171.566V92.0052H174.361V79.3074L183.661 92.0052H187.117V75.701H184.345Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M28.434 104.796C28.434 106.605 27.4483 107.185 24.3637 107.185H20.5833V102.384H24.5028C27.4831 102.384 28.434 102.975 28.434 104.796ZM25.245 99.786H17.7422V116.091H20.5833V109.666H25.245C29.3037 109.666 31.275 108.054 31.275 104.726C31.275 101.398 29.3037 99.786 25.245 99.786Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M38.1052 109.11H47.6489V106.408H38.1052V102.43H48.2751V99.786H35.2641V116.091H48.4258V113.342H38.1052V109.11Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M65.5187 112.496L56.1953 99.786H52.728V116.091H55.5343V103.393L64.8345 116.091H68.2902V99.786H65.5187V112.496Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M76.3843 99.786H73.5433V116.091H76.3843V99.786Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M94.4048 112.496L85.0815 99.786H81.6258V116.091H84.4205V103.393L93.7207 116.091H97.1879V99.786H94.4048V112.496Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M110.965 106.709L107.532 106.037C105.642 105.666 105.039 105.225 105.039 104.228C105.039 102.43 107.08 102.059 108.784 102.059C111.324 102.059 112.507 102.871 112.646 104.692L112.669 104.993H115.487V104.668C115.441 101.259 113.121 99.3804 108.958 99.3804C104.575 99.3804 102.07 101.224 102.07 104.436C102.07 106.895 103.589 108.321 106.836 108.901L110.698 109.597C112.704 109.956 113.11 110.582 113.11 111.487C113.11 112.96 111.66 113.806 109.121 113.806C106.083 113.806 104.633 112.751 104.552 110.478L104.54 110.165H101.572L101.583 110.49C101.653 114.49 104.146 116.508 108.993 116.508C113.481 116.508 116.055 114.606 116.055 111.29C116.055 108.286 114.107 107.312 110.965 106.709Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M131.919 109.005C131.919 112.322 130.62 113.737 127.559 113.737C124.544 113.737 123.21 112.275 123.21 109.005V99.786H120.369V109.933C120.369 114.166 122.92 116.508 127.559 116.508C132.197 116.508 134.76 114.177 134.76 109.933V99.786H131.919V109.005Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M142.286 99.786H139.456V116.091H151.818V113.342H142.286V99.786Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M165.154 108.947H160.04L162.672 103.358L165.154 108.947ZM161.397 99.786L153.697 116.091H156.735L158.811 111.626H166.348L168.331 116.091H171.323L164.11 99.786H161.397Z",
            fill: "#182281"
          }
        )
      ]
    }
  );
}
function GZ(e) {
  return /* @__PURE__ */ R(
    "svg",
    {
      width: "82",
      height: "22",
      viewBox: "0 0 82 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ R("g", { clipPath: "url(#clip0_982_12)", children: [
          /* @__PURE__ */ s(
            "path",
            {
              d: "M7.63302 5.31663C7.92132 5.31663 8.15502 5.08292 8.15502 4.79463C8.15502 4.50634 7.92132 4.27263 7.63302 4.27263C7.34473 4.27263 7.11102 4.50634 7.11102 4.79463C7.11102 5.08292 7.34473 5.31663 7.63302 5.31663Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              d: "M7.63299 0C6.09197 0.00187383 4.61459 0.614874 3.52492 1.70454C2.43525 2.79421 1.82225 4.27159 1.82038 5.81261C1.81856 7.07197 2.22998 8.29715 2.99152 9.30018C2.99152 9.30018 3.15004 9.50864 3.17551 9.53887L7.63299 14.5648L12.0923 9.53659C12.1158 9.50843 12.2745 9.29997 12.2745 9.29997L12.2753 9.2987C13.0363 8.29605 13.4475 7.0714 13.4456 5.81261C13.4437 4.27159 12.8307 2.79421 11.7411 1.70454C10.6514 0.614874 9.17402 0.00187383 7.63299 0ZM7.63299 3.17052C7.94652 3.17052 8.25302 3.26349 8.51371 3.43768C8.77441 3.61187 8.97759 3.85945 9.09758 4.14912C9.21756 4.43879 9.24895 4.75753 9.18779 5.06504C9.12662 5.37255 8.97564 5.65502 8.75394 5.87672C8.53223 6.09842 8.24977 6.2494 7.94226 6.31057C7.63475 6.37174 7.31601 6.34034 7.02634 6.22036C6.73667 6.10038 6.48909 5.89719 6.3149 5.63649C6.14071 5.3758 6.04773 5.06931 6.04773 4.75577C6.04819 4.33548 6.21536 3.93253 6.51255 3.63534C6.80975 3.33814 7.2127 3.17098 7.63299 3.17052ZM9.74667 8.98313H8.68983V7.92629H6.57615V8.98313H5.51931V7.92629C5.51964 7.64609 5.63108 7.37747 5.82921 7.17935C6.02734 6.98122 6.29596 6.86977 6.57615 6.86945H8.68983C8.97002 6.86977 9.23865 6.98122 9.43677 7.17935C9.6349 7.37747 9.74635 7.64609 9.74667 7.92629V8.98313Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M1.52294 13.5965L3.7864 12.3947L2.69125 11.8508L0.256336 13.1713C0.0978611 13.2566 -0.000691396 13.4224 3.65235e-06 13.6023C0.00069873 13.7823 0.100528 13.9473 0.259658 14.0314L7.39761 17.8038C7.54122 17.8797 7.71321 17.879 7.85626 17.8021L14.8684 14.0297C15.0262 13.9448 15.1247 13.7801 15.1248 13.6009C15.125 13.4217 15.0268 13.2568 14.8691 13.1716L12.5084 11.8508L11.4315 12.447L13.6103 13.5996L7.62331 16.8205L1.52294 13.5965Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M1.51805 17.1073L2.27632 16.6897L1.19879 16.1181L0.254173 16.6859C0.0965182 16.7718 -0.00113655 16.9375 9.98623e-06 17.117C0.00115652 17.2965 0.100919 17.4609 0.259658 17.5448L7.39761 21.3172C7.54122 21.3931 7.71321 21.3924 7.85626 21.3155L14.8684 17.5431C15.0257 17.4585 15.1241 17.2945 15.1248 17.1159C15.1256 16.9372 15.0285 16.7725 14.8718 16.6865L13.9965 16.1573L12.9404 16.739L13.6164 17.1097L7.6233 20.3339L1.51805 17.1073Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              d: "M80.1641 16.5194C79.6219 16.5194 79.1195 16.4317 78.657 16.2563C78.2105 16.0649 77.8198 15.7938 77.4848 15.4429C77.1659 15.0921 76.9107 14.6774 76.7193 14.199C76.5439 13.7205 76.4562 13.1783 76.4562 12.5723V7.90753H74.7817V5.63495H75.4993C76.3765 5.63495 76.815 5.19639 76.815 4.31925V2.76433H79.2072V5.39573H81.5994V7.90753H79.2072V12.4527C79.2072 12.9311 79.3428 13.3139 79.6139 13.6009C79.901 13.8721 80.2837 14.0076 80.7621 14.0076C80.8897 14.0076 80.9934 14.0076 81.0731 14.0076C81.1529 13.9917 81.2246 13.9757 81.2884 13.9598C81.3522 13.9438 81.416 13.9199 81.4798 13.888V16.2802C81.3682 16.328 81.2406 16.3679 81.0971 16.3998C80.8259 16.4795 80.515 16.5194 80.1641 16.5194Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              d: "M68.5733 16.5194C67.8238 16.5194 67.1141 16.3758 66.4443 16.0888C65.7904 15.7857 65.2083 15.3791 64.698 14.8687C64.2036 14.3584 63.8049 13.7683 63.5019 13.0985C63.2148 12.4128 63.0713 11.6792 63.0713 10.8977C63.0713 10.1163 63.2148 9.39064 63.5019 8.72083C63.8049 8.03507 64.2036 7.43702 64.698 6.92669C65.2083 6.41635 65.7904 6.01766 66.4443 5.73059C67.1141 5.42758 67.8238 5.27608 68.5733 5.27608C69.3229 5.27608 70.0246 5.42758 70.6784 5.73059C71.3483 6.01766 71.9304 6.41635 72.4247 6.92669C72.9351 7.43702 73.3338 8.03507 73.6208 8.72083C73.9238 9.39064 74.0753 10.1163 74.0753 10.8977C74.0753 11.6792 73.9238 12.4128 73.6208 13.0985C73.3338 13.7683 72.9351 14.3584 72.4247 14.8687C71.9304 15.3791 71.3483 15.7857 70.6784 16.0888C70.0246 16.3758 69.3229 16.5194 68.5733 16.5194ZM68.5733 13.8879C69.3548 13.8879 70.0086 13.6168 70.5349 13.0746C71.0612 12.5324 71.3243 11.8067 71.3243 10.8977C71.3243 9.98869 71.0612 9.26306 70.5349 8.72083C70.0086 8.1786 69.3548 7.90748 68.5733 7.90748C67.7919 7.90748 67.138 8.1786 66.6117 8.72083C66.0854 9.26306 65.8223 9.98869 65.8223 10.8977C65.8223 11.8067 66.0854 12.5324 66.6117 13.0746C67.138 13.6168 67.7919 13.8879 68.5733 13.8879Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              d: "M54.5894 1.32898H57.46V13.6487H61.6473C61.6473 13.6487 62.5017 15.5454 63.6408 16.3998C63.356 16.3998 54.5894 16.3998 54.5894 16.3998V1.32898Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              d: "M45.1468 20.347C45.0192 20.347 44.8916 20.339 44.764 20.323C44.6524 20.323 44.5567 20.3151 44.477 20.2991C44.3653 20.2832 44.2696 20.2593 44.1899 20.2274V17.9548C44.7959 17.9548 45.2584 17.8192 45.5774 17.5481C45.9123 17.277 46.1674 16.9341 46.3429 16.5195L46.5821 15.9214L42.3958 5.3958H45.2664L48.0174 12.5724L50.5292 5.3958H53.3998C52.6184 7.40523 51.9087 9.2233 51.2708 10.85C50.9997 11.5517 50.7285 12.2375 50.4574 12.9073C50.2023 13.5771 49.971 14.1911 49.7637 14.7492C49.5564 15.2915 49.3809 15.746 49.2374 16.1128C49.0939 16.4796 49.0062 16.6949 48.9743 16.7587C48.7032 17.4126 48.432 17.9628 48.1609 18.4093C47.9058 18.8718 47.6267 19.2466 47.3237 19.5336C47.0206 19.8207 46.6937 20.028 46.3429 20.1556C45.992 20.2832 45.5933 20.347 45.1468 20.347Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              d: "M26.1289 5.39569H28.1623L28.6407 6.47217C28.864 6.2489 29.1112 6.04955 29.3823 5.87412C29.6056 5.73059 29.8767 5.59504 30.1956 5.46745C30.5146 5.33987 30.8734 5.27608 31.2721 5.27608C31.8303 5.27608 32.3087 5.35582 32.7074 5.5153C33.1061 5.65883 33.4331 5.81831 33.6882 5.99373C33.9753 6.20106 34.2065 6.44028 34.382 6.71139C34.6371 6.44028 34.9322 6.20106 35.2671 5.99373C35.5541 5.81831 35.897 5.65883 36.2957 5.5153C36.6944 5.35582 37.133 5.27608 37.6114 5.27608C38.8075 5.27608 39.7644 5.65883 40.482 6.42433C41.1997 7.18983 41.5585 8.32213 41.5585 9.82123V16.3997H38.8075V10.0605C38.8075 9.39064 38.6241 8.86436 38.2573 8.48161C37.9064 8.09886 37.4918 7.90748 37.0134 7.90748C36.5349 7.90748 36.1123 8.09886 35.7455 8.48161C35.3946 8.86436 35.2192 9.39064 35.2192 10.0605V16.3997H32.4682V10.0605C32.4682 9.39064 32.2848 8.86436 31.918 8.48161C31.5671 8.09886 31.1525 7.90748 30.6741 7.90748C30.1956 7.90748 29.773 8.09886 29.4062 8.48161C29.0553 8.86436 28.8799 9.39064 28.8799 10.0605V16.3997H26.1289V5.39569Z",
              fill: "#0157FF"
            }
          )
        ] }),
        /* @__PURE__ */ s("defs", { children: /* @__PURE__ */ s("clipPath", { id: "clip0_982_12", children: /* @__PURE__ */ s("rect", { width: "81.5994", height: "21.3736", fill: "white" }) }) })
      ]
    }
  );
}
function Gc({ className: e, ...t }) {
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      className: F("h-4 w-4", e),
      ...t,
      children: /* @__PURE__ */ s(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
        }
      )
    }
  );
}
function nn({ className: e }) {
  return /* @__PURE__ */ R(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      className: e,
      children: [
        /* @__PURE__ */ s(
          "mask",
          {
            id: "mask0_4938_6991",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "24",
            height: "24",
            children: /* @__PURE__ */ s("rect", { width: "24", height: "24", fill: "#D9D9D9" })
          }
        ),
        /* @__PURE__ */ s("g", { mask: "url(#mask0_4938_6991)", children: /* @__PURE__ */ s(
          "path",
          {
            d: "M14 21L12.575 19.575L16.175 16H5V4H7V14H16.175L12.575 10.4L13.975 8.975L20 15L14 21Z",
            fill: "currentcolor"
          }
        ) })
      ]
    }
  );
}
function zZ({
  latitude: e,
  longitude: t,
  addressBoundary: n,
  nearObjects: r,
  className: o
}) {
  const i = Je(null), l = Je([]), c = Je([]), f = Je([]), p = Je([]);
  return Oe(() => {
    if (!i.current) {
      let h;
      if (e != null && t != null)
        h = { lat: e, lng: t };
      else if (n && n.length > 0) {
        const w = n.reduce((_, P) => _ + P.latitude, 0) / n.length, N = n.reduce((_, P) => _ + P.longitude, 0) / n.length;
        h = { lat: w, lng: N };
      } else {
        console.warn("No latitude, longitude, or addressBoundary provided");
        return;
      }
      const b = {
        zoom: 18,
        // Zoom level to display the area in detail
        center: h,
        mapTypeId: google.maps.MapTypeId.SATELLITE
        // Set to satellite view
      };
      i.current = new google.maps.Map(
        document.getElementById("map"),
        b
      ), console.log("Map initialized with center:", h);
    }
    const m = i.current;
    if (!m) return;
    l.current.forEach((h) => h.setMap(null)), c.current.forEach((h) => h.setMap(null)), f.current.forEach((h) => h.setMap(null)), p.current.forEach((h) => h.close()), l.current = [], c.current = [], f.current = [], p.current = [];
    const v = {
      WATER: {
        strokeColor: "#0000FF",
        fillColor: "#0000FF",
        strokeOpacity: 0.5,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Blue
      ROAD: {
        strokeColor: "#808080",
        fillColor: "#808080",
        strokeOpacity: 0.4,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Gray
      OVERLAY: {
        strokeColor: "#FFFF00",
        fillColor: "#FFFF00",
        strokeOpacity: 0.3,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Yellow
      ZONE: {
        strokeColor: "#800080",
        fillColor: "#800080",
        strokeOpacity: 0.6,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Purple
      BUSHFIRE_PRONE_AREA: {
        strokeColor: "#FF0000",
        fillColor: "#FF0000",
        strokeOpacity: 0.5,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Red
      SIGNIFICANT_TREE: {
        strokeColor: "#228800",
        fillColor: "#228800",
        strokeOpacity: 0.5,
        fillOpacity: 0.05,
        strokeWeight: 2
      }
    }, C = (h, b) => {
      const w = new google.maps.Polygon({
        paths: h,
        strokeColor: b.strokeColor,
        strokeOpacity: b.strokeOpacity,
        strokeWeight: b.strokeWeight,
        fillColor: b.fillColor,
        fillOpacity: b.fillOpacity
      });
      return w.setMap(m), l.current.push(w), w;
    }, x = (h, b) => {
      const w = new google.maps.Polyline({
        path: h,
        geodesic: !0,
        strokeColor: b.strokeColor,
        strokeOpacity: b.strokeOpacity,
        strokeWeight: b.strokeWeight
      });
      return w.setMap(m), c.current.push(w), w;
    }, y = (h, b) => {
      const w = new google.maps.Marker({
        position: h,
        map: m,
        title: b.object_name
      });
      f.current.push(w);
      const N = `
        <div>
          <h3>${b.object_name}</h3>
          <p>Type: ${b.object_type}</p>
          <p>Sub-Type: ${b.object_sub_type}</p>
          <p>Distance: ${b.object_distance} m</p>
        </div>
      `, _ = new google.maps.InfoWindow({
        content: N
      });
      p.current.push(_), w.addListener("click", () => {
        console.log(`Marker for ${b.object_name} clicked.`), p.current.forEach((P) => P.close()), _.open(m, w);
      });
    };
    if (n && n.length > 0) {
      const h = n.map(
        (w) => ({
          lat: w.latitude,
          lng: w.longitude
        })
      ), b = new google.maps.LatLngBounds();
      h.forEach((w) => b.extend(w)), m.fitBounds(b), console.log("Map bounds adjusted to boundary polygon:", b), C(h, {
        strokeColor: "#FF0000",
        fillColor: "#FF0000",
        strokeOpacity: 0.8,
        fillOpacity: 0,
        strokeWeight: 2
      });
    }
    return r && r.length > 0 && r.forEach((h, b) => {
      if (console.log(`Processing nearObject ${b}:`, h), !h.geo_data || !Array.isArray(h.geo_data)) {
        console.warn(
          `nearObjects[${b}].geo_data is undefined or not an array.`
        );
        return;
      }
      const w = h.geo_data.length;
      if (w === 1) {
        const N = {
          lat: h.geo_data[0][1],
          lng: h.geo_data[0][0]
        };
        y(N, h);
      } else if (w === 2) {
        const N = h.geo_data.map(
          (P, A) => ({ lat: P[1], lng: P[0] })
        ), _ = {
          strokeColor: v[h.object_type].strokeColor,
          strokeOpacity: v[h.object_type].strokeOpacity,
          strokeWeight: 2
        };
        x(N, _);
      } else if (w >= 3) {
        const N = h.geo_data.map(
          (T, M) => ({ lat: T[1], lng: T[0] })
        ), _ = v[h.object_type];
        if (!_) {
          console.warn(
            `nearObjects[${b}] has an unknown object_type: ${h.object_type}`
          );
          return;
        }
        const P = C(N, _), A = `
            <div>
              <h3>${h.object_name}</h3>
              <p>Type: ${h.object_type}</p>
              <p>Sub-Type: ${h.object_sub_type}</p>
              <p>Distance: ${h.object_distance} m</p>
            </div>
          `, I = new google.maps.InfoWindow({
          content: A
        });
        p.current.push(I), P.addListener("click", (T) => {
          T.latLng ? (console.log(`Polygon ${b} clicked at:`, {
            lat: T.latLng.lat(),
            lng: T.latLng.lng()
          }), p.current.forEach((M) => M.close()), I.setPosition(T.latLng), I.open(m)) : console.warn(
            `Clicked position is undefined for polygon ${b}.`
          );
        });
      } else
        console.warn(
          `nearObjects[${b}] has invalid geo_data length: ${w}`
        );
    }), () => {
      console.log("Cleaning up map overlays."), l.current.forEach((h) => h.setMap(null)), c.current.forEach((h) => h.setMap(null)), f.current.forEach((h) => h.setMap(null)), p.current.forEach((h) => h.close()), l.current = [], c.current = [], f.current = [], p.current = [];
    };
  }, [e, t, n, r]), /* @__PURE__ */ s(
    "div",
    {
      id: "map",
      className: o,
      style: { width: "100%", height: "500px" },
      children: e == null && t == null && (!n || n.length === 0) ? /* @__PURE__ */ s("p", { children: "Please provide latitude and longitude or an address boundary to display the map." }) : null
    }
  );
}
function qZ({ className: e }) {
  return /* @__PURE__ */ s("div", { className: F("grid-loader relative h-[160px]", e), children: /* @__PURE__ */ s("div", { className: "absolute inset-0 flex flex-col", children: Array.from({ length: 8 }).map((t, n) => /* @__PURE__ */ s("div", { className: "flex grow", children: Array.from({ length: 24 }).map((r, o) => /* @__PURE__ */ s(
    "div",
    {
      className: "grow border-2 border-[#FCFCF9]"
    },
    o
  )) }, n)) }) });
}
var dl = /* @__PURE__ */ ((e) => (e.none = "none", e.loading = "loading", e.done = "done", e))(dl || {});
function KZ({ items: e }) {
  const t = (n) => {
    switch (n.status) {
      case dl.done:
        return /* @__PURE__ */ R("span", { className: "text-successDefault flex gap-1 text-base", children: [
          /* @__PURE__ */ s("span", { className: "w-6", children: /* @__PURE__ */ s(wo, {}) }),
          /* @__PURE__ */ s("span", { className: "line-through", children: n.text })
        ] });
      case dl.loading:
        return /* @__PURE__ */ R("span", { className: "flex gap-1 text-base", children: [
          /* @__PURE__ */ s("span", { className: "w-6", children: /* @__PURE__ */ s(So, { className: "animate-spin" }) }),
          /* @__PURE__ */ s("span", { className: "text-textPrimary", children: n.text })
        ] });
      case dl.none:
        return /* @__PURE__ */ R("span", { className: "flex gap-1 text-base", children: [
          /* @__PURE__ */ s("span", { className: "w-6", children: n.icon }),
          /* @__PURE__ */ s("span", { className: "text-textDisabled", children: n.text })
        ] });
    }
  };
  return /* @__PURE__ */ s("ul", { className: "flex flex-col space-y-2", children: e.map((n, r) => /* @__PURE__ */ s("li", { children: t(n) }, r)) });
}
function qK({ message: e, hideTime: t = !1 }) {
  return /* @__PURE__ */ s(le, { children: /* @__PURE__ */ R(
    "div",
    {
      className: `flex w-full flex-col ${e.sender_account_type === fd.USER ? "pl-5 md:pl-20" : "pr-5 md:pr-20"}`,
      children: [
        /* @__PURE__ */ s(
          "div",
          {
            hidden: t,
            className: `mb-0.5 flex w-full flex-row items-center ${e.sender_account_type === fd.USER ? "justify-end" : "justify-start"}`,
            children: /* @__PURE__ */ s("div", { className: "text-textSubdued ml-1 text-xs leading-[18px]", children: new Date(e.created_at || "").toLocaleDateString("en-AU", {
              hour: "2-digit",
              minute: "2-digit",
              year: "2-digit",
              month: "2-digit",
              day: "2-digit",
              timeZone: "Australia/Sydney"
            }) })
          }
        ),
        /* @__PURE__ */ s(
          "div",
          {
            className: `text-textPrimary rounded-lg bg-[#F5F5F5] px-5 py-2 text-lg leading-[22px] ${e.sender_account_type === fd.USER ? "bg-actionDefault text-textWhite self-end" : "self-start"}`,
            children: Be(e.text || "", {
              components: {
                h1({ children: n }) {
                  return /* @__PURE__ */ s(le, { children: n });
                },
                h2({ children: n }) {
                  return /* @__PURE__ */ s(le, { children: n });
                },
                h3({ children: n }) {
                  return /* @__PURE__ */ s(le, { children: n });
                },
                h4({ children: n }) {
                  return /* @__PURE__ */ s(le, { children: n });
                },
                h5({ children: n }) {
                  return /* @__PURE__ */ s(le, { children: n });
                },
                h6({ children: n }) {
                  return /* @__PURE__ */ s(le, { children: n });
                },
                p({ children: n }) {
                  return /* @__PURE__ */ s("p", { children: n });
                }
              }
            })
          }
        )
      ]
    }
  ) });
}
function YZ({
  conversation: e,
  conversationMessages: t
}) {
  return /* @__PURE__ */ R("div", { className: "h-full min-h-0 grow", children: [
    /* @__PURE__ */ R("div", { className: "mb-0.5 flex flex-col pr-5 md:pr-20", children: [
      /* @__PURE__ */ s("div", { className: "text-textSubdued text-xs leading-[18px]", children: new Date((e == null ? void 0 : e.created_at) || "").toLocaleDateString(
        "en-AU",
        {
          hour: "2-digit",
          minute: "2-digit",
          year: "2-digit",
          month: "2-digit",
          day: "2-digit",
          timeZone: "Australia/Sydney"
        }
      ) }),
      /* @__PURE__ */ R("div", { className: "text-textPrimary self-start rounded-lg bg-[#F5F5F5] px-5 py-2 text-lg leading-[22px]", children: [
        "Thanks, I’ve pulled up the lot details for",
        " ",
        lP((e == null ? void 0 : e.address) || ""),
        ". You can find a summary in the ",
        /* @__PURE__ */ s("span", { className: "font-semibold", children: "Lot tab" }),
        ".",
        /* @__PURE__ */ s("br", {}),
        /* @__PURE__ */ s("br", {}),
        "Now I’ll guide you through a few questions. You can also ask me a question or just say “I don’t know”."
      ] })
    ] }),
    t.length > 0 && t.map((n, r) => /* @__PURE__ */ s("div", { className: "message-styles mb-3 last:mb-0", children: /* @__PURE__ */ s(qK, { message: n }) }, r))
  ] });
}
const KK = [
  {
    items: [
      {
        experts: [["existing_landuse_assessor", "existing_landuse_conclusion"]],
        title: "Existing land use"
      },
      {
        experts: [
          ["proposed_land_use_assessor", "proposed_land_use_assessment"]
        ],
        title: "Proposed land use"
      },
      {
        experts: [["land_use_assessor_checker", "output"], "land_use_assessor"],
        title: "Land use"
      },
      {
        experts: ["zone_assessor_checker", "zone_works_report"],
        title: "Buildings and works"
      },
      {
        experts: ["vicsmart_classifier"],
        title: "VicSmart"
      }
    ],
    title: "Zone"
  },
  {
    items: [
      {
        experts: [
          "bmo_overlay_checker",
          ["bmo_overlay_assessor", "final_output"]
        ],
        title: "Bushfire Management Overlay (BMO)"
      },
      {
        experts: [
          "emo_overlay_checker",
          ["emo_overlay_assessor", "final_output"]
        ],
        title: "Erosion Management Overlay (EMO)"
      },
      {
        experts: [
          "LSIO_overlay_checker",
          ["lsio_overlay_assessor", "final_output"]
        ],
        title: "Land Subject To Inundation Overlay (LSIO)"
      },
      {
        experts: [
          "slo_overlay_checker",
          ["slo_overlay_assessor", "final_output"]
        ],
        title: "Significant Landscape Overlay (SLO)"
      },
      {
        experts: [
          "ddo_overlay_checker",
          ["ddo_overlay_assessor", "final_output"]
        ],
        title: "Design and Development Overlay (DDO)"
      },
      {
        experts: [
          "vpo_overlay_checker",
          ["vpo_overlay_assessor", "final_output"]
        ],
        title: "Vegetation Protection Overlay (VPO)"
      },
      {
        experts: [
          "sbo_overlay_checker",
          ["sbo_overlay_assessor", "final_output"]
        ],
        title: "Special Building Overlay (SBO)"
      },
      {
        experts: [["ho_overlay_assessor", "ho_overlay_report"]],
        title: "Heritage Overlay (HO)"
      },
      {
        experts: [["eso_overlay_assessor", "final_output"]],
        title: "Environmental Significance Overlay (ESO)"
      },
      {
        experts: ["slo_vicsmart_classifier"],
        title: "VicSmart Significant Landscape Overlay (SLO)"
      },
      {
        experts: ["emo_vicsmart_classifier"],
        title: "VicSmart Erosion Management Overlay (EMO)"
      },
      {
        experts: ["eso_vicsmart_classifier"],
        title: "VicSmart Environmental Significance Overlay (ESO)"
      },
      {
        experts: ["sbo_vicsmart_classifier"],
        title: "VicSmart Special Building Overlay (SBO)"
      },
      {
        experts: ["ddo_vicsmart_classifier"],
        title: "VicSmart Design and Development Overlay (DDO)"
      },
      {
        experts: ["vpo_vicsmart_classifier"],
        title: "VicSmart Vegetation Protection Overlay (VPO)"
      },
      {
        experts: ["ho_vicsmart_classifier"],
        title: "VicSmart Heritage Overlay (HO)"
      }
    ],
    title: "Overlay"
  },
  {
    items: [
      {
        experts: ["vicsmart_classifier_combined"],
        title: "VicSmart classifier"
      }
    ],
    title: "VicSmart"
  },
  {
    items: [
      {
        experts: ["mandatory_requirements_combined"],
        title: "Combined mandatory requirements"
      },
      {
        experts: ["zone_mandatory_requirements"],
        title: "Zone mandatory requirements"
      },
      {
        experts: ["DDO_mandatory_requirements"],
        title: "DDO mandatory requirements"
      }
    ],
    title: "Mandatory requirements"
  },
  {
    items: [
      {
        experts: ["application_requirements"],
        title: "Application requirements"
      }
    ],
    title: "Application requirements"
  },
  {
    items: [{ experts: ["significant_GIS"], title: "Significant GIS" }],
    title: "GIS Data"
  }
], Z2 = /^(No).*(at this address)$/;
function YK({
  experts: e,
  info: t,
  noticeboardData: n,
  title: r
}) {
  const o = (f) => {
    if (Array.isArray(f)) {
      const [p, m] = f, v = n == null ? void 0 : n[p].parsed_output, C = (v == null ? void 0 : v[m]) || "";
      return ["", "No content"].includes(C) ? "Not applicable to this address" : C;
    } else if (f) {
      const p = n == null ? void 0 : n[f], m = (p == null ? void 0 : p.raw_output) || "";
      return ["", "No content"].includes(m) ? "Not applicable to this address" : m;
    }
    return "";
  }, i = hn(
    (f) => {
      var p;
      if (Array.isArray(f)) {
        const [m, v] = f;
        return n && m in n && "parsed_output" in n[m] && ((p = n[m].parsed_output) == null ? void 0 : p[v]) && !Z2.test(
          n[m].parsed_output[v]
        );
      } else {
        const m = f;
        return n && m in n && n[m].raw_output && !Z2.test(n[m].raw_output);
      }
    },
    [n]
  ), l = gn(() => e.find((f) => i(f)), [i, e]), c = gn(() => Array.isArray(l) ? l[0] : l, [l]);
  return c ? /* @__PURE__ */ R(co, { className: "border-interactiveBorder", value: c, children: [
    /* @__PURE__ */ s(uo, { className: "!px-4 !py-3 text-lg leading-5 !font-semibold", children: /* @__PURE__ */ R("span", { className: "flex gap-2 items-center", children: [
      r,
      t ? /* @__PURE__ */ R(pb, { children: [
        /* @__PURE__ */ s(mb, { children: /* @__PURE__ */ s(xP, { className: "text-textLink" }) }),
        /* @__PURE__ */ s(lm, { children: t })
      ] }) : null
    ] }) }),
    /* @__PURE__ */ s(fo, { className: "p-5 pt-0", children: Be(o(l)) })
  ] }) : null;
}
const X2 = /^(No).*(at this address)$/;
function ZK({
  onChange: e,
  noticeboardData: t,
  sections: n
}) {
  const r = (o) => o.some(
    (i) => i.experts.some((l) => {
      var c, f;
      if (Array.isArray(l)) {
        const [p, m] = l;
        return t && p in t && "parsed_output" in t[p] && ((f = (c = t[p]) == null ? void 0 : c.parsed_output) == null ? void 0 : f[m]) && !X2.test(
          t[p].parsed_output[m]
        );
      } else {
        const p = l;
        return t && p in t && t[p].raw_output && !X2.test(t[p].raw_output);
      }
    })
  );
  return /* @__PURE__ */ s(fb, { children: /* @__PURE__ */ R("div", { className: "border-interfaceBorder bg-interfaceWhite flex flex-col gap-6 rounded-lg border px-10 py-8", children: [
    /* @__PURE__ */ s("span", { className: "text-textPrimary text-lg leading-5", children: "How myLot got to its answer by zone and overlay. This is not shown to the customer." }),
    n.map((o, i) => {
      if (r(o.items))
        return /* @__PURE__ */ R("div", { children: [
          /* @__PURE__ */ s("span", { className: "text-textPrimary text-2xl font-semibold leading-7", children: o.title }),
          /* @__PURE__ */ s(
            hi,
            {
              className: "!border-interactiveBorder mt-3 rounded-[4px] border",
              onValueChange: (l) => e == null ? void 0 : e(o.title, l),
              type: "multiple",
              children: o.items.map((l, c) => /* @__PURE__ */ s(
                YK,
                {
                  experts: l.experts,
                  info: l.info,
                  title: l.title,
                  noticeboardData: t
                },
                c
              ))
            }
          )
        ] }, i);
    })
  ] }) });
}
ZK.defaultReasoningPanelSections = KK;
function b1() {
  return b1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, b1.apply(null, arguments);
}
function XK(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
var jK = y1, QK = function(t) {
  var n = d.useRef(t);
  return jK(function() {
    n.current = t;
  }), n;
}, j2 = function(t, n) {
  if (typeof t == "function") {
    t(n);
    return;
  }
  t.current = n;
}, JK = function(t, n) {
  var r = Je();
  return hn(function(o) {
    t.current = o, r.current && j2(r.current, null), r.current = n, n && j2(n, o);
  }, [n]);
}, Q2 = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0"
}, eY = function(t) {
  Object.keys(Q2).forEach(function(n) {
    t.style.setProperty(n, Q2[n], "important");
  });
}, J2 = eY, Ft = null, e3 = function(t, n) {
  var r = t.scrollHeight;
  return n.sizingStyle.boxSizing === "border-box" ? r + n.borderSize : r - n.paddingSize;
};
function tY(e, t, n, r) {
  n === void 0 && (n = 1), r === void 0 && (r = 1 / 0), Ft || (Ft = document.createElement("textarea"), Ft.setAttribute("tabindex", "-1"), Ft.setAttribute("aria-hidden", "true"), J2(Ft)), Ft.parentNode === null && document.body.appendChild(Ft);
  var o = e.paddingSize, i = e.borderSize, l = e.sizingStyle, c = l.boxSizing;
  Object.keys(l).forEach(function(C) {
    var x = C;
    Ft.style[x] = l[x];
  }), J2(Ft), Ft.value = t;
  var f = e3(Ft, e);
  Ft.value = t, f = e3(Ft, e), Ft.value = "x";
  var p = Ft.scrollHeight - o, m = p * n;
  c === "border-box" && (m = m + o + i), f = Math.max(m, f);
  var v = p * r;
  return c === "border-box" && (v = v + o + i), f = Math.min(v, f), [f, p];
}
var t3 = function() {
}, nY = function(t, n) {
  return t.reduce(function(r, o) {
    return r[o] = n[o], r;
  }, {});
}, rY = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak"
], oY = !!document.documentElement.currentStyle, iY = function(t) {
  var n = window.getComputedStyle(t);
  if (n === null)
    return null;
  var r = nY(rY, n), o = r.boxSizing;
  if (o === "")
    return null;
  oY && o === "border-box" && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px");
  var i = parseFloat(r.paddingBottom) + parseFloat(r.paddingTop), l = parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth);
  return {
    sizingStyle: r,
    paddingSize: i,
    borderSize: l
  };
}, aY = iY;
function gb(e, t, n) {
  var r = QK(n);
  d.useLayoutEffect(function() {
    var o = function(l) {
      return r.current(l);
    };
    if (e)
      return e.addEventListener(t, o), function() {
        return e.removeEventListener(t, o);
      };
  }, []);
}
var sY = function(t) {
  gb(window, "resize", t);
}, lY = function(t) {
  gb(document.fonts, "loadingdone", t);
}, cY = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], uY = function(t, n) {
  var r = t.cacheMeasurements, o = t.maxRows, i = t.minRows, l = t.onChange, c = l === void 0 ? t3 : l, f = t.onHeightChange, p = f === void 0 ? t3 : f, m = XK(t, cY), v = m.value !== void 0, C = d.useRef(null), x = JK(C, n), y = d.useRef(0), h = d.useRef(), b = function() {
    var _ = C.current, P = r && h.current ? h.current : aY(_);
    if (P) {
      h.current = P;
      var A = tY(P, _.value || _.placeholder || "x", i, o), I = A[0], T = A[1];
      y.current !== I && (y.current = I, _.style.setProperty("height", I + "px", "important"), p(I, {
        rowHeight: T
      }));
    }
  }, w = function(_) {
    v || b(), c(_);
  };
  return d.useLayoutEffect(b), sY(b), lY(b), /* @__PURE__ */ d.createElement("textarea", b1({}, m, {
    onChange: w,
    ref: x
  }));
}, Lr = /* @__PURE__ */ d.forwardRef(uY);
function bo({ comment: e, spacer: t = /* @__PURE__ */ s("br", {}) }) {
  return e.split(`
`).map((n, r, o) => /* @__PURE__ */ R(ia, { children: [
    n,
    r < o.length - 1 ? t : null
  ] }, r));
}
function dY({
  reviews: e,
  conversationId: t,
  onSubmitSuccess: n
}) {
  const r = e.at(-1), [o, i] = ne(""), [l, c] = ne(""), [f, p] = ne(""), [m, v] = ne([]), [C, x] = ne(""), [y, h] = ne(""), [b, w] = ne(""), [N, _] = ne(!1), {
    mutate: P,
    isPending: A,
    reset: I
  } = $l({
    onError(j) {
      console.error(
        "<ExistingReviewPanel> useCreateConversationReview() onError()",
        j.message
      );
    },
    onSuccess() {
      console.log(
        "<ExistingReviewPanel> useCreateConversationReview() onSuccess()"
      ), _(!1), i(""), n == null || n();
    }
  });
  Oe(() => {
    r && !or(r.review_data) && (console.log("<ReviewPanelV0> currentReview", r), c(r.review_data.customer_report_status), p(r.review_data.reasoning_correctness), v(r.review_data.reasoning_issues), x(r.review_data.conversation_quality), i(r.review_data.comments), h(r.created_at || ""), w(r.created_by_email || ""));
  }, [e]);
  const T = () => {
    if (!M()) {
      console.log("<ReviewPanelV0> handleClick() Adding review");
      const j = {
        customer_report_status: l,
        reasoning_correctness: f,
        reasoning_issues: m,
        conversation_quality: C,
        comments: o
      };
      I(), P({
        path: { conversation_id: t },
        body: {
          review_data: j
        }
      });
    }
  }, M = () => o !== "" || l !== "" || f !== "" || C !== "" ? !1 : m.length <= 0, D = () => l === "Yes" ? /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ s(Lt, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ s("p", { className: "text-successText ml-1.5 text-xs font-normal leading-[14px]", children: "Yes" })
  ] }) : l === "No" ? /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ s($t, { className: "text-destructiveText h-4 w-4" }),
    /* @__PURE__ */ s("p", { className: "text-destructiveText ml-1.5 text-xs font-normal leading-[14px]", children: "No" })
  ] }) : /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response entered." }), W = () => C === "Poor" ? /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ s(Bg, { className: "text-destructiveText h-4 w-4" }),
    /* @__PURE__ */ s("p", { className: "text-destructiveText ml-1.5 text-xs font-normal leading-[14px]", children: "Poor" })
  ] }) : C === "Ok" ? /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ s(Vg, { className: "text-warningText h-4 w-4" }),
    /* @__PURE__ */ s("p", { className: "text-warningText ml-1.5 text-xs font-normal leading-[14px]", children: "Ok" })
  ] }) : C === "Good" ? /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ s(Wg, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ s("p", { className: "text-successText ml-1.5 text-xs font-normal leading-[14px]", children: "Good" })
  ] }) : /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response entered." }), U = () => {
    let j = "";
    switch (f) {
      case "1":
        j = "😃 Mostly/all correct";
        break;
      case "2":
        j = "🙂 Partly correct";
        break;
      case "3":
        j = "😕 Partly incorrect";
        break;
      case "4":
        j = "☹️ Mostly incorrect";
        break;
      case "":
        return /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response entered." });
    }
    return /* @__PURE__ */ s("p", { className: "text-xs font-normal leading-[14px]", children: j });
  }, re = () => m.length > 0 ? m.map((j, X) => /* @__PURE__ */ R("div", { className: "flex flex-row gap-x-0.5", children: [
    /* @__PURE__ */ s(wo, { className: "text-actionDefault h-5 w-5 p-[1px]" }),
    /* @__PURE__ */ s("p", { className: "text-actionHover text-base font-normal leading-5", children: j })
  ] })) : /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response entered." });
  return /* @__PURE__ */ R("div", { className: "bg-interfaceWhite border-interfaceBorder text-textPrimary flex flex-col rounded-lg border p-8", children: [
    (e.length === 0 || N) && /* @__PURE__ */ R("section", { className: "flex flex-col gap-y-5 text-base font-semibold leading-5", children: [
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "Was the report good enough to send to the customer?" }),
        /* @__PURE__ */ s(
          "h4",
          {
            hidden: l !== "",
            className: "text-textSubdued text-xs font-normal leading-[14px]",
            children: "If No, follow up with the customer."
          }
        ),
        /* @__PURE__ */ s("div", { className: "mt-2", children: /* @__PURE__ */ s(
          so,
          {
            radioValue: l,
            setRadioValue: (j) => c(j),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ s(Lt, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ s($t, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ) })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "How correct is the reasoning?" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: /* @__PURE__ */ s(
          OK,
          {
            radioValue: f,
            setRadioValue: (j) => p(j)
          }
        ) })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "If there are issues with the reasoning, what are they?" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: /* @__PURE__ */ s(
          yH,
          {
            options: [
              "Land use term",
              "Zone trigger",
              "Overlay trigger",
              "Provision trigger",
              "Exemption",
              "Other"
            ],
            groupValue: m,
            setGroupValue: (j) => v(j)
          }
        ) })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "How was the quality of the conversation?" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: /* @__PURE__ */ s(
          so,
          {
            radioValue: C,
            setRadioValue: (j) => x(j),
            options: [
              {
                text: "Poor",
                icon: /* @__PURE__ */ s(Bg, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              },
              {
                text: "Ok",
                icon: /* @__PURE__ */ s(Vg, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-warningBgDefault",
                borderColor: "data-[state=checked]:border-warningBorder",
                textColor: "data-[state=checked]:text-warningText"
              },
              {
                text: "Good",
                icon: /* @__PURE__ */ s(Wg, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              }
            ]
          }
        ) })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "Comments" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: /* @__PURE__ */ s(
          Lr,
          {
            value: o,
            onChange: (j) => {
              i(j.target.value);
            },
            className: `${o === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-base font-normal leading-5 focus:outline-0`,
            placeholder: "Enter additional comments"
          }
        ) })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ R("div", { className: "flex w-full flex-row justify-end gap-x-2", children: [
          N && /* @__PURE__ */ s(
            "button",
            {
              onClick: () => _(!1),
              className: "text-actionDefault border-actionDefault flex flex-row items-center justify-center rounded border bg-transparent px-4 py-2 text-lg font-semibold leading-[22px]",
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ R(
            "button",
            {
              onClick: T,
              disabled: M() || A,
              className: "disabled:bg-interactiveBgHover text-textWhite disabled:text-textDisabled bg-actionDefault border-actionDefault flex flex-row items-center justify-center rounded border px-4 py-2 text-lg font-semibold leading-[22px] disabled:border disabled:border-[#CCCCCB]",
              children: [
                A && /* @__PURE__ */ s(So, { className: "mr-2 h-4 w-4 animate-spin" }),
                A ? "Submitting" : N ? "Update review" : "Submit review"
              ]
            }
          )
        ] }),
        N && /* @__PURE__ */ s("div", { className: "mt-2 flex w-full flex-row justify-end", children: /* @__PURE__ */ R("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: [
          "Previously updated by ",
          /* @__PURE__ */ s("span", { className: "text-textPrimary", children: b }),
          " on " + Bn(y).replace(",", " at")
        ] }) })
      ] })
    ] }),
    e.length !== 0 && !N && /* @__PURE__ */ R("section", { className: "flex flex-col gap-y-5 text-base font-semibold leading-5", children: [
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "Was the report good enough to send to the customer?" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: D() })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "How correct is the reasoning?" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: U() })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "If there are issues with the reasoning, what are they?" }),
        /* @__PURE__ */ s("div", { className: "mt-2 flex flex-row flex-wrap gap-x-3", children: re() })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "How was the quality of the conversation?" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: W() })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "Comments" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: o === "" ? /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response entered." }) : /* @__PURE__ */ s("p", { className: "text-wrap break-all text-base font-normal leading-5", children: /* @__PURE__ */ s(bo, { comment: o }) }) })
      ] }),
      /* @__PURE__ */ s("div", { className: "border-interfaceBorder w-full border-t" }),
      /* @__PURE__ */ R("div", { className: "flex flex-col gap-y-1", children: [
        /* @__PURE__ */ R(
          "button",
          {
            onClick: () => _(!0),
            className: "text-textLink flex flex-row items-center text-xs font-normal leading-[14px] underline",
            children: [
              /* @__PURE__ */ s(Gc, { className: "h-4 w-4" }),
              /* @__PURE__ */ s("p", { className: "ml-1", children: "Edit review" })
            ]
          }
        ),
        /* @__PURE__ */ R("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: [
          "Last updated " + Bn(y).replace(",", " at") + " by ",
          /* @__PURE__ */ s("span", { className: "text-textPrimary", children: b })
        ] })
      ] })
    ] })
  ] });
}
function vb({
  outcome: e
}) {
  switch (e) {
    case "Planning permit not required":
      return /* @__PURE__ */ R(le, { children: [
        "Buildings and works",
        " ",
        /* @__PURE__ */ s("span", { className: "text-actionDefault ml-1", children: "does not trigger a planning permit" }),
        ", is this correct?"
      ] });
    case "Planning permit maybe required":
      return /* @__PURE__ */ R(le, { children: [
        "Buildings and works",
        " ",
        /* @__PURE__ */ s("span", { className: "text-actionDefault ml-1", children: "does not trigger a planning permit" }),
        ", is this correct?"
      ] });
    case "Planning permit required":
      return /* @__PURE__ */ R(le, { children: [
        "Buildings and works",
        " ",
        /* @__PURE__ */ s("span", { className: "text-actionDefault ml-1", children: "triggers a planning permit" }),
        ", is this correct?"
      ] });
  }
}
function Cb({ outcome: e }) {
  switch (e) {
    case "Planning permit not required":
      return /* @__PURE__ */ R(le, { children: [
        "Land use",
        " ",
        /* @__PURE__ */ s("span", { className: "text-actionDefault ml-1", children: "does not trigger a planning permit" }),
        ", is this correct?"
      ] });
    case "Planning permit maybe required":
      return /* @__PURE__ */ R(le, { children: [
        "Land use",
        " ",
        /* @__PURE__ */ s("span", { className: "text-actionDefault ml-1", children: "does not trigger a planning permit" }),
        ", is this correct?"
      ] });
    case "Planning permit required":
      return /* @__PURE__ */ R(le, { children: [
        "Land use",
        " ",
        /* @__PURE__ */ s("span", { className: "text-actionDefault ml-1", children: "triggers a planning permit" }),
        ", is this correct?"
      ] });
    case "Prohibited":
      return /* @__PURE__ */ R(le, { children: [
        "Land use",
        " ",
        /* @__PURE__ */ s("span", { className: "text-actionDefault ml-1", children: "is prohibited" }),
        ", is this correct?"
      ] });
  }
}
function fY({
  conversation: e,
  noticeboard: t,
  onClickCancel: n,
  onSubmitSuccess: r,
  review: o
}) {
  var te, ee, Pe;
  const {
    mutate: i,
    isPending: l,
    reset: c
  } = $l({
    onError(ce) {
      console.error(
        "<ReviewPanelV1EditMode> useCreateConversationReview() onError()",
        ce.message
      );
    },
    onSuccess() {
      console.log(
        "<ReviewPanelV1EditMode> useCreateConversationReview() onSuccess()"
      ), U(""), r();
    }
  }), f = e == null ? void 0 : e.id, p = /* @__PURE__ */ s(
    mt,
    {
      value: e != null && e.report_outcome ? e.report_outcome : ""
    }
  ), m = ((ee = (te = t == null ? void 0 : t.building_works_assessment_result) == null ? void 0 : te.parsed_output) == null ? void 0 : ee.land_use_assessor_result) ?? "", v = ((Pe = t == null ? void 0 : t.building_works_assessment_result) == null ? void 0 : Pe.parsed_output.building_works_assessment_result) ?? "", [C, x] = ne(""), [y, h] = ne(""), [b, w] = ne(""), [N, _] = ne(""), [P, A] = ne(""), [I, T] = ne(""), [M, D] = ne(""), [W, U] = ne(""), [re, j] = ne(""), [X, oe] = ne("");
  Oe(() => {
    o && or(o.review_data) && o.review_data.version === 1 && (x(o.review_data.report_outcome), h(
      o.review_data.report_outcome_expected
    ), w(o.review_data.land_use_correctness), _(o.review_data.land_use_correctness_comment), A(
      o.review_data.buildings_and_works_correctness
    ), T(
      o.review_data.buildings_and_works_correctness_comment
    ), D(o.review_data.report_good_enough), U(o.review_data.comments), j(o.created_at || ""), oe(o.created_by || ""));
  }, [o]);
  const G = () => C !== "" || b !== "" || P !== "" ? !1 : M !== "" ? "" : W === "", Q = () => {
    if (!G() && f) {
      console.log("<ReviewPanelV1EditMode> Adding review.");
      const ce = {
        version: 1,
        report_outcome: C,
        report_outcome_expected: y,
        land_use_correctness: b,
        land_use_correctness_comment: N,
        buildings_and_works_correctness: P,
        buildings_and_works_correctness_comment: I,
        report_good_enough: M,
        comments: W
      };
      c(), i({
        path: { conversation_id: f },
        body: {
          review_data: ce
        }
      });
    }
  };
  return /* @__PURE__ */ R("section", { className: "flex flex-col gap-y-5 text-base font-semibold leading-5", children: [
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ R("h3", { className: "flex", children: [
        "The result is ",
        /* @__PURE__ */ s("span", { className: "ml-1", children: p }),
        ", is this correct?"
      ] }),
      /* @__PURE__ */ R("div", { className: "mt-2", children: [
        /* @__PURE__ */ s(
          so,
          {
            radioValue: C,
            setRadioValue: (ce) => x(ce),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ s(Lt, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ s($t, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        C === "No" ? /* @__PURE__ */ R("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ s(nn, {}),
          /* @__PURE__ */ R("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ s(nt, { children: "What should the result be?" }),
            /* @__PURE__ */ s(
              yi,
              {
                className: "gap-1",
                radioValue: y,
                setRadioValue: (ce) => h(ce),
                options: [
                  {
                    icon: /* @__PURE__ */ s("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ s(mt, { value: "No permit required" }) }),
                    bgColor: "data-[state=checked]:bg-successBgDefault",
                    borderColor: "data-[state=checked]:border-successBorder",
                    textColor: "data-[state=checked]:text-successText",
                    value: "No permit required"
                  },
                  {
                    icon: /* @__PURE__ */ s("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ s(mt, { value: "More information required" }) }),
                    bgColor: "data-[state=checked]:bg-actionBgLight",
                    borderColor: "data-[state=checked]:border-actionBorder",
                    textColor: "data-[state=checked]:text-actionDefault",
                    value: "More information required"
                  },
                  {
                    icon: /* @__PURE__ */ s("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ s(mt, { value: "Permit required" }) }),
                    bgColor: "data-[state=checked]:bg-warningBgLight",
                    borderColor: "data-[state=checked]:border-warningBorder",
                    textColor: "data-[state=checked]:text-warningText",
                    value: "Permit required"
                  },
                  {
                    icon: /* @__PURE__ */ s("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ s(mt, { value: "Prohibited" }) }),
                    bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                    borderColor: "data-[state=checked]:border-destructiveBorder",
                    textColor: "data-[state=checked]:text-destructiveText",
                    value: "Prohibited"
                  }
                ].filter(
                  (ce) => ce.value !== (e == null ? void 0 : e.report_outcome)
                )
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { className: "inline", children: /* @__PURE__ */ s(Cb, { outcome: m }) }),
      /* @__PURE__ */ R("div", { className: "mt-2", children: [
        /* @__PURE__ */ s(
          so,
          {
            radioValue: b,
            setRadioValue: (ce) => w(ce),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ s(Lt, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ s($t, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        b ? /* @__PURE__ */ R("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ s(nn, {}),
          /* @__PURE__ */ R("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ s(nt, { children: b === "Yes" ? "Comments" : "What is incorrect about it?" }),
            /* @__PURE__ */ s(
              Lr,
              {
                className: `${W === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-base font-normal leading-5 focus:outline-0`,
                onChange: (ce) => {
                  _(ce.target.value);
                },
                placeholder: b === "Yes" ? "Enter comments" : "Describe what’s incorrect and what it should have been.",
                tabIndex: 1,
                value: N
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { className: "inline", children: /* @__PURE__ */ s(vb, { outcome: v }) }),
      /* @__PURE__ */ R("div", { className: "mt-2", children: [
        /* @__PURE__ */ s(
          so,
          {
            radioValue: P,
            setRadioValue: (ce) => A(ce),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ s(Lt, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ s($t, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        P ? /* @__PURE__ */ R("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ s(nn, {}),
          /* @__PURE__ */ R("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ s(nt, { children: P === "Yes" ? "Comments" : "What is incorrect about it?" }),
            /* @__PURE__ */ s(
              Lr,
              {
                className: `${W === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-base font-normal leading-5 focus:outline-0`,
                onChange: (ce) => {
                  T(ce.target.value);
                },
                placeholder: P === "Yes" ? "Enter comments" : "Describe what’s incorrect and what it should have been.",
                tabIndex: 1,
                value: I
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { children: "Is the report good enough, or is a follow-up required?" }),
      /* @__PURE__ */ s("div", { className: "mt-2", children: /* @__PURE__ */ s(
        yi,
        {
          className: "gap-1",
          radioValue: M,
          setRadioValue: (ce) => D(ce),
          options: [
            {
              icon: /* @__PURE__ */ R("div", { className: "flex items-center py-2 pl-2 pr-3", children: [
                /* @__PURE__ */ s(Lt, { className: "mr-2.5 h-4 w-4" }),
                /* @__PURE__ */ s(
                  "span",
                  {
                    className: `text-sm ${M === "Yes" ? "text-successText" : "text-textPrimary"} font-normal`,
                    children: "The report is good enough"
                  }
                )
              ] }),
              bgColor: "data-[state=checked]:bg-successBgDefault",
              borderColor: "data-[state=checked]:border-successBorder",
              textColor: "data-[state=checked]:text-successText",
              value: "Yes"
            },
            {
              icon: /* @__PURE__ */ R("div", { className: "flex items-center py-2 pl-2 pr-3", children: [
                /* @__PURE__ */ s($t, { className: "mr-2.5 h-4 w-4" }),
                /* @__PURE__ */ s(
                  "span",
                  {
                    className: `text-sm ${M === "No" ? "text-destructiveText" : "text-textPrimary"} font-normal`,
                    children: "A follow-up with the customer is required"
                  }
                )
              ] }),
              bgColor: "data-[state=checked]:bg-destructiveBgDefault",
              borderColor: "data-[state=checked]:border-destructiveBorder",
              textColor: "data-[state=checked]:text-destructiveText",
              value: "No"
            }
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { children: "Additional comments" }),
      /* @__PURE__ */ s("div", { className: "mt-2", children: /* @__PURE__ */ s(
        Lr,
        {
          className: `${W === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-base font-normal leading-5 focus:outline-0`,
          onChange: (ce) => {
            U(ce.target.value);
          },
          placeholder: "Enter additional comments",
          tabIndex: 1,
          value: W
        }
      ) })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ R("div", { className: "flex w-full flex-row justify-end gap-x-2", children: [
        re ? /* @__PURE__ */ s(
          ct,
          {
            className: "text-actionDefault border-actionDefault",
            onClick: n,
            tabIndex: 1,
            variant: "outline",
            children: "Cancel"
          }
        ) : null,
        /* @__PURE__ */ R(
          ct,
          {
            disabled: G() || l,
            onClick: Q,
            tabIndex: 1,
            variant: "default",
            children: [
              l && /* @__PURE__ */ s(So, { className: "mr-2 h-4 w-4 animate-spin" }),
              l ? "Submitting" : "Submit review"
            ]
          }
        )
      ] }),
      re ? /* @__PURE__ */ s("div", { className: "mt-2 flex w-full flex-row justify-end", children: /* @__PURE__ */ R("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: [
        "Previously updated by ",
        /* @__PURE__ */ s("span", { className: "text-textPrimary", children: X }),
        " on " + Bn(re).replace(",", " at")
      ] }) }) : null
    ] })
  ] });
}
function pY({
  conversation: e,
  noticeboard: t,
  onSubmitSuccess: n
}) {
  const r = Tl({ conversation: e }), o = r.at(-1), [i, l] = ne(""), [c, f] = ne(""), [p, m] = ne(""), [v, C] = ne(""), [x, y] = ne(""), [h, b] = ne(""), [w, N] = ne(""), [_, P] = ne(""), [A, I] = ne(""), [T, M] = ne(""), [D, W] = ne(r.length === 0);
  Oe(() => {
    r.length > 0 && W(!1);
  }, [r.length]), Oe(() => {
    o && or(o.review_data) && o.review_data.version === 1 && (console.log("<ReviewPanelV1> currentReview:", o), l(o.review_data.report_outcome), f(
      o.review_data.report_outcome_expected
    ), m(o.review_data.land_use_correctness), C(
      o.review_data.land_use_correctness_comment
    ), y(
      o.review_data.buildings_and_works_correctness
    ), b(
      o.review_data.buildings_and_works_correctness_comment
    ), N(
      o.review_data.report_good_enough
    ), P(o.review_data.comments), I(o.created_at || ""), M(o.created_by_email || ""));
  }, [o]);
  const U = (Q, te) => /* @__PURE__ */ R("div", { className: "mt-2 flex pl-1", children: [
    /* @__PURE__ */ s(nn, {}),
    /* @__PURE__ */ R("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
      /* @__PURE__ */ s(nt, { children: te ? "Comments" : "What is incorrect about it?" }),
      Q ? /* @__PURE__ */ s("span", { className: "text-textSubdued text-sm", children: /* @__PURE__ */ s(bo, { comment: Q }) }) : /* @__PURE__ */ s("span", { className: "text-textSubdued text-xs font-normal", children: "No response provided." })
    ] })
  ] }), re = () => i === "Yes" ? /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ s(Lt, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ s("p", { className: "text-successText ml-1.5 text-xs font-normal leading-[14px]", children: "Yes" })
  ] }) : i === "No" ? /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ s($t, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ s("p", { className: "text-destructiveText ml-1.5 text-xs font-normal leading-[14px]", children: "No" })
    ] }),
    /* @__PURE__ */ R("div", { className: "mt-2 flex pl-1", children: [
      /* @__PURE__ */ s(nn, {}),
      /* @__PURE__ */ R("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
        /* @__PURE__ */ s(nt, { children: "What should the result be?" }),
        c ? /* @__PURE__ */ s(mt, { value: c }) : /* @__PURE__ */ s("span", { className: "text-textSubdued text-xs font-normal", children: "No response provided." })
      ] })
    ] })
  ] }) : /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response entered." }), j = () => p === "Yes" ? /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ s(Lt, { className: "text-successText h-4 w-4" }),
      /* @__PURE__ */ s("p", { className: "text-successText ml-1.5 text-xs font-normal leading-[14px]", children: "Yes" })
    ] }),
    U(v, !0)
  ] }) : p === "No" ? /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ s($t, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ s("p", { className: "text-destructiveText ml-1.5 text-xs font-normal leading-[14px]", children: "No" })
    ] }),
    U(v, !1)
  ] }) : /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response entered." }), X = () => x === "Yes" ? /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ s(Lt, { className: "text-successText h-4 w-4" }),
      /* @__PURE__ */ s("p", { className: "text-successText ml-1.5 text-xs font-normal leading-[14px]", children: "Yes" })
    ] }),
    U(h, !0)
  ] }) : x === "No" ? /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ s($t, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ s("p", { className: "text-destructiveText ml-1.5 text-xs font-normal leading-[14px]", children: "No" })
    ] }),
    U(h, !1)
  ] }) : /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response entered." }), oe = () => w === "Yes" ? /* @__PURE__ */ R("div", { className: "flex items-center", children: [
    /* @__PURE__ */ s(Lt, { className: "text-successText mr-2.5 h-4 w-4" }),
    /* @__PURE__ */ s("span", { className: "text-successText text-sm font-normal", children: "The report is good enough" })
  ] }) : w === "No" ? /* @__PURE__ */ R("div", { className: "flex items-center", children: [
    /* @__PURE__ */ s($t, { className: "text-destructiveText mr-2.5 h-4 w-4" }),
    /* @__PURE__ */ s("span", { className: " text-destructiveText text-sm font-normal", children: "A follow-up with the customer is required" })
  ] }) : /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response entered." }), G = () => {
    const Q = /* @__PURE__ */ s(
      mt,
      {
        value: e != null && e.report_outcome ? e.report_outcome : ""
      }
    ), te = (t == null ? void 0 : t.building_works_assessment_result.parsed_output.land_use_assessor_result) ?? "", ee = (t == null ? void 0 : t.building_works_assessment_result.parsed_output.building_works_assessment_result) ?? "";
    return /* @__PURE__ */ R("section", { className: "flex flex-col gap-y-5 text-base font-semibold leading-5", children: [
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ R("h3", { className: "flex", children: [
          "The result is ",
          /* @__PURE__ */ s("span", { className: "ml-1", children: Q }),
          ", is this correct?"
        ] }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: re() })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { className: "inline", children: /* @__PURE__ */ s(Cb, { outcome: te }) }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: j() })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { className: "inline", children: /* @__PURE__ */ s(vb, { outcome: ee }) }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: X() })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "Is the report good enough, or is a follow-up required?" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: oe() })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "Comments" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: _ === "" ? /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response provided." }) : /* @__PURE__ */ s("p", { className: "text-wrap break-all text-base font-normal leading-5", children: /* @__PURE__ */ s(bo, { comment: _ }) }) })
      ] }),
      /* @__PURE__ */ s("div", { className: "border-interfaceBorder w-full border-t" }),
      /* @__PURE__ */ R("div", { className: "flex flex-col gap-y-1", children: [
        /* @__PURE__ */ R(
          "button",
          {
            onClick: () => W(!0),
            className: "text-textLink flex flex-row items-center text-xs font-normal leading-[14px] underline",
            children: [
              /* @__PURE__ */ s(Gc, { className: "h-4 w-4" }),
              /* @__PURE__ */ s("p", { className: "ml-1", children: "Edit review" })
            ]
          }
        ),
        /* @__PURE__ */ R("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: [
          "Last updated " + Bn(A).replace(",", " at") + " by ",
          /* @__PURE__ */ s("span", { className: "text-textPrimary", children: T })
        ] })
      ] })
    ] });
  };
  return /* @__PURE__ */ R("div", { className: "bg-interfaceWhite border-interfaceBorder text-textPrimary flex flex-col rounded-lg border p-8", children: [
    r.length === 0 || D ? /* @__PURE__ */ s(
      fY,
      {
        conversation: e,
        noticeboard: t,
        onClickCancel: () => W(!1),
        onSubmitSuccess: () => {
          W(!1), n == null || n();
        },
        review: o
      }
    ) : null,
    r.length > 0 && !D ? G() : null
  ] });
}
function mY({
  conversation: e,
  onClickCancel: t,
  onSubmitSuccess: n,
  review: r
}) {
  const {
    mutate: o,
    isPending: i,
    reset: l
  } = $l({
    onError(D) {
      console.error(
        "<ReviewPanelV2EditMode> useCreateConversationReview() onError()",
        D.message
      );
    },
    onSuccess() {
      console.log(
        "<ReviewPanelV2EditMode> useCreateConversationReview() onSuccess()"
      ), N(""), n();
    }
  }), c = e == null ? void 0 : e.id, f = /* @__PURE__ */ s(
    mt,
    {
      value: e != null && e.report_outcome ? e.report_outcome : ""
    }
  ), [p, m] = ne(""), [v, C] = ne(""), [x, y] = ne(""), [h, b] = ne(""), [w, N] = ne(""), [_, P] = ne(""), [A, I] = ne("");
  Oe(() => {
    r && or(r.review_data) && r.review_data.version === 2 && (m(r.review_data.report_outcome), C(
      r.review_data.report_outcome_expected
    ), y(r.review_data.report_good_enough), b(
      r.review_data.report_good_enough_comment
    ), N(r.review_data.comments), P(r.created_at || ""), I(r.created_by || ""));
  }, [r]);
  const T = () => p !== "" ? !1 : x !== "" ? "" : w === "", M = () => {
    if (!T() && c) {
      console.log("<ReviewPanelV2EditMode> Adding review.");
      const D = {
        version: 2,
        report_outcome: p,
        report_outcome_expected: v,
        report_good_enough: x,
        report_good_enough_comment: h,
        comments: w
      };
      l(), o({
        path: { conversation_id: c },
        body: {
          review_data: D
        }
      });
    }
  };
  return /* @__PURE__ */ R("section", { className: "flex flex-col gap-y-5 text-base font-semibold leading-5", children: [
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ R("h3", { className: "flex", children: [
        "The result is ",
        /* @__PURE__ */ s("span", { className: "ml-1", children: f }),
        ", is this correct?"
      ] }),
      /* @__PURE__ */ R("div", { className: "mt-2", children: [
        /* @__PURE__ */ s(
          so,
          {
            radioValue: p,
            setRadioValue: (D) => m(D),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ s(Lt, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ s($t, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        p === "No" ? /* @__PURE__ */ R("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ s(nn, {}),
          /* @__PURE__ */ R("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ s(nt, { children: "What should the result be?" }),
            /* @__PURE__ */ s(
              yi,
              {
                className: "gap-1",
                radioValue: v,
                setRadioValue: (D) => C(D),
                options: [
                  {
                    icon: /* @__PURE__ */ s("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ s(mt, { value: "No permit required" }) }),
                    bgColor: "data-[state=checked]:bg-successBgDefault",
                    borderColor: "data-[state=checked]:border-successBorder",
                    textColor: "data-[state=checked]:text-successText",
                    value: "No permit required"
                  },
                  {
                    icon: /* @__PURE__ */ s("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ s(mt, { value: "More information required" }) }),
                    bgColor: "data-[state=checked]:bg-actionBgLight",
                    borderColor: "data-[state=checked]:border-actionBorder",
                    textColor: "data-[state=checked]:text-actionDefault",
                    value: "More information required"
                  },
                  {
                    icon: /* @__PURE__ */ s("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ s(mt, { value: "Permit required" }) }),
                    bgColor: "data-[state=checked]:bg-warningBgLight",
                    borderColor: "data-[state=checked]:border-warningBorder",
                    textColor: "data-[state=checked]:text-warningText",
                    value: "Permit required"
                  },
                  {
                    icon: /* @__PURE__ */ s("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ s(mt, { value: "Prohibited" }) }),
                    bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                    borderColor: "data-[state=checked]:border-destructiveBorder",
                    textColor: "data-[state=checked]:text-destructiveText",
                    value: "Prohibited"
                  }
                ].filter(
                  (D) => D.value !== (e == null ? void 0 : e.report_outcome)
                )
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { children: "Is the report good enough, or is a follow-up required?" }),
      /* @__PURE__ */ R("div", { className: "mt-2", children: [
        /* @__PURE__ */ s(
          yi,
          {
            className: "gap-1",
            radioValue: x,
            setRadioValue: (D) => y(D),
            options: [
              {
                icon: /* @__PURE__ */ R("div", { className: "flex items-center py-2 pl-2 pr-3", children: [
                  /* @__PURE__ */ s(Lt, { className: "mr-2.5 h-4 w-4" }),
                  /* @__PURE__ */ s(
                    "span",
                    {
                      className: `text-sm ${x === "Yes" ? "text-successText" : "text-textPrimary"} font-normal`,
                      children: "The report is good enough"
                    }
                  )
                ] }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText",
                value: "Yes"
              },
              {
                icon: /* @__PURE__ */ R("div", { className: "flex items-center py-2 pl-2 pr-3", children: [
                  /* @__PURE__ */ s($t, { className: "mr-2.5 h-4 w-4" }),
                  /* @__PURE__ */ s(
                    "span",
                    {
                      className: `text-sm ${x === "No" ? "text-destructiveText" : "text-textPrimary"} font-normal`,
                      children: "A follow-up with the customer is required"
                    }
                  )
                ] }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText",
                value: "No"
              }
            ]
          }
        ),
        x === "No" ? /* @__PURE__ */ R("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ s(nn, {}),
          /* @__PURE__ */ R("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ s(nt, { children: "What risk has the report introduced?" }),
            /* @__PURE__ */ s(
              Lr,
              {
                className: "border-interactiveBorder focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-base font-normal leading-5 focus:outline-0",
                onChange: (D) => {
                  b(D.target.value);
                },
                placeholder: "Describe how the council or customer may be affected due to the report’s content.",
                tabIndex: 1,
                value: h
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { children: "Was the reasoning by zone and overlay correct?" }),
      /* @__PURE__ */ s("span", { className: "text-textSubdued inline-block text-xs font-normal leading-[14px]", children: "Write your response against each applicable zone and overlay, e.g. “Zone: <comment>, BMO: <comment>, SLO: <comment>”." }),
      /* @__PURE__ */ s("div", { className: "mt-1", children: /* @__PURE__ */ s(
        Lr,
        {
          className: `${w === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-base font-normal leading-5 focus:outline-0`,
          onChange: (D) => {
            N(D.target.value);
          },
          placeholder: "Enter response",
          tabIndex: 1,
          value: w
        }
      ) })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ R("div", { className: "flex w-full flex-row justify-end gap-x-2", children: [
        _ ? /* @__PURE__ */ s(
          ct,
          {
            className: "text-actionDefault border-actionDefault",
            onClick: t,
            tabIndex: 1,
            variant: "outline",
            children: "Cancel"
          }
        ) : null,
        /* @__PURE__ */ R(
          ct,
          {
            disabled: T() || i,
            onClick: M,
            tabIndex: 1,
            variant: "default",
            children: [
              i && /* @__PURE__ */ s(So, { className: "mr-2 h-4 w-4 animate-spin" }),
              i ? "Submitting" : "Submit review"
            ]
          }
        )
      ] }),
      _ ? /* @__PURE__ */ s("div", { className: "mt-2 flex w-full flex-row justify-end", children: /* @__PURE__ */ R("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: [
        "Previously updated by ",
        /* @__PURE__ */ s("span", { className: "text-textPrimary", children: A }),
        " on " + Bn(_).replace(",", " at")
      ] }) }) : null
    ] })
  ] });
}
function hY({
  conversation: e,
  onSubmitSuccess: t
}) {
  const n = Tl({ conversation: e }), r = n.at(-1), [o, i] = ne(""), [l, c] = ne(""), [f, p] = ne(""), [m, v] = ne(""), [C, x] = ne(""), [y, h] = ne(""), [b, w] = ne(""), [N, _] = ne(n.length === 0);
  Oe(() => {
    n.length > 0 && _(!1);
  }, [n.length]), Oe(() => {
    r && or(r.review_data) && r.review_data.version === 2 && (console.log("<ReviewPanelV2> currentReview:", r), i(r.review_data.report_outcome), c(
      r.review_data.report_outcome_expected
    ), p(
      r.review_data.report_good_enough
    ), v(
      r.review_data.report_good_enough_comment
    ), x(r.review_data.comments), h(r.created_at || ""), w(r.created_by_email || ""));
  }, [r]);
  const P = (M, D) => /* @__PURE__ */ R("div", { className: "mt-2 flex pl-1", children: [
    /* @__PURE__ */ s(nn, {}),
    /* @__PURE__ */ R("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
      /* @__PURE__ */ s(nt, { children: "What risk has the report introduced?" }),
      M ? /* @__PURE__ */ s("span", { className: "text-textSubdued text-sm", children: /* @__PURE__ */ s(bo, { comment: M }) }) : /* @__PURE__ */ s("span", { className: "text-textSubdued text-xs font-normal", children: "No response provided." })
    ] })
  ] }), A = () => o === "Yes" ? /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ s(Lt, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ s("p", { className: "text-successText ml-1.5 text-xs font-normal leading-[14px]", children: "Yes" })
  ] }) : o === "No" ? /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ s($t, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ s("p", { className: "text-destructiveText ml-1.5 text-xs font-normal leading-[14px]", children: "No" })
    ] }),
    /* @__PURE__ */ R("div", { className: "mt-2 flex pl-1", children: [
      /* @__PURE__ */ s(nn, {}),
      /* @__PURE__ */ R("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
        /* @__PURE__ */ s(nt, { children: "What should the result be?" }),
        l ? /* @__PURE__ */ s(mt, { value: l }) : /* @__PURE__ */ s("span", { className: "text-textSubdued text-xs font-normal", children: "No response provided." })
      ] })
    ] })
  ] }) : /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response entered." }), I = () => f === "Yes" ? /* @__PURE__ */ R("div", { className: "flex items-center", children: [
    /* @__PURE__ */ s(Lt, { className: "text-successText mr-2.5 h-4 w-4" }),
    /* @__PURE__ */ s("span", { className: "text-successText text-sm font-normal", children: "The report is good enough" })
  ] }) : f === "No" ? /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ R("div", { className: "flex items-center", children: [
      /* @__PURE__ */ s($t, { className: "text-destructiveText mr-2.5 h-4 w-4" }),
      /* @__PURE__ */ s("span", { className: " text-destructiveText text-sm font-normal", children: "A follow-up with the customer is required" })
    ] }),
    P(m)
  ] }) : /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response entered." }), T = () => {
    const M = /* @__PURE__ */ s(
      mt,
      {
        value: e != null && e.report_outcome ? e.report_outcome : ""
      }
    );
    return /* @__PURE__ */ R("section", { className: "flex flex-col gap-y-5 text-base font-semibold leading-5", children: [
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ R("h3", { className: "flex", children: [
          "The result is ",
          /* @__PURE__ */ s("span", { className: "ml-1", children: M }),
          ", is this correct?"
        ] }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: A() })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "Is the report good enough, or is a follow-up required?" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: I() })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "Was the reasoning by zone and overlay correct?" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: C === "" ? /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response provided." }) : /* @__PURE__ */ s("p", { className: "text-wrap break-all text-base font-normal leading-5", children: /* @__PURE__ */ s(bo, { comment: C }) }) })
      ] }),
      /* @__PURE__ */ s("div", { className: "border-interfaceBorder w-full border-t" }),
      /* @__PURE__ */ R("div", { className: "flex flex-col gap-y-1", children: [
        /* @__PURE__ */ R(
          "button",
          {
            onClick: () => _(!0),
            className: "text-textLink flex flex-row items-center text-xs font-normal leading-[14px] underline",
            children: [
              /* @__PURE__ */ s(Gc, { className: "h-4 w-4" }),
              /* @__PURE__ */ s("p", { className: "ml-1", children: "Edit review" })
            ]
          }
        ),
        /* @__PURE__ */ R("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: [
          "Last updated " + Bn(y).replace(",", " at") + " by ",
          /* @__PURE__ */ s("span", { className: "text-textPrimary", children: b })
        ] })
      ] })
    ] });
  };
  return /* @__PURE__ */ R("div", { className: "bg-interfaceWhite border-interfaceBorder text-textPrimary flex flex-col rounded-lg border p-8", children: [
    n.length === 0 || N ? /* @__PURE__ */ s(
      mY,
      {
        conversation: e,
        onClickCancel: () => _(!1),
        onSubmitSuccess: () => {
          _(!1), t == null || t();
        },
        review: r
      }
    ) : null,
    n.length > 0 && !N ? T() : null
  ] });
}
function gY({ onOpenChange: e, open: t }) {
  return /* @__PURE__ */ s(s5, { open: t, onOpenChange: e, children: /* @__PURE__ */ R(ip, { children: [
    /* @__PURE__ */ s(u5, { children: "Risk types" }),
    /* @__PURE__ */ s("p", { className: "text-bodymd", children: "Risk types are defined as follows:" }),
    /* @__PURE__ */ R("ul", { className: "text-bodymd ml-4 list-outside list-decimal", children: [
      /* @__PURE__ */ R("li", { className: "marker:font-semibold", children: [
        /* @__PURE__ */ s("b", { children: "Monetary:" }),
        " Where as a result of the report they received, the customer may end up spending money unnecessarily, such as commissioning a report they don't actually need."
      ] }),
      /* @__PURE__ */ R("li", { className: "marker:font-semibold", children: [
        /* @__PURE__ */ s("b", { children: "Incorrect or unnecessary design changes:" }),
        " Where the customer may be encouraged to alter their design based on incorrect information provided about permit triggers."
      ] }),
      /* @__PURE__ */ R("li", { className: "marker:font-semibold", children: [
        /* @__PURE__ */ s("b", { children: "Irreversible actions:" }),
        " Where the customer may be encouraged to take a development action that is prohibited or requires a permit, which could have irreversible consequences."
      ] }),
      /* @__PURE__ */ R("li", { className: "marker:font-semibold", children: [
        /* @__PURE__ */ s("b", { children: "Reputational:" }),
        " Where the report includes content that may result in a negative reputational impact to the council."
      ] })
    ] }),
    /* @__PURE__ */ s("p", { className: "text-bodymd", children: "After selecting the risk type(s) you’ve identified, describe the language or error in the report that has introduced this risk." }),
    /* @__PURE__ */ s(c5, { children: /* @__PURE__ */ s(ct, { onClick: () => e(!1), variant: "outline", children: "Close" }) })
  ] }) });
}
function vY({
  conversation: e,
  onClickCancel: t,
  onSubmitSuccess: n,
  review: r
}) {
  const {
    mutate: o,
    isPending: i,
    reset: l
  } = $l({
    onError(G) {
      console.error(
        "<ReviewPanelV3EditMode> useCreateConversationReview() onError()",
        G.message
      );
    },
    onSuccess() {
      console.log(
        "<ReviewPanelV3EditMode> useCreateConversationReview() onSuccess()"
      ), P(""), n();
    }
  }), c = e == null ? void 0 : e.id, f = /* @__PURE__ */ s(
    mt,
    {
      value: e != null && e.report_outcome ? e.report_outcome : ""
    }
  ), [p, m] = ne(""), [v, C] = ne(""), [x, y] = ne(""), [h, b] = ne({
    monetary: !1,
    incorrectOrUnnecessaryDesignChange: !1,
    irreversibleActions: !1,
    reputational: !1
  }), [w, N] = ne(""), [_, P] = ne(""), [A, I] = ne(""), [T, M] = ne(""), [D, W] = ne(!1), [U, re] = ne({
    reportOutcome: "",
    reportRiskComment: ""
  }), j = () => {
    re({
      reportOutcome: "",
      reportRiskComment: ""
    });
  }, X = () => {
    j();
    let G = !0;
    return p === "" && (re((Q) => ({
      ...Q,
      reportOutcome: "This field is required"
    })), G = !1), ["Minor", "Yes"].includes(x) && w === "" && (re((Q) => ({
      ...Q,
      reportRiskComment: "This field is required"
    })), G = !1), G;
  };
  Oe(() => {
    r && or(r.review_data) && r.review_data.version === 3 && (m(r.review_data.report_outcome), C(
      r.review_data.report_outcome_expected
    ), y(r.review_data.report_risk), b(
      r.review_data.report_risk_types || {
        monetary: !1,
        incorrectOrUnnecessaryDesignChange: !1,
        irreversibleActions: !1,
        reputational: !1
      }
    ), N(r.review_data.report_risk_comment), P(r.review_data.comments), I(r.created_at || ""), M(r.created_by || ""));
  }, [r]);
  const oe = () => {
    if (c && X()) {
      console.log("<ReviewPanelV3EditMode> Adding review.");
      const G = {
        version: 3,
        report_outcome: p,
        report_outcome_expected: v,
        report_risk: x,
        report_risk_types: h,
        report_risk_comment: w,
        comments: _
      };
      l(), o({
        path: { conversation_id: c },
        body: {
          review_data: G
        }
      });
    }
  };
  return /* @__PURE__ */ R("section", { className: "flex flex-col gap-y-5 text-base font-semibold leading-5", children: [
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ R(
        "h3",
        {
          className: F(
            "flex",
            U.reportOutcome && "text-destructiveDefault"
          ),
          children: [
            "The result is ",
            /* @__PURE__ */ s("span", { className: "ml-1", children: f }),
            ", is this correct?"
          ]
        }
      ),
      /* @__PURE__ */ R("div", { className: "mt-2", children: [
        /* @__PURE__ */ s(
          so,
          {
            radioValue: p,
            setRadioValue: (G) => {
              j(), m(G);
            },
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ s(Lt, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ s($t, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        p === "No" ? /* @__PURE__ */ R("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ s(nn, {}),
          /* @__PURE__ */ R("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ s(nt, { children: "What should the result be?" }),
            /* @__PURE__ */ s(
              yi,
              {
                className: "gap-1",
                radioValue: v,
                setRadioValue: (G) => C(G),
                options: [
                  {
                    icon: /* @__PURE__ */ s("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ s(mt, { value: "No permit required" }) }),
                    bgColor: "data-[state=checked]:bg-successBgDefault",
                    borderColor: "data-[state=checked]:border-successBorder",
                    textColor: "data-[state=checked]:text-successText",
                    value: "No permit required"
                  },
                  {
                    icon: /* @__PURE__ */ s("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ s(mt, { value: "More information required" }) }),
                    bgColor: "data-[state=checked]:bg-actionBgLight",
                    borderColor: "data-[state=checked]:border-actionBorder",
                    textColor: "data-[state=checked]:text-actionDefault",
                    value: "More information required"
                  },
                  {
                    icon: /* @__PURE__ */ s("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ s(mt, { value: "Permit required" }) }),
                    bgColor: "data-[state=checked]:bg-warningBgLight",
                    borderColor: "data-[state=checked]:border-warningBorder",
                    textColor: "data-[state=checked]:text-warningText",
                    value: "Permit required"
                  },
                  {
                    icon: /* @__PURE__ */ s("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ s(mt, { value: "Prohibited" }) }),
                    bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                    borderColor: "data-[state=checked]:border-destructiveBorder",
                    textColor: "data-[state=checked]:text-destructiveText",
                    value: "Prohibited"
                  }
                ].filter(
                  (G) => G.value !== (e == null ? void 0 : e.report_outcome)
                )
              }
            )
          ] })
        ] }) : null,
        U.reportOutcome ? /* @__PURE__ */ s("div", { className: "text-destructiveDefault mt-2", children: U.reportOutcome }) : null
      ] })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { children: "Has the report introduced risk to the customer or council?" }),
      /* @__PURE__ */ R("div", { className: "mt-2", children: [
        /* @__PURE__ */ s(
          yi,
          {
            className: "gap-1",
            radioValue: x,
            setRadioValue: (G) => y(G),
            options: [
              {
                icon: /* @__PURE__ */ s("div", { className: "flex items-center py-2 pl-2 pr-3", children: /* @__PURE__ */ s(
                  "span",
                  {
                    className: `text-sm ${x === "No" ? "text-successText" : "text-textPrimary"} font-normal`,
                    children: "✅ No risk"
                  }
                ) }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText",
                value: "No"
              },
              {
                icon: /* @__PURE__ */ s("div", { className: "flex items-center py-2 pl-2 pr-3", children: /* @__PURE__ */ s(
                  "span",
                  {
                    className: `text-sm ${x === "Minor" ? "text-warningText" : "text-textPrimary"} font-normal`,
                    children: "⚠️ Yes, but it’s only minor"
                  }
                ) }),
                bgColor: "data-[state=checked]:bg-warningBgDefault",
                borderColor: "data-[state=checked]:border-warningBorder",
                textColor: "data-[state=checked]:text-warningText",
                value: "Minor"
              },
              {
                icon: /* @__PURE__ */ s("div", { className: "flex items-center py-2 pl-2 pr-3", children: /* @__PURE__ */ s(
                  "span",
                  {
                    className: `text-sm ${x === "Yes" ? "text-destructiveText" : "text-textPrimary"} font-normal`,
                    children: "🚨 Yes, and it’s potentially significant"
                  }
                ) }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText",
                value: "Yes"
              }
            ]
          }
        ),
        ["Minor", "Yes"].includes(x) ? /* @__PURE__ */ R("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ s(nn, {}),
          /* @__PURE__ */ R("div", { className: "mt-2 flex w-full flex-col gap-2", children: [
            /* @__PURE__ */ R("div", { className: "flex w-full justify-between", children: [
              /* @__PURE__ */ s(nt, { className: "text-bodymd text-textPrimary", children: "What type of risk has been introduced?" }),
              /* @__PURE__ */ R(
                ct,
                {
                  className: "mt-[-4px] h-0 gap-1 pr-0",
                  onClick: () => {
                    W(!0);
                  },
                  variant: "link",
                  children: [
                    /* @__PURE__ */ s(gP, { className: "h-5 w-5" }),
                    "Risk types"
                  ]
                }
              ),
              /* @__PURE__ */ s(
                gY,
                {
                  onOpenChange: W,
                  open: D
                }
              )
            ] }),
            /* @__PURE__ */ R("div", { className: "flex flex-col gap-1", children: [
              /* @__PURE__ */ R("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ s(
                  io,
                  {
                    id: "reportRiskMonetary",
                    checked: h.monetary,
                    onCheckedChange: (G) => {
                      b((Q) => ({
                        ...Q,
                        monetary: !!G
                      }));
                    },
                    name: "monetary"
                  }
                ),
                /* @__PURE__ */ s(nt, { htmlFor: "reportRiskMonetary", children: "Monetary" })
              ] }),
              /* @__PURE__ */ R("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ s(
                  io,
                  {
                    id: "reportRiskIncorrectOrUnnecessaryDesignChange",
                    checked: h.incorrectOrUnnecessaryDesignChange,
                    onCheckedChange: (G) => {
                      b((Q) => ({
                        ...Q,
                        incorrectOrUnnecessaryDesignChange: !!G
                      }));
                    }
                  }
                ),
                /* @__PURE__ */ s(nt, { htmlFor: "reportRiskIncorrectOrUnnecessaryDesignChange", children: "Incorrect or unnecessary design changes" })
              ] }),
              /* @__PURE__ */ R("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ s(
                  io,
                  {
                    id: "reportRiskIrreversibleActions",
                    checked: h.irreversibleActions,
                    onCheckedChange: (G) => {
                      b((Q) => ({
                        ...Q,
                        irreversibleActions: !!G
                      }));
                    }
                  }
                ),
                /* @__PURE__ */ s(nt, { htmlFor: "reportRiskIrreversibleActions", children: "Irreversible actions" })
              ] }),
              /* @__PURE__ */ R("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ s(
                  io,
                  {
                    id: "reportRiskReputational",
                    checked: h.reputational,
                    onCheckedChange: (G) => {
                      b((Q) => ({
                        ...Q,
                        reputational: !!G
                      }));
                    }
                  }
                ),
                /* @__PURE__ */ s(nt, { htmlFor: "reportRiskReputational", children: "Reputational" })
              ] })
            ] }),
            /* @__PURE__ */ s(
              nt,
              {
                className: F(
                  "mt-1",
                  U.reportRiskComment && "text-destructiveDefault"
                ),
                children: "Describe the risk"
              }
            ),
            /* @__PURE__ */ s(
              Lr,
              {
                className: "border-interactiveBorder focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-base font-normal leading-5 focus:outline-0",
                onChange: (G) => {
                  j(), N(G.target.value);
                },
                placeholder: "Enter response",
                tabIndex: 1,
                value: w
              }
            ),
            U.reportRiskComment ? /* @__PURE__ */ s("div", { className: "text-destructiveDefault", children: U.reportRiskComment }) : null
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { children: "Feedback on zone and overlay reasoning" }),
      /* @__PURE__ */ s("span", { className: "text-textSubdued inline-block text-xs font-normal leading-[14px]", children: "Write your response against each applicable zone and overlay, e.g. “Zone: <comment>, BMO: <comment>, SLO: <comment>”." }),
      /* @__PURE__ */ s("div", { className: "mt-1", children: /* @__PURE__ */ s(
        Lr,
        {
          className: `${_ === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-base font-normal leading-5 focus:outline-0`,
          onChange: (G) => {
            P(G.target.value);
          },
          placeholder: "Enter response",
          tabIndex: 1,
          value: _
        }
      ) })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ R("div", { className: "flex w-full flex-row justify-end gap-x-2", children: [
        A ? /* @__PURE__ */ s(
          ct,
          {
            className: "text-actionDefault border-actionDefault",
            onClick: t,
            tabIndex: 1,
            variant: "outline",
            children: "Cancel"
          }
        ) : null,
        /* @__PURE__ */ R(
          ct,
          {
            disabled: i,
            onClick: oe,
            tabIndex: 1,
            variant: "default",
            children: [
              i && /* @__PURE__ */ s(So, { className: "mr-2 h-4 w-4 animate-spin" }),
              i ? "Submitting" : "Submit review"
            ]
          }
        )
      ] }),
      A ? /* @__PURE__ */ s("div", { className: "mt-2 flex w-full flex-row justify-end", children: /* @__PURE__ */ R("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: [
        "Previously updated by ",
        /* @__PURE__ */ s("span", { className: "text-textPrimary", children: T }),
        " on " + Bn(A).replace(",", " at")
      ] }) }) : null
    ] })
  ] });
}
function n3({
  conversation: e,
  onSubmitSuccess: t
}) {
  const n = Tl({ conversation: e }), r = n.at(-1), [o, i] = ne(""), [l, c] = ne(""), [f, p] = ne(""), [m, v] = ne({
    monetary: !1,
    incorrectOrUnnecessaryDesignChange: !1,
    irreversibleActions: !1,
    reputational: !1
  }), [C, x] = ne(""), [y, h] = ne(""), [b, w] = ne(""), [N, _] = ne(""), [P, A] = ne(n.length === 0);
  Oe(() => {
    n.length > 0 && A(!1);
  }, [n.length]), Oe(() => {
    r && or(r.review_data) && r.review_data.version === 3 && (console.log("<ReviewPanelV3> currentReview:", r), i(r.review_data.report_outcome), c(
      r.review_data.report_outcome_expected
    ), p(r.review_data.report_risk), v(
      r.review_data.report_risk_types || {
        monetary: !1,
        incorrectOrUnnecessaryDesignChange: !1,
        irreversibleActions: !1,
        reputational: !1
      }
    ), x(r.review_data.report_risk_comment), h(r.review_data.comments), w(r.created_at || ""), _(r.created_by_email || ""));
  }, [r]);
  const I = () => {
    const W = [];
    return m.monetary && W.push("Monetary"), m.incorrectOrUnnecessaryDesignChange && W.push("Incorrect or unnecessary design change"), m.irreversibleActions && W.push("Irreversible actions"), m.reputational && W.push("Reputational"), /* @__PURE__ */ R("div", { className: "mt-2 flex pl-1", children: [
      /* @__PURE__ */ s(nn, {}),
      /* @__PURE__ */ R("div", { className: "mt-2 flex w-full flex-col", children: [
        /* @__PURE__ */ s(nt, { className: "text-bodymd text-textPrimary", children: "What type of risk has been introduced?" }),
        W.length > 0 ? /* @__PURE__ */ s("p", { className: "text-textSubdued text-sm", children: W.join(", ") }) : /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal", children: "No response provided." }),
        /* @__PURE__ */ s(nt, { className: "text-bodymd text-textPrimary mt-3", children: "Describe the risk" }),
        C ? /* @__PURE__ */ s("p", { className: "text-textSubdued text-sm", children: /* @__PURE__ */ s(bo, { comment: C }) }) : /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal", children: "No response provided." })
      ] })
    ] });
  }, T = () => o === "Yes" ? /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ s(Lt, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ s("p", { className: "text-successText ml-1.5 text-xs font-normal leading-[14px]", children: "Yes" })
  ] }) : o === "No" ? /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ R("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ s($t, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ s("p", { className: "text-destructiveText ml-1.5 text-xs font-normal leading-[14px]", children: "No" })
    ] }),
    /* @__PURE__ */ R("div", { className: "mt-2 flex pl-1", children: [
      /* @__PURE__ */ s(nn, {}),
      /* @__PURE__ */ R("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
        /* @__PURE__ */ s(nt, { children: "What should the result be?" }),
        l ? /* @__PURE__ */ s(mt, { value: l }) : /* @__PURE__ */ s("span", { className: "text-textSubdued text-xs font-normal", children: "No response provided." })
      ] })
    ] })
  ] }) : /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response entered." }), M = () => f === "No" ? /* @__PURE__ */ s("div", { className: "flex items-center", children: /* @__PURE__ */ s("span", { className: "text-successText text-sm font-normal", children: "✅ No risk" }) }) : f === "Minor" ? /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ s("div", { className: "flex items-center", children: /* @__PURE__ */ s("span", { className: " text-warningText text-sm font-normal", children: "⚠️ Yes, but it’s only minor" }) }),
    I()
  ] }) : f === "Yes" ? /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ s("div", { className: "flex items-center", children: /* @__PURE__ */ s("span", { className: " text-destructiveText text-sm font-normal", children: "🚨 Yes, and it’s potentially significant" }) }),
    I()
  ] }) : /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response entered." }), D = () => {
    const W = /* @__PURE__ */ s(
      mt,
      {
        value: e != null && e.report_outcome ? e.report_outcome : ""
      }
    );
    return /* @__PURE__ */ R("section", { className: "flex flex-col gap-y-5 text-base font-semibold leading-5", children: [
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ R("h3", { className: "flex", children: [
          "The result is ",
          /* @__PURE__ */ s("span", { className: "ml-1", children: W }),
          ", is this correct?"
        ] }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: T() })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "Has the report introduced risk to the customer or council?" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: M() })
      ] }),
      /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ s("h3", { children: "Feedback on zone and overlay reasoning" }),
        /* @__PURE__ */ s("div", { className: "mt-2", children: y === "" ? /* @__PURE__ */ s("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: "No response provided." }) : /* @__PURE__ */ s("p", { className: "text-wrap break-all text-base font-normal leading-5", children: /* @__PURE__ */ s(bo, { comment: y }) }) })
      ] }),
      /* @__PURE__ */ s("div", { className: "border-interfaceBorder w-full border-t" }),
      /* @__PURE__ */ R("div", { className: "flex flex-col gap-y-1", children: [
        /* @__PURE__ */ R(
          "button",
          {
            onClick: () => A(!0),
            className: "text-textLink flex flex-row items-center text-xs font-normal leading-[14px] underline",
            children: [
              /* @__PURE__ */ s(Gc, { className: "h-4 w-4" }),
              /* @__PURE__ */ s("p", { className: "ml-1", children: "Edit review" })
            ]
          }
        ),
        /* @__PURE__ */ R("p", { className: "text-textSubdued text-xs font-normal leading-[14px]", children: [
          "Last updated " + Bn(b).replace(",", " at") + " by ",
          /* @__PURE__ */ s("span", { className: "text-textPrimary", children: N })
        ] })
      ] })
    ] });
  };
  return /* @__PURE__ */ R("div", { className: "bg-interfaceWhite border-interfaceBorder text-textPrimary flex flex-col rounded-lg border p-8", children: [
    n.length === 0 || P ? /* @__PURE__ */ s(
      vY,
      {
        review: r,
        conversation: e,
        onClickCancel: () => A(!1),
        onSubmitSuccess: () => {
          A(!1), t == null || t();
        }
      }
    ) : null,
    n.length > 0 && !P ? D() : null
  ] });
}
function ZZ({
  conversation: e,
  noticeboard: t,
  onSubmitSuccess: n
}) {
  const r = e == null ? void 0 : e.id, o = Tl({ conversation: e }), i = o.at(-1);
  if (o.length > 0 && i && !or(i == null ? void 0 : i.review_data))
    return /* @__PURE__ */ s(
      dY,
      {
        conversationId: r || "",
        onSubmitSuccess: n,
        reviews: o
      }
    );
  if (o.length > 0 && i && or(i.review_data))
    switch (console.log("<ReviewPanel> currentReview", i), i.review_data.version) {
      case 1:
        return /* @__PURE__ */ s(
          pY,
          {
            conversation: e,
            noticeboard: t,
            onSubmitSuccess: n
          }
        );
      case 2:
        return /* @__PURE__ */ s(
          hY,
          {
            conversation: e,
            onSubmitSuccess: n
          }
        );
      case 3:
        return /* @__PURE__ */ s(
          n3,
          {
            conversation: e,
            onSubmitSuccess: n
          }
        );
    }
  return /* @__PURE__ */ s(
    n3,
    {
      conversation: e,
      onSubmitSuccess: n
    }
  );
}
function XZ({
  conversation: e,
  publicReportLink: t
}) {
  var i, l, c, f, p;
  const { getLocalisationEntry: n } = sr(e), r = n("councilName"), o = () => {
    if (e != null && e.updated_at && (e != null && e.created_at)) {
      const m = rP(
        new Date(e == null ? void 0 : e.updated_at),
        new Date(e == null ? void 0 : e.created_at)
      );
      let v = "";
      return m.days !== 0 && (v = v + m.days.toString() + " days "), m.minutes !== 0 && (v = v + m.minutes.toString() + " minutes "), v;
    }
    return "N/A";
  };
  return /* @__PURE__ */ R("div", { className: "h-full min-h-0 flex flex-col gap-y-6", children: [
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { className: "mb-0.5 font-semibold", children: "User" }),
      e != null && e.user_email ? /* @__PURE__ */ s(
        "a",
        {
          className: "text-textLink flex flex-row underline cursor-pointer",
          href: `mailto:${e.user_email}?subject=${r}%2planning%2enquiry%2follow-up`,
          rel: "noreferrer",
          tabIndex: 0,
          target: "_blank",
          children: e.user_email
        }
      ) : /* @__PURE__ */ s("p", { children: '"N/A"' })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { className: "mb-0.5 font-semibold", children: "Feedback consent" }),
      /* @__PURE__ */ s("p", { children: e != null && e.user_consent ? "Yes" : "No" })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { className: "mb-0.5 font-semibold", children: "ID" }),
      /* @__PURE__ */ s("p", { children: ((i = e == null ? void 0 : e.identifier) == null ? void 0 : i.toUpperCase()) || "N/A" })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { className: "mb-0.5 font-semibold", children: "Stage" }),
      /* @__PURE__ */ s(xY, { value: e != null && e.phase ? e.phase : "" })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { className: "mb-0.5 font-semibold", children: "Public report link" }),
      ["report_ready", "saved_report", "sent_to_council"].includes(
        (e == null ? void 0 : e.phase) || ""
      ) ? /* @__PURE__ */ s(
        "a",
        {
          href: `${t}${(l = e == null ? void 0 : e.identifier) == null ? void 0 : l.toUpperCase()}`,
          target: "_blank",
          className: "text-textLink hover:text-textLinkHover flex flex-row underline",
          children: `${t}${(c = e == null ? void 0 : e.identifier) == null ? void 0 : c.toUpperCase()}`
        }
      ) : /* @__PURE__ */ s("p", { children: "---" })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { className: "mb-1 font-semibold", children: "Time and duration" }),
      /* @__PURE__ */ s("table", { className: "w-full text-left text-base font-normal leading-5", children: /* @__PURE__ */ R("tbody", { children: [
        /* @__PURE__ */ R("tr", { className: "border-interfaceBorder w-full border-b", children: [
          /* @__PURE__ */ s("th", { className: "border-interfaceBorder w-1/2 border-r py-2 ", children: "Started" }),
          /* @__PURE__ */ s("td", { className: "w-1/2 py-2 pl-3", children: Bn(e == null ? void 0 : e.created_at) })
        ] }),
        /* @__PURE__ */ R("tr", { className: "border-interfaceBorder w-full border-b", children: [
          /* @__PURE__ */ s("th", { className: "border-interfaceBorder w-1/2 border-r py-2 ", children: "Last interaction" }),
          /* @__PURE__ */ s("td", { className: "w-1/2 py-2 pl-3", children: Bn(e == null ? void 0 : e.updated_at) })
        ] }),
        /* @__PURE__ */ R("tr", { className: "w-full", children: [
          /* @__PURE__ */ s("th", { className: "border-interfaceBorder w-1/2 border-r py-2 ", children: "Duration" }),
          /* @__PURE__ */ s("td", { className: "w-1/2 py-2 pl-3", children: o() })
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ s("h3", { className: "mb-0.5 font-semibold", children: "Ordinance" }),
      e != null && e.report_ordinance_version ? /* @__PURE__ */ s("p", { className: "text-base leading-5", children: "Outcome determined using planning legislation accessed on " + ((f = Fg((e == null ? void 0 : e.report_ordinance_version) || "")) == null ? void 0 : f.date) + " (version " + ((p = Fg((e == null ? void 0 : e.report_ordinance_version) || "")) == null ? void 0 : p.version) + ")." }) : /* @__PURE__ */ s("p", { children: "---" })
    ] })
  ] });
}
const CY = {
  microsoft: /* @__PURE__ */ s(zK, {}),
  google: /* @__PURE__ */ s(GK, {})
};
function jZ({
  disabled: e,
  socialApps: t
}) {
  return /* @__PURE__ */ s("div", { className: "flex gap-3", children: t.map((n) => {
    const r = CY[n.provider];
    return /* @__PURE__ */ s("a", { href: n.login_url, className: "grow", children: /* @__PURE__ */ R(
      ct,
      {
        className: "mt-1 w-full rounded-sm px-4 py-2 text-base leading-5 text-black",
        disabled: e,
        variant: "outline",
        children: [
          r ? /* @__PURE__ */ s("span", { className: "mr-2", children: r }) : null,
          " Log in with",
          " ",
          n.name
        ]
      },
      n.provider
    ) }, n.provider);
  }) });
}
function mt({ value: e }) {
  let t = e, n = !1, r = "text-textPrimary", o = "", i = "";
  switch (t) {
    case "No permit required":
      t = "Permit not required", r = "text-successText", o = "bg-successBgLight", i = "border-successBorder";
      break;
    case "More information required":
      t = "Exemptions may apply", r = "text-actionDefault", o = "bg-actionBgLight", i = "border-actionBorder";
      break;
    case "Permit required":
      r = "text-warningText", o = "bg-warningBgLight", i = "border-warningBorder";
      break;
    case "Prohibited":
      r = "text-destructiveText", o = "bg-destructiveBgLight", i = "border-destructiveBorder";
      break;
    case null:
      n = !0;
      break;
    case "":
      n = !0;
  }
  return n ? "---" : /* @__PURE__ */ s(
    "div",
    {
      className: F(
        "w-min whitespace-nowrap rounded-xl border px-3 text-sm font-medium leading-[18px]",
        r,
        o,
        i
      ),
      children: t
    }
  );
}
function QZ({ value: e }) {
  let t = e, n = "text-textPrimary", r = "", o = "";
  return t === !0 || t === "True" ? (t = "Yes", n = "text-successText", r = "bg-successBgLight", o = "border-successBorder") : (t = "No", n = "text-textSubdued", r = "bg-interfaceTags", o = "border-interactiveBorder"), /* @__PURE__ */ s(
    "div",
    {
      className: `${n} ${r} ${o} w-min whitespace-nowrap rounded-xl border px-3 text-sm font-medium leading-[18px]`,
      children: t
    }
  );
}
function JZ({ value: e }) {
  let t = e, n = "text-textPrimary", r = "", o = "";
  return t === !0 || t === "True" ? (t = "🚩 Yes", n = "text-redText", r = "bg-redBgLight", o = "border-redBorder") : (t = "No", n = "text-textSubdued", r = "bg-interfaceTags", o = "border-interactiveBorder"), /* @__PURE__ */ s(
    "div",
    {
      className: `${n} ${r} ${o} w-min whitespace-nowrap rounded-xl border px-3 text-sm font-medium leading-[18px]`,
      children: t
    }
  );
}
function xY({ value: e }) {
  let t = e, n = !1, r = "text-textPrimary", o = "", i = "";
  return t === "sent_to_council" ? (t = "Complete", r = "text-successText", o = "bg-successBgLight", i = "border-successBorder") : t === "saved_report" ? (t = "Review requested", r = "text-[#3A0075]", o = "bg-[#F8F3FF]", i = "border-[#D2B7FF]") : ["report_ready"].includes(t) ? (t = "Draft", r = "text-warningText", o = "bg-warningBgLight", i = "border-warningBorder") : t === "discarded" ? (t = "Discarded", r = "text-textSubdued", o = "bg-interfaceTags", i = "border-interactiveBorder") : t === null ? n = !0 : (t = "In progress", r = "text-actionPress", o = "bg-actionBgLight", i = "border-actionBorder"), n ? "---" : /* @__PURE__ */ s(
    "div",
    {
      className: `${r} ${o} ${i} w-min whitespace-nowrap rounded-xl border px-3 text-sm font-medium leading-[18px]`,
      children: t
    }
  );
}
function eX({ value: e }) {
  let t = "text-textPrimary", n = "", r = "", o;
  return e ? (o = "Yes", t = "text-successText", n = "bg-successBgLight", r = "border-successBorder") : (o = "No", t = "text-destructiveText", n = "bg-destructiveBgLight", r = "border-destructiveBorder"), /* @__PURE__ */ s(
    "div",
    {
      className: `${t} ${n} ${r} w-min whitespace-nowrap rounded-xl border px-3 text-sm font-medium leading-[18px]`,
      children: o
    }
  );
}
export {
  hi as Accordion,
  fo as AccordionContent,
  co as AccordionItem,
  uo as AccordionTrigger,
  oA as Alert,
  aA as AlertDescription,
  kY as AlertDialog,
  YT as AlertDialogAction,
  ZT as AlertDialogCancel,
  UT as AlertDialogContent,
  KT as AlertDialogDescription,
  zT as AlertDialogFooter,
  GT as AlertDialogHeader,
  Pv as AlertDialogOverlay,
  HT as AlertDialogPortal,
  qT as AlertDialogTitle,
  DY as AlertDialogTrigger,
  iA as AlertTitle,
  LY as AnalysisReport,
  MY as AnalysisReportAggregated,
  FY as AnimatedText,
  FZ as ApplicationRequirementsReport,
  MZ as AssessmentReport,
  IZ as AssessmentReportDemo,
  OZ as AssessmentReportFastEnquiry,
  n$ as Badge,
  VZ as BaysideCityCouncilLogo,
  WZ as BoroondaraCityCouncilLogo,
  ct as Button,
  r$ as Card,
  s$ as CardContent,
  a$ as CardDescription,
  l$ as CardFooter,
  o$ as CardHeader,
  i$ as CardTitle,
  io as Checkbox,
  VY as CheckboxGroup,
  zY as Collapsible,
  KY as CollapsibleContent,
  qY as CollapsibleTrigger,
  YY as ColumnVisibility,
  WY as Combobox,
  ya as Command,
  UY as CommandDialog,
  l4 as CommandEmpty,
  Ql as CommandGroup,
  s4 as CommandInput,
  Jl as CommandItem,
  jl as CommandList,
  bM as CommandSeparator,
  yM as CommandShortcut,
  XY as DataTable,
  PI as DataTablePagination,
  s5 as Dialog,
  tZ as DialogClose,
  ip as DialogContent,
  bO as DialogDescription,
  c5 as DialogFooter,
  xO as DialogHeader,
  l5 as DialogOverlay,
  CO as DialogPortal,
  u5 as DialogTitle,
  eZ as DialogTrigger,
  wO as DraftWatermarkOverlay,
  rZ as DropdownMenu,
  iB as DropdownMenuCheckboxItem,
  rB as DropdownMenuContent,
  iZ as DropdownMenuGroup,
  oB as DropdownMenuItem,
  sB as DropdownMenuLabel,
  aZ as DropdownMenuPortal,
  lZ as DropdownMenuRadioGroup,
  aB as DropdownMenuRadioItem,
  lB as DropdownMenuSeparator,
  cB as DropdownMenuShortcut,
  sZ as DropdownMenuSub,
  nB as DropdownMenuSubContent,
  tB as DropdownMenuSubTrigger,
  oZ as DropdownMenuTrigger,
  kZ as EmptyAssessmentReport,
  HZ as ExternalLinkIcon,
  sf as FilterType,
  BZ as Filters,
  LB as FormControl,
  MB as FormDescription,
  uZ as FormField,
  TB as FormItem,
  $B as FormLabel,
  IB as FormMessage,
  cZ as FormProvider,
  GK as GoogleSocialLoginLogo,
  qZ as GridLoader,
  so as HorizontalRadioGroup,
  Gc as IconEdit,
  Ep as Input,
  nt as Label,
  zZ as MapComponent,
  zK as MicrosoftSocialLoginLogo,
  UZ as MorningtonPeninsulaShireCouncilLogo,
  fZ as MultiSelect,
  GZ as MyLotLogoBlue,
  GV as NavigationMenu,
  YV as NavigationMenuContent,
  ZV as NavigationMenuIndicator,
  mZ as NavigationMenuItem,
  hZ as NavigationMenuLink,
  zV as NavigationMenuList,
  KV as NavigationMenuTrigger,
  i7 as NavigationMenuViewport,
  mt as OutcomeTag,
  E4 as Pagination,
  P4 as PaginationContent,
  $4 as PaginationEllipsis,
  Ji as PaginationItem,
  nc as PaginationLink,
  T4 as PaginationNext,
  A4 as PaginationPrevious,
  DZ as PermitRequirementsReport,
  B7 as Popover,
  vZ as PopoverAnchor,
  Vp as PopoverContent,
  V7 as PopoverTrigger,
  KZ as ProgressIndicatorList,
  dl as ProgressIndicatorListStatus,
  YZ as PublicConversation,
  YW as RadioBoxCircle,
  qW as RadioGroup,
  KW as RadioGroupItem,
  W7 as RadioMultiSelect,
  ZK as ReasoningPanel,
  yH as ReviewCheckboxGroup,
  JZ as ReviewNeededTag,
  ZZ as ReviewPanel,
  dY as ReviewPanelV0,
  pY as ReviewPanelV1,
  QZ as ReviewedTag,
  VH as ScrollArea,
  h9 as ScrollBar,
  yZ as Select,
  LG as SelectContent,
  wZ as SelectGroup,
  IG as SelectItem,
  MG as SelectLabel,
  OG as SelectSeparator,
  $G as SelectTrigger,
  SZ as SelectValue,
  ga as Separator,
  XZ as SessionPanel,
  wC as Sheet,
  NZ as SheetClose,
  Xp as SheetContent,
  GG as SheetDescription,
  NC as SheetFooter,
  HG as SheetHeader,
  SC as SheetOverlay,
  VG as SheetPortal,
  UG as SheetTitle,
  BG as SheetTrigger,
  qe as ShowMore,
  nz as Sidebar,
  uz as SidebarContent,
  lz as SidebarFooter,
  dz as SidebarGroup,
  pz as SidebarGroupAction,
  mz as SidebarGroupContent,
  fz as SidebarGroupLabel,
  sz as SidebarHeader,
  az as SidebarInput,
  iz as SidebarInset,
  hz as SidebarMenu,
  xz as SidebarMenuAction,
  bz as SidebarMenuBadge,
  Cz as SidebarMenuButton,
  gz as SidebarMenuItem,
  yz as SidebarMenuSkeleton,
  wz as SidebarMenuSub,
  Nz as SidebarMenuSubButton,
  Sz as SidebarMenuSubItem,
  tz as SidebarProvider,
  oz as SidebarRail,
  cz as SidebarSeparator,
  rz as SidebarTrigger,
  D2 as Skeleton,
  zz as Slider,
  jZ as SocialLoginButtons,
  xY as StageTag,
  nn as SubdirectoryArrowRightIcon,
  KC as Switch,
  S4 as Table,
  _4 as TableBody,
  RI as TableCaption,
  Af as TableCell,
  _I as TableFooter,
  R4 as TableHead,
  N4 as TableHeader,
  nl as TableRow,
  nr as Tabs,
  gt as TabsContent,
  Fn as TabsList,
  bt as TabsTrigger,
  eq as Textarea,
  EZ as TimeLine,
  Lx as Toast,
  $q as ToastAction,
  Mx as ToastClose,
  Ox as ToastDescription,
  Aq as ToastProvider,
  Ix as ToastTitle,
  $x as ToastViewport,
  TZ as Toaster,
  Vq as Toggle,
  pb as Tooltip,
  lm as TooltipContent,
  fb as TooltipProvider,
  mb as TooltipTrigger,
  yi as VerticalRadioGroup,
  OK as VerticalReasoningCorrectnessRadioGroup,
  eX as YesNoTag,
  t$ as badgeVariants,
  zl as buttonVariants,
  ZY as createColumnHelper,
  KK as defaultReasoningPanelSections,
  qV as navigationMenuTriggerStyle,
  Oq as reducer,
  kq as toast,
  Bq as toggleVariants,
  jY as useDataTablePagination,
  Nc as useFormContext,
  _c as useFormField,
  kc as useSidebar,
  Dq as useToast
};
//# sourceMappingURL=components.js.map
